import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Any */
  Any: { input: any; output: any };
  /**
   * RFC-3339 timestamp string, e.g. `2026-05-20T12:34:56Z`.
   *
   * Piloted by the MVD catalog API (ADR-067 §6e) as step 1 of the timestamp
   * migration in #15824 Phase 4: it is currently mapped to a string, so resolvers
   * keep returning `string` and no resolver churn is involved. Once every
   * timestamp field has migrated, the mapping flips to `graphql.Time` repo-wide.
   */
  DateTime: { input: any; output: any };
  /** Map */
  Map: { input: any; output: any };
};

/** Input for requesting an AI-generated summary for an asset or its findings. */
export type AiSummaryInput = {
  /** MRN of the asset to summarize. */
  assetMrn: Scalars["String"]["input"];
  /**
   * Optional MRNs of findings (CVEs, advisories, checks) to summarize.
   * When omitted or empty, an asset-level summary is generated.
   */
  findingMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Response payload for AI summary operations. */
export type AiSummaryPayload = {
  __typename: "AISummaryPayload";
  /**
   * When the summary was last generated or updated (RFC 3339 format).
   * Only populated when state is GENERATED.
   */
  generatedAt?: Maybe<Scalars["String"]["output"]>;
  /** The current state of the summary generation lifecycle. */
  state: AiSummaryState;
  /**
   * The AI-generated summary in Markdown format.
   * Only populated when state is GENERATED.
   */
  summary?: Maybe<Scalars["String"]["output"]>;
};

/** The lifecycle state of an AI-generated summary. */
export enum AiSummaryState {
  Error = "ERROR",
  Generated = "GENERATED",
  Generating = "GENERATING",
  NotAvailable = "NOT_AVAILABLE",
}

/** An API token in the system */
export type ApiToken = {
  __typename: "APIToken";
  /** RFC 3339 timestamp when the token was created */
  createdAt: Scalars["String"]["output"];
  /** The creator of the API token */
  creator?: Maybe<ApiTokenCreator>;
  /** The description of the API token */
  description?: Maybe<Scalars["String"]["output"]>;
  /** RFC 3339 timestamp when the token was last used */
  lastUsed?: Maybe<Scalars["String"]["output"]>;
  /** The MRN of the API token */
  mrn: Scalars["String"]["output"];
  /** The name of the API token */
  name: Scalars["String"]["output"];
  /** The roles assigned to the API token */
  roles: Array<Role>;
  /** The MRN of the scope for the API token */
  scopeMrn: Scalars["String"]["output"];
  /**
   * The MRN of the space (deprecated, use scopeMrn)
   * @deprecated Use scopeMrn
   */
  spaceMrn: Scalars["String"]["output"];
};

/** Connection containing API tokens */
export type ApiTokenConnection = {
  __typename: "APITokenConnection";
  /** The edges in the connection */
  edges?: Maybe<Array<ApiTokenEdge>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** The total number of API tokens */
  totalCount: Scalars["Int"]["output"];
};

/** Creator of an API token */
export type ApiTokenCreator = {
  __typename: "APITokenCreator";
  /** The email of the creator */
  email?: Maybe<Scalars["String"]["output"]>;
  /** The MRN of the creator */
  mrn?: Maybe<Scalars["String"]["output"]>;
  /**
   * A human-readable display name for the creator. Resolved server-side from
   * the MRN so clients do not need to pattern-match identifiers. Examples:
   * "Mondoo Platform" for the system user, "Service Account {id}" for a
   * service-account creator, or the creator's email when available.
   */
  name?: Maybe<Scalars["String"]["output"]>;
};

/** An edge in an API tokens connection */
export type ApiTokenEdge = {
  __typename: "APITokenEdge";
  /** The cursor for this edge */
  cursor: Scalars["ID"]["output"];
  /** The API token at the end of the edge */
  node?: Maybe<ApiToken>;
};

/** Input for ordering API tokens */
export type ApiTokenOrder = {
  /** The direction to order by */
  direction: OrderDirection;
  /** The field to order by */
  field: ApiTokenOrderField;
};

/** Field to order API tokens by */
export enum ApiTokenOrderField {
  /** Order by creation time */
  CreatedAt = "CREATED_AT",
  /** Order by last used time */
  LastUsed = "LAST_USED",
  /** Order by name */
  Name = "NAME",
}

/** AWS configuration options */
export type AwsConfigurationOptions = {
  __typename: "AWSConfigurationOptions";
  /** A list of AWS account IDs */
  accountIds?: Maybe<Array<Scalars["String"]["output"]>>;
  /** AWS account id where the serverless Lambda is deployed (WIF only). */
  awsAccountId: Scalars["String"]["output"];
  /**
   * Full CloudFormation console quickcreate URL. Contains a base64-encoded
   * MondooWifConfig parameter when useWif is true.
   */
  cloudFormationQuickcreateUrl: Scalars["String"]["output"];
  /** The CloudFormation template URL */
  cloudFormationTemplateUrl: Scalars["String"]["output"];
  /**
   * True when this integration is configured to land scanned assets in
   * spaces across multiple orgs.
   */
  crossOrg?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether this is an AWS Organization integration */
  isOrganization?: Maybe<Scalars["Boolean"]["output"]>;
  /** The origin AWS account ID */
  originAWSAccountId: Scalars["String"]["output"];
  /** The AWS region */
  region: Scalars["String"]["output"];
  /** The scan configuration for the AWS integration */
  scanConfiguration: ScanConfiguration;
  /**
   * The SNS endpoint for notifications
   * @deprecated SNS notifications are no longer supported and will be removed in the future
   */
  snsEndpoint: Scalars["String"]["output"];
  /** Whether the integration uses Workload Identity Federation. */
  useWif: Scalars["Boolean"]["output"];
  /** MRN of the WIF auth binding associated with this integration (WIF only). */
  wifAuthBindingMrn: Scalars["String"]["output"];
};

/** AWS integration input */
export type AwsConfigurationOptionsInput = {
  /**
   * A list of AWS account IDs (deprecated)
   * @deprecated Will be removed in the future
   */
  accountIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * AWS account id where the serverless Lambda is deployed. Required when
   * useWif is true; rejected when useWif is false.
   */
  awsAccountId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Allow this integration to land scanned assets in spaces across multiple
   * orgs. Immutable after creation. Only valid on organization-scoped AWS
   * serverless integrations and only on private-instance deployments
   * (rejected on prod and prod-eu environments).
   */
  crossOrg?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether this is an AWS Organization integration */
  isOrganization?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The AWS region */
  region: Scalars["String"]["input"];
  /** The scan configuration for the AWS integration */
  scanConfiguration: ScanConfigurationInput;
  /**
   * Whether to authenticate callbacks via Workload Identity Federation
   * instead of a static Mondoo token. Required true for organization-scoped
   * integrations. Requires v2Template=true.
   */
  useWif?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether to use v2 template */
  v2Template?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Options for AWS cross-account scanning */
export type AwsCrossAccountScanOptions = {
  __typename: "AWSCrossAccountScanOptions";
  /** The AWS account IDs to scan across. */
  accountIds?: Maybe<Array<Scalars["String"]["output"]>>;
  /**
   * Key-value tags indicating which accounts to consider for cross-account scanning.
   * They are evaluated using a logical OR. When empty, all discovered accounts are applicable.
   * When not empty, only accounts that match at least one of the specified tags are applicable.
   * A value of `*` is treated as a wildcard: only the tag key is matched, regardless of its value.
   * Defaults to an empty list.
   */
  accountTags?: Maybe<Array<Tag>>;
  /** The IAM role name to assume in each target account. */
  roleName?: Maybe<Scalars["String"]["output"]>;
};

/** Options for AWS cross-account scanning (input) */
export type AwsCrossAccountScanOptionsInput = {
  /** The AWS account IDs to scan across. */
  accountIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Key-value tags indicating which accounts to consider for cross-account scanning.
   * They are evaluated using a logical OR. When empty, all discovered accounts are applicable.
   * When not empty, only accounts that match at least one of the specified tags are applicable.
   * A value of `*` is treated as a wildcard: only the tag key is matched, regardless of its value.
   * Defaults to an empty list.
   */
  accountTags?: InputMaybe<Array<TagInput>>;
  /** The IAM role name to assume in each target account. */
  roleName?: InputMaybe<Scalars["String"]["input"]>;
};

/** AWSEventPattern are the event pattern based scan triggers for the AWS integration */
export type AwsEventPattern = {
  __typename: "AWSEventPattern";
  /** The event detail type */
  eventDetailType: Scalars["String"]["output"];
  /** The event source */
  eventSource: Scalars["String"]["output"];
  /** The scan type */
  scanType: Scalars["String"]["output"];
};

/** AWSEventPatternInput describes the options for event pattern based scan triggers */
export type AwsEventPatternInput = {
  /** The event detail type */
  eventDetailType: Scalars["String"]["input"];
  /** The event source */
  eventSource: Scalars["String"]["input"];
  /** The scan type */
  scanType: Scalars["String"]["input"];
};

/** AWS role credential input */
export type AwsRoleCredential = {
  /** The external ID for the AWS role credential */
  externalId?: InputMaybe<Scalars["String"]["input"]>;
  /** The role for the AWS role credential */
  role: Scalars["String"]["input"];
};

/** AWS secret key credential input */
export type AwsSecretKeyCredential = {
  /** The access key ID for the AWS secret key credential */
  accessKeyId: Scalars["String"]["input"];
  /** The secret access key for the AWS secret key credential */
  secretAccessKey: Scalars["String"]["input"];
};

/**
 * AWS WIF (Workload Identity Federation) credential input.
 * Uses Mondoo as an OIDC identity provider to assume an IAM role via web identity.
 */
export type AwsWifCredential = {
  /**
   * The audience value configured in the AWS IAM OIDC identity provider.
   * This must match the audience set when creating the OIDC provider in AWS.
   */
  audience: Scalars["String"]["input"];
  /**
   * The ARN of the IAM role to assume via web identity federation.
   * e.g., arn:aws:iam::123456789012:role/MondooAccess
   */
  roleArn: Scalars["String"]["input"];
};

/** Accept legal policy input */
export type AcceptLegalPolicy = {
  /** The policy ID */
  policyId?: InputMaybe<Scalars["String"]["input"]>;
  /** The resource MRN */
  resourceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Access level of the object */
export enum Access {
  All = "ALL",
  Authenticated = "AUTHENTICATED",
  Private = "PRIVATE",
  Public = "PUBLIC",
}

/** Action type used when triggering action on client integration */
export enum ActionType {
  ClearScanQueue = "CLEAR_SCAN_QUEUE",
  Diagnostics = "DIAGNOSTICS",
  Metrics = "METRICS",
  Pause = "PAUSE",
  /**
   * Revoke the integration's current enrollment token(s) and mint a fresh one
   * (Network Discovery Collector: "issue new 30-day token").
   */
  ReissueToken = "REISSUE_TOKEN",
  RetrySetup = "RETRY_SETUP",
  /**
   * Generic run — triggers the integration's primary operation (scan, import,
   * or export) without the caller needing to know the integration category.
   */
  Run = "RUN",
  /** @deprecated Use RUN instead */
  RunExport = "RUN_EXPORT",
  /** @deprecated Use RUN instead */
  RunImport = "RUN_IMPORT",
  /** @deprecated Use RUN instead */
  RunScan = "RUN_SCAN",
  Unpause = "UNPAUSE",
  Update = "UPDATE",
}

/** Activate user in region payload */
export type ActivateUserInRegionPayload = {
  __typename: "ActivateUserInRegionPayload";
  /** User */
  user: User;
};

/** Active policies connection */
export type ActivePoliciesConnection = {
  __typename: "ActivePoliciesConnection";
  /** Active policy edges */
  edges?: Maybe<Array<ActivePolicyEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** The total count of active policies */
  totalCount: Scalars["Int"]["output"];
};

/** Active policies input */
export type ActivePoliciesInput = {
  /** The ordering of the returned policies */
  orderBy?: InputMaybe<ActivePolicyOrder>;
  /** Filters the policies with the given query. Partial matches by name are supported. */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** Scope MRN the scope for which to grab the active policies. Currently, only spaces are supported. */
  scopeMrn: Scalars["String"]["input"];
};

/** Active policy */
export type ActivePolicy = {
  __typename: "ActivePolicy";
  /** Policy action determining whether the policy is preview or not */
  action: PolicyAction;
  /** The scope MRN where this policy was assigned (space, org, or platform) */
  assignedScope?: Maybe<Scalars["String"]["output"]>;
  /**
   * Policy blast radius for the given scope
   * @deprecated BlastRadius is available within ActivePolicy.Score
   */
  blastRadius: BlastRadius;
  /** Created time for the policy */
  created_at?: Maybe<Scalars["String"]["output"]>;
  /** Policy icon */
  icon: Icon_Ids;
  /** Last enabled at */
  lastAppliedAt?: Maybe<Scalars["String"]["output"]>;
  /** Policy MRN */
  mrn: Scalars["String"]["output"];
  /** Policy name */
  name: Scalars["String"]["output"];
  /** Policy score for the given scope */
  score?: Maybe<AggregateScore>;
  /**
   * Trust level: OFFICIAL for a policy from the Mondoo registry, PRIVATE for a
   * custom policy uploaded into the space.
   */
  trustLevel: TrustLevel;
  /** Policy last updated timestamp */
  updatedAt: Scalars["String"]["output"];
  /** Version */
  version?: Maybe<Scalars["String"]["output"]>;
};

/** Active policy edge */
export type ActivePolicyEdge = {
  __typename: "ActivePolicyEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Active policy */
  node?: Maybe<ActivePolicy>;
};

/** Active policy order field */
export type ActivePolicyOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: ActivePolicyOrderField;
};

/** Active policy order field */
export enum ActivePolicyOrderField {
  Action = "ACTION",
  AffectedAssets = "AFFECTED_ASSETS",
  Name = "NAME",
  RiskValue = "RISK_VALUE",
  Version = "VERSION",
}

/** Response when adding an SSH key */
export type AddSshKeyPayload = {
  __typename: "AddSSHKeyPayload";
  /** Whether the operation was successful */
  success: Scalars["Boolean"]["output"];
};

/** Input for adding an SSH key */
export type AddSshKeyRequest = {
  /** The content of the SSH key */
  content: Scalars["String"]["input"];
  /** The MRN of the user */
  mrn: Scalars["String"]["input"];
};

/** Input for adding external group mapping to a team */
export type AddTeamExternalGroupMappingInput = {
  /** The external group ID from the identity provider */
  externalId: Scalars["String"]["input"];
  /** The MRN of the team */
  teamMrn: Scalars["String"]["input"];
};

/** Input for adding a user to a team */
export type AddTeamMemberInput = {
  /**
   * The email of the user (for pending users or to identify existing users)
   * @deprecated Use identity instead
   */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** The identity of the user (MRN or email) */
  identity?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The MRN of the user (for existing users)
   * @deprecated Use identity instead
   */
  memberMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** The MRN of the team */
  teamMrn: Scalars["String"]["input"];
};

/** Result of adding a user to a team */
export type AddTeamMemberResponse = {
  __typename: "AddTeamMemberResponse";
  /** True if a pending team user was created (user doesn't exist yet) */
  createdPending: Scalars["Boolean"]["output"];
  /** The MRN of the member. Not available if the user is not registered yet */
  memberMrn?: Maybe<Scalars["String"]["output"]>;
};

/** Input for adding an edge to a workflow. */
export type AddWorkflowEdgeInput = {
  /** Source node ID. */
  from: Scalars["ID"]["input"];
  /** Output label for branching (e.g. "true", "false"). */
  output?: InputMaybe<Scalars["String"]["input"]>;
  /** Destination node ID. */
  to: Scalars["ID"]["input"];
  /** MRN of the workflow to modify. */
  workflowMrn: Scalars["ID"]["input"];
};

/** Result of adding an edge to a workflow. */
export type AddWorkflowEdgePayload = {
  __typename: "AddWorkflowEdgePayload";
  /** The workflow with the new edge. */
  workflow: Workflow;
};

/** Input for adding a node to a workflow. */
export type AddWorkflowNodeInput = {
  /** Action to invoke on the plugin. */
  action?: InputMaybe<Scalars["String"]["input"]>;
  /** Unique node identifier within this workflow. */
  id: Scalars["ID"]["input"];
  /** Human-readable label. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Plugin that provides the action. */
  plugin?: InputMaybe<Scalars["String"]["input"]>;
  /** Canvas position as [x, y] coordinates. */
  position?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  /** Template name or MRN for execute_workflow nodes. */
  subWorkflow?: InputMaybe<Scalars["String"]["input"]>;
  /** Node type (action, condition, transform, merge, noop, etc.). */
  type: Scalars["String"]["input"];
  /** MRN of the workflow to modify. */
  workflowMrn: Scalars["ID"]["input"];
};

/** Result of adding a node to a workflow. */
export type AddWorkflowNodePayload = {
  __typename: "AddWorkflowNodePayload";
  /** The workflow with the new node. */
  workflow: Workflow;
};

/** Advisory */
export type Advisory = {
  __typename: "Advisory";
  /** Packages affected by this advisory */
  affectedPackages?: Maybe<Array<Package>>;
  /**
   * Asset MRN
   * @deprecated Use vulnerabilityScores API to get the affected assets. This will be removed
   */
  assetMrn?: Maybe<Scalars["String"]["output"]>;
  /**
   * Advisory CVEs. If a scope MRN is provided, only CVEs existing in
   * the provided scope will be returned
   */
  cves?: Maybe<Array<Cve>>;
  /** Advisory scores */
  cvssScore: CvssScore;
  /** Advisory description */
  description?: Maybe<Scalars["String"]["output"]>;
  /**
   * Advisory source
   * external URL to the specific advisory
   */
  externalUrls?: Maybe<Array<Maybe<Reference>>>;
  /** Packages which fix this advisory */
  fixedByPackages?: Maybe<Array<Package>>;
  /**
   * A short string to identify the icon in the UI
   * @deprecated Deprecated: Use iconIDEnum. (remove in v12)
   */
  iconID?: Maybe<Scalars["String"]["output"]>;
  /** Same as iconID, but as an enum */
  iconIDEnum?: Maybe<Icon_Ids>;
  /** Advisory id */
  id: Scalars["String"]["output"];
  /**
   * Advisory modified date
   * @deprecated Use `modifiedAt`.
   */
  modified?: Maybe<Scalars["String"]["output"]>;
  /** Advisory modified date */
  modifiedAt?: Maybe<Scalars["String"]["output"]>;
  /** Advisory mrn */
  mrn: Scalars["String"]["output"];
  /**
   * Advisory published date
   * @deprecated Use `publishedAt`.
   */
  published?: Maybe<Scalars["String"]["output"]>;
  /** Advisory published date */
  publishedAt?: Maybe<Scalars["String"]["output"]>;
  /**
   * Score
   * @deprecated Use `cvssScore`.
   */
  score: CvssScore;
  /**
   * Advisory source
   * This includes the generic source, like Mozilla, but not the specific URL for a single advisory.
   * For the specific URL, use `externalUrls`.
   * @deprecated No longer supported. (remove in v12)
   */
  source: Source;
  /** Advisory title */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Advisory vendorscore */
  vendorscore?: Maybe<Scalars["Int"]["output"]>;
  /**
   * VulnerabilityRiskFactors: exploitable, RCE, ...
   * @deprecated Use `riskFactors`.
   */
  vulnerabilityRiskFactors: VulnerabilityRiskFactors;
};

/** Advisory */
export type AdvisoryCvesArgs = {
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input options for the advisory of the document */
export type AdvisoryDocumentOptionsInput = {
  /** The ID of the advisory to generate the report for */
  advisoryId: Scalars["String"]["input"];
  /** The MRN of the scope to generate the report for */
  scopeMrn: Scalars["String"]["input"];
};

/** Advisory finding object */
export type AdvisoryFinding = {
  __typename: "AdvisoryFinding";
  /** Asset information */
  asset?: Maybe<EntityInfoAsset>;
  /** Rating for the base score (CRITICAL/HIGH/MEDIUM/LOW/NONE) */
  baseRating: ScoreRating;
  /** Inverted value for the base score */
  baseValue: Scalars["Int"]["output"];
  /** Cases associated with this finding. */
  cases?: Maybe<CasesConnection>;
  /** CVSS information for this aggregate score (optional, only for vulnerabilities, and software) */
  cvss?: Maybe<CvssScore>;
  /** Sources which detected this vulnerability */
  detectionSources: Array<VulnerabilityScoreSource>;
  /** EPSS information for this aggregate score (optional, only for vulnerabilities, and software) */
  epss?: Maybe<EpssScore>;
  /**
   * Exception for this advisory, if exists
   * @deprecated Use exceptions
   */
  exception?: Maybe<FindingException>;
  /** Exceptions for this advisory, if some exist */
  exceptions?: Maybe<Array<Maybe<FindingException>>>;
  /** Timestamp, when the first failure was detected (RFC3339) */
  firstDetectedAt: Scalars["String"]["output"];
  /** Icon identifier for the score */
  iconId: Icon_Ids;
  /** Vulnerability ID */
  id: Scalars["String"]["output"];
  /** Most recent time the score was updated (RFC3339) */
  lastScoreUpdateTime: Scalars["String"]["output"];
  /**
   * Timestamp, when the score was last updated
   * Deprecated: Use lastScoreUpdateTime instead.
   * @deprecated Use lastScoreUpdateTime instead
   */
  lastUpdated: Scalars["String"]["output"];
  /** MRN */
  mrn: Scalars["String"]["output"];
  /**
   * Preview risk score (0 - 100) computed by the risk-dimension model.
   * Surfaced alongside riskScore for evaluation; null when not available.
   */
  previewRiskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Preview risk value is 100 - previewRiskScore; null when previewRiskScore is not available. */
  previewRiskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Timestamp, when the vulnerability was published (RFC3339) */
  publishedAt?: Maybe<Scalars["String"]["output"]>;
  /** Rating */
  rating: ScoreRating;
  /** Risk categories that apply to this advisory */
  riskCategories?: Maybe<Array<CveRiskCategory>>;
  /** Risk factors */
  riskFactors?: Maybe<Array<Maybe<RiskFactorStats>>>;
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore: Scalars["Int"]["output"];
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue: Scalars["Int"]["output"];
  /** Space risk delta and effort for the finding */
  spaceRiskDelta?: Maybe<FindingSpaceRiskDelta>;
  /** State */
  state: ScoreState;
  /** All states for the finding */
  states: FindingState;
  /** Risk score tags */
  tags?: Maybe<Array<Tag>>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Advisory finding object */
export type AdvisoryFindingCasesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<FindingCasesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** possible Advisory filters */
export enum AdvisoryPlatformFilter {
  Alpine = "ALPINE",
  Amazon = "AMAZON",
  Debian = "DEBIAN",
  Oracle = "ORACLE",
  Redhat = "REDHAT",
  Suse = "SUSE",
  Ubuntu = "UBUNTU",
}

/** Advisory stats for an asset */
export type AffectedAssetStats = {
  __typename: "AffectedAssetStats";
  /** count of assets with unfixed packages */
  affectedCount: Scalars["Int"]["output"];
  /** count of assets with fixed packages */
  fixedCount: Scalars["Int"]["output"];
  /** total count of assets */
  totalCount: Scalars["Int"]["output"];
};

/** Describes an agent (managed client) */
export type Agent = {
  __typename: "Agent";
  /** The assets associated with this agent */
  assets: Array<AgentAsset>;
  /** The created at time of the agent */
  createdAt: Scalars["String"]["output"];
  /** The errors of the agent */
  errors?: Maybe<Array<AgentError>>;
  /** The hostname of the agent */
  hostname: Scalars["String"]["output"];
  /** The ID of the agent */
  id: Scalars["String"]["output"];
  /** The IP address of the agent */
  ipaddress: Scalars["String"]["output"];
  /** The labels of the agent */
  labels: Array<KeyValue>;
  /** The MRN of the agent */
  mrn: Scalars["String"]["output"];
  /** The name of the agent */
  name: Scalars["String"]["output"];
  /** The notes of the agent */
  notes: Scalars["String"]["output"];
  /** The organizations of the agent */
  organizations?: Maybe<Array<Organization>>;
  /** The platform of the agent */
  platform?: Maybe<Platform>;
  /** The service accounts associated with this agent */
  serviceAccounts: Array<AgentServiceAccount>;
  /** The spaces of the agent */
  spaces?: Maybe<Array<Space>>;
  /** The status of the agent */
  status?: Maybe<AgentStatus>;
};

/** Describes an asset associated with an agent */
export type AgentAsset = {
  __typename: "AgentAsset";
  /** The MRN of the asset */
  mrn: Scalars["String"]["output"];
  /** The name of the asset */
  name: Scalars["String"]["output"];
};

/** Agents list edge */
export type AgentEdge = {
  __typename: "AgentEdge";
  /** The cursor of the agent */
  cursor: Scalars["ID"]["output"];
  /** The agent */
  node?: Maybe<Agent>;
};

/** Describes an agent error */
export type AgentError = {
  __typename: "AgentError";
  /** The message of the agent error */
  message?: Maybe<Scalars["String"]["output"]>;
  /** The timestamp of the agent error */
  timestamp?: Maybe<Scalars["String"]["output"]>;
};

/** Options for agents */
export type AgentOptions = {
  __typename: "AgentOptions";
  /** The hostname of the agent */
  hostname: Scalars["String"]["output"];
  /** The ID of the agent */
  id: Scalars["String"]["output"];
  /** The IP address of the agent */
  ipaddress: Scalars["String"]["output"];
  /** The notes of the agent */
  notes: Scalars["String"]["output"];
  /** The platform of the agent */
  platform?: Maybe<Platform>;
  /** The version of the agent */
  version?: Maybe<Scalars["String"]["output"]>;
};

/** Sorting for the agents */
export type AgentOrder = {
  /** The direction of the agent */
  direction: OrderDirection;
  /** The field of the agent */
  field: AgentOrderField;
};

/** Supported sorting fields for agents */
export enum AgentOrderField {
  Hostname = "HOSTNAME",
  Id = "ID",
  Ip = "IP",
  LastCheckin = "LAST_CHECKIN",
  Name = "NAME",
  Platform = "PLATFORM",
  Status = "STATUS",
  Version = "VERSION",
}

/** Describes a service account associated with an agent */
export type AgentServiceAccount = {
  __typename: "AgentServiceAccount";
  /** The MRN of the service account */
  mrn: Scalars["String"]["output"];
  /** The name of the service account */
  name: Scalars["String"]["output"];
};

/** Describes agent state */
export enum AgentState {
  Active = "ACTIVE",
  Missing = "MISSING",
}

/** Agent statistics */
export type AgentStatistics = {
  __typename: "AgentStatistics";
  /** Bad count */
  bad: Scalars["Int"]["output"];
  /** Good count */
  good: Scalars["Int"]["output"];
  /** Pending count */
  pending: Scalars["Int"]["output"];
  /** Total count */
  total: Scalars["Int"]["output"];
};

/** Describes agent status */
export type AgentStatus = {
  __typename: "AgentStatus";
  /** The last checkin time of the agent */
  lastCheckin?: Maybe<Scalars["String"]["output"]>;
  /** The state of the agent */
  state?: Maybe<AgentState>;
  /** The version of the agent */
  version?: Maybe<Scalars["String"]["output"]>;
};

/** Input used to filter the agents by version */
export type AgentVersionFilter = {
  /** Whether to filter out the agent */
  not?: Scalars["Boolean"]["input"];
  /** The version of the agent */
  version: Scalars["String"]["input"];
};

/** Agents list */
export type AgentsConnection = {
  __typename: "AgentsConnection";
  /** The edges of the agents */
  edges?: Maybe<Array<AgentEdge>>;
  /** The page info of the agents */
  pageInfo: PageInfo;
  /** The total number of agents */
  totalCount: Scalars["Int"]["output"];
};

/** Supported filter types for aggScoresSuggestions */
export enum AggScoresFilterType {
  /**
   * Filter by detection source (cnspec vs third-party scanners — SentinelOne,
   * MS Defender, CrowdStrike Falcon, etc.). Values are VexSourceName strings.
   */
  DetectionSources = "DETECTION_SOURCES",
  /** Filter by platform */
  Platform = "PLATFORM",
  /** Filter by policy MRN */
  PolicyMrn = "POLICY_MRN",
  /** Filter by rating (CRITICAL, HIGH, MEDIUM, LOW, etc.) */
  Rating = "RATING",
  /** Filter by risk category impact labels */
  RiskCategoryImpacts = "RISK_CATEGORY_IMPACTS",
  /** Filter by risk factor */
  RiskFactors = "RISK_FACTORS",
  /** Filter by aggregate score state (Exception Created, Ticket Created, Needs Action) */
  State = "STATE",
  /** Filter by aggregate score  types (VULNERABILITY, ADVISORY, ADVISORY, CHECK, POLICY, RISK, ASSET, CONTROL, FRAMEWORK) */
  Types = "TYPES",
}

/** Aggregate initiative metadata */
export type AggregateInitiativeMetadata = {
  __typename: "AggregateInitiativeMetadata";
  /** The number of affected assets. */
  assetCount: Scalars["Int"]["output"];
  /**
   * This is the effort, required by the user to remediate all the findings
   * for this initiative.
   */
  effort: Scalars["Int"]["output"];
  /** Total number of findings across all per-asset initiatives that roll up here. */
  findingCount: Scalars["Int"]["output"];
  /** The number of fixed assets. */
  fixedCount: Scalars["Int"]["output"];
  /** Manual effort calculations (expected effort without Mondoo help) */
  manualEffort: ManualEffort;
  /**
   * Number of those findings that are remediable through the security pipeline
   * (i.e. carry the SECURITY_PIPELINE state).
   */
  securityPipelineSupportedCount: Scalars["Int"]["output"];
};

/** Aggregate score node object */
export type AggregateScore = {
  __typename: "AggregateScore";
  /** Total number of assets affected by this finding */
  assetCount: Scalars["Int"]["output"];
  /** Rating for the base score (CRITICAL/HIGH/MEDIUM/LOW/NONE) */
  baseRating: ScoreRating;
  /** Base score ranging between 0 - 100 */
  baseScore?: Maybe<Scalars["Int"]["output"]>;
  /** Inverted value for the base score */
  baseValue: Scalars["Int"]["output"];
  /** Aggregate score blast radius */
  blastRadius?: Maybe<BlastRadius>;
  /** Cases associated with this finding. */
  cases?: Maybe<CasesConnection>;
  /** Aggregated risk category statistics */
  categoryStats?: Maybe<Array<AggregatedRiskCategoryCount>>;
  /** Completion percentage (0-100) representing the pass rate from finding stats */
  completion?: Maybe<Scalars["Int"]["output"]>;
  /** CVSS information for this aggregate score (optional, only for vulns, and software) */
  cvss?: Maybe<CvssScore>;
  /** Aggregate score description */
  description: Scalars["String"]["output"];
  /** Aggregate score sources which detected the scored vulnerability */
  detectionSources: Array<ScoreSource>;
  /**
   * This is the effort, required by the user to remediate all the
   * findings for an aggregate score, measured in minutes. The formula is count of assets * 10 minutes.
   */
  effort: Scalars["Int"]["output"];
  /** Enforcement state computed from policy override groups (ENFORCING or PREVIEW) */
  enforcementState: EnforcementState;
  /** Asset or Space */
  entity?: Maybe<Entity>;
  /** EPSS information for this aggregate score (optional, only for vulns, and software) */
  epss?: Maybe<EpssScore>;
  /** Exception for this score's check/cve/advisory/control if it exists */
  exception?: Maybe<FindingException>;
  /** MRN of the scored object (eg: check) */
  findingMrn: Scalars["String"]["output"];
  /** Distribution of finding states across all findings (state counts) */
  findingStateCounts?: Maybe<FindingStateCounts>;
  /** Finding-level pass/fail statistics */
  findingStats?: Maybe<FindingStats>;
  /** Timestamp, when the package data was last updated (RFC3339) */
  firstDetectedAt: Scalars["String"]["output"];
  /** Icon identifier for the score */
  iconId: Icon_Ids;
  /** Aggregate score id */
  id: Scalars["ID"]["output"];
  /**
   * Timestamp, when the package data was first collected (RFC3339)
   * Deprecated: Use lastScoreUpdateTime instead. This field is misnamed —
   * it contains the score update time, not the scan time.
   * @deprecated Use lastScoreUpdateTime instead
   */
  lastScannedAt?: Maybe<Scalars["String"]["output"]>;
  /** Most recent time the score was updated (RFC3339) */
  lastScoreUpdateTime?: Maybe<Scalars["String"]["output"]>;
  /** Manual effort calculations (expected effort without Mondoo help) */
  manualEffort?: Maybe<ManualEffort>;
  /**
   * Open cases (tickets) associated with this finding (no pagination, for dataloader use).
   * Returns cases with OPEN status.
   */
  openCases?: Maybe<CasesConnection>;
  /** Platforms where the finding is found. */
  platforms?: Maybe<Array<Scalars["String"]["output"]>>;
  /**
   * Preview risk score (0 - 100) computed by the risk-dimension model.
   * Surfaced alongside riskScore for evaluation; null when not available.
   */
  previewRiskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Preview risk value is 100 - previewRiskScore; null when previewRiskScore is not available. */
  previewRiskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Timestamp when the check will become enforcing (RFC3339), if currently in preview mode */
  previewUntil?: Maybe<Scalars["String"]["output"]>;
  /** Risk ranking */
  rank: Scalars["Float"]["output"];
  /** Rank Score */
  rankScore: Scalars["Float"]["output"];
  /** Score rating */
  rating: ScoreRating;
  /** Timestamp, when the package data was last updated (RFC3339) */
  remediatedAt: Scalars["String"]["output"];
  /** Risk factors */
  riskFactors?: Maybe<Array<Maybe<RiskFactorStats>>>;
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Aggregate score type */
  scoreType: AggregateScoreType;
  /** Number of assets with this finding approaching SLA deadline (at risk) */
  slaAtRiskCount: Scalars["Int"]["output"];
  /** Number of assets with this finding past SLA deadline (overdue) */
  slaOverdueCount: Scalars["Int"]["output"];
  /** The space that the entity belongs to */
  spaceId: Scalars["String"]["output"];
  /**
   * Space risk improvement represent the positive effect on the overall space risk, if this agg score
   * is fixed.
   */
  spaceRiskImprovement: Scalars["Float"]["output"];
  /** Aggregate score state (PREVIEW, ENABLED) */
  state: AggregateScoreState;
  /** All states for the finding */
  states: FindingState;
  /** Aggregate score tags */
  tags?: Maybe<Array<Tag>>;
  /** Aggregate score title */
  title: Scalars["String"]["output"];
  /** Version Distribution of software across the space (optional, only for software) */
  versionDistribution?: Maybe<VersionDistribution>;
};

/** Aggregate score node object */
export type AggregateScoreCasesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<AggregateScoreCasesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Describes how to aggregate */
export enum AggregateScoreAggregationType {
  /** Aggregate by the entity provided (the default) */
  Entity = "ENTITY",
  /** Break down by organization */
  Organization = "ORGANIZATION",
  /** Break down by space */
  Space = "SPACE",
  /** Break down by workspace */
  Workspace = "WORKSPACE",
}

/** Add this new input type somewhere in the file */
export type AggregateScoreCasesFilter = {
  /** Filter cases by their status. */
  statuses?: InputMaybe<Array<CaseStatus>>;
};

/** An aggregate score edge object */
export type AggregateScoreEdge = {
  __typename: "AggregateScoreEdge";
  /** A cursor used for pagination */
  cursor: Scalars["ID"]["output"];
  /** Aggregate score node object */
  node?: Maybe<AggregateScore>;
};

/** Aggregate score filters */
export type AggregateScoreFilter = {
  /**
   * How to aggregate. By default, its SCOPE. If any other values are provided,
   * a findingMrn must be provided
   */
  aggregationType?: InputMaybe<AggregateScoreAggregationType>;
  /**
   * Filter by the detection source(s) that reported the finding. Values are
   * VexSourceName strings (e.g. "VEX_SOURCE_CNSPEC", "VEX_SOURCE_SENTINEL_ONE").
   * Matching is OR/overlap; an empty or omitted list applies no source filter.
   * Used to filter aggregate scores reported by Mondoo (cnspec) vs third-party
   * scanners. VULN/ADVISORY aggregates match on their real source set; all other
   * types (checks, policies, frameworks, software, etc.) match "VEX_SOURCE_CNSPEC".
   */
  detectionSources?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Filter by enforcement state (ENFORCING or PREVIEW).
   * Returns checks matching any of the provided states.
   */
  enforcementState?: InputMaybe<Array<EnforcementState>>;
  /**
   * When true, exclude aggregate scores tied to CI/CD assets.
   * Defaults to false — CI/CD assets are included unless explicitly excluded.
   * Has no effect on rolled-up scores (space/workspace/org level), which are not
   * tied to a real asset.
   */
  excludeCicd?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Filter aggregated score by finding mrn
   * @deprecated Use findingMrns instead
   */
  findingMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter aggregated scores by findings mrns */
  findingMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Retrieve control scores by framework MRN */
  frameworkMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Filter agg scores that have active exceptions.
   * This filter filters out agg scores based only on valid exceptions.
   * Exceptions that are expired, rejected or deleted do not count.
   */
  hasActiveExceptions?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter agg scores that have any SLA violations (overdue OR at risk). */
  hasAnySla?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter agg scores that have at risk SLAs. */
  hasAtRiskSla?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Filter agg scores that have either pending or active exceptions.
   * This filter filters out agg scores based on valid exceptions or pending exceptions.
   * Exceptions that are expired, rejected or deleted do not count. Space setting for
   * exceptions being active only if approved doesn't count for this filter - meaning that
   * regardless of the setting, the filter takes pending exceptions into account.
   */
  hasExceptions?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter agg scores that have overdue SLAs. */
  hasOverdueSla?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Retrieve aggregate scores that have remediation */
  hasRemediation?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter that lists agg scores that have tickets. */
  hasTickets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter agg scores based on an intiative mrn that includes them. */
  initiativeMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** filter to find all scores that are lower or equal than the provided score */
  maxRiskScore?: InputMaybe<Scalars["Int"]["input"]>;
  /**
   * filter to find all scores that are higher or equal than the provided risk value.
   * Takes precedence over maxRiskScore
   */
  minRiskValue?: InputMaybe<Scalars["Int"]["input"]>;
  /** Platforms of the findings assets. */
  platforms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Retrieve check scores by policy MRN */
  policyMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Filter preview checks expiring within the specified number of days.
   * Only applicable when filtering for PREVIEW enforcement state.
   */
  previewUntilWithinDays?: InputMaybe<Scalars["Int"]["input"]>;
  /**
   * filter by textfield input. ex.: ["CHROME-2023"]
   * elements will be ANDed
   */
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Filters the aggregate scores by a list of risk ratings.
   * Accepts an array of `ScoreRating` enums (e.g., `CRITICAL`, `HIGH`).
   */
  rating?: InputMaybe<Array<ScoreRating>>;
  /**
   * Filter by risk-category impact. Multiple entries are ANDed (a finding must
   * match every category); impact labels within an entry are ORed.
   */
  riskCategoryFilters?: InputMaybe<Array<RiskCategoryFilterInput>>;
  /** filter by risk factor mrn */
  risks?: InputMaybe<RiskFactorFilter>;
  /**
   * filter by aggregated score type
   * @deprecated Use scoreTypes instead
   */
  scoreType?: InputMaybe<AggregateScoreType>;
  /** filter by aggregated score types */
  scoreTypes?: InputMaybe<Array<AggregateScoreType>>;
  /**
   * filter aggregated scores by findingMrn of an unversioned software package
   * e.g., finding versions of bash by searching for //.../software/.../name/bash
   * This filter should be used in conjunction with the scoreType filter: VERSIONED_SOFTWARE
   */
  softwareFindingMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Restrict results to scores whose containing space is in this list. Matches
   * both asset-level scores (asset's space) and space-level rolled-up scores
   * for the listed spaces. Used to scope an org-wide aggregateScores call to
   * a subset of spaces.
   */
  spaceMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** filter by aggregate score state. If not provided, all states are returned */
  state?: InputMaybe<AggregateScoreState>;
  /**
   * Filter by finding states. Each entry can specify any combination of state fields.
   * Multiple entries are ORed. Returns scores matching any of the provided state filters.
   */
  states?: InputMaybe<Array<FindingStateFilter>>;
};

/** Aggregate score order object */
export type AggregateScoreOrder = {
  /** Order direction */
  direction: OrderDirection;
  /** AggregateScore field */
  field: AggregateScoreOrderField;
};

/** Aggregate score order field */
export enum AggregateScoreOrderField {
  /** Total number of assets */
  AssetCount = "ASSET_COUNT",
  /** Risk score blast radius */
  BlastRadius = "BLAST_RADIUS",
  /** Completion percentage */
  Completion = "COMPLETION",
  /** First detected */
  FirstDetectedAt = "FIRST_DETECTED_AT",
  /** Number of checks (policies) */
  NumChecks = "NUM_CHECKS",
  /** Number of children (merged items) */
  NumChildren = "NUM_CHILDREN",
  /** Number of controls (frameworks) */
  NumControls = "NUM_CONTROLS",
  /** Number of exceptions (frameworks) */
  NumExceptions = "NUM_EXCEPTIONS",
  /** Number of queries (policies) */
  NumQueries = "NUM_QUERIES",
  /** Risk rank */
  Rank = "RANK",
  /** Risk score field */
  RiskScore = "RISK_SCORE",
  /** Risk value */
  RiskValue = "RISK_VALUE",
  /** SLA at risk count */
  SlaAtRiskCount = "SLA_AT_RISK_COUNT",
  /** SLA overdue count */
  SlaOverdueCount = "SLA_OVERDUE_COUNT",
  /** Title */
  Title = "TITLE",
  /** Number of workspaces containing this finding */
  WorkspaceCount = "WORKSPACE_COUNT",
}

/** Aggregate score rating suggestion value */
export type AggregateScoreRatingValue = {
  __typename: "AggregateScoreRatingValue";
  /** The score Rating filter value */
  value: ScoreRating;
};

/** Aggregate score state */
export enum AggregateScoreState {
  Disabled = "DISABLED",
  Enabled = "ENABLED",
  FalsePositive = "FALSE_POSITIVE",
  Preview = "PREVIEW",
  RiskAccepted = "RISK_ACCEPTED",
  /** @deprecated Use RISK_ACCEPTED */
  Snoozed = "SNOOZED",
  Workaround = "WORKAROUND",
}

/** Aggregate score state suggestion value */
export type AggregateScoreStateValue = {
  __typename: "AggregateScoreStateValue";
  /** The score state filter value */
  value: AggregateScoreState;
};

/** Status of the agg score */
export enum AggregateScoreStatus {
  /** Exception is created for the agg score */
  ExceptionCreated = "EXCEPTION_CREATED",
  /** Agg score needs action */
  NeedsAction = "NEEDS_ACTION",
  /** Ticket is created for the agg score */
  TicketCreated = "TICKET_CREATED",
}

/** Aggregate score status enum */
export type AggregateScoreStatusValue = {
  __typename: "AggregateScoreStatusValue";
  /** Status filter value. */
  value: AggregateScoreStatus;
};

/** Aggregate score type field */
export enum AggregateScoreType {
  Advisory = "ADVISORY",
  Asset = "ASSET",
  Check = "CHECK",
  Control = "CONTROL",
  Framework = "FRAMEWORK",
  /** Aggregate score for an installed product that rolls up all underlying INSTALLED_SOFTWARE entries into a single entry per upstream product (Mondoo product catalog), covering ALL installed software. Powers the per-product software inventory view. */
  InstalledProduct = "INSTALLED_PRODUCT",
  /** Aggregate score for an installed software package across all versions, covering ALL installed software (not just versions affected by a vulnerability). Powers the full software inventory view. */
  InstalledSoftware = "INSTALLED_SOFTWARE",
  Other = "OTHER",
  Policy = "POLICY",
  /** Aggregate score for a product (e.g., Firefox, Chrome) that rolls up all underlying SOFTWARE entries — across operating systems, package formats, and architectures — into a single entry per upstream product as defined in the Mondoo product catalog. */
  Product = "PRODUCT",
  Risk = "RISK",
  /** Aggregate score for a software package across all versions currently affected by a vulnerability */
  Software = "SOFTWARE",
  /** Aggregate score for a software package with a specific version affected by a vulnerability */
  VersionedSoftware = "VERSIONED_SOFTWARE",
  Vulnerability = "VULNERABILITY",
}

/** Aggregate score type suggestion value */
export type AggregateScoreTypeValue = {
  __typename: "AggregateScoreTypeValue";
  /** The score Type filter value */
  value: AggregateScoreType;
};

/** aggregate score connection object */
export type AggregateScoresConnection = {
  __typename: "AggregateScoresConnection";
  /** Risk score edges */
  edges?: Maybe<Array<AggregateScoreEdge>>;
  /** Pagination info */
  pageInfo: PageInfo;
  /** Total count of cves */
  totalCount: Scalars["Int"]["output"];
};

/** Aggregate scores filter suggestion */
export type AggregateScoresFilterSuggestion = FilterSuggestion & {
  __typename: "AggregateScoresFilterSuggestion";
  /** The human-readable label to display */
  label: Scalars["String"]["output"];
  /** The value to use when setting the filter */
  value: AggregateScoresFilterSuggestionValue;
};

/** Union of possible aggregate scores filter suggestion value type */
export type AggregateScoresFilterSuggestionValue =
  | AggregateScoreRatingValue
  | AggregateScoreStateValue
  | AggregateScoreStatusValue
  | AggregateScoreTypeValue
  | RiskCategorySuggestion
  | StringValue;

/** Aggregate score refresh info */
export type AggregateScoresRefreshInfo = {
  __typename: "AggregateScoresRefreshInfo";
  /** Number of assets in the last refresh */
  assets?: Maybe<Scalars["Int"]["output"]>;
  /** Timestamp, when the aggregate scores were last updated (RFC3339) */
  lastUpdatedAt?: Maybe<Scalars["String"]["output"]>;
  /** Whether the refresh is currently in progress */
  refreshInProgress: Scalars["Boolean"]["output"];
};

/** Aggregate scores response */
export type AggregateScoresResponse =
  | AggregateScoresConnection
  | NotFoundError
  | RequestError;

/** Aggregated details on attack surface risk category */
export type AggregatedAttackSurfaceScoredDetails = {
  __typename: "AggregatedAttackSurfaceScoredDetails";
  /** The number of found impact per layer (e.g. "network" -> 5, "internet" -> 2) */
  counts?: Maybe<Array<RiskCategoryDetailCount>>;
};

/** A connection to a system aggregated over a scope for blast radius scoring */
export type AggregatedBlastRadiusConnection = {
  __typename: "AggregatedBlastRadiusConnection";
  /** The number of connections with the same title and subtitle that were aggregated */
  count: Scalars["Int"]["output"];
  /** The subtitle of the connection */
  subtitle: Scalars["String"]["output"];
  /** The title of the connection, e.g. "PostgreSQL", "MySQL", "Kubernetes Cluster" */
  title: Scalars["String"]["output"];
  /** The highest (worst) impact among the aggregated connections */
  worstImpact: Scalars["Float"]["output"];
};

/** A group of connections to systems aggregated over a scope for blast radius scoring */
export type AggregatedBlastRadiusConnectionGroup = {
  __typename: "AggregatedBlastRadiusConnectionGroup";
  /** The connections aggregated for this group */
  children?: Maybe<Array<AggregatedBlastRadiusConnection>>;
  /** The total number of connections aggregated into this group across the scope */
  count: Scalars["Int"]["output"];
  /** The subtitle of the group */
  subtitle: Scalars["String"]["output"];
  /** The title of the group, e.g. "database", "k8s", "kms" */
  title: Scalars["String"]["output"];
  /** The type of the group, e.g. "database", "k8s", "kms" */
  type: Scalars["String"]["output"];
};

/** Aggregated details on blast radius risk category */
export type AggregatedBlastRadiusScoredDetails = {
  __typename: "AggregatedBlastRadiusScoredDetails";
  /** The number of found impact per group (e.g. "database" -> 5, "identity" -> 2) */
  counts?: Maybe<Array<RiskCategoryDetailCount>>;
  /** Connections to local systems, aggregated over a scope */
  localConnections?: Maybe<Array<AggregatedBlastRadiusConnectionGroup>>;
  /** Connections to remote systems, aggregated over a scope */
  remoteConnections?: Maybe<Array<AggregatedBlastRadiusConnectionGroup>>;
};

/** Aggregated details on business priority risk category */
export type AggregatedBusinessPriorityScoredDetails = {
  __typename: "AggregatedBusinessPriorityScoredDetails";
  /** The number of detected business priority groups (e.g. "dev" -> 5, "production" -> 2) */
  counts?: Maybe<Array<RiskCategoryDetailCount>>;
};

/** Aggregated counts on exploitability risk category */
export type AggregatedExploitabilityScoredDetails = {
  __typename: "AggregatedExploitabilityScoredDetails";
  /** The number of findings overrided by a user-defined label */
  overridedCount: Scalars["Int"]["output"];
  /** CVSS score (0-100, "100 = bad") of the representative finding (selected by worst impact). */
  worstCvssScore?: Maybe<Scalars["Int"]["output"]>;
  /** EPSS percentile of the representative finding (selected by worst impact). Range [0.0, 1.0]. */
  worstEpssPercentile?: Maybe<Scalars["Float"]["output"]>;
  /** EPSS probability of the representative finding (selected by worst impact). Range [0.0, 1.0]. */
  worstEpssProbability?: Maybe<Scalars["Float"]["output"]>;
  /**
   * CVE id or advisory id (e.g. "CVE-2024-1234", "GHSA-xxxx") of the representative
   * finding (selected by worst impact).
   */
  worstVulnerabilityId?: Maybe<Scalars["String"]["output"]>;
};

/** Aggregated details on news risk category */
export type AggregatedNewsScoredDetails = {
  __typename: "AggregatedNewsScoredDetails";
  /** The number of findings overrided by a user-defined label */
  overridedCount: Scalars["Int"]["output"];
};

/** Aggregated category information for a specific risk category (e.g. attack surface, connectivity, business priority, exploitability, news). */
export type AggregatedRiskCategoryCount = {
  __typename: "AggregatedRiskCategoryCount";
  /** Category MRN */
  categoryMrn: Scalars["String"]["output"];
  /** Aggregated category details on what exactly was scored for each finding (e.g. attack surface layers, connectivity groups). */
  details?: Maybe<AggregatedRiskCategoryScoredDetails>;
  /** Impact counts */
  impactCounts: RiskCategoryImpactCounts;
  /** The worst (highest) impact label for this category */
  impactLabel: RiskCategoryImpactLabel;
  /**
   * Highest (worst) per-finding impact value across all findings aggregated into this category.
   * Range [-1.0, 1.0]. Null when the aggregation produced no impact value (e.g. the category was
   * disabled or not applicable for every finding). Provided alongside `impactLabel` to make
   * scoring decisions debuggable from the UI.
   */
  worstImpact?: Maybe<Scalars["Float"]["output"]>;
};

/**
 * A union type for aggregated risk category details. Depending on the category, each type will contain different details on
 * what exactly was scored for each finding (e.g. attack surface layers, connectivity groups, number of overrides, etc).
 */
export type AggregatedRiskCategoryScoredDetails =
  | AggregatedAttackSurfaceScoredDetails
  | AggregatedBlastRadiusScoredDetails
  | AggregatedBusinessPriorityScoredDetails
  | AggregatedExploitabilityScoredDetails
  | AggregatedNewsScoredDetails;

/**
 * An installed LLM coding agent (ADR-058 llm-agent). Identified by normalized name +
 * vendor; ecosystem is the sub-entity axis and is not carried on the agent.
 */
export type AiAgent = {
  __typename: "AiAgent";
  /** Per-asset account identity observed for this agent (email/organization/role/...). */
  account?: Maybe<Scalars["Map"]["output"]>;
  /** CVE/advisory MRNs affecting the agent's own installed package on this asset. */
  cves: Array<Scalars["String"]["output"]>;
  /** RFC3339 first observation of this agent on the asset. */
  firstObserved: Scalars["String"]["output"];
  /** RFC3339 last observation of this agent on the asset. */
  lastObserved: Scalars["String"]["output"];
  /** Stable ARD leaf entity MRN. */
  mrn: Scalars["String"]["output"];
  /** Normalized app name, e.g. "Claude Code" (server catalog). */
  name: Scalars["String"]["output"];
  /** Name of the package that installed the agent on this asset; empty when not determined. */
  packageName: Scalars["String"]["output"];
  /** Version of the installing package; empty when not determined. */
  packageVersion: Scalars["String"]["output"];
  /** Package URL of the installing package; empty when not determined. */
  purl: Scalars["String"]["output"];
  /** Detected risk-factor MRNs for this agent on this asset. */
  riskIds: Array<Scalars["String"]["output"]>;
  /** Per-asset risk magnitude (0-100, higher = worse; 0 = unscored). Derived from the agent's own installed package's vulnerability risk; rolls up into the agent's aggregate score. */
  riskValue: Scalars["Int"]["output"];
  /** Coarse runtime host classification: "application" (standalone) | "IDE-plugin" | "browser-plugin". */
  runtimeCategory: Scalars["String"]["output"];
  /** CVE/advisory MRNs affecting the runtime host on this asset. */
  runtimeCves: Array<Scalars["String"]["output"]>;
  /** Concrete host software the agent runs in (OS/IDE/browser) on this asset; empty when not determined. */
  runtimeName: Scalars["String"]["output"];
  /** Runtime host package URL; empty when not determined. */
  runtimePurl: Scalars["String"]["output"];
  /** The runtime host's OWN risk (0-100, higher = worse; 0 = unscored) — the host's vuln status, not the agent's. */
  runtimeRiskValue: Scalars["Int"]["output"];
  /** Runtime host version; empty when not determined. */
  runtimeVersion: Scalars["String"]["output"];
  /** Publishing organization, server-classified. */
  vendor: Scalars["String"]["output"];
  /** Agent app version; empty when the tool exposes none. */
  version: Scalars["String"]["output"];
};

/** One asset's normalized AI-tooling inventory. */
export type AiInventory = {
  __typename: "AiInventory";
  /** LLM coding agents installed on the asset. */
  agents: Array<AiAgent>;
  /** MCP servers configured in the agents. */
  mcpServers: Array<AiMcpServer>;
  /** Plugins installed into the agents. */
  plugins: Array<AiPlugin>;
  /** Skills loaded by the agents. */
  skills: Array<AiSkill>;
};

/** An MCP server configured in an agent on an asset (ADR-058 mcp-server). There is no version. */
export type AiMcpServer = {
  __typename: "AiMcpServer";
  /** Owning agent app name (as observed on this asset). */
  agentName: Scalars["String"]["output"];
  /** Owning agent app version (as observed on this asset). */
  agentVersion: Scalars["String"]["output"];
  /** Owning family: claude | codex | ... (leaf identity). */
  ecosystem: Scalars["String"]["output"];
  /** RFC3339 first observation of this MCP server on the asset. */
  firstObserved: Scalars["String"]["output"];
  /** RFC3339 last observation of this MCP server on the asset. */
  lastObserved: Scalars["String"]["output"];
  /** Stable ARD leaf entity MRN. */
  mrn: Scalars["String"]["output"];
  /** MCP server name (server catalog). */
  name: Scalars["String"]["output"];
  /** false = unauthenticated (the headline risk); null when the family does not report it. */
  needsAuth?: Maybe<Scalars["Boolean"]["output"]>;
  /** Detected risk-factor MRNs for this MCP server on this asset. */
  riskIds: Array<Scalars["String"]["output"]>;
  /** Per-asset risk magnitude (0-100, higher = worse; 0 = unscored). */
  riskValue: Scalars["Int"]["output"];
};

/** A plugin installed into an agent on an asset (ADR-058 llm-plugin). */
export type AiPlugin = {
  __typename: "AiPlugin";
  /** Owning agent app name (as observed on this asset). */
  agentName: Scalars["String"]["output"];
  /** Owning agent app version (as observed on this asset). */
  agentVersion: Scalars["String"]["output"];
  /** Owning family: claude | codex | ... (leaf identity). */
  ecosystem: Scalars["String"]["output"];
  /** Whether the plugin is enabled; null when the family does not report it. */
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** RFC3339 first observation of this plugin on the asset. */
  firstObserved: Scalars["String"]["output"];
  /** Git commit SHA of the installed plugin; empty when not reported. */
  gitCommitSha: Scalars["String"]["output"];
  /** Filesystem path the plugin is installed at (as observed on this asset). */
  installPath: Scalars["String"]["output"];
  /** RFC3339 install time; empty when the family does not report it. */
  installedAt: Scalars["String"]["output"];
  /** RFC3339 last observation of this plugin on the asset. */
  lastObserved: Scalars["String"]["output"];
  /** Stable ARD leaf entity MRN. */
  mrn: Scalars["String"]["output"];
  /** Plugin name (server catalog). */
  name: Scalars["String"]["output"];
  /** Detected risk-factor MRNs for this plugin on this asset. */
  riskIds: Array<Scalars["String"]["output"]>;
  /** Per-asset risk magnitude (0-100, higher = worse; 0 = unscored). */
  riskValue: Scalars["Int"]["output"];
  /** Install scope: user | project. */
  scope: Scalars["String"]["output"];
  /** Plugin version; empty when the family exposes none. */
  version: Scalars["String"]["output"];
};

/** A skill loaded by an agent on an asset (ADR-058 skill). version is the content sha256. */
export type AiSkill = {
  __typename: "AiSkill";
  /** Owning agent app name (as observed on this asset). */
  agentName: Scalars["String"]["output"];
  /** Owning agent app version (as observed on this asset). */
  agentVersion: Scalars["String"]["output"];
  /** Requested capability surface. */
  allowedTools: Array<Scalars["String"]["output"]>;
  /** Human-readable skill description; empty when none is declared. */
  description: Scalars["String"]["output"];
  /** Owning family: claude | codex | ... (leaf identity). */
  ecosystem: Scalars["String"]["output"];
  /** RFC3339 first observation of this skill on the asset. */
  firstObserved: Scalars["String"]["output"];
  /** RFC3339 last observation of this skill on the asset. */
  lastObserved: Scalars["String"]["output"];
  /** Stable ARD leaf entity MRN. */
  mrn: Scalars["String"]["output"];
  /** Skill name (server catalog). */
  name: Scalars["String"]["output"];
  /** Detected risk-factor MRNs for this skill on this asset. */
  riskIds: Array<Scalars["String"]["output"]>;
  /** Per-asset risk magnitude (0-100, higher = worse; 0 = unscored). */
  riskValue: Scalars["Int"]["output"];
  /** Provenance path (as observed on this asset). */
  source: Scalars["String"]["output"];
  /** Content sha256 (integrity, not semver): an edited skill is a distinct row. */
  version: Scalars["String"]["output"];
};

/** Input data for analyzing an asset */
export type AnalyseAssetVulnerabilitiesInput = {
  /** Asset MRN */
  mrn: Scalars["ID"]["input"];
};

/** Data needed for analyzing an asset without mrn */
export type AnalyseIncognitoAssetInput = {
  /** optional kernel information for OS */
  kernelVersion?: InputMaybe<Scalars["String"]["input"]>;
  /** Asset packages */
  packages: Array<PackageInput>;
  /** Asset platform */
  platform: PlatformInput;
};

/** Annotation */
export type Annotation = {
  __typename: "Annotation";
  /** The name of the annotation */
  key: Scalars["String"]["output"];
  /** The value of the annotation */
  value: Scalars["String"]["output"];
};

/** Annotation input */
export type AnnotationInput = {
  /** Annotation key */
  key: Scalars["String"]["input"];
  /** Annotation value */
  value: Scalars["String"]["input"];
};

/** The input to apply an exception to multiple scopes */
export type ApplyExceptionForScopesInput = {
  /**
   * How this exception should be handled
   * Accept risk, disable, or enable findings
   * "enable" will delete the supplied control mrn from any exception
   */
  action: ExceptionMutationAction;
  /** List of advisory mrns that are excepted. Applies only for advisory exceptions */
  advisoryMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Apply the exception to the CVEs that are part of the advisories. Applies only for advisory exceptions */
  applyToCves?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** List of control mrns that are expected. Applies only for compliance exceptions */
  controlMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of cve mrns that are excepted. Applies only for cve exceptions */
  cveMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of finding exchange mrns that are excepted. Applies only for FEX exceptions */
  fexMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The justification for the exception */
  justification?: InputMaybe<Scalars["String"]["input"]>;
  /** List of query mrns that are expected. Applies only for security exceptions */
  queryMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The scopes of the exceptions. Can be a space or an asset mrns */
  scopeMrns: Array<Scalars["String"]["input"]>;
  /**
   * RFC3339 timestamp
   * The date, from which on the exception is no longer valid.
   * Only applies to action IGNORE, empty is interpreted as forever
   */
  validUntil?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for applying Intune remediation */
export type ApplyIntuneRemediationInput = {
  /** The MRN of the asset from whose context the remediation was triggered. */
  assetMrn: Scalars["String"]["input"];
  /** The MRN of the finding (advisory or CVE) */
  findingMrn: Scalars["String"]["input"];
  /** The Intune device group ID to target */
  groupId: Scalars["String"]["input"];
  /** The MRN of the Intune integration */
  integrationMrn: Scalars["String"]["input"];
  /** The MRN of the space */
  spaceMrn: Scalars["String"]["input"];
};

/** Response from applying Intune remediation */
export type ApplyIntuneRemediationPayload = {
  __typename: "ApplyIntuneRemediationPayload";
  /** A message describing the result */
  message?: Maybe<Scalars["String"]["output"]>;
  /** The Intune health script ID created for this remediation */
  scriptId?: Maybe<Scalars["String"]["output"]>;
  /** Whether the remediation was successfully applied */
  success: Scalars["Boolean"]["output"];
};

/** Input for approving a workflow step. */
export type ApproveWorkflowStepInput = {
  /** Optional data to pass to the approved node. */
  data?: InputMaybe<Scalars["Map"]["input"]>;
  /** MRN of the execution containing the approval step. */
  executionMrn: Scalars["ID"]["input"];
  /** ID of the node to approve. */
  nodeId: Scalars["ID"]["input"];
};

/** Result of approving a workflow step. */
export type ApproveWorkflowStepPayload = {
  __typename: "ApproveWorkflowStepPayload";
  /** MRN of the execution that was approved. */
  executionMrn: Scalars["ID"]["output"];
  /** ID of the approved node. */
  nodeId: Scalars["ID"]["output"];
};

/** The per-scope resource roll-up of an entity (no score; see ArdEntity.score). */
export type ArdAggregation = {
  __typename: "ArdAggregation";
  /** Number of in-scope assets rolled up into this entity (exposure). */
  assetCount: Scalars["Int"]["output"];
  /** Top-N histogram over the next grouping dimension (or a named aggregate field). */
  distribution: Array<ArdDistributionBucket>;
  /** Number of distinct descendant entities (products) rolled up into this entity. */
  entityCount: Scalars["Int"]["output"];
  /** = aggregate_score_id non-null; lets clients skip the score fetch. */
  hasScore: Scalars["Boolean"]["output"];
  /** asset-derived platform breakdown; empty unless the type enables it. */
  platformGroups: Array<ArdPlatformGroup>;
  /** per-asset runtime-host breakdown (host name → version) for llm-agent; empty unless the type enables it. */
  runtimeHostGroups: Array<ArdRuntimeHostGroup>;
  /** Scope (space, workspace, or organization MRN) this roll-up is computed for. */
  scopeMrn: Scalars["ID"]["output"];
  /** RFC3339 timestamp of the last recompute. */
  updatedAt: Scalars["String"]["output"];
};

/** The per-scope resource roll-up of an entity (no score; see ArdEntity.score). */
export type ArdAggregationDistributionArgs = {
  dimension?: InputMaybe<Scalars["String"]["input"]>;
  top?: InputMaybe<Scalars["Int"]["input"]>;
};

/** One bucket of an aggregation's distribution histogram. */
export type ArdDistributionBucket = {
  __typename: "ArdDistributionBucket";
  /** assets exhibiting this value (exposure). */
  assetCount: Scalars["Int"]["output"];
  /** child grouping node; null for the "_other" tail. */
  child?: Maybe<ArdEntity>;
  /** Grouping dimension (or aggregate-field name) this bucket breaks down by. */
  dimension: Scalars["String"]["output"];
  /** distinct descendant entities exhibiting it. */
  entityCount?: Maybe<Scalars["Int"]["output"]>;
  /** display snapshot of the child's AggregateScore. */
  score?: Maybe<Scalars["Int"]["output"]>;
  /** Dimension value for this bucket; "_other" carries the capped tail. */
  value: Scalars["String"]["output"];
};

/**
 * One node of an ARD inventory: a shared leaf (grouping == null) or an aggregate
 * grouping node. The shape is uniform at every level so the UI walks
 * parent ↔ children identically.
 */
export type ArdEntity = {
  __typename: "ArdEntity";
  /** Resource roll-up for the given scope (asset count, distribution, …). */
  aggregation: ArdAggregation;
  /** Assets this entity is observed on within the given scope (space, workspace, or organization MRN). */
  assets: AssetsConnection;
  /** Child nodes one level deeper within the same grouping, restricted to the given scope (space, workspace, or organization MRN). */
  children: ArdEntityConnection;
  /** Dimension values: full identity for a leaf, the fixed path for a node. */
  dimensions: Scalars["Map"]["output"];
  /** null for a shared leaf; grouping name for a node. */
  grouping?: Maybe<Scalars["String"]["output"]>;
  /**
   * Short enum identifying the icon for the UI. Software product entities reuse the same
   * resolution as SoftwareV2 (mapped from the product name); grouping nodes that don't name a
   * product (by-vendor/by-category/by-ecosystem roots) and uncurated products fall back to the
   * generic DEFAULT icon.
   */
  iconIDEnum: Icon_Ids;
  /** Depth within the grouping (0 at the root). */
  level: Scalars["Int"]["output"];
  /** The dimension fixed at this level. */
  levelName: Scalars["String"]["output"];
  /** Type-specific display metadata (leaves). */
  metadata: Scalars["Map"]["output"];
  /** Stable MRN; grouping-independent for leaves, strategy+path for nodes. */
  mrn: Scalars["ID"]["output"];
  /** Display name. */
  name: Scalars["String"]["output"];
  /** Parent node within the same grouping; null at a grouping root and for leaves. scopeMrn is the space, workspace, or organization the parent's aggregation is computed for. */
  parent?: Maybe<ArdEntity>;
  /**
   * The entity's score, when it has one, is the existing AggregateScore keyed by
   * this entity's mrn. null for score-free types.
   */
  score?: Maybe<AggregateScore>;
  /** ARD type this entity belongs to, e.g. "software". */
  type: Scalars["String"]["output"];
};

/**
 * One node of an ARD inventory: a shared leaf (grouping == null) or an aggregate
 * grouping node. The shape is uniform at every level so the UI walks
 * parent ↔ children identically.
 */
export type ArdEntityAggregationArgs = {
  scopeMrn: Scalars["ID"]["input"];
};

/**
 * One node of an ARD inventory: a shared leaf (grouping == null) or an aggregate
 * grouping node. The shape is uniform at every level so the UI walks
 * parent ↔ children identically.
 */
export type ArdEntityAssetsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  scopeMrn: Scalars["ID"]["input"];
};

/**
 * One node of an ARD inventory: a shared leaf (grouping == null) or an aggregate
 * grouping node. The shape is uniform at every level so the UI walks
 * parent ↔ children identically.
 */
export type ArdEntityChildrenArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  scopeMrn: Scalars["ID"]["input"];
};

/**
 * One node of an ARD inventory: a shared leaf (grouping == null) or an aggregate
 * grouping node. The shape is uniform at every level so the UI walks
 * parent ↔ children identically.
 */
export type ArdEntityParentArgs = {
  scopeMrn: Scalars["ID"]["input"];
};

/**
 * One node of an ARD inventory: a shared leaf (grouping == null) or an aggregate
 * grouping node. The shape is uniform at every level so the UI walks
 * parent ↔ children identically.
 */
export type ArdEntityScoreArgs = {
  scopeMrn: Scalars["ID"]["input"];
};

/** A page of ARD entities plus pagination metadata. */
export type ArdEntityConnection = {
  __typename: "ArdEntityConnection";
  /** Entities on this page. */
  edges?: Maybe<Array<ArdEntityEdge>>;
  /** Cursors for resuming the walk and the hasNextPage flag. */
  pageInfo: PageInfo;
  /** Total entities matching the query, ignoring pagination. */
  totalCount: Scalars["Int"]["output"];
};

/** A single edge in an ArdEntityConnection — the entity plus its cursor. */
export type ArdEntityEdge = {
  __typename: "ArdEntityEdge";
  /** Opaque cursor that resumes pagination from this entity's position. */
  cursor: Scalars["ID"]["output"];
  /** The ARD entity. */
  node: ArdEntity;
};

/** Filter applied when listing ARD entities. */
export type ArdEntityFilter = {
  dimensions?: InputMaybe<Scalars["Map"]["input"]>;
  /** Case-insensitive substring search term, matched against the dimensions named in searchDimensions (or the queried level's own name when that is empty). */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Score / risk filtering delegates to the existing AggregateScore filter. */
  score?: InputMaybe<AggregateScoreFilter>;
  /**
   * Which grouping-chain dimensions the `name` term searches (substring, OR-ed). Empty matches
   * only the queried level's own name. A dimension one level deeper than the queried level is
   * matched on the child nodes and folded back to their parent — e.g. listing os-by-vendor
   * (level 1) with searchDimensions ["vendor","name"] surfaces a vendor whose name OR a product
   * under it matches.
   */
  searchDimensions?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Ordering applied when listing ARD entities. */
export type ArdEntityOrder = {
  direction: OrderDirection;
  field: ArdEntityOrderField;
};

/** Fields an ARD entity listing can be ordered by. */
export enum ArdEntityOrderField {
  AssetCount = "ASSET_COUNT",
  Name = "NAME",
  Score = "SCORE",
}

/**
 * A declared grouping strategy: an ordered dimension chain plus an optional
 * pre-filter.
 */
export type ArdGrouping = {
  __typename: "ArdGrouping";
  /** Ordered dimension chain this grouping navigates, e.g. [category, vendor, name, version]. */
  dimensions: Array<Scalars["String"]["output"]>;
  /** Optional MQL pre-filter applied before grouping; null when there is none. */
  filter?: Maybe<Scalars["String"]["output"]>;
  /** Stable grouping name, e.g. "by-category"; appears in node MRNs and the UI. */
  name: Scalars["String"]["output"];
};

/** One node of the asset-derived platform breakdown (family → name → release). */
export type ArdPlatformGroup = {
  __typename: "ArdPlatformGroup";
  /** Assets in this platform group. */
  assetCount: Scalars["Int"]["output"];
  /** Next granularity down (family → name → release). */
  children: Array<ArdPlatformGroup>;
  /** Platform family, e.g. "debian". */
  family: Scalars["String"]["output"];
  /** Platform name, e.g. "ubuntu"; null at the family level. */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Platform release, e.g. "22.04"; null above the release level. */
  release?: Maybe<Scalars["String"]["output"]>;
  /** Display snapshot of the group's aggregate score. */
  score?: Maybe<Scalars["Int"]["output"]>;
};

/** One node of an llm-agent's runtime-host breakdown (host name → version, each version carrying the host's own vuln status). */
export type ArdRuntimeHostGroup = {
  __typename: "ArdRuntimeHostGroup";
  /** Assets running this host. */
  assetCount: Scalars["Int"]["output"];
  /** Next granularity down (name → version). */
  children: Array<ArdRuntimeHostGroup>;
  /** The host's CVE/advisory MRNs at the version level. */
  cves: Array<Scalars["String"]["output"]>;
  /** Host software name, e.g. "Firefox", "Visual Studio Code", "macOS". */
  name: Scalars["String"]["output"];
  /** The host's own risk (0-100, higher = worse; 0 = unscored). At the name level, the worst across versions. */
  riskValue: Scalars["Int"]["output"];
  /** Host version, e.g. "120.0"; empty at the name level. */
  version: Scalars["String"]["output"];
};

/** A UID+version-addressed, entity-scoped view of derived data. */
export type Assessment = {
  __typename: "Assessment";
  /**
   * UIDs of this Assessment's direct children. The children themselves
   * appear as separate entries in the enclosing `AssessmentList.items`,
   * so clients can resolve them by UID without recursive queries.
   */
  children: Array<Scalars["String"]["output"]>;
  /**  Typed payloads produced by the generator.  */
  data: Array<AssessmentData>;
  /**  MRN of the entity this assessment was computed for.  */
  entityMrn: Scalars["String"]["output"];
  /**  RFC3339 timestamp of the most recent update.  */
  lastUpdate: Scalars["String"]["output"];
  /**  Progress in [0.0, 1.0]. 1.0 means fully computed.  */
  progress: Scalars["Float"]["output"];
  /**  Lifecycle status of this assessment.  */
  status: AssessmentStatus;
  /**  Generator UID (e.g. "asset-info-os").  */
  uid: Scalars["String"]["output"];
  /**  Version of the generator that produced this assessment.  */
  version: Scalars["String"]["output"];
};

/**
 * A typed payload attached to an Assessment.
 *
 * The `payload` is opaque JSON whose shape is fully determined by `type`.
 * Consumers route each AssessmentData to a renderer registered for its
 * `type` (e.g. "asset-info-os") rather than enumerating possible shapes
 * in the GraphQL query. The canonical schema for each type lives in the
 * server's `assessment/data/` proto definitions.
 */
export type AssessmentData = {
  __typename: "AssessmentData";
  /**  Opaque JSON payload; shape is determined by `type`.  */
  payload: Scalars["Any"]["output"];
  /**  Canonical type identifier (e.g. "asset-info-os") that determines `payload`'s shape.  */
  type: Scalars["String"]["output"];
  /**  Item UID, distinguishes payloads of the same type within an Assessment.  */
  uid: Scalars["String"]["output"];
};

/**
 * List of computed Assessments.
 *
 * Hierarchies are flattened: when an Assessment has children, all of its
 * descendants are returned as siblings in `items`. Each Assessment's
 * `children` field carries the UIDs of its direct children, allowing the
 * client to reconstruct the tree without recursive GraphQL requests.
 *
 * Order: the top-level Assessments appear in the order requested, each
 * followed immediately by its descendants in depth-first order.
 */
export type AssessmentList = {
  __typename: "AssessmentList";
  /**  Flat list of computed Assessments, including all descendants.  */
  items: Array<Assessment>;
};

/** Lifecycle status of an Assessment. */
export enum AssessmentStatus {
  Aborted = "ABORTED",
  Completed = "COMPLETED",
  Errored = "ERRORED",
  InProgress = "IN_PROGRESS",
  NoResults = "NO_RESULTS",
  Unknown = "UNKNOWN",
}

/** Response wrapper for the assessments query and mutations. */
export type AssessmentsResponse = AssessmentList | NotFoundError | RequestError;

/** Asset */
export type Asset = {
  __typename: "Asset";
  /** Annotations */
  annotations: Array<KeyValue>;
  /** Asset type */
  asset_type: Scalars["String"]["output"];
  /** Creation time of the asset */
  createdAt: Scalars["String"]["output"];
  /** End-of-life */
  eol?: Maybe<EolAnalysis>;
  /**
   * Finding statistics (total and open findings) for the asset, derived from
   * the findings/all aggregate score. Null when the asset has no aggregate
   * score yet (e.g. it has not been scored).
   */
  findingStats?: Maybe<AssetFindingStats>;
  /** Unique asset id */
  id: Scalars["ID"]["output"];
  /** Asset insights */
  insights?: Maybe<AssetInsights>;
  /** Labels are optimized for searching */
  labels: Array<KeyValue>;
  /**
   * Most recent time a cnspec scan finished uploading results for this
   * asset (RFC3339). Distinct from lastUpstreamScanTime so the UI can show
   * cnspec and third-party provenance independently. Null when cnspec has
   * never reported a completed scan.
   */
  lastCnspecScanTime?: Maybe<Scalars["String"]["output"]>;
  /** Most recent time the asset score was updated (RFC3339) */
  lastScoreUpdateTime?: Maybe<Scalars["String"]["output"]>;
  /**
   * Most recent time the asset was assigned a score.
   * Deprecated: Use lastScoreUpdateTime instead.
   * @deprecated Use lastScoreUpdateTime instead
   */
  lastScoredAt?: Maybe<Scalars["String"]["output"]>;
  /**
   * Display name of the upstream source that produced lastUpstreamScanTime
   * (e.g. "SentinelOne", "Microsoft Defender", "Falcon Spotlight") — same
   * value as the "Detected by" tag on findings from that source. Null when
   * no upstream source has reported.
   */
  lastUpstreamScanSource?: Maybe<Scalars["String"]["output"]>;
  /**
   * Most recent time an upstream third-party scanner (e.g. SentinelOne, MS
   * Defender, CrowdStrike) reported having scanned this asset (RFC3339).
   * Independent of lastScoreUpdateTime so cnspec scans don't clobber the
   * upstream provenance. Null when no upstream source has reported.
   */
  lastUpstreamScanTime?: Maybe<Scalars["String"]["output"]>;
  /**
   * The most recent scan upload for this asset. Use this to detect when a
   * scan is still being processed (status PENDING / UPLOADED / PROCESSING)
   * so the UI can show a "results may still be processing" banner. Null
   * when the asset has never had a scan uploaded.
   */
  latestScanUpload?: Maybe<LatestScanUpload>;
  /** Policies applied to the asset */
  listPolicies?: Maybe<AssetPolicyListConnection>;
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["output"];
  /** Human readable name of the asset */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Overview groups */
  overviewGroups: Array<AssetOverviewGroup>;
  /** The following properties are scanner specific */
  platform?: Maybe<Platform>;
  /** Platform-specific asset identifiers */
  platformIds: Array<Scalars["String"]["output"]>;
  /** Reference IDs */
  referenceIDs: Array<Scalars["String"]["output"]>;
  /** Related assets */
  relatedAssets?: Maybe<RelatedAssets>;
  /**
   * Report
   * @deprecated Use the query assetVulnerabilityReport instead
   */
  report?: Maybe<Report>;
  /** Risk factors */
  riskFactors?: Maybe<Array<AssetRiskFactor>>;
  /**
   * The added/removed packages, new/resolved findings, and
   * newly-failing/newly-passing checks for one historical scan of this
   * asset, identified by its scored-at timestamp (see scanDeltaTimestamps).
   * Returns null when no delta is available for that timestamp -- expired
   * from bucket retention, never computed for that scan, or an unrecognized
   * timestamp -- never an error.
   */
  scanDelta?: Maybe<AssetScanDelta>;
  /**
   * Timestamps (RFC3339, UTC) of past scans for this asset that have a
   * per-scan delta available via scanDelta -- listed directly from
   * enriched-history bucket storage, NOT from scan upload records (which are
   * tombstoned and unsuitable as a scan-history source of truth). Ordered
   * newest first. Pass a node's value as scanDelta's scoredAt argument.
   */
  scanDeltaTimestamps?: Maybe<AssetScanDeltaTimestampConnection>;
  /**
   * Daily scan-history trend for this asset (server#17278): scan counts and
   * package/CVE/check totals and deltas, one point per UTC day that had at
   * least one scan. Ordered oldest to newest. Backed by a 90-day retention
   * timeseries -- requesting an earlier startTime simply yields fewer points,
   * never an error. See AssetScanHistoryPoint for the exact unknown-vs-zero
   * semantics of the delta fields.
   */
  scanHistory?: Maybe<AssetScanHistoryConnection>;
  /** Score & affected from latest report */
  score: Score;
  /**
   * True when a cnspec scan has finished uploading results for this asset but
   * the score does not yet reflect it — i.e. lastCnspecScanTime is newer than
   * lastScoreUpdateTime, or the asset has been scanned and never scored. The UI
   * shows this as "scoring in progress" so a stale score is not presented as a
   * current one.
   *
   * Derived from those two timestamps rather than stored, so it cannot get stuck:
   * if scoring dies, the timestamps do not move and this correctly stays true. A
   * stored flag would have been written "in progress" and left that way forever.
   *
   * Both timestamps are stamped server-side on either side of the work:
   * lastCnspecScanTime when a cnspec scan finishes uploading its results, and
   * lastScoreUpdateTime when the resulting recalculation persists. The gap
   * between them is precisely the interval where a score is owed but not yet
   * delivered, which is what this reports.
   *
   * Only reflects cnspec scans. Assets scored solely by third-party importers
   * (see lastUpstreamScanTime) are always false: that timestamp comes from the
   * importer's own clock and is stamped on metadata sync rather than on findings
   * upload, so it cannot be compared against our score time. Third-party uploads
   * are ingested by a separate path that never writes lastCnspecScanTime, so they
   * cannot produce a false positive here either.
   *
   * Scoping note: this says a score is owed, not that work is actively running.
   * A scan whose event is still queued reads true — which is the point. See
   * INC-2026-07-16, where an asset was scanned at 12:42Z and not scored until
   * 13:37Z while the UI showed the old score with no indication.
   */
  scoringPending: Scalars["Boolean"]["output"];
  /** State */
  state: AssetState;
  /** Latest update for the asset */
  updatedAt?: Maybe<Scalars["String"]["output"]>;
};

/** Asset */
export type AssetListPoliciesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<AssetListPoliciesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Asset */
export type AssetScanDeltaArgs = {
  scoredAt: Scalars["String"]["input"];
};

/** Asset */
export type AssetScanDeltaTimestampsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Asset */
export type AssetScanHistoryArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  endTime?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  startTime?: InputMaybe<Scalars["String"]["input"]>;
};

/** An exception for an advisory that is defined on an asset level */
export type AssetAdvisoryException = {
  __typename: "AssetAdvisoryException";
  /** CVSS information for this aggregate score (optional, only for vulns, and software) */
  cvss?: Maybe<CvssScore>;
  /** Icon identifier */
  iconId: Icon_Ids;
  /** Vulnerability ID */
  id: Scalars["String"]["output"];
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Rating */
  rating: ScoreRating;
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Asset advisory info */
export type AssetAdvisoryInfo = {
  __typename: "AssetAdvisoryInfo";
  /** Active advisory count */
  activeAdvisoryCount?: Maybe<Scalars["Int"]["output"]>;
  /** Worst CVSS score */
  worstCvssScore?: Maybe<CvssScore>;
};

/** An exception for a check that is defined on an asset level */
export type AssetCheckException = {
  __typename: "AssetCheckException";
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Policy MRN */
  policyMrn: Scalars["String"]["output"];
  /** Policy name */
  policyName: Scalars["String"]["output"];
  /** Rating */
  rating: ScoreRating;
  /** Risk score */
  riskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Score */
  score?: Maybe<Score>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Stats for the checks */
export type AssetCheckStats = {
  __typename: "AssetCheckStats";
  /** errored */
  errored: Scalars["Int"]["output"];
  /** failed */
  failed: Scalars["Int"]["output"];
  /** passed */
  passed: Scalars["Int"]["output"];
};

/** An exception for a CVE that is defined on an asset level */
export type AssetCveException = {
  __typename: "AssetCveException";
  /** CVSS information for this aggregate score (optional, only for vulns, and software) */
  cvss?: Maybe<CvssScore>;
  /** Vulnerability ID */
  id: Scalars["String"]["output"];
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Rating */
  rating: ScoreRating;
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Filter assets by device type */
export type AssetDeviceTypeFilter = {
  /** Device types to include */
  deviceTypes: Array<DeviceType>;
};

/** Input options for the asset of the document */
export type AssetDocumentOptionsInput = {
  /** The MRN of the asset to generate the report for */
  assetMrn: Scalars["String"]["input"];
};

/** Asset edge */
export type AssetEdge = {
  __typename: "AssetEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<Asset>;
};

/** Asset end-of-life filter */
export type AssetEolFilter = {
  /** Is end-of-life */
  isEol?: Scalars["Boolean"]["input"];
  /** Is not end-of-life */
  isNotEol?: Scalars["Boolean"]["input"];
};

/** Filter assets by their EOL status */
export type AssetEolStatusFilter = {
  /** EOL statuses to include */
  statuses: Array<EolStatus>;
};

/** Asset exploitable filter */
export type AssetExploitableFilter = {
  /** Is exploitable */
  isExploitable?: Scalars["Boolean"]["input"];
  /** Is not exploitable */
  isNotExploitable?: Scalars["Boolean"]["input"];
};

/** An exception for a finding exchange finding that is defined on an asset level */
export type AssetFexException = {
  __typename: "AssetFexException";
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Rating */
  rating: ScoreRating;
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Asset field filters */
export type AssetFieldFilters = {
  __typename: "AssetFieldFilters";
  /** annotation based filters */
  annotationBasedFilters?: Maybe<Array<KeyValue>>;
  /** label based filters */
  labelBasedFilters?: Maybe<Array<KeyValue>>;
};

/** Asset field filters mutation */
export type AssetFieldFiltersMutation = {
  /**
   * annotationBasedFilters is a list of key value pairs that is converted to a mql query. The provided
   * filters will filter against `asset.annotations`. All filters are ORed together
   */
  annotationBasedFilters?: InputMaybe<Array<KeyValueInput>>;
  /**
   * labelBasedFilters is a list of key value pairs that is converted to a mql query. The provided
   * filters will filter against `asset.labels`. All filters are ORed together
   */
  labelBasedFilters?: InputMaybe<Array<KeyValueInput>>;
};

/** Asset filter suggestion */
export type AssetFilterSuggestion = FilterSuggestion & {
  __typename: "AssetFilterSuggestion";
  /** The human-readable label to display */
  label: Scalars["String"]["output"];
  /** The value to use when setting the filter */
  value: AssetFilterSuggestionValue;
};

/** Union of possible asset filter suggestion value types */
export type AssetFilterSuggestionValue =
  | RiskCategorySuggestion
  | ScoreRatingValue
  | StringValue;

/** Supported filter types for asset inventory suggestions */
export enum AssetFilterType {
  /** Filter by annotations (e.g., "mondoo.com/organization: "mondoo-internal") */
  Annotations = "ANNOTATIONS",
  /** Filter by detection source (e.g., "CrowdStrike", "Microsoft Defender") */
  DetectionSource = "DETECTION_SOURCE",
  /** Filter by labels (e.g., "owner:sre-team") */
  Labels = "LABELS",
  /** Filter by asset name (e.g., "prod-database-1") */
  Name = "NAME",
  /** Filter by platform name (e.g., "ubuntu", "windows", "macos") */
  Platform = "PLATFORM",
  /** Filter by risk category impact labels */
  RiskCategoryImpacts = "RISK_CATEGORY_IMPACTS",
  /** Filter by risk rating (CRITICAL, HIGH, MEDIUM, LOW, etc.) */
  RiskRating = "RISK_RATING",
}

/** Finding statistics for an asset, derived from the findings/all aggregate score. */
export type AssetFindingStats = {
  __typename: "AssetFindingStats";
  /**
   * Number of open findings for the asset — the sum of critical, high, medium,
   * and low risk findings. Excludes passing, errored, snoozed, disabled, and
   * excepted findings.
   */
  open: Scalars["Int"]["output"];
  /**
   * Total number of findings for the asset (all checks, CVEs, advisories, and
   * software findings).
   */
  total: Scalars["Int"]["output"];
};

/** Asset grade distribution */
export type AssetGradeDistribution = {
  __typename: "AssetGradeDistribution";
  /** The number of Assets with grade A */
  A: Scalars["Int"]["output"];
  /** The number of Assets with grade B */
  B: Scalars["Int"]["output"];
  /** The number of Assets with grade C */
  C: Scalars["Int"]["output"];
  /** The number of Assets with grade D */
  D: Scalars["Int"]["output"];
  /** The number of Assets with grade F */
  F: Scalars["Int"]["output"];
  /** The number of Assets with grade U (unrated) */
  U: Scalars["Int"]["output"];
  /** The number of Assets with grade X (error) */
  X: Scalars["Int"]["output"];
  /** Total */
  total: Scalars["Int"]["output"];
};

/** Asset group order */
export type AssetGroupOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: Scalars["String"]["input"];
};

/** Asset group statistics */
export type AssetGroupStatistics = {
  __typename: "AssetGroupStatistics";
  /** Count */
  count: Scalars["Int"]["output"];
  /** Display name */
  displayName: Scalars["String"]["output"];
  /** Group type */
  groupType: Scalars["String"]["output"];
  /** Icon */
  icon: Icon_Ids;
  /** List asset types */
  listsAssetTypes: Array<AssetTypeInfo>;
  /** Statistics */
  statistics?: Maybe<Array<AssetTypeStatistics>>;
};

/** Asset grouping */
export type AssetGrouping = {
  __typename: "AssetGrouping";
  /** Group */
  group: Scalars["Map"]["output"];
  /** Items */
  items: Array<AssetItem>;
  /** Statistics */
  stats: ReportStatsAsset;
};

/**
 * Asset vulnerability report for assets without mrn
 * This is used by cnquery/cnspec shell/vuln/run
 */
export type AssetIncognitoVulnerabilityReport = {
  __typename: "AssetIncognitoVulnerabilityReport";
  /** Advisories affecting the asset */
  advisories: Array<Advisory>;
  /** CVEs affecting the asset */
  cves: Array<Cve>;
  /** Packages affected by advisories and CVEs */
  packages: Array<Package>;
  /** Stats for the asset */
  stats?: Maybe<ReportStats>;
};

/**
 * special type for cnspec shell
 * in these cases we don't have an asset mrn
 * but the AssetVulnerabilityReport is intercepted and requires an asset mrn to work
 */
export type AssetIncognitoVulnerabilityReportResponse =
  | AssetIncognitoVulnerabilityReport
  | NotFoundError;

/** Asset initiative metadata */
export type AssetInitiativeMetadata = {
  __typename: "AssetInitiativeMetadata";
  /**
   * Number of findings on this asset initiative remediable through the security
   * pipeline (i.e. carry the SECURITY_PIPELINE state). Total findings is the
   * length of the initiative's references; unsupported is total minus this.
   */
  securityPipelineSupportedCount: Scalars["Int"]["output"];
};

/** Asset insights */
export type AssetInsights = {
  __typename: "AssetInsights";
  /** Security insights */
  security: AssetInsightsSecurity;
  /**
   * Vulnerability insights. This can be empty if the platform vulnerability
   * policy is disabled for the space
   */
  vulnerability?: Maybe<AssetInsightsVulnerability>;
};

/** Asset security insights */
export type AssetInsightsSecurity = {
  __typename: "AssetInsightsSecurity";
  /** Total number of enabled policies for the asset */
  policyCount: Scalars["Int"]["output"];
  /** Security score */
  score: Score;
};

/** Asset vulnerability insights */
export type AssetInsightsVulnerability = {
  __typename: "AssetInsightsVulnerability";
  /** Vulnerability score */
  score: Score;
};

/** The complete asset interconnection graph for an organization */
export type AssetInterconnectionGraph = {
  __typename: "AssetInterconnectionGraph";
  /** All edges in the graph */
  edges: Array<InterconnectionEdge>;
  /** All nodes in the graph */
  nodes: Array<InterconnectionNode>;
};

/** AssetItem is a subset of Asset */
export type AssetItem = {
  __typename: "AssetItem";
  /** Advisory info */
  advisoryInfo?: Maybe<AssetAdvisoryInfo>;
  /** ID */
  id: Scalars["ID"]["output"];
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["output"];
  /** Name */
  name: Scalars["String"]["output"];
  /** Platform name */
  platformName?: Maybe<Scalars["String"]["output"]>;
  /** Platform version */
  platformVersion?: Maybe<Scalars["String"]["output"]>;
  /** Score */
  score: Score;
};

/** Query data for a single assets package update time */
export type AssetLastPackageUpdateTimeInput = {
  /** Asset MRN */
  mrn: Scalars["ID"]["input"];
};

/** Response data for a single assets package update time */
export type AssetLastPackageUpdateTimeResponse = {
  __typename: "AssetLastPackageUpdateTimeResponse";
  /** RFC3339 timestamp of the last update of the packages for the asset */
  lastUpdated: Scalars["String"]["output"];
};

/** Asset link info */
export type AssetLinkInfo = CiAssetLinkInfo | FleetAssetLinkInfo;

/** Asset link info input */
export type AssetLinkInfoInput = {
  /** Asset ID */
  assetId: Scalars["String"]["input"];
  /** Space ID */
  spaceID: Scalars["String"]["input"];
};

/** Asset link type */
export enum AssetLinkType {
  Ci = "CI",
  Fleet = "FLEET",
}

/** Filter for the asset policies */
export type AssetListPoliciesFilter = {
  /** Filters policies by their category */
  categories?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Filters policies by their grade
   * @deprecated Use ratings
   */
  grades?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filters policies partially matching on policy name and MRN */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** Filters policies by their rating */
  ratings?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Asset OS reboot filter */
export type AssetOsRebootFilter = {
  /** No reboot */
  noReboot?: Scalars["Boolean"]["input"];
  /** Pending reboot */
  pendingReboot?: Scalars["Boolean"]["input"];
};

/** Asset order */
export type AssetOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: AssetOrderField;
};

/** Asset order field */
export enum AssetOrderField {
  /**
   * Order by the per-asset end-of-life date (nulls last). Pairs with the
   * eolStatus filter to build date-ordered "what goes EOL next" listings.
   */
  EolDate = "EOL_DATE",
  Id = "ID",
  LastUpdated = "LAST_UPDATED",
  Name = "NAME",
  Platform = "PLATFORM",
  RiskScore = "RISK_SCORE",
  RiskValue = "RISK_VALUE",
  Score = "SCORE",
}

/** An array value for an item for an asset overview. */
export type AssetOverviewArrayValue = {
  __typename: "AssetOverviewArrayValue";
  /** The values */
  value?: Maybe<Array<AssetOverviewValueUnion>>;
};

/** A boolean value for an item for an asset overview. */
export type AssetOverviewBoolValue = {
  __typename: "AssetOverviewBoolValue";
  /** The value */
  value: Scalars["Boolean"]["output"];
};

/** A dict value for an item for an asset overview. */
export type AssetOverviewDictValue = {
  __typename: "AssetOverviewDictValue";
  /** The key-value pairs */
  value?: Maybe<Array<KeyValue>>;
};

/** An error value for an item for an asset overview. */
export type AssetOverviewError = {
  __typename: "AssetOverviewError";
  /** The value of the error, which can be a specific error type. */
  value: AssetOverviewErrorValueUnion;
};

/** An error value for an item for an asset overview when execution of a query failed. */
export type AssetOverviewErrorExecutionFailed = {
  __typename: "AssetOverviewErrorExecutionFailed";
  /** The error message. */
  msg: Scalars["String"]["output"];
  /** The MRN of the query that was providing the value for this item. */
  queryMrn?: Maybe<Scalars["String"]["output"]>;
};

/** An error value for an item for an asset overview when there is no data available. */
export type AssetOverviewErrorNoData = {
  __typename: "AssetOverviewErrorNoData";
  /** The error message. */
  msg: Scalars["String"]["output"];
  /** The MRN of the policy that provided the error. */
  providedByPolicyMrn: Scalars["String"]["output"];
};

/** An enumeration of the possible error types for an item for an asset overview. */
export type AssetOverviewErrorValueUnion =
  | AssetOverviewErrorExecutionFailed
  | AssetOverviewGenericError;

/** An error value for an item for an asset overview. */
export type AssetOverviewGenericError = {
  __typename: "AssetOverviewGenericError";
  /**
   * The error code.
   * - UNKNOWN: we haven't defined this type of error
   */
  code: Scalars["String"]["output"];
  /** The error message. */
  msg: Scalars["String"]["output"];
};

/** A group of curated items for an asset overview. */
export type AssetOverviewGroup = {
  __typename: "AssetOverviewGroup";
  /** The list of curated items in the group. */
  items: Array<AssetOverviewItem>;
  /**
   * A unique identifier for the group. In case the UI
   * needs to find something specific
   */
  key: Scalars["String"]["output"];
  /** The title of the group. */
  title: Scalars["String"]["output"];
};

/** A curated item for an asset overview. */
export type AssetOverviewItem = {
  __typename: "AssetOverviewItem";
  /**
   * A unique identifier for the group. In case the UI
   * needs to find something specific
   */
  key: Scalars["String"]["output"];
  /** The name of the curated item. */
  name: Scalars["String"]["output"];
  /** Where the value comes from */
  sources?: Maybe<Array<AssetOverviewItemSource>>;
  /** The values of the item, which can be a string, boolean, dict, reference, or error. */
  values: Array<AssetOverviewValueUnion>;
};

/** A union type representing the possible sources of an item for an asset overview. */
export type AssetOverviewItemSource = KeyValueSource | QuerySource;

/** A null value for an item for an asset overview. */
export type AssetOverviewNullValue = {
  __typename: "AssetOverviewNullValue";
  /** This is always empty */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Asset overview page info */
export type AssetOverviewPageInfo = {
  /** Asset MRN */
  assetMrn: Scalars["String"]["input"];
  /** Organization MRN */
  orgMrn: Scalars["String"]["input"];
  /** Space MRN */
  spaceMrn: Scalars["String"]["input"];
  /**
   * Which tab is selected: Overview, Policies, Controls,
   * Platform Vulnerabilities, Resources
   */
  tab: Scalars["String"]["input"];
};

/** An enumeration of the possible reference types for a  item for an asset overview. */
export enum AssetOverviewReferenceTypeEnum {
  Asset = "ASSET",
  Integration = "INTEGRATION",
}

/** A reference value for an item for an asset overview. */
export type AssetOverviewReferenceValue = {
  __typename: "AssetOverviewReferenceValue";
  /** The display value of the reference. */
  displayValue: Scalars["String"]["output"];
  /** The MRN of the reference. */
  mrn: Scalars["String"]["output"];
  /** The type of the reference, which can be an asset or an integration. */
  referenceType: AssetOverviewReferenceTypeEnum;
};

/** A string value for an item for an asset overview. */
export type AssetOverviewStringValue = {
  __typename: "AssetOverviewStringValue";
  /** The value */
  value: Scalars["String"]["output"];
};

/** A time value for an item for an asset overview. */
export type AssetOverviewTimeValue = {
  __typename: "AssetOverviewTimeValue";
  /** RFC 3339 timestamp */
  value: Scalars["String"]["output"];
};

/** A URL value for an item for an asset overview. */
export type AssetOverviewUrlValue = {
  __typename: "AssetOverviewURLValue";
  /** The display value of the URL */
  displayValue: Scalars["String"]["output"];
  /** The URL to link to */
  url: Scalars["String"]["output"];
};

/** A union type representing the possible values of an item for an asset overview. */
export type AssetOverviewValueUnion =
  | AssetOverviewArrayValue
  | AssetOverviewBoolValue
  | AssetOverviewDictValue
  | AssetOverviewError
  | AssetOverviewNullValue
  | AssetOverviewReferenceValue
  | AssetOverviewStringValue
  | AssetOverviewTimeValue
  | AssetOverviewUrlValue;

/** Asset packages stats */
export type AssetPackagesStats = {
  __typename: "AssetPackagesStats";
  /** Amount of applications detected on the asset */
  appsCount: Scalars["Int"]["output"];
  /** Amount of OS packages detected on the asset */
  osPackagesCount: Scalars["Int"]["output"];
};

/** Asset packages stats input */
export type AssetPackagesStatsInput = {
  /** Asset MRN */
  mrn: Scalars["String"]["input"];
  /** Filter by state */
  state?: InputMaybe<ScoreStateFilter>;
};

/** Asset policy details */
export type AssetPolicy = {
  __typename: "AssetPolicy";
  /** The Action */
  action: PolicyAction;
  /** Category */
  category: Scalars["String"]["output"];
  /** The mrn is a unique identifier */
  mrn: Scalars["ID"]["output"];
  /** Name */
  name: Scalars["String"]["output"];
  /** The score */
  score: Score;
  /** Score statistics */
  scoreStats?: Maybe<ScoreStats>;
};

/** Asset policy connection */
export type AssetPolicyListConnection = {
  __typename: "AssetPolicyListConnection";
  /** Edges */
  edges: Array<AssetPolicyListEdge>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Asset policy edge */
export type AssetPolicyListEdge = {
  __typename: "AssetPolicyListEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node: AssetPolicy;
};

/** Asset report analysis */
export type AssetReportAnalysis = {
  __typename: "AssetReportAnalysis";
  /** End-of-life */
  eol?: Maybe<EolAnalysis>;
};

/**
 * Deprecated: use FindingException instead
 * Asset report exception
 */
export type AssetReportException = {
  __typename: "AssetReportException";
  /** Action */
  action: ExceptionMutationAction;
  /** ID */
  id: Scalars["String"]["output"];
  /** Justification */
  justification: Scalars["String"]["output"];
  /** Review status */
  reviewStatus: ReviewStatus;
};

/** Filter for the asset report's policies */
export type AssetReportListPoliciesFilter = {
  /** Filters policies by their category */
  categories?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filters policies by their grade */
  grades?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filters policies partially matching on policy name and MRN */
  query?: InputMaybe<Scalars["String"]["input"]>;
};

/** Asset report policy details */
export type AssetReportPolicy = {
  __typename: "AssetReportPolicy";
  /** Action */
  action: PolicyAction;
  /** Category */
  category: Scalars["String"]["output"];
  /** The mrn is a unique identifier */
  mrn: Scalars["ID"]["output"];
  /** Name */
  name: Scalars["String"]["output"];
  /** The score */
  score: Score;
  /** Score statistics */
  scoreStats: ScoreStats;
  /** Version */
  version: Scalars["String"]["output"];
};

/** Asset report policy connection */
export type AssetReportPolicyConnection = {
  __typename: "AssetReportPolicyConnection";
  /** Edges */
  edges: Array<AssetReportPolicyEdge>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Asset report policy details */
export type AssetReportPolicyDetails = {
  __typename: "AssetReportPolicyDetails";
  /** The mrn of the asset */
  assetMrn: Scalars["ID"]["output"];
  /** Policy */
  policy: Policy;
  /** Queries */
  queries?: Maybe<Array<AssetReportQuery>>;
  /** The score */
  score: Score;
  /** Score statistics */
  scoreStats: ScoreStats;
};

/** Asset report policy edge */
export type AssetReportPolicyEdge = {
  __typename: "AssetReportPolicyEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node: AssetReportPolicyDetails;
};

/** Asset report policy connection */
export type AssetReportPolicyListConnection = {
  __typename: "AssetReportPolicyListConnection";
  /** Edges */
  edges: Array<AssetReportPolicyListEdge>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Asset report policy edge */
export type AssetReportPolicyListEdge = {
  __typename: "AssetReportPolicyListEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node: AssetReportPolicy;
};

/** Asset report policy order */
export type AssetReportPolicyOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: AssetReportQueryOrderField;
};

/** Asset report query */
export type AssetReportQuery = {
  __typename: "AssetReportQuery";
  /** Action */
  action: PolicyReportScoreEntryAction;
  /** Assessment */
  assessment?: Maybe<PolicyQueryAssessment>;
  /** Data */
  data?: Maybe<Scalars["Any"]["output"]>;
  /** Exception */
  exception?: Maybe<AssetReportException>;
  /** ID */
  id: Scalars["ID"]["output"];
  /** Mquery */
  mquery: Mquery;
  /** Mquery state */
  mqueryState: MqueryState;
  /** Mquery type */
  mqueryType: MqueryType;
  /** Policies */
  policies?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Policy ID */
  policyId: Scalars["String"]["output"];
  /** Policy name */
  policyName: Scalars["String"]["output"];
  /** The score */
  score: Score;
};

/** Asset report query connection */
export type AssetReportQueryConnection = {
  __typename: "AssetReportQueryConnection";
  /** Edges */
  edges: Array<AssetReportQueryEdge>;
  /** Page info */
  pageInfo: PageInfo;
  /** Summary of failed, passed, skipped checks */
  stats?: Maybe<CheckStatsSummary>;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Asset report query edge */
export type AssetReportQueryEdge = {
  __typename: "AssetReportQueryEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node: AssetReportQuery;
};

/** Asset report query order */
export type AssetReportQueryOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: AssetReportQueryOrderField;
};

/** Asset report query order field */
export enum AssetReportQueryOrderField {
  Score = "SCORE",
  Severity = "SEVERITY",
  Title = "TITLE",
}

/** Asset report recommended action */
export type AssetReportRecommendedAction =
  | RecommendedActionItemAdvisory
  | RecommendedActionItemControl;

/** Asset report recommended actions connection */
export type AssetReportRecommendedActionsConnection = {
  __typename: "AssetReportRecommendedActionsConnection";
  /** Edges */
  edges: Array<AssetReportRecommendedActionsEdge>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Asset report recommended actions edge */
export type AssetReportRecommendedActionsEdge = {
  __typename: "AssetReportRecommendedActionsEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node: AssetReportRecommendedAction;
};

/** Input for retrieving asset resources */
export type AssetResourceInput = {
  /** The MRN of the asset */
  assetMrn: Scalars["String"]["input"];
  /** The selected names to retrieve */
  selectedNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The selected paths to retrieve */
  selectedPaths?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Response containing asset resources */
export type AssetResourceResponse = {
  __typename: "AssetResourceResponse";
  /** The resources for the asset */
  resources: Array<Resource>;
  /** The selected names that were retrieved */
  selectedNames?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The selected paths that were retrieved */
  selectedPaths?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** Asset risk factor */
export type AssetRiskFactor = {
  __typename: "AssetRiskFactor";
  /**
   * deprecated, will not be used
   * @deprecated not needed
   */
  affected: Scalars["Int"]["output"];
  /** Risk factor explanation */
  explanation?: Maybe<RiskFactorExplanation>;
  /** Risk factor indicator */
  indicator: Scalars["String"]["output"];
  /** Is detected */
  isDetected: Scalars["Boolean"]["output"];
  /** True if the risk factor has a positive effect on risk */
  isPositive: Scalars["Boolean"]["output"];
  /** Risk factor magnitude */
  magnitude: RiskMagnitude;
  /** Risk Factor Mrn */
  mrn: Scalars["String"]["output"];
  /** Risk factor title */
  title: Scalars["String"]["output"];
  /**
   * deprecated, will not be used
   * @deprecated not needed
   */
  total: Scalars["Int"]["output"];
};

/** A condition within an asset routing rule. */
export type AssetRoutingCondition = {
  __typename: "AssetRoutingCondition";
  /** Asset field to evaluate. */
  field: AssetRoutingField;
  /** Optional label key when field is LABEL. */
  key?: Maybe<Scalars["String"]["output"]>;
  /** Comparison operator to apply. */
  operator: AssetRoutingOperator;
  /** Values to compare against. */
  values: Array<Scalars["String"]["output"]>;
};

/** Input for an asset routing condition. */
export type AssetRoutingConditionInput = {
  /** Asset field to evaluate. */
  field: AssetRoutingField;
  /** Optional label key when field is LABEL. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Comparison operator to apply. */
  operator: AssetRoutingOperator;
  /** Values to compare against. */
  values: Array<Scalars["String"]["input"]>;
};

/** Distribution of currently-routed assets by routing rule and space. */
export type AssetRoutingDistribution = {
  __typename: "AssetRoutingDistribution";
  /** One entry per (routing rule, space) pair holding at least one routed asset. */
  entries: Array<RoutingRuleAssetCount>;
};

/** Asset fields available for routing conditions. */
export enum AssetRoutingField {
  /** Match on asset hostname. */
  Hostname = "HOSTNAME",
  /** Match on asset label key/value. */
  Label = "LABEL",
  /** Match on asset platform name. */
  Platform = "PLATFORM",
}

/** Comparison operators for routing conditions. */
export enum AssetRoutingOperator {
  /** Substring containment check. */
  Contains = "CONTAINS",
  /** Exact equality match. */
  Equal = "EQUAL",
  /** Glob/wildcard match (e.g. "prod-*.example.com"). */
  Matches = "MATCHES",
  /** Negated equality match. */
  NotEqual = "NOT_EQUAL",
}

/** A single routing rule that maps matching assets to a target space. */
export type AssetRoutingRule = {
  __typename: "AssetRoutingRule";
  /**
   * Conditions that must all be satisfied for this rule to match (AND logic).
   * Empty for wildcard rules.
   */
  conditions: Array<AssetRoutingCondition>;
  /** Unique identifier for this routing rule. */
  mrn: Scalars["String"]["output"];
  /** Priority for rule ordering (lower values evaluated first). */
  priority: Scalars["Int"]["output"];
  /**
   * MRN of the space where matching assets will be routed. Empty for
   * wildcard rules — the target space is derived from each asset's tags.
   */
  targetSpaceMrn: Scalars["String"]["output"];
  /**
   * When set, this rule derives the target space from a tag on each asset.
   * Platform scope only; if present, must be the only rule in the scope.
   */
  wildcard?: Maybe<WildcardRoutingConfig>;
};

/** Input for a single asset routing rule. */
export type AssetRoutingRuleInput = {
  /**
   * Conditions that must all match for this rule to apply. Leave empty for
   * wildcard rules.
   */
  conditions: Array<AssetRoutingConditionInput>;
  /**
   * MRN of the target space for matching assets. Leave empty for wildcard
   * rules.
   */
  targetSpaceMrn: Scalars["String"]["input"];
  /**
   * Wildcard routing config. When set, this rule derives the target space
   * from a tag on each asset. Platform scope only; if present, must be the
   * only rule in the scope.
   */
  wildcard?: InputMaybe<WildcardRoutingConfigInput>;
};

/** Asset routing table configuration for a scope (organization or platform). */
export type AssetRoutingTable = {
  __typename: "AssetRoutingTable";
  /**
   * Deprecated alias for scopeMrn — populated for backwards compatibility.
   * @deprecated use scopeMrn
   */
  orgMrn: Scalars["String"]["output"];
  /** Ordered list of routing rules evaluated first-match-wins. */
  rules: Array<AssetRoutingRule>;
  /** Scope MRN that owns this routing table (org MRN or platform MRN). */
  scopeMrn: Scalars["String"]["output"];
};

/**
 * The per-scan delta for one historical scan of an asset (server#17278) --
 * packages/findings/checks that changed relative to the scan immediately
 * preceding it.
 */
export type AssetScanDelta = {
  __typename: "AssetScanDelta";
  /** Check qr_ids whose effective state flipped to failing in this scan. */
  checksNewlyFailing: Array<Scalars["String"]["output"]>;
  /** Check qr_ids whose effective state flipped to passing in this scan. */
  checksNewlyPassing: Array<Scalars["String"]["output"]>;
  /** Finding mrns (CVE/advisory) newly detected in this scan. */
  cvesNew: Array<Scalars["String"]["output"]>;
  /** Finding mrns (CVE/advisory) resolved as of this scan. */
  cvesResolved: Array<Scalars["String"]["output"]>;
  /**
   * True when this was the asset's first successful scan -- every list below
   * is then empty by definition, not an error.
   */
  firstScan: Scalars["Boolean"]["output"];
  /** Purls of packages newly observed in this scan. */
  packagesAdded: Array<Scalars["String"]["output"]>;
  /** Purls of packages no longer observed in this scan. */
  packagesRemoved: Array<Scalars["String"]["output"]>;
};

/** Scan-delta-timestamp connection for Asset.scanDeltaTimestamps. */
export type AssetScanDeltaTimestampConnection = {
  __typename: "AssetScanDeltaTimestampConnection";
  /** Edges */
  edges: Array<AssetScanDeltaTimestampEdge>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total number of scans with a delta available (before pagination). */
  totalCount: Scalars["Int"]["output"];
};

/**
 * Scan-delta-timestamp edge for Asset.scanDeltaTimestamps. node is an
 * RFC3339 scored-at timestamp usable as Asset.scanDelta's scoredAt argument.
 */
export type AssetScanDeltaTimestampEdge = {
  __typename: "AssetScanDeltaTimestampEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** RFC3339 scored-at timestamp identifying the scan. */
  node: Scalars["String"]["output"];
};

/** Scan-history connection for Asset.scanHistory. */
export type AssetScanHistoryConnection = {
  __typename: "AssetScanHistoryConnection";
  /** Edges */
  edges: Array<AssetScanHistoryEdge>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total number of points in the requested window (before pagination). */
  totalCount: Scalars["Int"]["output"];
};

/** Scan-history edge for Asset.scanHistory. */
export type AssetScanHistoryEdge = {
  __typename: "AssetScanHistoryEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** One UTC day's scan-summary trend point. */
  node: AssetScanHistoryPoint;
};

/**
 * One UTC day's scan-summary trend point for an asset (server#17278).
 *
 * packagesAdded/packagesRemoved/cvesNew/cvesResolved/checksNewlyFailing/
 * checksNewlyPassing are null when deltaScans is 0: no delta-capable scan
 * (one whose enriched-artifact producer computed a per-scan diff) contributed
 * to this day's bucket, so their Sum is UNKNOWN for that day -- NOT a
 * verified zero change. A reader must treat a null here as "no data", not as
 * "nothing changed". When deltaScans is greater than 0 every one of those
 * fields is populated, and 0 is then a verified count.
 */
export type AssetScanHistoryPoint = {
  __typename: "AssetScanHistoryPoint";
  /** Total failing-check count as of the most recent scan this day. */
  checksFailing: Scalars["Int"]["output"];
  /** Checks that newly started failing this day, summed across contributing scans. */
  checksNewlyFailing?: Maybe<Scalars["Int"]["output"]>;
  /** Checks that newly started passing this day, summed across contributing scans. */
  checksNewlyPassing?: Maybe<Scalars["Int"]["output"]>;
  /** CVEs/advisories newly detected this day, summed across contributing scans. */
  cvesNew?: Maybe<Scalars["Int"]["output"]>;
  /** CVEs/advisories resolved this day, summed across contributing scans. */
  cvesResolved?: Maybe<Scalars["Int"]["output"]>;
  /** Total open CVE/advisory count as of the most recent scan this day. */
  cvesTotal: Scalars["Int"]["output"];
  /**
   * Number of this day's scans that carried real per-scan delta data (out of
   * `scans`). See this type's doc comment for what deltaScans == 0 means for
   * the nullable fields below.
   */
  deltaScans: Scalars["Int"]["output"];
  /** Packages newly observed this day, summed across contributing scans. */
  packagesAdded?: Maybe<Scalars["Int"]["output"]>;
  /** Packages no longer observed this day, summed across contributing scans. */
  packagesRemoved?: Maybe<Scalars["Int"]["output"]>;
  /** Total package count as of the most recent scan this day. */
  packagesTotal: Scalars["Int"]["output"];
  /** Risk score as of the most recent scan this day. */
  riskScore: Scalars["Int"]["output"];
  /** Number of scans that contributed to this day's bucket. */
  scans: Scalars["Int"]["output"];
  /** Start of the UTC day this point summarizes (RFC3339). */
  timestamp: Scalars["String"]["output"];
};

/** Asset scores distribution */
export type AssetScoresDistribution = {
  __typename: "AssetScoresDistribution";
  /** Date */
  date: Scalars["String"]["output"];
  /** Scores */
  scores: RiskDistribution;
};

/** Structured filters for asset search operations. */
export type AssetSearchFilter = {
  /** Filters assets by annotations (key-value pairs). Uses OR logic. */
  annotations?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filters assets by labels (key-value pairs). Uses OR logic. */
  labels?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filters assets by a partial name match. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Filters assets by one or more platform names. Uses OR logic. */
  platform?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * @deprecated Use riskRating instead. Filters assets by one or more risk ratings. Uses OR logic.
   * @deprecated Use riskRating instead
   */
  rating?: InputMaybe<Array<ScoreRating>>;
  /**
   * Filters assets by the worst impact label of their per-asset risk
   * categories (matched against the per-asset FINDINGS rollup).
   * Multiple entries are ANDed; impact labels within an entry are ORed.
   */
  riskCategoryFilters?: InputMaybe<Array<RiskCategoryFilterInput>>;
  /** Filters assets by one or more risk ratings. Uses OR logic. */
  riskRating?: InputMaybe<Array<ScoreRating>>;
  /** The MRN of the workflow to filter assets by */
  workflowMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Asset search input */
export type AssetSearchInput = {
  /** Filter assets by their hierarchy */
  assetUrlFilter?: InputMaybe<Array<AssetUrlSegmentInput>>;
  /** orgMrn is the mrn of the organization to search assets for */
  orgMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Full text search query. Each term in the query will be ANDed together. The
   * query language supports the following qualifiers:
   * - `name`: Search for assets containing a specific name. This is the default
   * qualifier if none is specified
   * Example: `name:my-asset-name`
   * - `asset`: Alias for `name`
   * - `id`: Search for assets containing a specific asset ID. MRNs are
   * also accepted
   * Example: `id:my-asset-id`
   * - `asset-id`: Alias for `id`
   * - `label`: Search for assets containing a label a specific key and optional value.
   * If no value is specified, the tag must exist with any value. If a value
   * is specified, the tag must exist with that value.
   * Example: `label:my-tag` or `label:my-tag=*` or `label:my-tag="my-value"`
   * - `asset-label`: Alias for `label`
   * - `annotation`: Search for assets containing a annotation a specific key and optional value.
   * If no value is specified, the tag must exist with any value. If a value
   * is specified, the tag must exist with that value.
   * Example: `annotation:my-tag` or `annotation:my-tag=*` or `annotation:my-tag="my-value"`
   * - `asset-annotation`: Alias for `annotation`
   * - `platform`: Search for assets containing a specific platform
   * Example: `platform:my-platform`
   */
  query: Scalars["String"]["input"];
  /**
   * spaceMrns is a list of space mrns to search assets for. If none are provided,
   * all spaces in the organization will be searched
   */
  spaceMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Asset search order field */
export enum AssetSearchOrderField {
  Id = "ID",
  Name = "NAME",
}

/** Response containing asset search suggestions */
export type AssetSearchSuggestions = {
  __typename: "AssetSearchSuggestions";
  /** The list of search suggestions */
  suggestions: Array<Suggestion>;
};

/** Input for asset search suggestions */
export type AssetSearchSuggestionsInput = {
  /** Whether to include CI/CD assets */
  isCiCd?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter suggestions by labels */
  labelFilter?: InputMaybe<Array<InputMaybe<KeyValueInput>>>;
  /** The MRN of a related asset */
  relatedAssetMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** The MRN of the scope to search within */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** The search key for suggestions */
  searchKey?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The MRN of the space (deprecated, use scopeMrn instead)
   * @deprecated Use scopeMrn instead
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Asset search suggestions response */
export type AssetSearchSuggestionsResponse = AssetSearchSuggestions;

/** Asset state */
export enum AssetState {
  Deleted = "DELETED",
  Error = "ERROR",
  Offline = "OFFLINE",
  Online = "ONLINE",
  Pending = "PENDING",
  Reboot = "REBOOT",
  Running = "RUNNING",
  Shutdown = "SHUTDOWN",
  Stopped = "STOPPED",
  Stopping = "STOPPING",
  Terminated = "TERMINATED",
  Unknown = "UNKNOWN",
}

/** Asset summary order */
export type AssetSummaryOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: AssetSummaryOrderField;
};

/** Asset summary order field */
export enum AssetSummaryOrderField {
  Id = "ID",
  Modified = "MODIFIED",
  Published = "PUBLISHED",
  Score = "SCORE",
  Title = "TITLE",
}

/** Asset type info */
export type AssetTypeInfo = {
  __typename: "AssetTypeInfo";
  /** Aliases */
  aliases?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Asset type */
  assetType: Scalars["String"]["output"];
  /** Display name */
  displayName: Scalars["String"]["output"];
  /** Short name */
  shortName: Scalars["String"]["output"];
};

/** Asset type statistics */
export type AssetTypeStatistics = {
  __typename: "AssetTypeStatistics";
  /** Count */
  count: Scalars["Int"]["output"];
  /** Type */
  type: AssetTypeInfo;
};

/** Asset update filter */
export type AssetUpdateFilter = {
  /** After */
  after?: InputMaybe<Scalars["String"]["input"]>;
  /** Before */
  before?: InputMaybe<Scalars["String"]["input"]>;
};

/** The distribution of asset scores */
export type AssetUrlScoreDistribution = {
  __typename: "AssetUrlScoreDistribution";
  /** Critical */
  Critical: Scalars["Int"]["output"];
  /** High */
  High: Scalars["Int"]["output"];
  /** Low */
  Low: Scalars["Int"]["output"];
  /** Medium */
  Medium: Scalars["Int"]["output"];
  /** Ok */
  Ok: Scalars["Int"]["output"];
  /** Unscored */
  Unscored: Scalars["Int"]["output"];
};

/** Asset url segment */
export type AssetUrlSegment = {
  __typename: "AssetUrlSegment";
  /** The key */
  key: Scalars["String"]["output"];
  /** The value */
  value: Scalars["String"]["output"];
};

/** Asset url segment input */
export type AssetUrlSegmentInput = {
  /** The key of the URL segment to filter by */
  key: Scalars["String"]["input"];
  /** The value of the URL segment to filter by */
  value: Scalars["String"]["input"];
};

/** Asset url stats */
export type AssetUrlStats = {
  __typename: "AssetUrlStats";
  /**
   * Asset url is an array of key value pairs. For example, tech=aws service=ec2 would be represented as
   * [{"key": "tech", "value": "aws"}, {"key": "service", "value": "ec2"}]
   */
  assetUrl: Array<AssetUrlSegment>;
  /** The distribution of asset scores */
  scoreDistribution: AssetUrlScoreDistribution;
};

/** Asset url stats category */
export enum AssetUrlStatsCategory {
  Critical = "CRITICAL",
  High = "HIGH",
  Low = "LOW",
  Medium = "MEDIUM",
  Ok = "OK",
  Unscored = "UNSCORED",
}

/** Asset url stats input */
export type AssetUrlStatsInput = {
  /** Exclude stats in the listed categories */
  excludeCategories?: InputMaybe<Array<AssetUrlStatsCategory>>;
  /**
   * Scope to score by. Default is ALL, which is a combination of
   * the security and vulnerabilities scores
   */
  scope?: InputMaybe<AssetUrlStatsScope>;
  /** Scope MRN */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Space MRN
   * @deprecated Use scopeMrn
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Asset url stats payload */
export type AssetUrlStatsPayload = {
  __typename: "AssetUrlStatsPayload";
  /** Asset url stats */
  stats?: Maybe<Array<AssetUrlStats>>;
};

/** Asset url stats scope */
export enum AssetUrlStatsScope {
  /** Score based on vulnerabilities and security */
  All = "ALL",
  /** Score based on security */
  Security = "SECURITY",
  /** Score based on vulnerabilities */
  Vulnerabilities = "VULNERABILITIES",
}

/**
 * This is used by cnquery/cnspec
 * No pagination, no filtering, no ordering, ...
 */
export type AssetVulnerabilityCompactReport = {
  __typename: "AssetVulnerabilityCompactReport";
  /**
   * Advisories affecting the asset
   * @deprecated This approach is deprecated, do not use it.
   */
  advisories: Array<Advisory>;
  /**
   * Asset mrn
   * @deprecated This approach is deprecated, do not use it.
   */
  assetMrn: Scalars["String"]["output"];
  /**
   * CVEs affecting the asset
   * @deprecated This approach is deprecated, do not use it.
   */
  cves: Array<Cve>;
  /**
   * Packages affected by advisories and CVEs
   * @deprecated This approach is deprecated, do not use it.
   */
  packages: Array<Package>;
  /**
   * Stats for the asset
   * @deprecated This approach is deprecated, do not use it.
   */
  stats?: Maybe<ReportStats>;
};

/** Input data for an asset vulnerability report */
export type AssetVulnerabilityReportInput = {
  /** The MRN of the asset */
  assetMrn: Scalars["ID"]["input"];
  /** The format type for the report */
  formatType?: InputMaybe<FormatType>;
};

/** Possible responses for the asset vulnerability report */
export type AssetVulnerabilityReportResponse =
  | AssetVulnerabilityCompactReport
  | NotFoundError
  | NotSupported;

/** Assets connection */
export type AssetsConnection = {
  __typename: "AssetsConnection";
  /** asset group statistics */
  assetGroupStats?: Maybe<Array<AssetGroupStatistics>>;
  /** Edges */
  edges?: Maybe<Array<AssetEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Assets info */
export type AssetsInfo = {
  __typename: "AssetsInfo";
  /** Improved assets this week */
  improved: Scalars["Int"]["output"];
  /** Regressed assets this week */
  regressed: Scalars["Int"]["output"];
  /** Scores */
  scores: RiskDistribution;
  /** Unchanged assets this week */
  unchanged: Scalars["Int"]["output"];
};

/** Attack surface configuration */
export type AttackSurfaceConfiguration = {
  __typename: "AttackSurfaceConfiguration";
  /** Whether to enable attack surface analysis */
  enabled: Scalars["Boolean"]["output"];
  /** Impacts */
  impacts?: Maybe<Array<AttackSurfaceImpact>>;
  /** Weight of the attack surface category */
  weight: Scalars["Float"]["output"];
};

/** Attack surface configuration input */
export type AttackSurfaceConfigurationInput = {
  /** Whether to enable attack surface analysis */
  enabled: Scalars["Boolean"]["input"];
  /** Impacts */
  impacts?: InputMaybe<Array<AttackSurfaceImpactInput>>;
  /** Weight of the attack surface category */
  weight: Scalars["Float"]["input"];
};

/**
 * Attack Surface integration options (as stored/returned): the domains to scan, the
 * scan schedule, the target space, and the enabled scanner modules. The scanner
 * endpoint is server-configured and never exposed here.
 */
export type AttackSurfaceConfigurationOptions = {
  __typename: "AttackSurfaceConfigurationOptions";
  /** Discover cloud assets (AWS, Azure, GCP) associated with the domains. */
  cloudDiscovery?: Maybe<Scalars["Boolean"]["output"]>;
  /** Scan DNS configuration and inventory records. */
  dnsSecurity?: Maybe<Scalars["Boolean"]["output"]>;
  /** Domains to scan. */
  domains?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Scan email security records (SPF, DKIM, DMARC). */
  emailSecurity?: Maybe<Scalars["Boolean"]["output"]>;
  /** Scan HTTP response headers and security configuration. */
  httpSecurity?: Maybe<Scalars["Boolean"]["output"]>;
  /** Check exposed services against known vulnerabilities. */
  knownVulns?: Maybe<Scalars["Boolean"]["output"]>;
  /** When true, scheduled scans are paused. */
  pauseScanning?: Maybe<Scalars["Boolean"]["output"]>;
  /** Scan for open ports and exposed services. */
  portScan?: Maybe<Scalars["Boolean"]["output"]>;
  /** Scan cadence (Go duration, cron, "once", or empty = daily). Recurring scans run at most once every 24h. */
  schedule?: Maybe<Scalars["String"]["output"]>;
  /** Space findings upload to (the integration's own space, or the org's target space). */
  spaceMrn?: Maybe<Scalars["String"]["output"]>;
  /** Detect dangling DNS records vulnerable to subdomain takeover. */
  subdomainTakeover?: Maybe<Scalars["Boolean"]["output"]>;
  /** Discover subdomains of the target domains. */
  subdomains?: Maybe<Scalars["Boolean"]["output"]>;
  /** Scan TLS/SSL configuration and certificate security. */
  tlsSecurity?: Maybe<Scalars["Boolean"]["output"]>;
  /** Run active vulnerability checks against discovered assets. */
  vulnerabilityScanning?: Maybe<Scalars["Boolean"]["output"]>;
  /** Fingerprint web technologies (web bill of materials). */
  webFingerprint?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Attack Surface integration input: the domains to scan, the scan schedule, the
 * target space (at org scope), and which scanner modules to run. Each module toggle
 * enables one or more scanner steps. The scanner endpoint is server-configured and
 * never accepted from the client.
 */
export type AttackSurfaceConfigurationOptionsInput = {
  /** Discover cloud assets (AWS, Azure, GCP) associated with the domains. */
  cloudDiscovery?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Scan DNS configuration and inventory records. */
  dnsSecurity?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Domains to scan (e.g. "example.com"). */
  domains?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Scan email security records (SPF, DKIM, DMARC). */
  emailSecurity?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Scan HTTP response headers and security configuration. */
  httpSecurity?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Check exposed services against known vulnerabilities. */
  knownVulns?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** When true, scheduled scans are paused. */
  pauseScanning?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Scan for open ports and exposed services. */
  portScan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Scan cadence as a Go duration (e.g. "24h"), a cron expression, "once", or empty = daily. Recurring scans run at most once every 24h; a shorter cadence is rejected. */
  schedule?: InputMaybe<Scalars["String"]["input"]>;
  /** Target space findings upload to. Required at org scope; ignored at space scope. */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Detect dangling DNS records vulnerable to subdomain takeover. */
  subdomainTakeover?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Discover subdomains of the target domains. */
  subdomains?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Scan TLS/SSL configuration and certificate security. */
  tlsSecurity?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Run active vulnerability checks against discovered assets. */
  vulnerabilityScanning?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Fingerprint web technologies (web bill of materials). */
  webFingerprint?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Amount of impacted layers for attack surface risk category, e.g., "network" -> 5, "internet" -> 2 */
export type AttackSurfaceDetails = {
  __typename: "AttackSurfaceDetails";
  /** The number of found impacts per layer, e.g., "network" -> 5, "internet" -> 2 */
  layers: Array<AttackSurfaceLayerCount>;
};

/** Impact for an attack-surface layer */
export type AttackSurfaceImpact = {
  __typename: "AttackSurfaceImpact";
  /** Whether the particular attack-surface layer is considered in risk scoring. */
  enabled: Scalars["Boolean"]["output"];
  /** Impact for the attack-surface layer */
  impact: Scalars["Float"]["output"];
  /** Attack-surface layer, e.g. "internet", "network", "local", "system", "none" */
  layer: Scalars["String"]["output"];
};

/** Impact for an attack-surface layer */
export type AttackSurfaceImpactInput = {
  /** Whether the particular attack-surface layer is considered in risk scoring. */
  enabled: Scalars["Boolean"]["input"];
  /** Impact for the attack-surface layer */
  impact: Scalars["Float"]["input"];
  /** Attack-surface layer, e.g. "internet", "network", "local", "system", "none" */
  layer: Scalars["String"]["input"];
};

/** A count of attack surface impacts for a specific layer */
export type AttackSurfaceLayerCount = {
  __typename: "AttackSurfaceLayerCount";
  /** The count of impacts for this layer */
  count: Scalars["Int"]["output"];
  /** The layer name (e.g., "network", "internet") */
  layer: Scalars["String"]["output"];
  /** Whether this impact is provided by Mondoo. In the future, users may define their own impacts. */
  mondooProvided: Scalars["Boolean"]["output"];
};

/** Connection containing audit log entries */
export type AuditLogConnection = {
  __typename: "AuditLogConnection";
  /** The edges in the connection */
  edges?: Maybe<Array<AuditLogEdge>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** The total number of audit log entries */
  totalCount: Scalars["Int"]["output"];
};

/** An edge in an audit log connection */
export type AuditLogEdge = {
  __typename: "AuditLogEdge";
  /** The cursor for this edge */
  cursor: Scalars["ID"]["output"];
  /** The audit log entry at the end of the edge */
  node?: Maybe<AuditLogEntry>;
};

/** An entry in the audit log */
export type AuditLogEntry = {
  __typename: "AuditLogEntry";
  /** The action that was performed */
  action: Scalars["String"]["output"];
  /** The identity that performed the action */
  identity: Identity;
  /** The IP address of the requester */
  ip?: Maybe<Scalars["String"]["output"]>;
  /** The message describing the action */
  msg?: Maybe<Scalars["String"]["output"]>;
  /** The parent resource */
  parent?: Maybe<Scalars["String"]["output"]>;
  /** The resource that was acted upon */
  resource: Scalars["String"]["output"];
  /** RFC 3339 timestamp when the action occurred */
  timestamp: Scalars["String"]["output"];
};

/** Audit log export configuration options */
export type AuditLogExportConfigurationOptions = {
  __typename: "AuditLogExportConfigurationOptions";
  /** Destination bucket name */
  bucket: Scalars["String"]["output"];
  /** Destination type (e.g., gcs) */
  destinationType: Scalars["String"]["output"];
  /** Export format (e.g., OCSF) */
  format: Scalars["String"]["output"];
  /** Whether to include historical audit logs on first export */
  includeHistorical: Scalars["Boolean"]["output"];
  /** Export interval in minutes (minimum 5) */
  intervalMinutes: Scalars["Int"]["output"];
  /** WIF audience URL for GCP workload identity federation */
  wifAudience?: Maybe<Scalars["String"]["output"]>;
  /** Optional GCP service account email for WIF service account impersonation */
  wifServiceAccountEmail?: Maybe<Scalars["String"]["output"]>;
  /** Computed OIDC subject for WIF token requests */
  wifSubject?: Maybe<Scalars["String"]["output"]>;
};

/** Audit log export configuration options input */
export type AuditLogExportConfigurationOptionsInput = {
  /** Destination bucket name */
  bucket: Scalars["String"]["input"];
  /** Destination type (e.g., gcs). Defaults to gcs. */
  destinationType?: InputMaybe<Scalars["String"]["input"]>;
  /** Export format (e.g., OCSF). Defaults to OCSF. */
  format?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether to include historical audit logs on first export */
  includeHistorical?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * GCS service account JSON credentials.
   * Optional when using WIF (workload identity federation) credentials.
   */
  serviceAccountJson?: InputMaybe<Scalars["String"]["input"]>;
  /** WIF audience URL for GCP workload identity federation */
  wifAudience?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional GCP service account email for WIF service account impersonation */
  wifServiceAccountEmail?: InputMaybe<Scalars["String"]["input"]>;
};

/** Audit log filter suggestion */
export type AuditLogFilterSuggestion = FilterSuggestion & {
  __typename: "AuditLogFilterSuggestion";
  /** The human-readable label to display */
  label: Scalars["String"]["output"];
  /** The value to use when setting the filter */
  value: AuditLogFilterSuggestionValue;
};

/** Union of possible audit log filter suggestion value types */
export type AuditLogFilterSuggestionValue = StringValue | TimestampFilterValue;

/** Supported filter types for audit log suggestions */
export enum AuditLogFilterType {
  /** Filter by action */
  Action = "ACTION",
  /** Filter by identity name */
  Identity = "IDENTITY",
  /** Filter by time range */
  Timestamp = "TIMESTAMP",
}

/** Input for ordering audit log entries */
export type AuditLogOrder = {
  /** The direction to order by */
  direction: OrderDirection;
  /** The field to order by */
  field: AuditLogOrderField;
};

/** Field to order audit log entries by */
export enum AuditLogOrderField {
  /** Order by timestamp */
  Timestamp = "TIMESTAMP",
}

/** Audit log filters for multi-filter support */
export type AuditLogsFilter = {
  /** Filter by action (string match) */
  actionFilter?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by identity */
  identityFilter?: InputMaybe<IdentityFilter>;
  /** Filter by timestamp */
  timestampFilter?: InputMaybe<TimestampFilter>;
};

/** Field to order WIF auth bindings by */
export enum AuthBindingOrderField {
  CreateTime = "CREATE_TIME",
  IssuerUri = "ISSUER_URI",
  LastUsed = "LAST_USED",
  Name = "NAME",
}

/** Authentication required error */
export type AuthenticationRequired = Error & {
  __typename: "AuthenticationRequired";
  /** Code */
  code: Scalars["String"]["output"];
  /** Message */
  message: Scalars["String"]["output"];
};

/** Author information for content attribution */
export type Author = {
  __typename: "Author";
  /** The email address of the author */
  email?: Maybe<Scalars["String"]["output"]>;
  /** The ID of the author (MRN) */
  mrn?: Maybe<Scalars["String"]["output"]>;
  /** The name of the author */
  name: Scalars["String"]["output"];
  /** The type of author: USER or SERVICE_ACCOUNT */
  type: AuthorType;
};

/** The type of author */
export enum AuthorType {
  /** A valid service account */
  ServiceAccount = "SERVICE_ACCOUNT",
  /** A registered user */
  User = "USER",
}

/** AWS S3 configuration options */
export type AwsS3ConfigurationOptions = {
  __typename: "AwsS3ConfigurationOptions";
  /** The access key for the S3 bucket */
  accessKey: Scalars["String"]["output"];
  /** The AWS account id (WIF). */
  awsAccountId?: Maybe<Scalars["String"]["output"]>;
  /** The S3 bucket name */
  bucket: Scalars["String"]["output"];
  /** The output format for the S3 bucket */
  output: BucketOutputType;
  /** The AWS region for the S3 bucket */
  region: Scalars["String"]["output"];
  /** Whether this integration uses keyless Workload Identity Federation. */
  useWif?: Maybe<Scalars["Boolean"]["output"]>;
  /** WIF audience. */
  wifAudience?: Maybe<Scalars["String"]["output"]>;
  /** ARN of the IAM role Mondoo assumes (WIF). */
  wifRoleArn?: Maybe<Scalars["String"]["output"]>;
  /**
   * Ready-to-run aws CLI script that provisions the OIDC provider, the
   * mondoo-s3-export role, and a write-only bucket policy. Empty when the
   * integration is not WIF or the deployment has no configured issuer.
   */
  wifSetupScript?: Maybe<Scalars["String"]["output"]>;
  /** Computed OIDC subject for WIF token requests. */
  wifSubject?: Maybe<Scalars["String"]["output"]>;
};

/** AWS S3 integration input */
export type AwsS3ConfigurationOptionsInput = {
  /** The access key for the S3 bucket (static-credential auth) */
  accessKey?: InputMaybe<Scalars["String"]["input"]>;
  /** AWS account id (12 digits). With useWif, the server derives the role ARN and audience. */
  awsAccountId?: InputMaybe<Scalars["String"]["input"]>;
  /** The S3 bucket name */
  bucket: Scalars["String"]["input"];
  /** The output format for the S3 bucket */
  output: BucketOutputType;
  /** The AWS region for the S3 bucket */
  region: Scalars["String"]["input"];
  /** The secret access key for the S3 bucket (static-credential auth) */
  secretAccessKey?: InputMaybe<Scalars["String"]["input"]>;
  /** Use keyless Workload Identity Federation instead of a static access key. */
  useWif?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** WIF audience (manual/advanced; derived from awsAccountId when omitted). */
  wifAudience?: InputMaybe<Scalars["String"]["input"]>;
  /** ARN of the IAM role Mondoo assumes (manual/advanced; derived when omitted). */
  wifRoleArn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Scan type provided when triggering a scan on an AWS integration */
export type AwsScanOptions = {
  scanType: Scalars["String"]["input"];
};

/** Azure blob configuration options */
export type AzureBlobConfigurationOptions = {
  __typename: "AzureBlobConfigurationOptions";
  /**
   * SAS-less container URL to export into (WIF), e.g.
   * https://<account>.blob.core.windows.net/<container>
   */
  blobURL?: Maybe<Scalars["String"]["output"]>;
  /** Client id of the customer's Entra app that Mondoo federates into (WIF). */
  clientId?: Maybe<Scalars["String"]["output"]>;
  /** The output format for the Azure blob */
  output: BucketOutputType;
  /** Azure tenant id of the customer's Entra app (WIF). */
  tenantId?: Maybe<Scalars["String"]["output"]>;
  /** Use keyless Workload Identity Federation instead of a SAS token. */
  useWif?: Maybe<Scalars["Boolean"]["output"]>;
  /** OIDC audience for the Entra token exchange (api://AzureADTokenExchange). */
  wifAudience?: Maybe<Scalars["String"]["output"]>;
  /** Deployment OIDC issuer (STS endpoint) the customer trusts in the federated credential. */
  wifIssuerURL?: Maybe<Scalars["String"]["output"]>;
  /** Computed OIDC subject for WIF token requests. */
  wifSubject?: Maybe<Scalars["String"]["output"]>;
};

/** Azure Blob integration input */
export type AzureBlobConfigurationOptionsInput = {
  /** The Azure blob SAS URL (static-credential auth). Optional when useWif is set. */
  blobSasURL?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * SAS-less container URL to export into (required with useWif), e.g.
   * https://<account>.blob.core.windows.net/<container>
   */
  blobURL?: InputMaybe<Scalars["String"]["input"]>;
  /** Client id of the customer's Entra app that Mondoo federates into (required with useWif). */
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  /** The output format for the Azure blob */
  output: BucketOutputType;
  /** Azure tenant id of the customer's Entra app (required with useWif). */
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
  /** Use keyless Workload Identity Federation instead of a SAS token. */
  useWif?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Azure configuration options */
export type AzureConfigurationOptions = {
  __typename: "AzureConfigurationOptions";
  /** The Azure client ID */
  clientId: Scalars["String"]["output"];
  /** Selected discovery targets. Empty means use the default discovery behavior. */
  discoveryTargets?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Whether to scan VMs */
  scanVms?: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of secret used for authentication */
  secretType?: Maybe<Scalars["String"]["output"]>;
  /** A list of allowed subscription IDs */
  subscriptionsAllowlist?: Maybe<Array<Scalars["String"]["output"]>>;
  /**
   * A list of blacklisted subscription IDs (deprecated)
   * @deprecated Use subscriptionsDenylist
   */
  subscriptionsBlacklist?: Maybe<Array<Scalars["String"]["output"]>>;
  /** A list of denied subscription IDs */
  subscriptionsDenylist?: Maybe<Array<Scalars["String"]["output"]>>;
  /**
   * A list of whitelisted subscription IDs (deprecated)
   * @deprecated Use subscriptionsAllowlist
   */
  subscriptionsWhitelist?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The Azure tenant ID */
  tenantId: Scalars["String"]["output"];
  /** Whether this integration uses Workload Identity Federation (keyless). */
  useWif?: Maybe<Scalars["Boolean"]["output"]>;
  /** OIDC audience for the Entra token exchange (api://AzureADTokenExchange). */
  wifAudience?: Maybe<Scalars["String"]["output"]>;
  /** Mondoo OIDC issuer URL (STS endpoint) the Entra federated credential must trust. */
  wifIssuerUrl?: Maybe<Scalars["String"]["output"]>;
  /** Computed OIDC subject for WIF token requests. */
  wifSubject?: Maybe<Scalars["String"]["output"]>;
};

/** Azure integration input */
export type AzureConfigurationOptionsInput = {
  /** TODO: temporary optional, fix by having separate update models */
  certificate?: InputMaybe<Scalars["String"]["input"]>;
  /** The Azure client ID */
  clientId: Scalars["String"]["input"];
  /** The client secret for authentication (optional) */
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  /** Selected discovery targets. Empty means use the default discovery behavior. */
  discoveryTargets?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Whether to scan VMs */
  scanVms?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** A list of allowed subscription IDs */
  subscriptionsAllowlist?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * A list of blacklisted subscription IDs (deprecated)
   * @deprecated Use subscriptionsDenylist
   */
  subscriptionsBlacklist?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** A list of denied subscription IDs */
  subscriptionsDenylist?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * A list of whitelisted subscription IDs (deprecated)
   * @deprecated Use subscriptionsAllowlist
   */
  subscriptionsWhitelist?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The Azure tenant ID */
  tenantId: Scalars["String"]["input"];
  /**
   * Opt into Workload Identity Federation (keyless). When true, provide tenantId
   * and clientId only — no clientSecret/certificate.
   */
  useWif?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Azure Devops configuration options */
export type AzureDevopsConfigurationOptions = {
  __typename: "AzureDevopsConfigurationOptions";
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["output"];
  /** Whether to auto-create tickets */
  autoCreateTickets: Scalars["Boolean"]["output"];
  /** The default Azure DevOps project name */
  defaultProjectName?: Maybe<Scalars["String"]["output"]>;
  /** The Azure DevOps organization URL */
  organizationUrl: Scalars["String"]["output"];
  /** The Azure service principal ID */
  servicePrincipalId: Scalars["String"]["output"];
  /** The Azure tenant ID */
  tenantId: Scalars["String"]["output"];
};

/** Azure Devops integration input */
export type AzureDevopsConfigurationOptionsInput = {
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["input"];
  /** Whether to auto-create tickets */
  autoCreateTickets: Scalars["Boolean"]["input"];
  /** The Azure client secret */
  clientSecret: Scalars["String"]["input"];
  /** The default Azure DevOps project name */
  defaultProjectName?: InputMaybe<Scalars["String"]["input"]>;
  /** The Azure DevOps organization URL */
  organizationUrl: Scalars["String"]["input"];
  /** The Azure service principal ID */
  servicePrincipalId: Scalars["String"]["input"];
  /** The Azure tenant ID */
  tenantId: Scalars["String"]["input"];
};

/** An Azure DevOps job */
export type AzureDevopsJob = {
  __typename: "AzureDevopsJob";
  /** The branch name */
  branch: Scalars["String"]["output"];
  /** The build URL */
  buildUrl: Scalars["String"]["output"];
  /** The commit SHA */
  commitSha: Scalars["String"]["output"];
  /**
   * The grade of the job (deprecated)
   * @deprecated Grades will be removed in future. Use score.
   */
  grade: Grade;
  /** The ID of the job */
  id: Scalars["String"]["output"];
  /** The job name */
  job: Scalars["String"]["output"];
  /** The job ID */
  jobId: Scalars["String"]["output"];
  /** The MRN of the job */
  mrn: Scalars["String"]["output"];
  /** The name of the job */
  name: Scalars["String"]["output"];
  /** The kind of pipeline */
  pipelineKind: GitPipelineKind;
  /** The URL of the project */
  projectUrl: Scalars["String"]["output"];
  /** The repository URL */
  repositoryUrl: Scalars["String"]["output"];
  /** The score of the job */
  score: Score;
  /** The target of the job */
  target?: Maybe<Scalars["String"]["output"]>;
  /** The time the job was last updated */
  updatedAt: Scalars["String"]["output"];
  /** The username */
  userName: Scalars["String"]["output"];
};

/** This type represents an Azure Devops project. It contains the project's unique name. */
export type AzureDevopsProject = {
  __typename: "AzureDevopsProject";
  /** The name of the project. */
  name: Scalars["String"]["output"];
};

/** Azure Devops ticket configuration input */
export type AzureDevopsTicketConfigInput = {
  /** The Azure Devops project name */
  projectName: Scalars["String"]["input"];
};

/** Parameters for AzureDevopsTicketContext */
export type AzureDevopsTicketContextInput = {
  /** The parameters for the ticket context. */
  projects?: InputMaybe<AzureDevopsTicketContextProjectsInput>;
  /** The type of the ticket context. */
  type: AzureDevopsTicketContextType;
};

/** Azure Devops projects filter parameters for AzureDevopsTicketContext */
export type AzureDevopsTicketContextProjectsInput = {
  /** The Azure Devops query to filter the projects by. */
  query?: InputMaybe<Scalars["String"]["input"]>;
};

/** This type represents an Azure Devops ticket context. It contains the projects that are available for creating a ticket. */
export type AzureDevopsTicketContextProjectsPayload = {
  __typename: "AzureDevopsTicketContextProjectsPayload";
  /** The projects that are available for creating a ticket. */
  projects?: Maybe<Array<AzureDevopsProject>>;
};

/** The type of the ticket context. */
export enum AzureDevopsTicketContextType {
  /** The ticket context for Azure Devops projects. */
  Projects = "PROJECTS",
}

/**
 * A BI dashboard, always returned at a specific version.
 * By default includes the latest version; version-specific
 * queries return the dashboard at the requested version.
 */
export type BiDashboard = {
  __typename: "BIDashboard";
  /** User-provided commit message for this version */
  commitMessage?: Maybe<Scalars["String"]["output"]>;
  /** RFC 3339 timestamp of dashboard creation */
  createdAt: Scalars["String"]["output"];
  /** MRN of the user who created the dashboard */
  createdBy?: Maybe<Scalars["String"]["output"]>;
  /** Dashboard layout and query definition as JSON */
  definition?: Maybe<Scalars["Map"]["output"]>;
  /** Optional description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Unique dashboard identifier */
  id: Scalars["ID"]["output"];
  /** Whether the dashboard has been soft-deleted */
  isArchived: Scalars["Boolean"]["output"];
  /** Whether this version is pinned against pruning */
  isPinned?: Maybe<Scalars["Boolean"]["output"]>;
  /** Globally unique MRN for this dashboard */
  mrn: Scalars["String"]["output"];
  /** ID of the parent version this was derived from */
  parentVersionId?: Maybe<Scalars["Int"]["output"]>;
  /** Scope MRN (organization or space) that owns this dashboard */
  scopeMrn: Scalars["String"]["output"];
  /** Dashboard display title */
  title: Scalars["String"]["output"];
  /** RFC 3339 timestamp of last dashboard update */
  updatedAt: Scalars["String"]["output"];
  /** Total number of versions for this dashboard */
  versionCount?: Maybe<Scalars["Int"]["output"]>;
  /** RFC 3339 timestamp of version creation */
  versionCreatedAt?: Maybe<Scalars["String"]["output"]>;
  /** MRN of the user who created this version */
  versionCreatedBy?: Maybe<Scalars["String"]["output"]>;
  /** Unique version identifier */
  versionId?: Maybe<Scalars["ID"]["output"]>;
  /** Sequential version number within this dashboard */
  versionNumber?: Maybe<Scalars["Int"]["output"]>;
};

/** Input for pinning or unpinning a dashboard version. */
export type BiPinVersionInput = {
  /** Dashboard MRN */
  mrn: Scalars["String"]["input"];
  /** Version ID to pin/unpin */
  versionId: Scalars["ID"]["input"];
};

/** A scheduled export configuration for a BI dashboard. */
export type BiScheduledExport = {
  __typename: "BIScheduledExport";
  /** RFC 3339 timestamp of export creation */
  createdAt: Scalars["String"]["output"];
  /** MRN of the user who created this export */
  createdBy?: Maybe<Scalars["String"]["output"]>;
  /** MRN of the dashboard this export belongs to */
  dashboardMrn: Scalars["String"]["output"];
  /** Export options (format, filters) as JSON */
  exportOptions?: Maybe<Scalars["Map"]["output"]>;
  /** Unique export identifier */
  id: Scalars["ID"]["output"];
  /** Whether this export is currently active */
  isActive: Scalars["Boolean"]["output"];
  /** Error message from the last failed run */
  lastError?: Maybe<Scalars["String"]["output"]>;
  /** RFC 3339 timestamp of the last export run */
  lastRunAt?: Maybe<Scalars["String"]["output"]>;
  /** Status of the last export run */
  lastRunStatus?: Maybe<Scalars["String"]["output"]>;
  /** RFC 3339 timestamp of the next scheduled run */
  nextRunAt?: Maybe<Scalars["String"]["output"]>;
  /** Email addresses to deliver exports to */
  recipients?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Schedule configuration as JSON */
  scheduleConfig?: Maybe<Scalars["Map"]["output"]>;
  /** Schedule type (e.g., daily, weekly) */
  scheduleType?: Maybe<Scalars["String"]["output"]>;
  /** Scope MRN that owns this export */
  scopeMrn: Scalars["String"]["output"];
  /** RFC 3339 timestamp of last export update */
  updatedAt: Scalars["String"]["output"];
};

/** BI tag and SLA configuration for a scope. */
export type BiTagConfig = {
  __typename: "BITagConfig";
  /** Scope MRN this config applies to */
  scopeMrn: Scalars["String"]["output"];
  /** SLA tier configuration (severity -> days threshold) */
  slaTiers?: Maybe<Scalars["Map"]["output"]>;
  /** Annotation/label keys exposed as cube dimensions */
  tagKeys: Array<Scalars["String"]["output"]>;
  /** RFC 3339 timestamp of last update */
  updatedAt?: Maybe<Scalars["String"]["output"]>;
};

/** Input for creating a scheduled export. */
export type BiCreateScheduledExportInput = {
  /** Export options (format, filters) as JSON */
  exportOptions?: InputMaybe<Scalars["Map"]["input"]>;
  /** Dashboard MRN */
  mrn: Scalars["String"]["input"];
  /** Email addresses to deliver exports to */
  recipients?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Schedule configuration as JSON */
  scheduleConfig?: InputMaybe<Scalars["Map"]["input"]>;
  /** Schedule type (e.g., daily, weekly) */
  scheduleType?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for deleting a scheduled export. */
export type BiDeleteScheduledExportInput = {
  /** Export ID */
  id: Scalars["ID"]["input"];
  /** Dashboard MRN */
  mrn: Scalars["String"]["input"];
};

/** Input for updating a scheduled export. */
export type BiUpdateScheduledExportInput = {
  /** Export options (format, filters) as JSON */
  exportOptions?: InputMaybe<Scalars["Map"]["input"]>;
  /** Export ID */
  id: Scalars["ID"]["input"];
  /** Whether this export is active */
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Dashboard MRN */
  mrn: Scalars["String"]["input"];
  /** Email addresses to deliver exports to */
  recipients?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Schedule configuration as JSON */
  scheduleConfig?: InputMaybe<Scalars["Map"]["input"]>;
};

/** BigQuery configuration options */
export type BigqueryConfigurationOptions = {
  __typename: "BigqueryConfigurationOptions";
  /** The BigQuery dataset ID */
  datasetId: Scalars["String"]["output"];
  /** WIF audience URL for GCP workload identity federation */
  wifAudience?: Maybe<Scalars["String"]["output"]>;
  /** Optional GCP service account email for WIF service account impersonation */
  wifServiceAccountEmail?: Maybe<Scalars["String"]["output"]>;
  /**
   * Ready-to-run gcloud script that provisions the shared WIF pool/provider and a
   * write-scoped mondoo-export service account for this export. Empty when the
   * integration is not WIF or the deployment has no configured issuer.
   */
  wifSetupScript?: Maybe<Scalars["String"]["output"]>;
  /** Computed OIDC subject for WIF token requests */
  wifSubject?: Maybe<Scalars["String"]["output"]>;
};

/** BigQuery integration input */
export type BigqueryConfigurationOptionsInput = {
  /** The BigQuery dataset ID */
  datasetId: Scalars["String"]["input"];
  /**
   * GCP project id. With projectNumber, the server derives the WIF audience and
   * the mondoo-export service-account email; the client need not send wifAudience
   * or wifServiceAccountEmail.
   */
  projectId?: InputMaybe<Scalars["String"]["input"]>;
  /** GCP project number (digits). See projectId. */
  projectNumber?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * note: this is the content of the service account JSON file.
   * Optional when using WIF (workload identity federation) credentials.
   */
  serviceAccount?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * WIF audience URL for GCP workload identity federation.
   * e.g., https://iam.googleapis.com/projects/PROJECT_NUMBER/locations/global/workloadIdentityPools/POOL_ID/providers/PROVIDER_ID
   */
  wifAudience?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional GCP service account email for WIF service account impersonation */
  wifServiceAccountEmail?: InputMaybe<Scalars["String"]["input"]>;
};

/** Response containing billing session information */
export type BillingSession = {
  __typename: "BillingSession";
  /** The URL for the billing session */
  url: Scalars["String"]["output"];
};

/** Input for creating a billing session */
export type BillingSessionInput = {
  /** The MRN of the organization */
  orgMrn: Scalars["ID"]["input"];
  /** The URL to return to after billing operations */
  returnURL: Scalars["String"]["input"];
};

/** Blast radius */
export type BlastRadius = {
  __typename: "BlastRadius";
  /** Total number of affected assets */
  affected: Scalars["Int"]["output"];
  /** Total number of assets (including assets with no risk) */
  assets: Scalars["Int"]["output"];
  /** Number of assets with critical risk */
  critical: Scalars["Int"]["output"];
  /** Number of assets with disabled finding */
  disabled: Scalars["Int"]["output"];
  /** Number of assets with an error */
  error: Scalars["Int"]["output"];
  /** Number of assets with high risk */
  high: Scalars["Int"]["output"];
  /** Risk score indicator eg. S, M or L */
  indicator: Scalars["String"]["output"];
  /** Number of assets with low risk */
  low: Scalars["Int"]["output"];
  /** Number of assets with medium risk */
  medium: Scalars["Int"]["output"];
  /** Number of assets with no risk */
  none: Scalars["Int"]["output"];
  /** Number of assets that passed */
  pass: Scalars["Int"]["output"];
  /** Number of assets with risk accepted finding */
  riskAccepted: Scalars["Int"]["output"];
  /**
   * Number of assets with snoozed finding
   * @deprecated Use riskAccepted instead
   */
  snoozed: Scalars["Int"]["output"];
};

/** Blast radius configuration */
export type BlastRadiusConfiguration = {
  __typename: "BlastRadiusConfiguration";
  /** Whether to enable blast radius analysis */
  enabled: Scalars["Boolean"]["output"];
  /** Impacts */
  impacts?: Maybe<Array<BlastRadiusImpact>>;
  /** Weight of the blast radius category */
  weight: Scalars["Float"]["output"];
};

/** Blast radius configuration input */
export type BlastRadiusConfigurationInput = {
  /** Whether to enable blast radius analysis */
  enabled: Scalars["Boolean"]["input"];
  /** Impacts */
  impacts?: InputMaybe<Array<BlastRadiusImpactInput>>;
  /** Weight of the blast radius category */
  weight: Scalars["Float"]["input"];
};

/** A connection to a system detected on an asset for blast radius scoring */
export type BlastRadiusConnection = {
  __typename: "BlastRadiusConnection";
  /** The impact this connection has towards the blast radius category */
  impact: Scalars["Float"]["output"];
  /** The subtitle of the connection */
  subtitle: Scalars["String"]["output"];
  /** The title of the connection, e.g. "PostgreSQL", "MySQL", "Kubernetes Cluster" */
  title: Scalars["String"]["output"];
};

/** A group of connections to systems detected on an asset for blast radius scoring */
export type BlastRadiusConnectionGroup = {
  __typename: "BlastRadiusConnectionGroup";
  /** The connections that were detected for this group */
  children?: Maybe<Array<BlastRadiusConnection>>;
  /** The number of connections that were detected */
  count: Scalars["Int"]["output"];
  /** The subtitle of the group */
  subtitle: Scalars["String"]["output"];
  /** The title of the group, e.g. "database", "k8s", "kms" */
  title: Scalars["String"]["output"];
  /** The type of the group, e.g. "database", "k8s", "kms" */
  type: Scalars["String"]["output"];
};

/** Amount of impacted groups for blast radius risk category, e.g., "database" -> 5, "identity" -> 2 */
export type BlastRadiusDetails = {
  __typename: "BlastRadiusDetails";
  /** The number of found impacts per group, e.g., "database" -> 5, "identity" -> 2 */
  groups: Array<BlastRadiusGroupCount>;
  /** Connections to local systems that were detected */
  localConnections?: Maybe<Array<BlastRadiusConnectionGroup>>;
  /** Connections to remote systems that were detected */
  remoteConnections?: Maybe<Array<BlastRadiusConnectionGroup>>;
};

/** A count of blast radius impacts for a specific group */
export type BlastRadiusGroupCount = {
  __typename: "BlastRadiusGroupCount";
  /** The count of impacts for this group */
  count: Scalars["Int"]["output"];
  /** The group name (e.g., "database", "identity") */
  group: Scalars["String"]["output"];
  /** Whether this impact is provided by Mondoo. In the future, users may define their own impacts. */
  mondooProvided: Scalars["Boolean"]["output"];
};

/** Impact for a blast radius group */
export type BlastRadiusImpact = {
  __typename: "BlastRadiusImpact";
  /** Whether the particular blast radius group is considered in risk scoring. */
  enabled: Scalars["Boolean"]["output"];
  /** Blast radius group, e.g. "database", "identity", "kubernetes", "keys" */
  group: Scalars["String"]["output"];
  /** Impact score for the blast radius group */
  impact: Scalars["Float"]["output"];
};

/** Blast radius impact input */
export type BlastRadiusImpactInput = {
  /** Whether the particular blast radius group is considered in risk scoring. */
  enabled: Scalars["Boolean"]["input"];
  /** Blast radius group, e.g. "database", "identity", "kubernetes", "keys" */
  group: Scalars["String"]["input"];
  /** Impact score for the blast radius group */
  impact: Scalars["Float"]["input"];
};

/** Format of the reports for the bucket */
export enum BucketOutputType {
  Csv = "CSV",
  Jsonl = "JSONL",
  Unknown = "UNKNOWN",
}

/** Business priority configuration */
export type BusinessPriorityConfiguration = {
  __typename: "BusinessPriorityConfiguration";
  /** Whether to enable business priority analysis */
  enabled: Scalars["Boolean"]["output"];
  /** Groups for business priority matching */
  groups?: Maybe<Array<BusinessPriorityGroup>>;
  /** Weight of the business priority category */
  weight: Scalars["Float"]["output"];
};

/** Business priority configuration input */
export type BusinessPriorityConfigurationInput = {
  /** Whether to enable business priority analysis */
  enabled: Scalars["Boolean"]["input"];
  /** Groups for business priority matching */
  groups?: InputMaybe<Array<BusinessPriorityGroupInput>>;
  /** Weight of the business priority category */
  weight: Scalars["Float"]["input"];
};

/** Business priority details for risk category scoring */
export type BusinessPriorityDetails = {
  __typename: "BusinessPriorityDetails";
  /** The name of the matched group (e.g., "business-critical", "dev", "test") */
  matchedGroup: Scalars["String"]["output"];
  /** The tags that matched from the group configuration */
  matchedTags: Array<BusinessPriorityMatchedTag>;
};

/** Business priority group */
export type BusinessPriorityGroup = {
  __typename: "BusinessPriorityGroup";
  /** Description providing more details about the group */
  description: Scalars["String"]["output"];
  /** Whether this group is enabled for matching */
  enabled: Scalars["Boolean"]["output"];
  /** Impact score for the group on the overall risk score, from -1 to 1 */
  impact: Scalars["Float"]["output"];
  /** Name of the group, e.g. "business-critical", "production", "dev", "test" */
  name: Scalars["String"]["output"];
  /**
   * Tags that assets must match to be considered part of this group.
   * An asset must match at least one tag to be considered part of the group.
   */
  tags: Array<BusinessPriorityTag>;
};

/** Business priority group input */
export type BusinessPriorityGroupInput = {
  /** Optional description providing more details about the group */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether this group is enabled for matching. Defaults to true if not specified. */
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Impact score for the group on the overall risk score, from -1 to 1 */
  impact: Scalars["Float"]["input"];
  /** Name of the group, e.g. "business-critical", "production", "dev", "test" */
  name: Scalars["String"]["input"];
  /**
   * Tags that assets must match to be considered part of this group.
   * At least one tag must match for the asset to be considered part of the group.
   */
  tags: Array<BusinessPriorityTagInput>;
};

/** A matched tag from business priority group configuration */
export type BusinessPriorityMatchedTag = {
  __typename: "BusinessPriorityMatchedTag";
  /** The tag key */
  key: Scalars["String"]["output"];
  /** The tag value */
  value: Scalars["String"]["output"];
};

/** Business priority tag - a key-value pair for matching asset labels */
export type BusinessPriorityTag = {
  __typename: "BusinessPriorityTag";
  /** Tag key, e.g. "mondoo.com/business-priority", "env" */
  key: Scalars["String"]["output"];
  /** Tag value, e.g. "business-critical", "production" */
  value: Scalars["String"]["output"];
};

/** Business priority tag input - a key-value pair for matching asset labels */
export type BusinessPriorityTagInput = {
  /** Tag key, e.g. "mondoo.com/business-priority", "env" */
  key: Scalars["String"]["input"];
  /** Tag value, e.g. "business-critical", "production" */
  value: Scalars["String"]["input"];
};

/** Input for cancelling a workflow execution. */
export type CancelWorkflowExecutionInput = {
  /** MRN of the execution to cancel. */
  executionMrn: Scalars["ID"]["input"];
};

/** Result of cancelling a workflow execution. */
export type CancelWorkflowExecutionPayload = {
  __typename: "CancelWorkflowExecutionPayload";
  /** MRN of the cancelled execution. */
  executionMrn: Scalars["ID"]["output"];
};

/** Case */
export type Case = {
  __typename: "Case";
  /**
   * The affected assets for the case. This includes all assets that still need to be
   * mitigated.
   */
  affectedAssets?: Maybe<CaseAssetsConnection>;
  /**
   * AI-generated summary for the case. Only available for V2 cases with AI generation enabled.
   * Only populated when fetching a single case via the `case` query. Always nil in the `cases` list query.
   */
  aiSummary?: Maybe<Scalars["String"]["output"]>;
  /** The amount of unique assets in the case */
  assetsCount: Scalars["Int"]["output"];
  /** Total count of closed refs (across queries, controls and vulnerabilities) */
  closedRefsCount: Scalars["Int"]["output"];
  /** References to compliance controls */
  controlRefs?: Maybe<Array<Maybe<CaseRef>>>;
  /** RFC 3339 timestamp */
  createdAt: Scalars["String"]["output"];
  /** User that created the case */
  createdBy?: Maybe<Author>;
  /** The mitigated assets for the case. This includes all assets that have been mitigated. */
  mitigatedAssets?: Maybe<CaseAssetsConnection>;
  /** RFC 3339 timestamp */
  modifiedAt: Scalars["String"]["output"];
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Owner MRN */
  ownerMrn: Scalars["String"]["output"];
  /** References to package scores */
  packageRefs?: Maybe<Array<Maybe<CaseRef>>>;
  /** References to queries */
  queryRefs?: Maybe<Array<Maybe<CaseRef>>>;
  /**
   * Space risk delta for the case.
   * Space risk delta of all the findings, which are included
   * in the case.
   */
  spaceRiskDelta?: Maybe<Scalars["Float"]["output"]>;
  /** Status */
  status: CaseStatus;
  /** Tags */
  tags?: Maybe<Array<Tag>>;
  /** Ticket references */
  ticketRefs?: Maybe<Array<TicketRef>>;
  /** Title */
  title: Scalars["String"]["output"];
  /** Total count of refs (across queries, controls and vulnerabilities) */
  totalRefsCount: Scalars["Int"]["output"];
  /** References to vulnerabilities (CVEs and advisories) */
  vulnerabilityRefs?: Maybe<Array<Maybe<CaseRef>>>;
};

/** Case */
export type CaseAffectedAssetsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Case */
export type CaseMitigatedAssetsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Case asset edge */
export type CaseAssetEdge = {
  __typename: "CaseAssetEdge";
  /** Cursor */
  cursor: Scalars["String"]["output"];
  /** Node */
  node: EntityInfoAsset;
};

/** Case assets connection */
export type CaseAssetsConnection = {
  __typename: "CaseAssetsConnection";
  /** Edges */
  edges?: Maybe<Array<CaseAssetEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Case content */
export type CaseContent = {
  __typename: "CaseContent";
  /** Title */
  title: Scalars["String"]["output"];
};

/** Case content input */
export type CaseContentInput = {
  /** References */
  references: Array<CaseRefInput>;
  /** Ticket type to generate content for */
  type: TicketRefType;
};

/** Cases edge */
export type CaseEdge = {
  __typename: "CaseEdge";
  /** Cursor */
  cursor: Scalars["String"]["output"];
  /** Node */
  node: Case;
};

/** Case initiative reference input */
export type CaseInitiativeRefInput = {
  /** Entity MRN. Must be an asset, space or workspace MRN. */
  entityMrn: Scalars["String"]["input"];
  /** Initiative MRN. */
  initiativeMrn: Scalars["String"]["input"];
};

/** Case reference */
export type CaseRef = {
  __typename: "CaseRef";
  /** MRN pointing to a query, control, CVE, advisory or package (software finding) MRN */
  findingMrn: Scalars["String"]["output"];
  /** Scope MRN pointing to a space or an asset MRN */
  scopeMrn: Scalars["String"]["output"];
  /** Status */
  status: CaseRefStatus;
};

/** Case reference input */
export type CaseRefInput = {
  /** MRN. Must be a query, control, CVE or advisory MRN. */
  findingMrn: Scalars["String"]["input"];
  /** Scope MRN. Must be a space or an asset MRN */
  scopeMrn: Scalars["String"]["input"];
};

/** Case reference status */
export enum CaseRefStatus {
  Closed = "CLOSED",
  Open = "OPEN",
}

/** Case responses */
export type CaseResponse = Case | NotFoundError | RequestError;

/** Case status */
export enum CaseStatus {
  Closed = "CLOSED",
  Error = "ERROR",
  Open = "OPEN",
  Pending = "PENDING",
}

/** Ticket configuration input */
export type CaseTicketConfigInput = {
  /** Azure Devops ticket configuration */
  azureDevops?: InputMaybe<AzureDevopsTicketConfigInput>;
  /** Email ticket configuration */
  email?: InputMaybe<EmailTicketConfigInput>;
  /** Github ticket configuration */
  github?: InputMaybe<GithubTicketConfigInput>;
  /** Gitlab ticket configuration */
  gitlab?: InputMaybe<GitlabTicketConfigInput>;
  /** Jira ticket configuration */
  jira?: InputMaybe<JiraTicketConfigInput>;
  /** ServiceNow ticket configuration */
  serviceNow?: InputMaybe<ServiceNowTicketConfigInput>;
  /** Zendesk ticket configuration */
  zendesk?: InputMaybe<ZendeskTicketConfigInput>;
};

/** Cases configuration */
export type CasesConfiguration = {
  __typename: "CasesConfiguration";
  /**
   * Aggregate findings for the same asset within this window. The value is
   * specified in hours. 0 means no aggregation
   */
  aggregationWindow: Scalars["Int"]["output"];
  /** Whether to enable auto-create cases on drift */
  autoCreate: Scalars["Boolean"]["output"];
};

/** Cases configuration input */
export type CasesConfigurationInput = {
  /**
   * Aggregate findings for the same asset within this window. The value is
   * specified in hours. 0 means no aggregation
   */
  aggregationWindow?: InputMaybe<Scalars["Int"]["input"]>;
  /** Whether to enable auto-create cases on drift */
  autoCreate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Paginated list of cases */
export type CasesConnection = {
  __typename: "CasesConnection";
  /** Edges */
  edges?: Maybe<Array<CaseEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Cases input */
export type CasesInput = {
  /**
   * A context MRN to filter workspaces by. Can be used when the scope is an asset MRN.
   * If specified, will show only cases for the given asset in the provided context. For example,
   * if scope is asset MRN and context MRN is workspace MRN, will show only workspaces that have
   * the asset in the given workspace.
   */
  contextMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Finding MRNs. If set, will only return cases with the specified finding MRNs */
  findingMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Initiative reference. If set, will only return cases linked to the specified initiative. */
  initiativeRef?: InputMaybe<InitiativeRefInput>;
  /** Order by. If not provided the default ordering is by space risk delta desc. */
  orderBy?: InputMaybe<CasesOrder>;
  /** The scope of the cases to list */
  scopeMrn: Scalars["String"]["input"];
  /** Case statuses. If set, will only return cases with the specified statuses */
  statuses?: InputMaybe<Array<CaseStatus>>;
};

/** Cases order */
export type CasesOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: CasesOrderField;
};

/** Cases order field */
export enum CasesOrderField {
  CreatedAt = "CREATED_AT",
  LastUpdated = "LAST_UPDATED",
  Mrn = "MRN",
  SpaceRiskDelta = "SPACE_RISK_DELTA",
  Title = "TITLE",
}

/** Type of the object */
export enum CatalogType {
  All = "ALL",
  Policy = "POLICY",
  Query = "QUERY",
  Querypack = "QUERYPACK",
}

/** Input for retrieving a list of categories for the scope */
export type CategoriesListInput = {
  /**
   * scopeMrn is the space mrn the user is requesting categories for. The returned
   * response will contain all public categories unioned with categories appearing
   * in content for this space
   */
  scopeMrn: Scalars["String"]["input"];
};

/** Category */
export type Category = {
  __typename: "Category";
  /** Name */
  name: Scalars["String"]["output"];
  /** Packs */
  packs: Scalars["Int"]["output"];
  /** Policies */
  policies: Scalars["Int"]["output"];
  /** Queries */
  queries: Scalars["Int"]["output"];
};

/** Name of the certifying authority */
export type Certifier = {
  __typename: "Certifier";
  /** The name of the certifier */
  name: Scalars["String"]["output"];
};

/** Union type for subscription plan change actions */
export type ChangeSubscriptionPlanAction =
  | BillingSession
  | ChangeSubscriptionSuccess
  | PaymentPreview;

/** Input for changing subscription plan */
export type ChangeSubscriptionPlanInput = {
  /** Whether to confirm the subscription change */
  confirm: Scalars["Boolean"]["input"];
  /** The subscription items to change */
  items?: InputMaybe<Array<SubscriptionItem>>;
  /** The MRN of the organization */
  orgMrn: Scalars["ID"]["input"];
  /** The proration date for the change */
  prorationDate?: InputMaybe<Scalars["Int"]["input"]>;
  /** The URL to return to after the change */
  returnURL: Scalars["String"]["input"];
};

/** Response when subscription change is successful */
export type ChangeSubscriptionSuccess = {
  __typename: "ChangeSubscriptionSuccess";
  /** The amount paid */
  amountPaid: Scalars["Int"]["output"];
  /** The currency of the payment */
  currency: Scalars["String"]["output"];
};

/**
 * Represents a check that builds up a control.
 * It can either be a simple check (an MQL query) or an entire policy
 */
export type Check = PolicyCheck | QueryCheck;

/** Check finding object */
export type CheckFinding = {
  __typename: "CheckFinding";
  /** Asset information */
  asset?: Maybe<EntityInfoAsset>;
  /** Rating for the base score (CRITICAL/HIGH/MEDIUM/LOW/NONE) */
  baseRating: ScoreRating;
  /** Base score ranging between 0 - 100 */
  baseScore: Scalars["Int"]["output"];
  /** Inverted value for the base score */
  baseValue: Scalars["Int"]["output"];
  /** Cases associated with this finding. */
  cases?: Maybe<CasesConnection>;
  /**
   * Exception for this check, if exists
   * @deprecated Use exceptions
   */
  exception?: Maybe<FindingException>;
  /** Exceptions for this check, if some exist */
  exceptions?: Maybe<Array<Maybe<FindingException>>>;
  /** Icon identifier for the score */
  iconId: Icon_Ids;
  /** Check ID */
  id: Scalars["String"]["output"];
  /** Most recent time the score was updated (RFC3339) */
  lastScoreUpdateTime: Scalars["String"]["output"];
  /**
   * Last updated time (RFC3339)
   * Deprecated: Use lastScoreUpdateTime instead.
   * @deprecated Use lastScoreUpdateTime instead
   */
  lastUpdated: Scalars["String"]["output"];
  /** Error message when the check encountered an error during execution */
  message?: Maybe<Scalars["String"]["output"]>;
  /** The mquery */
  mquery?: Maybe<Mquery>;
  /** MRN of the Check */
  mrn: Scalars["String"]["output"];
  /**
   * Preview risk score (0 - 100) computed by the risk-dimension model.
   * Surfaced alongside riskScore for evaluation; null when not available.
   */
  previewRiskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Preview risk value is 100 - previewRiskScore; null when previewRiskScore is not available. */
  previewRiskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Rating */
  rating: ScoreRating;
  /** Related policies that are active */
  relatedPolicies?: Maybe<Array<ActivePolicy>>;
  /** Result Type */
  resultType: ScoreResultType;
  /** Risk categories that apply to this check */
  riskCategories?: Maybe<Array<CheckRiskCategory>>;
  /** Risk factors */
  riskFactors?: Maybe<Array<Maybe<RiskFactorStats>>>;
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore: Scalars["Int"]["output"];
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue: Scalars["Int"]["output"];
  /** Space risk delta and effort for the finding */
  spaceRiskDelta?: Maybe<FindingSpaceRiskDelta>;
  /** State */
  state: ScoreState;
  /** All states for the finding */
  states: FindingState;
  /** Risk score tags */
  tags?: Maybe<Array<Tag>>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Check finding object */
export type CheckFindingCasesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<FindingCasesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Details specific to a check-source remediation. */
export type CheckRemediationDetails = {
  __typename: "CheckRemediationDetails";
  /** MRN of the failing check this remediation resolves. */
  checkMrn: Scalars["String"]["output"];
  /** Human-readable title of the check (from the mquery title field). */
  checkTitle: Scalars["String"]["output"];
  /** TypedDoc identifiers present on the check's docs.remediation (e.g. "ansible", "shell", "default"). */
  typedDocIds: Array<Scalars["String"]["output"]>;
};

/** Risk category scoring for a check finding */
export type CheckRiskCategory = {
  __typename: "CheckRiskCategory";
  /** Whether this category is applicable to the scoring */
  applicable: Scalars["Boolean"]["output"];
  /** The MRN of the category */
  categoryMrn: Scalars["String"]["output"];
  /** Per-category details on what was scored */
  details?: Maybe<CheckRiskCategoryDetails>;
  /** Whether this category was enabled at the time of scoring */
  enabled: Scalars["Boolean"]["output"];
  /** What impact this category has in the overall risk score calculation */
  impact: Scalars["Float"]["output"];
  /** Enum representation of the impact level */
  impactLabel: RiskCategoryImpactLabel;
};

/** Check Risk Category Details - union of possible detail types */
export type CheckRiskCategoryDetails =
  | AttackSurfaceDetails
  | BlastRadiusDetails
  | BusinessPriorityDetails;

/** Check score node object */
export type CheckScore = {
  __typename: "CheckScore";
  /** Asset information */
  asset?: Maybe<EntityInfoAsset>;
  /** Base score ranging between 0 - 100 */
  baseScore?: Maybe<Scalars["Int"]["output"]>;
  /** Exception for this check, if exists */
  exception?: Maybe<FindingException>;
  /** Icon identifier for the score */
  iconId: Icon_Ids;
  /** Check ID */
  id: Scalars["String"]["output"];
  /** Query Impact (critical, high, medium, low, none) */
  impactRating: QueryImpact;
  /** Most recent time the score was updated (RFC3339) */
  lastScoreUpdateTime: Scalars["String"]["output"];
  /**
   * Last updated time (RFC3339)
   * Deprecated: Use lastScoreUpdateTime instead.
   * @deprecated Use lastScoreUpdateTime instead
   */
  lastUpdated: Scalars["String"]["output"];
  /** The mquery */
  mquery?: Maybe<Mquery>;
  /** MRN of the Check */
  mrn: Scalars["String"]["output"];
  /** Asset platform */
  platform?: Maybe<Platform>;
  /** Query State (risk_accepted, disabled, etc) */
  queryState: MqueryState;
  /** Rating */
  rating: ScoreRating;
  /** Result Type */
  resultType: ScoreResultType;
  /** Risk factors */
  riskFactors?: Maybe<Array<Maybe<RiskFactorStats>>>;
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Severity
   * @deprecated Use rating
   */
  severity: ScoreSeverity;
  /** State */
  state: ScoreState;
  /** Risk score tags */
  tags?: Maybe<Array<Tag>>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Check score filters */
export type CheckScoreFilter = {
  /** Filter the result by a check mrn */
  checkMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by impact */
  impact?: InputMaybe<Array<QueryImpact>>;
  /** Whether to include checks for CI/CD assets in the results */
  includeCicd?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter the result by a policy mrn */
  policyMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Optional query terms. Will return only vulnerabilities containing
   * the term in their MRN
   */
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filter by state */
  state?: InputMaybe<ScoreStateFilter>;
};

/** Check score order */
export type CheckScoreOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: CheckScoreOrderField;
};

/** Asset order field */
export enum CheckScoreOrderField {
  /**  ID  */
  AssetName = "ASSET_NAME",
  LastUpdated = "LAST_UPDATED",
  RiskValue = "RISK_VALUE",
  Score = "SCORE",
}

/** Check scores connection */
export type CheckScoresConnection = {
  __typename: "CheckScoresConnection";
  /** Edges */
  edges?: Maybe<Array<CheckScoresEdge>>;
  /** Total count with filters applied */
  filteredTotalCount: Scalars["Int"]["output"];
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Check scores edge */
export type CheckScoresEdge = {
  __typename: "CheckScoresEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<CheckScore>;
};

/** Check scores response */
export type CheckScoresResponse =
  | CheckScoresConnection
  | NotFoundError
  | RequestError;

/** Check state */
export enum CheckState {
  Active = "ACTIVE",
  Disabled = "DISABLED",
  RiskAccepted = "RISK_ACCEPTED",
  /** @deprecated Use RISK_ACCEPTED */
  Snoozed = "SNOOZED",
}

/** Check stats summary */
export type CheckStatsSummary = {
  __typename: "CheckStatsSummary";
  /** critical */
  critical: AssetCheckStats;
  /** high */
  high: AssetCheckStats;
  /** low */
  low: AssetCheckStats;
  /** medium */
  medium: AssetCheckStats;
  /** unscored */
  unscored: Scalars["Int"]["output"];
};

/** Checks connection */
export type ChecksConnection = {
  __typename: "ChecksConnection";
  /** Edges */
  edges?: Maybe<Array<ChecksEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Checks edge */
export type ChecksEdge = {
  __typename: "ChecksEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<Check>;
};

/** Checks order */
export type ChecksOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: ChecksOrderField;
};

/** Checks order field */
export enum ChecksOrderField {
  AssetsCount = "ASSETS_COUNT",
  Completion = "COMPLETION",
  Name = "NAME",
}

/** Checks search input */
export type ChecksSearchInput = {
  /** Framework MRN */
  frameworkMrn: Scalars["String"]["input"];
  /** Determines the ordering */
  orderBy?: InputMaybe<ChecksOrder>;
  /** Query to search checks by, currently searches by the check name only. */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** Scope MRN */
  scopeMrn: Scalars["String"]["input"];
};

/** CI asset link info */
export type CiAssetLinkInfo = {
  __typename: "CiAssetLinkInfo";
  /** Asset link type */
  assetLinkType: AssetLinkType;
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["output"];
  /** Project ID */
  projectID: Scalars["String"]["output"];
};

/** Page information for CI/CD jobs */
export type CiCdJobPageInfo = {
  /** The MRN of the asset */
  assetMrn: Scalars["String"]["input"];
  /** The MRN of the organization */
  orgMrn: Scalars["String"]["input"];
  /** The MRN of the space */
  spaceMrn: Scalars["String"]["input"];
  /** Which tab is selected: Overview, Policies, Controls, Platform Vulnerabilities, Resources */
  tab: Scalars["String"]["input"];
};

/** Page information for CI/CD projects */
export type CiCdProjectPageInfo = {
  /** The MRN of the organization */
  orgMrn: Scalars["String"]["input"];
  /** The MRN of the project */
  projectMrn: Scalars["String"]["input"];
  /** The MRN of the space */
  spaceMrn: Scalars["String"]["input"];
};

/** Control how findings on CI/CD assets are returned. */
export enum CicdAssetFilter {
  /** Only return findings on CI/CD assets. */
  CicdOnly = "CICD_ONLY",
  /** Only return findings on non-CI/CD assets (default). */
  Exclude = "EXCLUDE",
  /** Return findings on both CI/CD and non-CI/CD assets. */
  Include = "INCLUDE",
}

/** A CI/CD project */
export type CicdProject = {
  __typename: "CicdProject";
  /** The time the project was created */
  createTime: Scalars["String"]["output"];
  /** The ID of the project */
  id: Scalars["ID"]["output"];
  /** The labels of the project */
  labels?: Maybe<Array<KeyValue>>;
  /** The MRN of the project */
  mrn: Scalars["ID"]["output"];
  /** The name of the project */
  name: Scalars["String"]["output"];
  /** The owner of the project */
  owner: Scalars["String"]["output"];
  /** The ID of the project */
  projectID?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the project */
  projectURL: Scalars["String"]["output"];
  /** The number of runs in the project */
  runsCount: Scalars["Int"]["output"];
  /** The type of the project */
  type: Scalars["String"]["output"];
};

/** An edge in a CI/CD projects connection */
export type CicdProjectEdge = {
  __typename: "CicdProjectEdge";
  /** The cursor for this edge */
  cursor: Scalars["ID"]["output"];
  /** The project at the end of the edge */
  node: CicdProject;
};

/** CI/CD project jobs */
export type CicdProjectJobs = {
  __typename: "CicdProjectJobs";
  /** The ID of the project jobs */
  id: Scalars["ID"]["output"];
  /** The jobs in the project */
  jobs?: Maybe<JobsConnection>;
  /** The project */
  project: CicdProject;
  /** The MRN of the space */
  spaceMrn: Scalars["ID"]["output"];
};

/** CI/CD project jobs */
export type CicdProjectJobsJobsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  labelFilter?: InputMaybe<Array<InputMaybe<KeyValueInput>>>;
};

/** Input for retrieving CI/CD project jobs */
export type CicdProjectJobsInput = {
  projectId: Scalars["ID"]["input"];
  spaceMrn: Scalars["ID"]["input"];
};

/** Response containing CI/CD project jobs */
export type CicdProjectJobsResponse = CicdProjectJobs;

/** Input for ordering CI/CD projects */
export type CicdProjectOrder = {
  /** The direction to order by */
  direction: OrderDirection;
  /** The field to order by */
  field: CicdProjectOrderField;
};

/** Input for ordering CI/CD projects */
export enum CicdProjectOrderField {
  Name = "NAME",
}

/** CI/CD projects for a space */
export type CicdProjects = {
  __typename: "CicdProjects";
  /** The projects in the space */
  projects: CicdProjectsConnection;
  /** The MRN of the space */
  spaceMrn: Scalars["ID"]["output"];
};

/** CI/CD projects for a space */
export type CicdProjectsProjectsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CicdProjectOrder>;
};

/** Connection containing CI/CD projects */
export type CicdProjectsConnection = {
  __typename: "CicdProjectsConnection";
  /** The edges in the connection */
  edges: Array<CicdProjectEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** The total number of projects */
  totalCount: Scalars["Int"]["output"];
};

/** Input for retrieving CI/CD projects */
export type CicdProjectsInput = {
  /**
   * The MRN of a single space. Required when spaceMrns is not provided.
   * Callers using the multi-space spaceMrns path should omit this field
   * (previously required, now nullable to avoid forcing a dummy value).
   */
  spaceMrn?: InputMaybe<Scalars["ID"]["input"]>;
  /**
   * Optional list of space MRNs. When set, returns projects across all of
   * the listed spaces (used by the org-wide executive report to scope
   * results to a subset of spaces). Pagination is preserved by pushing the
   * filter into a single SQL query rather than fanning out N requests.
   * Mutually exclusive with spaceMrn — providing both is an error.
   */
  spaceMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filter by project type */
  typeFilter?: InputMaybe<Scalars["String"]["input"]>;
};

/** Response containing CI/CD projects */
export type CicdProjectsResponse = CicdProjects;

/** A CircleCI job */
export type CircleCiJob = {
  __typename: "CircleCIJob";
  /** The associated pull requests */
  associatedPullRequests: Scalars["String"]["output"];
  /** The branch name */
  branch: Scalars["String"]["output"];
  /** The build URL */
  buildUrl: Scalars["String"]["output"];
  /** The commit SHA */
  commitSha: Scalars["String"]["output"];
  /**
   * The grade of the job (deprecated)
   * @deprecated Grades will be removed in future. Use score.
   */
  grade: Grade;
  /** The ID of the job */
  id: Scalars["String"]["output"];
  /** The job name */
  job: Scalars["String"]["output"];
  /** The job ID */
  jobId: Scalars["String"]["output"];
  /** The merge request URL */
  mergeRequestUrl: Scalars["String"]["output"];
  /** The MRN of the job */
  mrn: Scalars["String"]["output"];
  /** The name of the job */
  name: Scalars["String"]["output"];
  /** The kind of pipeline */
  pipelineKind: GitPipelineKind;
  /** The URL of the project */
  projectUrl: Scalars["String"]["output"];
  /** The repository URL */
  repositoryUrl: Scalars["String"]["output"];
  /** The score of the job */
  score: Score;
  /** The target of the job */
  target?: Maybe<Scalars["String"]["output"]>;
  /** The time the job was last updated */
  updatedAt: Scalars["String"]["output"];
  /** The username */
  userName: Scalars["String"]["output"];
  /** The workflow ID */
  workflowId: Scalars["String"]["output"];
  /** The workflow job ID */
  workflowJobId: Scalars["String"]["output"];
  /** The workflow workspace ID */
  workflowWorkspaceId: Scalars["String"]["output"];
};

/** ClientIntegration is the details of an integration */
export type ClientIntegration = {
  __typename: "ClientIntegration";
  /** Annotations applied to every asset discovered by this integration's scans. */
  annotations?: Maybe<Array<KeyValue>>;
  /** The asset counts for the integration */
  assetCounts?: Maybe<Array<IntegrationAssetCount>>;
  /** The configuration options for the integration */
  configurationOptions?: Maybe<ClientIntegrationConfigurationOptions>;
  /** The date the integration was created */
  created: Scalars["String"]["output"];
  /** The author of the integration */
  createdBy?: Maybe<Author>;
  /** The errors for the integration */
  errors?: Maybe<Array<IntegrationError>>;
  /** The evaluated configurations for the integration */
  evaluatedConfigurations?: Maybe<Array<EvaluatedConfiguration>>;
  /** The labels for the integration */
  labels?: Maybe<Array<KeyValue>>;
  /** The date the integration was last checked in */
  lastCheckin?: Maybe<Scalars["String"]["output"]>;
  /** The date the integration was last modified */
  lastModified?: Maybe<Scalars["String"]["output"]>;
  /** The last state info for the integration */
  lastStateInfo?: Maybe<ClientIntegrationState>;
  /** The messages for the integration */
  messages?: Maybe<Array<IntegrationMessage>>;
  /** The MRN of the integration */
  mrn: Scalars["String"]["output"];
  /** The name of the integration */
  name: Scalars["String"]["output"];
  /** The date the integration scan job was attempted */
  scanJobAttempted?: Maybe<Scalars["String"]["output"]>;
  /** The date the integration scan job was finished */
  scanJobFinished?: Maybe<Scalars["String"]["output"]>;
  /** The date the integration scan job was started */
  scanJobStarted?: Maybe<Scalars["String"]["output"]>;
  /** The status of the integration */
  status: Scalars["String"]["output"];
  /** The token for the integration */
  token?: Maybe<Scalars["String"]["output"]>;
  /** The type of integration */
  type: ClientIntegrationType;
};

/** Configuration options for client integrations */
export type ClientIntegrationConfigurationInput = {
  attackSurfaceConfigurationOptions?: InputMaybe<AttackSurfaceConfigurationOptionsInput>;
  auditLogExportConfigurationOptions?: InputMaybe<AuditLogExportConfigurationOptionsInput>;
  awsConfigurationOptions?: InputMaybe<AwsConfigurationOptionsInput>;
  awsHostedConfigurationOptions?: InputMaybe<HostedAwsConfigurationOptionsInput>;
  awsS3ConfigurationOptions?: InputMaybe<AwsS3ConfigurationOptionsInput>;
  azureBlobConfigurationOptions?: InputMaybe<AzureBlobConfigurationOptionsInput>;
  azureConfigurationOptions?: InputMaybe<AzureConfigurationOptionsInput>;
  azureDevopsConfigurationOptions?: InputMaybe<AzureDevopsConfigurationOptionsInput>;
  bigqueryConfigurationOptions?: InputMaybe<BigqueryConfigurationOptionsInput>;
  cloudflareConfigurationOptions?: InputMaybe<CloudflareConfigurationOptionsInput>;
  crowdstrikeFalconConfigurationOptions?: InputMaybe<CrowdstrikeFalconConfigurationOptionsInput>;
  digitaloceanConfigurationOptions?: InputMaybe<DigitaloceanConfigurationOptionsInput>;
  elasticConfigurationOptions?: InputMaybe<ElasticConfigurationOptionsInput>;
  emailConfigurationOptions?: InputMaybe<EmailConfigurationOptionsInput>;
  gcpConfigurationOptions?: InputMaybe<GcpConfigurationOptionsInput>;
  gcpServerlessConfigurationOptions?: InputMaybe<GcpServerlessConfigurationOptionsInput>;
  gcsBucketConfigurationOptions?: InputMaybe<GcsBucketConfigurationOptionsInput>;
  githubConfigurationOptions?: InputMaybe<GithubConfigurationOptionsInput>;
  githubTicketingConfigurationOptions?: InputMaybe<GithubTicketingConfigurationOptionsInput>;
  gitlabConfigurationOptions?: InputMaybe<GitlabConfigurationOptionsInput>;
  gitlabTicketingConfigurationOptions?: InputMaybe<GitlabTicketingConfigurationOptionsInput>;
  googleSccExportConfigurationOptions?: InputMaybe<GoogleSccExportConfigurationOptionsInput>;
  googleSccImportConfigurationOptions?: InputMaybe<GoogleSccImportConfigurationOptionsInput>;
  googleWorkspaceConfigurationOptions?: InputMaybe<GoogleWorkspaceConfigurationOptionsInput>;
  hetznerConfigurationOptions?: InputMaybe<HetznerConfigurationOptionsInput>;
  hostConfigurationOptions?: InputMaybe<HostConfigurationOptionsInput>;
  jiraConfigurationOptions?: InputMaybe<JiraConfigurationOptionsInput>;
  k8sConfigurationOptions?: InputMaybe<K8sConfigurationOptionsInput>;
  microsoftDefenderConfigurationOptions?: InputMaybe<MicrosoftDefenderConfigurationOptionsInput>;
  ms365ConfigurationOptions?: InputMaybe<Ms365ConfigurationOptionsInput>;
  msIntuneConfigurationOptions?: InputMaybe<MsIntuneConfigurationOptionsInput>;
  networkScanConfigurationOptions?: InputMaybe<NetworkScanConfigurationOptionsInput>;
  nextdnsConfigurationOptions?: InputMaybe<NextdnsConfigurationOptionsInput>;
  ociConfigurationOptions?: InputMaybe<OciConfigurationOptionsInput>;
  oktaConfigurationOptions?: InputMaybe<OktaConfigurationOptionsInput>;
  openvasConfigurationOptions?: InputMaybe<OpenvasConfigurationOptionsInput>;
  postgresConfigurationOptions?: InputMaybe<PostgresConfigurationOptionsInput>;
  qualysConfigurationOptions?: InputMaybe<QualysConfigurationOptionsInput>;
  s3ConfigurationOptions?: InputMaybe<S3ConfigurationOptionsInput>;
  securityPipelineGithubConfigurationOptions?: InputMaybe<SecurityPipelineGithubConfigurationOptionsInput>;
  securityScorecardConfigurationOptions?: InputMaybe<SecurityScorecardConfigurationOptionsInput>;
  sentinelOneConfigurationOptions?: InputMaybe<SentinelOneConfigurationOptionsInput>;
  serviceNowConfigurationOptions?: InputMaybe<ServiceNowConfigurationOptionsInput>;
  shodanConfigurationOptions?: InputMaybe<ShodanConfigurationOptionsInput>;
  slackConfigurationOptions?: InputMaybe<SlackConfigurationOptionsInput>;
  snowflakeConfigurationOptions?: InputMaybe<SnowflakeConfigurationOptionsInput>;
  snowflakeScanConfigurationOptions?: InputMaybe<SnowflakeScanConfigurationOptionsInput>;
  snykConfigurationOptions?: InputMaybe<SnykConfigurationOptionsInput>;
  sonarqubeConfigurationOptions?: InputMaybe<SonarqubeConfigurationOptionsInput>;
  splunkConfigurationOptions?: InputMaybe<SplunkConfigurationOptionsInput>;
  stackitConfigurationOptions?: InputMaybe<StackitConfigurationOptionsInput>;
  tailscaleConfigurationOptions?: InputMaybe<TailscaleConfigurationOptionsInput>;
  tenableConfigurationOptions?: InputMaybe<TenableConfigurationOptionsInput>;
  tenableSCConfigurationOptions?: InputMaybe<TenableScConfigurationOptionsInput>;
  webhookConfigurationOptions?: InputMaybe<WebhookConfigurationOptionsInput>;
  zendeskConfigurationOptions?: InputMaybe<ZendeskConfigurationOptionsInput>;
};

/** ClientIntegrationConfigurationOptions is a union of all configuration options for the integrations */
export type ClientIntegrationConfigurationOptions =
  | AwsConfigurationOptions
  | AgentOptions
  | AttackSurfaceConfigurationOptions
  | AuditLogExportConfigurationOptions
  | AwsS3ConfigurationOptions
  | AzureBlobConfigurationOptions
  | AzureConfigurationOptions
  | AzureDevopsConfigurationOptions
  | BigqueryConfigurationOptions
  | CloudflareConfigurationOptions
  | CrowdstrikeFalconConfigurationOptions
  | DigitaloceanConfigurationOptions
  | ElasticConfigurationOptions
  | EmailConfigurationOptions
  | GcpConfigurationOptions
  | GcpServerlessConfigurationOptions
  | GcsBucketConfigurationOptions
  | GithubConfigurationOptions
  | GithubTicketingConfigurationOptions
  | GitlabConfigurationOptions
  | GitlabTicketingConfigurationOptions
  | GoogleSccExportConfigurationOptions
  | GoogleSccImportConfigurationOptions
  | GoogleWorkspaceConfigurationOptions
  | HetznerConfigurationOptions
  | HostConfigurationOptions
  | HostedAwsConfigurationOptions
  | JiraConfigurationOptions
  | K8sConfigurationOptions
  | MicrosoftDefenderConfigurationOptions
  | Ms365ConfigurationOptions
  | MsIntuneConfigurationOptions
  | NetworkScanConfigurationOptions
  | NextdnsConfigurationOptions
  | OciConfigurationOptions
  | OktaConfigurationOptions
  | OpenvasConfigurationOptions
  | PostgresConfigurationOptions
  | QualysConfigurationOptions
  | S3ConfigurationOptions
  | SecurityPipelineGithubConfigurationOptions
  | SecurityScorecardConfigurationOptions
  | SentinelOneConfigurationOptions
  | ServiceNowConfigurationOptions
  | ShodanConfigurationOptions
  | SlackConfigurationOptions
  | SnowflakeConfigurationOptions
  | SnowflakeScanConfigurationOptions
  | SnykConfigurationOptions
  | SonarqubeConfigurationOptions
  | SplunkConfigurationOptions
  | StackitConfigurationOptions
  | TailscaleConfigurationOptions
  | TenableConfigurationOptions
  | TenableScConfigurationOptions
  | WebhookConfigurationOptions
  | ZendeskConfigurationOptions;

/** Input for client integration */
export type ClientIntegrationInput = {
  mrn: Scalars["String"]["input"];
  withToken?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Response when requesting a client integration */
export type ClientIntegrationPayload = {
  __typename: "ClientIntegrationPayload";
  /** The requested client integration */
  integration: ClientIntegration;
};

/** Union type for the client integration state */
export type ClientIntegrationState = K8sIntegrationLastState;

/** Type of the client integration */
export enum ClientIntegrationType {
  AttackSurface = "ATTACK_SURFACE",
  AuditLogExport = "AUDIT_LOG_EXPORT",
  Aws = "AWS",
  AwsHosted = "AWS_HOSTED",
  AwsS3 = "AWS_S3",
  Azure = "AZURE",
  AzureBlob = "AZURE_BLOB",
  Bigquery = "BIGQUERY",
  Cloudflare = "CLOUDFLARE",
  CrowdstrikeFalcon = "CROWDSTRIKE_FALCON",
  Digitalocean = "DIGITALOCEAN",
  Elastic = "ELASTIC",
  Gcp = "GCP",
  GcpServerless = "GCP_SERVERLESS",
  GcsBucket = "GCS_BUCKET",
  Github = "GITHUB",
  Gitlab = "GITLAB",
  GoogleSccExport = "GOOGLE_SCC_EXPORT",
  GoogleSccImport = "GOOGLE_SCC_IMPORT",
  GoogleWorkspace = "GOOGLE_WORKSPACE",
  Hetzner = "HETZNER",
  Host = "HOST",
  HostedSlack = "HOSTED_SLACK",
  K8S = "K8S",
  ManagedClient = "MANAGED_CLIENT",
  MicrosoftDefender = "MICROSOFT_DEFENDER",
  MondooBi = "MONDOO_BI",
  Ms365 = "MS365",
  MsIntune = "MS_INTUNE",
  NetworkDiscoveryCollector = "NETWORK_DISCOVERY_COLLECTOR",
  NetworkScan = "NETWORK_SCAN",
  Nextdns = "NEXTDNS",
  Oci = "OCI",
  Okta = "OKTA",
  Openvas = "OPENVAS",
  Postgres = "POSTGRES",
  Qualys = "QUALYS",
  S3 = "S3",
  SecurityPipelineGithub = "SECURITY_PIPELINE_GITHUB",
  SecurityScorecard = "SECURITY_SCORECARD",
  SentinelOne = "SENTINEL_ONE",
  Shodan = "SHODAN",
  Snowflake = "SNOWFLAKE",
  SnowflakeScan = "SNOWFLAKE_SCAN",
  Snyk = "SNYK",
  Sonarqube = "SONARQUBE",
  Splunk = "SPLUNK",
  Stackit = "STACKIT",
  Tailscale = "TAILSCALE",
  Tenable = "TENABLE",
  TenableSc = "TENABLE_SC",
  TicketSystemAzureDevops = "TICKET_SYSTEM_AZURE_DEVOPS",
  TicketSystemEmail = "TICKET_SYSTEM_EMAIL",
  TicketSystemGithub = "TICKET_SYSTEM_GITHUB",
  TicketSystemGitlab = "TICKET_SYSTEM_GITLAB",
  TicketSystemJira = "TICKET_SYSTEM_JIRA",
  TicketSystemServiceNow = "TICKET_SYSTEM_SERVICE_NOW",
  TicketSystemWebhook = "TICKET_SYSTEM_WEBHOOK",
  TicketSystemZendesk = "TICKET_SYSTEM_ZENDESK",
  Unknown = "UNKNOWN",
}

/** Close case input */
export type CloseCaseInput = {
  /** MRN of the case to close */
  mrn: Scalars["String"]["input"];
};

/** Cloudflare integration */
export type CloudflareConfigurationOptions = {
  __typename: "CloudflareConfigurationOptions";
  /**
   * The Cloudflare API token. Always null in responses — the token is stored in
   * the vault and never echoed back; a non-null value here simply indicates the
   * token is configured.
   */
  token?: Maybe<Scalars["String"]["output"]>;
};

/** Cloudflare integration input */
export type CloudflareConfigurationOptionsInput = {
  /** Cloudflare API token */
  token: Scalars["String"]["input"];
};

/** Comparison operators for filtering */
export enum ComparisonOperator {
  /** Greater than */
  Gt = "GT",
  /** Less than */
  Lt = "LT",
}

/** Represents an asset in the context of a compliance framework or control */
export type ComplianceAsset = {
  __typename: "ComplianceAsset";
  /** The asset */
  asset: Asset;
  /** The compliance percentage of the asset with respect to the control or framework it is being fetched for. */
  compliancePercentage?: Maybe<Scalars["Int"]["output"]>;
  /**
   * The exception for the control for which the asset is fetched. This is only set when scoreType is
   * OUT_OF_SCOPE or DISABLED
   */
  exception?: Maybe<ControlException>;
  /** currently not implemented */
  relatedAssets?: Maybe<Scalars["Int"]["output"]>;
  /** The score type of the asset */
  scoreType?: Maybe<ScoreType>;
};

/** Compliance asset edge */
export type ComplianceAssetEdge = {
  __typename: "ComplianceAssetEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<ComplianceAsset>;
};

/** Compliance asset order */
export type ComplianceAssetOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: ComplianceAssetOrderField;
};

/** Compliance asset order field */
export enum ComplianceAssetOrderField {
  Completion = "COMPLETION",
  Id = "ID",
  LastUpdated = "LAST_UPDATED",
  Name = "NAME",
  Platform = "PLATFORM",
}

/** Compliance assets connection */
export type ComplianceAssetsConnection = {
  __typename: "ComplianceAssetsConnection";
  /** Edges */
  edges?: Maybe<Array<ComplianceAssetEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Compliance assets search input */
export type ComplianceAssetsSearchInput = {
  /**
   * after is the pagination cursor. To paginate to the end of the search results,
   * keep calling search the the endCursor from the pageInfo response while the
   * hasNextPage field is true
   */
  after?: InputMaybe<Scalars["String"]["input"]>;
  /** first is the number of items to return. Defaults to 100 */
  first?: InputMaybe<Scalars["Int"]["input"]>;
  /** The asset group filters that match the assets */
  groups?: InputMaybe<Array<GroupFilter>>;
  /** Order by */
  orderBy?: InputMaybe<ComplianceAssetOrder>;
  /** Search query */
  query: Scalars["String"]["input"];
};

/** Compliance control */
export type ComplianceControl = {
  __typename: "ComplianceControl";
  /** The asset group statistics for all assets that are in scope of the compliance control. */
  assetGroupStatistics: Array<AssetGroupStatistics>;
  /** Allows retrieval of the assets in scope for the compliance control. */
  assets?: Maybe<ComplianceAssetsConnection>;
  /** Assets statistics */
  assetsStats: ControlAssetsStats;
  /** Allows filtering for all checks in the control. */
  checks?: Maybe<ChecksConnection>;
  /** Checks statistics */
  checksStats: ControlChecksStats;
  /** Completion */
  completion: Scalars["Int"]["output"];
  /**
   * Allows filtering for all data queries in the control.
   * Note that this returns a QueriesConnection and not a ChecksConnection as data queries cannot be represented by entire policies.
   */
  dataQueries?: Maybe<QueriesConnection>;
  /** Description */
  description: Scalars["String"]["output"];
  /** Gets the exception for this control, if any. Rejected exceptions aren't returned. */
  exception?: Maybe<ControlException>;
  /**
   * Gets the list of all exceptions that have been applied to the control.
   * @deprecated Use exception instead
   */
  exceptions: Array<ControlException>;
  /** The framework to which this control belongs to. */
  framework?: Maybe<ComplianceFramework>;
  /** Whether the control is manual */
  manual: Scalars["Boolean"]["output"];
  /** MRN */
  mrn: Scalars["String"]["output"];
  /**
   * The MRN of the scope in which this control was requested. Used in the control's resolvers
   * to avoid having to include it in multiple functions' parameters.
   */
  scopeMrn: Scalars["String"]["output"];
  /** State */
  state: ControlState;
  /** Tags */
  tags: Array<Maybe<Tag>>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Compliance control */
export type ComplianceControlAssetsArgs = {
  input: ComplianceAssetsSearchInput;
};

/** Compliance control */
export type ComplianceControlChecksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  input: ChecksSearchInput;
};

/** Compliance control */
export type ComplianceControlDataQueriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  input: ChecksSearchInput;
};

/** Compliance control input */
export type ComplianceControlInput = {
  /** Control MRN */
  controlMrn: Scalars["String"]["input"];
  /** Framework MRN */
  frameworkMrn: Scalars["String"]["input"];
  /** Scope MRN */
  scopeMrn: Scalars["String"]["input"];
};

/** Compliance framework */
export type ComplianceFramework = {
  __typename: "ComplianceFramework";
  /** The asset group statistics for all assets that are in scope of the compliance framework. */
  assetGroupStatistics: Array<AssetGroupStatistics>;
  /** Allows retrieval of the assets that are in scope of the compliance framework. */
  assets?: Maybe<ComplianceAssetsConnection>;
  /** Authors */
  authors?: Maybe<Array<Author>>;
  /**
   * The completion percentage for the framework.
   * Calculated by dividing the amount of compliant assets against the total count of assets
   */
  completion?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Allows retrieval of the framework's controls' metadata. It includes no information about the checks
   * which build up the control.
   */
  controls?: Maybe<ControlsConnection>;
  /** RFC 3339 timestamp */
  createdAt: Scalars["String"]["output"];
  /** Description */
  description: Scalars["String"]["output"];
  /**
   * RFC 3339 timestamp
   * can be empty, when the exception wasn't reviewed yet
   */
  modifiedAt: Scalars["String"]["output"];
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Name */
  name: Scalars["String"]["output"];
  /**
   * The list of all policies, referenced by any framework map that belongs to the framework itself.
   * These serve as a suggestion/hint towards which policies should be active for the controls to start reporting.
   */
  policiesMrns: Array<Scalars["String"]["output"]>;
  /**
   * The previous known completion scores for the framework. Compared to 'completion',
   * this can determine if there has been an improvement in the framework scoring.
   * Currently not implemented and will always return an empty list.
   */
  previousCompletionScores?: Maybe<ComplianceScoresHistory>;
  /**
   * The MRN of the scope in which this framework was requested. Used in the framework's resolvers (such as controls)
   * to avoid having to include it in multiple functions' parameters.
   */
  scopeMrn: Scalars["String"]["output"];
  /** State */
  state: ComplianceFrameworkState;
  /** Statistics */
  stats: ComplianceFrameworkStats;
  /** Summary */
  summary: Scalars["String"]["output"];
  /** Tags */
  tags?: Maybe<Array<Tag>>;
  /** Version */
  version: Scalars["String"]["output"];
};

/** Compliance framework */
export type ComplianceFrameworkAssetsArgs = {
  input: ComplianceAssetsSearchInput;
};

/** Compliance framework */
export type ComplianceFrameworkControlsArgs = {
  input: ControlsSearchInput;
};

/** Compliance framework input */
export type ComplianceFrameworkInput = {
  /** The compliance framework mrn. */
  frameworkMrn: Scalars["String"]["input"];
  /** The scope mrn for which to fetch the compliance framework. */
  scopeMrn: Scalars["String"]["input"];
};

/** Compliance framework mutation action */
export enum ComplianceFrameworkMutationAction {
  Disable = "DISABLE",
  Enable = "ENABLE",
  Preview = "PREVIEW",
}

/** Compliance framework mutation input */
export type ComplianceFrameworkMutationInput = {
  /** Action */
  action: ComplianceFrameworkMutationAction;
  /** Framework MRN */
  frameworkMrn: Scalars["String"]["input"];
  /** Scope MRN */
  scopeMrn: Scalars["String"]["input"];
};

/** Compliance framework state */
export enum ComplianceFrameworkState {
  Active = "ACTIVE",
  Disabled = "DISABLED",
  Preview = "PREVIEW",
}

/** Compliance framework statistics */
export type ComplianceFrameworkStats = {
  __typename: "ComplianceFrameworkStats";
  /** The total amount of assets that have reported in for the framework. */
  assets: Scalars["Int"]["output"];
  /**
   * The total amount of checks, implemented by controls in the framework.
   * @deprecated Inaccurate for spaces with bundle-filtered checks. Use ControlsConnection.totalActiveChecks instead.
   */
  checks: Scalars["Int"]["output"];
  /** Controls */
  controls: ControlsStats;
  /** The total amount of controls, checks and assets that have been exempt. */
  exceptions: Scalars["Int"]["output"];
};

/** Compliance frameworks by org input */
export type ComplianceFrameworksByOrgInput = {
  /**
   * The organization MRN to list frameworks for. Frameworks are aggregated
   * across all spaces in the organization that the caller can read.
   */
  orgMrn: Scalars["String"]["input"];
  /** Optional framework states to filter by. If empty, all states are returned. */
  states?: InputMaybe<Array<ComplianceFrameworkState>>;
};

/** Compliance frameworks input */
export type ComplianceFrameworksInput = {
  /** The scope mrn for which to fetch compliance frameworks. Currently only supported is a space mrn. */
  scopeMrn: Scalars["String"]["input"];
  /**
   * The framework state to filter by.
   * @deprecated Use 'states' instead
   */
  state?: InputMaybe<ComplianceFrameworkState>;
  /** The framework states to filter by. */
  states?: InputMaybe<Array<ComplianceFrameworkState>>;
};

/** Represents a point in time and a compliance score at that moment */
export type ComplianceScoreEntry = {
  __typename: "ComplianceScoreEntry";
  /**
   * The compliance score. For compliance scores this is the percentage of compliant assets with regards to the
   * control or framework
   */
  score: Scalars["Int"]["output"];
  /** The RFC 3339 timestamp at which the compliance score was taken */
  timestamp: Scalars["String"]["output"];
};

/** Compliance scores history */
export type ComplianceScoresHistory = {
  __typename: "ComplianceScoresHistory";
  /** Entries */
  entries: Array<ComplianceScoreEntry>;
};

/** Consent */
export type Consent = {
  __typename: "Consent";
  /** The email address */
  email: Scalars["String"]["output"];
  /** The resource MRN */
  mrn: Scalars["String"]["output"];
  /** The date the consent was signed */
  signatureAt: Scalars["String"]["output"];
};

/** Platform information */
export type ContentPlatform = {
  __typename: "ContentPlatform";
  /** The platform identifier */
  id: Scalars["ID"]["output"];
  /** The name of the platform */
  name: Scalars["String"]["output"];
  /** The version of the platform */
  version: Scalars["String"]["output"];
};

/** Input for searching for policies or registries */
export type ContentSearchInput = {
  /**
   * after is the pagination cursor. To paginate to the end of the search results,
   * keep calling search the the endCursor from the pageInfo response while the
   * hasNextPage field is true
   */
  after?: InputMaybe<Scalars["String"]["input"]>;
  /** If assignedOnly is set to true, only policies that are assigned will be considered */
  assignedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** catalogType is the type of content items to consider */
  catalogType?: CatalogType;
  /**
   * A list of categories that a content item can match. Content matching at
   * least one of the provided will be considered
   */
  categories?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * contentMrns is a list of mrns to consider. If none are provided, all will be considered
   * Useful for text searching a specific set of content, like active policies
   */
  contentMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** includePrivate indicates whether to include private content. Defaults to true */
  includePrivate?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** includePublic indicates whether to include mondoo provided content. Defaults to true */
  includePublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** limit is the number of items to return. Defaults to 100 */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<ContentSearchResultItemOrder>;
  /**
   * A list of platforms that a content item must match. Only content matching
   * all platforms will be considered
   */
  platforms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Full text search query. Each term in the query will be ANDed together */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * scopeMrn is the space mrn the user is requesting content for. Private
   * content will only be searched from this space
   */
  scopeMrn: Scalars["String"]["input"];
};

/** Search result type */
export type ContentSearchResultItem = Policy;

/** Connection for content search results */
export type ContentSearchResultItemConnection = {
  __typename: "ContentSearchResultItemConnection";
  /** The edges for each item */
  edges: Array<ContentSearchResultItemEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** The total number of items matching the search criteria */
  totalCount: Scalars["Int"]["output"];
};

/** Edge for a content search result item */
export type ContentSearchResultItemEdge = {
  __typename: "ContentSearchResultItemEdge";
  /** Pagination cursor */
  cursor: Scalars["ID"]["output"];
  /** The search result item */
  node: ContentSearchResultItem;
};

/** User defined order direction and field */
export type ContentSearchResultItemOrder = {
  /** The direction to order the results */
  direction: OrderDirection;
  /** The field to order the results */
  field: ContentSearchResultItemOrderField;
};

/** Order fields for content search results */
export enum ContentSearchResultItemOrderField {
  /**
   * Order by assignment/scoring state: Active (Scored) -> Ignore (Preview) ->
   * unassigned.
   */
  Action = "ACTION",
  /**
   * Order by where the policy is assigned/inherited from, following the
   * platform -> organization -> space -> unassigned hierarchy.
   */
  AssignedScope = "ASSIGNED_SCOPE",
  Name = "NAME",
}

/** Control assets statistics */
export type ControlAssetsStats = {
  __typename: "ControlAssetsStats";
  /** Compliant assets count */
  compliantAssets: Scalars["Int"]["output"];
  /** Non-compliant assets count */
  failedAssets: Scalars["Int"]["output"];
  /** Total assets count */
  totalAssets: Scalars["Int"]["output"];
};

/** Control checks statistics */
export type ControlChecksStats = {
  __typename: "ControlChecksStats";
  /** Active checks count */
  activeChecks: Scalars["Int"]["output"];
  /** Active queries count */
  activeQueries: Scalars["Int"]["output"];
  /**
   * Disabled checks count
   * @deprecated Use totalExceptions instead.
   */
  disabledChecks: Scalars["Int"]["output"];
  /**
   * Disabled queries count
   * @deprecated Use totalExceptions instead.
   */
  disabledQueries: Scalars["Int"]["output"];
  /**
   * Snoozed checks count
   * @deprecated Use totalExceptions instead.
   */
  snoozedChecks: Scalars["Int"]["output"];
  /**
   * Snoozed queries count
   * @deprecated Use totalExceptions instead.
   */
  snoozedQueries: Scalars["Int"]["output"];
  /** Total checks count */
  totalChecks: Scalars["Int"]["output"];
  /** Total count of exceptions for checks */
  totalExceptions: Scalars["Int"]["output"];
  /** Total queries count */
  totalQueries: Scalars["Int"]["output"];
};

/** Input options for the controls of the document */
export type ControlDocumentOptionsInput = {
  /** The MRN of the control */
  controlMRN: Scalars["String"]["input"];
  /** The MRN of the framework the control is for */
  frameworkMRN: Scalars["String"]["input"];
};

/** An exception for a compliance control */
export type ControlException = {
  __typename: "ControlException";
  /**
   * How this exception should be handled
   * Accept risk, disable, or enable findings
   */
  action: ExceptionMutationAction;
  /** The user who created the exception */
  author: Author;
  /** RFC 3339 timestamp */
  createdAt: Scalars["String"]["output"];
  /**
   * Exception ID. Uniquely identifies the exception within its owner scope.
   * Format: exception-{n}
   */
  exceptionId: Scalars["String"]["output"];
  /**
   * Exception MRN. Uniquely identifies the exception globally.
   * Format: //policy.api.mondoo.app/spaces/{spaceId}/exceptions/{n}
   */
  exceptionMrn: Scalars["String"]["output"];
  /** The id to use to reference the exception */
  id: Scalars["String"]["output"];
  /** The justification for the exception */
  justification?: Maybe<Scalars["String"]["output"]>;
  /**
   * RFC 3339 timestamp
   * can be empty, when the exception wasn't reviewed yet
   */
  modifiedAt?: Maybe<Scalars["String"]["output"]>;
  /**
   * The review status for the exception
   * @deprecated replaced by status
   */
  reviewStatus: ReviewStatus;
  /**
   * The user who rejected/approved the exception
   * The email is expected
   * This can be empty, when the exception wasn't reviewed yet
   */
  reviewer?: Maybe<Author>;
  /** The status for the exception */
  status: ExceptionStatus;
  /** Title of the exception */
  title: Scalars["String"]["output"];
};

/** Control score node object */
export type ControlScore = {
  __typename: "ControlScore";
  /** Asset information */
  asset?: Maybe<EntityInfoAsset>;
  /** Base score ranging between 0 - 100 */
  baseScore?: Maybe<Scalars["Int"]["output"]>;
  /** Asset ID */
  id: Scalars["String"]["output"];
  /** Most recent time the score was updated (RFC3339) */
  lastScoreUpdateTime: Scalars["String"]["output"];
  /**
   * Last updated time (RFC3339)
   * Deprecated: Use lastScoreUpdateTime instead.
   * @deprecated Use lastScoreUpdateTime instead
   */
  lastUpdated: Scalars["String"]["output"];
  /** MRN of the Control */
  mrn: Scalars["String"]["output"];
  /** Asset platform */
  platform?: Maybe<Platform>;
  /** State */
  state: ScoreState;
};

/** Control score filters */
export type ControlScoreFilter = {
  /** Filter the result by a control mrn */
  controlMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether to include controls for CI/CD assets in the results */
  includeCicd?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Optional query terms. Will return only vulnerabilities containing
   * the term in their MRN
   */
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filter by state */
  state?: InputMaybe<ScoreStateFilter>;
};

/** Control score order */
export type ControlScoreOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: ControlScoreOrderField;
};

/** Control Score order field */
export enum ControlScoreOrderField {
  /**  ID  */
  AssetName = "ASSET_NAME",
  LastUpdated = "LAST_UPDATED",
  Score = "SCORE",
}

/** Control scores connection */
export type ControlScoresConnection = {
  __typename: "ControlScoresConnection";
  /** Edges */
  edges?: Maybe<Array<ControlScoresEdge>>;
  /** Total count with filters applied */
  filteredTotalCount: Scalars["Int"]["output"];
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Control scores edge */
export type ControlScoresEdge = {
  __typename: "ControlScoresEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<ControlScore>;
};

/** Control scores response */
export type ControlScoresResponse =
  | ControlScoresConnection
  | NotFoundError
  | RequestError;

/** Control state */
export enum ControlState {
  Active = "ACTIVE",
  Disabled = "DISABLED",
  FalsePositive = "FALSE_POSITIVE",
  OutOfScope = "OUT_OF_SCOPE",
  RiskAccepted = "RISK_ACCEPTED",
  /** @deprecated Use RISK_ACCEPTED */
  Snoozed = "SNOOZED",
  Workaround = "WORKAROUND",
}

/** Connection for compliance controls */
export type ControlsConnection = {
  __typename: "ControlsConnection";
  /** Edges */
  edges?: Maybe<Array<ControlsEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /**
   * Distinct active checks across all controls in this connection, deduplicated by MRN.
   * Already bundle-filtered (only checks/policies active in the space are counted).
   */
  totalActiveChecks: Scalars["Int"]["output"];
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** An edge in the compliance controls connection. Represents a single control */
export type ControlsEdge = {
  __typename: "ControlsEdge";
  /** A cursor used for pagination */
  cursor: Scalars["ID"]["output"];
  /** The control */
  node?: Maybe<ComplianceControl>;
};

/** Controls order */
export type ControlsOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: ControlsOrderField;
};

/** Controls order field */
export enum ControlsOrderField {
  Assets = "ASSETS",
  Checks = "CHECKS",
  Completion = "COMPLETION",
  Exceptions = "EXCEPTIONS",
  Id = "ID",
  Queries = "QUERIES",
  /**
   * Order by control state/status: Active, then the exception states
   * (Disabled, Out of scope, Risk accepted, Workaround, False positive).
   */
  State = "STATE",
  Title = "TITLE",
}

/** Controls search input */
export type ControlsSearchInput = {
  /**
   * after is the pagination cursor. To paginate to the end of the search results,
   * keep calling search the the endCursor from the pageInfo response while the
   * hasNextPage field is true
   */
  after?: InputMaybe<Scalars["String"]["input"]>;
  /** limit is the number of items to return. Defaults to 100 */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Order by */
  orderBy?: InputMaybe<ControlsOrder>;
  /** query, used to search on controls' or policies' description */
  query?: InputMaybe<Scalars["String"]["input"]>;
};

/** Control statistics */
export type ControlsStats = {
  __typename: "ControlsStats";
  /** Active controls count */
  activeControls: Scalars["Int"]["output"];
  /** Average completion */
  averageCompletion: Scalars["Int"]["output"];
  /**
   * Disabled controls count
   * @deprecated Use totalExceptions instead.
   */
  disabledControls: Scalars["Int"]["output"];
  /** Out of scope controls count */
  outOfScopeControls: Scalars["Int"]["output"];
  /** Previous average completion */
  previousAverageCompletion: Scalars["Int"]["output"];
  /**
   * Snoozed controls count
   * @deprecated Use totalExceptions instead.
   */
  snoozedControls: Scalars["Int"]["output"];
  /** Total controls count */
  totalControls: Scalars["Int"]["output"];
  /** Total exceptions count */
  totalExceptions: Scalars["Int"]["output"];
};

/**
 * Input for creating a new individual asset routing rule.
 * Provide either orgMrn (deprecated) or scopeMrn.
 */
export type CreateAssetRoutingRuleInput = {
  /**
   * Conditions that must all match for this rule to apply. Leave empty for
   * wildcard rules.
   */
  conditions: Array<AssetRoutingConditionInput>;
  /**
   * Deprecated alias for scopeMrn.
   * @deprecated use scopeMrn
   */
  orgMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Priority for rule ordering (lower values evaluated first). */
  priority: Scalars["Int"]["input"];
  /** Scope MRN that owns this routing rule (org MRN or platform MRN). */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * MRN of the target space for matching assets. Leave empty for wildcard
   * rules.
   */
  targetSpaceMrn: Scalars["String"]["input"];
  /**
   * Wildcard routing config. When set, this rule derives the target space
   * from a tag on each asset. Platform scope only; if present, must be the
   * only rule in the scope.
   */
  wildcard?: InputMaybe<WildcardRoutingConfigInput>;
};

/** Input for creating a new BI dashboard. */
export type CreateBiDashboardInput = {
  /** Commit message for the initial version */
  commitMessage?: InputMaybe<Scalars["String"]["input"]>;
  /** Initial dashboard definition as JSON */
  definition?: InputMaybe<Scalars["Map"]["input"]>;
  /** Optional description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Scope MRN (organization or space) */
  scopeMrn: Scalars["String"]["input"];
  /** Dashboard title */
  title: Scalars["String"]["input"];
};

/** The input to create a case */
export type CreateCaseInput = {
  /** Initiative references. Either references or initiativeRefs must be provided. */
  initiativeRefs?: InputMaybe<Array<CaseInitiativeRefInput>>;
  /** Ticketing integration MRN */
  integrationMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether to create a V2 ticket for multiple findings */
  isV2?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Notes */
  notes: Scalars["String"]["input"];
  /** References. Either references or initiativeRefs must be provided. */
  references?: InputMaybe<Array<CaseRefInput>>;
  /** Ticket configuration */
  ticketConfig: CaseTicketConfigInput;
  /** Title */
  title: Scalars["String"]["input"];
  /**
   * Optional workspace MRN. If specified, the case will be created in the workspace.
   * It is required that the case references are contained in the space that owns the provided workspace.
   */
  workspaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input provided when creating a client integration */
export type CreateClientIntegrationInput = {
  /**
   * Annotations applied to every asset discovered by this integration's scans.
   * Only meaningful for hosted scan-job integration types; ignored for
   * ticketing/export/import types.
   */
  annotations?: InputMaybe<Array<KeyValueInput>>;
  configurationOptions: ClientIntegrationConfigurationInput;
  /**
   * Labels are arbitrary key/value metadata on the integration itself, used for
   * routing, filtering, and grouping integrations — distinct from `annotations`,
   * which tag the assets an integration discovers. Any integration type may carry
   * them. For example, a Network Discovery Collector's labels are its tags, and a
   * Network Scan routes jobs to collectors carrying a matching label.
   */
  labels?: InputMaybe<Array<KeyValueInput>>;
  longLivedToken: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  /**
   * The scope MRN for the integration (space, organization, or platform).
   * Preferred over spaceMrn.
   */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Use scopeMrn instead */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
  type: ClientIntegrationType;
};

/** Response from creating a client integration */
export type CreateClientIntegrationPayload = {
  __typename: "CreateClientIntegrationPayload";
  /** The created client integration */
  integration: ClientIntegration;
};

/** Input for creating a new credential. */
export type CreateCredentialInput = {
  /** Secret field values (keys must match the template's field definitions). */
  data: Scalars["Map"]["input"];
  /** Optional expiration timestamp (RFC 3339). */
  expiresAt?: InputMaybe<Scalars["String"]["input"]>;
  /** Human-readable display name. */
  name: Scalars["String"]["input"];
  /** MRN of the owning space or organization. */
  ownerMrn: Scalars["ID"]["input"];
  /** Credential type key matching a credential template (e.g. "github"). */
  type: Scalars["String"]["input"];
};

/** Result of creating a credential. */
export type CreateCredentialPayload = {
  __typename: "CreateCredentialPayload";
  /** The newly created credential. */
  credential: Credential;
};

/** Create exception for scopes response */
export type CreateExceptionForScopesResponse = {
  __typename: "CreateExceptionForScopesResponse";
  /** Exception groups */
  exceptionGroups: Array<ExceptionGroup>;
};

/** Create exception response */
export type CreateExceptionResponse = {
  __typename: "CreateExceptionResponse";
  /** Exception group */
  exceptionGroup: ExceptionGroup;
};

/** Input for creating an invitation */
export type CreateInvitationInput = {
  /** The expiration time of the invitation */
  expiresAt?: InputMaybe<Scalars["String"]["input"]>;
  /** Either inviteeMrn or inviteeEmail need to be set */
  inviteeEmail?: InputMaybe<Scalars["String"]["input"]>;
  /** Either inviteeMrn or inviteeEmail need to be set */
  inviteeMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** The message for the invitation */
  message?: InputMaybe<Scalars["String"]["input"]>;
  /** The MRN of the resource (space or organization) */
  resourceMrn: Scalars["String"]["input"];
  /**
   * Deprecated: Use roleMrns instead. Provide either roleMrn or roleMrns, not both
   * @deprecated Use roleMrns instead
   */
  roleMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** List of role MRNs for the invitation. Provide either roleMrn or roleMrns, not both */
  roleMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Create organization input */
export type CreateOrganizationInput = {
  /** Annotations */
  annotations?: InputMaybe<Array<AnnotationInput>>;
  /** Company name */
  company?: InputMaybe<Scalars["String"]["input"]>;
  /** Contacts */
  contacts?: InputMaybe<Array<ResourceContactInput>>;
  /** Description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** ID */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Name */
  name: Scalars["String"]["input"];
  /** Settings */
  settings?: InputMaybe<OrganizationSettingsInput>;
  /** Tags */
  tags?: InputMaybe<Array<TagInput>>;
};

/** Create a new security pipeline pull request input. */
export type CreateSecurityPipelinePullRequestInput = {
  /** An optional list of asset MRNs. If provided, we create a patch only for the specified assets. */
  assetMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** An optional list of finding MRNs. If provided, we create a patch only for the specified findings. */
  findingMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The MRN of the security pipeline integration to use. */
  integrationMrn: Scalars["String"]["input"];
};

/** Create a new security pipeline pull request response. */
export type CreateSecurityPipelinePullRequestResponse = {
  __typename: "CreateSecurityPipelinePullRequestResponse";
  /** Information about the created pull request. */
  pullRequest: PullRequestInfo;
};

/** Create a new security pipeline scheduled workflow input. */
export type CreateSecurityPipelineScheduledWorkflowInput = {
  /** The configuration for the scheduled workflow. */
  configuration: SecurityPipelineScheduledWorkflowConfigurationInput;
  /** The MRN of the security pipeline integration to use. */
  integrationMrn: Scalars["String"]["input"];
  /** The MRN of the owner (space). */
  ownerMrn: Scalars["String"]["input"];
  /** The selection criteria for the scheduled workflow. */
  selection: SecurityPipelineScheduledWorkflowSelectionInput;
  /** Workflow title. */
  title: Scalars["String"]["input"];
};

/** Create a new security pipeline scheduled workflow response. */
export type CreateSecurityPipelineScheduledWorkflowResponse = {
  __typename: "CreateSecurityPipelineScheduledWorkflowResponse";
  /** Information about the created workflow. */
  workflow: SecurityPipelineScheduledWorkflow;
};

/** Create a new security pipeline workflow input. */
export type CreateSecurityPipelineWorkflowInput = {
  /** An optional list of asset MRNs. If provided, we create a patch only for the specified assets. */
  assetMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** An optional list of finding MRNs. If provided, we create a patch only for the specified findings. */
  findingMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** An optional list of initiative MRNs. If provided, we create a patch only for the specified initiatives. */
  initiativeMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The MRN of the security pipeline integration to use. */
  integrationMrn: Scalars["String"]["input"];
  /** The MRN of the owner (space). */
  ownerMrn: Scalars["String"]["input"];
  /** Workflow title. */
  title: Scalars["String"]["input"];
};

/** Create a new security pipeline workflow response. */
export type CreateSecurityPipelineWorkflowResponse = {
  __typename: "CreateSecurityPipelineWorkflowResponse";
  /** Information about the created workflow. */
  workflow: SecurityPipelineWorkflow;
};

/** Input for creating a service account */
export type CreateServiceAccountInput = {
  /** Optional description for the service account */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional labels for the service account */
  labels?: InputMaybe<Array<KeyValueInput>>;
  /** Optional name for the service account */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** The roles to assign to the service account */
  roles?: InputMaybe<Array<RoleInput>>;
  /** The scope for which the service account will be created (currently the only supported scopes are space and an organization) */
  scopeMrn: Scalars["String"]["input"];
  /** Optional RFC 3339 timestamp until which the service account will be valid */
  validUntil?: InputMaybe<Scalars["String"]["input"]>;
};

/** Create space input */
export type CreateSpaceInput = {
  /** Annotations */
  annotations?: InputMaybe<Array<AnnotationInput>>;
  /** Contacts */
  contacts?: InputMaybe<Array<ResourceContactInput>>;
  /** Description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** ID */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Name */
  name: Scalars["String"]["input"];
  /** Organization MRN */
  orgMrn: Scalars["String"]["input"];
  /** Settings */
  settings?: InputMaybe<SpaceSettingsInput>;
  /** Tags */
  tags?: InputMaybe<Array<TagInput>>;
};

/** Input for creating a team */
export type CreateTeamInput = {
  /** Optional description of the team */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The contact email for the team */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** ID */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** The name of the team */
  name: Scalars["String"]["input"];
  /**
   * Optional role MRNs to grant the team at the scope at creation time. When set,
   * the team is created and bound in a single call; if the binding fails the team
   * is rolled back. When omitted, the team is created without any membership.
   */
  roles?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The scope MRN (organization or space) that will own this team */
  scopeMrn: Scalars["String"]["input"];
};

/** Input for creating a Workload Identity Federation (WIF) auth binding */
export type CreateWifAuthBindingInput = {
  /** List of allowed audiences */
  allowedAudiences?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Optional description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Expiration in seconds associated with the binding */
  expiration?: InputMaybe<Scalars["Int"]["input"]>;
  /** URI for the token issuer, e.g. https://accounts.google.com */
  issuerUri: Scalars["String"]["input"];
  /** List of additional configurations to confirm */
  mappings?: InputMaybe<Array<KeyValueInput>>;
  /** User selected name */
  name: Scalars["String"]["input"];
  /** List of roles associated with the binding (e.g. agent mrn) */
  roles?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Space mrn associated with the binding */
  scopeMrn: Scalars["String"]["input"];
  /** Unique identifier to confirm */
  subject: Scalars["String"]["input"];
};

/** Response when creating a WIF auth binding */
export type CreateWifAuthBindingPayload = {
  __typename: "CreateWIFAuthBindingPayload";
  /** The created WIF auth binding */
  binding?: Maybe<WifAuthBinding>;
  /** The external auth configuration */
  config?: Maybe<WifExternalAuthConfig>;
};

/** Input for creating a workflow from a template. */
export type CreateWorkflowFromTemplateInput = {
  /**
   * Optional display name. Defaults to the template's name. Names that collide
   * with an existing workflow are auto-disambiguated with " (2)", " (3)", etc.
   */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** MRN of the owning space or organization. */
  ownerMrn: Scalars["ID"]["input"];
  /** Template to instantiate. */
  templateId: Scalars["ID"]["input"];
  /**
   * Variables to substitute into the template's {{ var_name }} placeholders.
   * Required template variables must be present; optional ones fall back to defaults.
   */
  variables?: InputMaybe<Scalars["Map"]["input"]>;
};

/** Result of creating a workflow from a template. */
export type CreateWorkflowFromTemplatePayload = {
  __typename: "CreateWorkflowFromTemplatePayload";
  /** The newly created workflow. */
  workflow: Workflow;
};

/** Input for creating a workflow. */
export type CreateWorkflowInput = {
  /** Optional longer description. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Human-readable display name. */
  name: Scalars["String"]["input"];
  /** MRN of the owning space or organization. */
  ownerMrn: Scalars["ID"]["input"];
  /** Full workflow definition in YAML. */
  yaml: Scalars["String"]["input"];
};

/** Result of creating a workflow. */
export type CreateWorkflowPayload = {
  __typename: "CreateWorkflowPayload";
  /** The newly created workflow. */
  workflow: Workflow;
};

/** Input for creating a workflow resource. */
export type CreateWorkflowResourceInput = {
  /** Resource key. */
  name: Scalars["String"]["input"];
  /** MRN of the owning space or organization. */
  ownerMrn: Scalars["ID"]["input"];
  /** Resource type (string, secret, json). */
  type: Scalars["String"]["input"];
  /** Initial value. */
  value: Scalars["String"]["input"];
};

/** Result of creating a workflow resource. */
export type CreateWorkflowResourcePayload = {
  __typename: "CreateWorkflowResourcePayload";
  /** The newly created resource. */
  resource: WorkflowResource;
};

/** Input for creating a workflow schedule. */
export type CreateWorkflowScheduleInput = {
  /** Cron expression defining the recurrence. */
  cronExpression: Scalars["String"]["input"];
  /** MRN of the workflow to schedule. */
  workflowMrn: Scalars["ID"]["input"];
};

/** Result of creating a workflow schedule. */
export type CreateWorkflowSchedulePayload = {
  __typename: "CreateWorkflowSchedulePayload";
  /** The newly created schedule. */
  schedule: WorkflowSchedule;
};

/** Create workspace input */
export type CreateWorkspaceInput = {
  /** Contacts */
  contacts?: InputMaybe<Array<ResourceContactInput>>;
  /** Description of the workspace */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The name of the workspace */
  name: Scalars["String"]["input"];
  /** The MRN of the owner of the workspace */
  ownerMrn: Scalars["String"]["input"];
  /** Workspace selections */
  selections: WorkspaceSelectionsInput;
};

/** A credential set used by workflows to authenticate with external services. */
export type Credential = {
  __typename: "Credential";
  /** Timestamp when the credential was created (RFC 3339). */
  createdAt: Scalars["String"]["output"];
  /** MRN of the user who created this credential. */
  createdBy?: Maybe<Scalars["String"]["output"]>;
  /** Expiration timestamp (RFC 3339). Null if the credential does not expire. */
  expiresAt?: Maybe<Scalars["String"]["output"]>;
  /** Timestamp of the last health check (RFC 3339). */
  healthCheckedAt?: Maybe<Scalars["String"]["output"]>;
  /** Error message from the last failed health check, if any. */
  healthError?: Maybe<Scalars["String"]["output"]>;
  /** Most recent health-check result (e.g. "healthy", "unhealthy"). */
  healthStatus?: Maybe<Scalars["String"]["output"]>;
  /** Unique Mondoo resource identifier. */
  mrn: Scalars["ID"]["output"];
  /** Human-readable display name. */
  name: Scalars["String"]["output"];
  /** MRN of the space or organization that owns this credential. */
  ownerMrn: Scalars["ID"]["output"];
  /** Credential type key (e.g. "github", "aws", "slack"). */
  type: Scalars["String"]["output"];
  /** Timestamp of the last update (RFC 3339). */
  updatedAt: Scalars["String"]["output"];
};

/**
 * A credential template defines the fields and auth configuration for a
 * credential type. Used by the UI to render creation forms.
 */
export type CredentialTemplate = {
  __typename: "CredentialTemplate";
  /** Human-readable description of the provider. */
  description: Scalars["String"]["output"];
  /** Input fields for this credential type. */
  fields: Array<CredentialTemplateField>;
  /** Unique identifier (e.g. "github", "aws"). */
  name: Scalars["String"]["output"];
  /** Support tier. */
  tier: CredentialTemplateTier;
};

/** A single input field in a credential template. */
export type CredentialTemplateField = {
  __typename: "CredentialTemplateField";
  /** Help text shown below the input. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable label for the form. */
  label: Scalars["String"]["output"];
  /** Field key used in the data map. */
  name: Scalars["String"]["output"];
  /** Placeholder value for the input. */
  placeholder?: Maybe<Scalars["String"]["output"]>;
  /** Whether the field must be provided when creating the credential. */
  required: Scalars["Boolean"]["output"];
  /** Whether the field value should be masked in the UI. */
  secret: Scalars["Boolean"]["output"];
};

/**
 * Support tier for a credential template. Supported providers have dedicated
 * health-check testers; experimental providers are untested and hidden in the
 * UI by default.
 */
export enum CredentialTemplateTier {
  Experimental = "EXPERIMENTAL",
  Supported = "SUPPORTED",
}

/** CrowdstrikeFalcon configuration options */
export type CrowdstrikeFalconConfigurationOptions = {
  __typename: "CrowdstrikeFalconConfigurationOptions";
  /** Client ID used for authentication with CrowdStrike Falcon platform. */
  clientId: Scalars["String"]["output"];
  /** The CrowdStrike Falcon cloud region. */
  cloud?: Maybe<Scalars["String"]["output"]>;
  /** createAssets is a flag to create assets in the backend when they are not found */
  createAssets?: Maybe<Scalars["Boolean"]["output"]>;
  /** CID selector for cases when the client id/secret has access to multiple CIDs. */
  memberCID?: Maybe<Scalars["String"]["output"]>;
  /** mondooEnrichment is a flag to enable mondoo scans based on the CrowdStrike data */
  mondooEnrichment?: Maybe<Scalars["Boolean"]["output"]>;
};

/** CrowdstrikeFalcon integration input */
export type CrowdstrikeFalconConfigurationOptionsInput = {
  /** Client ID used for authentication with CrowdStrike Falcon platform. */
  clientId: Scalars["String"]["input"];
  /** Client Secret used for authentication with CrowdStrike Falcon platform. */
  clientSecret: Scalars["String"]["input"];
  /** The CrowdStrike Falcon cloud region. */
  cloud?: InputMaybe<Scalars["String"]["input"]>;
  /** createAssets is a flag to create assets in the backend when they are not found */
  createAssets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** CID selector for cases when the client id/secret has access to multiple CIDs. */
  memberCID?: InputMaybe<Scalars["String"]["input"]>;
  /** mondooEnrichment is a flag to enable mondoo scans based on the CrowdStrike data */
  mondooEnrichment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** CVE */
export type Cve = {
  __typename: "Cve";
  /** Aggregate scores for advisories containing the cve */
  advisoryAggregateScores?: Maybe<AggregateScoresResponse>;
  /**
   * only set in context of space
   * @deprecated Use vulnerabilityScores API to get the affected assets. This will be removed
   */
  assets?: Maybe<Array<AssetItem>>;
  /** CVE score */
  cvssScore: CvssScore;
  /** CVE scores */
  cvssScores: Array<Maybe<CvssScore>>;
  /** CVE CWE */
  cwe?: Maybe<Scalars["String"]["output"]>;
  /** CVE description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** EPSS score for this CVE */
  epssScore?: Maybe<EpssScore>;
  /**
   * Exploits are now attached to CVE when available
   * @deprecated Use `riskFactors`.
   */
  exploitable?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * CVE data sources
   * external URLs to the specific CVE by NVD, CISA KEV, ...
   */
  externalUrls?: Maybe<Array<Maybe<Reference>>>;
  /** CVE id */
  id: Scalars["String"]["output"];
  /**
   * CVE modified date
   * @deprecated Use `modifiedAt`.
   */
  modified?: Maybe<Scalars["String"]["output"]>;
  /** CVE modified date */
  modifiedAt?: Maybe<Scalars["String"]["output"]>;
  /** CVE mrn */
  mrn: Scalars["String"]["output"];
  /**
   * CVE NVD enrichment status: whether and how NVD has analyzed this CVE.
   * Distinct from `state`; explains why a valid CVE may be unscored by NVD.
   */
  nvdStatus?: Maybe<NvdStatus>;
  /**
   * CVE published date
   * @deprecated Use `publishedAt`.
   */
  published?: Maybe<Scalars["String"]["output"]>;
  /** CVE published date */
  publishedAt?: Maybe<Scalars["String"]["output"]>;
  /** Risk score rating. Only set in context of space */
  rating?: Maybe<ScoreRating>;
  /**
   * References to NVD, CISA, etc.
   * But also blog posts, bugzilla, etc.
   */
  references?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /**
   * Risk score ranging between 0 - 100, calculated based on base score and risk factors.
   * Only set in context of space
   */
  riskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue?: Maybe<Scalars["Int"]["output"]>;
  /**
   * CVE score
   * @deprecated Use `cvssScore`.
   */
  score: CvssScore;
  /**
   * CVE source
   * This includes the generic source, i.e. NVD, but not the specific URL for a single CVE.
   * For the specific URL, use `externalUrls`.
   * @deprecated No longer supported. (remove in v12)
   */
  source: Source;
  /** CVE state: the MITRE/cve.org lifecycle state of the record (is it valid?). */
  state?: Maybe<CveState>;
  /**
   * CVE summary
   * @deprecated Use `description`.
   */
  summary?: Maybe<Scalars["String"]["output"]>;
  /** CVE title */
  title?: Maybe<Scalars["String"]["output"]>;
  /**
   * CVE url
   * @deprecated Use `references`.
   */
  url?: Maybe<Scalars["String"]["output"]>;
  /**
   * VulnerabilityRiskFactors: exploitable, RCE, ...
   * @deprecated Use `riskFactors`.
   */
  vulnerabilityRiskFactors: VulnerabilityRiskFactors;
  /**
   * Timestamp when the CVE record was withdrawn (rejected). Null unless the
   * CVE is REJECTED. Withdrawn CVEs are excluded from asset matching.
   */
  withdrawnAt?: Maybe<Scalars["String"]["output"]>;
};

/** CVE */
export type CveAdvisoryAggregateScoresArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** CVE finding object */
export type CveFinding = {
  __typename: "CveFinding";
  /** Asset information */
  asset?: Maybe<EntityInfoAsset>;
  /** Rating for the base score (CRITICAL/HIGH/MEDIUM/LOW/NONE) */
  baseRating: ScoreRating;
  /** Inverted value for the base score */
  baseValue: Scalars["Int"]["output"];
  /** Cases associated with this finding. */
  cases?: Maybe<CasesConnection>;
  /** CVSS information for this aggregate score (optional, only for vulnerabilities, and software) */
  cvss?: Maybe<CvssScore>;
  /** Sources which detected this vulnerability */
  detectionSources: Array<VulnerabilityScoreSource>;
  /** EPSS information for this aggregate score (optional, only for vulnerabilities, and software) */
  epss?: Maybe<EpssScore>;
  /**
   * Exception for this CVE, if exists
   * @deprecated Use exceptions
   */
  exception?: Maybe<FindingException>;
  /** Exceptions for this CVE, if some exist */
  exceptions?: Maybe<Array<Maybe<FindingException>>>;
  /** Timestamp, when the first failure was detected (RFC3339) */
  firstDetectedAt: Scalars["String"]["output"];
  /** Icon identifier for the score */
  iconId: Icon_Ids;
  /** Vulnerability ID */
  id: Scalars["String"]["output"];
  /** Most recent time the score was updated (RFC3339) */
  lastScoreUpdateTime: Scalars["String"]["output"];
  /**
   * Timestamp, when the score was last updated
   * Deprecated: Use lastScoreUpdateTime instead.
   * @deprecated Use lastScoreUpdateTime instead
   */
  lastUpdated: Scalars["String"]["output"];
  /** MRN */
  mrn: Scalars["String"]["output"];
  /**
   * Preview risk score (0 - 100) computed by the risk-dimension model.
   * Surfaced alongside riskScore for evaluation; null when not available.
   */
  previewRiskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Preview risk value is 100 - previewRiskScore; null when previewRiskScore is not available. */
  previewRiskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Timestamp, when the vulnerability was published (RFC3339) */
  publishedAt?: Maybe<Scalars["String"]["output"]>;
  /** Rating */
  rating: ScoreRating;
  /** Risk categories that apply to this CVE */
  riskCategories?: Maybe<Array<CveRiskCategory>>;
  /** Risk factors */
  riskFactors?: Maybe<Array<Maybe<RiskFactorStats>>>;
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore: Scalars["Int"]["output"];
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue: Scalars["Int"]["output"];
  /** Space risk delta and effort for the finding */
  spaceRiskDelta?: Maybe<FindingSpaceRiskDelta>;
  /** State */
  state: ScoreState;
  /** All states for the finding */
  states: FindingState;
  /** Risk score tags */
  tags?: Maybe<Array<Tag>>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** CVE finding object */
export type CveFindingCasesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<FindingCasesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A single mention of a CVE from an RSS, Mastodon, or Bluesky source. */
export type CveMention = {
  __typename: "CveMention";
  /** Author identifier. */
  author: Scalars["String"]["output"];
  /** Avatar URL of the author. */
  authorAvatar: Scalars["String"]["output"];
  /** Display name of the author. */
  authorName: Scalars["String"]["output"];
  /** When the mention was collected by the system. */
  collectedAt: Scalars["String"]["output"];
  /** Content or body of the mention. */
  content: Scalars["String"]["output"];
  /** Number of likes/favorites. */
  likeCount: Scalars["Int"]["output"];
  /** The type of mention (news or social media). */
  mentionType?: Maybe<CveMentionType>;
  /** When the mention was published. */
  publishedAt: Scalars["String"]["output"];
  /** Number of replies. */
  replyCount: Scalars["Int"]["output"];
  /** Number of reposts/boosts/reshares. */
  repostCount: Scalars["Int"]["output"];
  /** The source identifier (e.g. feed URL or account handle). */
  source: Scalars["String"]["output"];
  /** The type of source. */
  sourceType?: Maybe<CveMentionSourceType>;
  /** Title of the mention (e.g. article title). */
  title: Scalars["String"]["output"];
  /** URL to the original mention. */
  url: Scalars["String"]["output"];
};

/**
 * The number of mentions of a CVE from a single source type, precomputed at import
 * so consumers avoid aggregating the raw `mentions` array client-side.
 */
export type CveMentionSourceCount = {
  __typename: "CveMentionSourceCount";
  /** Number of mentions from this source type. */
  count: Scalars["Int"]["output"];
  /** The source type these mentions came from. */
  sourceType?: Maybe<CveMentionSourceType>;
};

/** Source type of a CVE mention. */
export enum CveMentionSourceType {
  /** Bluesky social media source. */
  Bluesky = "BLUESKY",
  /** Mastodon social media source. */
  Mastodon = "MASTODON",
  /** RSS feed source. */
  Rss = "RSS",
}

/** The type of a CVE mention. */
export enum CveMentionType {
  /** News mention (e.g. RSS feed article). */
  News = "NEWS",
  /** Social media mention (e.g. Mastodon, Bluesky post). */
  SocialMedia = "SOCIAL_MEDIA",
}

/** CVE Risk Category - represents a scored risk category for a CVE/Advisory */
export type CveRiskCategory = {
  __typename: "CveRiskCategory";
  /** Whether this category is applicable to the scoring */
  applicable: Scalars["Boolean"]["output"];
  /** The MRN of the category */
  categoryMrn: Scalars["String"]["output"];
  /** Per-category details on what was scored */
  details?: Maybe<CveRiskCategoryDetails>;
  /** Whether this category was enabled at the time of scoring */
  enabled: Scalars["Boolean"]["output"];
  /** What impact this category has in the overall risk score calculation */
  impact: Scalars["Float"]["output"];
  /** Enum representation of the impact level */
  impactLabel: RiskCategoryImpactLabel;
};

/** CVE Risk Category Details - union of possible detail types */
export type CveRiskCategoryDetails =
  | AttackSurfaceDetails
  | BlastRadiusDetails
  | BusinessPriorityDetails
  | ExploitabilityDetails
  | NewsDetails;

/** Possible CVE states (MITRE/cve.org lifecycle) */
export enum CveState {
  Invalid = "INVALID",
  MergedTo = "MERGED_TO",
  Public = "PUBLIC",
  Rejected = "REJECTED",
  ReplacedBy = "REPLACED_BY",
  Reserved = "RESERVED",
  SplitFrom = "SPLIT_FROM",
}

/** Trending data for a single CVE. */
export type CveTrend = {
  __typename: "CveTrend";
  /** The CVE identifier (e.g. "CVE-2024-1234"). */
  cveId: Scalars["String"]["output"];
  /** When this CVE was first seen trending. */
  firstSeen: Scalars["String"]["output"];
  /** JSON array of key mentions used to generate the summary. */
  keyMentions: Scalars["String"]["output"];
  /** When this CVE was last seen trending. */
  lastSeen: Scalars["String"]["output"];
  /** Total number of mentions across all sources. */
  mentionCount: Scalars["Int"]["output"];
  /** Individual mentions from various sources. */
  mentions: Array<CveMention>;
  /**
   * Precomputed mention counts per source type. Lets a list/summary view show an
   * RSS/Mastodon/Bluesky breakdown without selecting the full `mentions` array.
   */
  mentionsBySource: Array<CveMentionSourceCount>;
  /** Score from news/RSS sources. */
  newsScore: Scalars["Float"]["output"];
  /**
   * Historical score snapshots accumulated over time. Only populated when
   * this field is explicitly selected in the query; otherwise empty.
   */
  scoreHistory: Array<CveTrendScoreSnapshot>;
  /** Score from social media sources (Mastodon, Bluesky). */
  socialScore: Scalars["Float"]["output"];
  /** LLM-generated summary text for the CVE. */
  summary: Scalars["String"]["output"];
  /** When the summary was generated. */
  summaryGeneratedAt: Scalars["String"]["output"];
  /** URL of the top reference for this CVE. */
  topReference: Scalars["String"]["output"];
  /** Overall trend score. */
  trendScore: Scalars["Float"]["output"];
  /** Number of unique sources that mentioned this CVE. */
  uniqueSources: Scalars["Int"]["output"];
  /** When the trend data was last updated. */
  updatedAt: Scalars["String"]["output"];
};

/**
 * A point-in-time snapshot of a CVE's trend scores. The history is appended on
 * each trend run so that score evolution can be tracked over time.
 */
export type CveTrendScoreSnapshot = {
  __typename: "CveTrendScoreSnapshot";
  /** Score from news/RSS sources at the time of the snapshot. */
  newsScore: Scalars["Float"]["output"];
  /** Score from social media sources at the time of the snapshot. */
  socialScore: Scalars["Float"]["output"];
  /** When this snapshot was captured (RFC3339). */
  timestamp: Scalars["String"]["output"];
  /** Overall trend score at the time of the snapshot. */
  trendScore: Scalars["Float"]["output"];
};

/** A connection to a list of CVE trends. */
export type CveTrendsConnection = {
  __typename: "CveTrendsConnection";
  /** The edges in this connection. */
  edges?: Maybe<Array<CveTrendsEdge>>;
  /** Pagination info. */
  pageInfo: PageInfo;
  /** Total count of CVE trends. */
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a CVE trends connection. */
export type CveTrendsEdge = {
  __typename: "CveTrendsEdge";
  /** A cursor used for pagination. */
  cursor: Scalars["ID"]["output"];
  /** The CVE trend node. */
  node?: Maybe<CveTrend>;
};

/** Ordering options for CVE trends. */
export type CveTrendsOrder = {
  /** Order direction. */
  direction: OrderDirection;
  /** Order field. */
  field?: InputMaybe<CveTrendsOrderField>;
};

/** Order field for CVE trends. */
export enum CveTrendsOrderField {
  /** Order by overall trend score. */
  TrendScore = "TREND_SCORE",
}

/** CVSS score */
export type CvssScore = {
  __typename: "CvssScore";
  /** ID */
  id: Scalars["String"]["output"];
  /** Rating */
  rating: ScoreRating;
  /** Source */
  source: Scalars["String"]["output"];
  /** Type */
  type: Scalars["Int"]["output"];
  /** Value */
  value: Scalars["Int"]["output"];
  /** Vector */
  vector: Scalars["String"]["output"];
};

/** Data queries connection */
export type DataQueriesConnection = {
  __typename: "DataQueriesConnection";
  /** Edges */
  edges?: Maybe<Array<DataQueriesEdge>>;
  /** Total count with filters applied */
  filteredTotalCount: Scalars["Int"]["output"];
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Data queries edge */
export type DataQueriesEdge = {
  __typename: "DataQueriesEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<DataQuery>;
};

/** Data queries response */
export type DataQueriesResponse =
  | DataQueriesConnection
  | NotFoundError
  | RequestError;

/** Data query node object */
export type DataQuery = {
  __typename: "DataQuery";
  /** Asset information */
  asset?: Maybe<EntityInfoAsset>;
  /** Icon identifier for the score */
  iconId: Icon_Ids;
  /** Query ID */
  id: Scalars["String"]["output"];
  /** Most recent time the score was updated (RFC3339) */
  lastScoreUpdateTime: Scalars["String"]["output"];
  /**
   * Last updated time (RFC3339)
   * Deprecated: Use lastScoreUpdateTime instead.
   * @deprecated Use lastScoreUpdateTime instead
   */
  lastUpdated: Scalars["String"]["output"];
  /** The mquery */
  mquery?: Maybe<Mquery>;
  /** MRN of the query */
  mrn: Scalars["String"]["output"];
  /** Asset platform */
  platform?: Maybe<Platform>;
  /** Risk score tags */
  tags?: Maybe<Array<Tag>>;
  /**
   * Title
   * @deprecated Use mquery.title
   */
  title: Scalars["String"]["output"];
  /** The value of the data query */
  value?: Maybe<Scalars["Any"]["output"]>;
};

/** Data query filters */
export type DataQueryFilter = {
  /** Whether to include checks for CI/CD assets in the results */
  includeCicd?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter the result by a policy mrn */
  policyMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter the result by a query mrn */
  queryMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Optional query terms. Will return only vulnerabilities containing
   * the term in their MRN
   */
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Data query order */
export type DataQueryOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: DataQueryOrderField;
};

/** Data query order field */
export enum DataQueryOrderField {
  AssetName = "ASSET_NAME",
  LastUpdated = "LAST_UPDATED",
}

/** Input for deleting an API token */
export type DeleteApiTokenInput = {
  /** The MRN of the API token to delete */
  mrn: Scalars["String"]["input"];
};

/** Response when deleting an API token */
export type DeleteApiTokenResponse = {
  __typename: "DeleteAPITokenResponse";
  /** Whether the operation was successful */
  ok: Scalars["Boolean"]["output"];
};

/** Input used when deleting an agent */
export type DeleteAgentsInput = {
  /** The MRNs of the agents to delete */
  agentMrns: Array<Scalars["String"]["input"]>;
  /** The MRN of the space */
  spaceMrn: Scalars["String"]["input"];
};

/** Response when deleting an agent */
export type DeleteAgentsPayload = {
  __typename: "DeleteAgentsPayload";
  /** The MRNs of the agents that were deleted */
  agentMrns: Array<Scalars["String"]["output"]>;
  /** Errors for the agents that were not deleted */
  errors: Scalars["Map"]["output"];
};

/** Delete assets input */
export type DeleteAssetsInput = {
  /** Asset MRNs */
  assetMrns?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /**
   * Scope MRN. Accepts a space MRN or workspace MRN. When a workspace MRN is
   * provided, deletion is constrained to assets that belong to that workspace.
   */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Space MRN
   * @deprecated Use scopeMrn instead
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Delete assets payload */
export type DeleteAssetsPayload = {
  __typename: "DeleteAssetsPayload";
  /**
   * Asset MRNs
   * @deprecated will no longer be returned as such a result can be very large
   */
  assetMrns?: Maybe<Array<Scalars["ID"]["output"]>>;
  /** Errors */
  errors: Scalars["Map"]["output"];
  /** Scope MRN echoed back from the request. */
  scopeMrn: Scalars["String"]["output"];
  /**
   * Space MRN
   * @deprecated Use scopeMrn instead
   */
  spaceMrn: Scalars["String"]["output"];
};

/** Input for deleting (archiving) a BI dashboard. */
export type DeleteBiDashboardInput = {
  /** Dashboard MRN */
  mrn: Scalars["String"]["input"];
};

/** Delete cases input */
export type DeleteCasesInput = {
  /** MRNs of cases to delete */
  mrns: Array<Scalars["String"]["input"]>;
};

/** Input for deleting a client integration */
export type DeleteClientIntegrationInput = {
  mrn: Scalars["String"]["input"];
};

/** Response when deleting an integration */
export type DeleteClientIntegrationPayload = {
  __typename: "DeleteClientIntegrationPayload";
  /** The MRN of the deleted client integration */
  mrn: Scalars["String"]["output"];
};

/** Input for deleting a credential. */
export type DeleteCredentialInput = {
  /** MRN of the credential to delete. */
  mrn: Scalars["ID"]["input"];
};

/** Result of deleting a credential. */
export type DeleteCredentialPayload = {
  __typename: "DeleteCredentialPayload";
  /** MRN of the deleted credential. */
  deletedMrn: Scalars["ID"]["output"];
};

/** Input for deleting a policy */
export type DeleteCustomPolicyInput = {
  /** The mrn of the policy */
  policyMrn: Scalars["String"]["input"];
};

/** Result of deleting a policy */
export type DeleteCustomPolicyPayload = {
  __typename: "DeleteCustomPolicyPayload";
  /** The mrn of the policy */
  policyMrn: Scalars["String"]["output"];
};

/** Input for deleting a query pack */
export type DeleteCustomQueryPackInput = {
  /** The mrn of the query pack */
  queryPackMrn: Scalars["String"]["input"];
};

/** Result of deleting a query pack */
export type DeleteCustomQueryPackPayload = {
  __typename: "DeleteCustomQueryPackPayload";
  /** The mrn of the query pack */
  queryPackMrn: Scalars["String"]["output"];
};

/** Delete framework input */
export type DeleteFrameworkInput = {
  /** Framework MRN */
  mrn: Scalars["String"]["input"];
};

/** Input for deleting projects */
export type DeleteProjectsInput = {
  /** The MRNs of the projects to delete */
  mrns: Array<Scalars["String"]["input"]>;
};

/** Response when deleting projects */
export type DeleteProjectsPayload = {
  __typename: "DeleteProjectsPayload";
  /** The MRNs of the deleted projects */
  mrns: Array<Scalars["String"]["output"]>;
};

/** Response when deleting an SSH key */
export type DeleteSshKeyPayload = {
  __typename: "DeleteSSHKeyPayload";
  /** Whether the operation was successful */
  success: Scalars["Boolean"]["output"];
};

/** Input for deleting an SSH key */
export type DeleteSshKeyRequest = {
  /** The fingerprint of the SSH key to delete */
  fingerprint: Scalars["String"]["input"];
  /** The MRN of the user */
  mrn: Scalars["String"]["input"];
};

/** Input for deleting SSO provider */
export type DeleteSsoProviderInput = {
  /** The MRN of the organization */
  organizationMrn: Scalars["String"]["input"];
};

/** Input for deleting service accounts */
export type DeleteServiceAccountsInput = {
  /** The MRNs of the service accounts to delete */
  mrns: Array<Scalars["String"]["input"]>;
  /** The MRN of the scope containing the service accounts */
  scopeMrn: Scalars["String"]["input"];
};

/** Response when deleting service accounts */
export type DeleteServiceAccountsPayload = {
  __typename: "DeleteServiceAccountsPayload";
  /** Any errors that occurred during deletion */
  errors: Scalars["Map"]["output"];
  /** The MRNs of the deleted service accounts */
  mrns: Array<Scalars["String"]["output"]>;
};

/** Input for deleting an edge from a workflow. */
export type DeleteWorkflowEdgeInput = {
  /** Source node ID. */
  from: Scalars["ID"]["input"];
  /** Destination node ID. */
  to: Scalars["ID"]["input"];
  /** MRN of the workflow to modify. */
  workflowMrn: Scalars["ID"]["input"];
};

/** Result of deleting an edge from a workflow. */
export type DeleteWorkflowEdgePayload = {
  __typename: "DeleteWorkflowEdgePayload";
  /** The workflow with the edge removed. */
  workflow: Workflow;
};

/** Input for deleting a workflow. */
export type DeleteWorkflowInput = {
  /** MRN of the workflow to delete. */
  mrn: Scalars["ID"]["input"];
};

/** Input for deleting a workflow node. */
export type DeleteWorkflowNodeInput = {
  /** ID of the node to delete. */
  nodeId: Scalars["ID"]["input"];
  /** MRN of the workflow containing the node. */
  workflowMrn: Scalars["ID"]["input"];
};

/** Result of deleting a workflow node. */
export type DeleteWorkflowNodePayload = {
  __typename: "DeleteWorkflowNodePayload";
  /** The workflow with the node removed. */
  workflow: Workflow;
};

/** Result of deleting a workflow. */
export type DeleteWorkflowPayload = {
  __typename: "DeleteWorkflowPayload";
  /** MRN of the deleted workflow. */
  deletedMrn: Scalars["ID"]["output"];
};

/** Input for deleting a workflow resource. */
export type DeleteWorkflowResourceInput = {
  /** Resource key to delete. */
  name: Scalars["String"]["input"];
  /** MRN of the scope containing the resource. */
  scopeMrn: Scalars["ID"]["input"];
};

/** Result of deleting a workflow resource. */
export type DeleteWorkflowResourcePayload = {
  __typename: "DeleteWorkflowResourcePayload";
  /** Name of the deleted resource. */
  deletedName: Scalars["String"]["output"];
  /** Scope MRN the resource belonged to. */
  scopeMrn: Scalars["ID"]["output"];
};

/** Input for deleting a workflow schedule. */
export type DeleteWorkflowScheduleInput = {
  /** MRN of the schedule to delete. */
  mrn: Scalars["ID"]["input"];
};

/** Result of deleting a workflow schedule. */
export type DeleteWorkflowSchedulePayload = {
  __typename: "DeleteWorkflowSchedulePayload";
  /** MRN of the deleted schedule. */
  deletedMrn: Scalars["ID"]["output"];
};

/** Delete workspaces input */
export type DeleteWorkspacesInput = {
  /** MRNs of workspaces to delete */
  mrns: Array<Scalars["String"]["input"]>;
};

/** Input for denying a workflow step. */
export type DenyWorkflowStepInput = {
  /** MRN of the execution containing the approval step. */
  executionMrn: Scalars["ID"]["input"];
  /** ID of the node to deny. */
  nodeId: Scalars["ID"]["input"];
  /** Reason for denial. */
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

/** Result of denying a workflow step. */
export type DenyWorkflowStepPayload = {
  __typename: "DenyWorkflowStepPayload";
  /** MRN of the execution that was denied. */
  executionMrn: Scalars["ID"]["output"];
  /** ID of the denied node. */
  nodeId: Scalars["ID"]["output"];
};

/** Device type classification */
export enum DeviceType {
  Container = "CONTAINER",
  Server = "SERVER",
  Unknown = "UNKNOWN",
  Workstation = "WORKSTATION",
}

/** DigitalOcean integration */
export type DigitaloceanConfigurationOptions = {
  __typename: "DigitaloceanConfigurationOptions";
  /**
   * The DigitalOcean API token. Always null in responses — the token is stored in
   * the vault and never echoed back; a non-null value here simply indicates the
   * token is configured.
   */
  token?: Maybe<Scalars["String"]["output"]>;
};

/** DigitalOcean integration input */
export type DigitaloceanConfigurationOptionsInput = {
  /** DigitalOcean API token */
  token: Scalars["String"]["input"];
};

/** Integration provider whose discovery targets can be listed. */
export enum DiscoveryProvider {
  Aws = "AWS",
  Azure = "AZURE",
  Gcp = "GCP",
}

/** Discovery statistics */
export type DiscoveryStat = {
  __typename: "DiscoveryStat";
  /** Count */
  count: Scalars["Int"]["output"];
  /** Identifier */
  identifier?: Maybe<Scalars["String"]["output"]>;
  /** Query */
  query: Scalars["String"]["output"];
  /** The title */
  title: Scalars["String"]["output"];
};

/** A selectable discovery target for an integration. */
export type DiscoveryTarget = {
  __typename: "DiscoveryTarget";
  /** A human-readable label for the discovery target, for display in the UI. */
  title: Scalars["String"]["output"];
  /** The discovery target identifier passed to the scanner (e.g. "s3-buckets"). */
  value: Scalars["String"]["output"];
};

/** Response when downloading document */
export type DocumentDownloadPayload = {
  __typename: "DocumentDownloadPayload";
  /** The signed URL for containing any collected debug information */
  debugDownloadUrl?: Maybe<Scalars["String"]["output"]>;
  /** The signed URL for downloading the document */
  downloadUrl: Scalars["String"]["output"];
  /** The time at which the download URL expires */
  expiresAt: Scalars["String"]["output"];
};

/** Document format */
export enum DocumentFormat {
  Csv = "CSV",
  Jsonl = "JSONL",
  Pdf = "PDF",
}

/** List of document metadata */
export type DocumentMetadata = {
  __typename: "DocumentMetadata";
  /** The MRN of the user who requested the document */
  createdBy?: Maybe<Author>;
  /** The format of the document */
  format: DocumentFormat;
  /** The time at which the document was generated */
  generatedAt?: Maybe<Scalars["String"]["output"]>;
  /** Status/progress messages from the document generation */
  messages?: Maybe<Array<IntegrationMessage>>;
  /** The MRN of the document */
  mrn: Scalars["String"]["output"];
  /** The name of the document */
  name: Scalars["String"]["output"];
  /** The time at which the document was requested */
  requestedAt: Scalars["String"]["output"];
  /** The status of the document */
  status: DocumentStatus;
  /** The message associated with the document status */
  statusMessage?: Maybe<Scalars["String"]["output"]>;
  /** The type of the document */
  type: DocumentType;
};

/** List of document metadata */
export type DocumentMetadataConnection = {
  __typename: "DocumentMetadataConnection";
  /** A list of document metadata */
  edges: Array<DocumentMetadataEdge>;
  /** Information about the current page */
  pageInfo: PageInfo;
  /** The total number of documents */
  totalCount: Scalars["Int"]["output"];
};

/** List of document metadata edge */
export type DocumentMetadataEdge = {
  __typename: "DocumentMetadataEdge";
  /** The cursor for this edge */
  cursor: Scalars["String"]["output"];
  /** The document metadata for this edge */
  node: DocumentMetadata;
};

/** Document status */
export enum DocumentStatus {
  Completed = "COMPLETED",
  Failed = "FAILED",
  Pending = "PENDING",
  Queued = "QUEUED",
  Running = "RUNNING",
}

/** Document type */
export enum DocumentType {
  AdvisoryReport = "ADVISORY_REPORT",
  AssetReport = "ASSET_REPORT",
  AuditLogExport = "AUDIT_LOG_EXPORT",
  ChecksReport = "CHECKS_REPORT",
  CheckReport = "CHECK_REPORT",
  ControlReport = "CONTROL_REPORT",
  Export = "EXPORT",
  FrameworkReport = "FRAMEWORK_REPORT",
  PolicyAggregateScoresExport = "POLICY_AGGREGATE_SCORES_EXPORT",
  SecurityReport = "SECURITY_REPORT",
  VulnerabilitiesReport = "VULNERABILITIES_REPORT",
  VulnerabilityReport = "VULNERABILITY_REPORT",
}

/** Download bundle input */
export type DownloadBundleInput = {
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["input"];
};

/** Download bundle payload */
export type DownloadBundlePayload = PolicyBundleYaml;

/** Download framework input */
export type DownloadFrameworkInput = {
  /**
   * Whether to include all evidence in the bundle. By default, only
   * evidence for activated policies is returned.
   */
  allEvidence?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Framework MRN */
  mrn: Scalars["String"]["input"];
  /** Scope MRN */
  scopeMrn: Scalars["String"]["input"];
};

/** End-of-life analysis */
export type EolAnalysis = {
  __typename: "EOLAnalysis";
  /** Date */
  date: Scalars["String"]["output"];
  /** Status */
  status: EolStatus;
};

/**
 * End-of-life status of an operating system (`Asset.eol`) or a package
 * (`Software.eol`), classified relative to the space's EOL warning window
 * (`eolAssetsConfiguration.monthsInAdvance`, default 6 months) — the same
 * window that drives the EOL risk factor, so the status is consistent
 * across the product.
 */
export enum EolStatus {
  /**
   * The published EOL date has already passed — the OS/package is
   * end-of-life today.
   */
  Eol = "EOL",
  /**
   * A published EOL date exists and is still more than `monthsInAdvance`
   * months in the future. End-of-life is known but not yet approaching.
   */
  Scheduled = "SCHEDULED",
  /**
   * A published EOL date exists and falls within the next `monthsInAdvance`
   * months (but has not passed). This is the population surfaced as
   * "EOL soon" in the inventory.
   */
  Soon = "SOON",
  /**
   * No EOL date is known for this OS/package (e.g. the platform has no
   * published end-of-life date yet). Previously reported as `SCHEDULED`.
   */
  Unknown = "UNKNOWN",
}

/** EBS scan options for the AWS integration */
export type EbsScanOptions = {
  __typename: "EbsScanOptions";
  /**
   * The maximum number of instances per ASG
   * @deprecated Will be removed in the future
   */
  maxAsgInstances?: Maybe<Scalars["Int"]["output"]>;
  /** The target instances per scanner */
  targetInstancesPerScanner?: Maybe<Scalars["Int"]["output"]>;
};

/** Options for EBS scanning with the AWS integration */
export type EbsScanOptionsInput = {
  /**
   * The maximum number of instances per ASG
   * @deprecated Will be removed in the future
   */
  maxAsgInstances?: InputMaybe<Scalars["Int"]["input"]>;
  /** The target instances per scanner */
  targetInstancesPerScanner?: InputMaybe<Scalars["Int"]["input"]>;
};

/** EC2 scan options for the AWS integration */
export type Ec2ScanOptions = {
  __typename: "Ec2ScanOptions";
  /**
   * Whether to use AWS Secrets Manager
   * @deprecated Will be removed in the future
   */
  awsSecretsManagerVault?: Maybe<Scalars["Boolean"]["output"]>;
  /** EBS scan options */
  ebsScanOptions?: Maybe<EbsScanOptions>;
  /** Whether to scan EBS volumes */
  ebsVolumeScan: Scalars["Boolean"]["output"];
  /** The instance IDs to exclude */
  excludedInstanceIdsFilter?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The regions to exclude */
  excludedRegionsFilter?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The tags to exclude */
  excludedTagsFilter?: Maybe<Scalars["Map"]["output"]>;
  /** Whether to use instance connect */
  instanceConnect: Scalars["Boolean"]["output"];
  /** The instance IDs to filter */
  instanceIdsFilter?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The regions to filter */
  regionsFilter?: Maybe<Array<Scalars["String"]["output"]>>;
  /**
   * The query to use for secrets metadata
   * @deprecated Will be removed in the future
   */
  secretsMetadataQuery?: Maybe<Scalars["String"]["output"]>;
  /** Whether to use SSM */
  ssm: Scalars["Boolean"]["output"];
  /** The tags to filter */
  tagsFilter: Scalars["Map"]["output"];
  /**
   * The vault type
   * @deprecated Will be removed in the future
   */
  vaultType?: Maybe<Scalars["String"]["output"]>;
};

/** Options for EC2 scans with the AWS integration */
export type Ec2ScanOptionsInput = {
  /**
   * EBS scan options
   * @deprecated Will be removed in the future
   */
  ebsScanOptions?: InputMaybe<EbsScanOptionsInput>;
  /** Whether to scan EBS volumes */
  ebsVolumeScan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The instance IDs to exclude */
  excludedInstanceIdsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The regions to exclude */
  excludedRegionsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The tags to exclude */
  excludedTagsFilter?: InputMaybe<Scalars["Map"]["input"]>;
  /** Whether to use instance connect */
  instanceConnect?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The instance IDs to filter */
  instanceIdsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The regions to filter */
  regionsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Whether to use SSM */
  ssm?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The tags to filter */
  tagsFilter?: InputMaybe<Scalars["Map"]["input"]>;
};

/** Represents an ecosystem. */
export type Ecosystem = {
  __typename: "Ecosystem";
  /**
   * The versionless ecosystem string. This should be used for filtering remediations,
   * when the ecosystem has no versions.
   */
  ecosystem: Scalars["String"]["output"];
  /** The friendly name of the ecosystem, e.g. "Ubuntu", "Redhat", etc. */
  friendlyName: Scalars["String"]["output"];
  /** Icon ID to determine the icon in the UI */
  icon: Icon_Ids;
  /** The versions in this ecosystem. */
  versions?: Maybe<Array<EcosystemVersion>>;
};

/**
 * Ecosystem entry
 * An ecosystem is something like "AmazonLinux:2023" or "Debian:12" or "Ubuntu:22.04"
 */
export type EcosystemEntry = {
  __typename: "EcosystemEntry";
  /** Icon ID to determine the icon in the UI */
  iconIDEnum?: Maybe<Icon_Ids>;
  /** ID */
  id: Scalars["String"]["output"];
  /** Title */
  title: Scalars["String"]["output"];
  /** Version */
  version: Scalars["String"]["output"];
};

/** Represents an ecosystem version. */
export type EcosystemVersion = {
  __typename: "EcosystemVersion";
  /** The fully qualified ecosystem string. This should be used for filtering remediations. */
  ecosystem: Scalars["String"]["output"];
  /** The version's friendly name */
  friendlyName: Scalars["String"]["output"];
};

/** Elastic configuration options */
export type ElasticConfigurationOptions = {
  __typename: "ElasticConfigurationOptions";
  /**
   * Elastic Cloud ID (alternative to endpoint for Elastic Cloud deployments),
   * e.g. "my-deployment:dXMtZWFzdC0xLmF3cy5mb3VuZC5pbyQ..."
   */
  cloudId?: Maybe<Scalars["String"]["output"]>;
  /** Elasticsearch endpoint URL, e.g. "https://my-cluster.es.us-east-1.aws.found.io:443" */
  endpoint?: Maybe<Scalars["String"]["output"]>;
  /** Index name or pattern to write to, e.g. "mondoo-vulnerabilities" */
  index: Scalars["String"]["output"];
  /** Whether to skip TLS certificate verification (for self-signed certs) */
  skipTlsVerify: Scalars["Boolean"]["output"];
};

/** Elastic integration input */
export type ElasticConfigurationOptionsInput = {
  /** API key for authentication, e.g. "VnVhQ2ZHY0JDZGJrUW0tZTVhT3g6dWkybHAyYXhUTm1zeWFrd..." */
  apiKey: Scalars["String"]["input"];
  /**
   * Elastic Cloud ID (alternative to endpoint for Elastic Cloud deployments),
   * e.g. "my-deployment:dXMtZWFzdC0xLmF3cy5mb3VuZC5pbyQ...".
   * Either endpoint or cloudId must be provided.
   */
  cloudId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Elasticsearch endpoint URL, e.g. "https://my-cluster.es.us-east-1.aws.found.io:443".
   * Either endpoint or cloudId must be provided.
   */
  endpoint?: InputMaybe<Scalars["String"]["input"]>;
  /** Index name or pattern to write to, e.g. "mondoo-vulnerabilities" */
  index: Scalars["String"]["input"];
  /** Whether to skip TLS certificate verification (for self-signed certs) */
  skipTlsVerify: Scalars["Boolean"]["input"];
};

/** Email configuration options */
export type EmailConfigurationOptions = {
  __typename: "EmailConfigurationOptions";
  /**
   * Whether to auto-close tickets for closed cases
   * @deprecated do not use
   */
  autoCloseTickets: Scalars["Boolean"]["output"];
  /** Whether to auto-create tickets for new cases */
  autoCreateTickets: Scalars["Boolean"]["output"];
  /** A list of potential email recipients */
  recipients: Array<EmailRecipient>;
  /**
   * Whether to send email notifications when a ticket is updated (e.g. findings resolved).
   * Defaults to true for backwards compatibility.
   */
  sendUpdateEmails: Scalars["Boolean"]["output"];
};

/** Email integration input */
export type EmailConfigurationOptionsInput = {
  /**
   * Whether to auto-close tickets for closed cases
   * @deprecated do not use
   */
  autoCloseTickets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether to auto-create tickets for new cases */
  autoCreateTickets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** A list of potential email recipients */
  recipients: Array<EmailRecipientInput>;
  /**
   * Whether to send email notifications when a ticket is updated (e.g. findings resolved).
   * Defaults to true for backwards compatibility.
   */
  sendUpdateEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Email preference */
export type EmailPreference = {
  __typename: "EmailPreference";
  /** The list ID */
  listID: EmailPreferenceList;
  /** Whether to subscribe to the list */
  subscribed: Scalars["Boolean"]["output"];
  /** The date the user subscribed to the list */
  subscribedAt: Scalars["String"]["output"];
};

/** Email preference input */
export type EmailPreferenceInput = {
  /** The list ID */
  listID: EmailPreferenceList;
  /** Whether to subscribe to the list */
  subscribe: Scalars["Boolean"]["input"];
};

/** Email preference list */
export enum EmailPreferenceList {
  NewsletterEvents = "NEWSLETTER_EVENTS",
  NewsletterGeneral = "NEWSLETTER_GENERAL",
  NewsletterProduct = "NEWSLETTER_PRODUCT",
  NotificationExceptionsPendingReview = "NOTIFICATION_EXCEPTIONS_PENDING_REVIEW",
  NotificationExpiringExceptions = "NOTIFICATION_EXPIRING_EXCEPTIONS",
  NotificationSpaceAlerts = "NOTIFICATION_SPACE_ALERTS",
  NotificationWeeklyReports = "NOTIFICATION_WEEKLY_REPORTS",
}

/** Email recipient */
export type EmailRecipient = {
  __typename: "EmailRecipient";
  /** The email address of the recipient */
  email: Scalars["String"]["output"];
  /** Whether this recipient is the default recipient */
  isDefault: Scalars["Boolean"]["output"];
  /** The name of the recipient */
  name: Scalars["String"]["output"];
  /** An optional reference URL for the recipient */
  referenceUrl?: Maybe<Scalars["String"]["output"]>;
};

/** Email recipient input */
export type EmailRecipientInput = {
  /** Email of the recipient */
  email: Scalars["String"]["input"];
  /** Whether this recipient is the default recipient */
  isDefault: Scalars["Boolean"]["input"];
  /** Name of the recipient */
  name: Scalars["String"]["input"];
  /**
   * An optional reference URL that will get attached to the ticket reference
   * created by this integration
   */
  referenceUrl?: InputMaybe<Scalars["String"]["input"]>;
};

/** Email ticket configuration input */
export type EmailTicketConfigInput = {
  /** Email address to send the ticket to */
  emailAddress: Scalars["String"]["input"];
};

/** This type represents an email ticket context. It contains the recipient's email address and display name. */
export type EmailTicketContextPayload = {
  __typename: "EmailTicketContextPayload";
  /** The recipients that are available for creating a ticket. */
  recipients: Array<EmailRecipient>;
};

/** Input for enabling SSO provider */
export type EnableSsoProviderInput = {
  /** Whether to enable the SSO provider */
  enabled: Scalars["Boolean"]["input"];
  /** The MRN of the organization */
  organizationMrn: Scalars["String"]["input"];
};

/** Enforcement state for checks (computed from policy override groups) */
export enum EnforcementState {
  /** Check is enforcing and affects the asset score */
  Enforcing = "ENFORCING",
  /** Check is in preview mode and does not affect the asset score */
  Preview = "PREVIEW",
}

/** Entitlement information for a product */
export type Entitlement = {
  __typename: "Entitlement";
  /** The description of the entitlement */
  description: Scalars["String"]["output"];
  /** The key identifier for the entitlement */
  key: Scalars["String"]["output"];
  /** The name of the entitlement */
  name: Scalars["String"]["output"];
  /** The units for the entitlement */
  units: Scalars["String"]["output"];
  /** The value of the entitlement */
  value: Scalars["Int"]["output"];
};

/** Information about the entity, eg. asset or space */
export type Entity =
  | EntityInfoAsset
  | EntityInfoOrganization
  | EntityInfoPlatform
  | EntityInfoSpace
  | EntityInfoUnknown
  | EntityInfoWorkspace;

/** Asset Information */
export type EntityInfoAsset = {
  __typename: "EntityInfoAsset";
  /**
   * Finding statistics (total and open findings) for the asset, derived from
   * the findings/all aggregate score. Null when the asset has no aggregate
   * score yet (e.g. it has not been scored).
   */
  findingStats?: Maybe<AssetFindingStats>;
  /** Asset icon */
  icon?: Maybe<Icon_Ids>;
  /** Asset id */
  id: Scalars["String"]["output"];
  /** Most recent time the asset score was updated (RFC3339) */
  lastScoreUpdateTime: Scalars["String"]["output"];
  /**
   * Last updated timestamp
   * Deprecated: Use lastScoreUpdateTime instead.
   * @deprecated Use lastScoreUpdateTime instead
   */
  lastUpdated: Scalars["String"]["output"];
  /** Asset mrn */
  mrn: Scalars["String"]["output"];
  /** Asset name */
  name: Scalars["String"]["output"];
  /** Asset platform */
  platform?: Maybe<Platform>;
  /** Asset tags */
  tags?: Maybe<Array<Maybe<Tag>>>;
};

/** Organization information */
export type EntityInfoOrganization = {
  __typename: "EntityInfoOrganization";
  /** Contacts assigned to this organization */
  contacts?: Maybe<Array<ResourceContact>>;
  /** Organization id */
  id: Scalars["String"]["output"];
  /** Member statistics for this organization */
  memberStats?: Maybe<MemberStats>;
  /** Organization mrn */
  mrn: Scalars["String"]["output"];
  /** Organization name */
  name: Scalars["String"]["output"];
};

/** Platform Info */
export type EntityInfoPlatform = {
  __typename: "EntityInfoPlatform";
  /** id */
  id: Scalars["String"]["output"];
  /** mrn */
  mrn: Scalars["String"]["output"];
  /** name */
  name: Scalars["String"]["output"];
};

/** Space Information */
export type EntityInfoSpace = {
  __typename: "EntityInfoSpace";
  /** Contacts assigned to this space */
  contacts?: Maybe<Array<ResourceContact>>;
  /** Space id */
  id: Scalars["String"]["output"];
  /** Member statistics for this space */
  memberStats?: Maybe<MemberStats>;
  /** Space mrn */
  mrn: Scalars["String"]["output"];
  /** Space name */
  name: Scalars["String"]["output"];
  /** Space settings */
  settings?: Maybe<SpaceSettings>;
};

/** Entity Info Unknown */
export type EntityInfoUnknown = {
  __typename: "EntityInfoUnknown";
  /** mrn */
  mrn: Scalars["String"]["output"];
};

/** Workspace  Information */
export type EntityInfoWorkspace = {
  __typename: "EntityInfoWorkspace";
  /** Contacts assigned to this workspace */
  contacts?: Maybe<Array<ResourceContact>>;
  /** Workspace id */
  id: Scalars["String"]["output"];
  /** Workspace mrn */
  mrn: Scalars["String"]["output"];
  /** Workspace name */
  name: Scalars["String"]["output"];
};

/** eol assets configuration input */
export type EolAssetsConfiguration = {
  __typename: "EolAssetsConfiguration";
  /** Whether to enable EOL assets analysis */
  enable: Scalars["Boolean"]["output"];
  /** How many months in advance should EOL be applied as risk factor */
  monthsInAdvance: Scalars["Int"]["output"];
};

/** eol assets configuration input */
export type EolAssetsConfigurationInput = {
  /** Whether to enable EOL assets analysis */
  enable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** How many months in advance should EOL be applied as risk factor */
  monthsInAdvance?: InputMaybe<Scalars["Int"]["input"]>;
};

/** EPSS configuration - adjusts risk based on the EPSS percentile of the vulnerability */
export type EpssConfiguration = {
  __typename: "EpssConfiguration";
  /** Whether to factor EPSS into the exploitability score */
  enabled: Scalars["Boolean"]["output"];
  /** Weight of the EPSS component */
  weight: Scalars["Float"]["output"];
};

/** EPSS configuration input */
export type EpssConfigurationInput = {
  /** Whether to factor EPSS into the exploitability score */
  enabled: Scalars["Boolean"]["input"];
  /** Weight of the EPSS component */
  weight: Scalars["Float"]["input"];
};

/** EPSS (Exploit Prediction Scoring System) score for CVEs */
export type EpssScore = {
  __typename: "EpssScore";
  /** Percentile [0.0, 1.0] */
  percentile: Scalars["Float"]["output"];
  /** Normalized percentile [0.0, 100.0] */
  percentileNormalized: Scalars["Float"]["output"];
  /** Probability [0.0, 1.0] */
  probability: Scalars["Float"]["output"];
  /** Normalized probability [0.0, 100.0] */
  probabilityNormalized: Scalars["Float"]["output"];
};

/** Error */
export type Error = {
  /** Code */
  code: Scalars["String"]["output"];
  /** Message */
  message: Scalars["String"]["output"];
};

/** EvaluatedConfiguration contains more details about the configuration of the integration, specific to the k8s integration */
export type EvaluatedConfiguration = {
  __typename: "EvaluatedConfiguration";
  /** Whether the configuration is applied */
  applied?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether the configuration is configured */
  configured?: Maybe<Scalars["Boolean"]["output"]>;
  /** The message */
  msg?: Maybe<Scalars["String"]["output"]>;
  /** The message status */
  msgStatus?: Maybe<IntegrationMessageStatus>;
  /** The operator message */
  operatorMsg?: Maybe<Scalars["String"]["output"]>;
  /** The operator message status */
  operatorMsgStatus?: Maybe<IntegrationMessageStatus>;
  /** The option */
  option?: Maybe<Scalars["String"]["output"]>;
};

/** Evidence data */
export type Evidence = {
  __typename: "Evidence";
  /**
   * Source's confidence in this evidence: LOW, MEDIUM, or HIGH. Null when the
   * source did not report a confidence.
   */
  confidence?: Maybe<Scalars["String"]["output"]>;
  /**
   * Evidence details (union type). May be null when the source reports only
   * attack context (tactic/technique/confidence) without a structured payload.
   */
  details?: Maybe<EvidenceDetails>;
  /** MRN of the finding this evidence belongs to (a VEX or FEX finding). */
  findingMrn: Scalars["String"]["output"];
  /** ID */
  id: Scalars["String"]["output"];
  /** Source the evidence is coming from: cnspec, MS Defender, ... */
  source: Scalars["String"]["output"];
  /**
   * MITRE ATT&CK tactic associated with this evidence, if the source reports one
   * (e.g. "Reconnaissance").
   */
  tactic?: Maybe<Scalars["String"]["output"]>;
  /**
   * MITRE ATT&CK technique associated with this evidence, if the source reports
   * one (e.g. "Banner Grabbing").
   */
  technique?: Maybe<Scalars["String"]["output"]>;
  /**
   * VEX MRN this evidence is for
   * @deprecated Use findingMrn instead.
   */
  vexMrn: Scalars["String"]["output"];
};

/** Network connection / open-port evidence (nmap, nessus, nuclei, ...). */
export type EvidenceConnection = {
  __typename: "EvidenceConnection";
  /** Destination (target) address */
  destinationAddress?: Maybe<Scalars["String"]["output"]>;
  /** Destination (target) port */
  destinationPort?: Maybe<Scalars["Int"]["output"]>;
  /** Transport protocol, e.g. TCP, UDP, ICMP */
  protocol?: Maybe<Scalars["String"]["output"]>;
  /** Source address */
  sourceAddress?: Maybe<Scalars["String"]["output"]>;
  /** Source port */
  sourcePort?: Maybe<Scalars["Int"]["output"]>;
};

/** Container evidence. */
export type EvidenceContainer = {
  __typename: "EvidenceContainer";
  /** Image digest */
  digest?: Maybe<Scalars["String"]["output"]>;
  /** Container image URI */
  imageUri?: Maybe<Scalars["String"]["output"]>;
  /** Container name */
  name?: Maybe<Scalars["String"]["output"]>;
};

/** Evidence details union type */
export type EvidenceDetails =
  | EvidenceConnection
  | EvidenceContainer
  | EvidenceFile
  | EvidenceHttpRequest
  | EvidenceKubernetes
  | EvidenceProcess
  | EvidenceRegistryKey
  | EvidenceUser;

/** File evidence — a file or source-code location backing the finding. */
export type EvidenceFile = {
  __typename: "EvidenceFile";
  /** Line number the finding was matched at (source-code findings) */
  line?: Maybe<Scalars["Int"]["output"]>;
  /** MD5 hash of the file */
  md5?: Maybe<Scalars["String"]["output"]>;
  /** Absolute or repo-relative file path */
  path: Scalars["String"]["output"];
  /** SHA-256 hash of the file */
  sha256?: Maybe<Scalars["String"]["output"]>;
  /** File size in bytes */
  size?: Maybe<Scalars["Int"]["output"]>;
  /** Matched code/content snippet at that location */
  snippet?: Maybe<Scalars["String"]["output"]>;
};

/** HTTP request/response evidence from a DAST scanner (nikto, ZAP, Burp, ...). */
export type EvidenceHttpRequest = {
  __typename: "EvidenceHttpRequest";
  /** Attack payload */
  attack?: Maybe<Scalars["String"]["output"]>;
  /** Matched evidence string in the response */
  evidence?: Maybe<Scalars["String"]["output"]>;
  /** HTTP method */
  method?: Maybe<Scalars["String"]["output"]>;
  /** Vulnerable parameter */
  param?: Maybe<Scalars["String"]["output"]>;
  /** Raw HTTP request */
  request?: Maybe<Scalars["String"]["output"]>;
  /** Raw HTTP response */
  response?: Maybe<Scalars["String"]["output"]>;
  /** Request URL */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Evidence query input */
export type EvidenceInput = {
  /** Filter evidence */
  filter?: InputMaybe<EvidenceInputFilter>;
  /** Finding MRN (CVE, advisory or package) */
  findingMrn: Scalars["String"]["input"];
  /** Scope MRN (spaceMRN or assetMRN) */
  scopeMrn: Scalars["String"]["input"];
};

/** Evidence query filter input */
export type EvidenceInputFilter = {
  /** Filter evidence by ecosystem */
  ecosystem?: InputMaybe<Scalars["String"]["input"]>;
};

/** A Kubernetes node referenced by evidence. */
export type EvidenceK8sNode = {
  __typename: "EvidenceK8sNode";
  /** Node id */
  id?: Maybe<Scalars["String"]["output"]>;
  /** Node name */
  name?: Maybe<Scalars["String"]["output"]>;
};

/** A Kubernetes pod referenced by evidence. */
export type EvidenceK8sPod = {
  __typename: "EvidenceK8sPod";
  /** Pod name */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Pod namespace */
  namespace?: Maybe<Scalars["String"]["output"]>;
};

/** Kubernetes evidence — the pods and nodes involved. */
export type EvidenceKubernetes = {
  __typename: "EvidenceKubernetes";
  /** Nodes involved */
  nodes: Array<EvidenceK8sNode>;
  /** Pods involved */
  pods: Array<EvidenceK8sPod>;
};

/** Process evidence (EDR sources such as CrowdStrike / Defender, cloud posture). */
export type EvidenceProcess = {
  __typename: "EvidenceProcess";
  /** Path to the process binary */
  binaryPath?: Maybe<Scalars["String"]["output"]>;
  /** Process command line */
  cmdline?: Maybe<Scalars["String"]["output"]>;
  /** Process ID */
  pid?: Maybe<Scalars["Int"]["output"]>;
  /** Path to the executed script, if any */
  scriptPath?: Maybe<Scalars["String"]["output"]>;
};

/** Registry key evidence */
export type EvidenceRegistryKey = {
  __typename: "EvidenceRegistryKey";
  /** Value data */
  data: Scalars["String"]["output"];
  /** Value name (empty for default value) */
  name: Scalars["String"]["output"];
  /** Registry key path (e.g., HKLM\\SOFTWARE\\Microsoft\\Windows) */
  path: Scalars["String"]["output"];
};

/** Evidence query response */
export type EvidenceResponse = {
  __typename: "EvidenceResponse";
  /** List of evidence items */
  items: Array<Evidence>;
  /** Total count of evidence items */
  totalCount: Scalars["Int"]["output"];
};

/** User evidence (e.g. the account involved in a finding). */
export type EvidenceUser = {
  __typename: "EvidenceUser";
  /** User id */
  id?: Maybe<Scalars["String"]["output"]>;
  /** User name */
  name?: Maybe<Scalars["String"]["output"]>;
};

/** Exception filter suggestion */
export type ExceptionFilterSuggestion = FilterSuggestion & {
  __typename: "ExceptionFilterSuggestion";
  /** The human-readable label to display */
  label: Scalars["String"]["output"];
  /** The value to use when setting the filter */
  value: ExceptionFilterSuggestionValue;
};

/** Union of possible exception filter suggestion value type */
export type ExceptionFilterSuggestionValue =
  | ExceptionReviewStatusValue
  | ExceptionStatusValue
  | ExceptionTypeValue
  | StringValue
  | TimeRangeValue;

/** Exception filter type */
export enum ExceptionFilterType {
  /** Filter by who approved the exception */
  ApprovedBy = "APPROVED_BY",
  /** Filter by who created the exception */
  CreatedBy = "CREATED_BY",
  /** Filter by exception status (NEW, APPROVED, REJECTED, EXPIRED etc.) */
  ExceptionStatus = "EXCEPTION_STATUS",
  /** Filter by exception type (CVE, ADVISORY, SECURITY, COMPLIANCE) */
  ExceptionType = "EXCEPTION_TYPE",
  /** Filter by expiration status (EXPIRING, NOT_EXPIRING) */
  Expiring = "EXPIRING",
  /**
   * Filter by exception review status (NOT_REVIEWED, APPROVED, REJECTED, etc.)
   * @deprecated Use EXCEPTION_STATUS instead
   */
  Status = "STATUS",
}

/** Exception group */
export type ExceptionGroup = {
  __typename: "ExceptionGroup";
  /**
   * How this exception should be handled
   * Accept risk, disable, or enable findings
   */
  action: ExceptionMutationAction;
  /** The user who created the exception. For legacy exceptions this is empty */
  author?: Maybe<Author>;
  /** RFC 3339 timestamp */
  createdAt: Scalars["String"]["output"];
  /** RFC 3339 timestamp. Date of deletion. */
  deletedAt?: Maybe<Scalars["String"]["output"]>;
  /** The user who deleted the exception group. */
  deletedBy?: Maybe<Author>;
  /**
   * Exception ID. This uniquely identifies the exception on a per owner basis, meaning that
   * no two exceptions can have the same identifier if they are in the same owner scope.
   */
  exceptionId: Scalars["String"]["output"];
  /** The members of this exception group. Can contain a mix of different finding types. */
  exceptions: Array<ExceptionMember>;
  /** List of extensions */
  extensions?: Maybe<Array<ExceptionGroupExtension>>;
  /** The id to use to reference the exception */
  id: Scalars["String"]["output"];
  /** Whether the exception group is currently active (based on space settings and exception state). */
  isActive: Scalars["Boolean"]["output"];
  /** The justification for the exception group */
  justification?: Maybe<Scalars["String"]["output"]>;
  /**
   * RFC 3339 timestamp
   * can be empty, when the exception wasn't reviewed yet
   */
  modifiedAt?: Maybe<Scalars["String"]["output"]>;
  /** The MRN of the exception */
  mrn: Scalars["String"]["output"];
  /**
   * The review status for the exception group
   * @deprecated Replaced by status
   */
  reviewStatus: ReviewStatus;
  /**
   * The user who rejected/approved the exception
   * The email is expected
   * This can be empty, when the exception wasn't reviewed yet
   */
  reviewer?: Maybe<Author>;
  /**
   * Scope entity information. Returns entities representing the scope hierarchy
   * (e.g., asset + space + organization for asset-scoped exceptions).
   */
  scopeInfos?: Maybe<Array<Entity>>;
  /** The scope of the exception. Can be a space or an asset mrn */
  scopeMrn: Scalars["String"]["output"];
  /** The status of the exception group */
  status: ExceptionStatus;
  /** Title of the exception group */
  title: Scalars["String"]["output"];
  /** Valid until date. The string is a valid RFC 3339 date. */
  validUntil?: Maybe<Scalars["String"]["output"]>;
};

/** Exception group edge */
export type ExceptionGroupEdge = {
  __typename: "ExceptionGroupEdge";
  /** Cursor */
  cursor: Scalars["String"]["output"];
  /** Node */
  node: ExceptionGroup;
};

/** Exception group extension. */
export type ExceptionGroupExtension = {
  __typename: "ExceptionGroupExtension";
  /** Author of the extension. */
  author: Author;
  /** Create date. The string is a valid RFC 3339 date. */
  createDate: Scalars["String"]["output"];
  /** Justification of the extension. */
  justification?: Maybe<Scalars["String"]["output"]>;
  /**
   * Review date. Optional date representing the time the exception got reviewed.
   * The string is a valid RFC 3339 date.
   */
  reviewDate?: Maybe<Scalars["String"]["output"]>;
  /** Reviewer of the extension. */
  reviewer?: Maybe<Author>;
  /** Status of the extension. */
  status: ExceptionGroupExtensionStatus;
  /** Valid until date. The string is a valid RFC 3339 date. */
  validUntil: Scalars["String"]["output"];
};

/** The review status for an exception group extension. */
export enum ExceptionGroupExtensionStatus {
  Approved = "APPROVED",
  NotReviewed = "NOT_REVIEWED",
  Rejected = "REJECTED",
}

/** The input to get a list of exception groups */
export type ExceptionGroupsInput = {
  /** The action of the exception groups. Empty list means all. */
  actions?: InputMaybe<Array<ExceptionMutationAction>>;
  /** The mrn to filter on. It can be a query, control, policy or a framework */
  mrn?: InputMaybe<Scalars["String"]["input"]>;
  /** The mrn of the space/asset */
  scopeMrn: Scalars["String"]["input"];
  /**
   * Deprecated. Use the types field
   * @deprecated Use the types field
   */
  type?: InputMaybe<ExceptionType>;
  /** The types of the exceptions */
  types?: InputMaybe<Array<ExceptionType>>;
};

/** A union of all the possible members of an exception group */
export type ExceptionMember =
  | AssetAdvisoryException
  | AssetCheckException
  | AssetCveException
  | AssetFexException
  | ControlsEdge
  | SpaceAdvisoryException
  | SpaceCheckException
  | SpaceCveException
  | SpaceFexException;

/** The action to apply to the exception */
export enum ExceptionMutationAction {
  Disable = "DISABLE",
  Enable = "ENABLE",
  FalsePositive = "FALSE_POSITIVE",
  /** Applicable only for compliance */
  OutOfScope = "OUT_OF_SCOPE",
  RiskAccepted = "RISK_ACCEPTED",
  /** @deprecated Do not use this action, it is preserved for backwards compatibility. Use RISK_ACCEPTED instead. */
  Snooze = "SNOOZE",
  Workaround = "WORKAROUND",
}

/** The input to apply an exception */
export type ExceptionMutationInput = {
  /**
   * How this exception should be handled
   * Accept risk, disable, or enable findings
   * "enable" will delete the supplied control mrn from any exception
   */
  action: ExceptionMutationAction;
  /** List of advisory mrns that are excepted. Applies only for advisory exceptions */
  advisoryMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Apply the exception to the CVEs that are part of the advisories. Applies only for advisory exceptions */
  applyToCves?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** List of control mrns that are excepted. Applies only for compliance exceptions */
  controlMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of cve mrns that are excepted. Applies only for cve exceptions */
  cveMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * DEPRECATED. WILL BE REMOVED ONCE THE UI IS OUT
   * List of mrns that are excepted
   * @deprecated Use controlMrns and controlMrns
   */
  exceptionMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of finding exchange mrns that are excepted. Applies only for FEX exceptions */
  fexMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The justification for the exception */
  justification?: InputMaybe<Scalars["String"]["input"]>;
  /** List of query mrns that are excepted. Applies only for security exceptions */
  queryMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * DEPRECATED. WILL BE REMOVED ONCE THE UI IS OUT
   * the resource to apply the exception to, e.g. a framework
   * @deprecated Use only scopeMrn
   */
  resourceMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** The scope of the exception. Can be a space or an asset mrn */
  scopeMrn: Scalars["String"]["input"];
  /**
   * RFC3339 timestamp
   * The date, from which on the exception is no longer valid.
   * Only applies to action IGNORE, empty is interpreted as forever
   */
  validUntil?: InputMaybe<Scalars["String"]["input"]>;
};

/** The type of review action */
export enum ExceptionReviewAction {
  Approved = "APPROVED",
  Rejected = "REJECTED",
}

/** The input to apply a review to an exception */
export type ExceptionReviewInput = {
  /** The review action to be applied */
  action: ExceptionReviewAction;
  /**
   * The id of the exception to review.
   * @deprecated Use exceptionMrn
   */
  exceptionId?: InputMaybe<Scalars["String"]["input"]>;
  /** The exception MRN. Can be used instead of scopeMrn + exceptionId. */
  exceptionMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The scope of the exception. Can be a space or an asset mrn.
   * @deprecated Use exceptionMrn
   */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Exception review status suggestion value */
export type ExceptionReviewStatusValue = {
  __typename: "ExceptionReviewStatusValue";
  /** The exception status value */
  value: ReviewStatus;
};

/** The status for an exception group */
export enum ExceptionStatus {
  Approved = "APPROVED",
  Expired = "EXPIRED",
  NeedsExtension = "NEEDS_EXTENSION",
  New = "NEW",
  Rejected = "REJECTED",
  Removed = "REMOVED",
}

/** Exception status suggestion value */
export type ExceptionStatusValue = {
  __typename: "ExceptionStatusValue";
  /** The exception status value */
  value: ExceptionStatus;
};

/** The type of the exception */
export enum ExceptionType {
  Advisory = "ADVISORY",
  Compliance = "COMPLIANCE",
  Cve = "CVE",
  Fex = "FEX",
  Security = "SECURITY",
}

/** Exception type suggestion value */
export type ExceptionTypeValue = {
  __typename: "ExceptionTypeValue";
  /** The exception type value */
  value: ExceptionType;
};

/** Exceptions configuration configuration */
export type ExceptionsConfiguration = {
  __typename: "ExceptionsConfiguration";
  /**
   * Whether to allow creation of
   * exception groups with indefinite valid until.
   */
  allowIndefiniteValidUntil?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a user can approve their own exception requests. */
  allowSelfApproval?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether to enable require approval for exceptions */
  requireApproval?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Exceptions configuration configuration input */
export type ExceptionsConfigurationInput = {
  /**
   * Whether to allow creation of
   * exception groups with indefinite valid until.
   */
  allowIndefiniteValidUntil?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a user can approve their own exception requests. */
  allowSelfApproval?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether to enable require approval for exceptions */
  requireApproval?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Exceptions delete input */
export type ExceptionsDeleteInput = {
  /**
   * Exception ids. Could be for asset or space scoped exceptions.
   * @deprecated Use exceptionMrns
   */
  exceptionIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Exception MRNs. Can be used instead of spaceMrn + exceptionIds. */
  exceptionMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Space MRN for the exceptions. NOTE: exception ids must be for the same scope.
   * @deprecated Use exceptionMrns
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** The upstream source that reported or published an exploit. */
export enum ExploitSource {
  /** CISA Known Exploited Vulnerabilities catalog. */
  CisaKev = "CISA_KEV",
  /** First EPSS (Exploit Prediction Scoring System). */
  Epss = "EPSS",
  /** Metasploit framework exploit modules. */
  Metasploit = "METASPLOIT",
  /**
   * Any other upstream source not represented by a dedicated enum member.
   * Returned in responses when the source is unmapped. Not valid as a filter
   * input.
   */
  Other = "OTHER",
}

/** Exploitability configuration */
export type ExploitabilityConfiguration = {
  __typename: "ExploitabilityConfiguration";
  /** Whether to enable exploitability analysis */
  enabled: Scalars["Boolean"]["output"];
  /** EPSS configuration */
  epss: EpssConfiguration;
  /** KEV configuration */
  kev: KevConfiguration;
  /** Weight of the exploitability category */
  weight: Scalars["Float"]["output"];
};

/** Exploitability configuration input */
export type ExploitabilityConfigurationInput = {
  /** Whether to enable exploitability analysis */
  enabled: Scalars["Boolean"]["input"];
  /** EPSS configuration */
  epss: EpssConfigurationInput;
  /** KEV configuration */
  kev: KevConfigurationInput;
  /** Weight of the exploitability category */
  weight: Scalars["Float"]["input"];
};

/** Exploitability details for risk category scoring */
export type ExploitabilityDetails = {
  __typename: "ExploitabilityDetails";
  /** The EPSS score of the vulnerability finding. Note this is the EPSS score at the time of the scoring. */
  epss?: Maybe<EpssScore>;
  /** Whether the exploitability impact was overridden by a label */
  overridedByLabel: Scalars["Boolean"]["output"];
};

/** Input for filtering checks in the export report */
export type ExportReportFilterChecks = {
  /** Enable filtering checks */
  enable: Scalars["Boolean"]["input"];
};

/** Input for filtering inventory in the export report */
export type ExportReportFilterInventoryInput = {
  /** Enable filtering data */
  data: Scalars["Boolean"]["input"];
  /** Enable filtering inventory */
  enable: Scalars["Boolean"]["input"];
};

/** Input for filtering packages in the export report */
export type ExportReportFilterPackages = {
  /** Enable filtering packages */
  enable: Scalars["Boolean"]["input"];
};

/** Input for filtering vulnerabilities in the export report */
export type ExportReportFilterVulnerabilitiesInput = {
  /** Enable filtering vulnerabilities */
  enable: Scalars["Boolean"]["input"];
};

/** Input options for the export report */
export type ExportReportOptionsInput = {
  /** Filter checks */
  checks?: InputMaybe<ExportReportFilterChecks>;
  /** Filter inventory */
  inventory?: InputMaybe<ExportReportFilterInventoryInput>;
  /** Filter packages */
  packages?: InputMaybe<ExportReportFilterPackages>;
  /** Filter vulnerabilities */
  vulnerabilities?: InputMaybe<ExportReportFilterVulnerabilitiesInput>;
};

/** Input for exporting a workflow as YAML. */
export type ExportWorkflowYamlInput = {
  /** MRN of the workflow to export. */
  mrn: Scalars["ID"]["input"];
};

/** Result of exporting a workflow as YAML. */
export type ExportWorkflowYamlPayload = {
  __typename: "ExportWorkflowYamlPayload";
  /** The exported YAML content. */
  yaml: Scalars["String"]["output"];
};

/** Exception extend input. */
export type ExtendExceptionInput = {
  /**
   * Id of the exception.
   * @deprecated Use exceptionMrn
   */
  exceptionId?: InputMaybe<Scalars["String"]["input"]>;
  /** The exception MRN. Can be used instead of spaceMrn + exceptionId. */
  exceptionMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** The justification for the exception */
  justification?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Space MRN of the exception.
   * @deprecated Use exceptionMrn
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * RFC3339 timestamp
   * The date, from which on the exception is no longer valid.
   */
  validUntil: Scalars["String"]["input"];
};

/** The input to apply a review to an exception extension */
export type ExtendExceptionReviewInput = {
  /** The review action to be applied */
  action: ExceptionReviewAction;
  /**
   * The id of the exception.
   * @deprecated Use exceptionMrn
   */
  exceptionId?: InputMaybe<Scalars["String"]["input"]>;
  /** The exception MRN. Can be used instead of spaceMrn + exceptionId. */
  exceptionMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The space of the exception.
   * @deprecated Use exceptionMrn
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * The presentational detail of a FEX finding, resolved from its stored document in
 * a single read: all evidence mechanisms, external references, and remediation.
 */
export type FexFindingDetails = {
  __typename: "FexFindingDetails";
  /**
   * Evidence items backing the finding (code locations, network connections/ports,
   * HTTP requests, processes, ...).
   */
  evidences: Array<Evidence>;
  /** External references (e.g. CWE entries) with a title + URL. */
  references: Array<Reference>;
  /** Remediation guidance carried by the finding. */
  remediations: Array<FexRemediation>;
};

/** Remediation guidance carried by a FEX finding (faithful to the source document). */
export type FexRemediation = {
  __typename: "FexRemediation";
  /** Remediation category, e.g. Fix, Workaround, NoneAvailable, NoFixPlanned. */
  category: Scalars["String"]["output"];
  /** Detailed remediation instructions. */
  details?: Maybe<Scalars["String"]["output"]>;
  /** Short remediation summary. */
  summary?: Maybe<Scalars["String"]["output"]>;
  /** Optional URL with more information about the fix. */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** A field within a resource */
export type Field = {
  __typename: "Field";
  /** The description of the field */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The name of the field */
  name: Scalars["String"]["output"];
  /** Whether the field has nested content */
  nestedContent: Scalars["Boolean"]["output"];
  /** The number of elements in the field */
  numElements: Scalars["Int"]["output"];
  /** The path of the field */
  path?: Maybe<Scalars["String"]["output"]>;
  /** The type of the field */
  type: Scalars["String"]["output"];
  /** The timestamp when the field was last updated (RFC 3339) */
  updatedAt: Scalars["String"]["output"];
  /** The value of the field */
  value?: Maybe<Scalars["Any"]["output"]>;
};

/** Base interface for all filter suggestions */
export type FilterSuggestion = {
  /** The human-readable label to display */
  label?: Maybe<Scalars["String"]["output"]>;
};

/** Union of possible filter suggestion value types */
export type FilterSuggestionValue =
  | IntValue
  | StringValue
  | TimestampFilterValue;

/** Finding */
export type Finding =
  | AdvisoryFinding
  | CheckFinding
  | CveFinding
  | GenericFinding
  | PackageFinding;

/** The action state for a finding. */
export enum FindingActionState {
  Detected = "DETECTED",
  /**
   * Finding can be remediated through the Microsoft Intune integration —
   * its affected Windows software is in the product mapping catalog with
   * a winget_id. Ranked above SCRIPT/SECURITY_PIPELINE in the
   * action-dimension picker. The UI gates the "Send to Intune" action on
   * `state.action == INTUNE_REMEDIATION`. The flag does NOT consider
   * whether the space has an Intune integration configured or whether
   * the asset is enrolled in Intune — those are checked separately.
   */
  IntuneRemediation = "INTUNE_REMEDIATION",
  NoFixedVersion = "NO_FIXED_VERSION",
  Script = "SCRIPT",
  SecurityPipeline = "SECURITY_PIPELINE",
  Unknown = "UNKNOWN",
}

/** The age state for a finding - whether it is new or not. */
export enum FindingAgeState {
  New = "NEW",
  None = "NONE",
}

/** Cases filters for finding */
export type FindingCasesFilter = {
  /** Filter cases by their status. */
  statuses?: InputMaybe<Array<CaseStatus>>;
};

/** Input options for the finding of the document */
export type FindingDocumentOptionsInput = {
  /** The MRN of the finding to generate the report for */
  findingMrn: Scalars["String"]["input"];
  /** The MRN of the scope to generate the report for */
  scopeMrn: Scalars["String"]["input"];
};

/** The enforcement state for a finding - whether the check is enforcing or in preview mode. */
export enum FindingEnforcementState {
  Enforcing = "ENFORCING",
  Preview = "PREVIEW",
}

/** Finding exception */
export type FindingException = {
  __typename: "FindingException";
  /** Action */
  action: ExceptionMutationAction;
  /** Responsible party for creating the exception */
  author?: Maybe<Author>;
  /** Exception creation date */
  createdAt: Scalars["String"]["output"];
  /**
   * Exception ID. Uniquely identifies the exception within its owner scope.
   * Format: exception-{n}
   */
  exceptionId: Scalars["String"]["output"];
  /**
   * Exception MRN. Uniquely identifies the exception globally.
   * Format: //policy.api.mondoo.app/spaces/{spaceId}/exceptions/{n}
   */
  exceptionMrn: Scalars["String"]["output"];
  /** ID */
  id: Scalars["String"]["output"];
  /** Justification */
  justification: Scalars["String"]["output"];
  /**
   * Review status
   * @deprecated replaced by status
   */
  reviewStatus: ReviewStatus;
  /** Scope of the exception (e.g. space, asset) */
  scope: Scalars["String"]["output"];
  /** Exception status */
  status: ExceptionStatus;
};

/** The exception state for a finding - is the finding part of an active exception. */
export enum FindingExceptionState {
  Disabled = "DISABLED",
  Exceptions = "EXCEPTIONS",
  FalsePositive = "FALSE_POSITIVE",
  None = "NONE",
  RiskAccepted = "RISK_ACCEPTED",
  Workaround = "WORKAROUND",
}

/** Finding filter type */
export enum FindingFilterType {
  /**
   * Filter by detection source (cnspec vs third-party scanners — SentinelOne,
   * MS Defender, CrowdStrike Falcon, etc.). Values are VexSourceName strings.
   */
  DetectionSource = "DETECTION_SOURCE",
  /** Filter by policy MRN */
  PolicyMrn = "POLICY_MRN",
  /** Filter by rating (CRITICAL, HIGH, MEDIUM, LOW, etc.) */
  Rating = "RATING",
  /** Filter by risk factor */
  RiskFactors = "RISK_FACTORS",
  /** Filter vulnerabilities by software MRN */
  SoftwareMrn = "SOFTWARE_MRN",
  /** State filter */
  State = "STATE",
  /** Filter by finding types (CHECK, CVE, ADVISORY, PACKAGE, etc.) */
  Types = "TYPES",
}

/** The overall state for a finding. */
export enum FindingOverallState {
  Detected = "DETECTED",
  Disabled = "DISABLED",
  Exceptions = "EXCEPTIONS",
  FalsePositive = "FALSE_POSITIVE",
  Fixed = "FIXED",
  FixAvailable = "FIX_AVAILABLE",
  InProgress = "IN_PROGRESS",
  New = "NEW",
  Regressed = "REGRESSED",
  RiskAccepted = "RISK_ACCEPTED",
  Ticketed = "TICKETED",
  Workaround = "WORKAROUND",
}

/** The score state for a finding. */
export enum FindingScoreState {
  Failed = "FAILED",
  Fixed = "FIXED",
  Regressed = "REGRESSED",
}

/** The security pipeline state for a finding. */
export enum FindingSecurityPipelineState {
  InProgress = "IN_PROGRESS",
  None = "NONE",
}

/** Finding space risk delta */
export type FindingSpaceRiskDelta = {
  __typename: "FindingSpaceRiskDelta";
  /** Space risk delta for this finding alone */
  delta: Scalars["Float"]["output"];
  /** Effort required by the user to remediate the finding, measured in minutes */
  effort: Scalars["Int"]["output"];
  /** Manual effort calculations (expected effort without Mondoo help) */
  manualEffort: ManualEffort;
};

/** The state of a finding. */
export type FindingState = {
  __typename: "FindingState";
  /** The action state for a finding - what kind of remediation can Mondoo offer. */
  action: FindingActionState;
  /** The age state for a finding - whether it is new or not. */
  age: FindingAgeState;
  /** The enforcement state for a finding - whether the check is enforcing or in preview. */
  enforcement: FindingEnforcementState;
  /** The exception state for a finding - is the finding part of an active exception. */
  exception: FindingExceptionState;
  /**
   * The overall state of the finding. This state is calculated by resolving all
   * other states into a single one.
   */
  overall: FindingOverallState;
  /** The score state for a finding (e.g. failed, fixed, etc.) */
  score: FindingScoreState;
  /**
   * The security pipeline state for a finding - is the finding included in an in
   * progress security pipeline.
   */
  securityPipeline: FindingSecurityPipelineState;
  /** The ticket state for a finding - is the finding included in an open ticket. */
  ticket: FindingTicketState;
};

/** Count of findings for a specific state */
export type FindingStateCount = {
  __typename: "FindingStateCount";
  /** The count of findings in this state */
  count: Scalars["Int"]["output"];
  /** The state name (e.g., FAILED, REGRESSED, DETECTED, TICKETED) */
  state: Scalars["String"]["output"];
};

/** Distribution of finding states for an aggregate score */
export type FindingStateCounts = {
  __typename: "FindingStateCounts";
  /** Action state counts (DETECTED, NO_FIXED_VERSION, SCRIPT, SECURITY_PIPELINE) */
  actionCounts: Array<FindingStateCount>;
  /** Exception state counts (WORKAROUND, FALSE_POSITIVE, RISK_ACCEPTED, DISABLED, NONE) */
  exceptionCounts: Array<FindingStateCount>;
  /** Score state counts (REGRESSED, FAILED, FIXED) */
  scoreCounts: Array<FindingStateCount>;
  /** Ticket state counts (TICKETED, NONE) */
  ticketCounts: Array<FindingStateCount>;
};

/**
 * Input type for filtering findings by state. Each field is optional.
 * Only set the fields you want to filter on.
 */
export type FindingStateFilter = {
  action?: InputMaybe<FindingActionState>;
  age?: InputMaybe<FindingAgeState>;
  enforcement?: InputMaybe<FindingEnforcementState>;
  exception?: InputMaybe<FindingExceptionState>;
  overall?: InputMaybe<FindingOverallState>;
  score?: InputMaybe<FindingScoreState>;
  securityPipeline?: InputMaybe<FindingSecurityPipelineState>;
  ticket?: InputMaybe<FindingTicketState>;
};

/**
 * Finding-level statistics tracking individual pass/fail results.
 * For checks: total = number of assets. For policies: total = assets x checks.
 * Exceptions count as passing. Disabled findings are excluded.
 */
export type FindingStats = {
  __typename: "FindingStats";
  /** Number of excepted findings (included in pass count) */
  exceptions: Scalars["Int"]["output"];
  /** Number of failing findings */
  fail: Scalars["Int"]["output"];
  /** Number of passing findings (includes exceptions) */
  pass: Scalars["Int"]["output"];
  /** Total number of findings */
  total: Scalars["Int"]["output"];
};

/** The ticket state for a finding - is the finding included in an open ticket. */
export enum FindingTicketState {
  None = "NONE",
  Ticketed = "TICKETED",
}

/** Finding type */
export enum FindingType {
  Advisory = "ADVISORY",
  AppPackage = "APP_PACKAGE",
  Check = "CHECK",
  Cve = "CVE",
  Informational = "INFORMATIONAL",
  Malware = "MALWARE",
  OsPackage = "OS_PACKAGE",
  Package = "PACKAGE",
  Secret = "SECRET",
  Security = "SECURITY",
  Threat = "THREAT",
}

/** Finding type suggestion value */
export type FindingTypeValue = {
  __typename: "FindingTypeValue";
  /** The finding type value */
  value: FindingType;
};

/** Findings connection */
export type FindingsConnection = {
  __typename: "FindingsConnection";
  /** Edges */
  edges?: Maybe<Array<FindingsEdge>>;
  /** Total count with filters applied */
  filteredTotalCount: Scalars["Int"]["output"];
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Findings edge */
export type FindingsEdge = {
  __typename: "FindingsEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<Finding>;
};

/** Findings filters */
export type FindingsFilter = {
  /**
   * Control how findings on CI/CD assets are returned:
   * - EXCLUDE (default): only non-CI/CD assets
   * - INCLUDE: both CI/CD and non-CI/CD assets
   * - CICD_ONLY: only CI/CD assets
   * Takes precedence over the deprecated `includeCicd`.
   */
  cicd?: InputMaybe<CicdAssetFilter>;
  /**
   * Filter by the detection source(s) that reported the finding. Values are the
   * VexSourceName strings stored on the score (e.g., "VEX_SOURCE_CNSPEC",
   * "VEX_SOURCE_SENTINEL_ONE", "VEX_SOURCE_MSDEFENDER"). Findings match when
   * their source set overlaps with this list (OR semantics). An empty or null
   * list means no source filtering. Use this to filter findings reported by
   * Mondoo vs third-party scanners (SentinelOne, Microsoft Defender,
   * CrowdStrike Falcon, etc.).
   */
  detectionSources?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Whether to include findings for CI/CD assets in the results.
   * Deprecated: use `cicd` instead — `cicd` supports a CICD_ONLY mode that
   * this boolean cannot express. When `cicd` is set, `includeCicd` is ignored.
   * @deprecated Use `cicd` instead, which supports a CICD_ONLY mode.
   */
  includeCicd?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter the result by mrn */
  mrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Filters applicable only for package findings */
  package?: InputMaybe<FindingsPackagesFilter>;
  /** Filter the result by a policy mrn. Applicable only for checks */
  policyMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Optional query terms. Will return only vulnerabilities containing
   * the term in their MRN
   */
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filter by score rating */
  rating?: InputMaybe<Array<ScoreRating>>;
  /** Filter by risk factor MRNs */
  riskFactors?: InputMaybe<RiskFactorFilter>;
  /**
   * Filter vulnerabilities by findingMrn of a versioned software package
   * e.g., finding versions of bash 5.0.1 by searching for //.../software/.../name/bash/5.0.1
   */
  softwareFindingMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by state */
  state?: InputMaybe<ScoreStateFilter>;
  /**
   * Filter by finding states. Each entry can specify any combination of state fields.
   * Multiple entries are ORed. Returns findings matching any of the provided state filters.
   */
  states?: InputMaybe<Array<FindingStateFilter>>;
  /** Filter by finding type */
  types?: InputMaybe<Array<FindingType>>;
  /** Filter by vulnerability mrn */
  vulnerabilityMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Findings filter suggestion */
export type FindingsFilterSuggestion = FilterSuggestion & {
  __typename: "FindingsFilterSuggestion";
  /** The human-readable label to display */
  label: Scalars["String"]["output"];
  /** The value to use when setting the filter */
  value: FindingsFilterSuggestionValue;
};

/** Union of possible findings filter suggestion value type */
export type FindingsFilterSuggestionValue =
  | FindingTypeValue
  | ScoreRatingValue
  | ScoreStateFilterValue
  | StringValue;

/** Findings order */
export type FindingsOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: FindingsOrderField;
};

/** Findings order field */
export enum FindingsOrderField {
  /**  ID  */
  AssetName = "ASSET_NAME",
  BaseScore = "BASE_SCORE",
  CvssScore = "CVSS_SCORE",
  FirstFound = "FIRST_FOUND",
  LastUpdated = "LAST_UPDATED",
  Mrn = "MRN",
  PackageName = "PACKAGE_NAME",
  RiskFactors = "RISK_FACTORS",
  RiskScore = "RISK_SCORE",
  RiskValue = "RISK_VALUE",
}

/** Findings packages filter */
export type FindingsPackagesFilter = {
  /** Package version */
  packageVersion?: InputMaybe<Scalars["String"]["input"]>;
};

/** Findings response */
export type FindingsResponse =
  | FindingsConnection
  | NotFoundError
  | RequestError;

/** Findings SLA */
export type FindingsSla = {
  __typename: "FindingsSLA";
  /** The number of days before a warning is issued */
  daysBeforeWarning: Scalars["Int"]["output"];
  /** The target number of days to resolve a finding */
  daysToResolve: Scalars["Int"]["output"];
  /** The rating to which this SLA applies */
  rating: ScoreRating;
};

/** Findings webhook post request */
export type FindingsWebhookPostRequest = {
  /** Finding MRN */
  findingMrn: Scalars["String"]["input"];
  /** Scope MRN */
  scopeMrn: Scalars["String"]["input"];
  /** Finding type */
  type: FindingType;
};

/** Findings webhook post response */
export type FindingsWebhookPostResponse = {
  __typename: "FindingsWebhookPostResponse";
  /** Status */
  status?: Maybe<Scalars["String"]["output"]>;
};

/** Fleet asset link info */
export type FleetAssetLinkInfo = {
  __typename: "FleetAssetLinkInfo";
  /** Asset link type */
  assetLinkType: AssetLinkType;
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["output"];
};

/** Fork framework input */
export type ForkFrameworkInput = {
  /**
   * Whether to include all evidence in the bundle. By default, only
   * evidence for activated policies is returned.
   */
  allEvidence?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The MRN of the framework to fork */
  mrn: Scalars["String"]["input"];
  /** Space MRN */
  spaceMrn: Scalars["String"]["input"];
};

/** Output format */
export enum FormatType {
  Csv = "CSV",
  Json = "JSON",
}

/** Framework */
export type Framework = {
  __typename: "Framework";
  /** framework authors */
  authors?: Maybe<Array<Author>>;
  /** framework description */
  description: Scalars["String"]["output"];
  /** framework MRN */
  mrn: Scalars["String"]["output"];
  /** aggregate score */
  score?: Maybe<AggregateScore>;
  /** framework state */
  state: ComplianceFrameworkState;
  /** tags */
  tags?: Maybe<Array<Tag>>;
  /** framework title */
  title: Scalars["String"]["output"];
  /** created at */
  uploadedAt: Scalars["String"]["output"];
};

/** Framework bundle */
export type FrameworkBundle = {
  __typename: "FrameworkBundle";
  /** YAML */
  yaml: Scalars["String"]["output"];
};

/** Input options for framework document */
export type FrameworkDocumentOptionsInput = {
  /** The MRN of the framework */
  frameworkMRN: Scalars["String"]["input"];
};

/** Framework edge */
export type FrameworkEdge = {
  __typename: "FrameworkEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node: Framework;
};

/** Frameworks connection */
export type FrameworksConnection = {
  __typename: "FrameworksConnection";
  /** Edges */
  edges?: Maybe<Array<FrameworkEdge>>;
};

/** Garbage collect assets configuration */
export type GarbageCollectAssetsConfiguration = {
  __typename: "GarbageCollectAssetsConfiguration";
  /** After how many days to garbage collect */
  afterDays: Scalars["Int"]["output"];
  /** Whether to enable garbage collection */
  enable: Scalars["Boolean"]["output"];
};

/** Garbage collect assets configuration input */
export type GarbageCollectAssetsConfigurationInput = {
  /** After how many days to garbage collect */
  afterDays?: InputMaybe<Scalars["Int"]["input"]>;
  /** Whether to enable garbage collection */
  enable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** GCP configuration options */
export type GcpConfigurationOptions = {
  __typename: "GcpConfigurationOptions";
  /** Whether to discover all resources */
  discoverAll?: Maybe<Scalars["Boolean"]["output"]>;
  /** Selected discovery targets. Empty means use the default discovery behavior. */
  discoveryTargets?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The GCP organization ID */
  organizationId?: Maybe<Scalars["String"]["output"]>;
  /** The GCP project ID */
  projectId?: Maybe<Scalars["String"]["output"]>;
  /** WIF audience URL for GCP workload identity federation */
  wifAudience?: Maybe<Scalars["String"]["output"]>;
  /**
   * The Mondoo OIDC issuer URL (STS endpoint) the customer's WIF provider must
   * trust. Deployment-wide; populated at read time so the console can build the
   * one-click gcloud setup script. Empty when not configured.
   */
  wifIssuerUrl?: Maybe<Scalars["String"]["output"]>;
  /** Optional GCP service account email for WIF service account impersonation */
  wifServiceAccountEmail?: Maybe<Scalars["String"]["output"]>;
  /**
   * Ready-to-run gcloud script that provisions the WIF pool, provider, and
   * read-only service account for this integration. Empty when the integration is
   * not WIF or the deployment has no configured issuer.
   */
  wifSetupScript?: Maybe<Scalars["String"]["output"]>;
  /** Computed OIDC subject for WIF token requests */
  wifSubject?: Maybe<Scalars["String"]["output"]>;
};

/** GCP integration input */
export type GcpConfigurationOptionsInput = {
  /** Whether to discover all resources */
  discoverAll?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Selected discovery targets. Empty means use the default discovery behavior. */
  discoveryTargets?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The GCP organization ID */
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The GCP project ID */
  projectId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * GCP project number (digits). When set, the server derives the WIF audience and
   * scanner service-account email; the client need not send wifAudience or
   * wifServiceAccountEmail.
   */
  projectNumber?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * note: this is the content of the service account JSON file.
   * Optional when using WIF (workload identity federation) credentials.
   */
  serviceAccount?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * WIF audience URL for GCP workload identity federation.
   * Required together with wifServiceAccountEmail for WIF authentication.
   * e.g., https://iam.googleapis.com/projects/PROJECT_NUMBER/locations/global/workloadIdentityPools/POOL_ID/providers/PROVIDER_ID
   */
  wifAudience?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * GCP service account email for WIF service account impersonation.
   * Required together with wifAudience for WIF authentication.
   */
  wifServiceAccountEmail?: InputMaybe<Scalars["String"]["input"]>;
};

/** GCP serverless configuration options */
export type GcpServerlessConfigurationOptions = {
  __typename: "GcpServerlessConfigurationOptions";
  /**
   * True when this integration is configured to land scanned assets in
   * spaces across multiple orgs.
   */
  crossOrg?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The Terraform module version the deployed serverless stack is currently
   * running. Reported by the scanner on check-in; read-only from the API.
   * Null when the scanner has not reported a version yet.
   */
  currentModuleVersion?: Maybe<Scalars["String"]["output"]>;
  /**
   * The GCS path (bucket path) holding the GCP serverless Terraform
   * deployment module; the UI constructs the full Terraform module source
   * from it. Read-only, filled from the server configuration like
   * orchestratorImage. Null when the server has no path configured.
   */
  gcsSource?: Maybe<Scalars["String"]["output"]>;
  /** The GCP project ID where the serverless scanner is deployed */
  hostProjectId?: Maybe<Scalars["String"]["output"]>;
  /**
   * The latest Terraform module version available. Read-only. Compare against
   * currentModuleVersion to tell whether the deployed stack is out of date. Null
   * when it is not available.
   */
  latestModuleVersion?: Maybe<Scalars["String"]["output"]>;
  /**
   * The container image of the GCP serverless scanner's orchestrator that
   * this platform version expects. Read-only, filled from the server
   * configuration: pass it to the customer's Terraform deployment. Null when
   * the server has no image configured.
   */
  orchestratorImage?: Maybe<Scalars["String"]["output"]>;
  /** The GCP region where the serverless scanner is deployed */
  region?: Maybe<Scalars["String"]["output"]>;
  /** Scan options that control what the deployed scanner scans. */
  scanConfiguration?: Maybe<GcpServerlessScanConfiguration>;
  /** The GCP scope to scan (a folder ID or an organization ID) */
  scope?: Maybe<Scalars["String"]["output"]>;
  /**
   * The numeric unique ID of the GCP service account the deployed scanner runs
   * as, used as the WIF binding subject.
   */
  serviceAccountId?: Maybe<Scalars["String"]["output"]>;
  /**
   * A customer-provided service account identity to run this integration with,
   * instead of the platform automatically creating one (bring-your-own-identity).
   * Stored and returned verbatim.
   */
  suppliedSaIdentity?: Maybe<Scalars["String"]["output"]>;
  /**
   * True when the deployed scanner authenticates back to the platform via GCP
   * Workload Identity Federation.
   */
  useWif?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * MRN of the captain WIF auth binding created for this integration.
   * Server-managed. Empty when useWif is false.
   */
  wifAuthBindingMrn?: Maybe<Scalars["String"]["output"]>;
  /**
   * Base64-encoded WIF external account configuration for the deployed scanner.
   * Read-only, fetched from the server: pass it to the customer's Terraform
   * deployment. Empty when useWif is false.
   */
  wifConfig?: Maybe<Scalars["String"]["output"]>;
};

/**
 * GCP serverless integration input. The customer deploys a serverless scanner
 * into their own host project; the platform stores only what to scan and where
 * the scanner is deployed (auth is configured separately).
 */
export type GcpServerlessConfigurationOptionsInput = {
  /**
   * Allow this integration to land scanned assets in spaces across multiple
   * orgs. Immutable after creation. Only valid on organization-scoped GCP
   * serverless integrations and only on private-instance deployments
   * (rejected on prod and prod-eu environments).
   */
  crossOrg?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The GCP project ID where the serverless scanner is deployed. */
  hostProjectId: Scalars["String"]["input"];
  /** The GCP region where the serverless scanner is deployed. */
  region: Scalars["String"]["input"];
  /** Scan options that control what the deployed scanner scans. */
  scanConfiguration?: InputMaybe<GcpServerlessScanConfigurationInput>;
  /**
   * The GCP scope to scan. Accepts either a folder ID or an organization ID.
   * Optional: when omitted, the scanner falls back to its default scope.
   */
  scope?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The numeric unique ID of the GCP service account the deployed scanner runs
   * as. Used as the WIF binding subject (matched against the Google OIDC token's
   * sub claim). Required when useWif is true; immutable after creation.
   */
  serviceAccountId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * A customer-provided service account identity to run this integration with,
   * instead of the platform automatically creating one (bring-your-own-identity).
   * Stored and returned verbatim.
   */
  suppliedSaIdentity?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * When true, the deployed scanner authenticates back to the platform via GCP
   * Workload Identity Federation: a WIF auth binding is minted at create time.
   * Immutable after creation.
   */
  useWif?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Scan options for a GCP serverless integration. */
export type GcpServerlessScanConfiguration = {
  __typename: "GcpServerlessScanConfiguration";
  /**
   * Exclude filter: projects whose tags match at least one of these key-value
   * pairs are skipped. A value of "*" matches any value for that tag key
   */
  excludedTagsFilter?: Maybe<Array<KeyValue>>;
  /**
   * When true, the GCP project tags are propagated to all assets discovered
   * under the project.
   */
  propagateProjectTags?: Maybe<Scalars["Boolean"]["output"]>;
  /** How often (in hours) the deployed scanner runs a scan. */
  scanScheduleHours?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Include filter: only projects whose tags match at least one of these
   * key-value pairs are scanned. A value of "*" matches any value for that tag key
   */
  tagsFilter?: Maybe<Array<KeyValue>>;
};

/** Scan options for a GCP serverless integration. */
export type GcpServerlessScanConfigurationInput = {
  /**
   * Exclude filter: projects whose tags match at least one of these key-value
   * pairs are skipped, even if they match the include filter. A value of "*"
   * matches any value for that tag key.
   */
  excludedTagsFilter?: InputMaybe<Array<KeyValueInput>>;
  /**
   * When true, the GCP project tags are propagated to all assets discovered
   * under the project.
   */
  propagateProjectTags?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** How often (in hours) the deployed scanner runs a scan. */
  scanScheduleHours?: InputMaybe<Scalars["Int"]["input"]>;
  /**
   * Include filter: when not empty, only projects whose tags match at least one
   * of these key-value pairs are scanned. A value of "*" matches any value for
   * that tag key.
   */
  tagsFilter?: InputMaybe<Array<KeyValueInput>>;
};

/** GCS configuration options */
export type GcsBucketConfigurationOptions = {
  __typename: "GcsBucketConfigurationOptions";
  /** The GCS bucket name */
  bucket: Scalars["String"]["output"];
  /** The output format for the GCS bucket */
  output: BucketOutputType;
  /** WIF audience URL for GCP workload identity federation */
  wifAudience?: Maybe<Scalars["String"]["output"]>;
  /** Optional GCP service account email for WIF service account impersonation */
  wifServiceAccountEmail?: Maybe<Scalars["String"]["output"]>;
  /**
   * Ready-to-run gcloud script that provisions the shared WIF pool/provider and a
   * write-scoped mondoo-export service account for this export. Empty when the
   * integration is not WIF or the deployment has no configured issuer.
   */
  wifSetupScript?: Maybe<Scalars["String"]["output"]>;
  /** Computed OIDC subject for WIF token requests */
  wifSubject?: Maybe<Scalars["String"]["output"]>;
};

/** GCS Bucket integration input */
export type GcsBucketConfigurationOptionsInput = {
  /** The GCS bucket name */
  bucket: Scalars["String"]["input"];
  /** The output format for the GCS bucket */
  output: BucketOutputType;
  /**
   * GCP project id. With projectNumber, the server derives the WIF audience and
   * the mondoo-export service-account email; the client need not send wifAudience
   * or wifServiceAccountEmail.
   */
  projectId?: InputMaybe<Scalars["String"]["input"]>;
  /** GCP project number (digits). See projectId. */
  projectNumber?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * note: this is the content of the service account JSON file.
   * Optional when using WIF (workload identity federation) credentials.
   */
  serviceAccount?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * WIF audience URL for GCP workload identity federation.
   * e.g., https://iam.googleapis.com/projects/PROJECT_NUMBER/locations/global/workloadIdentityPools/POOL_ID/providers/PROVIDER_ID
   */
  wifAudience?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional GCP service account email for WIF service account impersonation */
  wifServiceAccountEmail?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for generating a new API token */
export type GenerateApiTokenInput = {
  /** The description of the API token */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The name of the API token */
  name: Scalars["String"]["input"];
  /** The roles to assign to the API token */
  roles?: InputMaybe<Array<RoleInput>>;
  /** The MRN of the scope for the API token */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The MRN of the space (deprecated, use scopeMrn)
   * @deprecated Use scopeMrn
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Response when generating a new API token */
export type GenerateApiTokenResponse = {
  __typename: "GenerateAPITokenResponse";
  /** RFC 3339 timestamp when the token was created */
  createdAt: Scalars["String"]["output"];
  /** The user who created the token */
  createdBy: Scalars["String"]["output"];
  /** The description of the API token */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The MRN of the API token */
  mrn: Scalars["String"]["output"];
  /** The name of the API token */
  name: Scalars["String"]["output"];
  /** The MRN of the scope for the API token */
  scopeMrn: Scalars["String"]["output"];
  /**
   * The MRN of the space (deprecated, use scopeMrn)
   * @deprecated Use scopeMrn
   */
  spaceMrn?: Maybe<Scalars["String"]["output"]>;
  /** The generated API token */
  token: Scalars["String"]["output"];
};

/** Input when generating a document */
export type GenerateDocumentInput = {
  /** Options for generating an advisory report document */
  advisoryReportOptions?: InputMaybe<AdvisoryDocumentOptionsInput>;
  /** Options for generating an asset report document */
  assetReportOptions?: InputMaybe<AssetDocumentOptionsInput>;
  /** Whether to capture debug information */
  captureDebug?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Options for generating a control document */
  controlOptions?: InputMaybe<ControlDocumentOptionsInput>;
  /** Options for generating an export document */
  exportOptions?: InputMaybe<ExportReportOptionsInput>;
  /** Options for generating a finding report document */
  findingReportOptions?: InputMaybe<FindingDocumentOptionsInput>;
  /** The format of the document */
  format: DocumentFormat;
  /** Options for generating a framework document */
  frameworkOptions?: InputMaybe<FrameworkDocumentOptionsInput>;
  /** The name of the document to generate */
  name: Scalars["String"]["input"];
  /** Options for generating a policy aggregate scores export */
  policyAggregateScoresExportOptions?: InputMaybe<PolicyAggregateScoresExportOptionsInput>;
  /** The MRN of the space */
  scopeMRN: Scalars["String"]["input"];
  /** Options for generating a scope report document */
  scopeReportOptions?: InputMaybe<ScopeDocumentOptionsInput>;
  /**
   * The MRN of the resource for which the document is being generated
   * @deprecated Use controlOptions and frameworkOptions
   */
  targetMRN?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of the document */
  type: DocumentType;
  /** Options for generating a vulnerability report document */
  vulnerabilityReportOptions?: InputMaybe<VulnerabilityDocumentOptionsInput>;
};

/** Response when generating a document */
export type GenerateDocumentPayload = {
  __typename: "GenerateDocumentPayload";
  /** The MRN of the document */
  mrn: Scalars["String"]["output"];
};

/** Input type for GeneratePolicyInput */
export type GeneratePolicyInput = {
  /** Prompt for policy generation */
  prompts: Array<Scalars["String"]["input"]>;
  /** Providers to use for policy generation */
  providers: Array<Scalars["String"]["input"]>;
  /** Scope mrn */
  scopeMrn: Scalars["String"]["input"];
  /** Indicates if the generated policy should be stored in the space */
  storeInSpace?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Payload for generating a policy */
export type GeneratePolicyPayload = {
  __typename: "GeneratePolicyPayload";
  /** Raw policy content */
  content?: Maybe<Scalars["String"]["output"]>;
  /** The mrn's of stored policies */
  policyMrns?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Generated policy content as Yaml */
  yaml: Scalars["String"]["output"];
};

/** Generic finding object */
export type GenericFinding = {
  __typename: "GenericFinding";
  /** Asset information */
  asset?: Maybe<EntityInfoAsset>;
  /** Rating for the base score (CRITICAL/HIGH/MEDIUM/LOW/NONE) */
  baseRating: ScoreRating;
  /** Inverted value for the base score */
  baseValue: Scalars["Int"]["output"];
  /** Description */
  description: Scalars["String"]["output"];
  /**
   * Sources which detected this finding (e.g. the Attack Surface scanner). Mirrors
   * the detectionSources exposed on CVE/advisory findings.
   *
   * Remediation is deliberately NOT a field here: GenericFinding is a member of
   * the Finding union returned by findings lists, and its remediation lives in the
   * finding's FEX document in the bucket, so selecting it per-row would be an N+1
   * of document reads. Fetch remediation for a single finding via the
   * remediationForScope query (scopeMrn = asset MRN, vulnId = finding MRN), which
   * reads the document lazily — one finding at a time.
   */
  detectionSources: Array<VulnerabilityScoreSource>;
  /** Exceptions for this finding, if any */
  exceptions?: Maybe<Array<Maybe<FindingException>>>;
  /** Timestamp, when the finding was first detected (RFC3339) */
  firstDetectedAt: Scalars["String"]["output"];
  /** Icon identifier for the score */
  iconId: Icon_Ids;
  /** Finding ID */
  id: Scalars["String"]["output"];
  /** Most recent time the score was updated (RFC3339) */
  lastScoreUpdateTime: Scalars["String"]["output"];
  /**
   * Timestamp, when the finding was last updated (RFC3339)
   * Deprecated: Use lastScoreUpdateTime instead.
   * @deprecated Use lastScoreUpdateTime instead
   */
  lastUpdated: Scalars["String"]["output"];
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Rating */
  rating: ScoreRating;
  /** Risk factors for this finding, if any */
  riskFactors?: Maybe<Array<Maybe<RiskFactorStats>>>;
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore: Scalars["Int"]["output"];
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue: Scalars["Int"]["output"];
  /** State */
  state: ScoreState;
  /** All states for the finding */
  states: FindingState;
  /** Finding tags */
  tags?: Maybe<Array<Tag>>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Inputs used to get the delete command for a client integration (used for K8s) */
export type GetClientIntegrationDeleteCommandInput = {
  mrn: Scalars["String"]["input"];
  type: ClientIntegrationType;
};

/** Response from requesting the delete command for a client integration (used for K8s) */
export type GetClientIntegrationDeleteCommandPayload = {
  __typename: "GetClientIntegrationDeleteCommandPayload";
  /** The delete command message */
  message: Scalars["String"]["output"];
};

/** Input provided when fetching a token for a client integration */
export type GetClientIntegrationTokenInput = {
  longLivedToken?: InputMaybe<Scalars["Boolean"]["input"]>;
  mrn: Scalars["String"]["input"];
};

/** Response when fetching token for client integration */
export type GetClientIntegrationTokenPayload = {
  __typename: "GetClientIntegrationTokenPayload";
  /** The token for the client integration */
  token: Scalars["String"]["output"];
};

/** Payload returned by getRoles query */
export type GetRolesPayload = {
  __typename: "GetRolesPayload";
  /** The email of the identity if available */
  identityEmail?: Maybe<Scalars["String"]["output"]>;
  /** The MRN of the identity */
  identityMrn: Scalars["String"]["output"];
  /** Array of role MRNs assigned to the identity at this scope */
  roles: Array<Scalars["String"]["output"]>;
  /** The MRN of the scope/resource */
  scopeMrn: Scalars["String"]["output"];
};

/** Response when getting a WIF auth binding */
export type GetWifAuthBindingPayload = {
  __typename: "GetWIFAuthBindingPayload";
  /** The WIF auth binding */
  binding?: Maybe<WifAuthBinding>;
  /** The external auth configuration */
  config?: Maybe<WifExternalAuthConfig>;
};

/** Enum representing the different types of Git pipelines */
export enum GitPipelineKind {
  Branch = "BRANCH",
  PullRequest = "PULL_REQUEST",
  Tag = "TAG",
  Unknown = "UNKNOWN",
}

/** How a GitHub scanning integration authenticates with GitHub. */
export enum GithubAuthMethod {
  /** The read-only Mondoo Scanner GitHub App. */
  App = "APP",
  /** Personal access token supplied by the user. */
  Token = "TOKEN",
}

/** Github configuration options */
export type GithubConfigurationOptions = {
  __typename: "GithubConfigurationOptions";
  /**
   * A link that when opened in the browser will trigger the GitHub App
   * installation. When the installation is completed, the user is redirected back
   * and the installation is coupled with this integration. Only present while the
   * GitHub App is configured and no installation is coupled yet. The link only
   * works for GitHub accounts that do not have the app installed yet — for
   * accounts that already have it, the app must be uninstalled on GitHub first
   * and then installed again through this link.
   */
  appInstallationLink?: Maybe<Scalars["String"]["output"]>;
  /** Whether to discover Kubernetes manifests */
  discoverK8sManifests: Scalars["Boolean"]["output"];
  /** Whether to discover Terraform files */
  discoverTerraform: Scalars["Boolean"]["output"];
  /** Whether code scanning (SAST) is enabled */
  enableCodeScan: Scalars["Boolean"]["output"];
  /** Whether secrets detection is enabled */
  enableSecretScan: Scalars["Boolean"]["output"];
  /** Whether dependency vulnerability scanning is enabled */
  enableVulnScan: Scalars["Boolean"]["output"];
  /** The GitHub Enterprise Server URL */
  enterpriseUrl?: Maybe<Scalars["String"]["output"]>;
  /**
   * The GitHub App installation id coupled with this integration. When set, the
   * integration authenticates via the Mondoo GitHub App instead of a token. It is
   * set by the app's post-install callback, not through this API.
   */
  installationId?: Maybe<Scalars["String"]["output"]>;
  /** The GitHub organization name */
  organization?: Maybe<Scalars["String"]["output"]>;
  /** The GitHub repository owner */
  owner?: Maybe<Scalars["String"]["output"]>;
  /** A list of allowed repository glob patterns */
  reposAllowList?: Maybe<Array<Scalars["String"]["output"]>>;
  /** A list of denied repository glob patterns */
  reposDenyList?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The GitHub repository name */
  repository?: Maybe<Scalars["String"]["output"]>;
  /** The type of GitHub integration */
  type: GithubIntegrationType;
};

/** Github integration input */
export type GithubConfigurationOptionsInput = {
  /**
   * How the integration authenticates with GitHub. APP selects the read-only
   * Mondoo Scanner GitHub App install flow: the integration is created without
   * a token or scope, and completing the installation on GitHub couples it and
   * determines the scan scope. Defaults to TOKEN. Only available for
   * organization-level integrations.
   */
  authMethod?: InputMaybe<GithubAuthMethod>;
  /** Discover k8s manifests in the repositories */
  discoverK8sManifests?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Discover Terraform files in the repositories */
  discoverTerraform?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Enable code scanning (SAST) of the repository source. */
  enableCodeScan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Enable secrets detection across the repository. */
  enableSecretScan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Enable dependency vulnerability scanning (SCA) of the repository. */
  enableVulnScan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Github Enterprise Server URL */
  enterpriseUrl?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Organization. If specified, the integration will scan the
   * complete organization.
   */
  organization?: InputMaybe<Scalars["String"]["input"]>;
  /** Repository owner. Must be provided in combination with repository. */
  owner?: InputMaybe<Scalars["String"]["input"]>;
  /** Scan only the repositories matching these glob patterns. Only applicable when type is ORG. */
  reposAllowList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Scan all repositories except the ones matching these glob patterns. Only applicable when type is ORG. */
  reposDenyList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Repository name. Must be provided in combination with owner. */
  repository?: InputMaybe<Scalars["String"]["input"]>;
  /** The GitHub API token (optional) */
  token?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of GitHub integration */
  type: GithubIntegrationType;
};

/** Github integration type */
export enum GithubIntegrationType {
  Org = "ORG",
  Repo = "REPO",
  /**
   * A personal GitHub account. Set by the GitHub App install flow when the app
   * was installed on a user account rather than an organization; not selectable
   * in setup forms.
   */
  User = "USER",
}

/** A GitHub job */
export type GithubJob = {
  __typename: "GithubJob";
  /** The action performed in the job */
  action: Scalars["String"]["output"];
  /** The actor who triggered the job */
  actor: Scalars["String"]["output"];
  /** The base ref for the job */
  baseRef: Scalars["String"]["output"];
  /** The event name that triggered the job */
  eventName: Scalars["String"]["output"];
  /** The event path for the job */
  eventPath: Scalars["String"]["output"];
  /**
   * The grade of the job (deprecated)
   * @deprecated Grades will be removed in future. Use score.
   */
  grade: Grade;
  /** The head ref for the job */
  headRef: Scalars["String"]["output"];
  /** The ID of the job */
  id: Scalars["String"]["output"];
  /** The job name */
  job: Scalars["String"]["output"];
  /** The MRN of the job */
  mrn: Scalars["String"]["output"];
  /** The name of the job */
  name: Scalars["String"]["output"];
  /** The kind of pipeline */
  pipelineKind: GitPipelineKind;
  /** The ref for the job */
  ref: Scalars["String"]["output"];
  /** The repository where the job ran */
  repository: Scalars["String"]["output"];
  /** The run ID for the job */
  runId: Scalars["String"]["output"];
  /** The run number for the job */
  runNumber: Scalars["String"]["output"];
  /** The score of the job */
  score: Score;
  /** The server URL for the job */
  serverUrl: Scalars["String"]["output"];
  /** The commit SHA for the job */
  sha: Scalars["String"]["output"];
  /** The target of the job */
  target?: Maybe<Scalars["String"]["output"]>;
  /** The time the job was last updated */
  updatedAt: Scalars["String"]["output"];
  /** The workflow associated with the job */
  workflow: Scalars["String"]["output"];
  /** The workspace for the job */
  workspace: Scalars["String"]["output"];
};

/** Github repository */
export type GithubRepository = {
  __typename: "GithubRepository";
  /** The full repository name (e.g. "mondoohq/cnspec") */
  fullName: Scalars["String"]["output"];
  /** A link to the repository on Github */
  link: Scalars["String"]["output"];
  /**
   * The space to which the repository is linked. If the repo is not linked yet,
   * this value is not set.
   */
  spaceMrn?: Maybe<Scalars["String"]["output"]>;
};

/** Github ticket configuration input */
export type GithubTicketConfigInput = {
  /** The Github repo owner */
  owner: Scalars["String"]["input"];
  /** The Github repo */
  repo: Scalars["String"]["input"];
};

/** Github ticketing configuration options */
export type GithubTicketingConfigurationOptions = {
  __typename: "GithubTicketingConfigurationOptions";
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["output"];
  /** Whether to auto-create tickets */
  autoCreateTickets: Scalars["Boolean"]["output"];
  /** The default repository name */
  defaultRepoName?: Maybe<Scalars["String"]["output"]>;
  /** The default repository owner */
  defaultRepoOwner?: Maybe<Scalars["String"]["output"]>;
  /** The GitHub Enterprise URL */
  enterpriseUrl?: Maybe<Scalars["String"]["output"]>;
};

/** Github ticketing integration input */
export type GithubTicketingConfigurationOptionsInput = {
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["input"];
  /** Whether to auto-create tickets */
  autoCreateTickets: Scalars["Boolean"]["input"];
  /** The default repository name */
  defaultRepoName?: InputMaybe<Scalars["String"]["input"]>;
  /** The default repository owner */
  defaultRepoOwner?: InputMaybe<Scalars["String"]["input"]>;
  /** The GitHub Enterprise URL */
  enterpriseUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** The GitHub API token */
  token: Scalars["String"]["input"];
};

/** GitlabConfigurationOptions defines the scan configuration for the gitlab integration */
export type GitlabConfigurationOptions = {
  __typename: "GitlabConfigurationOptions";
  /** The GitLab base URL */
  baseUrl: Scalars["String"]["output"];
  /** Whether to discover groups */
  discoverGroups?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether to discover Kubernetes manifests */
  discoverK8sManifests: Scalars["Boolean"]["output"];
  /** Whether to discover projects */
  discoverProjects?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether to discover Terraform files */
  discoverTerraform?: Maybe<Scalars["Boolean"]["output"]>;
  /** The GitLab group name */
  group: Scalars["String"]["output"];
  /** The type of GitLab integration */
  type: GitlabIntegrationType;
};

/** Gitlab integration input */
export type GitlabConfigurationOptionsInput = {
  baseUrl?: InputMaybe<Scalars["String"]["input"]>;
  discoverGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
  discoverK8sManifests?: InputMaybe<Scalars["Boolean"]["input"]>;
  discoverProjects?: InputMaybe<Scalars["Boolean"]["input"]>;
  discoverTerraform?: InputMaybe<Scalars["Boolean"]["input"]>;
  group?: InputMaybe<Scalars["String"]["input"]>;
  token?: InputMaybe<Scalars["String"]["input"]>;
  type: GitlabIntegrationType;
};

/** Gitlab integration type */
export enum GitlabIntegrationType {
  /** denotes a limiting group for the integration, we do not want to discover groups not related to this group */
  Group = "GROUP",
  /** nothing is limited, discover all groups */
  None = "NONE",
}

/** A GitLab CI/CD job */
export type GitlabJob = {
  __typename: "GitlabJob";
  /** The commit description */
  commitDescription: Scalars["String"]["output"];
  /** The commit reference name */
  commitRefName: Scalars["String"]["output"];
  /** The commit SHA */
  commitSha: Scalars["String"]["output"];
  /** The default branch */
  defaultBranch: Scalars["String"]["output"];
  /**
   * The grade of the job (deprecated)
   * @deprecated Grades will be removed in future. Use score.
   */
  grade: Grade;
  /** The ID of the job */
  id: Scalars["String"]["output"];
  /** The ID of the job */
  jobId: Scalars["String"]["output"];
  /** The name of the job */
  jobName: Scalars["String"]["output"];
  /** The stage of the job */
  jobStage: Scalars["String"]["output"];
  /** The URL of the job */
  jobURL: Scalars["String"]["output"];
  /** The merge request ID */
  mergeRequestId: Scalars["String"]["output"];
  /** The merge request project URL */
  mergeRequestProjectUrl: Scalars["String"]["output"];
  /** The MRN of the job */
  mrn: Scalars["String"]["output"];
  /** The name of the job */
  name: Scalars["String"]["output"];
  /** The kind of pipeline */
  pipelineKind: GitPipelineKind;
  /** The URL of the pipeline */
  pipelineUrl: Scalars["String"]["output"];
  /** The ID of the project */
  projectId: Scalars["String"]["output"];
  /** The title of the project */
  projectTitle: Scalars["String"]["output"];
  /** The URL of the project */
  projectUrl: Scalars["String"]["output"];
  /** The score of the job */
  score: Score;
  /** The target of the job */
  target?: Maybe<Scalars["String"]["output"]>;
  /** The time the job was last updated */
  updatedAt: Scalars["String"]["output"];
  /** The user email */
  userEmail: Scalars["String"]["output"];
  /** The user ID */
  userId: Scalars["String"]["output"];
  /** The username */
  userName: Scalars["String"]["output"];
};

/** Gitlab ticket configuration input */
export type GitlabTicketConfigInput = {
  /** The Gitlab project */
  project: Scalars["String"]["input"];
};

/** Gitlab ticketing configuration options */
export type GitlabTicketingConfigurationOptions = {
  __typename: "GitlabTicketingConfigurationOptions";
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["output"];
  /** Whether to auto-create tickets */
  autoCreateTickets: Scalars["Boolean"]["output"];
  /** The GitLab base URL */
  baseUrl?: Maybe<Scalars["String"]["output"]>;
  /** The default GitLab project */
  defaultProject?: Maybe<Scalars["String"]["output"]>;
};

/** Gitlab ticketing integration input */
export type GitlabTicketingConfigurationOptionsInput = {
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["input"];
  /** Whether to auto-create tickets */
  autoCreateTickets: Scalars["Boolean"]["input"];
  /** The GitLab base URL */
  baseUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** The default GitLab project */
  defaultProject?: InputMaybe<Scalars["String"]["input"]>;
  /** The GitLab API token */
  token: Scalars["String"]["input"];
};

/** Google SCC export configuration options */
export type GoogleSccExportConfigurationOptions = {
  __typename: "GoogleSccExportConfigurationOptions";
  /** SCC source name for creating findings */
  sourceName: Scalars["String"]["output"];
  /** WIF audience URL for GCP workload identity federation */
  wifAudience?: Maybe<Scalars["String"]["output"]>;
  /** Optional GCP service account email for WIF service account impersonation */
  wifServiceAccountEmail?: Maybe<Scalars["String"]["output"]>;
  /**
   * One-click gcloud setup script; non-null only when the canonical Mondoo export
   * identity was derived from a project id + number.
   */
  wifSetupScript?: Maybe<Scalars["String"]["output"]>;
  /** Computed OIDC subject for WIF token requests */
  wifSubject?: Maybe<Scalars["String"]["output"]>;
};

/** Google SCC export integration input */
export type GoogleSccExportConfigurationOptionsInput = {
  /**
   * One-click WIF: GCP project id. With projectNumber, the server derives the
   * export service-account email and WIF audience and returns a setup script.
   */
  projectId?: InputMaybe<Scalars["String"]["input"]>;
  /** One-click WIF: GCP project number (used to build the WIF pool audience). */
  projectNumber?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Content of the GCP service account JSON file.
   * Optional when using WIF (workload identity federation) credentials.
   */
  serviceAccount?: InputMaybe<Scalars["String"]["input"]>;
  /** SCC source name to create findings under (e.g. organizations/123/sources/456) */
  sourceName: Scalars["String"]["input"];
  /** WIF audience URL for GCP workload identity federation. */
  wifAudience?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional GCP service account email for WIF service account impersonation */
  wifServiceAccountEmail?: InputMaybe<Scalars["String"]["input"]>;
};

/** Google SCC import configuration options */
export type GoogleSccImportConfigurationOptions = {
  __typename: "GoogleSccImportConfigurationOptions";
  /** Parent resource for listing findings */
  parent: Scalars["String"]["output"];
  /** WIF audience URL for GCP workload identity federation */
  wifAudience?: Maybe<Scalars["String"]["output"]>;
  /** Optional GCP service account email for WIF service account impersonation */
  wifServiceAccountEmail?: Maybe<Scalars["String"]["output"]>;
  /** Computed OIDC subject for WIF token requests */
  wifSubject?: Maybe<Scalars["String"]["output"]>;
};

/** Google SCC import integration input */
export type GoogleSccImportConfigurationOptionsInput = {
  /** Parent resource for listing findings (e.g. organizations/123/sources/-) */
  parent: Scalars["String"]["input"];
  /**
   * Content of the GCP service account JSON file.
   * Optional when using WIF (workload identity federation) credentials.
   */
  serviceAccount?: InputMaybe<Scalars["String"]["input"]>;
  /** WIF audience URL for GCP workload identity federation. */
  wifAudience?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional GCP service account email for WIF service account impersonation */
  wifServiceAccountEmail?: InputMaybe<Scalars["String"]["input"]>;
};

/** Google Workspace configuration options */
export type GoogleWorkspaceConfigurationOptions = {
  __typename: "GoogleWorkspaceConfigurationOptions";
  /** The Google Workspace customer ID */
  customerId: Scalars["String"]["output"];
  /** The impersonated user email */
  impersonatedUserEmail: Scalars["String"]["output"];
};

/** Google Workspace integration input */
export type GoogleWorkspaceConfigurationOptionsInput = {
  /** The Google Workspace customer ID */
  customerId: Scalars["String"]["input"];
  /** The impersonated user email */
  impersonatedUserEmail: Scalars["String"]["input"];
  /** note: this is the content of the service account JSON file */
  serviceAccount?: InputMaybe<Scalars["String"]["input"]>;
};

/** deprecated, use Score.grade instead */
export enum Grade {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  F = "F",
  U = "U",
}

/** Group filter */
export type GroupFilter = {
  /** Asset types */
  assetTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Group type */
  groupType: Scalars["String"]["input"];
};

/** Hetzner integration */
export type HetznerConfigurationOptions = {
  __typename: "HetznerConfigurationOptions";
  /**
   * The Hetzner API token. Always null in responses — the token is stored in
   * the vault and never echoed back; a non-null value here simply indicates the
   * token is configured.
   */
  token?: Maybe<Scalars["String"]["output"]>;
};

/** Hetzner integration input */
export type HetznerConfigurationOptionsInput = {
  /** Hetzner API token */
  token: Scalars["String"]["input"];
};

/** Host configuration options */
export type HostConfigurationOptions = {
  __typename: "HostConfigurationOptions";
  /** Whether to discover all subdomains */
  discoverSubdomains?: Maybe<Scalars["Boolean"]["output"]>;
  /** The host address */
  host: Scalars["String"]["output"];
  /** Whether to use HTTP */
  http?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether to use HTTPS */
  https?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Host integration input */
export type HostConfigurationOptionsInput = {
  /** Discover all subdomains for the given domain */
  discoverSubdomains?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The host address */
  host: Scalars["String"]["input"];
  /** Whether to use HTTP */
  http?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether to use HTTPS */
  https?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Hosted AWS integration configuration */
export type HostedAwsConfigurationOptions = {
  __typename: "HostedAwsConfigurationOptions";
  /** The access key ID for the hosted AWS integration */
  accessKeyId?: Maybe<Scalars["String"]["output"]>;
  /** Selected discovery targets. Empty means use the default discovery behavior. */
  discoveryTargets?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The role for the hosted AWS integration */
  role?: Maybe<Scalars["String"]["output"]>;
  /**
   * The Mondoo hosted-runner role ARN that the customer's cross-account role must
   * trust as Principal: AWS. Deployment-wide; populated at read time so the
   * console can build a CloudFormation quick-create link. Empty when the
   * deployment has no hosted-scan-runner configured.
   */
  runnerPrincipalArn?: Maybe<Scalars["String"]["output"]>;
  /** WIF audience configured in the AWS IAM OIDC identity provider */
  wifAudience?: Maybe<Scalars["String"]["output"]>;
  /**
   * The Mondoo OIDC issuer URL (STS endpoint) the customer's WIF OIDC provider
   * must point at. Deployment-wide; populated at read time so the console can
   * build a CloudFormation quick-create link. Empty when not configured.
   */
  wifIssuerUrl?: Maybe<Scalars["String"]["output"]>;
  /** ARN of the IAM role to assume via WIF */
  wifRoleArn?: Maybe<Scalars["String"]["output"]>;
  /** Computed OIDC subject for WIF token requests */
  wifSubject?: Maybe<Scalars["String"]["output"]>;
};

/** Hosted AWS integration input */
export type HostedAwsConfigurationOptionsInput = {
  /** Selected discovery targets. Empty means use the default discovery behavior. */
  discoveryTargets?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The key credential for the hosted AWS integration */
  keyCredential?: InputMaybe<AwsSecretKeyCredential>;
  /** The role credential for the hosted AWS integration */
  roleCredential?: InputMaybe<AwsRoleCredential>;
  /**
   * WIF credential for the hosted AWS integration.
   * Uses Mondoo as an OIDC identity provider with AWS IAM.
   */
  wifCredential?: InputMaybe<AwsWifCredential>;
};

/** ENUM for icon ids */
export enum Icon_Ids {
  Adobe = "ADOBE",
  AdobeIllustrator = "ADOBE_ILLUSTRATOR",
  AdobeIndesign = "ADOBE_INDESIGN",
  AdobePhotoshop = "ADOBE_PHOTOSHOP",
  AdobePremierePro = "ADOBE_PREMIERE_PRO",
  AdobeReader = "ADOBE_READER",
  Ai = "AI",
  Aix = "AIX",
  AlibabaCloud = "ALIBABA_CLOUD",
  AlmaLinux = "ALMA_LINUX",
  Alpine = "ALPINE",
  Amazon = "AMAZON",
  Ansible = "ANSIBLE",
  Apple = "APPLE",
  Arch = "ARCH",
  Arista = "ARISTA",
  Asset = "ASSET",
  Atlassian = "ATLASSIAN",
  Aws = "AWS",
  Azure = "AZURE",
  Bitwarden = "BITWARDEN",
  Busybox = "BUSYBOX",
  CachyOs = "CACHY_OS",
  Centos = "CENTOS",
  Check = "CHECK",
  CheckPoint = "CHECK_POINT",
  Cirros = "CIRROS",
  CisaKev = "CISA_KEV",
  Cisco = "CISCO",
  Claude = "CLAUDE",
  Cloudflare = "CLOUDFLARE",
  Cloudformation = "CLOUDFORMATION",
  CloudLinux = "CLOUD_LINUX",
  Containers = "CONTAINERS",
  Coreos = "COREOS",
  Crates = "CRATES",
  CumulusLinux = "CUMULUS_LINUX",
  Cursor = "CURSOR",
  Cve = "CVE",
  CveOrg = "CVE_ORG",
  Dart = "DART",
  Databricks = "DATABRICKS",
  Datadog = "DATADOG",
  Debian = "DEBIAN",
  Default = "DEFAULT",
  DellIdrac = "DELL_IDRAC",
  DigitalOcean = "DIGITAL_OCEAN",
  Dns = "DNS",
  DockerDesktop = "DOCKER_DESKTOP",
  DomainsAndHosts = "DOMAINS_AND_HOSTS",
  DragonflyBsd = "DRAGONFLY_BSD",
  Dropbox = "DROPBOX",
  Elementary = "ELEMENTARY",
  EndeavourOs = "ENDEAVOUR_OS",
  Equinix = "EQUINIX",
  EuroLinux = "EURO_LINUX",
  F5BigIp = "F5_BIG_IP",
  Fedora = "FEDORA",
  Flatcar = "FLATCAR",
  Fortios = "FORTIOS",
  FortiClient = "FORTI_CLIENT",
  Freebsd = "FREEBSD",
  Garageband = "GARAGEBAND",
  GardenLinux = "GARDEN_LINUX",
  Gcp = "GCP",
  Gentoo = "GENTOO",
  Gimp = "GIMP",
  Github = "GITHUB",
  GithubDesktop = "GITHUB_DESKTOP",
  Gitlab = "GITLAB",
  Go = "GO",
  GoogleChrome = "GOOGLE_CHROME",
  GoogleProjectZero = "GOOGLE_PROJECT_ZERO",
  GoogleWorkspace = "GOOGLE_WORKSPACE",
  Hetzner = "HETZNER",
  Hex = "HEX",
  HpeIlo = "HPE_ILO",
  Huawei = "HUAWEI",
  HuggingFace = "HUGGING_FACE",
  Iac = "IAC",
  IntellijIdea = "INTELLIJ_IDEA",
  Inthewild = "INTHEWILD",
  Ipmi = "IPMI",
  Jamf = "JAMF",
  Java = "JAVA",
  Junos = "JUNOS",
  K8S = "K8S",
  Kali = "KALI",
  Keynote = "KEYNOTE",
  Kiro = "KIRO",
  Lede = "LEDE",
  LibreOffice = "LIBRE_OFFICE",
  Linux = "LINUX",
  LinuxMint = "LINUX_MINT",
  Macos = "MACOS",
  Mageia = "MAGEIA",
  Manjaro = "MANJARO",
  Mcp = "MCP",
  Metasploit = "METASPLOIT",
  Microsoft = "MICROSOFT",
  MicrosoftDotnet = "MICROSOFT_DOTNET",
  MicrosoftEdge = "MICROSOFT_EDGE",
  MicrosoftExcel = "MICROSOFT_EXCEL",
  MicrosoftOnenote = "MICROSOFT_ONENOTE",
  MicrosoftPowerpoint = "MICROSOFT_POWERPOINT",
  MicrosoftSqlServer = "MICROSOFT_SQL_SERVER",
  MicrosoftTeams = "MICROSOFT_TEAMS",
  MicrosoftVisualStudioCode = "MICROSOFT_VISUAL_STUDIO_CODE",
  MicrosoftWord = "MICROSOFT_WORD",
  Mikrotik = "MIKROTIK",
  Mistral = "MISTRAL",
  Mondoo = "MONDOO",
  MongodbAtlas = "MONGODB_ATLAS",
  Mozilla = "MOZILLA",
  MozillaFirefox = "MOZILLA_FIREFOX",
  MozillaThunderbird = "MOZILLA_THUNDERBIRD",
  Ms365 = "MS365",
  MxLinux = "MX_LINUX",
  Neon = "NEON",
  Netbsd = "NETBSD",
  NetscoutHardenedOs = "NETSCOUT_HARDENED_OS",
  NetworkDevices = "NETWORK_DEVICES",
  Nextdns = "NEXTDNS",
  NistNvd = "NIST_NVD",
  Nixos = "NIXOS",
  Nmap = "NMAP",
  Nobara = "NOBARA",
  NodeJs = "NODE_JS",
  NotepadPlusPlus = "NOTEPAD_PLUS_PLUS",
  Npm = "NPM",
  Nuget = "NUGET",
  Nutanix = "NUTANIX",
  Nvidia = "NVIDIA",
  Oci = "OCI",
  Okta = "OKTA",
  Ollama = "OLLAMA",
  Opcua = "OPCUA",
  Openai = "OPENAI",
  Openbsd = "OPENBSD",
  Openeuler = "OPENEULER",
  Openstack = "OPENSTACK",
  Openwrt = "OPENWRT",
  OperatingSystem = "OPERATING_SYSTEM",
  Oracle = "ORACLE",
  OracleJava = "ORACLE_JAVA",
  OracleVirtualbox = "ORACLE_VIRTUALBOX",
  Other = "OTHER",
  Packagist = "PACKAGIST",
  Pages = "PAGES",
  Panos = "PANOS",
  Parrot = "PARROT",
  Pgadmin = "PGADMIN",
  Plcnext = "PLCNEXT",
  Policy = "POLICY",
  Pop = "POP",
  Portainer = "PORTAINER",
  Proxmox = "PROXMOX",
  Pypi = "PYPI",
  Python = "PYTHON",
  Qubes = "QUBES",
  Raspbian = "RASPBIAN",
  Redfish = "REDFISH",
  Redhat = "REDHAT",
  Risk = "RISK",
  RockyLinux = "ROCKY_LINUX",
  Ruby = "RUBY",
  Rust = "RUST",
  Safari = "SAFARI",
  Sbom = "SBOM",
  ScientificLinux = "SCIENTIFIC_LINUX",
  Scratch = "SCRATCH",
  SevenZip = "SEVEN_ZIP",
  Shodan = "SHODAN",
  Skype = "SKYPE",
  Slack = "SLACK",
  Snowflake = "SNOWFLAKE",
  Solaris = "SOLARIS",
  Stackit = "STACKIT",
  SteamOs = "STEAM_OS",
  Supermicro = "SUPERMICRO",
  Suse = "SUSE",
  Swift = "SWIFT",
  Tails = "TAILS",
  Tailscale = "TAILSCALE",
  Talos = "TALOS",
  Teamviewer = "TEAMVIEWER",
  Terraform = "TERRAFORM",
  Together = "TOGETHER",
  Ubuntu = "UBUNTU",
  Unifi = "UNIFI",
  Vcd = "VCD",
  Vercel = "VERCEL",
  VlcMediaPlayer = "VLC_MEDIA_PLAYER",
  Vllm = "VLLM",
  Vmware = "VMWARE",
  VmwareFusion = "VMWARE_FUSION",
  VmwarePhoton = "VMWARE_PHOTON",
  VmwareTools = "VMWARE_TOOLS",
  VulncheckKev = "VULNCHECK_KEV",
  Webex = "WEBEX",
  Windows = "WINDOWS",
  Windows_10 = "WINDOWS_10",
  Windows_11 = "WINDOWS_11",
  Windsurf = "WINDSURF",
  Wireshark = "WIRESHARK",
  Wolfi = "WOLFI",
  WrLinux = "WR_LINUX",
  Xcode = "XCODE",
  Zorin = "ZORIN",
}

/** ID suggestion input */
export type IdSuggestionInput = {
  /** ID available */
  idAvailable?: InputMaybe<Scalars["String"]["input"]>;
  /** Parent MRN */
  parentMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Response for Organization and Space ID suggestion */
export type IdSuggestionResponse = {
  __typename: "IDSuggestionResponse";
  /** Available */
  available: Scalars["Boolean"]["output"];
  /** ID */
  id: Scalars["String"]["output"];
};

/** Identity interface for users and service accounts */
export type Identity = {
  /** The Mondoo Resource Name (MRN) uniquely identifies each identity. */
  mrn: Scalars["String"]["output"];
  /** The name of the identity */
  name: Scalars["String"]["output"];
};

/** Identity filter for auditlog queries */
export type IdentityFilter = {
  /** Filter by identity MRN */
  mrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by identity name */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Impact */
export type Impact = {
  __typename: "Impact";
  /** Rating */
  rating: Scalars["String"]["output"];
  /** Value */
  value: Scalars["Int"]["output"];
};

/** Input for importing a workflow from YAML. */
export type ImportWorkflowYamlInput = {
  /** MRN of the owning space or organization. */
  ownerMrn: Scalars["ID"]["input"];
  /** YAML content to import. */
  yaml: Scalars["String"]["input"];
};

/** Result of importing a workflow from YAML. */
export type ImportWorkflowYamlPayload = {
  __typename: "ImportWorkflowYamlPayload";
  /** The imported workflow. */
  workflow: Workflow;
};

/** Ingest proxy upload configuration */
export type IngestProxyConfiguration = {
  __typename: "IngestProxyConfiguration";
  /**
   * Whether scan-database uploads for this organization are routed through the
   * static-IP ingest proxy
   */
  enable: Scalars["Boolean"]["output"];
};

/** Ingest proxy upload configuration */
export type IngestProxyConfigurationInput = {
  /**
   * Whether scan-database uploads for this organization are routed through the
   * static-IP ingest proxy
   */
  enable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Initiative */
export type Initiative = {
  __typename: "Initiative";
  /** The creation timestamp of the workflow. */
  createdAt: Scalars["String"]["output"];
  /** Metadata */
  metadata?: Maybe<InitiativeMetadata>;
  /** The MRN of the initiative. */
  mrn: Scalars["String"]["output"];
  /** References */
  references?: Maybe<Array<InitiativeRef>>;
  /** Score delta */
  scoreDelta: Scalars["Float"]["output"];
  /** The status of the workflow. */
  status: InitiativeStatus;
  /** The title of the initiative. */
  title: Scalars["String"]["output"];
  /** The last updated timestamp of the workflow. */
  updatedAt: Scalars["String"]["output"];
};

/** Initiative edge. */
export type InitiativeEdge = {
  __typename: "InitiativeEdge";
  /** Cursor */
  cursor: Scalars["String"]["output"];
  /** Node */
  node: Initiative;
};

/** Initiative metadata */
export type InitiativeMetadata =
  | AggregateInitiativeMetadata
  | AssetInitiativeMetadata;

/** Initiative order object */
export type InitiativeOrder = {
  /** Order direction */
  direction: OrderDirection;
  /** Workflow field */
  field: InitiativeOrderField;
};

/** Initiative order field */
export enum InitiativeOrderField {
  ScoreDelta = "SCORE_DELTA",
  UpdatedAt = "UPDATED_AT",
}

/** Initiative reference */
export type InitiativeRef = {
  __typename: "InitiativeRef";
  /** The MRN of the finding. */
  findingMrn: Scalars["String"]["output"];
};

/** Initiative reference for filtering cases by initiative */
export type InitiativeRefInput = {
  /** The entity/asset MRN */
  entityMrn: Scalars["String"]["input"];
  /** The initiative MRN */
  initiativeMrn: Scalars["String"]["input"];
};

/** Initiative status */
export enum InitiativeStatus {
  Canceled = "CANCELED",
  Fixed = "FIXED",
  InProgress = "IN_PROGRESS",
  NotStarted = "NOT_STARTED",
  Ticketed = "TICKETED",
}

/** Type of initiative */
export enum InitiativeType {
  Aggregate = "AGGREGATE",
  Asset = "ASSET",
}

/** Initiatives response. */
export type InitiativesConnection = {
  __typename: "InitiativesConnection";
  /** Edges */
  edges?: Maybe<Array<InitiativeEdge>>;
  /** Information about the current page */
  pageInfo: PageInfo;
  /** The total number of initiatives */
  totalCount: Scalars["Int"]["output"];
};

/** Initiatives input */
export type InitiativesInput = {
  /** The entity for which to retrieve initiatives. */
  entityMrn: Scalars["String"]["input"];
  /** Filter initiatives by MRNs. */
  mrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The statuses to filter initiatives by. */
  statuses?: InputMaybe<Array<InitiativeStatus>>;
  /** The type of initiatives to retrieve. */
  type: InitiativeType;
};

/** Wrapper for integer values */
export type IntValue = {
  __typename: "IntValue";
  /** Integer value */
  value: Scalars["Int"]["output"];
};

/** Describes a chatops integration */
export type Integration = {
  __typename: "Integration";
  /** Whether the integration is enabled */
  enabled: Scalars["Boolean"]["output"];
  /** The MRN of the integration */
  mrn: Scalars["String"]["output"];
  /** The name of the integration */
  name: Scalars["String"]["output"];
  /** Options for the integration */
  options?: Maybe<IntegrationOptions>;
};

/**
 * IntegrationAccountAssets is the per-asset-type breakdown of the assets owned
 * by a single cloud account (or the empty-account bucket) within one space.
 */
export type IntegrationAccountAssets = {
  __typename: "IntegrationAccountAssets";
  /**
   * Owning account / subscription / project ID. Empty ("") for assets with no
   * derivable owning account.
   */
  accountId: Scalars["String"]["output"];
  /** Asset counts per type owned by this account in the space. */
  assetCounts: Array<IntegrationAssetCount>;
  /** Total assets owned by this account in the space. */
  total: Scalars["Int"]["output"];
};

/** IntegrationAssetCount describes the amount of inventory assets discovered by the integration */
export type IntegrationAssetCount = {
  __typename: "IntegrationAssetCount";
  /**
   * For cloud account asset types (aws.account, azure.subscription, gcp.project),
   * the list of account / subscription / project IDs discovered by this
   * integration. Empty for every other asset type.
   */
  accountIds: Array<Scalars["String"]["output"]>;
  /** The asset type */
  assetType: Scalars["String"]["output"];
  /** The total number of assets */
  total: Scalars["Int"]["output"];
};

/**
 * Asset distribution for an integration: which spaces contain its assets,
 * what types, and when each space last received data from this integration.
 */
export type IntegrationAssetDistribution = {
  __typename: "IntegrationAssetDistribution";
  /**
   * Per-space entries, ordered by total asset count descending. Only spaces
   * that currently contain at least one asset from this integration are
   * returned.
   */
  spaces: Array<IntegrationSpaceAssets>;
  /** Org-level totals across every space. */
  totals: IntegrationAssetTotals;
};

/** Org-level summary for an integration's asset distribution. */
export type IntegrationAssetTotals = {
  __typename: "IntegrationAssetTotals";
  /** Per-type breakdown summed across all spaces. */
  byAssetType: Array<IntegrationAssetCount>;
  /**
   * Number of distinct orgs that contain at least one asset from this
   * integration. Always 1 for normal (non-cross-org) integrations; greater
   * than 1 only when cross-org routing has delivered assets into multiple
   * orgs.
   */
  orgCount: Scalars["Int"]["output"];
  /** Number of spaces that contain at least one asset from this integration. */
  spaceCount: Scalars["Int"]["output"];
  /** Total asset count across all spaces. */
  total: Scalars["Int"]["output"];
};

/** IntegrationError describes an error reported by the integration */
export type IntegrationError = {
  __typename: "IntegrationError";
  /** The error message */
  error: Scalars["String"]["output"];
  /** The timestamp of the error */
  timestamp?: Maybe<Scalars["String"]["output"]>;
};

/** Input options provided when creating a chatops integration */
export type IntegrationInput = {
  /** Whether the integration is enabled */
  enabled: Scalars["Boolean"]["input"];
  /** The MRN of the integration */
  mrn: Scalars["String"]["input"];
  /** The name of the integration */
  name: Scalars["String"]["input"];
  /** Options for the integration */
  options?: InputMaybe<IntegrationOptionsInput>;
};

/** IntegrationMessage is a message reported by the integration. It can be informational or serve as a warning/error */
export type IntegrationMessage = {
  __typename: "IntegrationMessage";
  /**
   * The database id of the message. Stable for messages returned from integrationMessages;
   * always 0 for messages on ClientIntegration.messages (the legacy bytea-backed list).
   */
  id: Scalars["ID"]["output"];
  /** The identifier of the message */
  identifier?: Maybe<Scalars["String"]["output"]>;
  /** The message */
  message: Scalars["String"]["output"];
  /** The status of the message */
  status: IntegrationMessageStatus;
  /** Whether the message is suppressed by the user */
  suppressedByUser?: Maybe<Scalars["Boolean"]["output"]>;
  /** The timestamp of the message */
  timestamp?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the message */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Connection containing integration messages */
export type IntegrationMessageConnection = {
  __typename: "IntegrationMessageConnection";
  /** The edges in the connection */
  edges?: Maybe<Array<IntegrationMessageEdge>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** The total number of messages matching the query (across all pages) */
  totalCount: Scalars["Int"]["output"];
};

/** An edge in an integration message connection */
export type IntegrationMessageEdge = {
  __typename: "IntegrationMessageEdge";
  /** The cursor for this edge */
  cursor: Scalars["ID"]["output"];
  /** The integration message at the end of the edge */
  node?: Maybe<IntegrationMessage>;
};

/** IntegrationMessageStatus denotes the status of the message reported by the integration */
export enum IntegrationMessageStatus {
  Error = "ERROR",
  Info = "INFO",
  Warning = "WARNING",
}

/** Describes options for a chatops integration */
export type IntegrationOptions = {
  __typename: "IntegrationOptions";
  /** The chat ID for the integration */
  chatid?: Maybe<Scalars["String"]["output"]>;
  /** The notification type for the integration */
  notificationType?: Maybe<NotificationType>;
  /** The token for the integration */
  token?: Maybe<Scalars["String"]["output"]>;
  /** The URL for the integration */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Options for chatops integration */
export type IntegrationOptionsInput = {
  /** The chat ID for the integration */
  chatid?: InputMaybe<Scalars["String"]["input"]>;
  /** The notification type for the integration */
  notificationType?: InputMaybe<NotificationType>;
  /** The token for the integration */
  token?: InputMaybe<Scalars["String"]["input"]>;
  /** The URL for the integration */
  url?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * A single space entry in the integration asset distribution, with the
 * per-asset-type breakdown and the most recent update time for assets from
 * this integration in that space.
 */
export type IntegrationSpaceAssets = {
  __typename: "IntegrationSpaceAssets";
  /**
   * Per-owning-account breakdown of this integration's assets in this space.
   * The owning account / subscription / project ID is derived from each asset's
   * platform identifier, so it covers every cloud asset type (not just the
   * cloud-account asset types). Assets with no derivable owning account are
   * grouped under an entry whose accountId is empty (""). Ordered with real
   * accounts first (by total descending) and the empty bucket last.
   */
  accounts: Array<IntegrationAccountAssets>;
  /** Asset counts per type within this space for this integration. */
  assetCounts: Array<IntegrationAssetCount>;
  /** Most recent update timestamp across this integration's assets in this space (RFC3339). */
  lastScanAt?: Maybe<Scalars["String"]["output"]>;
  /**
   * The org that owns this space. For non-cross-org integrations this is
   * always the integration's home org. For cross-org integrations this
   * identifies which org the listed space belongs to.
   */
  org: Organization;
  /** The space. */
  space: Space;
  /** Total assets from this integration in this space. */
  total: Scalars["Int"]["output"];
};

/** Integration statistics */
export type IntegrationStatistics = {
  __typename: "IntegrationStatistics";
  /** Active count */
  active: Scalars["Int"]["output"];
  /** Errored count */
  errored: Scalars["Int"]["output"];
  /** Pending count */
  pending: Scalars["Int"]["output"];
  /** Total count */
  total: Scalars["Int"]["output"];
  /** Integration type */
  type: IntegrationType;
};

/** Summary of client integrations */
export enum IntegrationType {
  AttackSurface = "ATTACK_SURFACE",
  AuditLogExport = "AUDIT_LOG_EXPORT",
  Aws = "AWS",
  AwsHosted = "AWS_HOSTED",
  AwsS3 = "AWS_S3",
  Azure = "AZURE",
  AzureBlob = "AZURE_BLOB",
  Bigquery = "BIGQUERY",
  Cloudflare = "CLOUDFLARE",
  CrowdstrikeFalcon = "CROWDSTRIKE_FALCON",
  Digitalocean = "DIGITALOCEAN",
  Elastic = "ELASTIC",
  Gcp = "GCP",
  GcpServerless = "GCP_SERVERLESS",
  GcsBucket = "GCS_BUCKET",
  Github = "GITHUB",
  Gitlab = "GITLAB",
  GoogleSccExport = "GOOGLE_SCC_EXPORT",
  GoogleSccImport = "GOOGLE_SCC_IMPORT",
  GoogleWorkspace = "GOOGLE_WORKSPACE",
  Hetzner = "HETZNER",
  Host = "HOST",
  HostedSlack = "HOSTED_SLACK",
  Httppost = "HTTPPOST",
  K8S = "K8S",
  ManagedClient = "MANAGED_CLIENT",
  MicrosoftDefender = "MICROSOFT_DEFENDER",
  MondooBi = "MONDOO_BI",
  Ms365 = "MS365",
  Msteams = "MSTEAMS",
  MsIntune = "MS_INTUNE",
  NetworkDiscoveryCollector = "NETWORK_DISCOVERY_COLLECTOR",
  NetworkScan = "NETWORK_SCAN",
  Nextdns = "NEXTDNS",
  Oci = "OCI",
  Okta = "OKTA",
  Openvas = "OPENVAS",
  Postgres = "POSTGRES",
  Qualys = "QUALYS",
  S3 = "S3",
  SecurityPipelineGithub = "SECURITY_PIPELINE_GITHUB",
  SecurityScorecard = "SECURITY_SCORECARD",
  SentinelOne = "SENTINEL_ONE",
  Shodan = "SHODAN",
  Slack = "SLACK",
  Snowflake = "SNOWFLAKE",
  SnowflakeScan = "SNOWFLAKE_SCAN",
  Snyk = "SNYK",
  Sonarqube = "SONARQUBE",
  Splunk = "SPLUNK",
  Stackit = "STACKIT",
  Tailscale = "TAILSCALE",
  Telegram = "TELEGRAM",
  Tenable = "TENABLE",
  TenableSc = "TENABLE_SC",
  TicketSystemAzureDevops = "TICKET_SYSTEM_AZURE_DEVOPS",
  TicketSystemEmail = "TICKET_SYSTEM_EMAIL",
  TicketSystemGithub = "TICKET_SYSTEM_GITHUB",
  TicketSystemGitlab = "TICKET_SYSTEM_GITLAB",
  TicketSystemJira = "TICKET_SYSTEM_JIRA",
  TicketSystemServiceNow = "TICKET_SYSTEM_SERVICE_NOW",
  TicketSystemWebhook = "TICKET_SYSTEM_WEBHOOK",
  TicketSystemZendesk = "TICKET_SYSTEM_ZENDESK",
  Unknown = "UNKNOWN",
}

/** Summary of a client integration type */
export type IntegrationTypeSummary = {
  __typename: "IntegrationTypeSummary";
  /** The count of active integrations of this type */
  activeCount: Scalars["Int"]["output"];
  /** The count of assets discovered by integrations of this type */
  assetsCount: Scalars["Int"]["output"];
  /** The count of checks, applicable to integrations of this type */
  checksCount: Scalars["Int"]["output"];
  /** The count of failed integrations of this type */
  failedCount: Scalars["Int"]["output"];
  /** The count of policies, applicable to integrations of this type */
  policiesCount: Scalars["Int"]["output"];
  /** The total count of integrations of this type */
  totalCount: Scalars["Int"]["output"];
  /** The type of the integration for which this summary is */
  type: IntegrationType;
  /** The count of integrations that have warnings of this type */
  warningCount: Scalars["Int"]["output"];
};

/** Input for summary of client integrations */
export type IntegrationsSummaryInput = {
  spaceMrn: Scalars["String"]["input"];
};

/** Summaries of client integrations */
export type IntegrationsSummaryPayload = {
  __typename: "IntegrationsSummaryPayload";
  /** A list of integration type summaries */
  integrationSummaries?: Maybe<Array<IntegrationTypeSummary>>;
  /** The total number of integrations */
  total: Scalars["Int"]["output"];
};

/** An edge in the asset interconnection graph */
export type InterconnectionEdge = {
  __typename: "InterconnectionEdge";
  /** Source node ID */
  from: Scalars["String"]["output"];
  /** Whether this is the primary subnet assignment for the asset */
  primary: Scalars["Boolean"]["output"];
  /** Target node ID */
  to: Scalars["String"]["output"];
  /** Edge type */
  type: InterconnectionEdgeType;
};

/** Edge type in the asset interconnection graph */
export enum InterconnectionEdgeType {
  /** Hard match: direct connection observed via listening ports */
  Connection = "CONNECTION",
  /** Soft match: asset belongs to a subnet based on IP address */
  Subnet = "SUBNET",
}

/** Metadata about the precomputed asset interconnection graph */
export type InterconnectionGraphInfo = {
  __typename: "InterconnectionGraphInfo";
  /** Deterministic document MRN - pass to requestDocumentDownloadUrl to get signed URL */
  documentMrn?: Maybe<Scalars["String"]["output"]>;
  /** When the graph was last successfully generated */
  lastGeneratedAt?: Maybe<Scalars["String"]["output"]>;
  /** Generation status */
  status: InterconnectionGraphStatus;
};

/** Status of the precomputed interconnection graph */
export enum InterconnectionGraphStatus {
  Completed = "COMPLETED",
  Failed = "FAILED",
  Generating = "GENERATING",
  NotAvailable = "NOT_AVAILABLE",
  Pending = "PENDING",
}

/** A node in the asset interconnection graph */
export type InterconnectionNode = {
  __typename: "InterconnectionNode";
  /** IP addresses associated with this node */
  addresses: Array<Scalars["String"]["output"]>;
  /** Asset MRN (only for ASSET nodes) */
  assetMrn?: Maybe<Scalars["String"]["output"]>;
  /** Number of child subnets (for SUPERNET nodes) */
  childCount: Scalars["Int"]["output"];
  /** Total number of open findings (vulnerabilities + advisories). For aggregate nodes: sum of children. */
  findingsCount: Scalars["Int"]["output"];
  /** Unique node identifier (e.g. "asset_{mrn}", "sn_10.0.1.0/24", "supernet_10.0.0.0/8") */
  id: Scalars["String"]["output"];
  /** Display label */
  label: Scalars["String"]["output"];
  /** Number of member assets (for SUBNET nodes) */
  memberCount: Scalars["Int"]["output"];
  /** Risk rating derived from the score (CRITICAL, HIGH, MEDIUM, LOW, NONE, UNSCORED). */
  riskRating: ScoreRating;
  /** Risk value (0-100, higher is worse). Computed as 100 - score. 0 for both perfect score and unscored assets (use riskRating to distinguish). */
  riskValue: Scalars["Int"]["output"];
  /** Security score (0-100, higher is better). For aggregate nodes: worst (minimum) score of children. */
  score: Scalars["Int"]["output"];
  /** Space MRN (only for ASSET nodes) */
  spaceMrn?: Maybe<Scalars["String"]["output"]>;
  /** Node type */
  type: InterconnectionNodeType;
  /** Count of critical severity vulnerabilities (aggregated for subnet/supernet nodes) */
  vulnCritical: Scalars["Int"]["output"];
  /** Count of high severity vulnerabilities (aggregated for subnet/supernet nodes) */
  vulnHigh: Scalars["Int"]["output"];
  /** Count of low severity vulnerabilities (aggregated for subnet/supernet nodes) */
  vulnLow: Scalars["Int"]["output"];
  /** Count of medium severity vulnerabilities (aggregated for subnet/supernet nodes) */
  vulnMedium: Scalars["Int"]["output"];
  /** Worst severity level present on this node (critical > high > medium > low) */
  vulnWorst: Scalars["String"]["output"];
};

/** Node type in the asset interconnection graph */
export enum InterconnectionNodeType {
  Asset = "ASSET",
  Subnet = "SUBNET",
  Supernet = "SUPERNET",
}

/** An Intune device group */
export type IntuneDeviceGroup = {
  __typename: "IntuneDeviceGroup";
  /** The description of the device group */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The display name of the device group */
  displayName: Scalars["String"]["output"];
  /** The ID of the device group */
  id: Scalars["String"]["output"];
  /** The number of members in the group */
  memberCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Input for querying Intune device groups for an asset */
export type IntuneDeviceGroupsInput = {
  /**
   * Optional: The MRN of the asset. When provided, returns only groups the device belongs to.
   * When omitted, returns all device groups from the Intune tenant.
   */
  assetMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** The MRN of the Intune integration */
  integrationMrn: Scalars["String"]["input"];
  /** The MRN of the space */
  spaceMrn: Scalars["String"]["input"];
};

/** Response from querying Intune device groups */
export type IntuneDeviceGroupsPayload = {
  __typename: "IntuneDeviceGroupsPayload";
  /** The list of device groups the asset belongs to */
  groups: Array<IntuneDeviceGroup>;
};

/** Invalid data error */
export type InvalidDataError = Error & {
  __typename: "InvalidDataError";
  /** Error code */
  code: Scalars["String"]["output"];
  /** Error message */
  message: Scalars["String"]["output"];
};

/** An invitation to join a space or organization */
export type Invitation = {
  __typename: "Invitation";
  /** The expiration time of the invitation */
  expiresAt: Scalars["String"]["output"];
  /** The ID of the invitation */
  id: Scalars["String"]["output"];
  /** The email of the invitee */
  inviteeEmail: Scalars["String"]["output"];
  /** The MRN of the invitee */
  inviteeMrn: Scalars["String"]["output"];
  /** The message for the invitation */
  message: Scalars["String"]["output"];
  /** The MRN of the invitation */
  mrn: Scalars["String"]["output"];
  /** The MRN of the resource (space or organization) */
  resourceMrn: Scalars["String"]["output"];
  /**
   * Deprecated: Use roleMrns instead. Provide either roleMrn or roleMrns, not both
   * @deprecated Use roleMrns instead
   */
  roleMrn?: Maybe<Scalars["String"]["output"]>;
  /** The MRNs of the roles for the invitation */
  roleMrns?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The email of the sender */
  senderEmail: Scalars["String"]["output"];
  /** The state of the invitation */
  state: InvitationState;
};

/** An edge in an invitations connection */
export type InvitationEdge = {
  __typename: "InvitationEdge";
  /** The cursor for this edge */
  cursor: Scalars["ID"]["output"];
  /** The invitation at the end of the edge */
  node?: Maybe<Invitation>;
};

/** Input for ordering invitations */
export type InvitationOrder = {
  /** The direction to order by */
  direction: OrderDirection;
  /** The field to order by */
  field: InvitationOrderField;
};

/** Field to order invitations by */
export enum InvitationOrderField {
  Created = "CREATED",
}

/** State of an invitation */
export enum InvitationState {
  Accepted = "ACCEPTED",
  Canceled = "CANCELED",
  Declined = "DECLINED",
  Pending = "PENDING",
}

/** Connection containing invitations */
export type InvitationsConnection = {
  __typename: "InvitationsConnection";
  /** The edges in the connection */
  edges?: Maybe<Array<InvitationEdge>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** The total number of invitations */
  totalCount: Scalars["Int"]["output"];
};

/** A Jenkins job */
export type JenkinsJob = {
  __typename: "JenkinsJob";
  /** The branch name */
  branch: Scalars["String"]["output"];
  /** The build URL */
  buildUrl: Scalars["String"]["output"];
  /** The commit SHA */
  commitSha: Scalars["String"]["output"];
  /**
   * The grade of the job (deprecated)
   * @deprecated Grades will be removed in future. Use score.
   */
  grade: Grade;
  /** The ID of the job */
  id: Scalars["String"]["output"];
  /** The job name */
  job: Scalars["String"]["output"];
  /** The job ID */
  jobId: Scalars["String"]["output"];
  /** The MRN of the job */
  mrn: Scalars["String"]["output"];
  /** The name of the job */
  name: Scalars["String"]["output"];
  /** The kind of pipeline */
  pipelineKind: GitPipelineKind;
  /** The URL of the project */
  projectUrl: Scalars["String"]["output"];
  /** The repository URL */
  repositoryUrl: Scalars["String"]["output"];
  /** The score of the job */
  score: Score;
  /** The target of the job */
  target?: Maybe<Scalars["String"]["output"]>;
  /** The time the job was last updated */
  updatedAt: Scalars["String"]["output"];
  /** The username */
  userName: Scalars["String"]["output"];
};

/** Jira configuration options */
export type JiraConfigurationOptions = {
  __typename: "JiraConfigurationOptions";
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["output"];
  /** Whether to auto-create cases */
  autoCreateCases: Scalars["Boolean"]["output"];
  /**
   * The Jira Cloud ID for scoped API token support.
   * When provided, the integration will use the api.atlassian.com gateway URL
   * instead of the direct instance URL, enabling scoped API tokens.
   * Can be obtained from https://{domain}.atlassian.net/_edge/tenant_info
   */
  cloudId?: Maybe<Scalars["String"]["output"]>;
  /** The default Jira project */
  defaultProject: Scalars["String"]["output"];
  /** The Jira user email */
  email: Scalars["String"]["output"];
  /** The Jira host URL */
  host: Scalars["String"]["output"];
};

/** Jira integration input */
export type JiraConfigurationOptionsInput = {
  /** The Jira API token */
  apiToken: Scalars["String"]["input"];
  /** Whether to auto-close tickets */
  autoCloseTickets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether to auto-create cases */
  autoCreateCases?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * The Jira Cloud ID for scoped API token support.
   * When provided, the integration will use the api.atlassian.com gateway URL
   * instead of the direct instance URL, enabling scoped API tokens.
   * Can be obtained from https://{domain}.atlassian.net/_edge/tenant_info
   */
  cloudId?: InputMaybe<Scalars["String"]["input"]>;
  /** The default Jira project */
  defaultProject: Scalars["String"]["input"];
  /** The Jira user email */
  email: Scalars["String"]["input"];
  /** The Jira host URL */
  host: Scalars["String"]["input"];
};

/** This type represents a Jira project. It contains the project's unique identifier and name. */
export type JiraProject = {
  __typename: "JiraProject";
  /** Whether this is the default project */
  isDefault: Scalars["Boolean"]["output"];
  /** The unique identifier of the project. */
  key: Scalars["String"]["output"];
  /** The name of the project. */
  name: Scalars["String"]["output"];
};

/** Jira ticket configuration input */
export type JiraTicketConfigInput = {
  /** The Jira issue type */
  issueType: Scalars["String"]["input"];
  /** The Jira project key */
  projectKey: Scalars["String"]["input"];
};

/** Parameters for JiraTicketContext */
export type JiraTicketContextInput = {
  /** The parameters for the ticket context. */
  projects?: InputMaybe<JiraTicketContextProjectsInput>;
  /** The type of the ticket context. */
  type: JiraTicketContextType;
  /** The parameters for the ticket context. */
  users?: InputMaybe<JiraTicketContextUsersInput>;
};

/** Jira Projects filter parameters for JiraTicketContext */
export type JiraTicketContextProjectsInput = {
  /** The Jira query to filter the projects by. */
  query?: InputMaybe<Scalars["String"]["input"]>;
};

/** This type represents a Jira ticket context. It contains the projects and users that are available for creating a ticket. */
export type JiraTicketContextProjectsPayload = {
  __typename: "JiraTicketContextProjectsPayload";
  /** The projects that are available for creating a ticket. */
  projects?: Maybe<Array<JiraProject>>;
};

/** The type of the ticket context. */
export enum JiraTicketContextType {
  /** The ticket context for Jira projects. */
  Projects = "PROJECTS",
  /** The ticket context for Jira users. */
  Users = "USERS",
}

/** Jira Users filter parameters for JiraTicketContext */
export type JiraTicketContextUsersInput = {
  /** The Jira project key to filter the users by. */
  projectKey: Scalars["String"]["input"];
  /** The query to filter the users by. */
  query?: InputMaybe<Scalars["String"]["input"]>;
};

/** This type represents a Jira ticket context. It contains the projects and users that are available for creating a ticket. */
export type JiraTicketContextUsersPayload = {
  __typename: "JiraTicketContextUsersPayload";
  /** The users that are available for creating a ticket. */
  users?: Maybe<Array<JiraUser>>;
};

/** This type represents a Jira user. It contains the user's unique identifier and display name. */
export type JiraUser = {
  __typename: "JiraUser";
  /** The unique identifier of the user. */
  accountId: Scalars["String"]["output"];
  /** The display name of the user. */
  displayName: Scalars["String"]["output"];
};

/** A job in a CI/CD system. Can be one of several types. */
export type Job =
  | AzureDevopsJob
  | CircleCiJob
  | GithubJob
  | GitlabJob
  | JenkinsJob
  | KubernetesJob;

/** An edge in a jobs connection */
export type JobEdge = {
  __typename: "JobEdge";
  /** The cursor for this edge */
  cursor: Scalars["ID"]["output"];
  /** The job at the end of the edge */
  node: Job;
};

/** Connection containing jobs */
export type JobsConnection = {
  __typename: "JobsConnection";
  /** The edges in the connection */
  edges?: Maybe<Array<JobEdge>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** The total number of jobs */
  totalCount: Scalars["Int"]["output"];
};

/** AKS workload identity configuration */
export type K8sAksWif = {
  __typename: "K8sAksWif";
  /** Azure client ID for managed identity */
  clientId?: Maybe<Scalars["String"]["output"]>;
  /** AKS cluster name */
  clusterName?: Maybe<Scalars["String"]["output"]>;
  /** Optional Kubernetes API server endpoint override URL (must start with https://) */
  endpoint?: Maybe<Scalars["String"]["output"]>;
  /** Container registry login server URL (used by containers WIF for ACR) */
  loginServer?: Maybe<Scalars["String"]["output"]>;
  /** Azure resource group */
  resourceGroup?: Maybe<Scalars["String"]["output"]>;
  /** Azure subscription ID */
  subscriptionId?: Maybe<Scalars["String"]["output"]>;
  /** Azure tenant ID */
  tenantId?: Maybe<Scalars["String"]["output"]>;
};

/** AKS workload identity configuration input */
export type K8sAksWifInput = {
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  clusterName?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional Kubernetes API server endpoint override URL (must start with https://). Consumed by the mondoo-operator, not by the server. */
  endpoint?: InputMaybe<Scalars["String"]["input"]>;
  loginServer?: InputMaybe<Scalars["String"]["input"]>;
  resourceGroup?: InputMaybe<Scalars["String"]["input"]>;
  subscriptionId?: InputMaybe<Scalars["String"]["input"]>;
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
};

/** K8s configuration options */
export type K8sConfigurationOptions = {
  __typename: "K8sConfigurationOptions";
  /** The certificate manager to use */
  certificateManager: Scalars["String"]["output"];
  /** Cron schedule for container image scanning */
  containersSchedule?: Maybe<Scalars["String"]["output"]>;
  /** Workload identity configuration for container registry auth */
  containersWif?: Maybe<K8sContainersWif>;
  /** External clusters to scan */
  externalClusters?: Maybe<Array<K8sExternalCluster>>;
  /** A list of allowed namespaces */
  namespaceAllowList?: Maybe<Array<Scalars["String"]["output"]>>;
  /** A list of denied namespaces */
  namespaceDenyList?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Cron schedule for node scanning */
  nodesSchedule?: Maybe<Scalars["String"]["output"]>;
  /** Names of Secrets containing credentials for private registries */
  privateRegistriesPullSecretRefs?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Whether to scan deployments */
  scanDeploys?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether to also scan the local cluster where the operator runs */
  scanLocalCluster?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether to scan nodes */
  scanNodes?: Maybe<Scalars["Boolean"]["output"]>;
  /** The style of node scanning */
  scanNodesStyle: K8sScanNodesStyle;
  /** Whether to scan public images */
  scanPublicImages?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether to scan workloads */
  scanWorkloads?: Maybe<Scalars["Boolean"]["output"]>;
  /** Cron schedule for Kubernetes resource scanning */
  schedule?: Maybe<Scalars["String"]["output"]>;
  /** Use a unique audit config name based on the integration ID (for multi-config clusters) */
  uniqueAuditConfig?: Maybe<Scalars["Boolean"]["output"]>;
};

/** K8s integration input */
export type K8sConfigurationOptionsInput = {
  /** The certificate manager to use */
  certificateManager?: InputMaybe<Scalars["String"]["input"]>;
  /** Cron schedule for container image scanning */
  containersSchedule?: InputMaybe<Scalars["String"]["input"]>;
  /** Workload identity configuration for container registry auth */
  containersWif?: InputMaybe<K8sContainersWifInput>;
  /** External clusters to scan */
  externalClusters?: InputMaybe<Array<K8sExternalClusterInput>>;
  /** A list of allowed namespaces */
  namespaceAllowList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** A list of denied namespaces */
  namespaceDenyList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Cron schedule for node scanning */
  nodesSchedule?: InputMaybe<Scalars["String"]["input"]>;
  /** Names of Secrets containing credentials for private registries */
  privateRegistriesPullSecretRefs?: InputMaybe<
    Array<Scalars["String"]["input"]>
  >;
  /** Whether to scan deployments */
  scanDeploys: Scalars["Boolean"]["input"];
  /** Whether to also scan the local cluster where the operator runs */
  scanLocalCluster?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether to scan nodes */
  scanNodes: Scalars["Boolean"]["input"];
  /** The style of node scanning */
  scanNodesStyle?: InputMaybe<K8sScanNodesStyle>;
  /** Whether to scan public images */
  scanPublicImages?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether to scan workloads */
  scanWorkloads: Scalars["Boolean"]["input"];
  /** Cron schedule for Kubernetes resource scanning */
  schedule?: InputMaybe<Scalars["String"]["input"]>;
  /** Use a unique audit config name based on the integration ID (for multi-config clusters) */
  uniqueAuditConfig?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Workload identity configuration for authenticating to cloud container registries */
export type K8sContainersWif = {
  __typename: "K8sContainersWif";
  /** AKS workload identity configuration */
  aks?: Maybe<K8sAksWif>;
  /** EKS workload identity configuration */
  eks?: Maybe<K8sEksWif>;
  /** GKE workload identity configuration */
  gke?: Maybe<K8sGkeWif>;
  /** Cloud provider: gke, eks, or aks */
  provider: Scalars["String"]["output"];
};

/** Workload identity configuration for authenticating to cloud container registries */
export type K8sContainersWifInput = {
  aks?: InputMaybe<K8sAksWifInput>;
  eks?: InputMaybe<K8sEksWifInput>;
  gke?: InputMaybe<K8sGkeWifInput>;
  /** Cloud provider: gke, eks, or aks */
  provider: Scalars["String"]["input"];
};

/** EKS workload identity configuration */
export type K8sEksWif = {
  __typename: "K8sEksWif";
  /** EKS cluster name */
  clusterName?: Maybe<Scalars["String"]["output"]>;
  /** Optional Kubernetes API server endpoint override URL (must start with https://) */
  endpoint?: Maybe<Scalars["String"]["output"]>;
  /** AWS region */
  region?: Maybe<Scalars["String"]["output"]>;
  /** IAM role ARN for workload identity */
  roleArn?: Maybe<Scalars["String"]["output"]>;
};

/** EKS workload identity configuration input */
export type K8sEksWifInput = {
  clusterName?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional Kubernetes API server endpoint override URL (must start with https://). Consumed by the mondoo-operator, not by the server. */
  endpoint?: InputMaybe<Scalars["String"]["input"]>;
  region?: InputMaybe<Scalars["String"]["input"]>;
  roleArn?: InputMaybe<Scalars["String"]["input"]>;
};

/** External cluster returned from K8s integration configuration */
export type K8sExternalCluster = {
  __typename: "K8sExternalCluster";
  /** AKS workload identity configuration */
  aks?: Maybe<K8sAksWif>;
  /** Auth method: kubeconfig, serviceAccount, or workloadIdentity */
  authMethod: Scalars["String"]["output"];
  /** Whether to scan container images in this external cluster */
  containerImageScanning?: Maybe<Scalars["Boolean"]["output"]>;
  /** Secret containing service account credentials */
  credentialsSecret?: Maybe<Scalars["String"]["output"]>;
  /** EKS workload identity configuration */
  eks?: Maybe<K8sEksWif>;
  /** GKE workload identity configuration */
  gke?: Maybe<K8sGkeWif>;
  /** Secret containing kubeconfig data */
  kubeconfigSecret?: Maybe<Scalars["String"]["output"]>;
  /** Cluster identifier */
  name: Scalars["String"]["output"];
  /** List of namespaces to include in scanning */
  namespaceAllowList?: Maybe<Array<Scalars["String"]["output"]>>;
  /** List of namespaces to exclude from scanning */
  namespaceDenyList?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Kubernetes API server URL */
  server?: Maybe<Scalars["String"]["output"]>;
  /** Whether to skip TLS verification for the API server */
  skipTLSVerify?: Maybe<Scalars["Boolean"]["output"]>;
  /** SPIFFE authentication configuration */
  spiffe?: Maybe<K8sSpiffeAuth>;
  /** Vault authentication configuration */
  vault?: Maybe<K8sVaultAuth>;
  /** Workload identity provider: gke, eks, or aks */
  wifProvider?: Maybe<Scalars["String"]["output"]>;
};

/** External cluster configuration for K8s integration */
export type K8sExternalClusterInput = {
  aks?: InputMaybe<K8sAksWifInput>;
  /** Auth method: kubeconfig, serviceAccount, or workloadIdentity */
  authMethod: Scalars["String"]["input"];
  /** Whether to scan container images in this external cluster */
  containerImageScanning?: InputMaybe<Scalars["Boolean"]["input"]>;
  credentialsSecret?: InputMaybe<Scalars["String"]["input"]>;
  eks?: InputMaybe<K8sEksWifInput>;
  gke?: InputMaybe<K8sGkeWifInput>;
  kubeconfigSecret?: InputMaybe<Scalars["String"]["input"]>;
  /** Cluster identifier */
  name: Scalars["String"]["input"];
  namespaceAllowList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  namespaceDenyList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  server?: InputMaybe<Scalars["String"]["input"]>;
  skipTLSVerify?: InputMaybe<Scalars["Boolean"]["input"]>;
  spiffe?: InputMaybe<K8sSpiffeAuthInput>;
  vault?: InputMaybe<K8sVaultAuthInput>;
  /** Workload identity provider: gke, eks, or aks */
  wifProvider?: InputMaybe<Scalars["String"]["input"]>;
};

/** GKE workload identity configuration */
export type K8sGkeWif = {
  __typename: "K8sGkeWif";
  /** GKE cluster location (region or zone) */
  clusterLocation?: Maybe<Scalars["String"]["output"]>;
  /** GKE cluster name */
  clusterName?: Maybe<Scalars["String"]["output"]>;
  /** Optional Kubernetes API server endpoint override URL (must start with https://) */
  endpoint?: Maybe<Scalars["String"]["output"]>;
  /** Google service account email for workload identity */
  googleServiceAccount?: Maybe<Scalars["String"]["output"]>;
  /** GCP project ID */
  projectId?: Maybe<Scalars["String"]["output"]>;
};

/** GKE workload identity configuration input */
export type K8sGkeWifInput = {
  clusterLocation?: InputMaybe<Scalars["String"]["input"]>;
  clusterName?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional Kubernetes API server endpoint override URL (must start with https://). Consumed by the mondoo-operator, not by the server. */
  endpoint?: InputMaybe<Scalars["String"]["input"]>;
  googleServiceAccount?: InputMaybe<Scalars["String"]["input"]>;
  projectId?: InputMaybe<Scalars["String"]["input"]>;
};

/** K8sIntegrationLastState describes the k8s and operator versions */
export type K8sIntegrationLastState = {
  __typename: "K8sIntegrationLastState";
  /** The Kubernetes version */
  k8sVersion?: Maybe<Scalars["String"]["output"]>;
  /** The namespace */
  namespace?: Maybe<Scalars["String"]["output"]>;
  /** The operator version */
  operatorVersion?: Maybe<Scalars["String"]["output"]>;
};

/** K8s node scanning style */
export enum K8sScanNodesStyle {
  Cronjob = "CRONJOB",
  Daemonset = "DAEMONSET",
  Deployment = "DEPLOYMENT",
  Unknown = "UNKNOWN",
}

/** SPIFFE authentication configuration */
export type K8sSpiffeAuth = {
  __typename: "K8sSpiffeAuth";
  /** SPIFFE audience for token validation */
  audience?: Maybe<Scalars["String"]["output"]>;
  /** SPIFFE server address */
  server?: Maybe<Scalars["String"]["output"]>;
  /** SPIFFE workload API socket path */
  socketPath?: Maybe<Scalars["String"]["output"]>;
  /** Secret containing the SPIFFE trust bundle */
  trustBundleSecret?: Maybe<Scalars["String"]["output"]>;
};

/** SPIFFE authentication configuration input */
export type K8sSpiffeAuthInput = {
  audience?: InputMaybe<Scalars["String"]["input"]>;
  server?: InputMaybe<Scalars["String"]["input"]>;
  socketPath?: InputMaybe<Scalars["String"]["input"]>;
  trustBundleSecret?: InputMaybe<Scalars["String"]["input"]>;
};

/** Vault authentication configuration */
export type K8sVaultAuth = {
  __typename: "K8sVaultAuth";
  /** Vault server address */
  addr?: Maybe<Scalars["String"]["output"]>;
  /** Vault authentication mount path */
  authPath?: Maybe<Scalars["String"]["output"]>;
  /** Vault authentication role */
  authRole?: Maybe<Scalars["String"]["output"]>;
  /** Secret containing Vault CA certificate */
  caCertSecret?: Maybe<Scalars["String"]["output"]>;
  /** Vault credentials role for dynamic secrets */
  credsRole?: Maybe<Scalars["String"]["output"]>;
  /** Kubernetes namespace for Vault authentication */
  kubernetesNamespace?: Maybe<Scalars["String"]["output"]>;
  /** Vault secrets engine path */
  secretsPath?: Maybe<Scalars["String"]["output"]>;
  /** Vault server name */
  server?: Maybe<Scalars["String"]["output"]>;
  /** Secret containing the target cluster CA certificate for Vault */
  targetCaCertSecret?: Maybe<Scalars["String"]["output"]>;
  /** TTL for Vault-issued credentials */
  ttl?: Maybe<Scalars["String"]["output"]>;
};

/** Vault authentication configuration input */
export type K8sVaultAuthInput = {
  addr?: InputMaybe<Scalars["String"]["input"]>;
  authPath?: InputMaybe<Scalars["String"]["input"]>;
  authRole?: InputMaybe<Scalars["String"]["input"]>;
  caCertSecret?: InputMaybe<Scalars["String"]["input"]>;
  credsRole?: InputMaybe<Scalars["String"]["input"]>;
  kubernetesNamespace?: InputMaybe<Scalars["String"]["input"]>;
  secretsPath?: InputMaybe<Scalars["String"]["input"]>;
  server?: InputMaybe<Scalars["String"]["input"]>;
  targetCaCertSecret?: InputMaybe<Scalars["String"]["input"]>;
  ttl?: InputMaybe<Scalars["String"]["input"]>;
};

/** KEV configuration - adjusts risk based on how many known exploits exist for a vulnerability */
export type KevConfiguration = {
  __typename: "KevConfiguration";
  /** Whether to factor known exploits into the exploitability score */
  enabled: Scalars["Boolean"]["output"];
  /** Weight of the KEV component */
  weight: Scalars["Float"]["output"];
};

/** KEV configuration input */
export type KevConfigurationInput = {
  /** Whether to factor known exploits into the exploitability score */
  enabled: Scalars["Boolean"]["input"];
  /** Weight of the KEV component */
  weight: Scalars["Float"]["input"];
};

/** Key-value pair for storing metadata */
export type KeyValue = {
  __typename: "KeyValue";
  /** The key of the key-value pair */
  key: Scalars["String"]["output"];
  /** The value of the key-value pair */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Input for key-value pair */
export type KeyValueInput = {
  /** The key of the key-value pair */
  key: Scalars["String"]["input"];
  /** The value of the key-value pair */
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/** A value with a KeyValueSource is derived from a key-value pair. */
export type KeyValueSource = {
  __typename: "KeyValueSource";
  /** The key of the key-value pair */
  key: Scalars["String"]["output"];
  /** The value of the key-value pair */
  value: Scalars["String"]["output"];
};

/** A Kubernetes job */
export type KubernetesJob = {
  __typename: "KubernetesJob";
  /** The author of the job */
  author: Scalars["String"]["output"];
  /** The cluster ID where the job ran */
  clusterId: Scalars["String"]["output"];
  /**
   * The grade of the job (deprecated)
   * @deprecated Grades will be removed in future. Use score.
   */
  grade: Grade;
  /** The ID of the job */
  id: Scalars["String"]["output"];
  /** The kind of resource the job operated on */
  kind: Scalars["String"]["output"];
  /** The MRN of the job */
  mrn: Scalars["String"]["output"];
  /** The name of the job */
  name: Scalars["String"]["output"];
  /** The namespace of the job */
  namespace: Scalars["String"]["output"];
  /** The operation performed by the job */
  operation: Scalars["String"]["output"];
  /** The owner kind of the job */
  ownerKind: Scalars["String"]["output"];
  /** The owner name of the job */
  ownerName: Scalars["String"]["output"];
  /** The owner UID of the job */
  ownerUid: Scalars["String"]["output"];
  /** The resource version of the job */
  resourceVersion: Scalars["String"]["output"];
  /** The score of the job */
  score: Score;
  /** The target of the job */
  target?: Maybe<Scalars["String"]["output"]>;
  /** The UID of the job */
  uid: Scalars["String"]["output"];
  /** The time the job was last updated */
  updatedAt: Scalars["String"]["output"];
};

/** Latest asset-scoped scan upload record. */
export type LatestScanUpload = {
  __typename: "LatestScanUpload";
  /** Error message if the upload terminated as FAILED. */
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  /**
   * When the upload reached a terminal status (PROCESSED or FAILED). Unset while
   * the upload is still in flight (RFC3339).
   */
  finishedAt?: Maybe<Scalars["String"]["output"]>;
  /** When the upload session was created (RFC3339). */
  startedAt?: Maybe<Scalars["String"]["output"]>;
  /** Current status of the upload. */
  status: ScanProcessingStatus;
};

/** Legal policy */
export type LegalPolicy = {
  __typename: "LegalPolicy";
  /** The consent for the policy */
  consent?: Maybe<Consent>;
  /** The ID of the policy */
  id: Scalars["String"]["output"];
  /** The name of the policy */
  name: Scalars["String"]["output"];
  /** The consent for the policy */
  updatedAt: Scalars["String"]["output"];
  /** The URL of the policy */
  url: Scalars["String"]["output"];
  /** The version of the policy */
  version: Scalars["String"]["output"];
};

/** Library statistics entry */
export type LibraryStatisticsEntry = {
  __typename: "LibraryStatisticsEntry";
  /** Key */
  key: Scalars["String"]["output"];
  /** Values */
  values: ReportStatsCves;
};

/** ListClientIntegrationsFilterInput provides filtering options for listing the client integrations */
export type ListClientIntegrationsFilterInput = {
  /** The managed clients filters */
  managedClientsFilters?: InputMaybe<ManagedClientsFilters>;
  /** type is deprecated, use types */
  type?: InputMaybe<ClientIntegrationType>;
  /** The list of integration types */
  types?: InputMaybe<Array<InputMaybe<ClientIntegrationType>>>;
};

/** ListClientIntegrationsInput describes the input for listing the integrations */
export type ListClientIntegrationsInput = {
  /** The filter query */
  filterQuery?: InputMaybe<ListClientIntegrationsFilterInput>;
  /** The scope MRN (space or organization) */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The space MRN
   * @deprecated Use scopeMrn instead
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** ListClientIntegrationsPayload is the response to a list of client integrations */
export type ListClientIntegrationsPayload = {
  __typename: "ListClientIntegrationsPayload";
  /** The list of client integrations */
  integrations: Array<Maybe<ClientIntegration>>;
};

/** List discovery results input */
export type ListDiscoveryResultsInput = {
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["input"];
};

/** List discovery results payload */
export type ListDiscoveryResultsPayload = {
  __typename: "ListDiscoveryResultsPayload";
  /** Statistics */
  stats?: Maybe<Array<DiscoveryStat>>;
};

/** Filter for listing documents */
export type ListDocumentsFilter = {
  /**
   * Restrict results to documents whose target_mrn is this finding
   * (policy, CVE, check, control, framework, ...).
   */
  findingMRN?: InputMaybe<Scalars["String"]["input"]>;
};

/** Exception groups list response */
export type ListExceptionGroupsConnection = {
  __typename: "ListExceptionGroupsConnection";
  /** Edges */
  edges?: Maybe<Array<ExceptionGroupEdge>>;
  /** Information about the current page */
  pageInfo: PageInfo;
  /** The total number of exception groups */
  totalCount: Scalars["Int"]["output"];
};

/** List exception groups filters */
export type ListExceptionGroupsFilter = {
  /** Filter by users who approved the exceptions */
  approvedBy?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filter by users who created the exceptions */
  createdBy?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filter by exception MRN */
  exceptionMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Filter by id of exception group
   * @deprecated Use exceptionMrn
   */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Include soft deleted exceptions */
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Include exception extensions */
  includeExtension?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Filter by review status
   * @deprecated Use statuses
   */
  reviewStatuses?: InputMaybe<Array<ReviewStatus>>;
  /** Filter by exception status */
  statuses?: InputMaybe<Array<ExceptionStatus>>;
  /**
   * Filter by valid until date. Input is string date.
   * The BE logic is exception.ValidUntil <= filter.validUntil
   * @deprecated Use validUntilTo
   */
  validUntil?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by validUntil time range */
  validUntilRange?: InputMaybe<TimeRange>;
};

/** The input to get a list of exception groups */
export type ListExceptionGroupsInput = {
  /** The action of the exception groups. Empty list means all. */
  actions?: InputMaybe<Array<ExceptionMutationAction>>;
  /** Additional filters */
  filter?: InputMaybe<ListExceptionGroupsFilter>;
  /**
   * Flag indicating whether to include exceptions in child scopes
   * If scopeMrn is a space and this flag is true, all exceptions defined on the space
   * and on all of the space's assets will be returned
   */
  includeChildScopes?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The mrn to filter on. It can be a query, control, policy or a framework */
  mrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Order by. If not provided the default ordering is by valid until and uid asc. */
  orderBy?: InputMaybe<ListExceptionGroupsOrder>;
  /** The mrn of the space/asset */
  scopeMrn: Scalars["String"]["input"];
  /**
   * Restrict results to exception groups owned by these space MRNs.
   * Used to scope an org-wide query to a subset of spaces.
   * Composes with scopeMrn + includeChildScopes (further restricts the result set).
   */
  spaceMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The types of the exceptions */
  types?: InputMaybe<Array<ExceptionType>>;
};

/** Exception groups order */
export type ListExceptionGroupsOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: ListExceptionGroupsOrderField;
};

/** Exception groups order field */
export enum ListExceptionGroupsOrderField {
  CreatedAt = "CREATED_AT",
  ValidUntil = "VALID_UNTIL",
}

/** List frameworks filter state */
export enum ListFrameworksFilterState {
  Active = "ACTIVE",
  Available = "AVAILABLE",
}

/** List frameworks input */
export type ListFrameworksInput = {
  /** The framework state to filter by. */
  filterState: ListFrameworksFilterState;
  /** The scope mrn for which to fetch frameworks. Currently only supported is a space mrn. */
  scopeMrn: Scalars["String"]["input"];
};

/** Response containing list of WIF auth bindings */
export type ListWifAuthBindingsPayload = {
  __typename: "ListWIFAuthBindingsPayload";
  /** The list of WIF auth bindings */
  bindings?: Maybe<Array<Maybe<WifAuthBinding>>>;
};

/** MProperty */
export type MProperty = {
  __typename: "MProperty";
  /** The property's MQL expression as defined on the policy. Always populated. */
  defaultValue: Scalars["String"]["output"];
  /** A list of properties this property can override */
  for: Array<MPropertyFor>;
  /**
   * Effective value: defaultValue, or overrideValue when one exists.
   * @deprecated Use defaultValue / overrideValue. Effective value = overrideValue || defaultValue.
   */
  mql: Scalars["String"]["output"];
  /** The mrn is a unique identifier */
  mrn: Scalars["ID"]["output"];
  /**
   * The space-level override MQL for this property. Empty string when no override
   * is set (or when the query is unscoped). When non-empty, this is the value
   * actually used when the policy is evaluated in the requested scope.
   */
  overrideValue: Scalars["String"]["output"];
  /**
   * setByPolicyMrn is the mrn of the policy that contributed the effective value.
   * Equals the policy's own MRN when defaultValue is in effect; equals the
   * space's asset-policy MRN when an override is in effect. Null when no scope
   * was provided.
   */
  setByPolicyMrn?: Maybe<Scalars["String"]["output"]>;
  /** The title */
  title: Scalars["String"]["output"];
  /** Unique resource identifier (uid) */
  uid: Scalars["ID"]["output"];
};

/** MPropertyFor */
export type MPropertyFor = {
  __typename: "MPropertyFor";
  /** MRN of a property the current property can override */
  mrn: Scalars["ID"]["output"];
};

/** Filters that can be used when listing managed clients */
export type ManagedClientsFilters = {
  /** The order by field */
  orderBy?: InputMaybe<AgentOrder>;
  /** The list of query strings */
  queryStrings?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The list of agent states */
  state?: InputMaybe<Array<AgentState>>;
  /** The list of agent versions */
  version?: InputMaybe<Array<AgentVersionFilter>>;
};

/** Manual effort to fix a finding */
export type ManualEffort = {
  __typename: "ManualEffort";
  /** Estimated effort for research */
  research: Scalars["Int"]["output"];
  /** Estimated effort for rollout */
  rollout: Scalars["Int"]["output"];
  /** Estimated effort for scripting */
  scripting: Scalars["Int"]["output"];
  /** Effort to remediate the finding without Mondoo help, in minutes */
  totalManualEffort: Scalars["Int"]["output"];
  /** Estimated effort for verification */
  verification: Scalars["Int"]["output"];
};

/** A member of a space or organization */
export type Member = {
  __typename: "Member";
  /** The identity of the member */
  identity: Identity;
  /** Resource */
  resource: ResourceInfo;
  /** The roles assigned to the member */
  roles: Array<Role>;
  /**
   * The user information
   * @deprecated Use identity
   */
  user?: Maybe<User>;
};

/** An edge in a members connection */
export type MemberEdge = {
  __typename: "MemberEdge";
  /** The cursor for this edge */
  cursor: Scalars["ID"]["output"];
  /** The member at the end of the edge */
  node?: Maybe<Member>;
};

/** Filter options for member identity types */
export enum MemberIdentityType {
  /** User who has been invited but hasn't signed up yet */
  PendingUser = "PENDING_USER",
  /** Service account */
  ServiceAccount = "SERVICE_ACCOUNT",
  /** Team */
  Team = "TEAM",
  /** Regular user */
  User = "USER",
}

/** Member statistics */
export type MemberStats = {
  __typename: "MemberStats";
  /** If there are more owners than returned in the sample */
  hasMoreOwners: Scalars["Boolean"]["output"];
  /** A sample of the owners */
  owners: Array<Identity>;
  /** The total number of members */
  total: Scalars["Int"]["output"];
};

/** Connection containing members */
export type MembersConnection = {
  __typename: "MembersConnection";
  /** The edges in the connection */
  edges?: Maybe<Array<MemberEdge>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** The total number of members */
  totalCount: Scalars["Int"]["output"];
};

/** Input for ordering memberships */
export type MembershipOrder = {
  /** The direction to order by */
  direction: OrderDirection;
  /** The field to order by */
  field: MembershipOrderField;
};

/** Field to order memberships by */
export enum MembershipOrderField {
  Name = "NAME",
}

/** Metric entry */
export type MetricEntry = {
  __typename: "MetricEntry";
  /** base64 arrow-encoded result */
  arrowResult?: Maybe<Scalars["String"]["output"]>;
  /** Metric description */
  description: Scalars["String"]["output"];
  /** Asset or Space Mrm */
  entityMrn: Scalars["String"]["output"];
  /** Metric id */
  id: Scalars["ID"]["output"];
  /** json-encoded result (not for production) */
  jsonResult?: Maybe<Scalars["Any"]["output"]>;
  /** MRN of the metric object */
  metricMrn: Scalars["String"]["output"];
  /** Metric title */
  title: Scalars["String"]["output"];
};

/** metrics response object */
export type MetricsResponse = {
  __typename: "MetricsResponse";
  /**
   * Metrics edges
   * metrics that are not found are ignored
   * input is treated like a search
   */
  entries?: Maybe<Array<MetricEntry>>;
};

/** Microsoft Defender configuration options */
export type MicrosoftDefenderConfigurationOptions = {
  __typename: "MicrosoftDefenderConfigurationOptions";
  /** clientId of the MS Defender instance */
  clientId: Scalars["String"]["output"];
  /** createAssets is a flag to create assets in the backend when they are not found */
  createAssets?: Maybe<Scalars["Boolean"]["output"]>;
  /** mondooEnrichment is a flag to enable mondoo scans based on the MS Defender data */
  mondooEnrichment?: Maybe<Scalars["Boolean"]["output"]>;
  /** certificate or client secret is required */
  secretType?: Maybe<Scalars["String"]["output"]>;
  /** subscriptionsAllowlist is a list of subscription IDs to include in the scan */
  subscriptionsAllowlist?: Maybe<Array<Scalars["String"]["output"]>>;
  /** subscriptionsDenylist is a list of subscription IDs to exclude from the scan */
  subscriptionsDenylist?: Maybe<Array<Scalars["String"]["output"]>>;
  /** tenantId of the MS Defender instance */
  tenantId: Scalars["String"]["output"];
};

/** Microsoft Defender integration input */
export type MicrosoftDefenderConfigurationOptionsInput = {
  /** certificate or client secret is required */
  certificate?: InputMaybe<Scalars["String"]["input"]>;
  /** clientId of the MS Defender instance */
  clientId: Scalars["String"]["input"];
  /** password used for authentication */
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  /** createAssets is a flag to create assets in the backend when they are not found */
  createAssets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** mondooEnrichment is a flag to enable mondoo scans based on the MS Defender data */
  mondooEnrichment?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** subscriptionsAllowlist is a list of subscription IDs to include in the scan */
  subscriptionsAllowlist?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** subscriptionsDenylist is a list of subscription IDs to exclude from the scan */
  subscriptionsDenylist?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** tenantId of the MS Defender instance */
  tenantId: Scalars["String"]["input"];
};

/** Modify risk factor input */
export type ModifyRiskFactorInput = {
  action?: InputMaybe<RiskFactorAction>;
  /** Asset field filters mutation */
  assetFieldFiltersMutation?: InputMaybe<AssetFieldFiltersMutation>;
  /** Risk factor magnitude modification */
  magnitude?: InputMaybe<RiskFactorMagnitudeModification>;
  /** Risk factor mrn */
  mrn: Scalars["String"]["input"];
};

/** Mquery */
export type Mquery = {
  __typename: "Mquery";
  /** Action */
  action: PolicyReportScoreEntryAction;
  /**
   * Code - deprecated
   * @deprecated Use mql
   */
  code: Scalars["String"]["output"];
  /**
   * CodeId - deprecated
   * @deprecated Use mrn
   */
  codeId: Scalars["String"]["output"];
  /** Docs */
  docs?: Maybe<MqueryDocs>;
  /** Impact */
  impact?: Maybe<Impact>;
  /** MQL */
  mql: Scalars["String"]["output"];
  /** The mrn is a unique identifier */
  mrn: Scalars["ID"]["output"];
  /** Parent */
  parent?: Maybe<Scalars["String"]["output"]>;
  /** Properties */
  properties?: Maybe<Array<MProperty>>;
  /**
   * Severity - deprecated
   * @deprecated Use impact
   */
  severity?: Maybe<Scalars["Int"]["output"]>;
  /** Tags */
  tags?: Maybe<Array<Tag>>;
  /** The title */
  title: Scalars["String"]["output"];
  /** unique resource identifier (uid) */
  uid: Scalars["ID"]["output"];
  /** Variant queries */
  variantQueries?: Maybe<Array<Maybe<MqueryVariant>>>;
  /** Variants */
  variants?: Maybe<Array<Variant>>;
};

/** Mquery asset data */
export type MqueryAssetData = MqueryAssetDataJson | MqueryAssetDataNone;

/** Mquery asset data connection */
export type MqueryAssetDataConnection = {
  __typename: "MqueryAssetDataConnection";
  /** Edges */
  edges?: Maybe<Array<MqueryAssetDataEdge>>;
  /** Mquery */
  mquery: Mquery;
  /** Page info */
  pageInfo: PageInfo;
};

/** Mquery asset data edge */
export type MqueryAssetDataEdge = {
  __typename: "MqueryAssetDataEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<QueryAssetData>;
};

/** Mquery asset data format */
export enum MqueryAssetDataFormat {
  Json = "JSON",
}

/** Mquery asset data input */
export type MqueryAssetDataInput = {
  /** Format */
  format?: InputMaybe<MqueryAssetDataFormat>;
  /** See AssetSearchInput */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** queryMrn is the MRN of the query to run */
  queryMrn: Scalars["String"]["input"];
  /** scopeMrn is the MRN of the space in which to search for assets */
  scopeMrn: Scalars["String"]["input"];
};

/** Mquery asset data JSON */
export type MqueryAssetDataJson = {
  __typename: "MqueryAssetDataJSON";
  /** Data */
  data: Scalars["String"]["output"];
};

/** Mquery asset data none */
export type MqueryAssetDataNone = {
  __typename: "MqueryAssetDataNone";
  /** Reason */
  reason?: Maybe<Scalars["String"]["output"]>;
};

/** Mquery asset scores connection */
export type MqueryAssetScoresConnection = {
  __typename: "MqueryAssetScoresConnection";
  /** Description */
  description: Scalars["String"]["output"];
  /** Docs */
  docs?: Maybe<MqueryDocs>;
  /** Edges */
  edges?: Maybe<Array<MqueryAssetScoresEdge>>;
  /** MQL */
  mql: Scalars["String"]["output"];
  /** Page info */
  pageInfo: PageInfo;
  /** Score distribution */
  scoreDistribution: MqueryResultsDistribution;
  /** The title */
  title: Scalars["String"]["output"];
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Mquery asset scores edge */
export type MqueryAssetScoresEdge = {
  __typename: "MqueryAssetScoresEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<QueryAssetScore>;
};

/** Mquery asset scores input */
export type MqueryAssetScoresInput = {
  /**
   * After is the pagination cursor. To paginate to the end of the search results,
   * keep calling search the the endCursor from the pageInfo response while the
   * hasNextPage field is true
   */
  after?: InputMaybe<Scalars["String"]["input"]>;
  /** Limit is the number of items to return. Defaults to 25 */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Order by */
  orderBy?: InputMaybe<AssetOrder>;
  /**
   * policyMrn is the MRN of the policy which the query is associated with.
   * If this is provided, the queryMrn will be converted to a code id.
   * This is temporary. We need to capture scores as MRNs, not code ids.
   * Until that happens, we need this.
   */
  policyMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** See AssetSearchInput */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** queryMrn is the MRN of the query to run */
  queryMrn: Scalars["String"]["input"];
  /** scopeMrn is the MRN of the space in which to search for assets */
  scopeMrn: Scalars["String"]["input"];
};

/** Mquery counts */
export type MqueryCounts = {
  __typename: "MqueryCounts";
  /** Data */
  data: Scalars["Int"]["output"];
  /** Scoring */
  scoring: Scalars["Int"]["output"];
  /** Total */
  total: Scalars["Int"]["output"];
};

/** Mquery docs */
export type MqueryDocs = {
  __typename: "MqueryDocs";
  /**
   * Audit (deprecated use remediations)
   * @deprecated Use remediations
   */
  audit: Scalars["String"]["output"];
  /** Description */
  desc: Scalars["String"]["output"];
  /** References */
  references?: Maybe<Array<MqueryRef>>;
  /**
   * Remediation (deprecated use remediations)
   * @deprecated Use remediations
   */
  remediation: Scalars["String"]["output"];
  /** Remediations */
  remediations?: Maybe<RemediationResult>;
};

/** MqueryInput */
export type MqueryInput = {
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["input"];
};

/** Mquery reference */
export type MqueryRef = {
  __typename: "MqueryRef";
  /** The title */
  title: Scalars["String"]["output"];
  /** URL */
  url: Scalars["String"]["output"];
};

/** Mquery remediation */
export type MqueryRemediation = {
  __typename: "MqueryRemediation";
  /** Description */
  desc: Scalars["String"]["output"];
  /** ID */
  id: Scalars["String"]["output"];
  /** Friendly name for the ID */
  idName: Scalars["String"]["output"];
};

/** Mquery results distribution */
export type MqueryResultsDistribution = {
  __typename: "MqueryResultsDistribution";
  /** The number of assets with errors */
  error: Scalars["Int"]["output"];
  /** The number of assets that fail */
  fail: Scalars["Int"]["output"];
  /** The number of assets that pass */
  pass: Scalars["Int"]["output"];
  /** The total number of assets */
  total: Scalars["Int"]["output"];
  /** The number of assets with unknown score */
  unknown: Scalars["Int"]["output"];
};

/** Mquery score */
export type MqueryScore = {
  __typename: "MqueryScore";
  /** Query */
  query: Mquery;
  /** Score distribution */
  scoreDistribution: MqueryResultsDistribution;
  /** Variants */
  variants?: Maybe<Array<MqueryScore>>;
};

/** Mquery score input */
export type MqueryScoreInput = {
  /** queryMrn is the MRN of the query to run */
  queryMrn: Scalars["String"]["input"];
  /** scopeMrn is the MRN of the space in which to search for assets */
  scopeMrn: Scalars["String"]["input"];
};

/** Mquery state */
export enum MqueryState {
  Disabled = "DISABLED",
  Enabled = "ENABLED",
  /** @deprecated Use RISK_ACCEPTED */
  Ignored = "IGNORED",
  RiskAccepted = "RISK_ACCEPTED",
  /** @deprecated Use RISK_ACCEPTED */
  Snoozed = "SNOOZED",
}

/** Mquery summary */
export type MquerySummary = {
  __typename: "MquerySummary";
  /** Asset grades */
  assetGrades: AssetGradeDistribution;
  /** Enhanced asset scores */
  enhancedAssetScores?: Maybe<Array<QueryAssetScore>>;
  /** Exception */
  exception?: Maybe<MquerySummaryException>;
  /** id */
  id: Scalars["ID"]["output"];
  /** Mquery */
  mquery: Mquery;
  /** Mquery state */
  mqueryState: MqueryState;
  /** Mquery type */
  mqueryType: MqueryType;
};

/** Mquery summary edge */
export type MquerySummaryEdge = {
  __typename: "MquerySummaryEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<MquerySummary>;
};

/** Mquery summary exception */
export type MquerySummaryException = {
  __typename: "MquerySummaryException";
  /** Action */
  action: ExceptionMutationAction;
  /** ID */
  id: Scalars["String"]["output"];
  /** Justification */
  justification: Scalars["String"]["output"];
  /** Review status */
  reviewStatus: ReviewStatus;
};

/** Mquery type */
export enum MqueryType {
  Data = "DATA",
  Scoring = "SCORING",
}

/** MqueryVariant */
export type MqueryVariant = {
  __typename: "MqueryVariant";
  /** Docs */
  docs?: Maybe<MqueryDocs>;
  /** Filter */
  filter: Scalars["String"]["output"];
  /** Filter identifier */
  filterID: Scalars["String"]["output"];
  /** Impact */
  impact?: Maybe<Impact>;
  /** MQL */
  mql: Scalars["String"]["output"];
  /** The mrn is a unique identifier */
  mrn: Scalars["ID"]["output"];
  /** Properties */
  properties?: Maybe<Array<Maybe<MProperty>>>;
  /** Tags */
  tags?: Maybe<Array<Tag>>;
  /** The title */
  title: Scalars["String"]["output"];
  /** Unique resource identifier (uid) */
  uid: Scalars["ID"]["output"];
};

/** MS365 configuration options */
export type Ms365ConfigurationOptions = {
  __typename: "Ms365ConfigurationOptions";
  /** The MS365 client ID */
  clientId: Scalars["String"]["output"];
  /** The MS365 tenant ID */
  tenantId: Scalars["String"]["output"];
  /** Whether the integration authenticates via Workload Identity Federation. */
  useWif?: Maybe<Scalars["Boolean"]["output"]>;
  /** OIDC audience for the Entra token exchange (api://AzureADTokenExchange). */
  wifAudience?: Maybe<Scalars["String"]["output"]>;
  /** Deployment OIDC issuer (STS endpoint) the customer trusts in the federated credential. */
  wifIssuerURL?: Maybe<Scalars["String"]["output"]>;
  /** Computed OIDC subject for WIF token requests. */
  wifSubject?: Maybe<Scalars["String"]["output"]>;
};

/** MS365 integration input */
export type Ms365ConfigurationOptionsInput = {
  /** TODO: temporary optional, fix by having separate update models */
  certificate?: InputMaybe<Scalars["String"]["input"]>;
  /** The MS365 client ID */
  clientId: Scalars["String"]["input"];
  /** The MS365 tenant ID */
  tenantId: Scalars["String"]["input"];
  /**
   * Use keyless Workload Identity Federation instead of a certificate/secret.
   * tenantId + clientId remain required; no certificate is provided in this mode.
   */
  useWif?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** MS Intune configuration options */
export type MsIntuneConfigurationOptions = {
  __typename: "MsIntuneConfigurationOptions";
  /** The MS Intune client ID */
  clientId: Scalars["String"]["output"];
  /** The MS Intune tenant ID */
  tenantId: Scalars["String"]["output"];
};

/** MS Intune configuration options input */
export type MsIntuneConfigurationOptionsInput = {
  /** The PEM certificate for certificate-based authentication */
  certificate?: InputMaybe<Scalars["String"]["input"]>;
  /** The MS Intune client ID */
  clientId: Scalars["String"]["input"];
  /** The client secret for password-based authentication */
  password?: InputMaybe<Scalars["String"]["input"]>;
  /** The MS Intune tenant ID */
  tenantId: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type Mutation = {
  __typename: "Mutation";
  /**
   * Accept an invitation by MRN
   * @deprecated Invitations are going away. Use setRoles to add roles to an identity instead.
   */
  acceptInvitation: Scalars["Boolean"]["output"];
  /** Accept legal policy */
  acceptLegalPolicy: Scalars["Boolean"]["output"];
  /** Activate a user in a region */
  activateUserInRegion: ActivateUserInRegionPayload;
  /**
   * DEPRECATED: use setPolicy instead
   * Uploads policy content
   * @deprecated use setCustomPolicy instead
   */
  addPolicy: Scalars["Boolean"]["output"];
  /**
   * DEPRECATED: use setQueryPack instead
   * Uploads query pack content
   * @deprecated use setCustomQueryPack instead
   */
  addQueryPack: Scalars["Boolean"]["output"];
  /** Add a new SSH key for a user */
  addSSHKey: AddSshKeyPayload;
  /** Add external group mapping to a team */
  addTeamExternalGroupMapping: TeamExternalGroupMapping;
  /** Add a user to a team */
  addTeamMember: AddTeamMemberResponse;
  /** Add an edge between two nodes. */
  addWorkflowEdge: AddWorkflowEdgePayload;
  /** Add a node to the workflow graph. */
  addWorkflowNode: AddWorkflowNodePayload;
  /**
   * Apply an Exception to a control, check, CVE or advisory
   * @deprecated Use createException instead
   */
  applyException: Scalars["Boolean"]["output"];
  /** Review exception extension. */
  applyExceptionExtensionReview: Scalars["Boolean"]["output"];
  /**
   * Apply an Exception to a control, check, CVE or advisory for multiple scopes
   * @deprecated Use createExceptionForScopes instead
   */
  applyExceptionForScopes: Scalars["Boolean"]["output"];
  /** Apply a Review to an Exception (approve/reject) */
  applyExceptionReview: Scalars["Boolean"]["output"];
  /** Applies a mutation to a specific compliance framework */
  applyFrameworkMutation: Scalars["Boolean"]["output"];
  /** Apply Intune remediation scripts to a device group */
  applyIntuneRemediation: ApplyIntuneRemediationPayload;
  /** Applies a mutation to a property. */
  applyPropertyQueryMutation: PropertyQueryMutationPayload;
  /** Approve a pending human-in-the-loop step and continue execution. */
  approveWorkflowStep: ApproveWorkflowStepPayload;
  /** Assign a policy to a space */
  assignPolicy: Scalars["Boolean"]["output"];
  /** Create a scheduled export for a BI dashboard */
  biCreateScheduledExport: BiScheduledExport;
  /** Delete a scheduled export */
  biDeleteScheduledExport: Scalars["Boolean"]["output"];
  /** Pin a BI dashboard version to prevent pruning */
  biPinVersion: Scalars["Boolean"]["output"];
  /** Unpin a BI dashboard version */
  biUnpinVersion: Scalars["Boolean"]["output"];
  /** Update a scheduled export */
  biUpdateScheduledExport: BiScheduledExport;
  /**
   * Cancel in-flight generation for the given assessment UIDs without
   * restarting. A row that already completed successfully is left untouched
   * (finish beats cancel). Admin-only recovery operation.
   */
  cancelAssessments: AssessmentsResponse;
  /** Cancel an initiative */
  cancelInitiative: Scalars["Boolean"]["output"];
  /**
   * Cancel an invitation by MRN
   * @deprecated Invitations are going away. Use setRoles to add roles to an identity instead.
   */
  cancelInvitation: Scalars["Boolean"]["output"];
  /** Cancel a running security pipeline workflow by its MRN. */
  cancelSecurityPipelineWorkflow: Scalars["Boolean"]["output"];
  /** Cancel a running workflow execution. */
  cancelWorkflowExecution: CancelWorkflowExecutionPayload;
  /** Change the subscription plan for an organization */
  changeSubscriptionPlan: ChangeSubscriptionPlanAction;
  /** Change viewer setting */
  changeViewerSetting: Scalars["Boolean"]["output"];
  /**
   * Clear all asset routing rules for a scope.
   * Provide either orgMrn (deprecated) or scopeMrn.
   */
  clearAssetRoutingTable: Scalars["Boolean"]["output"];
  /** Close case */
  closeCase: Scalars["Boolean"]["output"];
  /** Create an individual asset routing rule within a scope. */
  createAssetRoutingRule: AssetRoutingRule;
  /** Create a new BI dashboard */
  createBIDashboard: BiDashboard;
  /** Create a billing session for subscription management */
  createBillingSession: BillingSession;
  /** Create a case */
  createCase: Case;
  /** Create a client integration */
  createClientIntegration: CreateClientIntegrationPayload;
  /** Create a new credential and store its secret data in the vault. */
  createCredential: CreateCredentialPayload;
  /**
   * Apply an Exception to a control, check, CVE or advisory
   * Returns the exception
   */
  createException: CreateExceptionResponse;
  /**
   * Apply an Exception to a control, check, CVE or advisory for multiple scopes.
   * It returns the exceptions for the scopes.
   */
  createExceptionForScopes: CreateExceptionForScopesResponse;
  /**
   * Create a new invitation
   * @deprecated Invitations are going away. Use setRoles to add roles to an identity instead.
   */
  createInvitation: Invitation;
  /** Create an organization */
  createOrganization?: Maybe<Organization>;
  /** Create a new security pipeline pull request for specified findings and assets. */
  createSecurityPipelinePullRequest: CreateSecurityPipelinePullRequestResponse;
  /** Create a new security pipeline scheduled workflow. */
  createSecurityPipelineScheduledWorkflow: CreateSecurityPipelineScheduledWorkflowResponse;
  /** Create a new security pipeline workflow for specified findings and assets. */
  createSecurityPipelineWorkflow: CreateSecurityPipelineWorkflowResponse;
  /** Create a new service account */
  createServiceAccount?: Maybe<ServiceAccountCredential>;
  /** Create a space */
  createSpace?: Maybe<Space>;
  /** Create a team */
  createTeam: Team;
  /** Create a new Workload Identity Federation (WIF) auth binding */
  createWIFAuthBinding?: Maybe<CreateWifAuthBindingPayload>;
  /** Create a new workflow from a YAML definition. */
  createWorkflow: CreateWorkflowPayload;
  /**
   * Create a new workflow from a template. The display name defaults to the
   * template's name; the server appends " (2)", " (3)", … on collision so the
   * user always gets a friendly name without having to guess uniqueness.
   * Variables are substituted into the template body before saving.
   */
  createWorkflowFromTemplate: CreateWorkflowFromTemplatePayload;
  /** Create a workflow resource (global variable). */
  createWorkflowResource: CreateWorkflowResourcePayload;
  /** Create a Temporal schedule for recurring workflow execution. */
  createWorkflowSchedule: CreateWorkflowSchedulePayload;
  /** Create a workspace */
  createWorkspace: Workspace;
  /**
   * Decline an invitation by MRN
   * @deprecated Invitations are going away. Use setRoles to add roles to an identity instead.
   */
  declineInvitation: Scalars["Boolean"]["output"];
  /** Delete an API token */
  deleteAPIToken?: Maybe<DeleteApiTokenResponse>;
  /** Delete agents (managed client) */
  deleteAgents: DeleteAgentsPayload;
  /** Delete an individual asset routing rule by MRN. */
  deleteAssetRoutingRule: Scalars["Boolean"]["output"];
  /** Delete assets */
  deleteAssets?: Maybe<DeleteAssetsPayload>;
  /** Delete (archive) a BI dashboard */
  deleteBIDashboard: Scalars["Boolean"]["output"];
  /** Delete cases */
  deleteCases: Scalars["Boolean"]["output"];
  /** Delete CI/CD projects */
  deleteCicdProjects: DeleteProjectsPayload;
  /** Delete a client integration */
  deleteClientIntegration: DeleteClientIntegrationPayload;
  /** Permanently delete a credential and its vault data. */
  deleteCredential: DeleteCredentialPayload;
  /** Deletes a query pack */
  deleteCustomPolicy: DeleteCustomPolicyPayload;
  /** Deletes a query pack */
  deleteCustomQueryPack: DeleteCustomQueryPackPayload;
  /** Delete a document */
  deleteDocument: Scalars["Boolean"]["output"];
  /** Delete exceptions for a given space. */
  deleteExceptions: Scalars["Boolean"]["output"];
  /** Deletes a custom compliance framework */
  deleteFramework: Scalars["Boolean"]["output"];
  /** Delete an organization */
  deleteOrganization?: Maybe<Scalars["ID"]["output"]>;
  /**
   * DEPRECATED: use deletePolicyV2 instead
   * Deletes a policy
   * @deprecated use deleteCustomPolicy instead
   */
  deletePolicy: Scalars["Boolean"]["output"];
  /** Delete an SSH key for a user */
  deleteSSHKey: DeleteSshKeyPayload;
  /** Delete security pipeline scheduled workflows by their MRNs. */
  deleteSecurityPipelineScheduledWorkflow: Scalars["Boolean"]["output"];
  /** Delete security pipeline workflows by their MRNs. */
  deleteSecurityPipelineWorkflow: Scalars["Boolean"]["output"];
  /** Delete one or more service accounts */
  deleteServiceAccounts: DeleteServiceAccountsPayload;
  /** Delete a space */
  deleteSpace?: Maybe<Scalars["ID"]["output"]>;
  /** Delete a team */
  deleteTeam: Scalars["Boolean"]["output"];
  /** Delete viewer setting */
  deleteViewerSetting: Scalars["Boolean"]["output"];
  /** Permanently delete a workflow and all its execution history. */
  deleteWorkflow: DeleteWorkflowPayload;
  /** Delete an edge between two nodes. */
  deleteWorkflowEdge: DeleteWorkflowEdgePayload;
  /** Delete a node and its edges from the workflow graph. */
  deleteWorkflowNode: DeleteWorkflowNodePayload;
  /** Delete a workflow resource. */
  deleteWorkflowResource: DeleteWorkflowResourcePayload;
  /** Delete a workflow schedule. */
  deleteWorkflowSchedule: DeleteWorkflowSchedulePayload;
  /** Delete workspaces */
  deleteWorkspaces: Scalars["Boolean"]["output"];
  /** Deny a pending human-in-the-loop step. Execution follows the denial branch. */
  denyWorkflowStep: DenyWorkflowStepPayload;
  /** Enable the SSO provider for an organization */
  enableSSOProvider: Scalars["Boolean"]["output"];
  /** Export a workflow as YAML. */
  exportWorkflowYaml: ExportWorkflowYamlPayload;
  /**
   * Extend exceptions active period.
   * Only applies to exceptions with valid until.
   */
  extendException: Scalars["Boolean"]["output"];
  /** Forks a compliance framework */
  forkFramework: Scalars["Boolean"]["output"];
  /** Generate a new API token */
  generateAPIToken: GenerateApiTokenResponse;
  /** Generate a document */
  generateDocument: GenerateDocumentPayload;
  /**
   * Generates a new policy
   * @deprecated this query will be removed
   */
  generatePolicy: GeneratePolicyPayload;
  /** Generate a new registration token */
  generateRegistrationToken: RegistrationToken;
  /** Import a workflow from raw YAML into a scope. */
  importWorkflowYaml: ImportWorkflowYamlPayload;
  /** Modify the risk factors for a space */
  modifyRiskFactors: Scalars["Boolean"]["output"];
  /** Pause a workflow schedule. */
  pauseWorkflowSchedule: PauseWorkflowSchedulePayload;
  /** Process case events */
  processCaseEvents: Scalars["Boolean"]["output"];
  /**
   * Reactivate an inactive space, clearing the inactive flag and resuming its
   * background processing. The optional reason is recorded for observability.
   * Spaces are deactivated automatically by a background job; deactivation is
   * not exposed through the GraphQL API.
   */
  reactivateSpace?: Maybe<Space>;
  /** Refreshes the aggregate risk scores for the given group mrn */
  refreshAggregateScores: Scalars["Boolean"]["output"];
  /**
   * Force-regenerate the given assessment UIDs: cancel any in-flight run and
   * start a fresh one, bypassing the generator's ShouldGenerate decision.
   * Admin-only recovery operation; returns the in-flight state so the UI can
   * render it without a follow-up query.
   */
  regenerateAssessments: AssessmentsResponse;
  /** Notify that a specific action was taken in the ui */
  registerUserAction: Scalars["Boolean"]["output"];
  /** Remove organization membership */
  removeOrganizationMembership: Scalars["Boolean"]["output"];
  /** Remove the SSO provider for an organization */
  removeSSOProvider: Scalars["Boolean"]["output"];
  /** Remove space membership */
  removeSpaceMembership: Scalars["Boolean"]["output"];
  /** Remove external group mapping from a team */
  removeTeamExternalGroupMapping: Scalars["Boolean"]["output"];
  /** Remove a user from a team */
  removeTeamMember: RemoveTeamMemberResponse;
  /** Remove a Workload Identity Federation (WIF) auth binding by MRN */
  removeWIFAuthBinding?: Maybe<RemoveWifAuthBindingPayload>;
  /** Notify that a report has been viewed */
  reportViewed: Scalars["Boolean"]["output"];
  /**
   * Request an AI-generated summary for an asset or specific findings on an asset.
   * Returns immediately with the current state of the summary.
   * If no summary exists, triggers async generation and returns state GENERATING.
   * When findingMrns is empty or omitted, generates an asset-level summary.
   * When findingMrns is provided, generates a finding-specific summary.
   * Unsupported (non-compute) asset types return NOT_AVAILABLE without
   * triggering generation.
   */
  requestAiSummary: AiSummaryPayload;
  /** Request s signed URL for downloading a document */
  requestDocumentDownloadUrl: DocumentDownloadPayload;
  /**
   * Resend an invitation by MRN
   * @deprecated Invitations are going away. Use setRoles to add roles to an identity instead.
   */
  resendInvitation: Scalars["Boolean"]["output"];
  /**
   * Reset a workflow's YAML to the latest version of its source template.
   * Saves current YAML as a version snapshot before resetting.
   */
  resetWorkflowToTemplate: ResetWorkflowToTemplatePayload;
  /** Restore a previous version of a BI dashboard */
  restoreBIDashboardVersion: BiDashboard;
  /** Resume a paused workflow schedule. */
  resumeWorkflowSchedule: ResumeWorkflowSchedulePayload;
  /** Revoke a registration token */
  revokeRegistrationToken?: Maybe<RevokeRegistrationTokenResponse>;
  /** Replace a credential's secret data. Validates the new data before committing. */
  rotateCredential: RotateCredentialPayload;
  /** Save a new version of a BI dashboard */
  saveBIDashboardVersion: BiDashboard;
  /** Set asset annotations for a specific asset */
  setAssetAnnotations?: Maybe<SetAssetAnnotationsPayload>;
  /** Set the asset routing table for a scope (replaces existing). */
  setAssetRoutingTable: AssetRoutingTable;
  /** Updates a policy with the provided content */
  setCustomPolicy: SetCustomPolicyPayload;
  /** Updates a query pack with the provided content */
  setCustomQueryPack: SetCustomQueryPackPayload;
  /** Set email preference */
  setEmailPreference: Scalars["Boolean"]["output"];
  /** Set an integration */
  setIntegration: Scalars["Boolean"]["output"];
  /** Set organization membership */
  setOrganizationMembership: Scalars["Boolean"]["output"];
  /**
   * Set contacts for a resource (space, organization, or workspace).
   * Uses replacement semantics: all existing contacts are replaced.
   * Pass an empty list to clear all contacts.
   */
  setResourceContacts: Array<ResourceContact>;
  /** Set roles for a user or entity */
  setRoles?: Maybe<SetRolesPayload>;
  /** Set the SSO provider for an organization */
  setSSOProvider: Scalars["Boolean"]["output"];
  /** Set the SCIM group to space mapping */
  setScimGroupMapping: SetScimGroupMappingPayload;
  /** DEPRECATED - use setRoles instead */
  setSpaceMembership: Scalars["Boolean"]["output"];
  /** Suppress an integration message */
  suppressIntegrationMessage: SuppressIntegrationMessagePayload;
  /** Run a health check against the credential's external service. */
  testCredential: TestCredentialPayload;
  /** Trigger an ad-hoc audit log export for download. */
  triggerAuditLogExport: TriggerAuditLogExportPayload;
  /** Trigger regeneration of the interconnection graph for an organization */
  triggerInterconnectionGraphRegeneration: Scalars["Boolean"]["output"];
  /** Trigger a scheduled security pipeline workflow immediately by its MRN. */
  triggerSecurityPipelineScheduledWorkflow: Scalars["Boolean"]["output"];
  /** Start a new execution of a workflow. */
  triggerWorkflow: TriggerWorkflowPayload;
  /** Unassign a policy from a space */
  unassignPolicy: Scalars["Boolean"]["output"];
  /** Removes the linked Github account from the current user. */
  unpairGithub: Scalars["Boolean"]["output"];
  /** Update an API token's information */
  updateAPIToken?: Maybe<ApiToken>;
  /** Update an agent (managed client) */
  updateAgent: UpdateAgentPayload;
  /** Update an existing asset routing rule. */
  updateAssetRoutingRule: AssetRoutingRule;
  /** Update a BI dashboard's metadata */
  updateBIDashboard: BiDashboard;
  /** Update BI tag configuration for a scope */
  updateBITagConfig: BiTagConfig;
  /** Update a client integration */
  updateClientIntegrationConfiguration: UpdateClientIntegrationConfigurationPayload;
  /** Update an organization */
  updateOrganization: UpdateOrganizationPayload;
  /** Update the security model for the given scope */
  updateSecurityModel?: Maybe<SecurityModel>;
  /** Update security pipeline scheduled workflow. */
  updateSecurityPipelineScheduledWorkflow: UpdateSecurityPipelineScheduledWorkflowResponse;
  /** Update a service account's information */
  updateServiceAccount?: Maybe<ServiceAccount>;
  /** Update a space */
  updateSpace: UpdateSpacePayload;
  /** Update a team */
  updateTeam: Team;
  /** Update a user's information */
  updateUser: UpdateUserPayload;
  /** Update an existing workflow's metadata, YAML, or state. */
  updateWorkflow: UpdateWorkflowPayload;
  /** Update fields on a workflow node. */
  updateWorkflowNode: UpdateWorkflowNodePayload;
  /** Update node positions (batch — for drag operations). */
  updateWorkflowPositions: UpdateWorkflowPositionsPayload;
  /** Update a workflow resource value. */
  updateWorkflowResource: UpdateWorkflowResourcePayload;
  /** Update a workflow schedule. */
  updateWorkflowSchedule: UpdateWorkflowSchedulePayload;
  /** Update a workspace */
  updateWorkspace: Workspace;
  /** Upload a compliance framework */
  uploadFramework: Scalars["Boolean"]["output"];
  /** Validate a workflow YAML without saving it. */
  validateWorkflow: ValidateWorkflowPayload;
};

/** Root mutation type for IAM operations */
export type MutationAcceptInvitationArgs = {
  invitationMrn: Scalars["ID"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationAcceptLegalPolicyArgs = {
  input: AcceptLegalPolicy;
};

/** Root mutation type for IAM operations */
export type MutationAddPolicyArgs = {
  input: Array<PolicyAddInput>;
};

/** Root mutation type for IAM operations */
export type MutationAddQueryPackArgs = {
  input: Array<QueryPackAddInput>;
};

/** Root mutation type for IAM operations */
export type MutationAddSshKeyArgs = {
  input: AddSshKeyRequest;
};

/** Root mutation type for IAM operations */
export type MutationAddTeamExternalGroupMappingArgs = {
  input: AddTeamExternalGroupMappingInput;
};

/** Root mutation type for IAM operations */
export type MutationAddTeamMemberArgs = {
  input: AddTeamMemberInput;
};

/** Root mutation type for IAM operations */
export type MutationAddWorkflowEdgeArgs = {
  input: AddWorkflowEdgeInput;
};

/** Root mutation type for IAM operations */
export type MutationAddWorkflowNodeArgs = {
  input: AddWorkflowNodeInput;
};

/** Root mutation type for IAM operations */
export type MutationApplyExceptionArgs = {
  input: ExceptionMutationInput;
};

/** Root mutation type for IAM operations */
export type MutationApplyExceptionExtensionReviewArgs = {
  input: ExtendExceptionReviewInput;
};

/** Root mutation type for IAM operations */
export type MutationApplyExceptionForScopesArgs = {
  input: ApplyExceptionForScopesInput;
};

/** Root mutation type for IAM operations */
export type MutationApplyExceptionReviewArgs = {
  input: ExceptionReviewInput;
};

/** Root mutation type for IAM operations */
export type MutationApplyFrameworkMutationArgs = {
  input: ComplianceFrameworkMutationInput;
};

/** Root mutation type for IAM operations */
export type MutationApplyIntuneRemediationArgs = {
  input: ApplyIntuneRemediationInput;
};

/** Root mutation type for IAM operations */
export type MutationApplyPropertyQueryMutationArgs = {
  input: PropertyQueryMutationInput;
};

/** Root mutation type for IAM operations */
export type MutationApproveWorkflowStepArgs = {
  input: ApproveWorkflowStepInput;
};

/** Root mutation type for IAM operations */
export type MutationAssignPolicyArgs = {
  input: PolicyAssignmentInput;
};

/** Root mutation type for IAM operations */
export type MutationBiCreateScheduledExportArgs = {
  input: BiCreateScheduledExportInput;
};

/** Root mutation type for IAM operations */
export type MutationBiDeleteScheduledExportArgs = {
  input: BiDeleteScheduledExportInput;
};

/** Root mutation type for IAM operations */
export type MutationBiPinVersionArgs = {
  input: BiPinVersionInput;
};

/** Root mutation type for IAM operations */
export type MutationBiUnpinVersionArgs = {
  input: BiPinVersionInput;
};

/** Root mutation type for IAM operations */
export type MutationBiUpdateScheduledExportArgs = {
  input: BiUpdateScheduledExportInput;
};

/** Root mutation type for IAM operations */
export type MutationCancelAssessmentsArgs = {
  entityMrn: Scalars["String"]["input"];
  uids: Array<Scalars["String"]["input"]>;
};

/** Root mutation type for IAM operations */
export type MutationCancelInitiativeArgs = {
  entityMrn: Scalars["String"]["input"];
  initiativeMrn: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationCancelInvitationArgs = {
  invitationMrn: Scalars["ID"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationCancelSecurityPipelineWorkflowArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationCancelWorkflowExecutionArgs = {
  input: CancelWorkflowExecutionInput;
};

/** Root mutation type for IAM operations */
export type MutationChangeSubscriptionPlanArgs = {
  input: ChangeSubscriptionPlanInput;
};

/** Root mutation type for IAM operations */
export type MutationChangeViewerSettingArgs = {
  key: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationClearAssetRoutingTableArgs = {
  orgMrn?: InputMaybe<Scalars["String"]["input"]>;
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root mutation type for IAM operations */
export type MutationCloseCaseArgs = {
  input: CloseCaseInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateAssetRoutingRuleArgs = {
  input: CreateAssetRoutingRuleInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateBiDashboardArgs = {
  input: CreateBiDashboardInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateBillingSessionArgs = {
  input: BillingSessionInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateCaseArgs = {
  input: CreateCaseInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateClientIntegrationArgs = {
  input: CreateClientIntegrationInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateCredentialArgs = {
  input: CreateCredentialInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateExceptionArgs = {
  input: ExceptionMutationInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateExceptionForScopesArgs = {
  input: ApplyExceptionForScopesInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateSecurityPipelinePullRequestArgs = {
  input: CreateSecurityPipelinePullRequestInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateSecurityPipelineScheduledWorkflowArgs = {
  input: CreateSecurityPipelineScheduledWorkflowInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateSecurityPipelineWorkflowArgs = {
  input: CreateSecurityPipelineWorkflowInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateServiceAccountArgs = {
  input: CreateServiceAccountInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateSpaceArgs = {
  input: CreateSpaceInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateWifAuthBindingArgs = {
  input?: InputMaybe<CreateWifAuthBindingInput>;
};

/** Root mutation type for IAM operations */
export type MutationCreateWorkflowArgs = {
  input: CreateWorkflowInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateWorkflowFromTemplateArgs = {
  input: CreateWorkflowFromTemplateInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateWorkflowResourceArgs = {
  input: CreateWorkflowResourceInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateWorkflowScheduleArgs = {
  input: CreateWorkflowScheduleInput;
};

/** Root mutation type for IAM operations */
export type MutationCreateWorkspaceArgs = {
  input: CreateWorkspaceInput;
};

/** Root mutation type for IAM operations */
export type MutationDeclineInvitationArgs = {
  invitationMrn: Scalars["ID"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationDeleteApiTokenArgs = {
  input: DeleteApiTokenInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteAgentsArgs = {
  input: DeleteAgentsInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteAssetRoutingRuleArgs = {
  ruleMrn: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationDeleteAssetsArgs = {
  input: DeleteAssetsInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteBiDashboardArgs = {
  input: DeleteBiDashboardInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteCasesArgs = {
  input: DeleteCasesInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteCicdProjectsArgs = {
  input: DeleteProjectsInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteClientIntegrationArgs = {
  input: DeleteClientIntegrationInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteCredentialArgs = {
  input: DeleteCredentialInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteCustomPolicyArgs = {
  input: DeleteCustomPolicyInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteCustomQueryPackArgs = {
  input: DeleteCustomQueryPackInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteDocumentArgs = {
  documentMRN: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationDeleteExceptionsArgs = {
  input: ExceptionsDeleteInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteFrameworkArgs = {
  input: DeleteFrameworkInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteOrganizationArgs = {
  orgMrn: Scalars["ID"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationDeletePolicyArgs = {
  input: PolicyDeleteInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteSshKeyArgs = {
  input: DeleteSshKeyRequest;
};

/** Root mutation type for IAM operations */
export type MutationDeleteSecurityPipelineScheduledWorkflowArgs = {
  mrns: Array<Scalars["String"]["input"]>;
};

/** Root mutation type for IAM operations */
export type MutationDeleteSecurityPipelineWorkflowArgs = {
  mrns: Array<Scalars["String"]["input"]>;
};

/** Root mutation type for IAM operations */
export type MutationDeleteServiceAccountsArgs = {
  input: DeleteServiceAccountsInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteSpaceArgs = {
  spaceMrn: Scalars["ID"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationDeleteTeamArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationDeleteViewerSettingArgs = {
  key: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationDeleteWorkflowArgs = {
  input: DeleteWorkflowInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteWorkflowEdgeArgs = {
  input: DeleteWorkflowEdgeInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteWorkflowNodeArgs = {
  input: DeleteWorkflowNodeInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteWorkflowResourceArgs = {
  input: DeleteWorkflowResourceInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteWorkflowScheduleArgs = {
  input: DeleteWorkflowScheduleInput;
};

/** Root mutation type for IAM operations */
export type MutationDeleteWorkspacesArgs = {
  input: DeleteWorkspacesInput;
};

/** Root mutation type for IAM operations */
export type MutationDenyWorkflowStepArgs = {
  input: DenyWorkflowStepInput;
};

/** Root mutation type for IAM operations */
export type MutationEnableSsoProviderArgs = {
  input: EnableSsoProviderInput;
};

/** Root mutation type for IAM operations */
export type MutationExportWorkflowYamlArgs = {
  input: ExportWorkflowYamlInput;
};

/** Root mutation type for IAM operations */
export type MutationExtendExceptionArgs = {
  input: ExtendExceptionInput;
};

/** Root mutation type for IAM operations */
export type MutationForkFrameworkArgs = {
  input: ForkFrameworkInput;
};

/** Root mutation type for IAM operations */
export type MutationGenerateApiTokenArgs = {
  input: GenerateApiTokenInput;
};

/** Root mutation type for IAM operations */
export type MutationGenerateDocumentArgs = {
  input: GenerateDocumentInput;
};

/** Root mutation type for IAM operations */
export type MutationGeneratePolicyArgs = {
  input: GeneratePolicyInput;
};

/** Root mutation type for IAM operations */
export type MutationGenerateRegistrationTokenArgs = {
  input: RegistrationTokenInput;
};

/** Root mutation type for IAM operations */
export type MutationImportWorkflowYamlArgs = {
  input: ImportWorkflowYamlInput;
};

/** Root mutation type for IAM operations */
export type MutationModifyRiskFactorsArgs = {
  riskFactors: Array<ModifyRiskFactorInput>;
  spaceMrn: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationPauseWorkflowScheduleArgs = {
  input: PauseWorkflowScheduleInput;
};

/** Root mutation type for IAM operations */
export type MutationProcessCaseEventsArgs = {
  input: ProcessCaseEventsInput;
};

/** Root mutation type for IAM operations */
export type MutationReactivateSpaceArgs = {
  reason?: InputMaybe<Scalars["String"]["input"]>;
  spaceMrn: Scalars["ID"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationRefreshAggregateScoresArgs = {
  groupMrn: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationRegenerateAssessmentsArgs = {
  entityMrn: Scalars["String"]["input"];
  uids: Array<Scalars["String"]["input"]>;
};

/** Root mutation type for IAM operations */
export type MutationRegisterUserActionArgs = {
  input: RegisterUserActionInput;
};

/** Root mutation type for IAM operations */
export type MutationRemoveOrganizationMembershipArgs = {
  input: RemoveOrganizationMembershipInput;
};

/** Root mutation type for IAM operations */
export type MutationRemoveSsoProviderArgs = {
  input: DeleteSsoProviderInput;
};

/** Root mutation type for IAM operations */
export type MutationRemoveSpaceMembershipArgs = {
  input: RemoveSpaceMembershipInput;
};

/** Root mutation type for IAM operations */
export type MutationRemoveTeamExternalGroupMappingArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};

/** Root mutation type for IAM operations */
export type MutationRemoveWifAuthBindingArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationReportViewedArgs = {
  input: ReportViewedInput;
};

/** Root mutation type for IAM operations */
export type MutationRequestAiSummaryArgs = {
  input: AiSummaryInput;
};

/** Root mutation type for IAM operations */
export type MutationRequestDocumentDownloadUrlArgs = {
  documentMRN: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationResendInvitationArgs = {
  invitationMrn: Scalars["ID"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationResetWorkflowToTemplateArgs = {
  input: ResetWorkflowToTemplateInput;
};

/** Root mutation type for IAM operations */
export type MutationRestoreBiDashboardVersionArgs = {
  input: RestoreBiDashboardVersionInput;
};

/** Root mutation type for IAM operations */
export type MutationResumeWorkflowScheduleArgs = {
  input: ResumeWorkflowScheduleInput;
};

/** Root mutation type for IAM operations */
export type MutationRevokeRegistrationTokenArgs = {
  input: RevokeRegistrationTokenInput;
};

/** Root mutation type for IAM operations */
export type MutationRotateCredentialArgs = {
  input: RotateCredentialInput;
};

/** Root mutation type for IAM operations */
export type MutationSaveBiDashboardVersionArgs = {
  input: SaveBiDashboardVersionInput;
};

/** Root mutation type for IAM operations */
export type MutationSetAssetAnnotationsArgs = {
  input?: InputMaybe<SetAssetAnnotationsInput>;
};

/** Root mutation type for IAM operations */
export type MutationSetAssetRoutingTableArgs = {
  input: SetAssetRoutingTableInput;
};

/** Root mutation type for IAM operations */
export type MutationSetCustomPolicyArgs = {
  input: Array<SetCustomPolicyInput>;
};

/** Root mutation type for IAM operations */
export type MutationSetCustomQueryPackArgs = {
  input: Array<SetCustomQueryPackInput>;
};

/** Root mutation type for IAM operations */
export type MutationSetEmailPreferenceArgs = {
  input: Array<EmailPreferenceInput>;
};

/** Root mutation type for IAM operations */
export type MutationSetIntegrationArgs = {
  input: IntegrationInput;
};

/** Root mutation type for IAM operations */
export type MutationSetOrganizationMembershipArgs = {
  input: SetOrganizationMembershipInput;
};

/** Root mutation type for IAM operations */
export type MutationSetResourceContactsArgs = {
  input: SetResourceContactsInput;
};

/** Root mutation type for IAM operations */
export type MutationSetRolesArgs = {
  input: SetRolesInput;
};

/** Root mutation type for IAM operations */
export type MutationSetSsoProviderArgs = {
  input: SetSsoProviderInput;
};

/** Root mutation type for IAM operations */
export type MutationSetScimGroupMappingArgs = {
  input: SetScimGroupMappingInput;
};

/** Root mutation type for IAM operations */
export type MutationSetSpaceMembershipArgs = {
  input: SetSpaceMembershipInput;
};

/** Root mutation type for IAM operations */
export type MutationSuppressIntegrationMessageArgs = {
  input: SuppressIntegrationMessageInput;
};

/** Root mutation type for IAM operations */
export type MutationTestCredentialArgs = {
  input: TestCredentialInput;
};

/** Root mutation type for IAM operations */
export type MutationTriggerAuditLogExportArgs = {
  input: TriggerAuditLogExportInput;
};

/** Root mutation type for IAM operations */
export type MutationTriggerInterconnectionGraphRegenerationArgs = {
  input: TriggerInterconnectionGraphRegenerationInput;
};

/** Root mutation type for IAM operations */
export type MutationTriggerSecurityPipelineScheduledWorkflowArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root mutation type for IAM operations */
export type MutationTriggerWorkflowArgs = {
  input: TriggerWorkflowInput;
};

/** Root mutation type for IAM operations */
export type MutationUnassignPolicyArgs = {
  input: PolicyAssignmentInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateApiTokenArgs = {
  input: UpdateApiTokenInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateAgentArgs = {
  input: UpdateAgentInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateAssetRoutingRuleArgs = {
  input: UpdateAssetRoutingRuleInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateBiDashboardArgs = {
  input: UpdateBiDashboardInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateBiTagConfigArgs = {
  input: UpdateBiTagConfigInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateClientIntegrationConfigurationArgs = {
  input: UpdateClientIntegrationConfigurationInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateSecurityModelArgs = {
  input: UpdateSecurityModelInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateSecurityPipelineScheduledWorkflowArgs = {
  input: UpdateSecurityPipelineScheduledWorkflowInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateServiceAccountArgs = {
  input: UpdateServiceAccountInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateSpaceArgs = {
  input: UpdateSpaceInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateWorkflowArgs = {
  input: UpdateWorkflowInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateWorkflowNodeArgs = {
  input: UpdateWorkflowNodeInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateWorkflowPositionsArgs = {
  input: UpdateWorkflowPositionsInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateWorkflowResourceArgs = {
  input: UpdateWorkflowResourceInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateWorkflowScheduleArgs = {
  input: UpdateWorkflowScheduleInput;
};

/** Root mutation type for IAM operations */
export type MutationUpdateWorkspaceArgs = {
  input: UpdateWorkspaceInput;
};

/** Root mutation type for IAM operations */
export type MutationUploadFrameworkArgs = {
  input: UploadFrameworkInput;
};

/** Root mutation type for IAM operations */
export type MutationValidateWorkflowArgs = {
  input: ValidateWorkflowInput;
};

/** A package affected by a vulnerability, with its version ranges. */
export type MvdAffected = {
  __typename: "MvdAffected";
  /** The affected package. */
  package: MvdPackage;
  /** Version ranges describing when the package is affected. */
  ranges: Array<MvdRange>;
  /** Explicitly enumerated affected versions. */
  versions: Array<Scalars["String"]["output"]>;
};

/** Someone credited on a vulnerability record. */
export type MvdCredit = {
  __typename: "MvdCredit";
  /** Contact URLs or addresses. */
  contact?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Name of the person or organization. */
  name: Scalars["String"]["output"];
  /** Type of contribution. */
  type?: Maybe<Scalars["String"]["output"]>;
};

/** A CWE (Common Weakness Enumeration) catalog entry. */
export type MvdCwe = {
  __typename: "MvdCwe";
  /** Abstraction level: Base, Class, Variant, Compound. */
  abstraction?: Maybe<Scalars["String"]["output"]>;
  /** Consequences of the weakness. */
  commonConsequences: Array<MvdCweConsequence>;
  /** Short description. */
  description: Scalars["String"]["output"];
  /** Detection methods. */
  detectionMethods: Array<MvdCweDetectionMethod>;
  /** Extended description, may be empty. */
  extendedDescription?: Maybe<Scalars["String"]["output"]>;
  /** CWE identifier, e.g. "CWE-79". */
  id: Scalars["ID"]["output"];
  /** Phases in which the weakness is typically introduced. */
  modesOfIntroduction: Array<Scalars["String"]["output"]>;
  /** Weakness name. */
  name: Scalars["String"]["output"];
  /** Observed real-world examples. */
  observedExamples: Array<MvdCweObservedExample>;
  /** Suggested mitigations. */
  potentialMitigations: Array<MvdCweMitigation>;
  /** Related weaknesses in the CWE graph. */
  relatedWeaknesses: Array<MvdCweRelatedWeakness>;
  /** Catalog status, e.g. Stable, Draft, Deprecated. */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Number of vulnerabilities mapped to this CWE. */
  vulnerabilityCount: Scalars["Int"]["output"];
};

/** A page of CWE entries. */
export type MvdCweConnection = {
  __typename: "MvdCweConnection";
  /** The edges of the current page. */
  edges: Array<MvdCweEdge>;
  /** Relay cursor page information. */
  pageInfo: PageInfo;
  /** Bounded total. */
  totalCount: Scalars["Int"]["output"];
  /** True when the total was capped or skipped. */
  totalCountIsEstimate: Scalars["Boolean"]["output"];
};

/** A consequence of a weakness. */
export type MvdCweConsequence = {
  __typename: "MvdCweConsequence";
  /** Technical impacts. Repeated: the MITRE catalog lists several per consequence. */
  impact: Array<Scalars["String"]["output"]>;
  /** Additional note. */
  note?: Maybe<Scalars["String"]["output"]>;
  /** Affected security scopes, e.g. Confidentiality. */
  scope: Array<Scalars["String"]["output"]>;
};

/** A method for detecting a weakness. */
export type MvdCweDetectionMethod = {
  __typename: "MvdCweDetectionMethod";
  /** How the method is applied. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** How effective the method is. */
  effectiveness?: Maybe<Scalars["String"]["output"]>;
  /** Detection method name. */
  method?: Maybe<Scalars["String"]["output"]>;
};

/** An edge in a CWE connection. */
export type MvdCweEdge = {
  __typename: "MvdCweEdge";
  /** Opaque cursor for this row. */
  cursor: Scalars["ID"]["output"];
  /** The CWE entry. */
  node: MvdCwe;
};

/** Filters for the CWE catalog. */
export type MvdCweFilter = {
  /** Abstraction levels, e.g. Base, Class. */
  abstractions?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Free-text over id, name and description. */
  query?: InputMaybe<Scalars["String"]["input"]>;
};

/** A suggested mitigation for a weakness. */
export type MvdCweMitigation = {
  __typename: "MvdCweMitigation";
  /** What to do. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Lifecycle phases the mitigation applies to. */
  phase: Array<Scalars["String"]["output"]>;
  /** Mitigation strategy. */
  strategy?: Maybe<Scalars["String"]["output"]>;
};

/** A real-world example of a weakness. */
export type MvdCweObservedExample = {
  __typename: "MvdCweObservedExample";
  /** What the example demonstrates. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Link to the referenced record. */
  link?: Maybe<Scalars["String"]["output"]>;
  /** Reference identifier, typically a CVE id. */
  reference?: Maybe<Scalars["String"]["output"]>;
};

/** Ordering for the CWE catalog. */
export type MvdCweOrder = {
  /** Sort direction. */
  direction: OrderDirection;
  /** Field to order by. */
  field: MvdCweOrderField;
};

/** Orderable CWE fields. */
export enum MvdCweOrderField {
  /** CWE identifier. */
  Id = "ID",
  /** Weakness name. */
  Name = "NAME",
  /** Number of mapped vulnerabilities. */
  VulnerabilityCount = "VULNERABILITY_COUNT",
}

/** A weakness related to another in the CWE graph. */
export type MvdCweRelatedWeakness = {
  __typename: "MvdCweRelatedWeakness";
  /** The related CWE identifier. */
  cweId?: Maybe<Scalars["String"]["output"]>;
  /** Relationship nature, e.g. ChildOf, ParentOf. */
  nature?: Maybe<Scalars["String"]["output"]>;
};

/**
 * MVD ecosystem.
 *
 * UNREACHABLE — no field or argument in the schema references this enum, so no
 * client query can select it. Its only Go consumers, `toGqlEcosystems` and
 * `toProtoEcosystems` in `nexus/resolver/captain_organization.go`, have no callers
 * either; they compile only because Go permits unused unexported functions.
 *
 * Safe to delete along with those two functions: an unreachable type cannot appear
 * in any client document, so removal breaks nobody. Tracked for the
 * `no-unreachable-types` sweep in mondoohq/server#15824 Phase 1.
 *
 * Do not extend this enum for new ecosystems. Ecosystems are data-derived and grow
 * with upstream OSV ingests, so the catalog API models them as strings — see
 * ADR-067 §6i and `MvdEcosystemEntry` in vuln_intel.graphqls.
 */
export enum MvdEcosystem {
  Almalinux = "ALMALINUX",
  Alpine = "ALPINE",
  Debian = "DEBIAN",
  Fedora = "FEDORA",
  Linux = "LINUX",
  Macos = "MACOS",
  Opensuse = "OPENSUSE",
  Photonos = "PHOTONOS",
  Redhat = "REDHAT",
  Rockylinux = "ROCKYLINUX",
  Suse = "SUSE",
  Ubuntu = "UBUNTU",
  Windows = "WINDOWS",
  Windowsappx = "WINDOWSAPPX",
}

/** An ecosystem in the vulnerability catalog. */
export type MvdEcosystemEntry = {
  __typename: "MvdEcosystemEntry";
  /** Grouping bucket, e.g. "Language" or "OS". */
  group?: Maybe<Scalars["String"]["output"]>;
  /** Icon identifier for the console icon map. */
  icon?: Maybe<Scalars["String"]["output"]>;
  /** Canonical identifier, e.g. "npm" or "Alpine:v3.19". */
  id: Scalars["ID"]["output"];
  /** Display name. */
  name: Scalars["String"]["output"];
  /** Versioned members; populated only when `grouped: true`. */
  variants: Array<Scalars["String"]["output"]>;
  /** Number of vulnerabilities affecting this ecosystem. */
  vulnerabilityCount: Scalars["Int"]["output"];
};

/** A boundary event within an affected version range. */
export type MvdEvent = {
  __typename: "MvdEvent";
  /** Version that fixed it. */
  fixed?: Maybe<Scalars["String"]["output"]>;
  /** Version that introduced the vulnerability. */
  introduced?: Maybe<Scalars["String"]["output"]>;
  /** Last version known to be affected. */
  lastAffected?: Maybe<Scalars["String"]["output"]>;
  /** Upper bound of the range. */
  limit?: Maybe<Scalars["String"]["output"]>;
};

/** MVD experimental sources configuration */
export type MvdExperimentalSourcesConfiguration = {
  __typename: "MvdExperimentalSourcesConfiguration";
  /** List of experimental sources */
  sources?: Maybe<Array<MvdSource>>;
};

/** MVD experimental sources configuration */
export type MvdExperimentalSourcesConfigurationInput = {
  /** Enabled sources */
  enabledSources?: InputMaybe<Array<MvdSourceInput>>;
};

/** An affected package. */
export type MvdPackage = {
  __typename: "MvdPackage";
  /** Ecosystem the package belongs to, e.g. "npm". */
  ecosystem: Scalars["String"]["output"];
  /** Package name. */
  name: Scalars["String"]["output"];
  /** Package URL, when available. */
  purl?: Maybe<Scalars["String"]["output"]>;
};

/** Paging arguments. Supply either a cursor or an offset/page, never both. */
export type MvdPageInput = {
  /** Page backwards from the cursor. */
  backwards?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Opaque cursor from a previous page. */
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  /** Zero-based row offset. Capped at 10000. */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** One-based page number. */
  pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
  /** Page size. Omitted or <= 0 means 25; values above 100 are clamped. */
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  /** Skip the bounded count; `totalCount` is then 0 and estimated. */
  skipTotalCount?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * Stateless access to the Mondoo Vulnerability Database (MVD). Global catalog data:
 * no space or organization scope, identical for every caller, safe to cache. Never
 * returns tenant-derived data — for "which of my assets are affected", use the
 * scoped vulnerability fields in vuln_mgmt.graphqls instead.
 *
 * See ADR-067.
 */
export type MvdQuery = {
  __typename: "MvdQuery";
  /** Browse the CWE catalog. */
  cweEntries: MvdCweConnection;
  /** A single CWE by id, e.g. "CWE-79". Null when unknown. */
  cweEntry?: Maybe<MvdCwe>;
  /** The ecosystem catalog with vulnerability counts. */
  ecosystems: Array<MvdEcosystemEntry>;
  /**
   * Corpus-level metrics, Arrow-encoded. Reuses the platform MetricEntry shape;
   * metric MRNs are the vuln-intel values in the console's arrow metric map.
   */
  metrics: Array<MetricEntry>;
  /** Alias, related and upstream graph for one vulnerability. */
  relatedVulnerabilities: Array<MvdRelatedVulnerability>;
  /** Browse and search the vulnerability catalog. */
  vulnerabilities: MvdVulnerabilityConnection;
  /** A single vulnerability by id (CVE, GHSA, RHSA, MAL-…). Null when unknown. */
  vulnerability?: Maybe<MvdVulnerability>;
};

/**
 * Stateless access to the Mondoo Vulnerability Database (MVD). Global catalog data:
 * no space or organization scope, identical for every caller, safe to cache. Never
 * returns tenant-derived data — for "which of my assets are affected", use the
 * scoped vulnerability fields in vuln_mgmt.graphqls instead.
 *
 * See ADR-067.
 */
export type MvdQueryCweEntriesArgs = {
  filter?: InputMaybe<MvdCweFilter>;
  orderBy?: InputMaybe<MvdCweOrder>;
  page?: InputMaybe<MvdPageInput>;
};

/**
 * Stateless access to the Mondoo Vulnerability Database (MVD). Global catalog data:
 * no space or organization scope, identical for every caller, safe to cache. Never
 * returns tenant-derived data — for "which of my assets are affected", use the
 * scoped vulnerability fields in vuln_mgmt.graphqls instead.
 *
 * See ADR-067.
 */
export type MvdQueryCweEntryArgs = {
  id: Scalars["ID"]["input"];
};

/**
 * Stateless access to the Mondoo Vulnerability Database (MVD). Global catalog data:
 * no space or organization scope, identical for every caller, safe to cache. Never
 * returns tenant-derived data — for "which of my assets are affected", use the
 * scoped vulnerability fields in vuln_mgmt.graphqls instead.
 *
 * See ADR-067.
 */
export type MvdQueryEcosystemsArgs = {
  grouped?: InputMaybe<Scalars["Boolean"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Stateless access to the Mondoo Vulnerability Database (MVD). Global catalog data:
 * no space or organization scope, identical for every caller, safe to cache. Never
 * returns tenant-derived data — for "which of my assets are affected", use the
 * scoped vulnerability fields in vuln_mgmt.graphqls instead.
 *
 * See ADR-067.
 */
export type MvdQueryMetricsArgs = {
  metricMrns: Array<Scalars["String"]["input"]>;
};

/**
 * Stateless access to the Mondoo Vulnerability Database (MVD). Global catalog data:
 * no space or organization scope, identical for every caller, safe to cache. Never
 * returns tenant-derived data — for "which of my assets are affected", use the
 * scoped vulnerability fields in vuln_mgmt.graphqls instead.
 *
 * See ADR-067.
 */
export type MvdQueryRelatedVulnerabilitiesArgs = {
  id: Scalars["ID"]["input"];
};

/**
 * Stateless access to the Mondoo Vulnerability Database (MVD). Global catalog data:
 * no space or organization scope, identical for every caller, safe to cache. Never
 * returns tenant-derived data — for "which of my assets are affected", use the
 * scoped vulnerability fields in vuln_mgmt.graphqls instead.
 *
 * See ADR-067.
 */
export type MvdQueryVulnerabilitiesArgs = {
  filter?: InputMaybe<MvdVulnerabilityFilter>;
  orderBy?: InputMaybe<MvdVulnerabilityOrder>;
  page?: InputMaybe<MvdPageInput>;
};

/**
 * Stateless access to the Mondoo Vulnerability Database (MVD). Global catalog data:
 * no space or organization scope, identical for every caller, safe to cache. Never
 * returns tenant-derived data — for "which of my assets are affected", use the
 * scoped vulnerability fields in vuln_mgmt.graphqls instead.
 *
 * See ADR-067.
 */
export type MvdQueryVulnerabilityArgs = {
  id: Scalars["ID"]["input"];
};

/** A range of affected versions. */
export type MvdRange = {
  __typename: "MvdRange";
  /** Events marking where the range starts and stops. */
  events: Array<MvdEvent>;
  /** Versioning scheme the range is expressed in. */
  type: MvdRangeType;
};

/** Versioning scheme for an affected range. */
export enum MvdRangeType {
  /** Ecosystem-specific ordering. */
  Ecosystem = "ECOSYSTEM",
  /** Git commit ranges. */
  Git = "GIT",
  /** Semantic versioning. */
  Semver = "SEMVER",
}

/** A typed reference attached to a vulnerability. */
export type MvdReference = {
  __typename: "MvdReference";
  /** What the reference points at. */
  type: MvdReferenceType;
  /** The reference URL. */
  url: Scalars["String"]["output"];
};

/** OSV reference types. */
export enum MvdReferenceType {
  /** Vendor or distribution advisory. */
  Advisory = "ADVISORY",
  /** Article or blog post. */
  Article = "ARTICLE",
  /** Detection tooling. */
  Detection = "DETECTION",
  /** Public discussion. */
  Discussion = "DISCUSSION",
  /** Supporting evidence. */
  Evidence = "EVIDENCE",
  /** The fix itself. */
  Fix = "FIX",
  /** Where the flaw was introduced. */
  Introduced = "INTRODUCED",
  /** The affected package. */
  Package = "PACKAGE",
  /** Vulnerability report. */
  Report = "REPORT",
  /** Other web resource. */
  Web = "WEB",
}

/** A vulnerability related to another, with the nature of the relationship. */
export type MvdRelatedVulnerability = {
  __typename: "MvdRelatedVulnerability";
  /** The related vulnerability identifier. */
  id: Scalars["ID"]["output"];
  /** How it relates to the queried record. */
  relationship: MvdRelationshipType;
  /** Short title, when known. */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** How one vulnerability record relates to another. */
export enum MvdRelationshipType {
  /** Same vulnerability under a different identifier. */
  Alias = "ALIAS",
  /** Related but distinct. */
  Related = "RELATED",
  /** The upstream record this one derives from. */
  Upstream = "UPSTREAM",
}

/** A severity vector as published with the record. */
export type MvdSeverity = {
  __typename: "MvdSeverity";
  /** The raw vector string. */
  score: Scalars["String"]["output"];
  /** The scoring system used. */
  type: MvdSeverityType;
};

/** Banded severity level. */
export enum MvdSeverityLevel {
  /** Critical severity. Malware records are always CRITICAL. */
  Critical = "CRITICAL",
  /** High severity. */
  High = "HIGH",
  /** Low severity. */
  Low = "LOW",
  /** Medium severity. */
  Medium = "MEDIUM",
  /** No severity assigned. */
  None = "NONE",
  /** Severity could not be determined. */
  Unknown = "UNKNOWN",
}

/** Supported CVSS scoring systems. */
export enum MvdSeverityType {
  /** CVSS version 2. */
  CvssV2 = "CVSS_V2",
  /** CVSS version 3. */
  CvssV3 = "CVSS_V3",
  /** CVSS version 4. */
  CvssV4 = "CVSS_V4",
}

/** MVD source */
export type MvdSource = {
  __typename: "MvdSource";
  /** Is it enabled? */
  enabled: Scalars["Boolean"]["output"];
  /** ID */
  id: Scalars["String"]["output"];
  /** Pretty name for the ID */
  name: Scalars["String"]["output"];
};

/** MVD source input */
export type MvdSourceInput = {
  /** ID */
  id: Scalars["String"]["input"];
};

/**
 * A vulnerability record from the Mondoo Vulnerability Database. The unified view
 * of a CVE, advisory, or other vulnerability identifier with the full OSV data
 * model. This is the detail shape; lists return MvdVulnerabilitySummary.
 */
export type MvdVulnerability = {
  __typename: "MvdVulnerability";
  /** Affected packages and version ranges. */
  affected: Array<MvdAffected>;
  /** Identifiers naming the same vulnerability. */
  aliases: Array<Scalars["String"]["output"]>;
  /** Credited reporters and contributors. */
  credits: Array<MvdCredit>;
  /** Highest-ranked CVSS score. */
  cvssScore: CvssScore;
  /** All CVSS scores attached to the record. */
  cvssScores: Array<CvssScore>;
  /** Primary CWE identifier, when known. */
  cwe?: Maybe<Scalars["String"]["output"]>;
  /** Full description, may contain markdown. */
  details?: Maybe<Scalars["String"]["output"]>;
  /** EPSS exploitation probability. */
  epssScore?: Maybe<EpssScore>;
  /** External URLs for display. */
  externalUrls?: Maybe<Array<Maybe<Reference>>>;
  /** The vulnerability identifier, e.g. "CVE-2024-1234". */
  id: Scalars["ID"]["output"];
  /** When the record was last modified upstream. */
  modifiedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The Mondoo resource name. */
  mrn: Scalars["ID"]["output"];
  /** When the record was published. */
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Reference URLs without type information. */
  references?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Related but distinct identifiers. */
  related: Array<Scalars["String"]["output"]>;
  /** Raw severity vectors as published. */
  severity: Array<MvdSeverity>;
  /** Catalog state of the identifier. */
  state?: Maybe<CveState>;
  /** One-line summary. */
  summary?: Maybe<Scalars["String"]["output"]>;
  /** Short title. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** References with their OSV type. */
  typedReferences: Array<MvdReference>;
  /** Upstream records this one derives from. */
  upstream: Array<Scalars["String"]["output"]>;
  /** Risk factors such as CISA KEV membership. */
  vulnerabilityRiskFactors: VulnerabilityRiskFactors;
  /** When the record was withdrawn, if it was. */
  withdrawnAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/** A page of vulnerabilities. */
export type MvdVulnerabilityConnection = {
  __typename: "MvdVulnerabilityConnection";
  /** The edges of the current page. */
  edges: Array<MvdVulnerabilityEdge>;
  /** Total pages in offset mode; null in cursor mode. */
  pageCount?: Maybe<Scalars["Int"]["output"]>;
  /** Relay cursor page information. */
  pageInfo: PageInfo;
  /** One-based page number in offset mode; null in cursor mode. */
  pageNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Bounded total; see `totalCountIsEstimate`. */
  totalCount: Scalars["Int"]["output"];
  /** True when the total was capped or skipped. Render as "1000+". */
  totalCountIsEstimate: Scalars["Boolean"]["output"];
};

/** An edge in a vulnerability connection. */
export type MvdVulnerabilityEdge = {
  __typename: "MvdVulnerabilityEdge";
  /** Opaque cursor for this row. */
  cursor: Scalars["ID"]["output"];
  /** The vulnerability summary. */
  node: MvdVulnerabilitySummary;
};

/** Filters for the vulnerability catalog. All fields AND together. */
export type MvdVulnerabilityFilter = {
  /** Maximum CVSS base score, 0–10. */
  cvssMax?: InputMaybe<Scalars["Float"]["input"]>;
  /** Minimum CVSS base score, 0–10. */
  cvssMin?: InputMaybe<Scalars["Float"]["input"]>;
  /** CWE identifiers; OR together. Max 20. */
  cweIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Ecosystems; a bare value prefix-matches versioned ones. */
  ecosystems?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Only records with (or without) a fix. Omit for no filter. */
  hasFix?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Include withdrawn records. Omitted excludes them. */
  includeWithdrawn?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Only malware (or only non-malware). Omit for no filter. */
  isMalware?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Only CISA KEV records. Omit for no filter. */
  knownExploited?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Modified at or after this instant. */
  modifiedAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Narrows `packageName` to one ecosystem. */
  packageEcosystem?: InputMaybe<Scalars["String"]["input"]>;
  /** Exact package name. */
  packageName?: InputMaybe<Scalars["String"]["input"]>;
  /** Published at or after this instant. */
  publishedAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Published strictly before this instant. */
  publishedBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Free-text over id, aliases, summary and details. Max 200 characters. */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** Severity levels; OR together. */
  severities?: InputMaybe<Array<MvdSeverityLevel>>;
  /** Upstream sources; OR together. */
  sources?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Explicit identifier set. Max 500. */
  vulnerabilityIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Ordering for the vulnerability catalog. */
export type MvdVulnerabilityOrder = {
  /** Sort direction. */
  direction: OrderDirection;
  /** Field to order by. */
  field: MvdVulnerabilityOrderField;
};

/** Orderable fields. Every order is made total by appending the record id. */
export enum MvdVulnerabilityOrderField {
  /** Highest CVSS base score. */
  CvssScore = "CVSS_SCORE",
  /** Identifier. */
  Id = "ID",
  /** Last-modified date. */
  Modified = "MODIFIED",
  /** Publication date. */
  Published = "PUBLISHED",
  /** Text relevance. Valid only when `filter.query` is set. */
  Relevance = "RELEVANCE",
  /** Banded severity. */
  Severity = "SEVERITY",
}

/**
 * List projection of a vulnerability. Served from indexed columns only — it
 * deliberately omits `affected` so a browse page never deserializes the OSV blobs.
 * Use `mvd.vulnerability(id)` for the full record. See ADR-067 §2.
 */
export type MvdVulnerabilitySummary = {
  __typename: "MvdVulnerabilitySummary";
  /** Identifiers naming the same vulnerability. */
  aliases: Array<Scalars["String"]["output"]>;
  /** Highest CVSS base score, 0–10. */
  cvssScore?: Maybe<Scalars["Float"]["output"]>;
  /** CWE identifiers associated with this record. */
  cweIds: Array<Scalars["String"]["output"]>;
  /** Ecosystems the record affects. */
  ecosystems: Array<Scalars["String"]["output"]>;
  /** EPSS exploitation probability, 0–1. */
  epssScore?: Maybe<Scalars["Float"]["output"]>;
  /** True when any affected range carries a fixed version. */
  hasFix: Scalars["Boolean"]["output"];
  /** The vulnerability identifier. */
  id: Scalars["ID"]["output"];
  /** True for malicious-package records (MAL-*). */
  isMalware: Scalars["Boolean"]["output"];
  /** Present in the CISA KEV catalog. */
  knownExploited: Scalars["Boolean"]["output"];
  /** When the record was last modified upstream. */
  modifiedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The Mondoo resource name. */
  mrn: Scalars["ID"]["output"];
  /** When the record was published. */
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Network-reachable per the CVSS attack vector (AV:N). */
  remoteExploitable: Scalars["Boolean"]["output"];
  /** Banded severity, derived from the highest CVSS vector. */
  severity: MvdSeverityLevel;
  /** Upstream source, e.g. "ubuntu", "nvd". */
  source?: Maybe<Scalars["String"]["output"]>;
  /** Catalog state of the identifier. */
  state?: Maybe<CveState>;
  /** One-line summary, truncated for list display. */
  summary?: Maybe<Scalars["String"]["output"]>;
  /** Short title. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** When the record was withdrawn, if it was. */
  withdrawnAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Aggregated diagnostics for a Network Discovery Collector integration. */
export type NetworkDiscoveryCollectorDiagnostics = {
  __typename: "NetworkDiscoveryCollectorDiagnostics";
  /** MRN of the Network Discovery Collector integration. */
  integrationMrn: Scalars["String"]["output"];
  /** Number of runners currently enrolled under this collector integration. */
  registeredRunners: Scalars["Int"]["output"];
  /** The runners enrolled under this collector integration. */
  runners: Array<NetworkDiscoveryCollectorRunner>;
};

/** One enrolled collector runner and its most recent health report. */
export type NetworkDiscoveryCollectorRunner = {
  __typename: "NetworkDiscoveryCollectorRunner";
  /** Individual self-check results from the runner's most recent health report. */
  checks: Array<NetworkDiscoveryHealthCheck>;
  /** When the runner last checked in (RFC 3339, nil if never). */
  lastCheckin?: Maybe<Scalars["String"]["output"]>;
  /** MRN of the collector runner. */
  mrn: Scalars["String"]["output"];
  /** Runner-advertised name. */
  name: Scalars["String"]["output"];
  /** Overall health: HEALTHY / DEGRADED / UNHEALTHY / UNKNOWN. */
  overallHealth: Scalars["String"]["output"];
  /** Collector software version the runner is running. */
  version: Scalars["String"]["output"];
};

/** A single collector self-check result (e.g. TCP 443, DNS, TLS handshake). */
export type NetworkDiscoveryHealthCheck = {
  __typename: "NetworkDiscoveryHealthCheck";
  /** Human-readable detail for the check result. */
  detail: Scalars["String"]["output"];
  /** Measured latency in milliseconds, if the check timed an operation. */
  latencyMs?: Maybe<Scalars["Int"]["output"]>;
  /** Name of the self-check (e.g. "tcp-443", "dns", "tls"). */
  name: Scalars["String"]["output"];
  /** HEALTHY / DEGRADED / UNHEALTHY / UNKNOWN. */
  status: Scalars["String"]["output"];
};

/** Network Scan integration options (as stored/returned). */
export type NetworkScanConfigurationOptions = {
  __typename: "NetworkScanConfigurationOptions";
  /** Route to a specific collector by its integration MRN (mutually exclusive with tagKey/tagValue). */
  collectorMrn?: Maybe<Scalars["String"]["output"]>;
  /** Hosts/CIDRs to exclude from the scan. */
  excludes?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Schedule as a Go duration, cron expression, or one-off (empty = default). */
  schedule?: Maybe<Scalars["String"]["output"]>;
  /** Space that discovered assets/findings upload to. */
  spaceMrn?: Maybe<Scalars["String"]["output"]>;
  /** Route to collectors carrying this tag key (with tagValue). */
  tagKey?: Maybe<Scalars["String"]["output"]>;
  /** Route to collectors carrying this tag value (with tagKey). */
  tagValue?: Maybe<Scalars["String"]["output"]>;
  /** Scan targets (hosts/CIDRs) to sweep. */
  targets?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 * Network Scan integration input. Defines what to scan (targets + schedule) and
 * how to route it to Network Discovery Collectors. Set exactly one routing:
 * collectorMrn (a specific collector) or tagKey/tagValue (any collector with the
 * tag).
 */
export type NetworkScanConfigurationOptionsInput = {
  /** Route to one specific collector (its integration MRN). */
  collectorMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Hosts/CIDRs to exclude from the scan (e.g. 127.0.0.1, gateways). */
  excludes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Scan cadence as a Go duration (e.g. "1h", "24h") or cron; empty = daily. */
  schedule?: InputMaybe<Scalars["String"]["input"]>;
  /** Space that discovered assets/findings upload to (required for org-level scans). */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Route to any collector carrying this tag. */
  tagKey?: InputMaybe<Scalars["String"]["input"]>;
  tagValue?: InputMaybe<Scalars["String"]["input"]>;
  /** CIDR ranges and/or individual hosts/IPs to scan. */
  targets?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** One Network Scan run — a single execution of a scan's job definition. */
export type NetworkScanRun = {
  __typename: "NetworkScanRun";
  /** When the run was created/queued (RFC 3339). */
  createdAt?: Maybe<Scalars["String"]["output"]>;
  /** When the run reached a terminal state (RFC 3339, nil if not yet finished). */
  finishedAt?: Maybe<Scalars["String"]["output"]>;
  /** MRN of the Network Scan integration this run belongs to. */
  integrationMrn?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable status/error message for the run, if any. */
  message?: Maybe<Scalars["String"]["output"]>;
  /** MRN of this scan run. */
  mrn: Scalars["String"]["output"];
  /** Name of the Network Scan this run belongs to (nil if the scan was deleted). */
  scanName?: Maybe<Scalars["String"]["output"]>;
  /** When a collector started the run (RFC 3339, nil if not yet started). */
  startedAt?: Maybe<Scalars["String"]["output"]>;
  /** QUEUED / RUNNING / SUCCEEDED / FAILED / CANCELED. */
  state: Scalars["String"]["output"];
  /** Scan targets (hosts/CIDRs) this run covered. */
  targets?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** Vulnerability Details */
export type NewVulnerabilityInfo = {
  __typename: "NewVulnerabilityInfo";
  /** number of affected assets */
  assetsAffected: Scalars["Int"]["output"];
  /** CVE */
  cve: Cve;
  /** date */
  date: Scalars["String"]["output"];
};

/** News articles configuration - adjusts risk based on the news articles score of the vulnerability */
export type NewsArticlesConfiguration = {
  __typename: "NewsArticlesConfiguration";
  /** Whether to factor news articles into the news score */
  enabled: Scalars["Boolean"]["output"];
  /** Weight of the news articles component */
  weight: Scalars["Float"]["output"];
};

/** News articles configuration input */
export type NewsArticlesConfigurationInput = {
  /** Whether to factor news articles into the news score */
  enabled: Scalars["Boolean"]["input"];
  /** Weight of the news articles component */
  weight: Scalars["Float"]["input"];
};

/** News configuration - adjusts risk based on news articles and social media mentions of the vulnerability */
export type NewsConfiguration = {
  __typename: "NewsConfiguration";
  /** Whether to enable news analysis */
  enabled: Scalars["Boolean"]["output"];
  /** News articles configuration */
  newsArticles: NewsArticlesConfiguration;
  /** Social media configuration */
  socialMedia: SocialMediaConfiguration;
  /** Weight of the news category */
  weight: Scalars["Float"]["output"];
};

/** News configuration input */
export type NewsConfigurationInput = {
  /** Whether to enable news analysis */
  enabled: Scalars["Boolean"]["input"];
  /** News articles configuration */
  newsArticles: NewsArticlesConfigurationInput;
  /** Social media configuration */
  socialMedia: SocialMediaConfigurationInput;
  /** Weight of the news category */
  weight: Scalars["Float"]["input"];
};

/** News details for risk category scoring */
export type NewsDetails = {
  __typename: "NewsDetails";
  /** Whether the news impact was overridden by a label */
  overridedByLabel: Scalars["Boolean"]["output"];
};

/** NextDNS integration */
export type NextdnsConfigurationOptions = {
  __typename: "NextdnsConfigurationOptions";
  /**
   * The NextDNS API key. Always null in responses — the key is stored in
   * the vault and never echoed back; a non-null value here simply indicates the
   * key is configured.
   */
  apiKey?: Maybe<Scalars["String"]["output"]>;
};

/** NextDNS integration input */
export type NextdnsConfigurationOptionsInput = {
  /** NextDNS API key */
  apiKey: Scalars["String"]["input"];
};

/** A node that requires a credential binding. */
export type NodeCredentialRequirement = {
  __typename: "NodeCredentialRequirement";
  /** Required credential type (e.g. "github", "slack"). */
  credentialType: Scalars["String"]["output"];
  /** Node ID requiring the credential. */
  nodeId: Scalars["ID"]["output"];
  /** Display name of the node. */
  nodeName: Scalars["String"]["output"];
  /** Plugin that requires the credential. */
  plugin: Scalars["String"]["output"];
};

/** Position update for a single node. */
export type NodePositionInput = {
  /** ID of the node to reposition. */
  nodeId: Scalars["ID"]["input"];
  /** New canvas position as [x, y] coordinates. */
  position: Array<Scalars["Int"]["input"]>;
};

/** Not found error */
export type NotFoundError = Error & {
  __typename: "NotFoundError";
  /** Code */
  code: Scalars["String"]["output"];
  /** Message */
  message: Scalars["String"]["output"];
};

/** Not supported error */
export type NotSupported = Error & {
  __typename: "NotSupported";
  /** Code */
  code: Scalars["String"]["output"];
  /** Message */
  message: Scalars["String"]["output"];
};

/** Slack notification type enum */
export enum NotificationType {
  /** Send asset update notfication streams */
  AssetUpdates = "ASSET_UPDATES",
  /** Send triage conversations for findings */
  TriageConversations = "TRIAGE_CONVERSATIONS",
}

/**
 * NVD enrichment status for a CVE.
 *
 * Answers "has NVD analyzed this CVE?", separate from the MITRE lifecycle
 * `CveState`. See https://nvd.nist.gov/vuln/vulnerability-status
 */
export enum NvdStatus {
  AwaitingEnrichment = "AWAITING_ENRICHMENT",
  Enriched = "ENRICHED",
  ModifiedAfterEnrichment = "MODIFIED_AFTER_ENRICHMENT",
  NotScheduled = "NOT_SCHEDULED",
  Received = "RECEIVED",
  Rejected = "REJECTED",
  UndergoingEnrichment = "UNDERGOING_ENRICHMENT",
  Unknown = "UNKNOWN",
}

/** OCI integration input */
export type OciConfigurationOptions = {
  __typename: "OciConfigurationOptions";
  /** The fingerprint for the OCI integration */
  fingerprint: Scalars["String"]["output"];
  /** The region for the OCI integration */
  region: Scalars["String"]["output"];
  /** The tenancy OCID for the OCI integration */
  tenancyOcid: Scalars["String"]["output"];
  /** The user OCID for the OCI integration */
  userOcid: Scalars["String"]["output"];
};

/** OCI integration input */
export type OciConfigurationOptionsInput = {
  /** The fingerprint for the OCI integration */
  fingerprint: Scalars["String"]["input"];
  /** The private key for the OCI integration (optional) */
  privateKey?: InputMaybe<Scalars["String"]["input"]>;
  /** The region for the OCI integration */
  region: Scalars["String"]["input"];
  /** The tenancy OCID for the OCI integration */
  tenancyOcid: Scalars["String"]["input"];
  /** The user OCID for the OCI integration */
  userOcid: Scalars["String"]["input"];
};

/** Okta configuration options */
export type OktaConfigurationOptions = {
  __typename: "OktaConfigurationOptions";
  /** The Okta organization name */
  organization: Scalars["String"]["output"];
};

/** Okta integration input */
export type OktaConfigurationOptionsInput = {
  /** The Okta organization name */
  organization: Scalars["String"]["input"];
  /** The Okta API token (optional) */
  token?: InputMaybe<Scalars["String"]["input"]>;
};

/** OpenVAS / Greenbone configuration options */
export type OpenvasConfigurationOptions = {
  __typename: "OpenvasConfigurationOptions";
  /** Base URL of the Greenbone Cloud API (cloud transport) */
  baseUrl?: Maybe<Scalars["String"]["output"]>;
  /** Optional PEM CA bundle used to verify the GVM TLS certificate (gmp transport) */
  caCertificate?: Maybe<Scalars["String"]["output"]>;
  /** Whether to create assets in the backend when they are not found */
  createAssets: Scalars["Boolean"]["output"];
  /** Whether GMP connects over plaintext TCP instead of TLS (gmp transport) */
  gmpPlaintext: Scalars["Boolean"]["output"];
  /** GMP TLS port (gmp transport) */
  gmpPort?: Maybe<Scalars["String"]["output"]>;
  /** Self-hosted GVM/GSM hostname or IP (gmp transport) */
  host?: Maybe<Scalars["String"]["output"]>;
  /** Minimum severity the import is scoped to */
  severity?: Maybe<Scalars["String"]["output"]>;
  /** Whether TLS certificate verification is disabled (gmp transport) */
  skipTlsVerify: Scalars["Boolean"]["output"];
  /** Greenbone deployment being targeted: "gmp" or "cloud" */
  transport?: Maybe<Scalars["String"]["output"]>;
  /** Username for the GMP session (gmp transport) */
  username?: Maybe<Scalars["String"]["output"]>;
};

/** OpenVAS / Greenbone configuration options input */
export type OpenvasConfigurationOptionsInput = {
  /** Base URL of the Greenbone Cloud API (cloud transport) */
  baseUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional PEM CA bundle used to verify the GVM TLS certificate (gmp transport) */
  caCertificate?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether to create assets in the backend when they are not found */
  createAssets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Connect to GMP over plaintext TCP instead of TLS (gmp transport; default TLS).
   * For a socket-bridged Greenbone Community Edition; prefer TLS across untrusted networks.
   */
  gmpPlaintext?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** GMP TLS port (gmp transport; empty defaults to 9390) */
  gmpPort?: InputMaybe<Scalars["String"]["input"]>;
  /** Self-hosted GVM/GSM hostname or IP (gmp transport) */
  host?: InputMaybe<Scalars["String"]["input"]>;
  /** The GMP password (gmp transport) or Greenbone Cloud API token (cloud transport). Write-only. */
  secret?: InputMaybe<Scalars["String"]["input"]>;
  /** Minimum severity to import (e.g. "high"); empty imports all */
  severity?: InputMaybe<Scalars["String"]["input"]>;
  /** Disable TLS certificate verification (gmp transport) */
  skipTlsVerify?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Greenbone deployment to target: "gmp" (self-hosted GVM/GSM over the Greenbone
   * Management Protocol) or "cloud" (Greenbone Cloud REST API). Empty defaults to "gmp".
   */
  transport?: InputMaybe<Scalars["String"]["input"]>;
  /** Username for the GMP session (gmp transport) */
  username?: InputMaybe<Scalars["String"]["input"]>;
};

/** Defines the possible directions in which to sort a list of items. */
export enum OrderDirection {
  /** Ascending order. For example, from A to Z or from lowest to highest. */
  Asc = "ASC",
  /** Descending order. For example, from Z to A or from highest to lowest. */
  Desc = "DESC",
}

/**
 * A compliance framework together with the set of spaces in which it is
 * enabled within an organization.
 */
export type OrgComplianceFramework = {
  __typename: "OrgComplianceFramework";
  /** The MRNs of the spaces in which this framework is enabled. */
  enabledInSpaceMrns: Array<Scalars["String"]["output"]>;
  /**
   * The compliance framework. The scopeMrn on this framework is unset because
   * the entry spans multiple spaces — use enabledInSpaceMrns instead.
   */
  framework: ComplianceFramework;
};

/** Org view page info */
export type OrgViewPageInfo = {
  /** Organization MRN */
  orgMrn: Scalars["String"]["input"];
};

/** Organization */
export type Organization = {
  __typename: "Organization";
  /** Annotations */
  annotations: Array<Annotation>;
  /** Returns metadata about the precomputed asset interconnection graph */
  assetInterconnectionGraphInfo?: Maybe<InterconnectionGraphInfo>;
  /** Capabilities */
  capabilities: Array<Scalars["String"]["output"]>;
  /** Company name */
  company?: Maybe<Scalars["String"]["output"]>;
  /** Contacts assigned to this organization */
  contacts?: Maybe<Array<ResourceContact>>;
  /**
   * Aggregate compliance control statistics across every framework in every
   * space in the organization. Computed via a single SQL aggregation against
   * the policy score store — no per-space or per-framework client loops.
   * Nullable so that a transient aggregation error degrades gracefully
   * without nulling out co-selected Organization fields via GraphQL
   * null-propagation.
   *
   * When spaceMrns is set, the aggregation is restricted to the per-space
   * rolled-up rows for those spaces. Counts scale with the number of spaces
   * (each space contributes its own (control × space) rows) rather than
   * matching the org-level rollup totals — this is the natural
   * "controls across these spaces" reading.
   */
  controlComplianceStats?: Maybe<OrganizationControlComplianceStats>;
  /** Description */
  description: Scalars["String"]["output"];
  /**
   * Rolled-up effort totals across every space in the organization, filtered
   * to findings tagged with has-remediation. `state` selects the slice:
   *
   * - OPEN (default): current backlog — risk score ≤ 99.
   * - REMEDIATED: labor saved across already-fixed findings — risk score = 100.
   *
   * Computed server-side in one round trip. Nullable so that a transient
   * aggregation error degrades gracefully.
   *
   * When spaceMrns is set, the aggregation is restricted to the per-space
   * rolled-up rows for those spaces (rather than the org-level rollup row).
   */
  effortTotals?: Maybe<OrganizationEffortTotals>;
  /** ID */
  id: Scalars["ID"]["output"];
  /** Member statistics */
  memberStats?: Maybe<MemberStats>;
  /** List of members of the organization */
  members?: Maybe<MembersConnection>;
  /** List metrics for the organization */
  metrics?: Maybe<MetricsResponse>;
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Name */
  name: Scalars["String"]["output"];
  /** Settings */
  settings?: Maybe<OrganizationSettings>;
  /**
   * DEPRECATED
   * @deprecated Use spacesList instead
   */
  spaces: Array<Space>;
  /** Amount of spaces in the organization */
  spacesCount: Scalars["Int"]["output"];
  /** List of spaces in the organization */
  spacesList: SpaceConnection;
  /** Subscription info */
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  /** Tags */
  tags: Array<Tag>;
};

/** Organization */
export type OrganizationControlComplianceStatsArgs = {
  spaceMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Organization */
export type OrganizationEffortTotalsArgs = {
  spaceMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  state?: InputMaybe<OrganizationEffortFindingState>;
};

/** Organization */
export type OrganizationMembersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  identitiesFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  identityTypeFilter?: InputMaybe<Array<MemberIdentityType>>;
  includeChildrenOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderBy?: InputMaybe<MembershipOrder>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  rolesFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Organization */
export type OrganizationMetricsArgs = {
  endTime?: InputMaybe<Scalars["String"]["input"]>;
  metricMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  startTime?: InputMaybe<Scalars["String"]["input"]>;
};

/** Organization */
export type OrganizationSpacesArgs = {
  spaceMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Organization */
export type OrganizationSpacesListArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  spaceMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/**
 * Aggregate compliance control statistics for an organization, rolled up
 * across every framework in every space in the org. Returned from
 * Organization.controlComplianceStats.
 */
export type OrganizationControlComplianceStats = {
  __typename: "OrganizationControlComplianceStats";
  /** Number of controls whose state is ENABLED (i.e. in scope and not excepted). */
  activeControls: Scalars["Int"]["output"];
  /**
   * Average completion percentage across ENABLED controls only, integer 0–100.
   * Returns 0 if the organization has no active controls.
   */
  averageCompletion: Scalars["Int"]["output"];
  /** Number of ENABLED controls whose completion is below 100%. */
  failingControls: Scalars["Int"]["output"];
  /** Number of ENABLED controls whose completion is 100%. */
  passingControls: Scalars["Int"]["output"];
  /**
   * Total number of compliance controls across every framework in every space
   * in the organization, counting all states.
   */
  totalControls: Scalars["Int"]["output"];
  /**
   * Number of controls in any exempted state (SNOOZED, DISABLED,
   * RISK_ACCEPTED, WORKAROUND, FALSE_POSITIVE).
   */
  totalExceptions: Scalars["Int"]["output"];
};

/**
 * Which slice of organization-wide findings Organization.effortTotals
 * should roll up. Both slices require the has-remediation tag.
 */
export enum OrganizationEffortFindingState {
  /** Open backlog — risk score ≤ 99. */
  Open = "OPEN",
  /** Already-fixed findings — risk score = 100. Surfaces past labor saved. */
  Remediated = "REMEDIATED",
}

/**
 * Rolled-up effort totals for organization-wide findings.
 * Returned from Organization.effortTotals. All values are non-negative;
 * totalEffort and totalManualEffort are in minutes, matching
 * AggregateScore.effort and ManualEffort.totalManualEffort.
 */
export type OrganizationEffortTotals = {
  __typename: "OrganizationEffortTotals";
  /** Number of aggregate scores matched by the actionable-findings filter. */
  totalCount: Scalars["Int"]["output"];
  /** Sum of AggregateScore.effort across matched scores, in minutes. */
  totalEffort: Scalars["Int"]["output"];
  /** Sum of ManualEffort.totalManualEffort across matched scores, in minutes. */
  totalManualEffort: Scalars["Int"]["output"];
};

/** Organization overview input */
export type OrganizationOverviewInput = {
  /** Organization MRN */
  organizationMrn: Scalars["String"]["input"];
};

/** Organization overview response */
export type OrganizationOverviewResponse = {
  __typename: "OrganizationOverviewResponse";
  /** Asset scores */
  assetScores?: Maybe<Array<AssetScoresDistribution>>;
  /** Assets */
  assets: AssetsInfo;
  /** End-of-life assets count */
  eolAssets: Scalars["Int"]["output"];
  /** Integration summaries */
  integrationSummaries?: Maybe<Array<IntegrationTypeSummary>>;
  /** New vulnerabilities */
  newVulnerabilities?: Maybe<Array<NewVulnerabilityInfo>>;
  /** Organization MRN */
  organizationMrn: Scalars["String"]["output"];
  /** Report date */
  reportDate?: Maybe<Scalars["String"]["output"]>;
  /** Spaces overview */
  spacesOverview?: Maybe<Array<SpaceInfo>>;
  /** Top vulnerabilities */
  topVulnerabilities?: Maybe<Array<VulnerabilityInfo>>;
  /** Vulnerabilities */
  vulnerabilities?: Maybe<Array<Vulnerabilities>>;
};

/** Organization settings input */
export type OrganizationSettings = {
  __typename: "OrganizationSettings";
  /** Ingest proxy upload configuration */
  ingestProxyConfiguration: IngestProxyConfiguration;
  /** Risk categories configuration */
  riskCategoriesConfiguration: RiskCategoriesConfiguration;
};

/** Organization settings input */
export type OrganizationSettingsInput = {
  /** Ingest proxy upload configuration */
  ingestProxyConfiguration?: InputMaybe<IngestProxyConfigurationInput>;
  /** Risk category configuration */
  riskCategoriesConfiguration?: InputMaybe<RiskCategoriesConfigurationInput>;
};

/** OS Package */
export type Package = {
  __typename: "Package";
  /** Package arch */
  arch?: Maybe<Scalars["String"]["output"]>;
  /** Package available version */
  available?: Maybe<Scalars["String"]["output"]>;
  /** Package cvss score */
  cvssScore: CvssScore;
  /** Package description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Package ecosystem */
  ecosystem?: Maybe<Scalars["String"]["output"]>;
  /** Package EPSS score */
  epssScore?: Maybe<EpssScore>;
  /**
   * Package format
   * @deprecated Deprecated: Use `purlType` instead
   */
  format?: Maybe<Scalars["String"]["output"]>;
  /**
   * A short string to identify the icon in the UI
   * @deprecated Deprecated: Use iconIDEnum. (remove in v12)
   */
  iconID?: Maybe<Scalars["String"]["output"]>;
  /** Same as iconID, but as an enum */
  iconIDEnum?: Maybe<Icon_Ids>;
  /** Package id */
  id: Scalars["ID"]["output"];
  /** Package name */
  name: Scalars["String"]["output"];
  /**
   * Package namespace, e.g., ubuntu:18.04
   * @deprecated Deprecated: Use `ecosystem` instead
   */
  namespace?: Maybe<Scalars["String"]["output"]>;
  /** Package origin */
  origin?: Maybe<Scalars["String"]["output"]>;
  /** Package purl type */
  purlType?: Maybe<Scalars["String"]["output"]>;
  /**
   * Package score
   * @deprecated Use `cvssScore`.
   */
  score: CvssScore;
  /** Package status */
  status?: Maybe<Scalars["String"]["output"]>;
  /**
   * Is it an os package or an app?
   * @deprecated Deprecated: Use `ecosystem` instead
   */
  type: PackageType;
  /** Package version */
  version?: Maybe<Scalars["String"]["output"]>;
  /** When was the highest scored CVE first discovered */
  vulnDiscoveryTime?: Maybe<Scalars["String"]["output"]>;
};

/** Package filters */
export type PackageFilter = {
  /** is package affected by a CVE? */
  isVulnerable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * packageName is a filter with exact match
   * The queryTerms are a "contains" search. That's useful for the general search.
   * But for the softwareDetails we need to search for the exact package name.
   */
  packageName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * filter by textfield input. ex.: ["Chrome", "Firefox"]
   * elements will be ANDed
   */
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * os package or app
   * @deprecated OS_PACKAGE/APPLICATION distinction is no longer used
   */
  type?: InputMaybe<PackageType>;
};

/** Package finding object */
export type PackageFinding = {
  __typename: "PackageFinding";
  /** Asset information */
  asset?: Maybe<EntityInfoAsset>;
  /** Available version of the package */
  availableVersion?: Maybe<Scalars["String"]["output"]>;
  /** Base Score */
  baseScore: Scalars["Int"]["output"];
  /** Cases associated with this finding. */
  cases?: Maybe<CasesConnection>;
  /** CVSS score for this package */
  cvss: CvssScore;
  /** EPSS score for this package */
  epss?: Maybe<EpssScore>;
  /** First found (RFC3339) */
  firstFound: Scalars["String"]["output"];
  /** Icon ID to determine the icon in the UI */
  iconId?: Maybe<Icon_Ids>;
  /** Score ID */
  id: Scalars["String"]["output"];
  /** Installed version of the package */
  installedVersion?: Maybe<Scalars["String"]["output"]>;
  /** Most recent time the score was updated (RFC3339) */
  lastScoreUpdateTime: Scalars["String"]["output"];
  /**
   * Last updated (RFC3339)
   * Deprecated: Use lastScoreUpdateTime instead.
   * @deprecated Use lastScoreUpdateTime instead
   */
  lastUpdated: Scalars["String"]["output"];
  /** Finding MRN */
  mrn: Scalars["String"]["output"];
  /** Package name */
  packageName?: Maybe<Scalars["String"]["output"]>;
  /**
   * Is it an os package or an app?
   * @deprecated OS_PACKAGE/APPLICATION distinction is no longer used
   */
  packageType: PackageType;
  /** platform name and version as single string */
  platform?: Maybe<Scalars["String"]["output"]>;
  /** Rating */
  rating: ScoreRating;
  /** Risk factors */
  riskFactors?: Maybe<Array<Maybe<RiskFactorStats>>>;
  /** Risk Score */
  riskScore: Scalars["Int"]["output"];
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue: Scalars["Int"]["output"];
  /** Space risk delta and effort for the finding */
  spaceRiskDelta?: Maybe<FindingSpaceRiskDelta>;
  /** All states for the finding */
  states: FindingState;
  /** Package score tags, e.g., "epss", "available", ... */
  tags?: Maybe<Array<Tag>>;
  /**
   * Package title
   * Pretty name of the package, e.g., "Windows Server 2022"
   */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Package finding object */
export type PackageFindingCasesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<FindingCasesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Package input */
export type PackageInput = {
  /**
   * Package arch
   * @deprecated This approach is deprecated, do not use it.
   */
  arch?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Package format
   * @deprecated This approach is deprecated, do not use it.
   */
  format?: InputMaybe<Scalars["String"]["input"]>;
  /** Package name */
  name: Scalars["String"]["input"];
  /**
   * Package origin, needed for debian
   * @deprecated This approach is deprecated, do not use it.
   */
  origin?: InputMaybe<Scalars["String"]["input"]>;
  /** Package version */
  version: Scalars["String"]["input"];
};

/** Remediation script type */
export enum PackageManager {
  /** AIX */
  Aix = "AIX",
  /** APK */
  Apk = "APK",
  /** BREW aka. HOMEBREW */
  Brew = "BREW",
  /** DNF */
  Dnf = "DNF",
  /** DPKG */
  Dpkg = "DPKG",
  /** Manual Instructions */
  Manual = "MANUAL",
  /** POWERSHELL */
  Powershell = "POWERSHELL",
  /** SNAP */
  Snap = "SNAP",
  /** SOFTWARE_UPDATE (macOS Software Update) */
  SoftwareUpdate = "SOFTWARE_UPDATE",
  /** WINGET */
  Winget = "WINGET",
  /** YUM */
  Yum = "YUM",
  /** ZYPPER */
  Zypper = "ZYPPER",
}

/** Represents a package reference which can be used to filter remediaiton scripts. */
export type PackageReferenceInput = {
  /** The name of the package to filter remediations for. */
  name: Scalars["String"]["input"];
  /**
   * The version of the package to filter remediations for. This is optional and can be used to
   * filter remediations for a specific version of the package.
   * @deprecated This field is deprecated, and no longer affecting the remediation.
   */
  version?: InputMaybe<Scalars["String"]["input"]>;
};

/** Package score */
export type PackageScore = {
  __typename: "PackageScore";
  /** Asset information */
  asset?: Maybe<EntityInfoAsset>;
  /**
   * Asset MRN
   * @deprecated Use `asset.Mrn` instead.
   */
  assetMrn?: Maybe<Scalars["String"]["output"]>;
  /**
   * Asset name
   * @deprecated Use `asset.Name` instead.
   */
  assetName?: Maybe<Scalars["String"]["output"]>;
  /** Available version of the package */
  availableVersion?: Maybe<Scalars["String"]["output"]>;
  /** CVSS score for this package */
  cvssScore: CvssScore;
  /** EPSS score for this package */
  epssScore?: Maybe<EpssScore>;
  /** First found (RFC3339) */
  firstFound: Scalars["String"]["output"];
  /** Icon ID to determine the icon in the UI */
  iconIDEnum?: Maybe<Icon_Ids>;
  /** Score ID */
  id: Scalars["String"]["output"];
  /** Installed version of the package */
  installedVersion?: Maybe<Scalars["String"]["output"]>;
  /** Most recent time the score was updated (RFC3339) */
  lastScoreUpdateTime: Scalars["String"]["output"];
  /**
   * Last updated (RFC3339)
   * Deprecated: Use lastScoreUpdateTime instead.
   * @deprecated Use lastScoreUpdateTime instead
   */
  lastUpdated: Scalars["String"]["output"];
  /** Package name */
  packageName?: Maybe<Scalars["String"]["output"]>;
  /**
   * Is it an os package or an app?
   * @deprecated OS_PACKAGE/APPLICATION distinction is no longer used
   */
  packageType: PackageType;
  /** platform name and version as single string */
  platform?: Maybe<Scalars["String"]["output"]>;
  /** Rating */
  rating: ScoreRating;
  /** Risk factors */
  riskFactors?: Maybe<Array<Maybe<RiskFactorStats>>>;
  /** Risk Score */
  riskScore: Scalars["Int"]["output"];
  /** Base Score */
  score: Scalars["Int"]["output"];
  /** Package score tags, e.g., "epss", "available", ... */
  tags?: Maybe<Array<Tag>>;
  /**
   * Package title
   * Pretty name of the package, e.g., "Windows Server 2022"
   */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Package score edge */
export type PackageScoreEdge = {
  __typename: "PackageScoreEdge";
  /** A cursor used for pagination */
  cursor: Scalars["ID"]["output"];
  /** The real package score */
  node?: Maybe<PackageScore>;
};

/** Package scores */
export type PackageScores = {
  __typename: "PackageScores";
  /** Package scores */
  edges?: Maybe<Array<PackageScoreEdge>>;
  /** Pagination info */
  pageInfo: PageInfo;
  /** Statistics */
  stats?: Maybe<PackageScoresStats>;
  /** Total count of applications */
  totalApps: Scalars["Int"]["output"];
  /** Total count of scored packages */
  totalCount: Scalars["Int"]["output"];
  /** Total count of os packages */
  totalOsPackages: Scalars["Int"]["output"];
};

/** Package filters */
export type PackageScoresFilter = {
  /** is package affected by a CVE? */
  isVulnerable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Package version */
  packageVersion?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * filter by textfield input. ex.: ["Chrome", "Firefox"]
   * elements will be ANDed
   */
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * os package or app
   * @deprecated OS_PACKAGE/APPLICATION distinction is no longer used
   */
  type?: InputMaybe<PackageType>;
};

/**
 * PackageScores input data
 * This requires either a spaceMrn AND a findingMrn OR only an assetMrn
 */
export type PackageScoresInput = {
  /** Asset or Space MRN */
  entityMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter */
  filter?: InputMaybe<PackageScoresFilter>;
  /** Package/Finding mrn */
  findingMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Package version (optional)
   * @deprecated Use `filter.packageVersion`.
   */
  packageVersion?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Space MRN
   * @deprecated Use `entityMrn`.
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** PackageScores order */
export type PackageScoresOrder = {
  /** Order direction */
  direction: OrderDirection;
  /** Order field */
  field: PackageScoresOrderField;
};

/** PackageScores order fields */
export enum PackageScoresOrderField {
  AssetName = "ASSET_NAME",
  FirstFound = "FIRST_FOUND",
  LastUpdated = "LAST_UPDATED",
  PackageName = "PACKAGE_NAME",
  RiskFactors = "RISK_FACTORS",
  RiskScore = "RISK_SCORE",
  Score = "SCORE",
}

/** PackageScores response types */
export type PackageScoresResponse = NotFoundError | PackageScores;

/** Package stats counts for the Package scores */
export type PackageScoresStats = {
  __typename: "PackageScoresStats";
  /** Count of packages installed on the asset */
  totalPackages: Scalars["Int"]["output"];
  /** Count of packages affected by advisories and cves (w/o any filtering) */
  vulnerablePackages: Scalars["Int"]["output"];
};

/**
 * possible package types
 *
 * Deprecated: the OS_PACKAGE/APPLICATION distinction is no longer surfaced
 * in the UI. Tracked for removal: #15402.
 */
export enum PackageType {
  /** @deprecated OS_PACKAGE/APPLICATION distinction is no longer used */
  Application = "APPLICATION",
  /** @deprecated OS_PACKAGE/APPLICATION distinction is no longer used */
  OsPackage = "OS_PACKAGE",
}

/** package connection object */
export type PackagesConnection = {
  __typename: "PackagesConnection";
  /** packages */
  edges?: Maybe<Array<PackagesEdge>>;
  /** Pagination info */
  pageInfo: PageInfo;
  /** Statistics */
  stats?: Maybe<PackagesConnectionStats>;
  /** Total count of packages */
  totalCount: Scalars["Int"]["output"];
  /**
   * Total count of applications
   * @deprecated OS_PACKAGE/APPLICATION distinction is no longer used
   */
  totalCountApps: Scalars["Int"]["output"];
  /**
   * Total count of os packages
   * @deprecated OS_PACKAGE/APPLICATION distinction is no longer used
   */
  totalCountOsPackages: Scalars["Int"]["output"];
};

/** Package stats counts for the AssetVulnerabilityReport */
export type PackagesConnectionStats = {
  __typename: "PackagesConnectionStats";
  /** Count of packages installed on the asset */
  totalPackages: Scalars["Int"]["output"];
  /** Count of packages affected by advisories and CVEs (w/o any filtering) */
  vulnerablePackages: Scalars["Int"]["output"];
};

/**
 * An cve edge object
 * this should be singular
 */
export type PackagesEdge = {
  __typename: "PackagesEdge";
  /** A cursor used for pagination */
  cursor: Scalars["ID"]["output"];
  /** The real cve */
  node?: Maybe<Package>;
};

/** package order object */
export type PackagesOrder = {
  /** Order direction */
  direction: OrderDirection;
  /** Order field */
  field: PackagesOrderField;
};

/** possible package order fields */
export enum PackagesOrderField {
  FirstFound = "FIRST_FOUND",
  Name = "NAME",
  RiskFactors = "RISK_FACTORS",
  Score = "SCORE",
}

/** PageInfo contains information to aid in pagination. */
export type PageInfo = {
  __typename: "PageInfo";
  /** The cursor for the last item on the current page. */
  endCursor: Scalars["ID"]["output"];
  /** Indicates if there are more items to be queried beyond the current page. */
  hasNextPage: Scalars["Boolean"]["output"];
  /** Indicates if there are more items that can be queried before the current page. */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** The cursor for the first item on the current page. */
  startCursor: Scalars["ID"]["output"];
};

/** Input for pausing a workflow schedule. */
export type PauseWorkflowScheduleInput = {
  /** MRN of the schedule to pause. */
  mrn: Scalars["ID"]["input"];
};

/** Result of pausing a workflow schedule. */
export type PauseWorkflowSchedulePayload = {
  __typename: "PauseWorkflowSchedulePayload";
  /** The paused schedule. */
  schedule: WorkflowSchedule;
};

/** Preview of payment information for subscription changes */
export type PaymentPreview = {
  __typename: "PaymentPreview";
  /** The currency for the payment */
  currency: Scalars["String"]["output"];
  /** The amount due today */
  dueToday: Scalars["Int"]["output"];
  /** The effective date of the change */
  effectiveDate: Scalars["String"]["output"];
  /** The proration date */
  prorationDate: Scalars["Int"]["output"];
  /** The recurring cost of the subscription */
  recurringCost: Scalars["Int"]["output"];
};

/** A pending user who has been invited but hasn't signed up yet */
export type PendingUser = Identity & {
  __typename: "PendingUser";
  /** The email of the pending user */
  email: Scalars["String"]["output"];
  /** The MRN - empty for pending users */
  mrn: Scalars["String"]["output"];
  /** The name - empty for pending users */
  name: Scalars["String"]["output"];
};

/** Input options for discovery job on client integration */
export type PerformDiscoveryInput = {
  mrn: Scalars["String"]["input"];
};

/** Response when performing discovery job on client integration */
export type PerformDiscoveryPayload = {
  __typename: "PerformDiscoveryPayload";
  /** The MRN of the client integration for which discovery was performed */
  mrn: Scalars["String"]["output"];
};

/** Inputs used to ping a client integration */
export type PingIntegrationInput = {
  /** Optional source identifier, e.g. AWS account id. */
  identifiers?: InputMaybe<Array<Scalars["String"]["input"]>>;
  mrn: Scalars["String"]["input"];
};

/** Response from sending ping to client integration */
export type PingIntegrationPayload = {
  __typename: "PingIntegrationPayload";
  /** The MRN of the pinged client integration */
  mrn: Scalars["String"]["output"];
};

/** Platform */
export type Platform = {
  __typename: "Platform";
  /** The architecture of the platform */
  arch: Scalars["String"]["output"];
  /** Family */
  family?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The kind of the platform */
  kind: PlatformKind;
  /** Labels */
  labels?: Maybe<Array<KeyValue>>;
  /** The name of the platform */
  name: Scalars["String"]["output"];
  /**
   * The release of the platform (deprecated use version instead)
   * @deprecated Use version
   */
  release: Scalars["String"]["output"];
  /** The runtime of the platform */
  runtime: Scalars["String"]["output"];
  /** The title of the platform */
  title: Scalars["String"]["output"];
  /** The version of the platform */
  version: Scalars["String"]["output"];
};

/** Platform distribution statistics */
export type PlatformDistributionStats = {
  __typename: "PlatformDistributionStats";
  /** Assets count */
  assets: Scalars["Int"]["output"];
  /** Platform */
  platform?: Maybe<Platform>;
  /** Rating */
  rating: Scalars["String"]["output"];
};

/** Platform input */
export type PlatformInput = {
  /** The architecture of the platform */
  arch?: InputMaybe<Scalars["String"]["input"]>;
  /** The build of the platform */
  build?: InputMaybe<Scalars["String"]["input"]>;
  /** The platform families */
  family?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** The kind of the platform */
  kind?: InputMaybe<PlatformKind>;
  /** The labels of the platform */
  labels?: InputMaybe<Array<InputMaybe<KeyValueInput>>>;
  /** The name of the platform */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** The release of the platform */
  release?: InputMaybe<Scalars["String"]["input"]>;
  /** The runtime of the platform */
  runtime?: InputMaybe<Scalars["String"]["input"]>;
};

/** Platform kind */
export enum PlatformKind {
  Api = "API",
  BareMetal = "BARE_METAL",
  Code = "CODE",
  Container = "CONTAINER",
  ContainerImage = "CONTAINER_IMAGE",
  Package = "PACKAGE",
  Process = "PROCESS",
  Unknown = "UNKNOWN",
  VirtualMachine = "VIRTUAL_MACHINE",
  VirtualMachineImage = "VIRTUAL_MACHINE_IMAGE",
}

/** Platform MQL VEX configuration */
export type PlatformMqlVexConfiguration = {
  __typename: "PlatformMqlVexConfiguration";
  /** Whether to enable platform MQL VEX analysis */
  enable: Scalars["Boolean"]["output"];
};

/** Platform MQL VEX configuration input */
export type PlatformMqlVexConfigurationInput = {
  /** Whether to enable platform MQL VEX analysis */
  enable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Platform vulnerability configuration */
export type PlatformVulnerabilityConfiguration = {
  __typename: "PlatformVulnerabilityConfiguration";
  /** Whether to enable platform vulnerability analysis */
  enable: Scalars["Boolean"]["output"];
};

/** Platform vulnerability configuration input */
export type PlatformVulnerabilityConfigurationInput = {
  /** Whether to enable platform vulnerability analysis */
  enable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input for retrieving a list of platforms for the scope */
export type PlatformsListInput = {
  /**
   * scopeMrn is the space mrn the user is requesting platforms for. The returned
   * response will contain all public platforms unioned with platforms appearing
   * in content for this space
   */
  scopeMrn: Scalars["String"]["input"];
};

/** Policy */
export type Policy = {
  __typename: "Policy";
  /** Access */
  access: Access;
  /** Action */
  action?: Maybe<PolicyAction>;
  /** Assigned */
  assigned: Scalars["Boolean"]["output"];
  /** The scope MRN where this policy was assigned (space, org, or platform) */
  assignedScope?: Maybe<Scalars["String"]["output"]>;
  /** Authors */
  authors?: Maybe<Array<Author>>;
  /** Category */
  category: Scalars["String"]["output"];
  /** Certified by */
  certifiedBy?: Maybe<Certifier>;
  /**
   * Checksum
   * @deprecated Internal detail
   */
  checksum: Scalars["String"]["output"];
  /** Created at */
  createdAt: Scalars["String"]["output"];
  /** The default scoring system intended for the policy */
  defaultScoringSystem?: Maybe<ScoringSystem>;
  /** Docs */
  docs: Scalars["String"]["output"];
  /** Featured */
  featured: Scalars["Boolean"]["output"];
  /** Github URL */
  githubUrl?: Maybe<Scalars["String"]["output"]>;
  /**
   * Graph content checksum
   * @deprecated Internal detail
   */
  graph_content_checksum: Scalars["String"]["output"];
  /**
   * Graph execution checksum
   * @deprecated Internal detail
   */
  graph_execution_checksum: Scalars["String"]["output"];
  /** Groups */
  groups?: Maybe<Array<PolicyGroup>>;
  /**
   * IsPublic - deprecated
   * @deprecated Use access and trustLevel
   */
  isPublic: Scalars["Boolean"]["output"];
  /**
   * Mquery counts
   * @deprecated Use statistics
   */
  mqueryCounts: MqueryCounts;
  /** The mrn is a unique identifier */
  mrn: Scalars["ID"]["output"];
  /** Mutation statistics */
  mutationStatistics?: Maybe<PolicyMutationStatistics>;
  /** Name */
  name: Scalars["String"]["output"];
  /** Platforms */
  platforms?: Maybe<Array<ContentPlatform>>;
  /** Properties */
  properties?: Maybe<Array<MProperty>>;
  /** Queries */
  queries?: Maybe<Array<Mquery>>;
  /** Run CLI */
  runCli?: Maybe<RunCli>;
  /** Scoring system, potentially overridden by the space */
  scoringSystem?: Maybe<ScoringSystem>;
  /** Statistics */
  statistics: PolicyStatistics;
  /**
   * Statistics
   * @deprecated Use statistics
   */
  stats?: Maybe<PolicyStatistics>;
  /** Summary */
  summary: Scalars["String"]["output"];
  /** Tags */
  tags?: Maybe<Array<Tag>>;
  /** Trust level */
  trustLevel: TrustLevel;
  /** Unique resource identifier (uid) */
  uid: Scalars["ID"]["output"];
  /** Updated at */
  updatedAt: Scalars["String"]["output"];
  /** variantPlatformFilters is a list of platform filters to filter variants by */
  variantPlatformFilters?: Maybe<Array<VariantPlatformFilter>>;
  /** Variants */
  variants?: Maybe<Array<Variant>>;
  /** Version */
  version: Scalars["String"]["output"];
};

/** Policy action */
export enum PolicyAction {
  Active = "ACTIVE",
  Ignore = "IGNORE",
}

/** PolicyAddInput */
export type PolicyAddInput = {
  /** RFC2397, base64 encoded policy bundle */
  dataurl: Scalars["String"]["input"];
  /** Force */
  force?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The mrn of the space */
  spaceMrn: Scalars["String"]["input"];
};

/**
 * Input options for a policy aggregate scores export. The export emits one
 * JSONL line per check aggregate score under the given policy, tagged with
 * the scope hierarchy each row belongs to. The export scope comes from the
 * parent GenerateDocumentInput.scopeMRN.
 */
export type PolicyAggregateScoresExportOptionsInput = {
  /**
   * When true, additionally include per-asset rows (asset↔policy and
   * asset↔check) beneath each space/workspace. Off by default. Can be large.
   */
  includeAssetScores?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The MRN of the policy whose checks should be included in the export. */
  policyMrn: Scalars["String"]["input"];
  /**
   * When true, walks the hierarchy downward from the request scopeMRN:
   *   platform     -> orgs -> spaces -> workspaces
   *   organization ->         spaces -> workspaces
   *   space        ->                   workspaces
   *   workspace    -> leaf
   * When false, only the scope's own aggregate scores are emitted.
   */
  recursive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Policy analytics input */
export type PolicyAnalyticsInput = {
  /**
   * The ordering of the returned policies
   * @deprecated Use orderByV2 with PolicyAnalyticsOrder instead
   */
  orderBy?: InputMaybe<ActivePolicyOrder>;
  /** The ordering of the returned policies (v2) */
  orderByV2?: InputMaybe<PolicyAnalyticsOrder>;
  /** Filters the policies with the given query. Partial matches by name are supported. */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Scope MRN to filter by. If not provided, defaults to platform scope.
   * Accepts organization MRNs to scope results to a specific org.
   */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Policy analytics order */
export type PolicyAnalyticsOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: PolicyAnalyticsOrderField;
};

/** Policy analytics order field */
export enum PolicyAnalyticsOrderField {
  Action = "ACTION",
  AssetCount = "ASSET_COUNT",
  BlastRadius = "BLAST_RADIUS",
  Completion = "COMPLETION",
  Title = "TITLE",
}

/** Policy assignment input */
export type PolicyAssignmentInput = {
  /** Action */
  action?: InputMaybe<PolicyAction>;
  /** The mrn of the asset */
  assetMrn: Scalars["String"]["input"];
  /** The mrn of the policy */
  policyMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Policy MRNs */
  policyMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Scoring System */
  scoringSystem?: InputMaybe<ScoringSystem>;
};

/** Policy bundle YAML */
export type PolicyBundleYaml = {
  __typename: "PolicyBundleYaml";
  /** YAML */
  yaml: Scalars["String"]["output"];
};

/**
 * Represents a policy check that is part of a control. The policy is considered to be a single
 * check, passing only if the policy score is a 100.
 */
export type PolicyCheck = {
  __typename: "PolicyCheck";
  /** Amount of assets the check has been executed against */
  assets: Scalars["Int"]["output"];
  /** Completion */
  completion: Scalars["Int"]["output"];
  /** MRN of the policy the check is part of */
  policyMrn: Scalars["String"]["output"];
  /** Name of the policy the check is part of */
  policyName: Scalars["String"]["output"];
  /** State */
  state: CheckState;
};

/** Represents a reference to a policy and a specific group inside the policy. */
export type PolicyCheckRef = {
  __typename: "PolicyCheckRef";
  /** Group */
  group: Scalars["String"]["output"];
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Name */
  name: Scalars["String"]["output"];
};

/** Policy delete input */
export type PolicyDeleteInput = {
  /** The mrn of the policy */
  policyMrn: Scalars["String"]["input"];
};

/** PolicyGroup */
export type PolicyGroup = {
  __typename: "PolicyGroup";
  /** checks */
  checks?: Maybe<Array<QueryRef>>;
  /** policies */
  policies?: Maybe<Array<PolicyRef>>;
  /** queries */
  queries?: Maybe<Array<QueryRef>>;
  /** summary */
  summary: Scalars["String"]["output"];
  /** The title */
  title: Scalars["String"]["output"];
  /** Type of this group (regular, override, ignored, etc.) */
  type: PolicyGroupType;
  /** Validity window for this group (when it's active) */
  valid?: Maybe<ValidityWindow>;
};

/** Type of policy group */
export enum PolicyGroupType {
  /** Chapter/section grouping */
  Chapter = "CHAPTER",
  /** Disabled checks - not executing */
  Disable = "DISABLE",
  /** Ignored/preview checks - not scoring */
  Ignored = "IGNORED",
  /** Imported from another policy */
  Import = "IMPORT",
  /** Out of scope checks */
  OutOfScope = "OUT_OF_SCOPE",
  /** Override group - modifies existing checks (preview, impact changes, etc.) */
  Override = "OVERRIDE",
  /** Property modifications */
  Properties = "PROPERTIES",
  /** Regular group of checks/queries */
  Uncategorized = "UNCATEGORIZED",
}

/** Policy info */
export type PolicyInfo = {
  __typename: "PolicyInfo";
  /** The mrn is a unique identifier */
  mrn?: Maybe<Scalars["String"]["output"]>;
  /** Name */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Score */
  score?: Maybe<Scalars["Int"]["output"]>;
};

/** PolicyInput */
export type PolicyInput = {
  /** The mrn is a unique identifier */
  mrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * spaceMrn must be provided if you want to know if the policy
   * is assigned
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** variant */
  variant?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * variantPlatformFilter allows filter the variants by a target
   * platform id.
   */
  variantPlatformFilter?: InputMaybe<Scalars["String"]["input"]>;
};

/** Policy mutation statistics */
export type PolicyMutationStatistics = {
  __typename: "PolicyMutationStatistics";
  /** Checks */
  checks: PolicyQueryStatistics;
  /** Queries */
  queries: PolicyQueryStatistics;
};

/** Represents a reference to either a policy or a query pack. */
export type PolicyOrPackRef = PolicyCheckRef | QueryPackCheckRef;

/** Policy query assessment */
export type PolicyQueryAssessment = {
  __typename: "PolicyQueryAssessment";
  /** Extended results */
  extendedResults?: Maybe<Array<PolicyQueryAssessmentResources>>;
  /** Needs upgrade */
  needsUpgrade: Scalars["Boolean"]["output"];
  /** Rendered */
  rendered: Scalars["String"]["output"];
  /** Results */
  results?: Maybe<Array<PolicyQueryAssessmentItem>>;
  /** State */
  state: PolicyReportEntryState;
};

/** Policy query assessment item */
export type PolicyQueryAssessmentItem = {
  __typename: "PolicyQueryAssessmentItem";
  /** Actual */
  actual: Scalars["String"]["output"];
  /** Error */
  error: Scalars["String"]["output"];
  /** Expected */
  expected: Scalars["String"]["output"];
};

/** Policy query assessment resources */
export type PolicyQueryAssessmentResources = {
  __typename: "PolicyQueryAssessmentResources";
  /** Actual */
  actual?: Maybe<Array<Resource>>;
  /** Number of resources */
  numResources: Scalars["Int"]["output"];
  /** Resource name */
  resourceName: Scalars["String"]["output"];
  /** Resource title */
  resourceTitle: Scalars["String"]["output"];
};

/** Policy query statistics */
export type PolicyQueryStatistics = {
  __typename: "PolicyQueryStatistics";
  /** Active */
  active: Scalars["Int"]["output"];
  /** Ignored */
  ignored: Scalars["Int"]["output"];
  /** Removed */
  removed: Scalars["Int"]["output"];
};

/** Policy reference */
export type PolicyRef = {
  __typename: "PolicyRef";
  /** Action */
  action: PolicyReportScoreEntryAction;
  /** Impact */
  impact?: Maybe<Impact>;
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["output"];
};

/** Policy report */
export type PolicyReport = {
  __typename: "PolicyReport";
  /** Client version */
  clientVersion: Scalars["String"]["output"];
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["output"];
  /** Needs upgrade */
  needsUpgrade: Scalars["Boolean"]["output"];
  /** Results */
  results: Scalars["Map"]["output"];
  /** Scores */
  scores: Array<PolicyReportScoreEntry>;
};

/** Policy report asset summaries connection */
export type PolicyReportAssetSummariesConnection = {
  __typename: "PolicyReportAssetSummariesConnection";
  /** Edges */
  edges?: Maybe<Array<PolicyReportAssetSummaryEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Policy report asset summary */
export type PolicyReportAssetSummary = {
  __typename: "PolicyReportAssetSummary";
  /** Asset */
  asset: Asset;
  /** Grade */
  grade: Grade;
  /** ID */
  id: Scalars["ID"]["output"];
  /** Mquery results distribution */
  mqueryResultsDistribution: MqueryResultsDistribution;
  /** The mrn of the policy */
  policyMrn: Scalars["ID"]["output"];
  /** The score */
  score: Score;
};

/** Policy report asset summary edge */
export type PolicyReportAssetSummaryEdge = {
  __typename: "PolicyReportAssetSummaryEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<PolicyReportAssetSummary>;
};

/** Policy report entry state */
export enum PolicyReportEntryState {
  Error = "ERROR",
  Fail = "FAIL",
  Ignore = "IGNORE",
  Pass = "PASS",
}

/** Policy report mquery summaries connection */
export type PolicyReportMquerySummariesConnection = {
  __typename: "PolicyReportMquerySummariesConnection";
  /** Edges */
  edges?: Maybe<Array<MquerySummaryEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Policy report mquery summary order */
export type PolicyReportMquerySummaryOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: PolicyReportMquerySummaryOrderField;
};

/** Policy report mquery summary order field */
export enum PolicyReportMquerySummaryOrderField {
  Id = "ID",
  LastUpdated = "LAST_UPDATED",
  Name = "NAME",
  Platform = "PLATFORM",
  Score = "SCORE",
  Title = "TITLE",
}

/** Policy report score entry */
export type PolicyReportScoreEntry = {
  __typename: "PolicyReportScoreEntry";
  /** Action */
  action: PolicyReportScoreEntryAction;
  /** Assessment */
  assessment?: Maybe<PolicyQueryAssessment>;
  /** ID */
  id: Scalars["String"]["output"];
  /** The score */
  score: Score;
};

/** Policy report score entry action */
export enum PolicyReportScoreEntryAction {
  Deactivate = "DEACTIVATE",
  Ignore = "IGNORE",
  Unspecified = "UNSPECIFIED",
}

/** Policy report summaries connection */
export type PolicyReportSummariesConnection = {
  __typename: "PolicyReportSummariesConnection";
  /** Edges */
  edges?: Maybe<Array<PolicyReportSummaryEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Policy report summary */
export type PolicyReportSummary = {
  __typename: "PolicyReportSummary";
  /** Asset grades */
  assetGrades: AssetGradeDistribution;
  /** ID */
  id: Scalars["ID"]["output"];
  /** Policy */
  policy: Policy;
  /** The mrn of the policy */
  policyMrn: Scalars["ID"]["output"];
  /** Policy name */
  policyName: Scalars["ID"]["output"];
};

/** Policy report summary edge */
export type PolicyReportSummaryEdge = {
  __typename: "PolicyReportSummaryEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<PolicyReportSummary>;
};

/** Policy report summary order */
export type PolicyReportSummaryOrder = {
  /** Direction */
  direction: OrderDirection;
  /** Field */
  field: PolicyReportSummaryOrderField;
};

/** Policy report summary order field */
export enum PolicyReportSummaryOrderField {
  Id = "ID",
  Modified = "MODIFIED",
  Published = "PUBLISHED",
  Score = "SCORE",
  Title = "TITLE",
}

/** Policy statistics */
export type PolicyStatistics = {
  __typename: "PolicyStatistics";
  /** Number of checks in the policy */
  checks: Scalars["Int"]["output"];
  /**
   * Data queries
   * @deprecated Use policyMutationStatistics.checks
   */
  dataqueries: PolicyQueryStatistics;
  /** Number of policies */
  policies: Scalars["Int"]["output"];
  /** Number of queries in the policy */
  queries: Scalars["Int"]["output"];
  /**
   * Scoring queries
   * @deprecated Use policyMutationStatistics.checks
   */
  scoringqueries: PolicyQueryStatistics;
};

/** Postgres configuration options */
export type PostgresConfigurationOptions = {
  __typename: "PostgresConfigurationOptions";
  /** The Postgres database name */
  database: Scalars["String"]["output"];
  /** The Postgres host address */
  host: Scalars["String"]["output"];
  /** The Postgres port */
  port: Scalars["String"]["output"];
  /** The Postgres user name */
  user: Scalars["String"]["output"];
};

/** Postgres integration input */
export type PostgresConfigurationOptionsInput = {
  /** The Postgres database name */
  database: Scalars["String"]["input"];
  /** The Postgres host address */
  host: Scalars["String"]["input"];
  /** The Postgres password */
  password: Scalars["String"]["input"];
  /** The Postgres port */
  port: Scalars["String"]["input"];
  /** The Postgres user name */
  user: Scalars["String"]["input"];
};

/** Pricing information for a product */
export type Price = {
  __typename: "Price";
  /** The cost in the smallest currency unit */
  cost: Scalars["Int"]["output"];
  /** The currency for the price */
  currency: Scalars["String"]["output"];
  /** The price ID */
  id: Scalars["String"]["output"];
};

/** Process case events input */
export type ProcessCaseEventsInput = {
  /** MRN of the scope to process events for */
  scopeMrn: Scalars["String"]["input"];
};

/** Product information with pricing and entitlements */
export type Product = {
  __typename: "Product";
  /** The product description */
  description: Scalars["String"]["output"];
  /** The entitlements included with the product */
  entitlements?: Maybe<Array<Entitlement>>;
  /** The product ID */
  id: Scalars["String"]["output"];
  /** Whether the product is self-service */
  isSelfService: Scalars["Boolean"]["output"];
  /** The product key */
  key: Scalars["String"]["output"];
  /** The maximum quantity allowed for the product */
  maxQuantity: Scalars["Int"]["output"];
  /** The product name */
  name: Scalars["String"]["output"];
  /** The pricing information for the product */
  price: Price;
};

/** Information about a product in the subscription */
export type ProductInfo = {
  __typename: "ProductInfo";
  /** The product ID */
  id: Scalars["String"]["output"];
  /** The product key */
  key: Scalars["String"]["output"];
  /** The product name */
  name: Scalars["String"]["output"];
  /** The quantity of the product */
  quantity: Scalars["Int"]["output"];
};

/** Property query mutation action */
export enum PropertyQueryMutationAction {
  /**
   * If the check action is used, the mutation will not take effect. We will attempt to validate
   * the target and check the mql
   */
  Check = "CHECK",
  /** If the set action is used, the existing property MQL will be overridden. */
  Set = "SET",
  /** If a property override is set for the property mrn, the UNSET action will remove it. */
  Unset = "UNSET",
}

/** Property query mutation input */
export type PropertyQueryMutationInput = {
  /** The action to apply */
  action: PropertyQueryMutationAction;
  /** A list of properties to apply the action to */
  props?: InputMaybe<Array<PropertyQueryOverride>>;
  /** Target to apply scoring mutation to. Can be an space/asset mrn. Or an asset filter */
  target: PropertyQueryMutationTarget;
};

/** This is returned if there is a problem with the property */
export type PropertyQueryMutationInvalidProperty = Error & {
  __typename: "PropertyQueryMutationInvalidProperty";
  /**
   * Potential codes:
   * - NOT_FOUND: You gave us a property we couldn't find
   * - COMPILE_ERROR: There was an error compiling the query
   * - INVALID_TYPE: The query did not return the expected type
   * - INVALID: Property wasn't properly specified
   * - UNKNOWN:
   */
  code: Scalars["String"]["output"];
  /** Message */
  message: Scalars["String"]["output"];
};

/** This is returned if there was a problem with the target */
export type PropertyQueryMutationInvalidTarget = Error & {
  __typename: "PropertyQueryMutationInvalidTarget";
  /**
   * Potential codes:
   * - NOT_FOUND: Couldn't find the mrn
   * - COMPILE_ERROR: Filter query didn't compile
   * - INVALID_TYPE: Filter query didn't return a boolean
   * - INVALID: Target wasn't property specified
   * - UNKNOWN:
   */
  code: Scalars["String"]["output"];
  /** Message */
  message: Scalars["String"]["output"];
};

/** Property query mutation payload */
export type PropertyQueryMutationPayload =
  | PropertyQueryMutationInvalidProperty
  | PropertyQueryMutationInvalidTarget
  | PropertyQueryMutationSuccess;

/** Property query mutation success */
export type PropertyQueryMutationSuccess = {
  __typename: "PropertyQueryMutationSuccess";
  /** Success */
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * The target can be a mrn (space mrn) or a filter query.
 * It is only valid to provide one of the parameters
 */
export type PropertyQueryMutationTarget = {
  /**
   * For a future iteration.
   *
   * The mql for the filter to apply properties to
   */
  filter?: InputMaybe<Scalars["String"]["input"]>;
  /** MRN of the target. For example, a space MRN, or asset MRN */
  mrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Property query override */
export type PropertyQueryOverride = {
  /**
   * The property query. Must be provided for the SET and CHECK actions.
   * It must not be provided for the UNSET action
   */
  mql?: InputMaybe<Scalars["String"]["input"]>;
  /** The property to apply the action to */
  propertyMrn: Scalars["String"]["input"];
};

/** Pull request information. */
export type PullRequestInfo = {
  __typename: "PullRequestInfo";
  /** The title of the pull request. */
  title: Scalars["String"]["output"];
  /** The URL of the pull request. */
  url: Scalars["String"]["output"];
};

/** Qualys configuration options */
export type QualysConfigurationOptions = {
  __typename: "QualysConfigurationOptions";
  /** Whether to create assets in the backend when they are not found */
  createAssets: Scalars["Boolean"]["output"];
  /** mondooEnrichment is a flag to enable mondoo scans based on the Qualys data */
  mondooEnrichment?: Maybe<Scalars["Boolean"]["output"]>;
  /** The Qualys username */
  username?: Maybe<Scalars["String"]["output"]>;
};

/** Qualys configuration options input */
export type QualysConfigurationOptionsInput = {
  /** Whether to create assets in the backend when they are not found */
  createAssets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** mondooEnrichment is a flag to enable mondoo scans based on the Qualys data */
  mondooEnrichment?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The Qualys password */
  password?: InputMaybe<Scalars["String"]["input"]>;
  /** The Qualys username */
  username?: InputMaybe<Scalars["String"]["input"]>;
};

/** Queries connection */
export type QueriesConnection = {
  __typename: "QueriesConnection";
  /** Edges */
  edges?: Maybe<Array<QueryEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Root query type for IAM operations */
export type Query = {
  __typename: "Query";
  /** Lists the active policies in the specified scope */
  activePolicies?: Maybe<ActivePoliciesConnection>;
  /**
   * Advisory and cve information.
   * @deprecated Use vuln(id) from vuln_intel.graphqls instead.
   */
  advisory?: Maybe<Advisory>;
  /** Get a list of ecosystems that are affected by a vulnerability in a given scope. */
  affectedEcosystems: Array<Ecosystem>;
  /** Fetch an agent (managed client) */
  agent?: Maybe<Agent>;
  /** List of agents */
  agents?: Maybe<AgentsConnection>;
  /** Fetch the aggregate scores for an asset or space */
  aggregateScores?: Maybe<AggregateScoresResponse>;
  /** Fetch the aggregate scores refresh info for a group */
  aggregateScoresRefreshInfo: AggregateScoresRefreshInfo;
  /** Get filter suggestions for aggregate scores */
  aggregateScoresSuggestions?: Maybe<Array<AggregateScoresFilterSuggestion>>;
  /**
   * Returns one asset's AI coding-tooling inventory (ADR-058): the LLM coding agents
   * installed on the asset and, per agent, the plugins, skills, and MCP servers configured
   * for it. This is the per-asset "drill into this asset's AI tooling" view — the fleet-wide
   * aggregate is served by the ARD queries.
   */
  aiInventory: AiInventory;
  /**
   * Get the current state of an AI-generated summary without triggering generation.
   * Returns NOT_AVAILABLE if no summary exists and generation has not been requested,
   * or if the asset type is unsupported (non-compute).
   */
  aiSummary: AiSummaryPayload;
  /**
   * Analyse asset without mrn
   * used for cnquery/cnspec shell/vuln/run
   * @deprecated This approach is deprecated, do not use it.
   */
  analyseIncognitoAssetVulnerabilities?: Maybe<AssetIncognitoVulnerabilityReportResponse>;
  /** Get suggestions for asset annotations (keys or values) based on the assets in the specified scope */
  annotationSuggestions?: Maybe<Array<Scalars["String"]["output"]>>;
  /** List API tokens for a space or organization */
  apiTokens?: Maybe<ApiTokenConnection>;
  /**
   * Lists Aggregate Resource Data (ARD) entities within a scope. Navigate a
   * declared grouping by passing `grouping` plus `parentMrn` (the node whose
   * children you want); omit them to list at the top.
   *
   * scopeMrn is a space, workspace, or organization MRN. The aggregation on each
   * returned entity is computed for that scope.
   */
  ardEntities: ArdEntityConnection;
  /** Returns a single ARD entity by MRN, with its aggregation for the given scope. */
  ardEntity?: Maybe<ArdEntity>;
  /**
   * Returns the grouping strategies a given ARD type declares — drives the UI's
   * "group by …" menu. Static type metadata, not scope-specific.
   */
  ardGroupings: Array<ArdGrouping>;
  /**
   * Fetch one Assessment per requested UID for the given entity. Assessments
   * are computed on the fly from existing platform data; unknown UIDs are
   * returned with `UNKNOWN` status, generation failures with `ERRORED`.
   */
  assessments: AssessmentsResponse;
  /** Get an asset by its MRN */
  asset?: Maybe<Asset>;
  /** Get an asset by its ID */
  assetByPlatformId?: Maybe<Asset>;
  /** Get filter suggestions for the asset inventory */
  assetFilterSuggestions?: Maybe<Array<AssetFilterSuggestion>>;
  /** Get asset group statistics */
  assetGroupStats: Array<AssetGrouping>;
  /**
   * Get last package update time for an asset
   * @deprecated This approach is deprecated, do not use it.
   */
  assetLastPackageUpdateTime?: Maybe<AssetLastPackageUpdateTimeResponse>;
  /** Get asset packages stats */
  assetPackagesStats?: Maybe<AssetPackagesStats>;
  /** Get asset resources for a specific asset */
  assetResources: AssetResourceResponse;
  /**
   * Distribution of currently-routed assets across the scope's routing rules:
   * how many assets each rule has routed into each space. Derived from the
   * routing-rule label stamped on every routed asset.
   */
  assetRoutingDistribution: AssetRoutingDistribution;
  /** Get a single asset routing rule by MRN. */
  assetRoutingRule?: Maybe<AssetRoutingRule>;
  /**
   * Get the asset routing table for an organization or the platform.
   * Returns null if no routing table is configured.
   * Provide either orgMrn (deprecated) or scopeMrn.
   */
  assetRoutingTable?: Maybe<AssetRoutingTable>;
  /**
   * Perform a search for assets. Can be searched in the context of a space
   * or organization.
   */
  assetSearch?: Maybe<AssetsConnection>;
  /** Get asset search suggestions */
  assetSearchSuggestions: AssetSearchSuggestionsResponse;
  /** Returns a value indicating whether an asset supports vulnerabilities */
  assetSupportVulnerabilities: Scalars["Boolean"]["output"];
  /** Get the asset score distribution for a space grouped by the asset url */
  assetUrlStats?: Maybe<AssetUrlStatsPayload>;
  /**
   * Analyse asset with mrn, but return compact response
   * @deprecated This approach is deprecated, do not use it.
   */
  assetVulnerabilityCompactReport?: Maybe<AssetVulnerabilityReportResponse>;
  /** List assets */
  assets?: Maybe<AssetsConnection>;
  /** List ad-hoc audit log exports for an organization or space. */
  auditLogExports: DocumentMetadataConnection;
  /**
   * Get filter suggestions for audit logs
   * @deprecated Use `auditLogSuggestions` instead
   */
  auditLogFilterSuggestions: Array<FilterSuggestion>;
  /** Get filter suggestions for audit logs */
  auditLogSuggestions: Array<AuditLogFilterSuggestion>;
  /** List audit log entries for a resource */
  auditlog?: Maybe<AuditLogConnection>;
  /** Get a BI dashboard by MRN */
  biDashboard?: Maybe<BiDashboard>;
  /** Get a specific version of a BI dashboard */
  biDashboardVersion?: Maybe<BiDashboard>;
  /** List versions of a BI dashboard */
  biDashboardVersions: Array<BiDashboard>;
  /** List BI dashboards in a scope */
  biDashboards: Array<BiDashboard>;
  /** List scheduled exports for a BI dashboard */
  biScheduledExports: Array<BiScheduledExport>;
  /** Get BI tag configuration for a scope */
  biTagConfig: BiTagConfig;
  /** Get a case */
  case: CaseResponse;
  /** Get case content suggestion */
  caseContent: CaseContent;
  /**
   * List cases. Note: aiSummary is not loaded in list queries for performance reasons.
   * Use the single `case` query to fetch the AI summary.
   */
  cases: CasesConnection;
  /** All Categories */
  categories?: Maybe<Array<Maybe<Category>>>;
  /** Fetch the scores for an mquery for an asset or space */
  checkScores?: Maybe<CheckScoresResponse>;
  /**
   * Get child execution state (for sub-stories). Child workflows don't have
   * DB records — this queries Temporal directly by workflow ID.
   */
  childWorkflowExecutionState?: Maybe<WorkflowExecutionState>;
  /** List jobs for a CI/CD project */
  cicdProjectJobs?: Maybe<CicdProjectJobsResponse>;
  /** List CI/CD projects */
  cicdProjects?: Maybe<CicdProjectsResponse>;
  /** Fetch a client integration */
  clientIntegration: ClientIntegrationPayload;
  /** Get a compliance control */
  complianceControl: ComplianceControl;
  /** Get a compliance framework */
  complianceFramework: ComplianceFramework;
  /** List compliance frameworks (deprecated, use listFrameworks) */
  complianceFrameworks?: Maybe<Array<ComplianceFramework>>;
  /**
   * List compliance frameworks enabled anywhere in an organization, deduplicated
   * by framework MRN. Each entry includes the list of space MRNs in which the
   * framework is enabled. If a framework is enabled in multiple spaces with
   * different states, the entry's state uses the highest-priority state across
   * those spaces (ACTIVE > PREVIEW > DISABLED).
   */
  complianceFrameworksByOrg: Array<OrgComplianceFramework>;
  /** Perform a search across Policies and Query Packs */
  content?: Maybe<ContentSearchResultItemConnection>;
  /** Fetch the controls scores for an asset or space */
  controlScores?: Maybe<ControlScoresResponse>;
  /** Create webhook post for a finding */
  createFindingsWebhookPost?: Maybe<FindingsWebhookPostResponse>;
  /**
   * List available credential templates, optionally filtered by tier.
   * When tier is omitted, returns all templates.
   */
  credentialTemplates: Array<CredentialTemplate>;
  /** List credentials visible in the given scope. */
  credentials: Array<Credential>;
  /**
   * Single CVE lookup.
   * @deprecated Use vuln(id) from vuln_intel.graphqls instead.
   */
  cve?: Maybe<Cve>;
  /** List news/social media trends about CVE vulnerabilities. */
  cveTrends?: Maybe<CveTrendsConnection>;
  /** Fetch the data queries for an asset or space */
  dataQueries?: Maybe<DataQueriesResponse>;
  /** Lists the available discovery targets for an integration provider (for the integration UI picker). */
  discoveryTargets: Array<DiscoveryTarget>;
  /** Downloads a bundle of policies and queries */
  downloadBundle: DownloadBundlePayload;
  /** Downloads a compliance framework as a bundle */
  downloadFramework: FrameworkBundle;
  /** Get email preferences */
  emailPreferences: Array<Maybe<EmailPreference>>;
  /** Get evidence for a finding (vulnerability or package) */
  evidence?: Maybe<EvidenceResponse>;
  /** Get filter suggestions for exceptions */
  exceptionFilterSuggestions?: Maybe<Array<ExceptionFilterSuggestion>>;
  /**
   * Get a list of all the exception groups for the provided input
   * @deprecated Use listExceptionGroups
   */
  exceptionGroups: Array<Maybe<ExceptionGroup>>;
  /**
   * Fetch the asset distribution for a single integration, grouped by space
   * and asset type. Returns only spaces that currently contain at least one
   * asset from this integration; spaces are ordered by total asset count
   * descending.
   */
  fetchIntegrationAssets: IntegrationAssetDistribution;
  /**
   * Get the full detail (evidence, references, remediation) of a Finding Exchange
   * (FEX) finding — e.g. a SECURITY finding reported by a scanner such as xgrep,
   * nmap, or a DAST tool. Everything is read from the finding's stored document in
   * a single call. scopeMrn must be an asset MRN.
   */
  fexFindingDetails?: Maybe<FexFindingDetails>;
  /** Fetch the findings for an asset or space */
  findings?: Maybe<FindingsResponse>;
  /** Get filter suggestions for findings */
  findingsFilterSuggestions?: Maybe<Array<FindingsFilterSuggestion>>;
  /** Get asset link info */
  getAssetLinkInfo?: Maybe<AssetLinkInfo>;
  /** Fetch the delete command for a client integration */
  getClientIntegrationDeleteCommand: GetClientIntegrationDeleteCommandPayload;
  /** Fetch a token for the client integration */
  getClientIntegrationToken: GetClientIntegrationTokenPayload;
  /** Fetch metadata for a document */
  getDocumentMetadata: DocumentMetadata;
  /** Get contacts for a resource (space, organization, or workspace) by MRN. */
  getResourceContacts: Array<ResourceContact>;
  /**
   * Get role assignments for an identity at a specific scope.
   * Returns payload with empty roles array if no roles are assigned.
   * Useful for Terraform drift detection and IAM binding reads.
   */
  getRoles: GetRolesPayload;
  /** Fetch a specific Workload Identity Federation (WIF) auth binding by MRN */
  getWIFAuthBinding?: Maybe<GetWifAuthBindingPayload>;
  /** Get a link to pair the user's account with GitHub. */
  githubPairingLink: Scalars["String"]["output"];
  /** List initiatives */
  initiatives: InitiativesConnection;
  /**
   * List messages reported by an integration, paginated and optionally filtered by status
   * and timestamp range. Suppressed messages are returned with their suppressedByUser flag set;
   * clients are responsible for filtering them out if they don't want to display them.
   */
  integrationMessages: IntegrationMessageConnection;
  /** List of integrations */
  integrations: Array<Maybe<Integration>>;
  /** Fetch client integration summaries */
  integrationsSummary: IntegrationsSummaryPayload;
  /** Get signed token to interact with intercom */
  intercomToken: Scalars["String"]["output"];
  /** Get the Intune device groups for an asset */
  intuneDeviceGroups: IntuneDeviceGroupsPayload;
  /**
   * List invitations for a space or organization
   * @deprecated Invitations are going away. Use setRoles to add roles to an identity instead.
   */
  invitations?: Maybe<InvitationsConnection>;
  /** Get suggestions for asset labels (keys or values) based on the assets in the specified scope */
  labelSuggestions?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Get legal policies */
  legalPolicies: Array<Maybe<LegalPolicy>>;
  /** List client integrations */
  listClientIntegrations: ListClientIntegrationsPayload;
  /** List results from client integration discovery */
  listDiscoveryResults: ListDiscoveryResultsPayload;
  /** List documents */
  listDocuments: DocumentMetadataConnection;
  /** List exception groups with pagination */
  listExceptionGroups: ListExceptionGroupsConnection;
  /** List compliance frameworks */
  listFrameworks?: Maybe<FrameworksConnection>;
  /** List all Workload Identity Federation (WIF) auth bindings for a scope */
  listWIFAuthBindings?: Maybe<ListWifAuthBindingsPayload>;
  /** Fetch the metrics for an asset or space */
  metrics?: Maybe<MetricsResponse>;
  /** Fetch a query */
  mquery?: Maybe<Mquery>;
  /** Fetch the data for an mquery for each asset */
  mqueryAssetData?: Maybe<MqueryAssetDataConnection>;
  /**
   * Fetch the scores for an mquery for each asset
   * @deprecated Use checkScores and dataQueries
   */
  mqueryAssetScores?: Maybe<MqueryAssetScoresConnection>;
  /** Fetches the score distribution for the given query and all of its variants in the provided scope */
  mqueryScore?: Maybe<MqueryScore>;
  /**
   * Stateless MVD catalog. See MvdQuery — none of its fields accept a scope
   * argument, and none return tenant-derived data.
   */
  mvd: MvdQuery;
  /**
   * Diagnostics for a Network Discovery Collector integration: the runners that
   * enrolled under it and each runner's latest health self-check (reachability,
   * DNS, TLS, proxy, time, …). Backs the collector diagnostics view. The caller
   * must be authorized to view the integration.
   */
  networkDiscoveryCollectorDiagnostics?: Maybe<NetworkDiscoveryCollectorDiagnostics>;
  /**
   * Recent Network Scan runs (queued/scheduled, running, and finished) in a scope,
   * newest first. Backs the scan runs view. The caller must be authorized on the
   * scope.
   */
  networkScanRuns: Array<NetworkScanRun>;
  /** Get an organization by MRN */
  organization?: Maybe<Organization>;
  /** Get organization ID suggestions */
  organizationIDSuggestion?: Maybe<IdSuggestionResponse>;
  /** Get organization's overview */
  organizationOverview?: Maybe<OrganizationOverviewResponse>;
  /** Perform discovery action on a client integration */
  performDiscovery: PerformDiscoveryPayload;
  /** Send a ping to a client integration */
  pingIntegration: PingIntegrationPayload;
  /** All Platforms supported by Policies or Query Packs */
  platforms?: Maybe<Array<ContentPlatform>>;
  /** Fetch a Policy. */
  policy?: Maybe<Policy>;
  /** Lists policy analytics at the platform level */
  policyAnalytics?: Maybe<ActivePoliciesConnection>;
  /** Get policy report */
  policyReport?: Maybe<PolicyReport>;
  /** List registration tokens for a space or organization */
  registrationTokens?: Maybe<RegistrationTokensConnection>;
  /**
   * Returns candidate packages that could be affected by a vulnerability.
   * Used when a finding has no package-backed remediation and the user
   * needs to identify which software is installed.
   */
  remediationCandidates: RemediationCandidatesResponse;
  /**
   * Generates remediation scripts for a user-selected candidate package.
   * The selection is ephemeral — nothing is persisted to the SBOM.
   */
  remediationForCandidate: RemediationResponse;
  /**
   * Generates a single combined remediation script for multiple selected
   * candidate packages. All candidates must share the same ecosystem.
   */
  remediationForCandidates: RemediationResponse;
  /** Generate remediation for a scope and a specified vulnerability */
  remediationForScope?: Maybe<RemediationResponse>;
  /**
   * List remediations available across all findings in a scope, with each item
   * reporting how many findings it would fix when applied. Filterable by
   * remediation script type and by technology. Accepts a space or workspace
   * MRN. Pagination uses cursor-as-offset; default page size is 50.
   */
  remediationsForScope: RemediationsListResult;
  /** Fetch the rendered data for a query/check for an asset */
  renderedAssetQueryData?: Maybe<RenderedAssetQueryDataResponse>;
  /** Fetch the risk factors for a space */
  riskFactors: RiskFactorsResponse;
  /** Perform a search across resources, returning a maximum of 200 results. */
  search: SearchResultItemConnection;
  /** Get the security model for the given scope */
  securityModel?: Maybe<SecurityModel>;
  /**
   * Gets the security pipeline finding groups for a security pipeline workflow before it is created.
   * This can be used for previewing what would end up in a workflow with the current selection.
   */
  securityPipelineFindingGroups: SecurityPipelineFindingGroupsResponse;
  /** List security pipeline scheduled workflows */
  securityPipelineScheduledWorkflows: SecurityPipelineScheduledWorkflowConnection;
  /** Get a security pipeline workflow by its MRN. */
  securityPipelineWorkflow?: Maybe<SecurityPipelineWorkflowResponse>;
  /** List security pipeline workflows */
  securityPipelineWorkflows: SecurityPipelineWorkflowConnection;
  /** Fetch a service account by MRN */
  serviceAccount?: Maybe<ServiceAccount>;
  /** List service accounts for a space or organization */
  serviceAccounts?: Maybe<ServiceAccountConnection>;
  /** Get user shared spaces */
  sharedSpaces?: Maybe<UserSharedSpacesConnection>;
  /**
   * Returns the currently-installed software inventory for the given scope.
   *
   * scopeMrn accepts either an asset MRN (returns the packages installed on
   * that one asset) or a space MRN (returns one row per (asset, package)
   * across every active asset in the space — rows are not deduplicated).
   *
   * v1 surfaces wire-side data captured at scan time on each package row,
   * including vendor, cpes, and description as reported by the scanner.
   * Catalog-derived overrides for these fields (canonical vendor names,
   * NVD-aligned CPEs) are a planned follow-up.
   */
  software?: Maybe<SoftwareConnection>;
  /**
   * Returns the currently-installed software inventory in the normalized,
   * server-classified ADR-057 shape: the raw on-OS package nested under
   * `package`, plus the normalized vendor/authors identity, the category
   * genealogy ancestry, the derived versionStatus, and the domain/lang/roles
   * facets. Same scoping (asset MRN or space MRN), ordering, filtering, and
   * pagination as `software`; backed by the stored per-asset packages.
   */
  softwareV2?: Maybe<SoftwareV2Connection>;
  /**
   * Single-item lookup of one installed software (this asset + version). Both the asset
   * MRN and the software MRN are required: the SoftwareV2 `mrn` is the package-identity
   * MRN and is asset-independent (the same software on a different asset shares it), so the
   * asset scopes it to exactly one entry. Returns null when the asset has no such software.
   */
  softwareV2ByMrn?: Maybe<SoftwareV2>;
  /** Get a space by MRN */
  space?: Maybe<Space>;
  /** Get space ID suggestions */
  spaceIDSuggestion?: Maybe<IdSuggestionResponse>;
  /** Get space policy summary */
  spacePolicySummary?: Maybe<SpacePolicySummaryPayload>;
  /** Fetch the SSO provider for a given MRN */
  ssoProvider: SsoProviderResponse;
  /**
   * Get the base plan for an organization. Available to all org members
   * (not gated to admins).
   *
   * Returns only the non-sensitive base-plan identity (id, key, name,
   * quantity). It intentionally does NOT include utilization metrics,
   * entitlements, additions, billing/subscription status, pricing, customer
   * details, or any other field present on SubscriptionInfo. When adding
   * new fields to ProductInfo, confirm they are safe to expose to every
   * org member — if not, route them through subscriptionInfo (admin-gated)
   * instead of widening the surface of this query.
   */
  subscriptionBasePlan?: Maybe<ProductInfo>;
  /** Get subscription info for an organization */
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  /** Get available subscription plans for an organization */
  subscriptionPlans?: Maybe<Array<SubscriptionPlan>>;
  /** Get a team by MRN */
  team?: Maybe<Team>;
  /** Get a team external group mapping by MRN */
  teamExternalGroupMapping?: Maybe<TeamExternalGroupMapping>;
  /** Get a specific member of a team. Returns null if the identity is not a member. */
  teamMember?: Maybe<TeamMember>;
  /** resourceMrn need to be a valid space mrn or organization mrn */
  testIamActions: Array<Scalars["String"]["output"]>;
  /** Get context information for a new ticket. */
  ticketContext: TicketContextPayload;
  /** List ticketing integrations */
  ticketingIntegrations: TicketingIntegrationsPayload;
  /** Trigger an action on a client integration */
  triggerAction: TriggerActionPayload;
  /**
   * List assets that could not be routed during scope-level sync.
   * Provide either orgMrn (deprecated) or scopeMrn.
   */
  unroutableAssets: UnroutableAssetConnection;
  /** The currently authenticated user */
  viewer?: Maybe<User>;
  /**
   * Teams the currently authenticated user can manage the membership of — i.e.
   * holds the team-member-manager role on. Lets a scoped manager reach their
   * team(s) without organization-wide identity access. Empty for users who manage
   * no teams.
   */
  viewerManagedTeams: Array<Team>;
  /** The settings for the currently authenticated user */
  viewerSettings: Array<UserSetting>;
  /** List vulnerability exploits for all vulnerabilities affecting a given asset. */
  vulnerabilityExploits?: Maybe<VulnerabilityExploitConnection>;
  /** Get a workflow by its MRN. */
  workflow?: Maybe<Workflow>;
  /** Get the real-time execution state of a workflow run from Temporal. */
  workflowExecutionState?: Maybe<WorkflowExecutionState>;
  /** List execution history for a workflow. */
  workflowExecutions: Array<WorkflowExecution>;
  /** List pending approval steps across all workflows in a scope. */
  workflowPendingApprovals: Array<WorkflowPendingApproval>;
  /** Get detailed action definitions for a specific plugin. */
  workflowPluginActions: WorkflowPluginActions;
  /** List available plugins and their actions. */
  workflowPlugins: Array<WorkflowPlugin>;
  /** Get a workflow resource by scope and name. */
  workflowResource?: Maybe<WorkflowResource>;
  /** List workflow resources (global variables) for a scope. */
  workflowResources: Array<WorkflowResource>;
  /**
   * Get a single workflow template by ID. Returns hidden templates too,
   * used by the visual editor for sub-story variable resolution.
   */
  workflowTemplate?: Maybe<WorkflowTemplate>;
  /** List available workflow templates. */
  workflowTemplates: Array<WorkflowTemplate>;
  /** List version history for a workflow. */
  workflowVersions: Array<WorkflowVersion>;
  /** List workflows for a scope (space or organization). */
  workflows: Array<Workflow>;
  /** Get a workspace */
  workspace: WorkspaceResponse;
  /** Get possible values for a workspace condition */
  workspaceConditionPossibleValues: WorkspaceConditionPossibleValues;
  /** List workspaces */
  workspaces: WorkspacesConnection;
};

/** Root query type for IAM operations */
export type QueryActivePoliciesArgs = {
  input: ActivePoliciesInput;
};

/** Root query type for IAM operations */
export type QueryAdvisoryArgs = {
  id: Scalars["ID"]["input"];
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryAffectedEcosystemsArgs = {
  initiativeMrn?: InputMaybe<Scalars["String"]["input"]>;
  scopeMrn: Scalars["String"]["input"];
  vulnId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryAgentArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryAgentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AgentOrder>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  spaceMrn: Scalars["String"]["input"];
  state?: InputMaybe<Array<AgentState>>;
  version?: InputMaybe<Array<AgentVersionFilter>>;
};

/** Root query type for IAM operations */
export type QueryAggregateScoresArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  entityMrn: Scalars["String"]["input"];
  filter?: InputMaybe<AggregateScoreFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AggregateScoreOrder>;
};

/** Root query type for IAM operations */
export type QueryAggregateScoresRefreshInfoArgs = {
  groupMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryAggregateScoresSuggestionsArgs = {
  entityMrn: Scalars["String"]["input"];
  filter?: InputMaybe<AggregateScoreFilter>;
  filterType: AggScoresFilterType;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryAiInventoryArgs = {
  assetMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryAiSummaryArgs = {
  input: AiSummaryInput;
};

/** Root query type for IAM operations */
export type QueryAnalyseIncognitoAssetVulnerabilitiesArgs = {
  input: AnalyseIncognitoAssetInput;
};

/** Root query type for IAM operations */
export type QueryAnnotationSuggestionsArgs = {
  key?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryApiTokensArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<ApiTokenOrder>;
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryArdEntitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<ArdEntityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  grouping?: InputMaybe<Scalars["String"]["input"]>;
  level?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<ArdEntityOrder>;
  parentMrn?: InputMaybe<Scalars["ID"]["input"]>;
  scopeMrn: Scalars["ID"]["input"];
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryArdEntityArgs = {
  mrn: Scalars["ID"]["input"];
  scopeMrn: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryArdGroupingsArgs = {
  type: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryAssessmentsArgs = {
  entityMrn: Scalars["String"]["input"];
  uids: Array<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryAssetArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryAssetByPlatformIdArgs = {
  platformId: Scalars["String"]["input"];
  spaceMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryAssetFilterSuggestionsArgs = {
  filter?: InputMaybe<AssetSearchFilter>;
  filterType: AssetFilterType;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  scopeMrn: Scalars["String"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryAssetGroupStatsArgs = {
  groupBy: Scalars["String"]["input"];
  orderBy?: InputMaybe<AssetGroupOrder>;
  queryTerms?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  spaceMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryAssetLastPackageUpdateTimeArgs = {
  input: AssetLastPackageUpdateTimeInput;
};

/** Root query type for IAM operations */
export type QueryAssetPackagesStatsArgs = {
  input: AssetPackagesStatsInput;
};

/** Root query type for IAM operations */
export type QueryAssetResourcesArgs = {
  input: AssetResourceInput;
};

/** Root query type for IAM operations */
export type QueryAssetRoutingDistributionArgs = {
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryAssetRoutingRuleArgs = {
  ruleMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryAssetRoutingTableArgs = {
  orgMrn?: InputMaybe<Scalars["String"]["input"]>;
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryAssetSearchArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
  input: AssetSearchInput;
  orderBy?: InputMaybe<AssetOrder>;
};

/** Root query type for IAM operations */
export type QueryAssetSearchSuggestionsArgs = {
  input: AssetSearchSuggestionsInput;
};

/** Root query type for IAM operations */
export type QueryAssetSupportVulnerabilitiesArgs = {
  assetMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryAssetUrlStatsArgs = {
  input: AssetUrlStatsInput;
};

/** Root query type for IAM operations */
export type QueryAssetVulnerabilityCompactReportArgs = {
  input: AssetVulnerabilityReportInput;
};

/** Root query type for IAM operations */
export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assetTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  assetUrlFilter?: InputMaybe<Array<AssetUrlSegmentInput>>;
  detectionSources?: InputMaybe<Array<Scalars["String"]["input"]>>;
  deviceType?: InputMaybe<AssetDeviceTypeFilter>;
  eol?: InputMaybe<AssetEolFilter>;
  eolStatus?: InputMaybe<AssetEolStatusFilter>;
  exploitable?: InputMaybe<AssetExploitableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  groups?: InputMaybe<Array<GroupFilter>>;
  initiativeMrn?: InputMaybe<Scalars["String"]["input"]>;
  labels?: InputMaybe<Array<KeyValueInput>>;
  orderBy?: InputMaybe<AssetOrder>;
  platformKind?: InputMaybe<Array<PlatformKind>>;
  platformName?: InputMaybe<Array<Scalars["String"]["input"]>>;
  platformRuntime?: InputMaybe<Array<Scalars["String"]["input"]>>;
  platformTitle?: InputMaybe<Array<Scalars["String"]["input"]>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  rating?: InputMaybe<Array<ScoreRating>>;
  reboot?: InputMaybe<AssetOsRebootFilter>;
  relatedToAssetMrn?: InputMaybe<Scalars["String"]["input"]>;
  riskCategoryFilters?: InputMaybe<Array<RiskCategoryFilterInput>>;
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  scoreRange?: InputMaybe<Array<ScoreRange>>;
  scoreType?: InputMaybe<ScoreType>;
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Array<AssetState>>;
  unscored?: InputMaybe<Scalars["Boolean"]["input"]>;
  updated?: InputMaybe<AssetUpdateFilter>;
  workflowMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryAuditLogExportsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
  scopeMRN: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryAuditLogFilterSuggestionsArgs = {
  filter?: InputMaybe<AuditLogsFilter>;
  filterType: AuditLogFilterType;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  resourceMrn: Scalars["String"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryAuditLogSuggestionsArgs = {
  filter?: InputMaybe<AuditLogsFilter>;
  filterType: AuditLogFilterType;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  resourceMrn: Scalars["String"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryAuditlogArgs = {
  actionFilter?: InputMaybe<Scalars["String"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  identityFilter?: InputMaybe<IdentityFilter>;
  orderBy?: InputMaybe<AuditLogOrder>;
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  resourceMrn: Scalars["String"]["input"];
  timestampFilter?: InputMaybe<TimestampFilter>;
};

/** Root query type for IAM operations */
export type QueryBiDashboardArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryBiDashboardVersionArgs = {
  mrn: Scalars["String"]["input"];
  versionId: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryBiDashboardVersionsArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryBiDashboardsArgs = {
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryBiScheduledExportsArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryBiTagConfigArgs = {
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryCaseArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryCaseContentArgs = {
  input: CaseContentInput;
};

/** Root query type for IAM operations */
export type QueryCasesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  input: CasesInput;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryCategoriesArgs = {
  input: CategoriesListInput;
};

/** Root query type for IAM operations */
export type QueryCheckScoresArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  entityMrn: Scalars["String"]["input"];
  filter?: InputMaybe<CheckScoreFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CheckScoreOrder>;
};

/** Root query type for IAM operations */
export type QueryChildWorkflowExecutionStateArgs = {
  workflowId: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryCicdProjectJobsArgs = {
  input: CicdProjectJobsInput;
};

/** Root query type for IAM operations */
export type QueryCicdProjectsArgs = {
  input: CicdProjectsInput;
};

/** Root query type for IAM operations */
export type QueryClientIntegrationArgs = {
  input: ClientIntegrationInput;
};

/** Root query type for IAM operations */
export type QueryComplianceControlArgs = {
  input: ComplianceControlInput;
};

/** Root query type for IAM operations */
export type QueryComplianceFrameworkArgs = {
  input: ComplianceFrameworkInput;
};

/** Root query type for IAM operations */
export type QueryComplianceFrameworksArgs = {
  input: ComplianceFrameworksInput;
};

/** Root query type for IAM operations */
export type QueryComplianceFrameworksByOrgArgs = {
  input: ComplianceFrameworksByOrgInput;
};

/** Root query type for IAM operations */
export type QueryContentArgs = {
  input: ContentSearchInput;
};

/** Root query type for IAM operations */
export type QueryControlScoresArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  entityMrn: Scalars["String"]["input"];
  filter?: InputMaybe<ControlScoreFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<ControlScoreOrder>;
};

/** Root query type for IAM operations */
export type QueryCreateFindingsWebhookPostArgs = {
  input?: InputMaybe<FindingsWebhookPostRequest>;
};

/** Root query type for IAM operations */
export type QueryCredentialTemplatesArgs = {
  tier?: InputMaybe<CredentialTemplateTier>;
};

/** Root query type for IAM operations */
export type QueryCredentialsArgs = {
  scopeMrn: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryCveArgs = {
  assetMrn?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryCveTrendsArgs = {
  advisoryIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cveIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CveTrendsOrder>;
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryDataQueriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  entityMrn: Scalars["String"]["input"];
  filter?: InputMaybe<DataQueryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<DataQueryOrder>;
};

/** Root query type for IAM operations */
export type QueryDiscoveryTargetsArgs = {
  provider: DiscoveryProvider;
};

/** Root query type for IAM operations */
export type QueryDownloadBundleArgs = {
  input: DownloadBundleInput;
};

/** Root query type for IAM operations */
export type QueryDownloadFrameworkArgs = {
  input: DownloadFrameworkInput;
};

/** Root query type for IAM operations */
export type QueryEvidenceArgs = {
  input: EvidenceInput;
};

/** Root query type for IAM operations */
export type QueryExceptionFilterSuggestionsArgs = {
  filter?: InputMaybe<ListExceptionGroupsFilter>;
  filterType: ExceptionFilterType;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  resourceMrn: Scalars["String"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryExceptionGroupsArgs = {
  input: ExceptionGroupsInput;
};

/** Root query type for IAM operations */
export type QueryFetchIntegrationAssetsArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryFexFindingDetailsArgs = {
  findingMrn: Scalars["String"]["input"];
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryFindingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<FindingsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryFindingsFilterSuggestionsArgs = {
  filter?: InputMaybe<FindingsFilter>;
  filterType: FindingFilterType;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  resourceMrn: Scalars["String"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryGetAssetLinkInfoArgs = {
  input: AssetLinkInfoInput;
};

/** Root query type for IAM operations */
export type QueryGetClientIntegrationDeleteCommandArgs = {
  input: GetClientIntegrationDeleteCommandInput;
};

/** Root query type for IAM operations */
export type QueryGetClientIntegrationTokenArgs = {
  input: GetClientIntegrationTokenInput;
};

/** Root query type for IAM operations */
export type QueryGetDocumentMetadataArgs = {
  documentMRN: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryGetResourceContactsArgs = {
  resourceMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryGetRolesArgs = {
  identity: Scalars["String"]["input"];
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryGetWifAuthBindingArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryInitiativesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  input: InitiativesInput;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<InitiativeOrder>;
};

/** Root query type for IAM operations */
export type QueryIntegrationMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  identifierFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  integrationMrn: Scalars["String"]["input"];
  since?: InputMaybe<Scalars["String"]["input"]>;
  statusFilter?: InputMaybe<Array<IntegrationMessageStatus>>;
};

/** Root query type for IAM operations */
export type QueryIntegrationsArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryIntegrationsSummaryArgs = {
  input: IntegrationsSummaryInput;
};

/** Root query type for IAM operations */
export type QueryIntuneDeviceGroupsArgs = {
  input: IntuneDeviceGroupsInput;
};

/** Root query type for IAM operations */
export type QueryInvitationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  inviteeMrn?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<InvitationOrder>;
  resourceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryLabelSuggestionsArgs = {
  key?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryLegalPoliciesArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryListClientIntegrationsArgs = {
  input: ListClientIntegrationsInput;
};

/** Root query type for IAM operations */
export type QueryListDiscoveryResultsArgs = {
  input: ListDiscoveryResultsInput;
};

/** Root query type for IAM operations */
export type QueryListDocumentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<ListDocumentsFilter>;
  first?: Scalars["Int"]["input"];
  scopeMRN: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryListExceptionGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  input: ListExceptionGroupsInput;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryListFrameworksArgs = {
  input: ListFrameworksInput;
};

/** Root query type for IAM operations */
export type QueryListWifAuthBindingsArgs = {
  orderBy?: InputMaybe<WifAuthBindingOrder>;
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryMetricsArgs = {
  annotationKey?: InputMaybe<Scalars["String"]["input"]>;
  endTime?: InputMaybe<Scalars["String"]["input"]>;
  entityMrn: Scalars["String"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  metricMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  spaceMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  startTime?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryMqueryArgs = {
  input: MqueryInput;
};

/** Root query type for IAM operations */
export type QueryMqueryAssetDataArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
  input: MqueryAssetDataInput;
  orderBy?: InputMaybe<AssetOrder>;
};

/** Root query type for IAM operations */
export type QueryMqueryAssetScoresArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
  input: MqueryAssetScoresInput;
  orderBy?: InputMaybe<AssetOrder>;
};

/** Root query type for IAM operations */
export type QueryMqueryScoreArgs = {
  input: MqueryScoreInput;
};

/** Root query type for IAM operations */
export type QueryNetworkDiscoveryCollectorDiagnosticsArgs = {
  integrationMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryNetworkScanRunsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryOrganizationArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryOrganizationIdSuggestionArgs = {
  input: IdSuggestionInput;
};

/** Root query type for IAM operations */
export type QueryOrganizationOverviewArgs = {
  input: OrganizationOverviewInput;
};

/** Root query type for IAM operations */
export type QueryPerformDiscoveryArgs = {
  input: PerformDiscoveryInput;
};

/** Root query type for IAM operations */
export type QueryPingIntegrationArgs = {
  input: PingIntegrationInput;
};

/** Root query type for IAM operations */
export type QueryPlatformsArgs = {
  input: PlatformsListInput;
};

/** Root query type for IAM operations */
export type QueryPolicyArgs = {
  input: PolicyInput;
};

/** Root query type for IAM operations */
export type QueryPolicyAnalyticsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  input: PolicyAnalyticsInput;
};

/** Root query type for IAM operations */
export type QueryPolicyReportArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryRegistrationTokensArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<RegistrationTokenOrder>;
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryRemediationCandidatesArgs = {
  scopeMrn: Scalars["String"]["input"];
  vulnId: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryRemediationForCandidateArgs = {
  ecosystem: Scalars["String"]["input"];
  fixedVersion?: InputMaybe<Scalars["String"]["input"]>;
  packageName: Scalars["String"]["input"];
  scopeMrn: Scalars["String"]["input"];
  vulnId: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryRemediationForCandidatesArgs = {
  candidates: Array<RemediationCandidateInput>;
  ecosystem: Scalars["String"]["input"];
  scopeMrn: Scalars["String"]["input"];
  vulnId: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryRemediationForScopeArgs = {
  ecosystem?: InputMaybe<Scalars["String"]["input"]>;
  initiativeMrn?: InputMaybe<Scalars["String"]["input"]>;
  packages?: InputMaybe<Array<PackageReferenceInput>>;
  scopeMrn: Scalars["String"]["input"];
  vulnId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryRemediationsForScopeArgs = {
  input: RemediationsForScopeInput;
};

/** Root query type for IAM operations */
export type QueryRenderedAssetQueryDataArgs = {
  input: RenderedAssetQueryDataInput;
};

/** Root query type for IAM operations */
export type QueryRiskFactorsArgs = {
  mrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  spaceMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QuerySearchArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SearchFilters>;
  first?: Scalars["Int"]["input"];
  query: Scalars["String"]["input"];
  scope?: InputMaybe<Scalars["String"]["input"]>;
  type: SearchType;
};

/** Root query type for IAM operations */
export type QuerySecurityModelArgs = {
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QuerySecurityPipelineFindingGroupsArgs = {
  assetMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  findingMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  initiativeMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  ownerMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QuerySecurityPipelineScheduledWorkflowsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  input: SecurityPipelineScheduledWorkflowsInput;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query type for IAM operations */
export type QuerySecurityPipelineWorkflowArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QuerySecurityPipelineWorkflowsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  input: SecurityPipelineWorkflowsInput;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<SecurityPipelineWorkflowOrder>;
};

/** Root query type for IAM operations */
export type QueryServiceAccountArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryServiceAccountsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<ServiceAccountOrder>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QuerySharedSpacesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query type for IAM operations */
export type QuerySoftwareArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<SoftwareFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<SoftwareOrder>;
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QuerySoftwareV2Args = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<SoftwareFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<SoftwareOrder>;
  scopeMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QuerySoftwareV2ByMrnArgs = {
  assetMrn: Scalars["String"]["input"];
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QuerySpaceArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QuerySpaceIdSuggestionArgs = {
  input: IdSuggestionInput;
};

/** Root query type for IAM operations */
export type QuerySpacePolicySummaryArgs = {
  input: SpacePolicySummaryInput;
};

/** Root query type for IAM operations */
export type QuerySsoProviderArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QuerySubscriptionBasePlanArgs = {
  orgMrn: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QuerySubscriptionInfoArgs = {
  orgMrn: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QuerySubscriptionPlansArgs = {
  orgMrn: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryTeamArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryTeamExternalGroupMappingArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryTeamMemberArgs = {
  identity: Scalars["String"]["input"];
  teamMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryTestIamActionsArgs = {
  actions: Array<Scalars["String"]["input"]>;
  resourceMrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryTicketContextArgs = {
  input: TicketContextInput;
};

/** Root query type for IAM operations */
export type QueryTicketingIntegrationsArgs = {
  input: TicketingIntegrationsInput;
};

/** Root query type for IAM operations */
export type QueryTriggerActionArgs = {
  input: TriggerActionInput;
};

/** Root query type for IAM operations */
export type QueryUnroutableAssetsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orgMrn?: InputMaybe<Scalars["String"]["input"]>;
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query type for IAM operations */
export type QueryVulnerabilityExploitsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<VulnerabilityExploitOrder>;
  scopeMrn: Scalars["String"]["input"];
  sources?: InputMaybe<Array<ExploitSource>>;
};

/** Root query type for IAM operations */
export type QueryWorkflowArgs = {
  mrn: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryWorkflowExecutionStateArgs = {
  executionMrn: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryWorkflowExecutionsArgs = {
  input: WorkflowExecutionsInput;
};

/** Root query type for IAM operations */
export type QueryWorkflowPendingApprovalsArgs = {
  scopeMrn: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryWorkflowPluginActionsArgs = {
  plugin: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryWorkflowResourceArgs = {
  name: Scalars["String"]["input"];
  scopeMrn: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryWorkflowResourcesArgs = {
  scopeMrn: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryWorkflowTemplateArgs = {
  id: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryWorkflowTemplatesArgs = {
  scopeMrn: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryWorkflowVersionsArgs = {
  workflowMrn: Scalars["ID"]["input"];
};

/** Root query type for IAM operations */
export type QueryWorkflowsArgs = {
  input: WorkflowsInput;
};

/** Root query type for IAM operations */
export type QueryWorkspaceArgs = {
  mrn: Scalars["String"]["input"];
};

/** Root query type for IAM operations */
export type QueryWorkspaceConditionPossibleValuesArgs = {
  input: WorkspaceConditionPossibleValuesInput;
};

/** Root query type for IAM operations */
export type QueryWorkspacesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  input: WorkspacesInput;
};

/** Query asset data */
export type QueryAssetData = {
  __typename: "QueryAssetData";
  /** The mrn of the asset */
  assetMrn?: Maybe<Scalars["String"]["output"]>;
  /** The name of the asset */
  assetName?: Maybe<Scalars["String"]["output"]>;
  /** Asset platform */
  assetPlatform?: Maybe<Platform>;
  /** Data */
  data?: Maybe<MqueryAssetData>;
};

/** Query asset score */
export type QueryAssetScore = {
  __typename: "QueryAssetScore";
  /** The mrn of the asset */
  assetMrn?: Maybe<Scalars["String"]["output"]>;
  /** The name of the asset */
  assetName?: Maybe<Scalars["String"]["output"]>;
  /** Asset platform */
  assetPlatform?: Maybe<Platform>;
  /** The score */
  score?: Maybe<Score>;
};

/** Represents a simple query check that is part of a control. It represents a MQL query. The query can be either a scoring or a data one */
export type QueryCheck = {
  __typename: "QueryCheck";
  /** The amount of assets this query has been executed against */
  assets: Scalars["Int"]["output"];
  /** The completion of the query. May be 0 if referencing a data query. */
  completion: Scalars["Int"]["output"];
  /** Gets the exception for this query, if any. Rejected exceptions aren't returned. */
  exception?: Maybe<QueryCheckException>;
  /** The MQL query for the check */
  mquery: Mquery;
  /** Represents the query stats for that check within the requested scope. May be nil if referencing a data query. */
  queryStats?: Maybe<ScoreStats>;
  /** The list of policies or query packs that reference the query */
  refs: Array<PolicyOrPackRef>;
  /** State */
  state: CheckState;
};

/** Query check exception */
export type QueryCheckException = {
  __typename: "QueryCheckException";
  /** Action */
  action: ExceptionMutationAction;
  /**
   * Exception ID. Uniquely identifies the exception within its owner scope.
   * Format: exception-{n}
   */
  exceptionId: Scalars["String"]["output"];
  /**
   * Exception MRN. Uniquely identifies the exception globally.
   * Format: //policy.api.mondoo.app/spaces/{spaceId}/exceptions/{n}
   */
  exceptionMrn: Scalars["String"]["output"];
  /** ID */
  id: Scalars["String"]["output"];
  /** Justification */
  justification: Scalars["String"]["output"];
  /** Review status */
  reviewStatus: ReviewStatus;
  /** Exception status */
  status: ExceptionStatus;
};

/** Query edge */
export type QueryEdge = {
  __typename: "QueryEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<QueryCheck>;
};

/** QueryImpact maps an impact number to a human readable string */
export enum QueryImpact {
  /** Impact is critical when 90 - 100 */
  Critical = "CRITICAL",
  /** Impact is high when between 70 - 89 */
  High = "HIGH",
  /** Impact is none when 0 */
  Info = "INFO",
  /** Impact is low when between 1 - 39 */
  Low = "LOW",
  /** Impact is medium when between 40 - 69 */
  Medium = "MEDIUM",
}

/** Query info */
export type QueryInfo = {
  __typename: "QueryInfo";
  /** Code ID */
  codeId?: Maybe<Scalars["String"]["output"]>;
  /** Name */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Score */
  score?: Maybe<AssetGradeDistribution>;
  /** Severity */
  severity: Scalars["Int"]["output"];
};

/** Query pack add input */
export type QueryPackAddInput = {
  /** RFC2397, base64 encoded policy bundle */
  dataurl: Scalars["String"]["input"];
  /** Force */
  force?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The mrn of the space */
  spaceMrn: Scalars["String"]["input"];
};

/** Represents a reference to a query pack and a specific group inside the pack. */
export type QueryPackCheckRef = {
  __typename: "QueryPackCheckRef";
  /** Group */
  group: Scalars["String"]["output"];
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Name */
  name: Scalars["String"]["output"];
};

/** Query reference */
export type QueryRef = {
  __typename: "QueryRef";
  /** Action */
  action: PolicyReportScoreEntryAction;
  /** Impact */
  impact?: Maybe<Impact>;
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["output"];
};

/** A value with a QuerySource is derived from a query. */
export type QuerySource = {
  __typename: "QuerySource";
  /** The MRN of the query */
  mrn: Scalars["String"]["output"];
};

/** Rated policies input */
export type RatedPoliciesInput = {
  /** Count */
  count?: InputMaybe<Scalars["Int"]["input"]>;
  /** The mrn of the space */
  spaceMrn: Scalars["String"]["input"];
};

/** RC packages configuration */
export type RcPackagesConfiguration = {
  __typename: "RcPackagesConfiguration";
  /** Whether to exclude partially removed (rc) Debian packages from vulnerability scanning */
  exclude: Scalars["Boolean"]["output"];
};

/** RC packages configuration input */
export type RcPackagesConfigurationInput = {
  /** Whether to exclude partially removed (rc) Debian packages from vulnerability scanning */
  exclude?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Recommended action item advisory */
export type RecommendedActionItemAdvisory = {
  __typename: "RecommendedActionItemAdvisory";
  /** ID */
  id: Scalars["String"]["output"];
  /** Message */
  message: Scalars["String"]["output"];
  /** Severity */
  severity: Scalars["Int"]["output"];
};

/** Recommended action item control */
export type RecommendedActionItemControl = {
  __typename: "RecommendedActionItemControl";
  /**
   * Code ID
   * @deprecated Use mrn
   */
  codeId: Scalars["String"]["output"];
  /** Message */
  message: Scalars["String"]["output"];
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["output"];
  /** The score */
  score: Score;
  /** Severity */
  severity: Scalars["Int"]["output"];
};

/** Reference to an URL */
export type Reference = {
  __typename: "Reference";
  /** icon id */
  iconIDEnum?: Maybe<Icon_Ids>;
  /** Reference name */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Reference URL */
  url: Scalars["String"]["output"];
};

/** Details about an action a user took in the ui */
export type RegisterUserActionInput = {
  /** The action taken */
  action?: InputMaybe<UiAction>;
  /** Details */
  details?: InputMaybe<Scalars["String"]["input"]>;
  /** Page where the action was taken */
  page?: InputMaybe<UiPage>;
  /** Org or space mrn */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** A registration token for onboarding */
export type RegistrationToken = {
  __typename: "RegistrationToken";
  /** RFC 3339 timestamp when the token was created */
  createdAt: Scalars["String"]["output"];
  /** The user who created the token */
  createdBy: Scalars["String"]["output"];
  /**
   * A human-readable display name for the creator, resolved server-side so
   * clients do not need to pattern-match on MRNs. Falls back to the raw
   * createdBy value when no mapping applies.
   */
  createdByName: Scalars["String"]["output"];
  /** User-provided description for the token */
  description: Scalars["String"]["output"];
  /** RFC 3339 timestamp when the token expires */
  expiresAt: Scalars["String"]["output"];
  /** ID for token, only set for long-lived tokens */
  id: Scalars["String"]["output"];
  /** User-provided labels for the token */
  labels: Array<KeyValue>;
  /** Mondoo resource name for token, only set for long-lived tokens */
  mrn: Scalars["String"]["output"];
  /** Flag that indicates if the token has been revoked */
  revoked: Scalars["Boolean"]["output"];
  /** Token is set only when first generated */
  token: Scalars["String"]["output"];
};

/** An edge in a registration tokens connection */
export type RegistrationTokenEdge = {
  __typename: "RegistrationTokenEdge";
  /** The cursor for this edge */
  cursor: Scalars["ID"]["output"];
  /** The registration token at the end of the edge */
  node: RegistrationToken;
};

/** Input for generating a new registration token */
export type RegistrationTokenInput = {
  /** Optional description for the registration token */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional setting of the expiration time, if not set the token will not expire */
  expiresIn?: InputMaybe<Scalars["Int"]["input"]>;
  /** Optional labels for the registration token */
  labels?: InputMaybe<Array<KeyValueInput>>;
  /** Optional setting if the token should not be expired */
  noExpiration?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Optional roles to attach to the registration token */
  roles?: InputMaybe<Array<RoleInput>>;
  /** The MRN of the scope for the registration token */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The MRN of the space (deprecated, use scopeMrn)
   * @deprecated Use scopeMrn
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for ordering registration tokens */
export type RegistrationTokenOrder = {
  /** The direction to order by */
  direction: OrderDirection;
  /** The field to order by */
  field: RegistrationTokenOrderField;
};

/** Field to order registration tokens by */
export enum RegistrationTokenOrderField {
  /** Order by creation time */
  Created = "CREATED",
  /** Order by description */
  Description = "DESCRIPTION",
  /** Order by MRN */
  Mrn = "MRN",
}

/** A collection of registration tokens for a space */
export type RegistrationTokens = {
  __typename: "RegistrationTokens";
  /** The MRN of the space */
  spaceMrn: Scalars["ID"]["output"];
  /** The registration tokens in the space */
  tokens: RegistrationTokensConnection;
};

/** A collection of registration tokens for a space */
export type RegistrationTokensTokensArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<RegistrationTokenOrder>;
};

/** Connection containing registration tokens */
export type RegistrationTokensConnection = {
  __typename: "RegistrationTokensConnection";
  /** The edges in the connection */
  edges: Array<RegistrationTokenEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** The total number of registration tokens */
  totalCount: Scalars["Int"]["output"];
};

/** Related asset */
export type RelatedAsset = {
  __typename: "RelatedAsset";
  /** ID */
  id: Scalars["ID"]["output"];
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["output"];
  /** Name */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Score */
  score: Score;
  /** Type */
  type: Scalars["String"]["output"];
};

/** Related asset count */
export type RelatedAssetCount = {
  __typename: "RelatedAssetCount";
  /** Count */
  count: Scalars["Int"]["output"];
  /** Is parent */
  isParent: Scalars["Boolean"]["output"];
  /** Type */
  type: Scalars["String"]["output"];
};

/** Related asset edge */
export type RelatedAssetEdge = {
  __typename: "RelatedAssetEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<RelatedAsset>;
};

/** Related assets */
export type RelatedAssets = {
  __typename: "RelatedAssets";
  /** Count */
  count?: Maybe<Array<RelatedAssetCount>>;
  /** List related assets */
  list: RelatedAssetsConnection;
};

/** Related assets */
export type RelatedAssetsListArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assetType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Related assets connection */
export type RelatedAssetsConnection = {
  __typename: "RelatedAssetsConnection";
  /** Edges */
  edges?: Maybe<Array<RelatedAssetEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Remediated by severity */
export type RemediatedBySeverity = {
  __typename: "RemediatedBySeverity";
  /** Fixed count */
  fixed: Scalars["Int"]["output"];
  /** mttrInMinutes */
  mttrInMinutes: Scalars["Int"]["output"];
  /** Severity */
  severity: Scalars["String"]["output"];
  /** Total count */
  total: Scalars["Int"]["output"];
};

/** Remediation. */
export type Remediation = {
  __typename: "Remediation";
  /**
   * List of packages affected by the specified vulnerability in the scope. These
   * are all the potential packages that can be fixed by the remediation.
   */
  allPackages: Array<Package>;
  /** List of packages the remediations fixes. */
  remediatedPackages: Array<Package>;
  /** The scope MRN of the scope this remediation is for. */
  scopeMrn: Scalars["String"]["output"];
  /** The remediation scripts. */
  scripts: Array<RemediationScript>;
};

/**
 * A candidate package that could be affected by a vulnerability. Returned by
 * `remediationCandidates` so the user can identify which software is installed
 * and receive a tailored remediation script.
 */
export type RemediationCandidate = {
  __typename: "RemediationCandidate";
  /** The ecosystem this candidate belongs to (e.g., 'Debian:12', 'Red Hat:9'). */
  ecosystem: Scalars["String"]["output"];
  /** The version that fixes the vulnerability, if known. */
  fixedVersion?: Maybe<Scalars["String"]["output"]>;
  /** Package name (e.g., 'openssl', 'httpd'). */
  packageName: Scalars["String"]["output"];
  /** PURL for the package (e.g., 'pkg:deb/debian/openssl'). */
  purl?: Maybe<Scalars["String"]["output"]>;
};

/** Input for selecting a candidate package for batch remediation. */
export type RemediationCandidateInput = {
  /** Fixed version to upgrade to. Omit if unknown. */
  fixedVersion?: InputMaybe<Scalars["String"]["input"]>;
  /** Package name (e.g., 'openssl', 'kernel'). */
  packageName: Scalars["String"]["input"];
};

/**
 * Response for the `remediationCandidates` query, containing all candidate
 * packages MVD knows about for a given vulnerability.
 */
export type RemediationCandidatesResponse = {
  __typename: "RemediationCandidatesResponse";
  /** Candidate packages that could be affected, across all ecosystems. */
  candidates: Array<RemediationCandidate>;
  /**
   * Number of affected packages for which no vendor fix is available yet.
   * When candidates is empty but unfixedCount > 0, the UI should show
   * "No vendor fix available" rather than "no packages found".
   */
  unfixedCount: Scalars["Int"]["output"];
  /** One-line vulnerability summary for display context. */
  vulnSummary?: Maybe<Scalars["String"]["output"]>;
};

/** How many findings a remediation covers, broken down by axis. */
export type RemediationCoverage = {
  __typename: "RemediationCoverage";
  /**
   * Full Asset records for a subset of the affected assets. Resolved on
   * demand so clients pay only for asset fetches they request. The default
   * limit caps the response to the first 50 asset MRNs (sorted order) — if
   * `assetsAffected > limit`, the list is truncated; use `assetMrns` to see
   * the full set of identifiers.
   */
  affectedAssets: Array<Asset>;
  /**
   * The set of unique asset MRNs this remediation touches. Sorted for stable
   * consumption. Use this when you need only identifiers; use
   * `affectedAssets` to fetch full Asset records.
   */
  assetMrns: Array<Scalars["String"]["output"]>;
  /** Unique assets touched. Equal to length of assetMrns. */
  assetsAffected: Scalars["Int"]["output"];
  /** Unique checks resolved (check source only; always 1 for check items). */
  checksCovered: Scalars["Int"]["output"];
  /**
   * The set of unique CVE MRNs this remediation resolves. Vuln items only;
   * empty for check items. Sorted for stable consumption.
   */
  cveMrns: Array<Scalars["String"]["output"]>;
  /** Unique CVEs resolved (vuln source only). Equal to length of cveMrns. */
  cvesCovered: Scalars["Int"]["output"];
  /** Unique (finding × asset) pairs resolved. */
  findingsFixed: Scalars["Int"]["output"];
};

/** How many findings a remediation covers, broken down by axis. */
export type RemediationCoverageAffectedAssetsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Filter the remediation scripts */
export type RemediationFilter = {
  /**
   * filter by package ecosystem, e.g., AmazonLinux:2023
   * It is the ecosystem.ID in the RemediationResponse
   */
  ecosystem?: InputMaybe<Scalars["String"]["input"]>;
  /** filter by affected assets and their packages */
  filterAffected?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * filter by package namespace, e.g., ubuntu:18.04
   * @deprecated Use `ecosystem` instead.
   */
  namespace?: InputMaybe<Scalars["String"]["input"]>;
  /** filter by remediation script type */
  scriptTypes?: InputMaybe<Array<InputMaybe<RemediationScriptType>>>;
};

/** Input for the remediation script */
export type RemediationInput = {
  /**
   * one of these 3 must be present
   * @deprecated Use `vulnerabilityId` instead.
   */
  advisoryId?: InputMaybe<Scalars["ID"]["input"]>;
  /** filter by remediation type, etc */
  filter?: InputMaybe<RemediationFilter>;
  packages?: InputMaybe<Array<RemediationPackageFields>>;
  /**
   * scopeMrn has to be assetMrn or spaceMrn
   * used to determine the platform name in case of the packages
   *  it has to be the spaceMrn when the vulnerabilityId is present
   */
  scopeMrn: Scalars["String"]["input"];
  vulnerabilityId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * A single remediation item. The `source` field discriminates which of `vuln`
 * or `check` is populated. Both nullable so a client can drive its UI off a
 * single shape.
 */
export type RemediationItem = {
  __typename: "RemediationItem";
  /** Populated when source == SOURCE_CHECK. */
  check?: Maybe<CheckRemediationDetails>;
  /** How much this remediation covers (findings, CVEs, checks, assets). */
  coverage: RemediationCoverage;
  /** Stable deterministic id, safe to send back to a future bundle/download mutation. */
  id: Scalars["ID"]["output"];
  /** True iff at least one script has a type other than MANUAL_INSTRUCTION. */
  isAutomatable: Scalars["Boolean"]["output"];
  /** Vuln items: executable upgrade scripts. Check items: TypedDoc-derived instructions wrapped as scripts. */
  scripts: Array<RemediationScript>;
  /** Origin of the remediation — vulnerability finding or failed check. */
  source: RemediationSource;
  /** Coarse technology bucket derived from the affected asset platform or ecosystem. */
  technology: Technology;
  /** Populated when source == SOURCE_VULNERABILITY. */
  vuln?: Maybe<VulnerabilityRemediationDetails>;
};

/** We need to know the packages to generate the remediation script */
export type RemediationPackageFields = {
  /** Package version which fixes the vulnerability */
  fixedVersion?: InputMaybe<Scalars["String"]["input"]>;
  /** Package name */
  name: Scalars["String"]["input"];
};

/** Remediation responses */
export type RemediationQueryResponse =
  | VulnerabilityRemediationNotFound
  | VulnerabilityRemediationNotSupported
  | VulnerabilityRemediationResponse
  | VulnerabilityRemediationUnknown;

/** Represents a remediation script that can be used to fix a vulnerability. */
export type RemediationResponse =
  | Remediation
  | VulnerabilityNoFixAvailable
  | VulnerabilityRemediationNotFound
  | VulnerabilityRemediationNotSupported
  | VulnerabilityRemediationUnknown;

/** Remediation result */
export type RemediationResult = AuthenticationRequired | Remediations;

/** Remediation script */
export type RemediationScript = {
  __typename: "RemediationScript";
  /** Package manager: DPKG, YUM, DNF, ZYPPER, POWERSHELL */
  packageManager: PackageManager;
  /** Script platform name */
  platformName: Scalars["String"]["output"];
  /** Script platform version */
  platformVersion: Scalars["String"]["output"];
  /** Script */
  script: Scalars["String"]["output"];
  /** Type of the remediation script: SHELL, ANSIBLE, POWERSHELL */
  type: RemediationScriptType;
};

/** Remediation script type */
export enum RemediationScriptType {
  /** Ansible playbook */
  Ansible = "ANSIBLE",
  /** Click-through instructions for the Azure Portal */
  AzurePortal = "AZURE_PORTAL",
  /** Command-line invocation (cloud provider CLI, kubectl, etc.) */
  Cli = "CLI",
  /** AWS CloudFormation template snippet */
  Cloudformation = "CLOUDFORMATION",
  /** Click-through instructions for a cloud provider web console */
  Console = "CONSOLE",
  /** Click-through instructions for the GitHub web UI */
  GithubUi = "GITHUB_UI",
  /** Click-through instructions for the GitLab web UI */
  GitlabUi = "GITLAB_UI",
  /** Windows Group Policy configuration steps */
  GroupPolicy = "GROUP_POLICY",
  /** Intune Detection Script */
  IntuneDetection = "INTUNE_DETECTION",
  /** Intune Remediation Script */
  IntuneRemediation = "INTUNE_REMEDIATION",
  /**
   * Free-form prose instructions that don't fit a more specific tooling
   * category. Used as the fallback for unrecognized TypedDoc ids.
   */
  ManualInstruction = "MANUAL_INSTRUCTION",
  /** Powershell script */
  Powershell = "POWERSHELL",
  /** Shell script */
  Shell = "SHELL",
  /** Terraform (HCL) infrastructure-as-code snippet */
  Terraform = "TERRAFORM",
}

/** Source of a remediation in the unified list. */
export enum RemediationSource {
  /** Remediation derives from a failed check (MqueryDocs.remediation guidance). */
  SourceCheck = "SOURCE_CHECK",
  /** Remediation derives from a vulnerability finding (package upgrade). */
  SourceVulnerability = "SOURCE_VULNERABILITY",
}

/** Remediations */
export type Remediations = {
  __typename: "Remediations";
  /** Entries */
  entries: Array<MqueryRemediation>;
};

/**
 * Facet counts that accompany a `remediationsForScope` result. Each axis is
 * independent: toggling a Technology chip never affects another Technology
 * chip; toggling a ScriptType chip never affects another ScriptType chip.
 */
export type RemediationsFacets = {
  __typename: "RemediationsFacets";
  /**
   * Per-script-type counts. Computed ignoring the request's `scriptTypes`
   * filter; the `technologies` and `query` filters are applied. An item
   * with multiple scripts of different types contributes once per type.
   */
  scriptTypes: Array<ScriptTypeFacet>;
  /**
   * Per-technology counts. Computed ignoring the request's `technologies`
   * filter; the `scriptTypes` and `query` filters are applied.
   */
  technologies: Array<TechnologyFacet>;
};

/**
 * Input for `remediationsForScope`. The `scopeMrn` must be a space or workspace
 * MRN. Empty filter lists mean no filter.
 */
export type RemediationsForScopeInput = {
  /**
   * Filter to remediations that touch at least one of these asset MRNs. Used to
   * scope the list to a single asset (e.g. "download all remediations for this
   * asset"). Empty = no filter.
   */
  assetMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Filter to remediations that fix at least one of these finding MRNs. A finding
   * MRN matches a check item when it equals the item's check MRN, or a vuln item
   * when it is one of the item's covered CVE MRNs. Used to scope a download to a
   * selected set of findings. Empty = no filter.
   */
  findingMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Sort order. Default: FINDING_COUNT descending. */
  orderBy?: InputMaybe<RemediationsOrder>;
  /** Pagination control. */
  page?: InputMaybe<RemediationsPageInput>;
  /** Case-insensitive substring match against package name (vuln) or check title (check). */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** Space or workspace MRN. */
  scopeMrn: Scalars["String"]["input"];
  /** Filter to items that have at least one script of one of these types. */
  scriptTypes?: InputMaybe<Array<RemediationScriptType>>;
  /** Filter to items whose technology is in this set. */
  technologies?: InputMaybe<Array<Technology>>;
};

/** Result envelope for `remediationsForScope`. */
export type RemediationsListResult = {
  __typename: "RemediationsListResult";
  /**
   * Per-dimension counts for filter-chip rendering. Each facet ignores its
   * own dimension's active filter so chips stay togglable — a Technology
   * facet reports its count as if the chip were the active selection even
   * when other technologies are already filtered in. Every known enum value
   * is returned (count `0` when empty) so the UI can hide zero-count chips
   * without guessing the server's catalog.
   */
  facets: RemediationsFacets;
  /** The page of remediation items in the requested order. */
  items: Array<RemediationItem>;
  /** Cursor metadata for advancing through the paginated result set. */
  pageInfo: PageInfo;
  /** Total count of items across all pages after filtering. */
  totalCount: Scalars["Int"]["output"];
};

/** Order specification for the remediations list. */
export type RemediationsOrder = {
  direction: OrderDirection;
  field: RemediationsOrderField;
};

/** Fields available for ordering the remediations list. */
export enum RemediationsOrderField {
  /** Number of unique assets the remediation touches (blast radius). */
  AssetsAffected = "ASSETS_AFFECTED",
  /** Number of (finding × asset) pairs the remediation fixes. */
  FindingCount = "FINDING_COUNT",
  /** Item title: package name for vuln items, check title for check items. */
  Title = "TITLE",
}

/** Page input for the remediations list. Cursor is the integer offset as a string. */
export type RemediationsPageInput = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input for removing organization membership */
export type RemoveOrganizationMembershipInput = {
  /** The MRN of the organization */
  orgMrn: Scalars["String"]["input"];
  /** The MRN of the user */
  userMrn: Scalars["String"]["input"];
};

/** Input for removing space membership */
export type RemoveSpaceMembershipInput = {
  /** The MRN of the space */
  spaceMrn: Scalars["String"]["input"];
  /** The MRN of the user */
  userMrn: Scalars["String"]["input"];
};

/** Input for removing a user from a team */
export type RemoveTeamMemberInput = {
  /**
   * The email of the user (for pending users)
   * @deprecated Use identity instead
   */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** The identity of the user (MRN or email) */
  identity?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The MRN of the user (for existing users)
   * @deprecated Use identity instead
   */
  memberMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** The MRN of the team */
  teamMrn: Scalars["String"]["input"];
};

/** Result of removing of team member */
export type RemoveTeamMemberResponse = {
  __typename: "RemoveTeamMemberResponse";
  /** The MRN of the member. Not available if the user is not registered yet */
  memberMrn?: Maybe<Scalars["String"]["output"]>;
};

/** Response when removing a WIF auth binding */
export type RemoveWifAuthBindingPayload = {
  __typename: "RemoveWIFAuthBindingPayload";
  /** The MRN of the removed binding */
  mrn?: Maybe<Scalars["String"]["output"]>;
};

/** Rendered asset query data */
export type RenderedAssetQueryData = {
  __typename: "RenderedAssetQueryData";
  /** The rendered assessment */
  assessment?: Maybe<Scalars["String"]["output"]>;
  /** The rendered data as JSON */
  data?: Maybe<Scalars["Any"]["output"]>;
};

/** Rendered asset query data input */
export type RenderedAssetQueryDataInput = {
  /** assetMrn is the MRN of the asset to query */
  assetMrn: Scalars["String"]["input"];
  /** queryMrn is the MRN of the query to get the data for */
  queryMrn: Scalars["String"]["input"];
};

/** Rendered asset query data response */
export type RenderedAssetQueryDataResponse =
  | NotFoundError
  | RenderedAssetQueryData
  | RequestError;

/** Vulnerability Report */
export type Report = {
  __typename: "Report";
  /** Packages affected by advisories and cves */
  packages?: Maybe<PackagesConnection>;
  /** Platform */
  platform: Platform;
  /** published date */
  published?: Maybe<Scalars["String"]["output"]>;
  /** Statistics */
  stats?: Maybe<ReportStats>;
  /** Report status */
  status?: Maybe<ReportStatus>;
};

/** Vulnerability Report */
export type ReportPackagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isAffected?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderBy?: InputMaybe<PackagesOrder>;
};

/** Report found error */
export type ReportFound = Error & {
  __typename: "ReportFound";
  /** Code */
  code: Scalars["String"]["output"];
  /** Message */
  message: Scalars["String"]["output"];
};

/** Vulnerability Report Stats */
export type ReportStats = {
  __typename: "ReportStats";
  /** Advisories */
  advisories: ReportStatsAdvisories;
  /** Assets */
  assets: ReportStatsAsset;
  /** Cves */
  cves: ReportStatsCves;
  /** Exploits */
  exploits: ReportStatsExploits;
  /** Packages */
  packages: ReportStatsPackages;
  /** Scores */
  score: CvssScore;
};

/** Report statistics advisories */
export type ReportStatsAdvisories = {
  __typename: "ReportStatsAdvisories";
  /** Critical */
  critical: Scalars["Int"]["output"];
  /** High */
  high: Scalars["Int"]["output"];
  /** Low */
  low: Scalars["Int"]["output"];
  /** Medium */
  medium: Scalars["Int"]["output"];
  /** None */
  none: Scalars["Int"]["output"];
  /** Total */
  total: Scalars["Int"]["output"];
  /** Unknown */
  unknown: Scalars["Int"]["output"];
};

/** Vulnerability Report Stats for an asset */
export type ReportStatsAsset = {
  __typename: "ReportStatsAsset";
  /** Count of assets with score A */
  A: Scalars["Int"]["output"];
  /** Count of assets with score B */
  B: Scalars["Int"]["output"];
  /** Count of assets with score C */
  C: Scalars["Int"]["output"];
  /** Count of assets with score D */
  D: Scalars["Int"]["output"];
  /** Count of errored assets */
  Error: Scalars["Int"]["output"];
  /** Count of assets with score F */
  F: Scalars["Int"]["output"];
  /** Count of assets with score unknown */
  U: Scalars["Int"]["output"];
  /** Total count of assets */
  total: Scalars["Int"]["output"];
};

/** Report statistics CVEs */
export type ReportStatsCves = {
  __typename: "ReportStatsCves";
  /** The number of critical CVEs */
  critical: Scalars["Int"]["output"];
  /** The number of high CVEs */
  high: Scalars["Int"]["output"];
  /** The number of low CVEs */
  low: Scalars["Int"]["output"];
  /** The number of medium CVEs */
  medium: Scalars["Int"]["output"];
  /** The number of none CVEs */
  none: Scalars["Int"]["output"];
  /** The total number of CVEs */
  total: Scalars["Int"]["output"];
  /** The number of unknown CVEs */
  unknown: Scalars["Int"]["output"];
};

/** Report statistics exploits */
export type ReportStatsExploits = {
  __typename: "ReportStatsExploits";
  /** Total */
  total: Scalars["Int"]["output"];
};

/** Report statistics packages */
export type ReportStatsPackages = {
  __typename: "ReportStatsPackages";
  /** Affected */
  affected: Scalars["Int"]["output"];
  /** Critical */
  critical: Scalars["Int"]["output"];
  /** High */
  high: Scalars["Int"]["output"];
  /** Low */
  low: Scalars["Int"]["output"];
  /** Medium */
  medium: Scalars["Int"]["output"];
  /** None */
  none: Scalars["Int"]["output"];
  /** Total */
  total: Scalars["Int"]["output"];
  /** Unknown */
  unknown: Scalars["Int"]["output"];
};

/** Report status */
export type ReportStatus = NotFoundError | NotSupported | ReportFound;

/** Report viewed info. Only 1 page can be specified at a time */
export type ReportViewedInfo = {
  /** Asset overview page info */
  assetOverview?: InputMaybe<AssetOverviewPageInfo>;
  /** CI/CD job page info */
  cicdJob?: InputMaybe<CiCdJobPageInfo>;
  /** CI/CD project page info */
  cicdProject?: InputMaybe<CiCdProjectPageInfo>;
  /** Org view page info */
  orgView?: InputMaybe<OrgViewPageInfo>;
  /** Security dashboard page info */
  securityDashboard?: InputMaybe<SecurityDashboardPageInfo>;
  /** Vulnerability dashboard page info */
  vulnerabilityDashboard?: InputMaybe<VulnerabilityDashboardPageInfo>;
};

/** Report viewed input */
export type ReportViewedInput = {
  /** Information about the viewed page */
  info: ReportViewedInfo;
  /** The page that was viewed */
  page: ReportViewedPage;
};

/** Report viewed page defines the pages that can be reported as viewed */
export enum ReportViewedPage {
  AssetOverview = "ASSET_OVERVIEW",
  CicdJob = "CICD_JOB",
  CicdProject = "CICD_PROJECT",
  Finding = "FINDING",
  FindingOnAsset = "FINDING_ON_ASSET",
  OrgView = "ORG_VIEW",
  RemediationCopy = "REMEDIATION_COPY",
}

/** Request error indicates that the request failed server-side */
export type RequestError = Error & {
  __typename: "RequestError";
  /** Code */
  code: Scalars["String"]["output"];
  /** Message */
  message: Scalars["String"]["output"];
};

/** Input for resetting a workflow to its source template. */
export type ResetWorkflowToTemplateInput = {
  /** MRN of the workflow to reset. */
  mrn: Scalars["ID"]["input"];
};

/** Result of resetting a workflow to its source template. */
export type ResetWorkflowToTemplatePayload = {
  __typename: "ResetWorkflowToTemplatePayload";
  /** The workflow with the reset YAML. */
  workflow: Workflow;
};

/** A resource associated with an asset */
export type Resource = {
  __typename: "Resource";
  /** The assessment field for the resource */
  assessmentField?: Maybe<Field>;
  /** The fields of the resource */
  fields?: Maybe<Array<Maybe<Field>>>;
  /** The name of the resource */
  name: Scalars["String"]["output"];
  /** Whether the resource has nested content */
  nestedContent: Scalars["Boolean"]["output"];
  /** The number of elements in the resource */
  numElements: Scalars["Int"]["output"];
  /** The path of the resource (e.g., k8s.statefulsets) */
  path: Scalars["String"]["output"];
  /** The title of the resource */
  title: Scalars["String"]["output"];
  /** The type of the resource (e.g., k8s.statefulSets[]) */
  type: Scalars["String"]["output"];
};

/** A contact assigned to a resource (space, organization, or workspace) */
export type ResourceContact = {
  __typename: "ResourceContact";
  /** Contact type */
  contactType: ResourceContactType;
  /** Resolved email address */
  email?: Maybe<Scalars["String"]["output"]>;
  /** The identity: user MRN, team MRN, or email address */
  identity: Scalars["String"]["output"];
  /** Resolved display name */
  name?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Input for a single contact. The contact type is inferred from the identity:
 * user MRNs become USER contacts, team MRNs become TEAM contacts, and email
 * addresses become EMAIL contacts.
 */
export type ResourceContactInput = {
  /** The identity: user MRN, team MRN, or email address */
  identity: Scalars["String"]["input"];
};

/** Type of resource contact */
export enum ResourceContactType {
  Email = "EMAIL",
  Team = "TEAM",
  User = "USER",
}

/** Resource info */
export type ResourceInfo = {
  __typename: "ResourceInfo";
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Resource name */
  name: Scalars["String"]["output"];
};

/** Input for restoring a previous dashboard version. */
export type RestoreBiDashboardVersionInput = {
  /** Dashboard MRN */
  mrn: Scalars["String"]["input"];
  /** Version ID to restore from */
  versionId: Scalars["ID"]["input"];
};

/** Input for resuming a workflow schedule. */
export type ResumeWorkflowScheduleInput = {
  /** MRN of the schedule to resume. */
  mrn: Scalars["ID"]["input"];
};

/** Result of resuming a workflow schedule. */
export type ResumeWorkflowSchedulePayload = {
  __typename: "ResumeWorkflowSchedulePayload";
  /** The resumed schedule. */
  schedule: WorkflowSchedule;
};

/** The review status for an exception group */
export enum ReviewStatus {
  Approved = "APPROVED",
  NotReviewed = "NOT_REVIEWED",
  PendingExtension = "PENDING_EXTENSION",
  Rejected = "REJECTED",
}

/** Failure response for revoking a registration token */
export type RevokeRegistrationTokenFailure = Error & {
  __typename: "RevokeRegistrationTokenFailure";
  /** The error code */
  code: Scalars["String"]["output"];
  /** The error message */
  message: Scalars["String"]["output"];
};

/** Input for revoking a registration token */
export type RevokeRegistrationTokenInput = {
  /** The MRN of the registration token to revoke */
  mrn: Scalars["String"]["input"];
};

/** Response when revoking a registration token */
export type RevokeRegistrationTokenResponse =
  | RevokeRegistrationTokenFailure
  | RevokeRegistrationTokenSuccess;

/** Success response for revoking a registration token */
export type RevokeRegistrationTokenSuccess = {
  __typename: "RevokeRegistrationTokenSuccess";
  /** Whether the operation was successful */
  ok: Scalars["Boolean"]["output"];
};

/** Risk categories configuration */
export type RiskCategoriesConfiguration = {
  __typename: "RiskCategoriesConfiguration";
  /** Attack surface configuration */
  attackSurface: AttackSurfaceConfiguration;
  /** Blast radius configuration */
  blastRadius: BlastRadiusConfiguration;
  /** Business priority configuration */
  businessPriority: BusinessPriorityConfiguration;
  /** Whether the risk category is enabled and should be used in risk scoring */
  enabled: Scalars["Boolean"]["output"];
  /** Exploitability configuration */
  exploitability: ExploitabilityConfiguration;
  /** News configuration */
  news: NewsConfiguration;
};

/** Risk categories configuration */
export type RiskCategoriesConfigurationInput = {
  /** Attack surface configuration */
  attackSurface?: InputMaybe<AttackSurfaceConfigurationInput>;
  /** Blast radius configuration */
  blastRadius?: InputMaybe<BlastRadiusConfigurationInput>;
  /** Business priority configuration */
  businessPriority?: InputMaybe<BusinessPriorityConfigurationInput>;
  /** Whether the risk category is enabled and should be used in risk scoring */
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Exploitability configuration */
  exploitability?: InputMaybe<ExploitabilityConfigurationInput>;
  /** News configuration */
  news?: InputMaybe<NewsConfigurationInput>;
};

/** A single key-value count entry for risk category details */
export type RiskCategoryDetailCount = {
  __typename: "RiskCategoryDetailCount";
  /** The key (e.g. layer name or group name) */
  key: Scalars["String"]["output"];
  /** The count */
  value: Scalars["Int"]["output"];
};

/**
 * Filter aggregate scores by the worst impact label of a single risk category.
 * Use multiple entries to AND categories together.
 */
export type RiskCategoryFilterInput = {
  /** Risk category MRN, e.g. //policy.api.mondoo.app/risk-categories/attack-surface. */
  categoryMrn: Scalars["String"]["input"];
  /** Impact labels to match. ORed within the category. */
  impactLabels: Array<RiskCategoryImpactLabel>;
};

/** Counts of findings grouped by impact-level for a specific risk category */
export type RiskCategoryImpactCounts = {
  __typename: "RiskCategoryImpactCounts";
  /** The number of findings for which the category had `critical` impact */
  critical: Scalars["Int"]["output"];
  /** The number of findings for which the category was disabled at scoring time */
  disabled: Scalars["Int"]["output"];
  /** The number of findings for which the category had `high` impact */
  high: Scalars["Int"]["output"];
  /** The number of findings for which the category had `low` impact */
  low: Scalars["Int"]["output"];
  /** The number of findings for which the category had `medium` impact */
  medium: Scalars["Int"]["output"];
  /** The number of findings for which the category was not applicable */
  none: Scalars["Int"]["output"];
};

/** Impact label for risk category scoring */
export enum RiskCategoryImpactLabel {
  /** Critical impact on the risk score */
  Critical = "CRITICAL",
  /** Category is disabled and does not participate in scoring */
  Disabled = "DISABLED",
  /** High impact on the risk score */
  High = "HIGH",
  /** Low impact on the risk score */
  Low = "LOW",
  /** Medium impact on the risk score */
  Medium = "MEDIUM",
  /** Enabled, but no impact on the risk score. */
  None = "NONE",
}

/**
 * Risk-category impact-label suggestion value. One entry per category MRN
 * listing the impact labels currently present in the filtered set.
 */
export type RiskCategorySuggestion = {
  __typename: "RiskCategorySuggestion";
  /** Risk category MRN */
  categoryMrn: Scalars["String"]["output"];
  /** Impact labels available for this category in the current filtered set */
  impactLabels: Array<RiskCategoryImpactLabel>;
};

/** Risk distribution */
export type RiskDistribution = {
  __typename: "RiskDistribution";
  /** A count */
  A: Scalars["Int"]["output"];
  /** B count */
  B: Scalars["Int"]["output"];
  /** C count */
  C: Scalars["Int"]["output"];
  /** D count */
  D: Scalars["Int"]["output"];
  /** Error count */
  Error: Scalars["Int"]["output"];
  /** F count */
  F: Scalars["Int"]["output"];
  /** U count */
  U: Scalars["Int"]["output"];
  /** Total count */
  total: Scalars["Int"]["output"];
};

/** Risk factor */
export type RiskFactor = {
  __typename: "RiskFactor";
  /** Risk factor enabled or disabled */
  action?: Maybe<RiskFactorAction>;
  /** Risk factor tag based filters */
  assetFieldFilters?: Maybe<AssetFieldFilters>;
  /** Default risk magnitude */
  defaultMagnitude: RiskMagnitude;
  /** Docs */
  docs?: Maybe<RiskFactorDocs>;
  /**
   * Risk factor indicator eg.:
   * - db-access
   * - admin
   * - asset-in-use
   * - rce
   * - tagged
   * - protected-data
   * - credentials
   * - containers
   * - exploitable
   * - eol
   */
  indicator: Scalars["String"]["output"];
  /** True if the risk factor has a positive effect on risk */
  isPositive: Scalars["Boolean"]["output"];
  /** Risk factor magnitude */
  magnitude: RiskMagnitude;
  /** Mrn */
  mrn: Scalars["String"]["output"];
  /** Risk factor tags */
  tags?: Maybe<Array<Tag>>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Risk factor action */
export enum RiskFactorAction {
  /** Disable risk factor */
  Disable = "DISABLE",
  /** Enable risk factor */
  Enable = "ENABLE",
}

/** Risk factor docs */
export type RiskFactorDocs = {
  __typename: "RiskFactorDocs";
  /** Docs for when the risk factor is active (detected) */
  active?: Maybe<Scalars["String"]["output"]>;
  /** Docs for when the risk factor is inactive (not detected) */
  inactive?: Maybe<Scalars["String"]["output"]>;
};

/** Risk factor explanation */
export type RiskFactorExplanation = {
  __typename: "RiskFactorExplanation";
  /** Magnitude explanation */
  magnitudeExplanation: RiskMagnitudeExplaination;
  /** Summary */
  summary: Scalars["String"]["output"];
};

/** Risk factor filter by mrn */
export type RiskFactorFilter = {
  /** Risk factor indicators to filter on. They are ORed together */
  indicators?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** MRN filter query */
  mrns?: InputMaybe<RiskFactorFilterQuery>;
};

/** Risk factor filter query */
export type RiskFactorFilterQuery = {
  /** Any terms here will be ANDed */
  and?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Any terms here will be ORed */
  or?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Risk factor magnitude modification */
export type RiskFactorMagnitudeModification = {
  /** Risk factor is toxic */
  isToxic: Scalars["Boolean"]["input"];
  /** Risk factor magnitude: -100 to 100 */
  value: Scalars["Int"]["input"];
};

/** Risk factor stats */
export type RiskFactorStats = {
  __typename: "RiskFactorStats";
  /** Affected risk factors */
  affected: Scalars["Int"]["output"];
  /**
   * Risk factor indicator eg.:
   * - db-access
   * - admin
   * - asset-in-use
   * - rce
   * - tagged
   * - protected-data
   * - credentials
   * - containers
   * - exploitable
   * - eol
   */
  indicator: Scalars["String"]["output"];
  /** Risk factor has a positive effect on score */
  isPositive: Scalars["Boolean"]["output"];
  /** Magnitude for risk factor */
  magnitude?: Maybe<RiskMagnitude>;
  /** Risk Factor Mrn */
  mrn: Scalars["String"]["output"];
  /** Risk factor title */
  title: Scalars["String"]["output"];
  /** Total risk factors */
  total: Scalars["Int"]["output"];
};

/** Risk factors response */
export type RiskFactorsResponse = {
  __typename: "RiskFactorsResponse";
  /** Risk factor edges */
  edges?: Maybe<Array<RiskFactor>>;
};

/** Risk factor magnitude */
export type RiskMagnitude = {
  __typename: "RiskMagnitude";
  /** Risk factor is toxic */
  isToxic: Scalars["Boolean"]["output"];
  /** Risk factor magnitude */
  value: Scalars["Int"]["output"];
};

/** Risk magnitude explanation */
export enum RiskMagnitudeExplaination {
  DecreasesRisk = "DECREASES_RISK",
  IncreasesRisk = "INCREASES_RISK",
  NoEffect = "NO_EFFECT",
}

/** Role represents the role of a user within a system or organization. */
export type Role = {
  __typename: "Role";
  /** The Mondoo Resource Name (MRN) uniquely identifies each role. */
  mrn: Scalars["String"]["output"];
  /** The title provides a human-readable name or designation for the role. */
  title: Scalars["String"]["output"];
};

/** Input for a role */
export type RoleInput = {
  /** The MRN of the role */
  mrn: Scalars["String"]["input"];
};

/** Input for rotating a credential's secret data. */
export type RotateCredentialInput = {
  /** MRN of the credential to rotate. */
  mrn: Scalars["ID"]["input"];
  /** New secret field values (replaces all existing data). */
  newData: Scalars["Map"]["input"];
};

/** Result of rotating a credential's secret data. */
export type RotateCredentialPayload = {
  __typename: "RotateCredentialPayload";
  /** The credential with updated metadata. */
  credential: Credential;
};

/** The number of assets a single routing rule has routed into a given space. */
export type RoutingRuleAssetCount = {
  __typename: "RoutingRuleAssetCount";
  /** Number of assets. */
  count: Scalars["Int"]["output"];
  /** Full MRN of the routing rule that routed these assets. */
  ruleMrn: Scalars["String"]["output"];
  /** MRN of the space the assets are currently in. */
  spaceMrn: Scalars["String"]["output"];
};

/**
 * "
 * Instructions to run the policy or query pack from CLI
 */
export type RunCli = {
  __typename: "RunCli";
  /** The command to run */
  command: Scalars["String"]["output"];
  /** Url reference to the documentation for this command */
  installDocsURL: Scalars["String"]["output"];
};

/** S3 configuration options */
export type S3ConfigurationOptions = {
  __typename: "S3ConfigurationOptions";
  /** The access key for the S3 bucket */
  accessKey: Scalars["String"]["output"];
  /** The S3 bucket name */
  bucket: Scalars["String"]["output"];
  /** The S3 endpoint URL */
  endpoint: Scalars["String"]["output"];
  /** The output format for the S3 bucket */
  output: BucketOutputType;
  /** Whether to use legacy list mode */
  useLegacyList: Scalars["Boolean"]["output"];
  /** Whether to use path style access */
  usePathStyle: Scalars["Boolean"]["output"];
};

/** S3 integration input */
export type S3ConfigurationOptionsInput = {
  /** The access key for the S3 bucket */
  accessKey: Scalars["String"]["input"];
  /** The S3 bucket name */
  bucket: Scalars["String"]["input"];
  /** The S3 endpoint URL */
  endpoint: Scalars["String"]["input"];
  /** The output format for the S3 bucket */
  output: BucketOutputType;
  /** The secret access key for the S3 bucket */
  secretAccessKey: Scalars["String"]["input"];
  /** Whether to use legacy list mode */
  useLegacyList: Scalars["Boolean"]["input"];
  /** Whether to use path style access */
  usePathStyle: Scalars["Boolean"]["input"];
};

/** SLA rating source — controls how findings are bucketed into SLA severity tiers */
export enum SlaRatingSource {
  /** CVSS base score thresholds (Critical 9.0-10.0, High 7.0-8.9, Medium 4.0-6.9, Low 0.1-3.9) */
  Cvss = "CVSS",
  /** Mondoo risk rating (default). Buckets are derived from the contextual risk score. */
  Risk = "RISK",
}

/** SLA start date type */
export enum SlaStartDateConfig {
  /** SLA timer starts when Mondoo first discovers the vulnerability on an asset (default) */
  CveDetected = "CVE_DETECTED",
  /** SLA timer starts from the original CVE publication date */
  CvePublished = "CVE_PUBLISHED",
}

/** SLAs */
export type SlAs = {
  __typename: "SLAs";
  /** SLAs for findings */
  findings: Array<FindingsSla>;
  /** How findings are classified into SLA severity buckets (default: RISK) */
  ratingSource?: Maybe<SlaRatingSource>;
  /** When the SLA timer should start (default: CVE_DETECTED) */
  startDateConfig?: Maybe<SlaStartDateConfig>;
};

/** An SSH key for a user */
export type SshKey = {
  __typename: "SSHKey";
  /** The content of the SSH key */
  content: Scalars["String"]["output"];
  /** The fingerprint of the SSH key */
  fingerprint: Scalars["String"]["output"];
};

/** An SSO provider configuration */
export type SsoProvider = {
  __typename: "SSOProvider";
  /** Whether the SSO provider is enabled */
  enabled: Scalars["Boolean"]["output"];
  /** The entity ID of the identity provider */
  idpEntityID: Scalars["String"]["output"];
  /** The entity ID of the relying party */
  rpEntityID: Scalars["String"]["output"];
  /** The SSO URL for authentication */
  ssoUrl: Scalars["String"]["output"];
  /** The X.509 fingerprints for certificate validation */
  x509Fingerprints: Array<Scalars["String"]["output"]>;
};

/** Input for SSO provider configuration */
export type SsoProviderInput = {
  /** Whether the SSO provider is enabled */
  enabled: Scalars["Boolean"]["input"];
  /** The entity ID of the identity provider */
  idpEntityID: Scalars["String"]["input"];
  /** The entity ID of the relying party */
  rpEntityID: Scalars["String"]["input"];
  /** The SSO URL for authentication */
  ssoUrl: Scalars["String"]["input"];
  /** X.509 certificates used for new certificates */
  x509Certificates?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The X.509 fingerprints for certificate validation */
  x509Fingerprints: Array<Scalars["String"]["input"]>;
};

/** Response for SSO provider queries */
export type SsoProviderResponse = {
  __typename: "SSOProviderResponse";
  /** The MRN of the organization */
  organizationMrn?: Maybe<Scalars["String"]["output"]>;
  /** The SSO provider configuration */
  provider: SsoProvider;
};

/** Input for saving a new dashboard version. */
export type SaveBiDashboardVersionInput = {
  /** Commit message describing this version */
  commitMessage?: InputMaybe<Scalars["String"]["input"]>;
  /** Dashboard definition as JSON */
  definition: Scalars["Map"]["input"];
  /** Dashboard MRN */
  mrn: Scalars["String"]["input"];
};

/** ScanConfiguration for the AWS integration */
export type ScanConfiguration = {
  __typename: "ScanConfiguration";
  /** Whether to scan the AWS account */
  accountScan: Scalars["Boolean"]["output"];
  /** The number of hours between scans */
  cronScaninHours: Scalars["Int"]["output"];
  /** Whether cross-account scanning is enabled. */
  crossAccountScan?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Options controlling which accounts are targeted by cross-account scans
   * and which IAM role is assumed in each target account.
   */
  crossAccountScanOptions?: Maybe<AwsCrossAccountScanOptions>;
  /** Whether to scan EC2 instances */
  ec2Scan: Scalars["Boolean"]["output"];
  /** EC2 scan options */
  ec2ScanOptions: Ec2ScanOptions;
  /** Whether to scan ECR repositories */
  ecrScan: Scalars["Boolean"]["output"];
  /**
   * Whether to scan ECS clusters
   * @deprecated ECS scanning is no longer supported and will be removed in the future
   */
  ecsScan: Scalars["Boolean"]["output"];
  /** Event scan triggers */
  eventScanTriggers?: Maybe<Array<Maybe<AwsEventPattern>>>;
  /**
   * When true, the AWS account tags are propagated to all assets discovered
   * under the account.
   */
  propagateAccountTags: Scalars["Boolean"]["output"];
  /** VPC configuration */
  vpcConfiguration?: Maybe<VpcConfiguration>;
};

/** ScanConfigurationInput is the input options for the AWS integration scan configuration */
export type ScanConfigurationInput = {
  /** Whether to scan the AWS account */
  accountScan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The number of hours between scans */
  cronScaninHours?: InputMaybe<Scalars["Int"]["input"]>;
  /** Whether to enable cross-account scanning. */
  crossAccountScan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Options controlling which accounts are targeted by cross-account scans
   * and which IAM role is assumed in each target account.
   */
  crossAccountScanOptions?: InputMaybe<AwsCrossAccountScanOptionsInput>;
  /** Whether to scan EC2 instances */
  ec2Scan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** EC2 scan options */
  ec2ScanOptions?: InputMaybe<Ec2ScanOptionsInput>;
  /** Whether to scan ECR repositories */
  ecrScan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Whether to scan ECS clusters
   * @deprecated ECS scanning is no longer supported and will be removed in the future
   */
  ecsScan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Event scan triggers */
  eventScanTriggers?: InputMaybe<Array<InputMaybe<AwsEventPatternInput>>>;
  /**
   * When true, the AWS account tags are propagated to all assets discovered
   * under the account.
   */
  propagateAccountTags?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** VPC configuration */
  vpcConfiguration?: InputMaybe<VpcConfigurationInput>;
};

/** Status of an asset scan upload as it moves through the processing pipeline. */
export enum ScanProcessingStatus {
  /** Ingestion failed; see errorMessage. */
  Failed = "FAILED",
  /** Upload session created; waiting for the client to push data. */
  Pending = "PENDING",
  /** Ingestion completed successfully. */
  Processed = "PROCESSED",
  /** Server is ingesting the uploaded data. */
  Processing = "PROCESSING",
  /** Client has signalled that the upload is complete; ingestion has not started yet. */
  Uploaded = "UPLOADED",
}

/** A mapping of SCIM group to organization or its spaces and an IAM role */
export type ScimGroupMapping = {
  /** IAM role to be assigned to all members of the SCIM group */
  iamRole: Scalars["String"]["input"];
  /** MRN of the organization to be mapped */
  orgMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** MRN of the space to be mapped */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input options for the scope of the document */
export type ScopeDocumentOptionsInput = {
  /** The MRN of the scope to generate the report for */
  scopeMrn: Scalars["String"]["input"];
};

/** Score */
export type Score = {
  __typename: "Score";
  /** Completion */
  completion: Scalars["Int"]["output"];
  /** Grade */
  grade: Scalars["String"]["output"];
  /** ID */
  id: Scalars["String"]["output"];
  /** Message */
  message: Scalars["String"]["output"];
  /** Risk rating */
  riskRating: ScoreRating;
  /** Risk Score */
  riskScore: Scalars["Int"]["output"];
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue: Scalars["Int"]["output"];
  /** Type */
  type: Scalars["Int"]["output"];
  /** Value */
  value: Scalars["Int"]["output"];
  /** Weight */
  weight: Scalars["Int"]["output"];
};

/** Score range */
export type ScoreRange = {
  /** Begin */
  begin: Scalars["Int"]["input"];
  /** End */
  end: Scalars["Int"]["input"];
};

/** Score rating */
export enum ScoreRating {
  /** Critical - 0-10 */
  Critical = "CRITICAL",
  /** Error - the check encountered an error during execution */
  Error = "ERROR",
  /** High - 11-30 */
  High = "HIGH",
  /** Low - 61-99 */
  Low = "LOW",
  /** Medium - 31-60 */
  Medium = "MEDIUM",
  /** None - 100 */
  None = "NONE",
  /** Unscored, no scan ran yet */
  Unscored = "UNSCORED",
}

/** Score rating suggestion value */
export type ScoreRatingValue = {
  __typename: "ScoreRatingValue";
  /** The score rating value */
  value: ScoreRating;
};

/** Score result type */
export enum ScoreResultType {
  /** Score rrepresents an error */
  Error = "ERROR",
  /** Score represents a result */
  Result = "RESULT",
  /** Score was not scored because query was skipped */
  Skipped = "SKIPPED",
  /** Was not scored for an unknown reason */
  Unknown = "UNKNOWN",
  /** The query has no scoring element */
  Unscored = "UNSCORED",
}

/** ScoreSeverity maps a score number to a severity level */
export enum ScoreSeverity {
  /** Severity is critical when score is 0 */
  Critical = "CRITICAL",
  /** Severity is high when score is between 1 - 40 */
  High = "HIGH",
  /** Severity is low when score is between 71 - 90 */
  Low = "LOW",
  /** Severity is medium when score is between 41 - 70 */
  Medium = "MEDIUM",
  /** Severity is none when score is between 91 - 100 */
  None = "NONE",
}

/** Score source */
export type ScoreSource = {
  __typename: "ScoreSource";
  /** Affected assets */
  affectedAssets: Scalars["Int"]["output"];
  /** First detected at (RFC3339) */
  firstDetectedAt: Scalars["String"]["output"];
  /** Last updated at (RFC3339) */
  lastUpdatedAt: Scalars["String"]["output"];
  /** Source name */
  name: Scalars["String"]["output"];
  /** Vendor name */
  vendor?: Maybe<Scalars["String"]["output"]>;
};

/** Score state */
export enum ScoreState {
  /** Not fixed/Failed */
  Closed = "CLOSED",
  /** Disabled */
  Disabled = "DISABLED",
  /** Error */
  Error = "ERROR",
  /** False Positive */
  FalsePositive = "FALSE_POSITIVE",
  /** Fixed/Pass */
  Open = "OPEN",
  /** Risk Accepted */
  RiskAccepted = "RISK_ACCEPTED",
  /**
   * Snoozed
   * @deprecated we now have more granular types - risk accepted, workaround, false positive
   */
  Snoozed = "SNOOZED",
  /** Workaround */
  Workaround = "WORKAROUND",
}

/** Score state filter */
export enum ScoreStateFilter {
  /** All */
  All = "ALL",
  /** Only fixed/passed */
  Closed = "CLOSED",
  /** Only scores with exceptions */
  Exception = "EXCEPTION",
  /** Only not fixed/failed */
  Open = "OPEN",
}

/** Score state filter suggestion value */
export type ScoreStateFilterValue = {
  __typename: "ScoreStateFilterValue";
  /** The score state filter value */
  value: ScoreStateFilter;
};

/** Score statistics */
export type ScoreStats = {
  __typename: "ScoreStats";
  /** Disabled */
  disabled: Scalars["Int"]["output"];
  /** Errors */
  errors: Scalars["Int"]["output"];
  /** Exceptions */
  exceptions: Scalars["Int"]["output"];
  /** Failed */
  failed: Scalars["Int"]["output"];
  /** Incomplete */
  incomplete: Scalars["Int"]["output"];
  /** Passed */
  passed: Scalars["Int"]["output"];
  /** Risk accepted */
  riskAccepted: Scalars["Int"]["output"];
  /** Skipped */
  skipped: Scalars["Int"]["output"];
  /**
   * Snoozed
   * @deprecated Use riskAccepted instead
   */
  snoozed: Scalars["Int"]["output"];
  /** Total */
  total: Scalars["Int"]["output"];
  /** Unknown */
  unknown: Scalars["Int"]["output"];
  /** Worst */
  worst: Scalars["Int"]["output"];
};

/** Score type */
export enum ScoreType {
  Disabled = "DISABLED",
  Error = "ERROR",
  OutOfScope = "OUT_OF_SCOPE",
  Result = "RESULT",
  Unknown = "UNKNOWN",
  Unscored = "UNSCORED",
}

/** Policy Scoring System */
export enum ScoringSystem {
  Average = "AVERAGE",
  Banded = "BANDED",
  Decayed = "DECAYED",
  HighestImpact = "HIGHEST_IMPACT",
  WeightedAverage = "WEIGHTED_AVERAGE",
}

/** Count of remediation items that would match if a ScriptType chip were the active selection. */
export type ScriptTypeFacet = {
  __typename: "ScriptTypeFacet";
  /** Number of items that would match if this chip were the active ScriptType selection. */
  count: Scalars["Int"]["output"];
  /** The script type this count corresponds to. */
  scriptType: RemediationScriptType;
};

/** Filters for search operations */
export type SearchFilters = {
  /** The type of aggregate score to filter by */
  aggregateScoreType?: InputMaybe<AggregateScoreType>;
};

/** Status of the search item. Only applies to CVEs. */
export enum SearchItemStatus {
  Affected = "AFFECTED",
  NotAffected = "NOT_AFFECTED",
  NotFound = "NOT_FOUND",
  NotReal = "NOT_REAL",
  Unsupported = "UNSUPPORTED",
}

/** The results of a search. */
export type SearchResultItem = Advisory | AggregateScore | Cve;

/** Connection containing search result items */
export type SearchResultItemConnection = {
  __typename: "SearchResultItemConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SearchResultItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The distribution of search results by score type. */
  scoreTypeDistribution: SearchResultScoreTypeDistribution;
};

/** An edge in a connection. */
export type SearchResultItemEdge = {
  __typename: "SearchResultItemEdge";
  /** The item at the end of the edge. */
  node?: Maybe<SearchResultItem>;
  /** The status of the search result. Applies to CVEs only. */
  searchItemStatus?: Maybe<SearchItemStatus>;
};

/** Distribution of search results by score type */
export type SearchResultScoreTypeDistribution = {
  __typename: "SearchResultScoreTypeDistribution";
  /** Number of advisory results */
  advisory: Scalars["Int"]["output"];
  /** Number of asset results */
  asset: Scalars["Int"]["output"];
  /** Number of check results */
  check: Scalars["Int"]["output"];
  /** Number of control results */
  control: Scalars["Int"]["output"];
  /** Number of framework results */
  framework: Scalars["Int"]["output"];
  /** Number of policy results */
  policy: Scalars["Int"]["output"];
  /** Number of risk results */
  risk: Scalars["Int"]["output"];
  /** Number of software results */
  software: Scalars["Int"]["output"];
  /** Number of vulnerability results */
  vulnerability: Scalars["Int"]["output"];
};

/** Possible search types for the search query. */
export enum SearchType {
  /** Returns matching aggregate scores */
  AggregateScore = "AGGREGATE_SCORE",
  /** Returns matching vulnerabilities and advisories in MVD. */
  Mvd = "MVD",
  /** Returns matching osv vulnerabilities in MVD V2. */
  MvdV2 = "MVD_V2",
}

/** Security dashboard pagination info */
export type SecurityDashboardPageInfo = {
  /** organization mrn */
  orgMrn: Scalars["String"]["input"];
  /** space mrn */
  spaceMrn: Scalars["String"]["input"];
};

/** Security model */
export type SecurityModel = {
  __typename: "SecurityModel";
  /** The mrn is a unique identifier */
  scopeMrn: Scalars["String"]["output"];
  /** SLAs */
  slas: SlAs;
};

/** Security pipeline finding groups response for previewing workflow content. */
export type SecurityPipelineFindingGroupsResponse = {
  __typename: "SecurityPipelineFindingGroupsResponse";
  /** The list of finding groups (flat structure, same as workflow details page). */
  findingGroups: Array<SecurityPipelineWorkflowFindingGroup>;
};

/** Security pipeline for Github integration options */
export type SecurityPipelineGithubConfigurationOptions = {
  __typename: "SecurityPipelineGithubConfigurationOptions";
  /**
   * A link that when opened in the browser will trigger the Github app installation.
   * When the installation is completed, the user will be redirected back to us and
   * this will allow us to couple their app install with this integration.
   */
  appInstallationLink: Scalars["String"]["output"];
  /** Whether to auto-create workflows on regressions */
  autoCreateWorkflows: Scalars["Boolean"]["output"];
  /**
   * If the integration was created with generateSSHKey set to true, then this value is set.
   * It contains the public key for the key pair that we generated for the integration. Users
   * need to make sure this key is authorized to SSH to their machines.
   */
  publicKey?: Maybe<Scalars["String"]["output"]>;
  /** The Github repos for which the app installation has permissions */
  repositories?: Maybe<Array<GithubRepository>>;
};

/** Security pipeline for Github integration input */
export type SecurityPipelineGithubConfigurationOptionsInput = {
  /** Whether to auto-create workflows on regressions */
  autoCreateWorkflows?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Whether to generate a SSH key-pair. If false, the user should provision their own
   * SSH key in the repo.
   */
  generateSSHKey?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The list of Github repos to configure */
  repositories?: InputMaybe<
    Array<SecurityPipelineGithubConfigurationOptionsRepoInput>
  >;
};

/** Security pipeline for Github integration repository input */
export type SecurityPipelineGithubConfigurationOptionsRepoInput = {
  fullName: Scalars["String"]["input"];
  spaceMrn: Scalars["String"]["input"];
};

/** Security pipeline scheduled workflow. */
export type SecurityPipelineScheduledWorkflow = {
  __typename: "SecurityPipelineScheduledWorkflow";
  /** The configuration of the scheduled workflow. */
  configuration: SecurityPipelineScheduledWorkflowConfiguration;
  /** The creation timestamp of the scheduled workflow. */
  createdAt: Scalars["String"]["output"];
  /** The user who created the workflow. */
  createdBy: Author;
  /** The MRN of the security pipeline integration used to create this scheduled workflow. */
  integrationMrn: Scalars["String"]["output"];
  /** The MRN of the scheduled workflow. */
  mrn: Scalars["String"]["output"];
  /** Timestamp for the next scheduled run of this schedule. */
  nextRunAt: Scalars["String"]["output"];
  /** The MRN of the owner (space). */
  ownerMrn: Scalars["String"]["output"];
  /** The selection criteria of the scheduled workflow. */
  selection: SecurityPipelineScheduledWorkflowSelection;
  /** The title of the scheduled workflow. */
  title: Scalars["String"]["output"];
  /** The last updated timestamp of the scheduled workflow. */
  updatedAt: Scalars["String"]["output"];
};

/** Security pipeline scheduled workflow cadence. */
export enum SecurityPipelineScheduledWorkflowCadence {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
}

/** Security pipeline scheduled workflow configuration. */
export type SecurityPipelineScheduledWorkflowConfiguration = {
  __typename: "SecurityPipelineScheduledWorkflowConfiguration";
  /** The cadence of the scheduled workflow. */
  cadence: SecurityPipelineScheduledWorkflowCadence;
  /**
   * Supported for weekly and monthly cadence. For weekly 0-6 (0 is Sunday).
   * For monthly 1-31.
   */
  day?: Maybe<Scalars["Int"]["output"]>;
};

/** Security pipeline scheduled workflow configuration input. */
export type SecurityPipelineScheduledWorkflowConfigurationInput = {
  /** The cadence of the scheduled workflow. */
  cadence: SecurityPipelineScheduledWorkflowCadence;
  /**
   * Supported for weekly and monthly cadence. For weekly 0-6 (0 is Sunday).
   * For monthly 1-31.
   */
  day?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Security pipeline scheduled workflows response. */
export type SecurityPipelineScheduledWorkflowConnection = {
  __typename: "SecurityPipelineScheduledWorkflowConnection";
  /** Edges */
  edges?: Maybe<Array<SecurityPipelineScheduledWorkflowEdge>>;
  /** Information about the current page */
  pageInfo: PageInfo;
  /** The total number of security pipeline scheduled workflows */
  totalCount: Scalars["Int"]["output"];
};

/** Security pipeline scheduled workflow edge. */
export type SecurityPipelineScheduledWorkflowEdge = {
  __typename: "SecurityPipelineScheduledWorkflowEdge";
  /** Cursor */
  cursor: Scalars["String"]["output"];
  /** Node */
  node: SecurityPipelineScheduledWorkflow;
};

/** Security pipeline scheduled workflow responses */
export type SecurityPipelineScheduledWorkflowResponse =
  | NotFoundError
  | RequestError
  | SecurityPipelineScheduledWorkflow;

/** Security pipeline scheduled workflow selection. */
export type SecurityPipelineScheduledWorkflowSelection = {
  __typename: "SecurityPipelineScheduledWorkflowSelection";
  /**
   * An optional list of asset MRNs. If provided, we create a patch only
   * for findings with the specified ratings.
   */
  findingRatings?: Maybe<Array<ScoreRating>>;
  /** The MRN of the scope (space or workspace) to get assets from. */
  scopeMrn: Scalars["String"]["output"];
};

/** Security pipeline scheduled workflow selection input. */
export type SecurityPipelineScheduledWorkflowSelectionInput = {
  /**
   * An optional list of asset MRNs. If provided, we create a patch only
   * for findings with the specified ratings.
   */
  findingRatings?: InputMaybe<Array<ScoreRating>>;
  /** The MRN of the scope (space or workspace) to get assets from. */
  scopeMrn: Scalars["String"]["input"];
};

/** Security pipeline scheduled workflows input. */
export type SecurityPipelineScheduledWorkflowsInput = {
  /** The MRN of the scope (space). */
  scopeMrn: Scalars["String"]["input"];
};

/** Security pipeline workflow */
export type SecurityPipelineWorkflow = {
  __typename: "SecurityPipelineWorkflow";
  /** The creation timestamp of the workflow. */
  createdAt: Scalars["String"]["output"];
  /** The user who created the workflow. */
  createdBy: Author;
  /** Finding groups attached to the workflow */
  findingGroups?: Maybe<Array<SecurityPipelineWorkflowFindingGroup>>;
  /** The MRN of the security pipeline integration used to create this workflow. */
  integrationMrn: Scalars["String"]["output"];
  /** Labels */
  labels?: Maybe<Array<KeyValue>>;
  /** The MRN of the workflow. */
  mrn: Scalars["String"]["output"];
  /** The MRN of the owner (space). */
  ownerMrn: Scalars["String"]["output"];
  /** The pull request associated with the workflow. */
  pullRequest?: Maybe<PullRequestInfo>;
  /** The MRN of the scheduled workflow, if this workflow was created by a scheduled workflow. */
  scheduledWorkflowMrn?: Maybe<Scalars["String"]["output"]>;
  /** The status of the workflow. */
  status: WorkflowStatus;
  /** The list of tasks associated with the workflow. */
  tasks: Array<SecurityPipelineWorkflowTask>;
  /** The title of the workflow. */
  title: Scalars["String"]["output"];
  /** The last updated timestamp of the workflow. */
  updatedAt: Scalars["String"]["output"];
};

/** Security pipeline workflows response. */
export type SecurityPipelineWorkflowConnection = {
  __typename: "SecurityPipelineWorkflowConnection";
  /** Edges */
  edges?: Maybe<Array<SecurityPipelineWorkflowEdge>>;
  /** Information about the current page */
  pageInfo: PageInfo;
  /** The total number of security pipeline workflows */
  totalCount: Scalars["Int"]["output"];
};

/** Security pipeline workflow edge. */
export type SecurityPipelineWorkflowEdge = {
  __typename: "SecurityPipelineWorkflowEdge";
  /** Cursor */
  cursor: Scalars["String"]["output"];
  /** Node */
  node: SecurityPipelineWorkflow;
};

/** Security pipeline workflow finding group */
export type SecurityPipelineWorkflowFindingGroup = {
  __typename: "SecurityPipelineWorkflowFindingGroup";
  /** The number of assets in this group. */
  assetsCount: Scalars["Int"]["output"];
  /** The MRN of the finding. */
  findingMrn: Scalars["String"]["output"];
  /** Method of how the reference was added to the workflow. */
  method: WorkflowRefMethod;
  /** Score rating */
  rating: ScoreRating;
  /**
   * Risk score for the finding over the entire space/workspace. Note that
   * this includes more assets than just the ones selected in the workflow.
   */
  riskScore: Scalars["Int"]["output"];
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue: Scalars["Int"]["output"];
  /** The title of the finding. */
  title: Scalars["String"]["output"];
};

/** Security pipeline workflow order object */
export type SecurityPipelineWorkflowOrder = {
  /** Order direction */
  direction: OrderDirection;
  /** Workflow field */
  field: SecurityPipelineWorkflowOrderField;
};

/** Security pipeline workflow order field */
export enum SecurityPipelineWorkflowOrderField {
  CreatedAt = "CREATED_AT",
  Title = "TITLE",
  UpdatedAt = "UPDATED_AT",
}

/** Security pipeline workflow responses */
export type SecurityPipelineWorkflowResponse =
  | NotFoundError
  | RequestError
  | SecurityPipelineWorkflow;

/** Security pipeline workflow task */
export type SecurityPipelineWorkflowTask = {
  __typename: "SecurityPipelineWorkflowTask";
  /** The creation timestamp of the task. */
  createdAt: Scalars["String"]["output"];
  /** The status of the task. */
  status: WorkflowTaskStatus;
  /** The type of the task. */
  type: WorkflowTaskType;
  /** The last updated timestamp of the task. */
  updatedAt: Scalars["String"]["output"];
};

/** Security pipeline workflows input. */
export type SecurityPipelineWorkflowsInput = {
  /** The MRN of the security pipeline integration to filter by. */
  integrationMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** The MRN of the scope (space). */
  scopeMrn: Scalars["String"]["input"];
  /** The status of the workflows to filter by. */
  statuses?: InputMaybe<Array<WorkflowStatus>>;
};

/** SecurityScorecard configuration options */
export type SecurityScorecardConfigurationOptions = {
  __typename: "SecurityScorecardConfigurationOptions";
  /** createAssets is a flag to create assets in the backend when they are not found */
  createAssets?: Maybe<Scalars["Boolean"]["output"]>;
  /** The domain being monitored */
  domain?: Maybe<Scalars["String"]["output"]>;
};

/** SecurityScorecard configuration options input */
export type SecurityScorecardConfigurationOptionsInput = {
  /** The SecurityScorecard API token */
  apiToken?: InputMaybe<Scalars["String"]["input"]>;
  /** createAssets is a flag to create assets in the backend when they are not found */
  createAssets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The domain to monitor (e.g., example.com) */
  domain?: InputMaybe<Scalars["String"]["input"]>;
};

/** SentinelOne configuration options */
export type SentinelOneConfigurationOptions = {
  __typename: "SentinelOneConfigurationOptions";
  /** The account ID of the SentinelOne integration */
  account: Scalars["String"]["output"];
  /** createAssets is a flag to create assets in the backend when they are not found */
  createAssets?: Maybe<Scalars["Boolean"]["output"]>;
  /** The host of the SentinelOne integration */
  host: Scalars["String"]["output"];
  /** mondooEnrichment is a flag to enable mondoo scans based on the SentinelOne data */
  mondooEnrichment?: Maybe<Scalars["Boolean"]["output"]>;
  /** password or certificate is required */
  secretType?: Maybe<Scalars["String"]["output"]>;
};

/** SentinelOne integration input */
export type SentinelOneConfigurationOptionsInput = {
  /** The account ID of the SentinelOne integration */
  account: Scalars["String"]["input"];
  /** certificate or client secret is required */
  certificate?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  /** createAssets is a flag to create assets in the backend when they are not found */
  createAssets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The host of the SentinelOne integration */
  host: Scalars["String"]["input"];
  /** mondooEnrichment is a flag to enable mondoo scans based on the SentinelOne data */
  mondooEnrichment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A service account in the system */
export type ServiceAccount = Identity & {
  __typename: "ServiceAccount";
  /** RFC 3339 timestamp when the service account was created */
  createdAt: Scalars["String"]["output"];
  /** The creator of the service account */
  creator?: Maybe<ServiceAccountCreator>;
  /** The description of the service account */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The ID of the service account */
  id: Scalars["String"]["output"];
  /** The labels for the service account */
  labels: Array<KeyValue>;
  /** RFC 3339 timestamp when the service account was last used */
  lastUsed?: Maybe<Scalars["String"]["output"]>;
  /** The MRN of the service account */
  mrn: Scalars["String"]["output"];
  /** The name of the service account */
  name: Scalars["String"]["output"];
  /**
   * Notes for the service account (deprecated, use description)
   * @deprecated Use description
   */
  notes?: Maybe<Scalars["String"]["output"]>;
  /** The roles assigned to the service account */
  roles: Array<Role>;
};

/** Connection containing service accounts */
export type ServiceAccountConnection = {
  __typename: "ServiceAccountConnection";
  /** The edges in the connection */
  edges?: Maybe<Array<ServiceAccountEdge>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** The total number of service accounts */
  totalCount: Scalars["Int"]["output"];
};

/** Creator of a service account */
export type ServiceAccountCreator = {
  __typename: "ServiceAccountCreator";
  /** The email of the creator */
  email?: Maybe<Scalars["String"]["output"]>;
  /** The MRN of the creator */
  mrn?: Maybe<Scalars["String"]["output"]>;
  /**
   * A human-readable display name for the creator. Resolved server-side from
   * the MRN so clients do not need to pattern-match identifiers. Examples:
   * "Mondoo Platform" for the system user, "Service Account {id}" for a
   * service-account creator, or the creator's email when available.
   */
  name?: Maybe<Scalars["String"]["output"]>;
  /** The service that created the account */
  service?: Maybe<Scalars["String"]["output"]>;
};

/** Credentials for a service account */
export type ServiceAccountCredential = {
  __typename: "ServiceAccountCredential";
  /** The API endpoint for the service account */
  apiEndpoint: Scalars["String"]["output"];
  /** The certificate for the service account */
  certificate: Scalars["String"]["output"];
  /** The MRN of the service account */
  mrn: Scalars["String"]["output"];
  /** The private key for the service account */
  privateKey: Scalars["String"]["output"];
  /** The MRN of the scope for the service account */
  scopeMrn: Scalars["String"]["output"];
  /** The MRN of the space (deprecated) */
  spaceMrn?: Maybe<Scalars["String"]["output"]>;
};

/** An edge in a service accounts connection */
export type ServiceAccountEdge = {
  __typename: "ServiceAccountEdge";
  /** The cursor for this edge */
  cursor: Scalars["ID"]["output"];
  /** The service account at the end of the edge */
  node?: Maybe<ServiceAccount>;
};

/** Input for ordering service accounts */
export type ServiceAccountOrder = {
  /** The direction to order by */
  direction: OrderDirection;
  /** The field to order by */
  field: ServiceAccountOrderField;
};

/** Field to order service accounts by */
export enum ServiceAccountOrderField {
  /** Order by creation time */
  CreatedAt = "CREATED_AT",
  /** Order by ID */
  Id = "ID",
  /** Order by last used time */
  LastUsed = "LAST_USED",
  /** Order by name */
  Name = "NAME",
}

/** ServiceNow configuration options */
export type ServiceNowConfigurationOptions = {
  __typename: "ServiceNowConfigurationOptions";
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["output"];
  /** Whether to auto-create tickets */
  autoCreateTickets: Scalars["Boolean"]["output"];
  /** The ServiceNow client ID */
  clientId: Scalars["String"]["output"];
  /** The ServiceNow instance URL */
  instanceUrl: Scalars["String"]["output"];
  /** Email of user in ServiceNow to associate with action */
  userEmail?: Maybe<Scalars["String"]["output"]>;
};

/** ServiceNow integration input */
export type ServiceNowConfigurationOptionsInput = {
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["input"];
  /** Whether to auto-create tickets */
  autoCreateTickets: Scalars["Boolean"]["input"];
  /** The ServiceNow client ID */
  clientId: Scalars["String"]["input"];
  /** The ServiceNow instance URL */
  instanceUrl: Scalars["String"]["input"];
};

/** ServiceNow ticket configuration input */
export type ServiceNowTicketConfigInput = {
  /** Impact to attach to the incident */
  impact?: InputMaybe<Scalars["Int"]["input"]>;
  /** Priority to attach to the incident */
  priority?: InputMaybe<Scalars["Int"]["input"]>;
  /** Urgency to attach to the incident */
  urgency?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input for setting asset annotations */
export type SetAssetAnnotationsInput = {
  /** The annotations to set for the asset */
  annotations: Array<KeyValueInput>;
  /** The MRN of the asset to annotate */
  mrn: Scalars["String"]["input"];
  /** The MRN of the space containing the asset */
  spaceMrn: Scalars["String"]["input"];
};

/** Response when setting asset annotations */
export type SetAssetAnnotationsPayload = {
  __typename: "SetAssetAnnotationsPayload";
  /** The updated annotations for the asset */
  annotations: Array<KeyValue>;
};

/**
 * Input for setting the asset routing table.
 * Provide either orgMrn (deprecated) or scopeMrn.
 */
export type SetAssetRoutingTableInput = {
  /**
   * Deprecated alias for scopeMrn.
   * @deprecated use scopeMrn
   */
  orgMrn?: InputMaybe<Scalars["String"]["input"]>;
  /** Ordered list of routing rules. */
  rules: Array<AssetRoutingRuleInput>;
  /** Scope MRN to set the routing table for (org MRN or platform MRN). */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Uploads policy content */
export type SetCustomPolicyInput = {
  /** RFC2397, base64 encoded policy bundle */
  dataurl: Scalars["String"]["input"];
  /** Overwrites the policy if it already exists */
  overwrite?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Scope mrn is the mrn of the space, organization, or platform. A platform
   * scope mrn (//platform.api.mondoo.app) is mapped to the global policy owner
   * server-side.
   */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The mrn of the space
   * @deprecated use scopeMrn instead
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
};

/** Result of adding a policy */
export type SetCustomPolicyPayload = {
  __typename: "SetCustomPolicyPayload";
  /** The mrn's of stored policies */
  policyMrns?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** Creates a new query pack with the provided content */
export type SetCustomQueryPackInput = {
  /** RFC2397, base64 encoded policy bundle */
  dataurl: Scalars["String"]["input"];
  /** Overwrites the query pack if it already exists */
  overwrite?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The mrn of the space */
  spaceMrn: Scalars["String"]["input"];
};

/** Result of setting query pack content */
export type SetCustomQueryPackPayload = {
  __typename: "SetCustomQueryPackPayload";
  /** The mrn's of stored query packs */
  queryPackMrns?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** Input for setting organization membership */
export type SetOrganizationMembershipInput = {
  /** The MRN of the organization */
  orgMrn: Scalars["String"]["input"];
  /** The roles to assign to the user */
  roles: Array<RoleInput>;
  /** The MRN of the user */
  userMrn: Scalars["String"]["input"];
};

/** Input for setting contacts on a resource */
export type SetResourceContactsInput = {
  /** The contacts to set. Replaces all existing contacts. */
  contacts: Array<ResourceContactInput>;
  /** The MRN of the resource (space, organization, or workspace) */
  resourceMrn: Scalars["String"]["input"];
};

/** Input for setting a role */
export type SetRoleInput = {
  /** The MRN of the entity to update */
  entityMrn: Scalars["String"]["input"];
  /** The roles to assign to the entity */
  roles: Array<RoleInput>;
};

/** Input for setting roles */
export type SetRolesInput = {
  /** The email or MRN of the entity */
  identity?: InputMaybe<Scalars["String"]["input"]>;
  /** The roles to assign the identity on the scope */
  roles?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The MRN of the scope */
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The MRN of the space (deprecated, use scopeMrn)
   * @deprecated Use scopeMrn
   */
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The role updates to apply
   * @deprecated Use identity and scope. This API will set roles on a single identity
   */
  updates?: InputMaybe<Array<SetRoleInput>>;
};

/** Response when setting roles */
export type SetRolesPayload = {
  __typename: "SetRolesPayload";
  /**
   * Any errors that occurred during the operation
   * @deprecated Map type is not well supported
   */
  errors: Scalars["Map"]["output"];
  /** The email of the identity if available */
  identity_email?: Maybe<Scalars["String"]["output"]>;
  /** The MRN of the identity */
  identity_mrn: Scalars["String"]["output"];
  /**
   * The MRNs of the entities that were updated
   * @deprecated setRoles will only deal with a single identity scope binding
   */
  mrns?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** Input for setting SSO provider */
export type SetSsoProviderInput = {
  /** The MRN of the organization */
  organizationMrn: Scalars["String"]["input"];
  /** The SSO provider configuration */
  provider?: InputMaybe<SsoProviderInput>;
};

/** Input type for setScimGroupMapping */
export type SetScimGroupMappingInput = {
  /** Group Identifier which is the SCIM displayName */
  group: Scalars["String"]["input"];
  /** Mappings of SCIM group to organization or its spaces with IAM role */
  mappings: Array<ScimGroupMapping>;
  /** Organization MRN for with the SCIM mapping is defined */
  orgMrn: Scalars["String"]["input"];
};

/** Return type for setScimGroupMapping */
export type SetScimGroupMappingPayload = {
  __typename: "SetScimGroupMappingPayload";
  /** The group identifier that was mapped */
  group: Scalars["String"]["output"];
};

/** Input for setting space membership */
export type SetSpaceMembershipInput = {
  /** The roles to assign to the user */
  roles: Array<RoleInput>;
  /** The MRN of the space */
  spaceMrn: Scalars["String"]["input"];
  /** The MRN of the user */
  userMrn: Scalars["String"]["input"];
};

/** Possible severities */
export enum Severity {
  Critical = "CRITICAL",
  High = "HIGH",
  Low = "LOW",
  Medium = "MEDIUM",
  None = "NONE",
}

/** Shodan integration */
export type ShodanConfigurationOptions = {
  __typename: "ShodanConfigurationOptions";
  /** A list of Shodan scan targets */
  targets?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The Shodan API token */
  token: Scalars["String"]["output"];
};

/** Shodan integration input */
export type ShodanConfigurationOptionsInput = {
  /** Shodan scan targets. Can be a domain, IP or CIDR */
  targets?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Shodan API token */
  token: Scalars["String"]["input"];
};

/** Simple filter suggestion with a string label */
export type SimpleFilterSuggestion = FilterSuggestion & {
  __typename: "SimpleFilterSuggestion";
  /** The human-readable label to display */
  label: Scalars["String"]["output"];
  /** The value to use when setting the filter */
  value: FilterSuggestionValue;
};

/** Slack configuration options */
export type SlackConfigurationOptions = {
  __typename: "SlackConfigurationOptions";
  /** Placeholder for Slack configuration options */
  placeholder: Scalars["String"]["output"];
};

/** Slack integration input */
export type SlackConfigurationOptionsInput = {
  /** Type of notifications to send (default asset updates) */
  notificationType?: InputMaybe<NotificationType>;
  /** The Slack API token (optional) */
  slackToken?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Snowflake export integration configuration options. These configure the Snowflake
 * *export* integration (SNOWFLAKE), which exports Mondoo data into a Snowflake account.
 * Distinct from SnowflakeScanConfigurationOptions, which configures a hosted scan of a Snowflake account.
 */
export type SnowflakeConfigurationOptions = {
  __typename: "SnowflakeConfigurationOptions";
  /** The Snowflake account ID */
  accountId: Scalars["String"]["output"];
  /** The Snowflake database name */
  database: Scalars["String"]["output"];
  /** The Snowflake region */
  region: Scalars["String"]["output"];
  /** The Snowflake role */
  role?: Maybe<Scalars["String"]["output"]>;
  /** The Snowflake schema name */
  schema: Scalars["String"]["output"];
  /** The Snowflake user name */
  username: Scalars["String"]["output"];
  /** The Snowflake warehouse name */
  warehouse: Scalars["String"]["output"];
};

/**
 * Snowflake export integration input. Configures the Snowflake *export* integration
 * (SNOWFLAKE), which exports Mondoo data into a Snowflake account. Distinct from
 * SnowflakeScanConfigurationOptionsInput, which configures a hosted scan of a Snowflake account.
 */
export type SnowflakeConfigurationOptionsInput = {
  /** The Snowflake account ID */
  accountId: Scalars["String"]["input"];
  /** The Snowflake database name */
  database: Scalars["String"]["input"];
  /** The Snowflake password */
  password: Scalars["String"]["input"];
  /** The Snowflake region */
  region: Scalars["String"]["input"];
  /** The Snowflake role */
  role?: InputMaybe<Scalars["String"]["input"]>;
  /** The Snowflake schema name */
  schema: Scalars["String"]["input"];
  /** The Snowflake user name */
  username: Scalars["String"]["input"];
  /** The Snowflake warehouse name */
  warehouse: Scalars["String"]["input"];
};

/** Snowflake (hosted scan) integration */
export type SnowflakeScanConfigurationOptions = {
  __typename: "SnowflakeScanConfigurationOptions";
  /** Snowflake account identifier (locator) being scanned */
  account: Scalars["String"]["output"];
  /** Snowflake region (may be empty depending on the account identifier format) */
  region?: Maybe<Scalars["String"]["output"]>;
  /** Snowflake role assumed for the scan (may be empty) */
  role?: Maybe<Scalars["String"]["output"]>;
  /** Snowflake user used to authenticate */
  user: Scalars["String"]["output"];
};

/** Snowflake (hosted scan) integration input */
export type SnowflakeScanConfigurationOptionsInput = {
  /** Snowflake account identifier (locator) to scan */
  account: Scalars["String"]["input"];
  /** PEM-encoded private key (identity file) used for key-pair authentication */
  identityFile?: InputMaybe<Scalars["String"]["input"]>;
  /** Snowflake region (optional, depending on the account identifier format) */
  region?: InputMaybe<Scalars["String"]["input"]>;
  /** Snowflake role to assume for the scan (optional) */
  role?: InputMaybe<Scalars["String"]["input"]>;
  /** Snowflake user to authenticate as */
  user: Scalars["String"]["input"];
};

/** Snyk configuration options */
export type SnykConfigurationOptions = {
  __typename: "SnykConfigurationOptions";
  /** Base URL of the Snyk REST API */
  baseUrl?: Maybe<Scalars["String"]["output"]>;
  /** Whether to create assets in the backend when they are not found */
  createAssets: Scalars["Boolean"]["output"];
  /** Snyk organization the import is scoped to (UUID or slug) */
  organization?: Maybe<Scalars["String"]["output"]>;
  /** Snyk REST API version the import is pinned to */
  version?: Maybe<Scalars["String"]["output"]>;
};

/** Snyk configuration options input */
export type SnykConfigurationOptionsInput = {
  /** The Snyk API token (write-only) */
  apiToken?: InputMaybe<Scalars["String"]["input"]>;
  /** Base URL of the Snyk REST API (empty defaults to https://api.snyk.io/rest) */
  baseUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether to create assets in the backend when they are not found */
  createAssets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Snyk organization to scope the import to, by UUID or slug (empty imports all) */
  organization?: InputMaybe<Scalars["String"]["input"]>;
  /** Snyk REST API version to pin (empty uses the importer default) */
  version?: InputMaybe<Scalars["String"]["input"]>;
};

/** Social media configuration - adjusts risk based on the social media score of the vulnerability */
export type SocialMediaConfiguration = {
  __typename: "SocialMediaConfiguration";
  /** Whether to factor social media into the news score */
  enabled: Scalars["Boolean"]["output"];
  /** Weight of the social media component */
  weight: Scalars["Float"]["output"];
};

/** Social media configuration input */
export type SocialMediaConfigurationInput = {
  /** Whether to factor social media into the news score */
  enabled: Scalars["Boolean"]["input"];
  /** Weight of the social media component */
  weight: Scalars["Float"]["input"];
};

/** Software represents a single installed package as observed on an asset. */
export type Software = {
  __typename: "Software";
  /** Package architecture (e.g. "amd64", "aarch64"). */
  arch?: Maybe<Scalars["String"]["output"]>;
  /**
   * Common Platform Enumeration (CPE) identifiers for this package, in
   * canonical 2.3 form. Capped at 5 entries per package — packages whose
   * scanner-reported CPE count exceeds the cap report no CPEs at all.
   */
  cpes?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Human-readable description of the package, as reported by the scanner. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Ecosystem identifier (e.g. "ubuntu/22.04", "pypi"). */
  ecosystem?: Maybe<Scalars["String"]["output"]>;
  /**
   * End-of-life analysis for this package. Populated when a `MONDOO-EOL-*`
   * finding has matched the package's PURL+version against the EOL catalog.
   * Shape mirrors `Asset.eol` so the UI can share its display component
   * between asset and software views. Null when the package has no
   * EOL finding (catalog miss, or the package is not yet within the
   * configured EOL warning window).
   */
  eol?: Maybe<EolAnalysis>;
  /**
   * RFC3339 timestamp of the first observation of this exact name+version on
   * the asset.
   */
  firstObserved?: Maybe<Scalars["String"]["output"]>;
  /** Short string identifying the icon for the UI, mapped from the ecosystem. */
  iconIDEnum?: Maybe<Icon_Ids>;
  /** Stable identifier — the package score MRN, which encodes name and version. */
  id: Scalars["ID"]["output"];
  /**
   * RFC3339 timestamp of when the package was installed on the asset, as
   * reported by the OS package manager. May be empty when the backend
   * doesn't surface install time (apk, dpkg without log parsing, pacman,
   * macOS).
   */
  installDate?: Maybe<Scalars["String"]["output"]>;
  /** RFC3339 timestamp of the most recent scan that re-confirmed the package. */
  lastObserved?: Maybe<Scalars["String"]["output"]>;
  /**
   * SPDX license expression (or upstream-reported license string) for the
   * package. May be empty when the backend has no source for it (e.g.
   * Windows registry, or scanners predating the license collection in
   * mql#7816/#7817).
   */
  license?: Maybe<Scalars["String"]["output"]>;
  /** Same as id; provided as a separate field for parity with other types. */
  mrn: Scalars["String"]["output"];
  /** Package name as reported by the scanner. */
  name: Scalars["String"]["output"];
  /** Upstream / source package, when reported by the scanner. */
  origin?: Maybe<Scalars["String"]["output"]>;
  /**
   * Evidence file paths captured by the scanner that prove the package is
   * installed.
   */
  paths?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Package URL (purl) in canonical form, when available. */
  purl?: Maybe<Scalars["String"]["output"]>;
  /**
   * Risk factor MRNs detected on this package score. Mirrors the set
   * queryable via `filter.risks` so the UI can render badges (e.g. "EOL",
   * "known-exploited") without a second roundtrip. Empty when the package
   * has no detected risk factors.
   */
  riskIds?: Maybe<Array<Scalars["String"]["output"]>>;
  /**
   * Package vendor / publisher as reported by the scanner (e.g. "Red Hat,
   * Inc.", "Microsoft Corporation"). May be empty on platforms whose
   * package metadata does not surface a vendor field.
   */
  vendor?: Maybe<Scalars["String"]["output"]>;
  /** Package version as reported by the scanner. */
  version?: Maybe<Scalars["String"]["output"]>;
};

/**
 * One node of the software category genealogy (ADR-056), used to carry the
 * derived root→leaf ancestry of SoftwareV2.category.
 */
export type SoftwareCategoryNode = {
  __typename: "SoftwareCategoryNode";
  /** Genealogy node id (e.g. "web-browser"). */
  id: Scalars["String"]["output"];
  /** Human-readable taxonomy title (e.g. "Web Browser"). */
  title: Scalars["String"]["output"];
};

/** Connection wrapping a page of Software entries plus pagination metadata. */
export type SoftwareConnection = {
  __typename: "SoftwareConnection";
  /** Software entries on this page. */
  edges?: Maybe<Array<SoftwareEdge>>;
  /**
   * Pagination metadata — cursors for resuming the walk and the
   * hasNextPage flag.
   */
  pageInfo: PageInfo;
  /** Total number of rows matching the filter, ignoring pagination. */
  totalCount: Scalars["Int"]["output"];
};

/** A single edge in a SoftwareConnection — the entry plus its cursor. */
export type SoftwareEdge = {
  __typename: "SoftwareEdge";
  /** Opaque cursor that resumes pagination from this entry's position. */
  cursor: Scalars["ID"]["output"];
  /** The Software entry. */
  node: Software;
};

/**
 * Filters for the software inventory list. v1 covers identity (name,
 * ecosystem) only; richer filters (EOL, install path, category) come later.
 */
export type SoftwareFilter = {
  /** Exact match on ecosystem identifier (e.g. "ubuntu/22.04", "pypi"). */
  ecosystem?: InputMaybe<Scalars["String"]["input"]>;
  /** Exact match on package name. */
  packageName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Case-insensitive contains filter on package name. Multiple terms are
   * ANDed together.
   */
  queryTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Filter by risk factor MRNs attached to the package. Mirrors the
   * RiskFactorFilterQuery shape used by `findings(filter.riskFactors.mrns)`
   * so the same input drives both APIs. AND requires every listed MRN to be
   * present; OR matches any. EOL packages can be selected with
   * `risks: { and: ["//policy.api.mondoo.app/risks/software-is-eol"] }`.
   */
  risks?: InputMaybe<RiskFactorFilterQuery>;
};

/**
 * Ordering spec for the software inventory list. Direction is required and
 * field defaults to NAME at the server when omitted.
 */
export type SoftwareOrder = {
  /** Sort direction (ascending or descending). */
  direction: OrderDirection;
  /** Column to sort by. */
  field: SoftwareOrderField;
};

/** Available ordering keys for the software inventory list. */
export enum SoftwareOrderField {
  /** Order by the timestamp the package was first observed on the asset. */
  FirstObserved = "FIRST_OBSERVED",
  /** Order by the timestamp of the most recent scan that confirmed the package. */
  LastObserved = "LAST_OBSERVED",
  /** Order by package name. */
  Name = "NAME",
  /**
   * Order by the software's per-asset risk value (0–100, higher = worse). DESC lists the
   * most-at-risk software first; healthy and unscored (no-risk) packages sort last.
   */
  Risk = "RISK",
}

/**
 * The raw, on-OS package a SoftwareV2 was observed as (ADR-057
 * `software.package`): unmodified scanner detail. `vendor` here is the raw
 * packager string, NOT the normalized SoftwareV2.vendor.
 */
export type SoftwarePackage = {
  __typename: "SoftwarePackage";
  /** Package architecture (e.g. "amd64", "aarch64"). */
  arch?: Maybe<Scalars["String"]["output"]>;
  /** CPE 2.3 identifiers (capped at 5 on ingest). */
  cpes?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Human-readable description as reported by the scanner. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Package ecosystem / format (deb/rpm/apk/npm/pypi/...). */
  format?: Maybe<Scalars["String"]["output"]>;
  /** RFC3339 install time as reported by the OS package manager; may be empty. */
  installDate?: Maybe<Scalars["String"]["output"]>;
  /** SPDX license expression (or upstream-reported license string). */
  license?: Maybe<Scalars["String"]["output"]>;
  /** On-OS package name (e.g. "libssl1.1"), distinct from the normalized SoftwareV2.name. */
  name: Scalars["String"]["output"];
  /** The package's claimed distro/registry origin (mirrors package_scores.namespace). */
  namespace?: Maybe<Scalars["String"]["output"]>;
  /** Upstream / source package, when reported by the scanner. */
  origin?: Maybe<Scalars["String"]["output"]>;
  /** Evidence file paths proving the package is installed. */
  paths?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Package URL (canonical) — the software leaf identity. */
  purl?: Maybe<Scalars["String"]["output"]>;
  /** Raw vendor/publisher string as reported by the scanner; never the normalized vendor. */
  vendor?: Maybe<Scalars["String"]["output"]>;
  /** On-OS package version as reported by the scanner. */
  version?: Maybe<Scalars["String"]["output"]>;
};

/**
 * SoftwareV2 is the normalized, server-classified per-asset view of one
 * installed product (ADR-057): the raw `package` plus Mondoo's normalized
 * identity and server-owned classification.
 */
export type SoftwareV2 = {
  __typename: "SoftwareV2";
  /**
   * Individual upstream maintainers, when the software is people-authored rather
   * than org-published. Mutually exclusive in spirit with `vendor`. Sparsely
   * populated until ecosystem author ingestion lands.
   */
  authors?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Server-owned category — a genealogy leaf id (ADR-056); empty = unclassified. */
  category?: Maybe<Scalars["String"]["output"]>;
  /** Derived root→leaf ancestry of `category`; empty when unclassified. */
  categoryAncestry?: Maybe<Array<SoftwareCategoryNode>>;
  /** ADR-056 subject-area facet, single-valued. */
  domain?: Maybe<Scalars["String"]["output"]>;
  /**
   * End-of-life analysis for this package, resolved lazily from the EOL catalog
   * at query time (mirrors `Asset.eol` / `Software.eol`). Null unless the package
   * carries an EOL risk factor and the catalog has a matching release.
   */
  eol?: Maybe<EolAnalysis>;
  /** RFC3339 timestamp of the first observation on the asset. */
  firstObserved?: Maybe<Scalars["String"]["output"]>;
  /** Short enum identifying the icon for the UI, mapped from the package name. */
  iconIDEnum?: Maybe<Icon_Ids>;
  /**
   * Stable identifier — an inventory-namespace MRN
   * (`//security.api.mondoo.app/inventory/software/…`), equal to this software's
   * INSTALLED_SOFTWARE score MRN for the same asset. To look up the package's
   * finding / scores / vulnerabilities, map it back to the `/findings/` namespace
   * (server-side `FindingMrnFromInventory`).
   */
  id: Scalars["ID"]["output"];
  /** ADR-056 implementation-language facet, single-valued. */
  lang?: Maybe<Scalars["String"]["output"]>;
  /** RFC3339 timestamp of the most recent scan that re-confirmed the package. */
  lastObserved?: Maybe<Scalars["String"]["output"]>;
  /**
   * The latest version known to the MVD software catalog for this product (general freshness).
   * Catalog-limited and best-effort: null when the product isn't catalogued or the catalog is
   * unavailable — null does NOT imply the package is up to date.
   */
  latestAvailableVersion?: Maybe<Scalars["String"]["output"]>;
  /**
   * The version that fixes this package's known vulnerabilities — the advisory/VEX fixed
   * version (the latest *security* update). Null when the package is not vulnerable or no
   * fix version is known.
   */
  latestSecurityVersion?: Maybe<Scalars["String"]["output"]>;
  /** Same as id. */
  mrn: Scalars["String"]["output"];
  /**
   * Normalized, packaging-neutral product name: the curated product name when the
   * package is in the product catalog (e.g. "firefox-esr" → "Firefox"), otherwise
   * the raw package name.
   */
  name: Scalars["String"]["output"];
  /** The raw on-OS package this software was observed as (identity + detail). */
  package: SoftwarePackage;
  /**
   * The risk-category dimensions for this software on this asset (attack-surface, blast-radius,
   * business-priority, exploitability, news), aggregated from its findings — the same
   * `AggregatedRiskCategoryCount` shape the aggregate scores use. Null when there is no dimension
   * rollup (risk dimensions disabled, or a healthy package with no findings).
   */
  riskCategories?: Maybe<Array<AggregatedRiskCategoryCount>>;
  /**
   * Per-asset risk value for this software (this asset + version): 0–100, higher = worse
   * (100 - risk score). The worst of the software's active findings, rolled up alongside its
   * risk score and read straight off the row. 0 when there is no active risk or risk dimensions
   * are disabled.
   */
  riskValue: Scalars["Int"]["output"];
  /** ADR-056 delivery/behavior facets, multi-valued. */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
  /**
   * The normalized publishing organization ("Mozilla", "Red Hat"). Empty when
   * there is no publishing org (then `authors` may carry individuals). Never the
   * raw packager string (that stays on package.vendor).
   */
  vendor?: Maybe<Scalars["String"]["output"]>;
  /**
   * Normalized product version — epoch and a leading "v" stripped for display
   * ("2:1.0" → "1.0"). The raw version remains on `package.version`.
   */
  version?: Maybe<Scalars["String"]["output"]>;
  /**
   * Server-derived freshness bucket: eol | significantly_outdated | outdated |
   * slightly_outdated | up_to_date.
   */
  versionStatus?: Maybe<Scalars["String"]["output"]>;
};

/** Connection wrapping a page of SoftwareV2 entries plus pagination metadata. */
export type SoftwareV2Connection = {
  __typename: "SoftwareV2Connection";
  /** SoftwareV2 entries on this page. */
  edges?: Maybe<Array<SoftwareV2Edge>>;
  /** Pagination metadata. */
  pageInfo: PageInfo;
  /** Total number of rows matching the filter, ignoring pagination. */
  totalCount: Scalars["Int"]["output"];
};

/** A single edge in a SoftwareV2Connection — the entry plus its cursor. */
export type SoftwareV2Edge = {
  __typename: "SoftwareV2Edge";
  /** Opaque cursor that resumes pagination from this entry's position. */
  cursor: Scalars["ID"]["output"];
  /** The SoftwareV2 entry. */
  node: SoftwareV2;
};

/** SonarQube / SonarCloud configuration options */
export type SonarqubeConfigurationOptions = {
  __typename: "SonarqubeConfigurationOptions";
  /** Base URL of the SonarQube / SonarCloud instance */
  baseUrl?: Maybe<Scalars["String"]["output"]>;
  /** Whether to create assets in the backend when they are not found */
  createAssets: Scalars["Boolean"]["output"];
  /** SonarCloud organization key */
  organization?: Maybe<Scalars["String"]["output"]>;
  /** Comma-separated project keys the import is scoped to */
  projectKeys?: Maybe<Scalars["String"]["output"]>;
};

/** SonarQube / SonarCloud configuration options input */
export type SonarqubeConfigurationOptionsInput = {
  /** The SonarQube API token (write-only) */
  apiToken?: InputMaybe<Scalars["String"]["input"]>;
  /** Base URL of the SonarQube / SonarCloud instance (empty defaults to SonarCloud) */
  baseUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether to create assets in the backend when they are not found */
  createAssets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** SonarCloud organization key (optional) */
  organization?: InputMaybe<Scalars["String"]["input"]>;
  /** Comma-separated project keys to scope the import (empty imports all projects) */
  projectKeys?: InputMaybe<Scalars["String"]["input"]>;
};

/** Sources of CVEs, advisories, ... */
export type Source = {
  __typename: "Source";
  /** Source id */
  id: Scalars["String"]["output"];
  /** Source name */
  name: Scalars["String"]["output"];
  /** Source url */
  url: Scalars["String"]["output"];
};

/** Space */
export type Space = {
  __typename: "Space";
  /** Agents */
  agents?: Maybe<AgentsConnection>;
  /** Annotations */
  annotations: Array<Annotation>;
  /** Asset groups statistics */
  assetGroupStats: Array<AssetGroupStatistics>;
  /** Contacts assigned to this space */
  contacts?: Maybe<Array<ResourceContact>>;
  /** Description */
  description: Scalars["String"]["output"];
  /** ID */
  id: Scalars["ID"]["output"];
  /**
   * Inactive is true when the space has been marked inactive due to a lack of
   * scan activity. Heavy background processing is paused for inactive spaces.
   * Use the reactivateSpace mutation to mark a space active again.
   */
  inactive: Scalars["Boolean"]["output"];
  /** Members */
  members?: Maybe<MembersConnection>;
  /** List metrics for the space */
  metrics?: Maybe<MetricsResponse>;
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["output"];
  /** Name */
  name: Scalars["String"]["output"];
  /** Organization */
  organization?: Maybe<Organization>;
  /** The amount of priority findings (critical, high) in the space */
  priorityFindings: Scalars["Int"]["output"];
  /** Settings */
  settings?: Maybe<SpaceSettings>;
  /** True if the space is shared with the user */
  shared: Scalars["Boolean"]["output"];
  /**
   * Statistics
   * @deprecated Use assetGroupStats and metrics instead
   */
  stats?: Maybe<SpaceStatistics>;
  /** Tags */
  tags: Array<Tag>;
};

/** Space */
export type SpaceAgentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AgentOrder>;
};

/** Space */
export type SpaceMembersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  identitiesFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  identityTypeFilter?: InputMaybe<Array<MemberIdentityType>>;
  orderBy?: InputMaybe<MembershipOrder>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  rolesFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Space */
export type SpaceMetricsArgs = {
  endTime?: InputMaybe<Scalars["String"]["input"]>;
  metricMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  startTime?: InputMaybe<Scalars["String"]["input"]>;
};

/** An exception for an advisory that is defined on a space level */
export type SpaceAdvisoryException = {
  __typename: "SpaceAdvisoryException";
  /** CVSS information for this aggregate score (optional, only for vulns, and software) */
  cvss?: Maybe<CvssScore>;
  /** Icon identifier */
  iconId: Icon_Ids;
  /** Vulnerability ID */
  id: Scalars["String"]["output"];
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Rating */
  rating: ScoreRating;
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** An exception for a check that is defined on a space level */
export type SpaceCheckException = {
  __typename: "SpaceCheckException";
  /** Assets statistics */
  assetsStats: SpaceCheckExceptionAssetStats;
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** The MRN of the policy the check is part of */
  policyMrn: Scalars["String"]["output"];
  /** The name of the policy the check is part of */
  policyName: Scalars["String"]["output"];
  /** Rating */
  rating: ScoreRating;
  /** Risk score */
  riskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Check stats for a space */
export type SpaceCheckExceptionAssetStats = {
  __typename: "SpaceCheckExceptionAssetStats";
  /** The number of assets that errored this check */
  errored: Scalars["Int"]["output"];
  /** The number of assets that failed this check */
  failed: Scalars["Int"]["output"];
  /** The number of assets that passed this check */
  passed: Scalars["Int"]["output"];
  /** The total number of assets that were checked */
  total: Scalars["Int"]["output"];
};

/** Space connection */
export type SpaceConnection = {
  __typename: "SpaceConnection";
  /** Edges */
  edges: Array<SpaceEdge>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total amount of spaces */
  totalCount: Scalars["Int"]["output"];
};

/** Space coverage */
export type SpaceCoverage = {
  __typename: "SpaceCoverage";
  /** Monitored count */
  monitored: Scalars["Int"]["output"];
  /** Unhealthy count */
  unhealthy: Scalars["Int"]["output"];
  /** Unmonitored count */
  unmonitored: Scalars["Int"]["output"];
};

/** An exception for a CVE that is defined on a space level */
export type SpaceCveException = {
  __typename: "SpaceCveException";
  /** CVSS information for this aggregate score (optional, only for vulns, and software) */
  cvss?: Maybe<CvssScore>;
  /** Vulnerability ID */
  id: Scalars["String"]["output"];
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Rating */
  rating: ScoreRating;
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Space edge */
export type SpaceEdge = {
  __typename: "SpaceEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node: Space;
};

/** An exception for a finding exchange finding that is defined on a space level */
export type SpaceFexException = {
  __typename: "SpaceFexException";
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Rating */
  rating: ScoreRating;
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore?: Maybe<Scalars["Int"]["output"]>;
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue?: Maybe<Scalars["Int"]["output"]>;
  /** Title */
  title: Scalars["String"]["output"];
};

/** Space info */
export type SpaceInfo = {
  __typename: "SpaceInfo";
  /** Scores */
  scores: RiskDistribution;
  /** Space MRN */
  spaceMrn: Scalars["String"]["output"];
  /** Space name */
  spaceName: Scalars["String"]["output"];
  /** Space owners */
  spaceOwners: Array<Scalars["String"]["output"]>;
};

/** SpacePolicySummaryInput contains the input parameters for the spacePolicySummary query */
export type SpacePolicySummaryInput = {
  /** policyMrn is the MRN of the policy to summarize */
  policyMrn: Scalars["String"]["input"];
  /**
   * spaceMrn is the MRN of the space. Statistics will be calculated
   * for the provided policy MRN in this space.
   */
  spaceMrn: Scalars["String"]["input"];
};

/** SpacePolicySummaryPayload contains the results of the spacePolicySummary query. */
export type SpacePolicySummaryPayload = {
  __typename: "SpacePolicySummaryPayload";
  /**
   * assetGrades is the distribution of grades for the assets in the space
   * for the requested policy
   */
  assetGrades: AssetGradeDistribution;
  /** policyMrn is the MRN of the policy */
  policyMrn: Scalars["ID"]["output"];
  /** querySummaries is the list of summaries for the queries in the policy */
  querySummaries?: Maybe<SpacePolicySummaryQuerySummariesConnection>;
  /** spaceMrn is the MRN of the space */
  spaceMrn: Scalars["ID"]["output"];
};

/** SpacePolicySummaryQuerySummariesInput is the list of summaries for the queries in a policy */
export type SpacePolicySummaryQuerySummariesConnection = {
  __typename: "SpacePolicySummaryQuerySummariesConnection";
  /** Edges */
  edges?: Maybe<Array<SpacePolicySummaryQuerySummaryEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** totalCount is the total number of queries in the policy */
  totalCount: Scalars["Int"]["output"];
};

/** SpacePolicySummaryQuerySummary is the summary for a query in a policy */
export type SpacePolicySummaryQuerySummary = {
  __typename: "SpacePolicySummaryQuerySummary";
  /**
   * assetGrades is the distribution of grades for the assets in the space for
   * the query
   */
  assetGrades: AssetGradeDistribution;
  /** exception is an exception for the query if it exists */
  exception?: Maybe<MquerySummaryException>;
  /** ID */
  id: Scalars["ID"]["output"];
  /** mquery is the query */
  mquery: Mquery;
  /** mqueryState is the state of the query */
  mqueryState: MqueryState;
  /** mqueryType is the type of the query */
  mqueryType: MqueryType;
};

/** SpacePolicySummaryQuerySummaryEdge is the edge for a query summary */
export type SpacePolicySummaryQuerySummaryEdge = {
  __typename: "SpacePolicySummaryQuerySummaryEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node?: Maybe<SpacePolicySummaryQuerySummary>;
};

/** Space settings */
export type SpaceSettings = {
  __typename: "SpaceSettings";
  /** Cases configuration */
  casesConfiguration: CasesConfiguration;
  /** EOL platform configuration */
  eolAssetsConfiguration: EolAssetsConfiguration;
  /** exceptions configuration */
  exceptionsConfiguration?: Maybe<ExceptionsConfiguration>;
  /** Garbage collect assets configuration */
  garbageCollectAssetsConfiguration: GarbageCollectAssetsConfiguration;
  /** MVD experimental sources configuration */
  mvdExperimentalSourcesConfiguration: MvdExperimentalSourcesConfiguration;
  /** Platform MQL VEX configuration */
  platformMqlVexConfiguration: PlatformMqlVexConfiguration;
  /** Platform vulnerability configuration */
  platformVulnerabilityConfiguration: PlatformVulnerabilityConfiguration;
  /** RC (partially removed) packages configuration */
  rcPackagesConfiguration: RcPackagesConfiguration;
  /** Terminated assets configuration */
  terminatedAssetsConfiguration: TerminatedAssetsConfiguration;
  /** Trending CVEs configuration */
  trendingCvesConfiguration: TrendingCvesConfiguration;
  /** Unused service accounts configuration */
  unusedServiceAccountsConfiguration: UnusedServiceAccountsConfiguration;
};

/** Space settings input */
export type SpaceSettingsInput = {
  /** Cases configuration */
  casesConfiguration?: InputMaybe<CasesConfigurationInput>;
  /** EOL platform configuration */
  eolAssetsConfiguration?: InputMaybe<EolAssetsConfigurationInput>;
  /** exceptions configuration */
  exceptionsConfiguration?: InputMaybe<ExceptionsConfigurationInput>;
  /** Garbage collect assets configuration */
  garbageCollectAssetsConfiguration?: InputMaybe<GarbageCollectAssetsConfigurationInput>;
  /** MVD experimental sources configuration */
  mvdExperimentalSourcesConfiguration?: InputMaybe<MvdExperimentalSourcesConfigurationInput>;
  /** Platform MQL VEX configuration */
  platformMqlVexConfiguration?: InputMaybe<PlatformMqlVexConfigurationInput>;
  /** Platform vulnerability configuration */
  platformVulnerabilityConfiguration?: InputMaybe<PlatformVulnerabilityConfigurationInput>;
  /** RC (partially removed) packages configuration */
  rcPackagesConfiguration?: InputMaybe<RcPackagesConfigurationInput>;
  /** Terminated assets configuration */
  terminatedAssetsConfiguration?: InputMaybe<TerminatedAssetsConfigurationInput>;
  /** Trending CVEs configuration */
  trendingCvesConfiguration?: InputMaybe<TrendingCvesConfigurationInput>;
  /** Unused service accounts configuration */
  unusedServiceAccountsConfiguration?: InputMaybe<UnusedServiceAccountsConfigurationInput>;
};

/** Space statistics */
export type SpaceStatistics = {
  __typename: "SpaceStatistics";
  /** Agents */
  agents: AgentStatistics;
  /** Asset groups statistics */
  assetGroupStatistics: Array<AssetGroupStatistics>;
  /**
   * DEPRECATED
   * @deprecated Use integrationsStatistics instead
   */
  awsIntegrations: AgentStatistics;
  /** Coverage */
  coverage: SpaceCoverage;
  /**
   * DEPRECATED
   * @deprecated Use integrationsStatistics instead
   */
  integrations: AgentStatistics;
  /** Integrations statistics */
  integrationsStatistics: Array<IntegrationStatistics>;
  /** Platform distribution */
  platformdistribution?: Maybe<Array<Maybe<PlatformDistributionStats>>>;
  /** Risk distribution */
  riskdistribution: RiskDistribution;
};

/** Splunk HEC configuration options */
export type SplunkConfigurationOptions = {
  __typename: "SplunkConfigurationOptions";
  /** HEC endpoint URL, e.g. "https://prd-p-xxxx.splunkcloud.com:8088" */
  host: Scalars["String"]["output"];
  /** Splunk index to send events to, e.g. "main" or "mondoo" */
  index?: Maybe<Scalars["String"]["output"]>;
  /** Whether to skip TLS certificate verification (for self-signed certs) */
  skipTlsVerify: Scalars["Boolean"]["output"];
  /** Source identifier for events, e.g. "mondoo" */
  source?: Maybe<Scalars["String"]["output"]>;
  /** Source type for events, e.g. "mondoo:vulnerability" */
  sourcetype?: Maybe<Scalars["String"]["output"]>;
};

/** Splunk HEC integration input */
export type SplunkConfigurationOptionsInput = {
  /** HEC endpoint URL, e.g. "https://prd-p-xxxx.splunkcloud.com:8088" */
  host: Scalars["String"]["input"];
  /** Splunk index to send events to, e.g. "main" or "mondoo" */
  index?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether to skip TLS certificate verification (for self-signed certs) */
  skipTlsVerify: Scalars["Boolean"]["input"];
  /** Source identifier for events, e.g. "mondoo" */
  source?: InputMaybe<Scalars["String"]["input"]>;
  /** Source type for events, e.g. "mondoo:vulnerability" */
  sourcetype?: InputMaybe<Scalars["String"]["input"]>;
  /** HEC authentication token, e.g. "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" */
  token: Scalars["String"]["input"];
};

/** STACKIT integration */
export type StackitConfigurationOptions = {
  __typename: "StackitConfigurationOptions";
  /** The STACKIT project id being scanned. */
  projectId?: Maybe<Scalars["String"]["output"]>;
  /** The STACKIT region being scanned (e.g. eu01). */
  region?: Maybe<Scalars["String"]["output"]>;
  /**
   * The STACKIT service account key. Always null in responses — the key is stored
   * in the vault and never echoed back; a non-null value here simply indicates the
   * key is configured.
   */
  serviceAccountKey?: Maybe<Scalars["String"]["output"]>;
};

/** STACKIT integration input */
export type StackitConfigurationOptionsInput = {
  /** STACKIT project id to scan */
  projectId: Scalars["String"]["input"];
  /** STACKIT region to scan (e.g. eu01). Optional, defaults to the provider default. */
  region?: InputMaybe<Scalars["String"]["input"]>;
  /** STACKIT service account key (JSON) used to authenticate against the STACKIT API */
  serviceAccountKey: Scalars["String"]["input"];
};

/** Wrapper for string values */
export type StringValue = {
  __typename: "StringValue";
  /** String value */
  value: Scalars["String"]["output"];
};

/** Information about the current subscription */
export type SubscriptionInfo = {
  __typename: "SubscriptionInfo";
  /** Additional products in the subscription */
  additions?: Maybe<Array<ProductInfo>>;
  /** The base plan information */
  basePlan: ProductInfo;
  /** Whether the subscription is self-service */
  isSelfService: Scalars["Boolean"]["output"];
  /** Whether the subscription is pending cancellation */
  pendingCancel: Scalars["Boolean"]["output"];
  /** Utilization metrics for the subscription */
  utilizationMetrics?: Maybe<Array<UtilizationMetric>>;
};

/** Input for subscription item details */
export type SubscriptionItem = {
  /** The price ID for the subscription item */
  priceID: Scalars["String"]["input"];
  /** The quantity of the subscription item */
  quantity: Scalars["Int"]["input"];
};

/** Information about a subscription plan */
export type SubscriptionPlan = {
  __typename: "SubscriptionPlan";
  /** Additional products in the plan */
  additions?: Maybe<Array<Product>>;
  /** The base plan product */
  basePlan: Product;
  /** Whether this is the current plan */
  isCurrent: Scalars["Boolean"]["output"];
  /** Whether this is a downgrade from current plan */
  isDowngrade: Scalars["Boolean"]["output"];
  /** Whether the plan is self-service */
  isSelfService: Scalars["Boolean"]["output"];
  /** Whether this is an upgrade from current plan */
  isUpgrade: Scalars["Boolean"]["output"];
};

/** A single search suggestion */
export type Suggestion = {
  __typename: "Suggestion";
  /** The suggested value for the search */
  value: Scalars["String"]["output"];
};

/** SuppressIntegrationMessageInput contains the inputs needed to suppress (remove) an integration message */
export type SuppressIntegrationMessageInput = {
  /**
   * Optional database id of the message row, as returned in IntegrationMessage.id
   * by integrationMessages. When provided, the row in the normalized table is matched
   * directly by id; otherwise the (message, identifier) pair is used.
   */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /** The identifier of the message */
  identifier?: InputMaybe<Scalars["String"]["input"]>;
  /** The message to suppress */
  message: Scalars["String"]["input"];
  /** The MRN of the integration */
  mrn: Scalars["String"]["input"];
};

/** SuppressIntegrationMessagePayload holds the mrn of the target integration */
export type SuppressIntegrationMessagePayload = {
  __typename: "SuppressIntegrationMessagePayload";
  /** The MRN of the integration */
  mrn: Scalars["String"]["output"];
};

/** Tag */
export type Tag = {
  __typename: "Tag";
  /** The name of the tag */
  key: Scalars["String"]["output"];
  /** The value of the tag */
  value: Scalars["String"]["output"];
};

/** Tag input */
export type TagInput = {
  /** Tag key */
  key: Scalars["String"]["input"];
  /** Tag value */
  value: Scalars["String"]["input"];
};

/** Tailscale integration */
export type TailscaleConfigurationOptions = {
  __typename: "TailscaleConfigurationOptions";
  /**
   * The Tailscale OAuth client id. Populated when the integration authenticates
   * via an OAuth client; null when it authenticates via an API access token. The
   * matching client secret is stored in the vault and never echoed back.
   */
  clientId?: Maybe<Scalars["String"]["output"]>;
  /**
   * The Tailscale API access token. Always null in responses — the token is stored in
   * the vault and never echoed back; a non-null value here simply indicates the
   * token is configured.
   */
  token?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Tailscale integration input. Provide either an API access token, or an OAuth
 * client id together with its client secret.
 */
export type TailscaleConfigurationOptionsInput = {
  /**
   * Tailscale OAuth client id. Must be set together with clientSecret. Mutually
   * exclusive with token.
   */
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Tailscale OAuth client secret. Must be set together with clientId. Mutually
   * exclusive with token.
   */
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  /** Tailscale API access token. Mutually exclusive with clientId/clientSecret. */
  token?: InputMaybe<Scalars["String"]["input"]>;
};

/** A team in the system */
export type Team = Identity & {
  __typename: "Team";
  /** RFC 3339 timestamp when the team was created */
  createdAt: Scalars["String"]["output"];
  /** The description of the team */
  description: Scalars["String"]["output"];
  /** The contact email for the team */
  email?: Maybe<Scalars["String"]["output"]>;
  /** ID */
  id: Scalars["String"]["output"];
  /** List of users in this team */
  members: TeamMembersConnection;
  /** The MRN of the team */
  mrn: Scalars["String"]["output"];
  /** The name of the team */
  name: Scalars["String"]["output"];
  /** The scope MRN (organization or space) that owns this team */
  scopeMrn: Scalars["String"]["output"];
  /** RFC 3339 timestamp when the team was last updated */
  updatedAt: Scalars["String"]["output"];
};

/** A team in the system */
export type TeamMembersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** External group mapping for a team */
export type TeamExternalGroupMapping = {
  __typename: "TeamExternalGroupMapping";
  /** RFC 3339 timestamp when the mapping was created */
  createdAt: Scalars["String"]["output"];
  /** The external group ID from the identity provider */
  externalId: Scalars["String"]["output"];
  /** The MRN of the mapping */
  mrn: Scalars["String"]["output"];
  /** The team this mapping belongs to */
  team: Team;
};

/** A user in a team */
export type TeamMember = {
  __typename: "TeamMember";
  /** The email of the user */
  email: Scalars["String"]["output"];
  /** The MRN of the user (empty if user is pending) */
  mrn?: Maybe<Scalars["String"]["output"]>;
  /** The name of the user (empty if user is pending) */
  name?: Maybe<Scalars["String"]["output"]>;
};

/** Edge type for team users */
export type TeamMemberEdge = {
  __typename: "TeamMemberEdge";
  /** The cursor for this edge */
  cursor: Scalars["String"]["output"];
  /** The team user */
  node: TeamMember;
  /**
   * Roles this member holds bound directly on the team's scope (e.g.
   * team-member-manager). Empty if the member holds no team-scoped role.
   */
  roles: Array<Role>;
};

/** Connection type for team users */
export type TeamMembersConnection = {
  __typename: "TeamMembersConnection";
  /** Edges containing team users */
  edges: Array<TeamMemberEdge>;
  /** Page info for pagination */
  pageInfo: PageInfo;
  /** Total count of users in the team */
  totalCount: Scalars["Int"]["output"];
};

/** Coarse technology bucket for filtering and grouping remediations. */
export enum Technology {
  Aws = "AWS",
  Azure = "AZURE",
  Container = "CONTAINER",
  Gcp = "GCP",
  Kubernetes = "KUBERNETES",
  Linux = "LINUX",
  Macos = "MACOS",
  /** The item's platform could not be classified into one of the known buckets. */
  Unknown = "UNKNOWN",
  Windows = "WINDOWS",
}

/** Count of remediation items that would match if a Technology chip were the active selection. */
export type TechnologyFacet = {
  __typename: "TechnologyFacet";
  /** Number of items that would match if this chip were the active Technology selection. */
  count: Scalars["Int"]["output"];
  /** The technology bucket this count corresponds to. */
  technology: Technology;
};

/** Tenable configuration options */
export type TenableConfigurationOptions = {
  __typename: "TenableConfigurationOptions";
  /** The Tenable client key */
  clientKey?: Maybe<Scalars["String"]["output"]>;
  /** Whether to create assets in the backend when they are not found */
  createAssets: Scalars["Boolean"]["output"];
  /** mondooEnrichment is a flag to enable mondoo scans based on the Tenable data */
  mondooEnrichment?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Tenable configuration options input */
export type TenableConfigurationOptionsInput = {
  /** The Tenable client key */
  clientKey?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether to create assets in the backend when they are not found */
  createAssets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** mondooEnrichment is a flag to enable mondoo scans based on the Tenable data */
  mondooEnrichment?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The Tenable secret key */
  secretKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** Tenable SC configuration options */
export type TenableScConfigurationOptions = {
  __typename: "TenableSCConfigurationOptions";
  /** The access key for the Tenable SC API */
  accessKey?: Maybe<Scalars["String"]["output"]>;
  /** Allow connections to servers with self-signed or untrusted TLS certificates */
  allowInsecureTls: Scalars["Boolean"]["output"];
  /** Whether to create assets in the backend when they are not found */
  createAssets: Scalars["Boolean"]["output"];
  /** Optional comma-separated repository IDs to filter vulnerabilities */
  repositoryIds?: Maybe<Scalars["String"]["output"]>;
  /** The base URL for the Tenable SC server (e.g., https://tenablesc.example.com/rest) */
  serverUrl?: Maybe<Scalars["String"]["output"]>;
};

/** Tenable SC configuration options input */
export type TenableScConfigurationOptionsInput = {
  /** The access key for the Tenable SC API */
  accessKey?: InputMaybe<Scalars["String"]["input"]>;
  /** Allow connections to servers with self-signed or untrusted TLS certificates */
  allowInsecureTls?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether to create assets in the backend when they are not found */
  createAssets?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Optional comma-separated repository IDs to filter vulnerabilities */
  repositoryIds?: InputMaybe<Scalars["String"]["input"]>;
  /** The secret key for the Tenable SC API */
  secretKey?: InputMaybe<Scalars["String"]["input"]>;
  /** The base URL for the Tenable SC server (e.g., https://tenablesc.example.com/rest) */
  serverUrl?: InputMaybe<Scalars["String"]["input"]>;
};

/** Terminated assets configuration */
export type TerminatedAssetsConfiguration = {
  __typename: "TerminatedAssetsConfiguration";
  /** After how many days to cleanup */
  after: Scalars["Int"]["output"];
  /** Whether to cleanup terminated assets */
  cleanup: Scalars["Boolean"]["output"];
};

/** Terminated assets configuration input */
export type TerminatedAssetsConfigurationInput = {
  /** Whether to cleanup terminated assets */
  cleanup?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input for testing a credential's health. */
export type TestCredentialInput = {
  /** MRN of the credential to test. */
  mrn: Scalars["ID"]["input"];
};

/** Result of a credential health check. */
export type TestCredentialPayload = {
  __typename: "TestCredentialPayload";
  /** Error message if the health check failed. */
  error?: Maybe<Scalars["String"]["output"]>;
  /** Whether the credential authenticated successfully. */
  healthy: Scalars["Boolean"]["output"];
};

/** Fetch Jira ticket context information. */
export type TicketContextInput = {
  /** Azure Devops ticket context parameters. */
  azureDevops?: InputMaybe<AzureDevopsTicketContextInput>;
  /** Jira ticket context parameters. */
  jira?: InputMaybe<JiraTicketContextInput>;
  /** The MRN of the scope for which the context is fetched. */
  scopeMrn: Scalars["String"]["input"];
  /** Zendesk ticket context parmeters. */
  zendesk?: InputMaybe<ZendeskTicketContextInput>;
};

/** The payload for the ticket context. */
export type TicketContextPayload =
  | AzureDevopsTicketContextProjectsPayload
  | EmailTicketContextPayload
  | JiraTicketContextProjectsPayload
  | JiraTicketContextUsersPayload
  | ZendeskTicketContextFieldsPayload;

/** Ticket reference */
export type TicketRef = {
  __typename: "TicketRef";
  /** Integration MRN */
  integrationMrn: Scalars["String"]["output"];
  /** Ticket identifier. Only set if a ticket has been created. */
  ticketId?: Maybe<Scalars["String"]["output"]>;
  /** Type */
  type: TicketRefType;
  /** Ticket URL. Only set if a ticket has been created. */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Ticket reference type */
export enum TicketRefType {
  AzureDevops = "AZURE_DEVOPS",
  Email = "EMAIL",
  Github = "GITHUB",
  Gitlab = "GITLAB",
  Jira = "JIRA",
  ServiceNow = "SERVICE_NOW",
  Unknown = "UNKNOWN",
  Webhook = "WEBHOOK",
  Zendesk = "ZENDESK",
}

/** TicketingIntegrationsInput describes the input for listing ticketing integrations */
export type TicketingIntegrationsInput = {
  spaceMrn: Scalars["String"]["input"];
};

/** TicketingIntegrationsPayload is the response to a list of ticketing integrations */
export type TicketingIntegrationsPayload = {
  __typename: "TicketingIntegrationsPayload";
  /** The list of ticketing integrations */
  integrations: Array<Maybe<ClientIntegration>>;
};

/** Time Range */
export type TimeRange = {
  /** Lower bound of the time range. Must be valid RFC 3339 timestamp */
  from?: InputMaybe<Scalars["String"]["input"]>;
  /** Upper bound of the time range. Must be valid RFC 3339 timestamp */
  to?: InputMaybe<Scalars["String"]["input"]>;
};

/** Time range suggestion value */
export type TimeRangeValue = {
  __typename: "TimeRangeValue";
  /** Lower bound of the time range. RFC 3339 timestamp */
  from?: Maybe<Scalars["String"]["output"]>;
  /** Upper bound of the time range. RFC 3339 timestamp */
  to?: Maybe<Scalars["String"]["output"]>;
};

/** Timestamp filter */
export type TimestampFilter = {
  /** Comparison operator */
  operator: ComparisonOperator;
  /** RFC3339 timestamp */
  timestamp: Scalars["String"]["input"];
};

/** Timestamp filter suggestion value */
export type TimestampFilterValue = {
  __typename: "TimestampFilterValue";
  /** Comparison operator */
  operator: ComparisonOperator;
  /** RFC3339 timestamp */
  timestamp: Scalars["String"]["output"];
};

/** Trending CVEs configuration */
export type TrendingCvesConfiguration = {
  __typename: "TrendingCvesConfiguration";
  /**
   * Whether the trending-CVE bypass is disabled. When true, trending CVEs from
   * experimental sources the space hasn't enabled stay hidden. Default false
   * keeps the bypass on.
   */
  disable: Scalars["Boolean"]["output"];
};

/** Trending CVEs configuration input */
export type TrendingCvesConfigurationInput = {
  /**
   * Whether to disable the trending-CVE bypass. When true, trending CVEs from
   * experimental sources the space hasn't enabled stay hidden. Default false
   * keeps the bypass on.
   */
  disable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Inputs used to trigger an action on a client integration */
export type TriggerActionInput = {
  actionOptions?: InputMaybe<TriggerActionOptionsInput>;
  mrn: Scalars["String"]["input"];
  type: ActionType;
};

/** Inputs options used to trigger an action on a client integration */
export type TriggerActionOptionsInput = {
  /** Optional - AWS scan options. */
  awsScanOptions?: InputMaybe<AwsScanOptions>;
  /** Optional source identifier, e.g. AWS account id. */
  identifiers?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Response when triggering action on client integration */
export type TriggerActionPayload = {
  __typename: "TriggerActionPayload";
  /** The MRN of the client integration for which the action was triggered */
  mrn: Scalars["String"]["output"];
};

/** Input for triggering an ad-hoc audit log export. */
export type TriggerAuditLogExportInput = {
  /** Optional: only include logs before this RFC3339 timestamp. */
  endTime?: InputMaybe<Scalars["String"]["input"]>;
  /** Output format: CSV or JSONL (OCSF). */
  format: DocumentFormat;
  /** The organization or space MRN to export audit logs for. */
  scopeMrn: Scalars["String"]["input"];
  /** Optional: only include logs at or after this RFC3339 timestamp. */
  startTime?: InputMaybe<Scalars["String"]["input"]>;
};

/** Response from triggering an audit log export. */
export type TriggerAuditLogExportPayload = {
  __typename: "TriggerAuditLogExportPayload";
  /** The MRN of the document being generated — use with requestDocumentDownloadUrl. */
  documentMrn: Scalars["String"]["output"];
};

/** Input for triggering regeneration of the asset interconnection graph */
export type TriggerInterconnectionGraphRegenerationInput = {
  /** The organization MRN to regenerate the graph for */
  orgMrn: Scalars["String"]["input"];
};

/** Input for triggering a workflow execution. */
export type TriggerWorkflowInput = {
  /** Run without side effects. */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Runtime variable values for this execution. */
  triggerData?: InputMaybe<Scalars["Map"]["input"]>;
  /** MRN of the workflow to trigger. */
  workflowMrn: Scalars["ID"]["input"];
};

/** Result of triggering a workflow execution. */
export type TriggerWorkflowPayload = {
  __typename: "TriggerWorkflowPayload";
  /** MRN of the new execution. */
  executionMrn: Scalars["ID"]["output"];
  /** Temporal run ID for debugging. */
  temporalRunId?: Maybe<Scalars["ID"]["output"]>;
};

/** Trust level of the object */
export enum TrustLevel {
  All = "ALL",
  Official = "OFFICIAL",
  Oss = "OSS",
  Private = "PRIVATE",
  VerifiedPublisher = "VERIFIED_PUBLISHER",
}

/** The action taken in the UI */
export enum UiAction {
  /** Download/export of a compliance report (framework or control scope) */
  ComplianceReportDownload = "COMPLIANCE_REPORT_DOWNLOAD",
  /** Generation of an executive report */
  ExecutiveReportGenerate = "EXECUTIVE_REPORT_GENERATE",
  /** Login button on private instance clicked */
  PrivateinstanceLogin = "PRIVATEINSTANCE_LOGIN",
  /** Copy of remediation text */
  RemediationCopy = "REMEDIATION_COPY",
  /** Download of one or more remediations (scripts) as a file */
  RemediationDownload = "REMEDIATION_DOWNLOAD",
  /** Remediation is missing for a finding */
  RemediationMissing = "REMEDIATION_MISSING",
  /** Remediation is shown (available) for a finding — the positive counterpart to REMEDIATION_MISSING */
  RemediationShown = "REMEDIATION_SHOWN",
  /** A viewed finding is sourced from a third-party scanner (vs Mondoo-native / cnspec) */
  ThirdPartyFindingView = "THIRD_PARTY_FINDING_VIEW",
  /** Finding or asset or dashboard view */
  View = "VIEW",
}

/** The page in the UI where the action was taken */
export enum UiPage {
  /** Asset detail page */
  Asset = "ASSET",
  /** CI/CD job page */
  CicdJob = "CICD_JOB",
  /** CI/CD project page */
  CicdProject = "CICD_PROJECT",
  /** Compliance control detail page */
  ComplianceControl = "COMPLIANCE_CONTROL",
  /** Compliance controls list for a framework */
  ComplianceControls = "COMPLIANCE_CONTROLS",
  /** Compliance control exceptions tab */
  ComplianceControlExceptions = "COMPLIANCE_CONTROL_EXCEPTIONS",
  /** Compliance dashboard page */
  ComplianceDashboard = "COMPLIANCE_DASHBOARD",
  /** Compliance framework detail page */
  ComplianceFramework = "COMPLIANCE_FRAMEWORK",
  /** Compliance framework assets tab */
  ComplianceFrameworkAssets = "COMPLIANCE_FRAMEWORK_ASSETS",
  /** Compliance framework exceptions tab */
  ComplianceFrameworkExceptions = "COMPLIANCE_FRAMEWORK_EXCEPTIONS",
  /** Compliance framework policies tab */
  ComplianceFrameworkPolicies = "COMPLIANCE_FRAMEWORK_POLICIES",
  /** Executive report generation wizard */
  ExecutiveReport = "EXECUTIVE_REPORT",
  /** Finding detail page (not in asset context) */
  Finding = "FINDING",
  /** Finding viewed in the context of an asset */
  FindingOnAsset = "FINDING_ON_ASSET",
  /** Organization dashboard page */
  OrgDashboard = "ORG_DASHBOARD",
  /** Vulnerable software finding detail page */
  Software = "SOFTWARE",
  /** Software finding detail page viewed in the context of an asset */
  SoftwareOnAsset = "SOFTWARE_ON_ASSET",
  /** Space dashboard page */
  SpaceDashboard = "SPACE_DASHBOARD",
  /** Unknown or unspecified page */
  Unknown = "UNKNOWN",
}

/** An asset that could not be routed during scope-level sync. */
export type UnroutableAsset = {
  __typename: "UnroutableAsset";
  /** Timestamp when the unroutable asset was recorded. */
  createdAt: Scalars["String"]["output"];
  /** Asset labels as key-value pairs. */
  labels?: Maybe<Array<KeyValue>>;
  /** Human-readable asset name. */
  name: Scalars["String"]["output"];
  /** Platform-specific asset identifiers. */
  platformIds: Array<Scalars["String"]["output"]>;
  /** Platform name reported by the asset. */
  platformName: Scalars["String"]["output"];
};

/** Paginated connection of unroutable assets. */
export type UnroutableAssetConnection = {
  __typename: "UnroutableAssetConnection";
  /** List of unroutable asset edges. */
  edges: Array<UnroutableAssetEdge>;
  /** Pagination information. */
  pageInfo: PageInfo;
};

/** Edge in the unroutable assets connection. */
export type UnroutableAssetEdge = {
  __typename: "UnroutableAssetEdge";
  /** The unroutable asset. */
  node: UnroutableAsset;
};

/** Unused service accounts configuration */
export type UnusedServiceAccountsConfiguration = {
  __typename: "UnusedServiceAccountsConfiguration";
  /** After how many days to cleanup */
  after: Scalars["Int"]["output"];
  /** Whether to cleanup unused service accounts */
  cleanup: Scalars["Boolean"]["output"];
};

/** Unused service accounts configuration input */
export type UnusedServiceAccountsConfigurationInput = {
  /** Whether to cleanup unused service accounts */
  cleanup?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input used when updating an API token name or description */
export type UpdateApiTokenInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  mrn: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Inputs for updating agents */
export type UpdateAgentInput = {
  /** The MRN of the agent */
  agentMrn: Scalars["String"]["input"];
  /** The notes of the agent */
  notes?: InputMaybe<Scalars["String"]["input"]>;
};

/** Response when updating an agent */
export type UpdateAgentPayload = {
  __typename: "UpdateAgentPayload";
  /** The agent that was updated */
  agent: Agent;
};

/** Input for updating an existing asset routing rule. */
export type UpdateAssetRoutingRuleInput = {
  /**
   * Conditions that must all match for this rule to apply. Leave empty for
   * wildcard rules.
   */
  conditions: Array<AssetRoutingConditionInput>;
  /** Priority for rule ordering (lower values evaluated first). */
  priority: Scalars["Int"]["input"];
  /** MRN of the routing rule to update. */
  ruleMrn: Scalars["String"]["input"];
  /**
   * MRN of the target space for matching assets. Leave empty for wildcard
   * rules.
   */
  targetSpaceMrn: Scalars["String"]["input"];
  /**
   * Wildcard routing config. When set, this rule derives the target space
   * from a tag on each asset. Platform scope only; if present, must be the
   * only rule in the scope.
   */
  wildcard?: InputMaybe<WildcardRoutingConfigInput>;
};

/** Input for updating BI dashboard metadata. */
export type UpdateBiDashboardInput = {
  /** New description (null means no change) */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Dashboard MRN */
  mrn: Scalars["String"]["input"];
  /** New title (null means no change) */
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for updating BI tag configuration. */
export type UpdateBiTagConfigInput = {
  /** Scope MRN (organization or space) */
  scopeMrn: Scalars["String"]["input"];
  /** SLA tier configuration as JSON */
  slaTiers?: InputMaybe<Scalars["Map"]["input"]>;
  /** Annotation/label keys to expose as cube dimensions */
  tagKeys: Array<Scalars["String"]["input"]>;
};

/** Input for updating a client integration */
export type UpdateClientIntegrationConfigurationInput = {
  /**
   * Annotations applied to every asset discovered by this integration's scans.
   * Only meaningful for hosted scan-job integration types; ignored for
   * ticketing/export/import types.
   */
  annotations?: InputMaybe<Array<KeyValueInput>>;
  configurationOptions: ClientIntegrationConfigurationInput;
  /**
   * Labels are arbitrary key/value metadata on the integration itself, used for
   * routing, filtering, and grouping integrations — distinct from `annotations`,
   * which tag the assets an integration discovers. Any integration type may carry
   * them. For example, a Network Discovery Collector's labels are its tags, and a
   * Network Scan routes jobs to collectors carrying a matching label.
   */
  labels?: InputMaybe<Array<KeyValueInput>>;
  mrn: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  type: ClientIntegrationType;
};

/** Response when updating client integration */
export type UpdateClientIntegrationConfigurationPayload = {
  __typename: "UpdateClientIntegrationConfigurationPayload";
  /** The configuration options for the updated client integration */
  configurationOptions: ClientIntegrationConfigurationOptions;
  /** The name of the updated client integration */
  name: Scalars["String"]["output"];
};

/** Update findings SLA input */
export type UpdateFindingsSlaInput = {
  /** The number of days before a warning is issued */
  daysBeforeWarning: Scalars["Int"]["input"];
  /** The target number of days to resolve a finding */
  daysToResolve: Scalars["Int"]["input"];
  /** The rating to which this SLA applies */
  rating: ScoreRating;
};

/** Update organization input */
export type UpdateOrganizationInput = {
  /** Annotations */
  annotations?: InputMaybe<Array<AnnotationInput>>;
  /** Company name */
  company?: InputMaybe<Scalars["String"]["input"]>;
  /** Contacts */
  contacts?: InputMaybe<Array<ResourceContactInput>>;
  /** Description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** MRN */
  mrn: Scalars["String"]["input"];
  /** Name */
  name: Scalars["String"]["input"];
  /** Settings */
  settings?: InputMaybe<OrganizationSettingsInput>;
  /** Tags */
  tags?: InputMaybe<Array<TagInput>>;
};

/** Update organization payload */
export type UpdateOrganizationPayload = {
  __typename: "UpdateOrganizationPayload";
  /** Organization */
  organization: Organization;
};

/** Update SLAs input */
export type UpdateSlAsInput = {
  /** SLAs for findings */
  findings: Array<UpdateFindingsSlaInput>;
  /** How findings are classified into SLA severity buckets (default: RISK) */
  ratingSource?: InputMaybe<SlaRatingSource>;
  /** When the SLA timer should start (default: CVE_DETECTED) */
  startDateConfig?: InputMaybe<SlaStartDateConfig>;
};

/** Update security model input */
export type UpdateSecurityModelInput = {
  /** The mrn of the space */
  scopeMrn: Scalars["String"]["input"];
  /** SLAs */
  slas?: InputMaybe<UpdateSlAsInput>;
};

/** Update a security pipeline scheduled workflow. */
export type UpdateSecurityPipelineScheduledWorkflowInput = {
  /** The configuration for the scheduled workflow. */
  configuration?: InputMaybe<SecurityPipelineScheduledWorkflowConfigurationInput>;
  /** The MRN of the scheduled workflow to update. */
  mrn: Scalars["String"]["input"];
  /** The selection criteria for the scheduled workflow. */
  selection?: InputMaybe<SecurityPipelineScheduledWorkflowSelectionInput>;
  /** The title of the scheduled workflow. */
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/** Update a security pipeline scheduled workflow. */
export type UpdateSecurityPipelineScheduledWorkflowResponse = {
  __typename: "UpdateSecurityPipelineScheduledWorkflowResponse";
  /** Information about the updated workflow. */
  workflow: SecurityPipelineScheduledWorkflow;
};

/** Input used when updating service account name, notes, and labels */
export type UpdateServiceAccountInput = {
  labels?: InputMaybe<Array<InputMaybe<KeyValueInput>>>;
  mrn: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
};

/** Update space input */
export type UpdateSpaceInput = {
  /** Annotations */
  annotations?: InputMaybe<Array<AnnotationInput>>;
  /** Contacts */
  contacts?: InputMaybe<Array<ResourceContactInput>>;
  /** Description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** MRN */
  mrn: Scalars["String"]["input"];
  /** Name */
  name: Scalars["String"]["input"];
  /** Settings */
  settings?: InputMaybe<SpaceSettingsInput>;
  /** Tags */
  tags?: InputMaybe<Array<TagInput>>;
};

/** Update space payload */
export type UpdateSpacePayload = {
  __typename: "UpdateSpacePayload";
  /** Space */
  space: Space;
};

/** Input for updating a team */
export type UpdateTeamInput = {
  /** The description of the team */
  description: Scalars["String"]["input"];
  /** The contact email for the team */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** The MRN of the team to update */
  mrn: Scalars["String"]["input"];
  /** The name of the team */
  name: Scalars["String"]["input"];
};

/** Input for updating user information */
export type UpdateUserInput = {
  /** The name of the user */
  name: Scalars["String"]["input"];
};

/** Response when updating a user */
export type UpdateUserPayload = {
  __typename: "UpdateUserPayload";
  /** The updated user */
  user: User;
};

/** Input for updating a workflow. */
export type UpdateWorkflowInput = {
  /** Updated credential bindings. */
  credentialBindings?: InputMaybe<Scalars["Map"]["input"]>;
  /** New description. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Enable or disable the workflow. */
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** MRN of the workflow to update. */
  mrn: Scalars["ID"]["input"];
  /** New display name. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** New lifecycle status. */
  status?: InputMaybe<Scalars["String"]["input"]>;
  /** Updated YAML definition. */
  yaml?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for updating a workflow node. */
export type UpdateWorkflowNodeInput = {
  /** Updated action. */
  action?: InputMaybe<Scalars["String"]["input"]>;
  /** Updated comment. */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** Updated credential mapping for execute_workflow nodes (ADR-047). */
  credentials?: InputMaybe<Scalars["Map"]["input"]>;
  /** Enable or disable the node. */
  disabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Updated expression. */
  expression?: InputMaybe<Scalars["String"]["input"]>;
  /** Updated input mapping for execute_workflow nodes (ADR-047). */
  input?: InputMaybe<Scalars["Map"]["input"]>;
  /** Updated label. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** ID of the node to update. */
  nodeId: Scalars["ID"]["input"];
  /** Updated error handling strategy. */
  onError?: InputMaybe<Scalars["String"]["input"]>;
  /** Updated action parameters. */
  params?: InputMaybe<Scalars["Map"]["input"]>;
  /** Updated plugin. */
  plugin?: InputMaybe<Scalars["String"]["input"]>;
  /** Updated timeout. */
  timeout?: InputMaybe<Scalars["String"]["input"]>;
  /** MRN of the workflow containing the node. */
  workflowMrn: Scalars["ID"]["input"];
};

/** Result of updating a workflow node. */
export type UpdateWorkflowNodePayload = {
  __typename: "UpdateWorkflowNodePayload";
  /** The workflow with the updated node. */
  workflow: Workflow;
};

/** Result of updating a workflow. */
export type UpdateWorkflowPayload = {
  __typename: "UpdateWorkflowPayload";
  /** The updated workflow. */
  workflow: Workflow;
};

/** Input for updating node positions. */
export type UpdateWorkflowPositionsInput = {
  /** Position updates. */
  positions: Array<NodePositionInput>;
  /** MRN of the workflow to modify. */
  workflowMrn: Scalars["ID"]["input"];
};

/** Result of updating node positions. */
export type UpdateWorkflowPositionsPayload = {
  __typename: "UpdateWorkflowPositionsPayload";
  /** The workflow with updated positions. */
  workflow: Workflow;
};

/** Input for updating a workflow resource. */
export type UpdateWorkflowResourceInput = {
  /** Resource key. */
  name: Scalars["String"]["input"];
  /** MRN of the scope containing the resource. */
  scopeMrn: Scalars["ID"]["input"];
  /** New value. */
  value: Scalars["String"]["input"];
};

/** Result of updating a workflow resource. */
export type UpdateWorkflowResourcePayload = {
  __typename: "UpdateWorkflowResourcePayload";
  /** The updated resource. */
  resource: WorkflowResource;
};

/** Input for updating a workflow schedule. */
export type UpdateWorkflowScheduleInput = {
  /** New cron expression. */
  cronExpression?: InputMaybe<Scalars["String"]["input"]>;
  /** MRN of the schedule to update. */
  mrn: Scalars["ID"]["input"];
  /** Pause or unpause the schedule. */
  paused?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Result of updating a workflow schedule. */
export type UpdateWorkflowSchedulePayload = {
  __typename: "UpdateWorkflowSchedulePayload";
  /** The updated schedule. */
  schedule: WorkflowSchedule;
};

/** Update workspace input */
export type UpdateWorkspaceInput = {
  /** Contacts */
  contacts?: InputMaybe<Array<ResourceContactInput>>;
  /** Description of the workspace */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** MRN */
  mrn: Scalars["String"]["input"];
  /** The name of the workspace */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Workspace selections */
  selections?: InputMaybe<WorkspaceSelectionsInput>;
};

/** Upload framework input */
export type UploadFrameworkInput = {
  /** RFC2397, base64 encoded policy bundle */
  dataurl: Scalars["String"]["input"];
  /** The mrn of the space to which the framework belongs */
  spaceMrn: Scalars["String"]["input"];
};

/** A user in the system */
export type User = Identity & {
  __typename: "User";
  /** The datetime when the user was created */
  createdAt?: Maybe<Scalars["String"]["output"]>;
  /** The email of the identity */
  email?: Maybe<Scalars["String"]["output"]>;
  /** The first space the identity is a member of */
  firstSpace?: Maybe<Space>;
  /**
   * The Github user linked to the Mondoo user. Only set if the user paired
   * their account with Github.
   */
  githubUser?: Maybe<Scalars["String"]["output"]>;
  /** The Mondoo Resource Name (MRN) uniquely identifies each identity. */
  mrn: Scalars["String"]["output"];
  /** The name of the identity */
  name: Scalars["String"]["output"];
  /** The organizations the identity is a member of */
  organizations?: Maybe<Array<Organization>>;
  /** The spaces the identity is a member of */
  spaces?: Maybe<Array<Space>>;
  /** The SSH keys of the identity */
  sshKeys?: Maybe<Array<SshKey>>;
  /** The state of the identity */
  state?: Maybe<UserState>;
};

/** A user setting key-value pair */
export type UserSetting = {
  __typename: "UserSetting";
  /** The key of the setting */
  key: Scalars["String"]["output"];
  /** The value of the setting */
  value: Scalars["String"]["output"];
};

/** User shared space edge */
export type UserSharedSpaceEdge = {
  __typename: "UserSharedSpaceEdge";
  /** Cursor */
  cursor: Scalars["ID"]["output"];
  /** Node */
  node: Space;
};

/** User shared spaces connection */
export type UserSharedSpacesConnection = {
  __typename: "UserSharedSpacesConnection";
  /** Edges */
  edges?: Maybe<Array<UserSharedSpaceEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** State of a user */
export enum UserState {
  Enabled = "ENABLED",
  Unknown = "UNKNOWN",
  Waitlisted = "WAITLISTED",
}

/** Metric showing utilization of subscription resources */
export type UtilizationMetric = {
  __typename: "UtilizationMetric";
  /** The description of the metric */
  description: Scalars["String"]["output"];
  /** The key identifier for the metric */
  key: Scalars["String"]["output"];
  /** The limit for the metric (if applicable) */
  limit?: Maybe<Scalars["Int"]["output"]>;
  /** The name of the metric */
  name: Scalars["String"]["output"];
  /** The units for the metric */
  units: Scalars["String"]["output"];
  /** The current value of the metric */
  value: Scalars["Int"]["output"];
};

/** VPCConfiguration describes the options for the VPCs used for the scanners */
export type VpcConfiguration = {
  __typename: "VPCConfiguration";
  /** The CIDR of the VPC */
  CIDR?: Maybe<Scalars["String"]["output"]>;
  /**
   * Whether to use the default VPC
   * @deprecated Will be removed in the future
   */
  useDefaultVPC?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Whether to use the Mondoo VPC
   * @deprecated Will be removed in the future
   */
  useMondooVPC?: Maybe<Scalars["Boolean"]["output"]>;
  /** The flavour of the VPC */
  vpcFlavour?: Maybe<VpcFlavour>;
  /** The tag of the VPC */
  vpcTag?: Maybe<VpcTag>;
};

/**
 * VPCConfigurationInput describes the options for the VPCs used for the scanners. Setting useDefaultVPC to true will create the mondoo scanners in the
 * AWS account default VPC. Setting useDefaultVPC to false will lead to the lambda function creating the VPC for the scanners in each scanning region.
 */
export type VpcConfigurationInput = {
  /** The CIDR of the VPC */
  CIDR?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Whether to use the default VPC
   * @deprecated Will be removed in the future
   */
  useDefaultVPC?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Whether to use the Mondoo VPC
   * @deprecated Will be removed in the future
   */
  useMondooVPC?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The flavour of the VPC */
  vpcFlavour?: InputMaybe<VpcFlavour>;
  /** The tag of the VPC */
  vpcTag?: InputMaybe<VpcTagInput>;
};

/** Describes flavour of the VPC for AWS Serverless Scanners */
export enum VpcFlavour {
  CustomVpc = "CUSTOM_VPC",
  DefaultVpc = "DEFAULT_VPC",
  MondooIgw = "MONDOO_IGW",
  MondooNatgw = "MONDOO_NATGW",
}

/** VPCTag represents a key-value pair for VPC tagging */
export type VpcTag = {
  __typename: "VPCTag";
  /** The key of the tag */
  key: Scalars["String"]["output"];
  /** The value of the tag */
  value: Scalars["String"]["output"];
};

/** VPCTagInput represents input for a key-value pair for VPC tagging */
export type VpcTagInput = {
  /** The key of the tag */
  key: Scalars["String"]["input"];
  /** The value of the tag */
  value: Scalars["String"]["input"];
};

/** Input for validating a workflow YAML. */
export type ValidateWorkflowInput = {
  /** YAML content to validate. */
  yaml: Scalars["String"]["input"];
};

/** Result of validating a workflow YAML. */
export type ValidateWorkflowPayload = {
  __typename: "ValidateWorkflowPayload";
  /** Validation errors, if any. */
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Whether the YAML is valid. */
  valid: Scalars["Boolean"]["output"];
};

/** Time window for policy group validity. Dates in RFC 3339 format. */
export type ValidityWindow = {
  __typename: "ValidityWindow";
  /** End of validity window - when preview becomes enforcing (RFC 3339 format) */
  until?: Maybe<Scalars["String"]["output"]>;
};

/** Variant */
export type Variant = {
  __typename: "Variant";
  /** Icon */
  icon: Scalars["String"]["output"];
  /** Used for icons and filtering, variant id == code id */
  id: Scalars["ID"]["output"];
  /** The mrn is a unique identifier */
  mrn: Scalars["String"]["output"];
  /** The title */
  title: Scalars["String"]["output"];
};

/**
 * Describes a filter that can be used to filter a policies variants
 * by platform
 */
export type VariantPlatformFilter = {
  __typename: "VariantPlatformFilter";
  /** Icon */
  icon: Scalars["String"]["output"];
  /** Used for filtering */
  id: Scalars["ID"]["output"];
  /** The title */
  title: Scalars["String"]["output"];
};

/** Version distribution */
export type VersionDistribution = {
  __typename: "VersionDistribution";
  /** Total number of assets (all assets, noit only the onces with this software installed) */
  assets: Scalars["Int"]["output"];
  /** Version distribution */
  distribution?: Maybe<Array<VersionDistributionEntry>>;
  /** Total number of installs across all versions and independent of score */
  installations: Scalars["Int"]["output"];
  /** Total number of versions (not distinct) */
  total: Scalars["Int"]["output"];
};

/** Version distribution entry */
export type VersionDistributionEntry = {
  __typename: "VersionDistributionEntry";
  /** Number of assets with this version */
  count: Scalars["Int"]["output"];
  /** Risk score ranging between 0 - 100, calculated based on base score and risk factors */
  riskScore: Scalars["Int"]["output"];
  /** Risk score rating */
  riskScoreRating: ScoreRating;
  /** Risk Value is 100 - riskScore. This means that a 0 is no risk and 100 is the highest risk */
  riskValue: Scalars["Int"]["output"];
  /** Version */
  version: Scalars["String"]["output"];
};

/** Vulnerabilities */
export type Vulnerabilities = {
  __typename: "Vulnerabilities";
  /** number of critical vulnerabilities */
  critical: Scalars["Int"]["output"];
  /** date */
  date: Scalars["String"]["output"];
  /** number of high vulnerabilities */
  high: Scalars["Int"]["output"];
};

/** Vulnerabilities by space */
export type VulnerabilitiesPerSpace = {
  __typename: "VulnerabilitiesPerSpace";
  /** number of affected assets */
  amountAssets: Scalars["Int"]["output"];
  /** space mrn */
  spaceMrn: Scalars["String"]["output"];
  /** space name */
  spaceName: Scalars["String"]["output"];
  /** space owners */
  spaceOwners: Array<Scalars["String"]["output"]>;
};

/** Vuln Dashboard pagination info */
export type VulnerabilityDashboardPageInfo = {
  /** organization mrn */
  orgMrn: Scalars["String"]["input"];
  /** space mrn */
  spaceMrn: Scalars["String"]["input"];
};

/** Input options for the vulnerability of the document */
export type VulnerabilityDocumentOptionsInput = {
  /** The MRN of the scope to generate the report for */
  scopeMrn: Scalars["String"]["input"];
  /** The ID of the vulnerability to generate the report for */
  vulnerabilityId: Scalars["String"]["input"];
};

/** Vulnerability exploit information. */
export type VulnerabilityExploit = {
  __typename: "VulnerabilityExploit";
  /** Detailed vulnerability information. */
  details?: Maybe<VulnerabilityExploitDetails>;
  /** CVE or Advisory ID. */
  id: Scalars["String"]["output"];
  /** Unique reference identifier for this exploit. */
  ref: Scalars["String"]["output"];
  /** References for the vulnerability. */
  references?: Maybe<Array<Reference>>;
  /** Source of the vulnerability data. */
  source?: Maybe<VulnerabilityExploitSource>;
  /** Summary of the vulnerability. */
  summary: Scalars["String"]["output"];
};

/** A connection to a list of vulnerability exploits. */
export type VulnerabilityExploitConnection = {
  __typename: "VulnerabilityExploitConnection";
  /** The edges in this connection. */
  edges?: Maybe<Array<VulnerabilityExploitEdge>>;
  /** Pagination info. */
  pageInfo: PageInfo;
  /** Total count of vulnerability exploit entries. */
  totalCount: Scalars["Int"]["output"];
};

/** Detailed information about a vulnerability. */
export type VulnerabilityExploitDetails = {
  __typename: "VulnerabilityExploitDetails";
  /** When the vulnerability was created. */
  created: Scalars["String"]["output"];
  /** Description of the vulnerability. */
  details: Scalars["String"]["output"];
  /** When the vulnerability was published. */
  published: Scalars["String"]["output"];
  /** Recommendation for remediation. */
  recommendation: Scalars["String"]["output"];
  /** When the vulnerability was last updated. */
  updated: Scalars["String"]["output"];
  /** Workaround for the vulnerability. */
  workaround: Scalars["String"]["output"];
};

/** An edge in a vulnerability exploit connection. */
export type VulnerabilityExploitEdge = {
  __typename: "VulnerabilityExploitEdge";
  /** A cursor used for pagination. */
  cursor: Scalars["ID"]["output"];
  /** The vulnerability exploit node. */
  node?: Maybe<VulnerabilityExploit>;
};

/** Ordering options for vulnerability exploit. */
export type VulnerabilityExploitOrder = {
  /** Order direction. */
  direction: OrderDirection;
  /** Order field. */
  field?: InputMaybe<VulnerabilityExploitOrderField>;
};

/** Order field for vulnerability exploit. */
export enum VulnerabilityExploitOrderField {
  Id = "ID",
}

/** Source of a vulnerability exploit. */
export type VulnerabilityExploitSource = {
  __typename: "VulnerabilityExploitSource";
  /** Name of the source. */
  name: Scalars["String"]["output"];
  /** Typed source identifier. OTHER when the upstream source is not enumerated. */
  type: ExploitSource;
  /** URL of the source. */
  url: Scalars["String"]["output"];
};

/** Vulnerability Details */
export type VulnerabilityInfo = {
  __typename: "VulnerabilityInfo";
  /** CVE */
  cve: Cve;
  /** space statistics */
  stats?: Maybe<Array<VulnerabilitiesPerSpace>>;
  /** number of affected assets */
  totalAffectedAssets: Scalars["Int"]["output"];
};

/**
 * No fix is available yet: the affected package(s) are acknowledged by the
 * vendor/distro advisory but it lists no fixed version. This is distinct from
 * VulnerabilityRemediationNotSupported (Mondoo does not yet generate remediation
 * for the platform) — here there is genuinely no patch to apply.
 */
export type VulnerabilityNoFixAvailable = Error & {
  __typename: "VulnerabilityNoFixAvailable";
  /** Error code */
  code: Scalars["String"]["output"];
  /** Error message */
  message: Scalars["String"]["output"];
};

/** possible vulnerability order types */
export enum VulnerabilityOrderType {
  Newest = "NEWEST",
  Severe = "SEVERE",
}

/** Details specific to a vulnerability-source remediation. */
export type VulnerabilityRemediationDetails = {
  __typename: "VulnerabilityRemediationDetails";
  /** OSV-style ecosystem string (e.g. "ubuntu:22.04", "windows", "homebrew"). */
  ecosystem: Scalars["String"]["output"];
  /** Name of the package to upgrade. */
  packageName: Scalars["String"]["output"];
  /** Minimum package version that resolves all included CVEs. */
  targetVersion: Scalars["String"]["output"];
};

/** Remediation script not found, e.g., when the package is not found */
export type VulnerabilityRemediationNotFound = Error & {
  __typename: "VulnerabilityRemediationNotFound";
  /** Error code */
  code: Scalars["String"]["output"];
  /** Error message */
  message: Scalars["String"]["output"];
};

/** Remediation script not supported, e.g., wrong platform */
export type VulnerabilityRemediationNotSupported = Error & {
  __typename: "VulnerabilityRemediationNotSupported";
  /** Error code */
  code: Scalars["String"]["output"];
  /** Error message */
  message: Scalars["String"]["output"];
};

/** Remediation script(s) */
export type VulnerabilityRemediationResponse = {
  __typename: "VulnerabilityRemediationResponse";
  /** List of applicable ecosystems for a vulnerability */
  applicableEcosystems?: Maybe<Array<EcosystemEntry>>;
  /**
   * List of available ecosystems for a vulnerability
   * @deprecated Use `applicableEcosystems` instead.
   */
  ecosystems?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Name of the ecosystem with the highest version */
  highestVersionEcosystem?: Maybe<Scalars["String"]["output"]>;
  /**
   * Name of the namespace with the highest version
   * @deprecated Use `highestVersionEcosystem` instead.
   */
  highestVersionNamespace?: Maybe<Scalars["String"]["output"]>;
  /**
   * List of available namespaces for a vulnerability
   * @deprecated Use `ecosystems` instead.
   */
  namespaces?: Maybe<Array<Scalars["String"]["output"]>>;
  /** List of packages which are covered by the scripts */
  packages?: Maybe<Array<Package>>;
  /** The generated scripts */
  scripts?: Maybe<Array<RemediationScript>>;
};

/** Remediation not known, e.g., the vulnerability is not yet fixed */
export type VulnerabilityRemediationUnknown = Error & {
  __typename: "VulnerabilityRemediationUnknown";
  /** Error code */
  code: Scalars["String"]["output"];
  /** Error message */
  message: Scalars["String"]["output"];
};

/** Vulnerability Report asset summary */
export type VulnerabilityReportAssetSummary = {
  __typename: "VulnerabilityReportAssetSummary";
  /** number of unfixed advisories */
  activeAdvisoryCount: Scalars["Int"]["output"];
  /** number of unfixed cves */
  activeCveCount: Scalars["Int"]["output"];
  /** asset data */
  asset: Asset;
  /** number of fixed advisories */
  fixedAdvisoryCount: Scalars["Int"]["output"];
  /** number of fixed cves */
  fixedCveCount: Scalars["Int"]["output"];
  /** report id */
  id: Scalars["ID"]["output"];
  /** worst score */
  worstCvssScore?: Maybe<CvssScore>;
};

/**
 * VulnerabilityRiskFactors
 *
 * Deprecated: Use `RiskFactorStats` instead
 */
export type VulnerabilityRiskFactors = {
  __typename: "VulnerabilityRiskFactors";
  /** Does a known exploit exist for this vulnerability */
  knownExploited: Scalars["Boolean"]["output"];
  /** Is the vulnerability remotely exploitable */
  remoteExploitable: Scalars["Boolean"]["output"];
};

/** Vulnerability score source */
export type VulnerabilityScoreSource = {
  __typename: "VulnerabilityScoreSource";
  /** Time the vulnerability was first discovered by this source */
  firstDetectedAt: Scalars["String"]["output"];
  /** Time the vulnerability was mark fixed by this source */
  fixedAt?: Maybe<Scalars["String"]["output"]>;
  /** Time the data was last confirmed by this source */
  lastUpdatedAt: Scalars["String"]["output"];
  /** Name of the source */
  name: Scalars["String"]["output"];
  /**
   * URL to external finding (optional)
   * E.g., the URL to a finding inside MS Defender
   */
  url?: Maybe<Scalars["String"]["output"]>;
  /** Vendor of the scanner which discovered this vulnerability */
  vendor?: Maybe<VulnerabilityScoreSourceVendor>;
  /** Version of the scanner which discovered this vulnerability */
  version?: Maybe<Scalars["String"]["output"]>;
};

/** Vendor that can source a vulnerability */
export enum VulnerabilityScoreSourceVendor {
  Crowdstrike = "CROWDSTRIKE",
  Microsoft = "MICROSOFT",
  Mondoo = "MONDOO",
  SentinelOne = "SENTINEL_ONE",
  Tenable = "TENABLE",
  Unknown = "UNKNOWN",
}

/** A Workload Identity Federation (WIF) auth binding */
export type WifAuthBinding = {
  __typename: "WIFAuthBinding";
  /** List of allowed audiences */
  allowedAudiences?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Time when the binding was created */
  createdAt?: Maybe<Scalars["String"]["output"]>;
  /** User that created the binding */
  createdBy?: Maybe<Scalars["String"]["output"]>;
  /** Optional description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Expiration in seconds associated with the binding */
  expiration: Scalars["Int"]["output"];
  /** Icon id for the binding */
  iconId?: Maybe<Scalars["String"]["output"]>;
  /** URI for the token issuer, e.g. https://accounts.google.com */
  issuerUri: Scalars["String"]["output"];
  /** Time when the binding was last used */
  lastUsed?: Maybe<Scalars["String"]["output"]>;
  /** List of additional configurations to confirm */
  mappings?: Maybe<Array<KeyValue>>;
  /** MRN for the auth binding */
  mrn: Scalars["String"]["output"];
  /** User selected name */
  name: Scalars["String"]["output"];
  /** List of roles associated with the binding (e.g. agent mrn) */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Space mrn associated with the binding */
  scope: Scalars["String"]["output"];
  /** Unique identifier to confirm */
  subject: Scalars["String"]["output"];
};

/** Input for ordering WIF auth bindings */
export type WifAuthBindingOrder = {
  /** The direction to order by */
  direction: OrderDirection;
  /** The field to order by */
  field: AuthBindingOrderField;
};

/** External authentication configuration for WIF */
export type WifExternalAuthConfig = {
  __typename: "WIFExternalAuthConfig";
  /** Space mrn for the config */
  audience: Scalars["String"]["output"];
  /** Issuer URI for identity confirmation, e.g.  https://accounts.google.com */
  issuerUri: Scalars["String"]["output"];
  /** List of roles for the config (e.g. agent role mrn) */
  scopes?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Type of token e.g. urn:ietf:params:oauth:token-type:jwt */
  subjectTokenType: Scalars["String"]["output"];
  /** Type of config */
  type: Scalars["String"]["output"];
  /** API for Mondoo, e.g. https://api.edge.mondoo.com */
  universeDomain: Scalars["String"]["output"];
};

/** Webhook configuration options */
export type WebhookConfigurationOptions = {
  __typename: "WebhookConfigurationOptions";
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["output"];
  /** Whether to auto-create tickets */
  autoCreateTickets: Scalars["Boolean"]["output"];
  /** Url which will be used for calling the webhook */
  url: Scalars["String"]["output"];
};

/** Webhook configuration options input */
export type WebhookConfigurationOptionsInput = {
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["input"];
  /** Whether to auto-create tickets */
  autoCreateTickets: Scalars["Boolean"]["input"];
  /** Url which will be used for calling the webhook */
  url: Scalars["String"]["input"];
};

/**
 * Configuration for wildcard asset routing — derives the target space from
 * a tag on each asset. Platform-scope only; if present, must be the only
 * rule in the scope.
 */
export type WildcardRoutingConfig = {
  __typename: "WildcardRoutingConfig";
  /** Prefix used to construct the target space slug (e.g. "psi"). */
  spacePrefix: Scalars["String"]["output"];
  /**
   * Glob pattern (case-insensitive) matched against asset tag keys
   * (e.g. "*psi*").
   */
  tagKey: Scalars["String"]["output"];
};

/** Input for wildcard routing configuration. */
export type WildcardRoutingConfigInput = {
  spacePrefix: Scalars["String"]["input"];
  tagKey: Scalars["String"]["input"];
};

/** A workflow definition (automation story). */
export type Workflow = {
  __typename: "Workflow";
  /** Timestamp when the workflow was created (RFC 3339). */
  createdAt: Scalars["String"]["output"];
  /** MRN of the user who created this workflow. */
  createdBy?: Maybe<Scalars["String"]["output"]>;
  /** Map of placeholder names to credential MRNs. */
  credentialBindings?: Maybe<Scalars["Map"]["output"]>;
  /** Optional longer description of what this workflow does. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Whether this workflow can be triggered. */
  enabled: Scalars["Boolean"]["output"];
  /** Parsed graph structure for the visual editor. */
  graph?: Maybe<WorkflowGraph>;
  /** Whether this workflow is a sub-story (trigger type: sub_story). */
  isSubStory: Scalars["Boolean"]["output"];
  /** Unique Mondoo resource identifier. */
  mrn: Scalars["ID"]["output"];
  /** Human-readable display name. */
  name: Scalars["String"]["output"];
  /** Per-node credential requirements for the binding UI. */
  nodeCredentials?: Maybe<Array<NodeCredentialRequirement>>;
  /** MRN of the space or organization that owns this workflow. */
  ownerMrn: Scalars["ID"]["output"];
  /** Credential names required by the workflow and its sub-workflows. */
  requiredCredentials?: Maybe<Array<Scalars["String"]["output"]>>;
  /** MRN of the service account used for execution, if configured. */
  serviceAccountMrn?: Maybe<Scalars["ID"]["output"]>;
  /** Current lifecycle status (e.g. active, draft, archived). */
  status: Scalars["String"]["output"];
  /** Checksum of the source template at creation time, for drift detection. */
  templateChecksum?: Maybe<Scalars["String"]["output"]>;
  /** Template this workflow was created from, if any. */
  templateId?: Maybe<Scalars["ID"]["output"]>;
  /** Timestamp of the last update (RFC 3339). */
  updatedAt: Scalars["String"]["output"];
  /** Auto-incrementing version number, bumped on each update. */
  version: Scalars["Int"]["output"];
  /** Webhook URL for workflows with type: webhook trigger. Null otherwise. */
  webhookUrl?: Maybe<Scalars["String"]["output"]>;
  /** Full workflow definition in YAML format. */
  yaml: Scalars["String"]["output"];
};

/** An action definition on a plugin. */
export type WorkflowActionDef = {
  __typename: "WorkflowActionDef";
  /** Credential type required (e.g. "github", "slack"). Null if none needed. */
  credentialType?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable description of what this action does. */
  description: Scalars["String"]["output"];
  /** Action identifier (e.g. "create_pr", "send_message"). */
  name: Scalars["String"]["output"];
  /** Input parameters accepted by the action. */
  params: Array<WorkflowParamDef>;
};

/** An edge connecting two nodes in the workflow graph. */
export type WorkflowConnection = {
  __typename: "WorkflowConnection";
  /** Source node ID. */
  from: Scalars["ID"]["output"];
  /** Output label on the source node (e.g. "true", "false") for branching. */
  output?: Maybe<Scalars["String"]["output"]>;
  /** Destination node ID. */
  to: Scalars["ID"]["output"];
};

/** A single execution run of a workflow. */
export type WorkflowExecution = {
  __typename: "WorkflowExecution";
  /** When the execution finished (RFC 3339). */
  completedAt?: Maybe<Scalars["String"]["output"]>;
  /** Timestamp when the execution record was created (RFC 3339). */
  createdAt: Scalars["String"]["output"];
  /** Whether this was a dry-run execution (no side effects). */
  dryRun: Scalars["Boolean"]["output"];
  /** Error message if the execution failed. */
  error?: Maybe<Scalars["String"]["output"]>;
  /** Unique Mondoo resource identifier for this execution. */
  mrn: Scalars["ID"]["output"];
  /** When the execution started running (RFC 3339). */
  startedAt?: Maybe<Scalars["String"]["output"]>;
  /** Execution status (pending, running, completed, failed, cancelled). */
  status: Scalars["String"]["output"];
  /** Temporal run ID for debugging in the Temporal UI. */
  temporalRunId?: Maybe<Scalars["ID"]["output"]>;
  /** Variables and context provided at trigger time. */
  triggerData?: Maybe<Scalars["Map"]["output"]>;
  /** MRN of the workflow that was executed. */
  workflowMrn: Scalars["ID"]["output"];
  /** Workflow version at the time this execution was triggered. */
  workflowVersion?: Maybe<Scalars["Int"]["output"]>;
};

/** Real-time execution state of a running workflow, queried from Temporal. */
export type WorkflowExecutionState = {
  __typename: "WorkflowExecutionState";
  /** When the execution completed (RFC 3339). */
  completedAt?: Maybe<Scalars["String"]["output"]>;
  /** Error message if the execution failed. */
  error?: Maybe<Scalars["String"]["output"]>;
  /** Execution MRN. */
  executionMrn: Scalars["ID"]["output"];
  /** Per-node execution states. */
  nodes: Array<WorkflowNodeState>;
  /** When the execution started (RFC 3339). */
  startedAt?: Maybe<Scalars["String"]["output"]>;
  /** Overall execution status. */
  status: Scalars["String"]["output"];
  /** MRN of the workflow being executed. */
  workflowMrn: Scalars["ID"]["output"];
  /** Workflow version at trigger time, used to load the correct graph snapshot. */
  workflowVersion?: Maybe<Scalars["Int"]["output"]>;
  /** Workflow YAML at the version this execution ran against. */
  yaml?: Maybe<Scalars["String"]["output"]>;
};

/** Input for listing workflow executions. */
export type WorkflowExecutionsInput = {
  /** Filter by scope. */
  scopeMrn?: InputMaybe<Scalars["ID"]["input"]>;
  /** Filter by execution status. */
  status?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by a specific workflow. */
  workflowMrn?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The visual graph structure of a workflow. */
export type WorkflowGraph = {
  __typename: "WorkflowGraph";
  /** Edges connecting nodes in the graph. */
  connections: Array<WorkflowConnection>;
  /** User-defined MCP servers for the generic mcp plugin (ADR-043). */
  mcpServers?: Maybe<Scalars["Map"]["output"]>;
  /** Nodes in the workflow graph. */
  nodes: Array<WorkflowNode>;
  /** Sandbox configuration for isolated compute (ADR-044). */
  sandbox?: Maybe<WorkflowSandboxConfig>;
  /** Trigger configuration for this workflow. */
  trigger: WorkflowTrigger;
  /** Runtime variables that users provide when triggering. */
  variables?: Maybe<Array<WorkflowVariableDef>>;
};

/** A DNS-based network policy rule for sandboxes. */
export type WorkflowNetworkRule = {
  __typename: "WorkflowNetworkRule";
  /** Allow or deny traffic to this domain. */
  action: Scalars["String"]["output"];
  /** Domain pattern to match. */
  domain: Scalars["String"]["output"];
};

/** A node in the workflow graph. */
export type WorkflowNode = {
  __typename: "WorkflowNode";
  /** Action to invoke on the plugin. */
  action?: Maybe<Scalars["String"]["output"]>;
  /** Free-text annotation for the visual editor. */
  comment?: Maybe<Scalars["String"]["output"]>;
  /** Credential name required by this node's plugin. */
  credential?: Maybe<Scalars["String"]["output"]>;
  /** Credential mapping for execute_workflow nodes (ADR-047). */
  credentials?: Maybe<Scalars["Map"]["output"]>;
  /** Whether this node is skipped during execution. */
  disabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Node ID to route to on error. */
  errorOutput?: Maybe<Scalars["String"]["output"]>;
  /** Expression for condition/transform nodes. */
  expression?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier within this workflow. */
  id: Scalars["ID"]["output"];
  /** Input mapping for execute_workflow nodes (ADR-047). */
  input?: Maybe<Scalars["Map"]["output"]>;
  /** How to combine inputs from parallel predecessors. */
  mergeStrategy?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable label shown in the visual editor. */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Error handling strategy (stop, continue, retry). */
  onError?: Maybe<Scalars["String"]["output"]>;
  /** Named outputs for branching logic. */
  outputs?: Maybe<Scalars["Map"]["output"]>;
  /** Input parameters passed to the action. */
  params?: Maybe<Scalars["Map"]["output"]>;
  /** Plugin that provides the action (e.g. "github_pr", "slack"). */
  plugin?: Maybe<Scalars["String"]["output"]>;
  /** Canvas position as [x, y] coordinates. */
  position?: Maybe<Array<Scalars["Int"]["output"]>>;
  /** Template name or MRN for execute_workflow nodes. */
  subWorkflow?: Maybe<Scalars["String"]["output"]>;
  /** Variable definitions from the resolved sub-workflow, for type-aware inputs. */
  subWorkflowVariables?: Maybe<Array<WorkflowVariableDef>>;
  /** Maximum duration for this node's execution. */
  timeout?: Maybe<Scalars["String"]["output"]>;
  /** Node type (action, condition, transform, merge, noop, etc.). */
  type: Scalars["String"]["output"];
  /** How merge nodes combine parallel branches (all, any). */
  waitMode?: Maybe<Scalars["String"]["output"]>;
};

/** Execution state of a single node within a running workflow. */
export type WorkflowNodeState = {
  __typename: "WorkflowNodeState";
  /** When the node finished (RFC 3339). */
  completedAt?: Maybe<Scalars["String"]["output"]>;
  /** Error message if the node failed. */
  error?: Maybe<Scalars["String"]["output"]>;
  /** ID of the node in the workflow graph. */
  nodeId: Scalars["ID"]["output"];
  /** Output data produced by the node. */
  output?: Maybe<Scalars["Map"]["output"]>;
  /** When the node started executing (RFC 3339). */
  startedAt?: Maybe<Scalars["String"]["output"]>;
  /** Node execution status (pending, running, completed, failed, skipped). */
  status: Scalars["String"]["output"];
};

/** A parameter definition for a plugin action. */
export type WorkflowParamDef = {
  __typename: "WorkflowParamDef";
  /** Default value if none is provided. */
  defaultValue?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable description. */
  description: Scalars["String"]["output"];
  /** Parameter name. */
  name: Scalars["String"]["output"];
  /** Whether the parameter must be provided. */
  required: Scalars["Boolean"]["output"];
  /** Parameter type (string, int, bool, map, etc.). */
  type: Scalars["String"]["output"];
};

/** A pending approval step in a running workflow. */
export type WorkflowPendingApproval = {
  __typename: "WorkflowPendingApproval";
  /** When the approval was requested (RFC 3339). */
  createdAt: Scalars["String"]["output"];
  /** MRN of the execution containing this approval step. */
  executionMrn: Scalars["ID"]["output"];
  /** Approval prompt message. */
  message?: Maybe<Scalars["String"]["output"]>;
  /** ID of the node waiting for approval. */
  nodeId: Scalars["ID"]["output"];
  /** Display name of the approval node. */
  nodeName?: Maybe<Scalars["String"]["output"]>;
  /** MRN of the workflow. */
  workflowMrn: Scalars["ID"]["output"];
  /** Display name of the workflow. */
  workflowName: Scalars["String"]["output"];
};

/** A workflow plugin (integration type). */
export type WorkflowPlugin = {
  __typename: "WorkflowPlugin";
  /** Actions provided by this plugin. */
  actions: Array<WorkflowActionDef>;
  /** Human-readable description of the plugin's purpose. */
  description: Scalars["String"]["output"];
  /** Plugin identifier (e.g. "github_pr", "slack", "email"). */
  name: Scalars["String"]["output"];
};

/** Detailed plugin actions response. */
export type WorkflowPluginActions = {
  __typename: "WorkflowPluginActions";
  /** Actions provided by this plugin. */
  actions: Array<WorkflowActionDef>;
  /** Plugin identifier. */
  plugin: Scalars["String"]["output"];
};

/** Workflow reference method. This indicates how the reference was added to the workflow. */
export enum WorkflowRefMethod {
  /**
   * The reference was added because it would implicitly be fixed when all selected
   * references are fixed.
   */
  Related = "RELATED",
  /** The reference was selected when the workflow got created. */
  Selected = "SELECTED",
}

/** A global variable accessible from any workflow in a scope. */
export type WorkflowResource = {
  __typename: "WorkflowResource";
  /** Timestamp when the resource was created (RFC 3339). */
  createdAt: Scalars["String"]["output"];
  /** MRN of the user who created this resource. */
  createdBy?: Maybe<Scalars["String"]["output"]>;
  /** Unique Mondoo resource identifier. */
  mrn: Scalars["ID"]["output"];
  /** Resource key used in expressions. */
  name: Scalars["String"]["output"];
  /** MRN of the space or organization that owns this resource. */
  ownerMrn: Scalars["ID"]["output"];
  /** Resource type (string, secret, json). */
  type: Scalars["String"]["output"];
  /** Timestamp of the last update (RFC 3339). */
  updatedAt: Scalars["String"]["output"];
  /** Current value. */
  value: Scalars["String"]["output"];
};

/** Sandbox configuration for isolated compute environments (ADR-044). */
export type WorkflowSandboxConfig = {
  __typename: "WorkflowSandboxConfig";
  /** CPU allocation. */
  cpus?: Maybe<Scalars["Int"]["output"]>;
  /** Memory allocation (e.g. "512Mi", "2Gi"). */
  memory?: Maybe<Scalars["String"]["output"]>;
  /** DNS-based network egress rules. */
  networkPolicy?: Maybe<Array<WorkflowNetworkRule>>;
  /** Sandbox provider (e.g. "sprites"). */
  provider: Scalars["String"]["output"];
  /** Cloud region for the sandbox. */
  region?: Maybe<Scalars["String"]["output"]>;
  /** Disk storage allocation. */
  storage?: Maybe<Scalars["String"]["output"]>;
  /** Maximum execution duration. */
  timeout?: Maybe<Scalars["String"]["output"]>;
};

/** A Temporal schedule for recurring workflow execution. */
export type WorkflowSchedule = {
  __typename: "WorkflowSchedule";
  /** Timestamp when the schedule was created (RFC 3339). */
  createdAt: Scalars["String"]["output"];
  /** Cron expression defining the recurrence. */
  cronExpression: Scalars["String"]["output"];
  /** Unique Mondoo resource identifier. */
  mrn: Scalars["ID"]["output"];
  /** Whether the schedule is currently paused. */
  paused: Scalars["Boolean"]["output"];
  /** Timestamp of the last update (RFC 3339). */
  updatedAt: Scalars["String"]["output"];
  /** MRN of the scheduled workflow. */
  workflowMrn: Scalars["ID"]["output"];
};

/** Workflow status */
export enum WorkflowStatus {
  Canceled = "CANCELED",
  ConfirmingFix = "CONFIRMING_FIX",
  Deployed = "DEPLOYED",
  Failed = "FAILED",
  Fixed = "FIXED",
  Pending = "PENDING",
  PrCreated = "PR_CREATED",
  PrMerged = "PR_MERGED",
}

/** Workflow task status */
export enum WorkflowTaskStatus {
  Canceled = "CANCELED",
  Completed = "COMPLETED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  Pending = "PENDING",
}

/** Workflow task type */
export enum WorkflowTaskType {
  ClosePr = "CLOSE_PR",
  ConfirmFix = "CONFIRM_FIX",
  CreatePr = "CREATE_PR",
  DeployRemediation = "DEPLOY_REMEDIATION",
  MonitorExecution = "MONITOR_EXECUTION",
}

/** A pre-built workflow template. */
export type WorkflowTemplate = {
  __typename: "WorkflowTemplate";
  /** Template category for grouping in the UI. */
  category: Scalars["String"]["output"];
  /** Content hash for drift detection. */
  checksum: Scalars["String"]["output"];
  /** Description of what this template automates. */
  description: Scalars["String"]["output"];
  /** Parsed graph structure for read-only preview in the visual editor. */
  graph?: Maybe<WorkflowGraph>;
  /** Icon identifier for the UI. */
  icon: Scalars["String"]["output"];
  /** Unique template identifier. */
  id: Scalars["ID"]["output"];
  /** Human-readable template name. */
  name: Scalars["String"]["output"];
  /** Full template YAML. */
  yaml: Scalars["String"]["output"];
};

/** A trigger definition for a workflow. */
export type WorkflowTrigger = {
  __typename: "WorkflowTrigger";
  /** Filter conditions for event triggers. */
  conditions?: Maybe<Scalars["Map"]["output"]>;
  /** Expr-lang filter expression evaluated before dispatching webhook triggers. */
  filter?: Maybe<Scalars["String"]["output"]>;
  /** Rate limit for event/webhook triggers (e.g. "10/min"). */
  rateLimit?: Maybe<Scalars["String"]["output"]>;
  /** Cron expression for schedule triggers. */
  schedule?: Maybe<Scalars["String"]["output"]>;
  /** Credential name for webhook HMAC signature verification (ADR-045). */
  secretCredential?: Maybe<Scalars["String"]["output"]>;
  /** Trigger mechanism (manual, schedule, webhook, event, sub_story). */
  type: Scalars["String"]["output"];
  /** Server-generated webhook identifier for webhook triggers. */
  webhookId?: Maybe<Scalars["ID"]["output"]>;
};

/** A runtime variable that users provide when triggering a workflow. */
export type WorkflowVariableDef = {
  __typename: "WorkflowVariableDef";
  /** Default value used when none is provided. */
  default?: Maybe<Scalars["String"]["output"]>;
  /** Help text for the trigger form. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Variable key used in expressions. */
  name: Scalars["String"]["output"];
  /** Dropdown options for enum-type variables. */
  options?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Whether a value must be provided to trigger the workflow. */
  required: Scalars["Boolean"]["output"];
  /** Variable type: string (default), enum (dropdown), or credential. */
  type?: Maybe<Scalars["String"]["output"]>;
};

/** A version snapshot of a workflow. */
export type WorkflowVersion = {
  __typename: "WorkflowVersion";
  /** When this version was saved (RFC 3339). */
  createdAt: Scalars["String"]["output"];
  /** MRN of the user who saved this version. */
  createdBy?: Maybe<Scalars["String"]["output"]>;
  /** Version number. */
  version: Scalars["Int"]["output"];
  /** Workflow YAML at this version. */
  yaml: Scalars["String"]["output"];
};

/** Input for listing workflows. */
export type WorkflowsInput = {
  /** Filter by enabled state. */
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** MRN of the space or organization to list workflows for. */
  scopeMrn: Scalars["ID"]["input"];
  /** Filter by lifecycle status. */
  status?: InputMaybe<Scalars["String"]["input"]>;
};

/** Workspace */
export type Workspace = {
  __typename: "Workspace";
  /** Asset groups statistics */
  assetGroupStats: Array<AssetGroupStatistics>;
  /** Contacts assigned to this workspace */
  contacts?: Maybe<Array<ResourceContact>>;
  /** Description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** List metrics for the space */
  metrics?: Maybe<MetricsResponse>;
  /** MRN */
  mrn: Scalars["String"]["output"];
  /** Name */
  name: Scalars["String"]["output"];
  /** Owner MRN */
  ownerMrn: Scalars["String"]["output"];
  /** The amount of priority findings (critical, high) in the space */
  priorityFindings: Scalars["Int"]["output"];
  /** Workspace selections */
  selections: WorkspaceSelections;
};

/** Workspace */
export type WorkspaceMetricsArgs = {
  endTime?: InputMaybe<Scalars["String"]["input"]>;
  metricMrns?: InputMaybe<Array<Scalars["String"]["input"]>>;
  startTime?: InputMaybe<Scalars["String"]["input"]>;
};

/** Workspace condition int value suggestion */
export type WorkspaceConditionIntValueSuggestion = {
  __typename: "WorkspaceConditionIntValueSuggestion";
  /** Display name for the value */
  displayName: Scalars["String"]["output"];
  /** Condition value */
  value: Scalars["Int"]["output"];
};

/** Workspace condition possible values for int conditions */
export type WorkspaceConditionIntValues = {
  __typename: "WorkspaceConditionIntValues";
  /** String value suggestions */
  suggestions?: Maybe<Array<WorkspaceConditionIntValueSuggestion>>;
};

/** Workspace condition possible values */
export type WorkspaceConditionPossibleValues =
  | WorkspaceConditionIntValues
  | WorkspaceConditionRatingValues
  | WorkspaceConditionStringValues;

/** Workspace condition possible values input */
export type WorkspaceConditionPossibleValuesInput = {
  /** Int field */
  intField?: InputMaybe<WorkspaceSelectionConditionIntField>;
  /** Key-value field */
  keyValueField?: InputMaybe<WorkspaceSelectionConditionKeyValueField>;
  /** Query to filter values on */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** Rating field */
  ratingField?: InputMaybe<WorkspaceSelectionConditionRatingField>;
  /** Scope MRN */
  scopeMrn: Scalars["String"]["input"];
  /** String field */
  stringField?: InputMaybe<WorkspaceSelectionConditionStringField>;
};

/** Workspace condition rating value suggestion */
export type WorkspaceConditionRatingValueSuggestion = {
  __typename: "WorkspaceConditionRatingValueSuggestion";
  /** Display name for the value */
  displayName: Scalars["String"]["output"];
  /** Condition value */
  value: ScoreRating;
};

/** Workspace condition possible values for rating conditions */
export type WorkspaceConditionRatingValues = {
  __typename: "WorkspaceConditionRatingValues";
  /** Rating value suggestions */
  suggestions?: Maybe<Array<WorkspaceConditionRatingValueSuggestion>>;
};

/** Workspace condition string value suggestion */
export type WorkspaceConditionStringValueSuggestion = {
  __typename: "WorkspaceConditionStringValueSuggestion";
  /** Display name for the value */
  displayName: Scalars["String"]["output"];
  /** Condition value */
  value: Scalars["String"]["output"];
};

/** Workspace condition possible values for string conditions */
export type WorkspaceConditionStringValues = {
  __typename: "WorkspaceConditionStringValues";
  /** String value suggestions */
  suggestions?: Maybe<Array<WorkspaceConditionStringValueSuggestion>>;
};

/** Workspace edge */
export type WorkspaceEdge = {
  __typename: "WorkspaceEdge";
  /** Cursor */
  cursor: Scalars["String"]["output"];
  /** Node */
  node: Workspace;
};

/** Workspace response */
export type WorkspaceResponse = NotFoundError | RequestError | Workspace;

/** Workspace selection defining conditions for selecting assets for a workspace */
export type WorkspaceSelection = {
  __typename: "WorkspaceSelection";
  /** A list of conditions for the selection */
  conditions: Array<WorkspaceSelectionCondition>;
};

/** Workspace selection condition */
export type WorkspaceSelectionCondition = {
  __typename: "WorkspaceSelectionCondition";
  /** The condition itself */
  condition: WorkspaceSelectionTypedCondition;
  /** Operator determining how the condition is joined with the other conditions in the list */
  operator: WorkspaceSelectionConditionOperator;
};

/** Workspace selection condition */
export type WorkspaceSelectionConditionInput = {
  /** Int condition */
  intCondition?: InputMaybe<WorkspaceSelectionIntConditionInput>;
  /** Key-value condition */
  keyValueCondition?: InputMaybe<WorkspaceSelectionKeyValueConditionInput>;
  /** Operator determining how the condition is joined with the other conditions in the list */
  operator: WorkspaceSelectionConditionOperator;
  /** Rating condition */
  ratingCondition?: InputMaybe<WorkspaceSelectionRatingConditionInput>;
  /** String condition */
  stringCondition?: InputMaybe<WorkspaceSelectionStringConditionInput>;
};

/** Workspace selection condition int fields */
export enum WorkspaceSelectionConditionIntField {
  /**
   * Deprecated alias for RISK_VALUE, kept so existing clients keep working
   * until they migrate. Remove once the console sends RISK_VALUE.
   * @deprecated Use RISK_VALUE instead.
   */
  RiskScore = "RISK_SCORE",
  /** Risk value field (user-facing risk magnitude, higher = worse) */
  RiskValue = "RISK_VALUE",
  /** Unknwon int field */
  Unknown = "UNKNOWN",
}

/** Workspace selection condition key-value fields */
export enum WorkspaceSelectionConditionKeyValueField {
  /** Annotations field */
  Annotations = "ANNOTATIONS",
  /** Labels field */
  Labels = "LABELS",
  /** Unknwon key-value field */
  Unknown = "UNKNOWN",
}

/** Workspace selection condition key-value operators */
export enum WorkspaceSelectionConditionKeyValueOperator {
  /** Contains operator */
  Contains = "CONTAINS",
  /** Does not contain operator */
  NotContains = "NOT_CONTAINS",
  /** Unknown operator */
  Unknown = "UNKNOWN",
}

/** Workspace selection condition string operators */
export enum WorkspaceSelectionConditionNumericOperator {
  /** Equal operator */
  Equal = "EQUAL",
  /** Greater than operator */
  Gt = "GT",
  /** Less than operator */
  Lt = "LT",
  /** Not equal operator */
  NotEqual = "NOT_EQUAL",
  /** Unknown operator */
  Unknown = "UNKNOWN",
}

/** Workspace selection condition operator */
export enum WorkspaceSelectionConditionOperator {
  /** AND operator, meaning the condition will be "ANDed" to other conditions */
  And = "AND",
  /** AND NOT operator, meaning the condition will be "ANDed" to other conditions with a NOT */
  AndNot = "AND_NOT",
  /** Unknown operator */
  Unknown = "UNKNOWN",
}

/** Workspace selection condition rating fields */
export enum WorkspaceSelectionConditionRatingField {
  /** Risk field */
  Risk = "RISK",
  /** Unknwon rating field */
  Unknown = "UNKNOWN",
}

/** Workspace selection condition rating operators */
export enum WorkspaceSelectionConditionRatingOperator {
  /** Equal operator */
  Equal = "EQUAL",
  /** Not equal operator */
  NotEqual = "NOT_EQUAL",
  /** Unknown operator */
  Unknown = "UNKNOWN",
}

/** Workspace selection condition string fields */
export enum WorkspaceSelectionConditionStringField {
  /** Asset kind field */
  AssetKind = "ASSET_KIND",
  /** Asset name field */
  AssetName = "ASSET_NAME",
  /** Platform field */
  Platform = "PLATFORM",
  /** Platform version field */
  PlatformVersion = "PLATFORM_VERSION",
  /** Technology field */
  Technology = "TECHNOLOGY",
  /** Unknwon string field */
  Unknown = "UNKNOWN",
}

/** Workspace selection condition string operators */
export enum WorkspaceSelectionConditionStringOperator {
  /** Contains operator */
  Contains = "CONTAINS",
  /** Equal operator */
  Equal = "EQUAL",
  /** Not equal operator */
  NotEqual = "NOT_EQUAL",
  /** Unknown operator */
  Unknown = "UNKNOWN",
}

/** Workspace selection defining conditions for selecting assets for a workspace */
export type WorkspaceSelectionInput = {
  /** A list of conditions for the selection */
  conditions: Array<WorkspaceSelectionConditionInput>;
};

/** Workspace selection condition int condition */
export type WorkspaceSelectionIntCondition = {
  __typename: "WorkspaceSelectionIntCondition";
  /** Field to match */
  field: WorkspaceSelectionConditionIntField;
  /** Operator to use */
  operator: WorkspaceSelectionConditionNumericOperator;
  /** Values to match. Values are ORed together */
  values: Array<Scalars["Int"]["output"]>;
};

/** Workspace selection condition int condition */
export type WorkspaceSelectionIntConditionInput = {
  /** Field to match */
  field: WorkspaceSelectionConditionIntField;
  /** Operator to use */
  operator: WorkspaceSelectionConditionNumericOperator;
  /** Values to match. Values are ORed together */
  values: Array<Scalars["Int"]["input"]>;
};

/** Workspace selection key-value condition */
export type WorkspaceSelectionKeyValueCondition = {
  __typename: "WorkspaceSelectionKeyValueCondition";
  /** Field to match */
  field: WorkspaceSelectionConditionKeyValueField;
  /** Operator to use */
  operator: WorkspaceSelectionConditionKeyValueOperator;
  /** Values to match. Values are ORed together */
  values: Array<KeyValue>;
};

/** Workspace selection key-value condition */
export type WorkspaceSelectionKeyValueConditionInput = {
  /** Field to match */
  field: WorkspaceSelectionConditionKeyValueField;
  /** Operator to use */
  operator: WorkspaceSelectionConditionKeyValueOperator;
  /** Values to match. Values are ORed together */
  values: Array<KeyValueInput>;
};

/** Workspace selection rating condition */
export type WorkspaceSelectionRatingCondition = {
  __typename: "WorkspaceSelectionRatingCondition";
  /** Field to match */
  field: WorkspaceSelectionConditionRatingField;
  /** Operator to use */
  operator: WorkspaceSelectionConditionRatingOperator;
  /** Values to match. Values are ORed together */
  values: Array<ScoreRating>;
};

/** Workspace selection rating condition */
export type WorkspaceSelectionRatingConditionInput = {
  /** Field to match */
  field: WorkspaceSelectionConditionRatingField;
  /** Operator to use */
  operator: WorkspaceSelectionConditionRatingOperator;
  /** Values to match. Values are ORed together */
  values: Array<ScoreRating>;
};

/** Workspace selection string condition */
export type WorkspaceSelectionStringCondition = {
  __typename: "WorkspaceSelectionStringCondition";
  /** Field to match */
  field: WorkspaceSelectionConditionStringField;
  /** Operator to use */
  operator: WorkspaceSelectionConditionStringOperator;
  /** Values to match. Values are ORed together */
  values: Array<WorkspaceSelectionStringConditionValue>;
};

/** Workspace selection string condition */
export type WorkspaceSelectionStringConditionInput = {
  /** Field to match */
  field: WorkspaceSelectionConditionStringField;
  /** Operator to use */
  operator: WorkspaceSelectionConditionStringOperator;
  /** Values to match. Values are ORed together */
  values: Array<Scalars["String"]["input"]>;
};

/** Workspace selection string condition value */
export type WorkspaceSelectionStringConditionValue = {
  __typename: "WorkspaceSelectionStringConditionValue";
  /** Display name */
  displayName: Scalars["String"]["output"];
  /** Value */
  value: Scalars["String"]["output"];
};

/** Workspace selection typed condition */
export type WorkspaceSelectionTypedCondition =
  | WorkspaceSelectionIntCondition
  | WorkspaceSelectionKeyValueCondition
  | WorkspaceSelectionRatingCondition
  | WorkspaceSelectionStringCondition;

/** Workspace selections */
export type WorkspaceSelections = {
  __typename: "WorkspaceSelections";
  /** A list of workspace selections */
  selections: Array<WorkspaceSelection>;
};

/** Workspace selections input */
export type WorkspaceSelectionsInput = {
  /** A list of workspace selections */
  selections: Array<WorkspaceSelectionInput>;
};

/** Paginated list of workspaces */
export type WorkspacesConnection = {
  __typename: "WorkspacesConnection";
  /** Edges */
  edges?: Maybe<Array<WorkspaceEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"]["output"];
};

/** Workspaces input */
export type WorkspacesInput = {
  /** Query searches workspaces by name */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** The scope of the workspaces to list */
  scopeMrn: Scalars["String"]["input"];
};

/** Zendesk configuration options */
export type ZendeskConfigurationOptions = {
  __typename: "ZendeskConfigurationOptions";
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["output"];
  /** Whether to auto-create tickets */
  autoCreateTickets: Scalars["Boolean"]["output"];
  /** A list of custom fields for Zendesk */
  customFields?: Maybe<Array<ZendeskCustomField>>;
  /** The Zendesk email address */
  email: Scalars["String"]["output"];
  /** The Zendesk subdomain */
  subdomain: Scalars["String"]["output"];
};

/** Zendesk integration input */
export type ZendeskConfigurationOptionsInput = {
  /** The Zendesk API token */
  apiToken: Scalars["String"]["input"];
  /** Whether to auto-close tickets */
  autoCloseTickets: Scalars["Boolean"]["input"];
  /** Whether to auto-create tickets */
  autoCreateTickets: Scalars["Boolean"]["input"];
  /** A list of custom fields for Zendesk */
  customFields?: InputMaybe<Array<ZendeskCustomFieldInput>>;
  /** The Zendesk email address */
  email: Scalars["String"]["input"];
  /** The Zendesk subdomain */
  subdomain: Scalars["String"]["input"];
};

/** Zendesk custom field */
export type ZendeskCustomField = {
  __typename: "ZendeskCustomField";
  /** The custom field ID */
  id: Scalars["Int"]["output"];
  /** The value of the custom field */
  value: Scalars["String"]["output"];
};

/** Zendesk custom field input */
export type ZendeskCustomFieldInput = {
  /** Field ID */
  id: Scalars["Int"]["input"];
  /** Value */
  value: Scalars["String"]["input"];
};

/** Zendesk field */
export type ZendeskField = {
  __typename: "ZendeskField";
  /** Display name */
  displayName: Scalars["String"]["output"];
  /** Value */
  value: Scalars["String"]["output"];
};

/** Zendesk ticket configuration input */
export type ZendeskTicketConfigInput = {
  /** The Zendesk priority */
  priority?: InputMaybe<Scalars["String"]["input"]>;
  /** The Zendesk ticket type */
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** This type represents a Zendesk ticket context. It contains the fields that are available for creating a ticket. */
export type ZendeskTicketContextFieldsPayload = {
  __typename: "ZendeskTicketContextFieldsPayload";
  /** The values available for the priority field when creating a ticket. */
  priority?: Maybe<Array<ZendeskField>>;
  /** The values available for the type field when creating a ticket. */
  type?: Maybe<Array<ZendeskField>>;
};

/** Parameters for ZendeskTicketContext */
export type ZendeskTicketContextInput = {
  /** The type of the ticket context. */
  type: ZendeskTicketContextType;
};

/** The type of the ticket context. */
export enum ZendeskTicketContextType {
  /** The ticket context for Zendesk projects. */
  Fields = "FIELDS",
}

export type GetAffectedEcosystemsQueryVariables = Exact<{
  vulnId: Scalars["String"]["input"];
  scopeMrn: Scalars["String"]["input"];
  initiativeMrn?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetAffectedEcosystemsQuery = {
  __typename: "Query";
  affectedEcosystems: Array<{
    __typename: "Ecosystem";
    friendlyName: string;
    icon: Icon_Ids;
    versions?: Array<{
      __typename: "EcosystemVersion";
      friendlyName: string;
      ecosystem: string;
    }> | null;
  }>;
};

export type GetRemediationQueryVariables = Exact<{
  vulnId?: InputMaybe<Scalars["String"]["input"]>;
  scopeMrn: Scalars["String"]["input"];
  ecosystem?: InputMaybe<Scalars["String"]["input"]>;
  packages?: InputMaybe<Array<PackageReferenceInput> | PackageReferenceInput>;
  initiativeMrn?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetRemediationQuery = {
  __typename: "Query";
  remediationForScope?:
    | {
        __typename: "Remediation";
        scopeMrn: string;
        scripts: Array<{
          __typename: "RemediationScript";
          type: RemediationScriptType;
          script: string;
          packageManager: PackageManager;
          platformName: string;
          platformVersion: string;
        }>;
        allPackages: Array<{
          __typename: "Package";
          id: string;
          name: string;
          version?: string | null;
          namespace?: string | null;
          ecosystem?: string | null;
          arch?: string | null;
        }>;
      }
    | { __typename: "VulnerabilityNoFixAvailable" }
    | { __typename: "VulnerabilityRemediationNotFound"; message: string }
    | { __typename: "VulnerabilityRemediationNotSupported"; message: string }
    | { __typename: "VulnerabilityRemediationUnknown"; message: string }
    | null;
};

export type StartConversationQueryVariables = Exact<{
  input?: InputMaybe<FindingsWebhookPostRequest>;
}>;

export type StartConversationQuery = {
  __typename: "Query";
  createFindingsWebhookPost?: {
    __typename: "FindingsWebhookPostResponse";
    status?: string | null;
  } | null;
};

export type GetIntercomTokenQueryVariables = Exact<{ [key: string]: never }>;

export type GetIntercomTokenQuery = {
  __typename: "Query";
  intercomToken: string;
};

export type AdvisoryNodeFieldsFragment = {
  __typename: "Advisory";
  id: string;
  title?: string | null;
  publishedAt?: string | null;
  iconIDEnum?: Icon_Ids | null;
  cvssScore: {
    __typename: "CvssScore";
    id: string;
    source: string;
    type: number;
    value: number;
    vector: string;
    rating: ScoreRating;
  };
  vulnerabilityRiskFactors: {
    __typename: "VulnerabilityRiskFactors";
    knownExploited: boolean;
    remoteExploitable: boolean;
  };
  cves?: Array<{
    __typename: "Cve";
    id: string;
    vulnerabilityRiskFactors: {
      __typename: "VulnerabilityRiskFactors";
      knownExploited: boolean;
      remoteExploitable: boolean;
    };
  }> | null;
};

export type AffectedAssetStatsFieldsFragment = {
  __typename: "AffectedAssetStats";
  affectedCount: number;
  fixedCount: number;
  totalCount: number;
};

export type AgentFieldsFragment = {
  __typename: "AgentsConnection";
  totalCount: number;
  edges?: Array<{
    __typename: "AgentEdge";
    cursor: string;
    node?: {
      __typename: "Agent";
      id: string;
      mrn: string;
      name: string;
      hostname: string;
      ipaddress: string;
      createdAt: string;
      status?: {
        __typename: "AgentStatus";
        version?: string | null;
        state?: AgentState | null;
        lastCheckin?: string | null;
      } | null;
      labels: Array<{
        __typename: "KeyValue";
        key: string;
        value?: string | null;
      }>;
      platform?: {
        __typename: "Platform";
        name: string;
        release: string;
        arch: string;
      } | null;
    } | null;
  }> | null;
  pageInfo: {
    __typename: "PageInfo";
    startCursor: string;
    endCursor: string;
    hasNextPage: boolean;
  };
};

export type AssetFieldsFragment = {
  __typename: "AssetsConnection";
  totalCount: number;
  edges?: Array<{
    __typename: "AssetEdge";
    cursor: string;
    node?: {
      __typename: "Asset";
      id: string;
      mrn: string;
      name?: string | null;
      state: AssetState;
      updatedAt?: string | null;
      score: {
        __typename: "Score";
        id: string;
        value: number;
        type: number;
        completion: number;
        weight: number;
        message: string;
        riskRating: ScoreRating;
        riskValue: number;
      };
      labels: Array<{
        __typename: "KeyValue";
        key: string;
        value?: string | null;
      }>;
      platform?: {
        __typename: "Platform";
        name: string;
        title: string;
        release: string;
        arch: string;
        kind: PlatformKind;
        runtime: string;
      } | null;
    } | null;
  }> | null;
  pageInfo: {
    __typename: "PageInfo";
    startCursor: string;
    endCursor: string;
    hasNextPage: boolean;
  };
};

export type AssetGradeDistributionFieldsFragment = {
  __typename: "AssetGradeDistribution";
  total: number;
  A: number;
  B: number;
  C: number;
  D: number;
  F: number;
  U: number;
  X: number;
};

export type BlastRadiusFieldsFragment = {
  __typename: "BlastRadius";
  indicator: string;
  assets: number;
  affected: number;
  critical: number;
  high: number;
  medium: number;
  low: number;
  none: number;
  snoozed: number;
  disabled: number;
};

export type CveNodeFieldsFragment = {
  __typename: "Cve";
  id: string;
  state?: CveState | null;
  published?: string | null;
  title?: string | null;
  vulnerabilityRiskFactors: {
    __typename: "VulnerabilityRiskFactors";
    knownExploited: boolean;
    remoteExploitable: boolean;
  };
  epssScore?: { __typename: "EpssScore"; probability: number } | null;
  cvssScore: {
    __typename: "CvssScore";
    type: number;
    value: number;
    vector: string;
    rating: ScoreRating;
  };
  score: { __typename: "CvssScore"; value: number; type: number };
};

export type CvssScoreFieldsFragment = {
  __typename: "CvssScore";
  id: string;
  value: number;
  type: number;
  vector: string;
  source: string;
};

export type FindingStatesFieldsFragment = {
  __typename: "FindingState";
  score: FindingScoreState;
  age: FindingAgeState;
  action: FindingActionState;
  securityPipeline: FindingSecurityPipelineState;
  ticket: FindingTicketState;
  exception: FindingExceptionState;
  overall: FindingOverallState;
  enforcement: FindingEnforcementState;
};

export type MqueryDocsFieldsFragment = {
  __typename: "MqueryDocs";
  audit: string;
  desc: string;
  references?: Array<{
    __typename: "MqueryRef";
    title: string;
    url: string;
  }> | null;
  remediations?:
    | { __typename: "AuthenticationRequired"; message: string; code: string }
    | {
        __typename: "Remediations";
        entries: Array<{
          __typename: "MqueryRemediation";
          id: string;
          idName: string;
          desc: string;
        }>;
      }
    | null;
};

export type PackageFieldsFragment = {
  __typename: "Package";
  id: string;
  name: string;
  version?: string | null;
  arch?: string | null;
  available?: string | null;
  status?: string | null;
  vulnDiscoveryTime?: string | null;
  iconIDEnum?: Icon_Ids | null;
  cvssScore: {
    __typename: "CvssScore";
    type: number;
    value: number;
    vector: string;
  };
  epssScore?: {
    __typename: "EpssScore";
    percentile: number;
    probability: number;
  } | null;
};

export type PageInfoFieldsFragment = {
  __typename: "PageInfo";
  startCursor: string;
  endCursor: string;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
};

export type PlatformFieldsFragment = {
  __typename: "Platform";
  name: string;
  release: string;
  arch: string;
  kind: PlatformKind;
  runtime: string;
};

export type RemediationPackageFieldsFragment = {
  __typename: "Package";
  id: string;
  name: string;
  version?: string | null;
  namespace?: string | null;
  ecosystem?: string | null;
  arch?: string | null;
};

export type RemediationScriptFieldsFragment = {
  __typename: "RemediationScript";
  type: RemediationScriptType;
  script: string;
  packageManager: PackageManager;
  platformName: string;
  platformVersion: string;
};

export type ServiceAccountFieldsFragment = {
  __typename: "ServiceAccountConnection";
  totalCount: number;
  edges?: Array<{
    __typename: "ServiceAccountEdge";
    cursor: string;
    node?: {
      __typename: "ServiceAccount";
      id: string;
      mrn: string;
      name: string;
      description?: string | null;
      createdAt: string;
      lastUsed?: string | null;
      notes?: string | null;
      roles: Array<{ __typename: "Role"; mrn: string; title: string }>;
      labels: Array<{
        __typename: "KeyValue";
        key: string;
        value?: string | null;
      }>;
      creator?: {
        __typename: "ServiceAccountCreator";
        mrn?: string | null;
        email?: string | null;
        service?: string | null;
      } | null;
    } | null;
  }> | null;
  pageInfo: {
    __typename: "PageInfo";
    startCursor: string;
    endCursor: string;
    hasNextPage: boolean;
  };
};

export type VulnerabilityRiskFactorsFieldsFragment = {
  __typename: "VulnerabilityRiskFactors";
  knownExploited: boolean;
  remoteExploitable: boolean;
};

export type AcceptInvitationMutationVariables = Exact<{
  invitationMrn: Scalars["ID"]["input"];
}>;

export type AcceptInvitationMutation = {
  __typename: "Mutation";
  acceptInvitation: boolean;
};

export type AcceptLegalPolicyMutationVariables = Exact<{
  input: AcceptLegalPolicy;
}>;

export type AcceptLegalPolicyMutation = {
  __typename: "Mutation";
  acceptLegalPolicy: boolean;
};

export type ActivateUserInRegionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ActivateUserInRegionMutation = {
  __typename: "Mutation";
  activateUserInRegion: {
    __typename: "ActivateUserInRegionPayload";
    user: { __typename: "User"; mrn: string };
  };
};

export type AddQueryPackMutationVariables = Exact<{
  input: Array<QueryPackAddInput> | QueryPackAddInput;
}>;

export type AddQueryPackMutation = {
  __typename: "Mutation";
  addQueryPack: boolean;
};

export type ApplyExceptionMutationVariables = Exact<{
  input: ExceptionMutationInput;
}>;

export type ApplyExceptionMutation = {
  __typename: "Mutation";
  applyException: boolean;
};

export type ApplyExceptionExtensionReviewMutationVariables = Exact<{
  input: ExtendExceptionReviewInput;
}>;

export type ApplyExceptionExtensionReviewMutation = {
  __typename: "Mutation";
  applyExceptionExtensionReview: boolean;
};

export type ApplyExceptionReviewMutationVariables = Exact<{
  input: ExceptionReviewInput;
}>;

export type ApplyExceptionReviewMutation = {
  __typename: "Mutation";
  applyExceptionReview: boolean;
};

export type ApplyFrameworkMutationVariables = Exact<{
  input: ComplianceFrameworkMutationInput;
}>;

export type ApplyFrameworkMutation = {
  __typename: "Mutation";
  applyFrameworkMutation: boolean;
};

export type AssignPolicyMutationVariables = Exact<{
  input: PolicyAssignmentInput;
}>;

export type AssignPolicyMutation = {
  __typename: "Mutation";
  assignPolicy: boolean;
};

export type CancelInvitationMutationVariables = Exact<{
  invitationMrn: Scalars["ID"]["input"];
}>;

export type CancelInvitationMutation = {
  __typename: "Mutation";
  cancelInvitation: boolean;
};

export type ChangeSubscriptionPlanMutationVariables = Exact<{
  input: ChangeSubscriptionPlanInput;
}>;

export type ChangeSubscriptionPlanMutation = {
  __typename: "Mutation";
  changeSubscriptionPlan:
    | { __typename: "BillingSession"; url: string }
    | { __typename: "ChangeSubscriptionSuccess" }
    | {
        __typename: "PaymentPreview";
        currency: string;
        recurringCost: number;
        dueToday: number;
        prorationDate: number;
        effectiveDate: string;
      };
};

export type CreateBillingSessionMutationVariables = Exact<{
  input: BillingSessionInput;
}>;

export type CreateBillingSessionMutation = {
  __typename: "Mutation";
  createBillingSession: { __typename: "BillingSession"; url: string };
};

export type CreateCaseMutationVariables = Exact<{
  input: CreateCaseInput;
}>;

export type CreateCaseMutation = {
  __typename: "Mutation";
  createCase: {
    __typename: "Case";
    mrn: string;
    ticketRefs?: Array<{
      __typename: "TicketRef";
      ticketId?: string | null;
    }> | null;
  };
};

export type CreateClientIntegrationMutationVariables = Exact<{
  input: CreateClientIntegrationInput;
}>;

export type CreateClientIntegrationMutation = {
  __typename: "Mutation";
  createClientIntegration: {
    __typename: "CreateClientIntegrationPayload";
    integration: {
      __typename: "ClientIntegration";
      mrn: string;
      token?: string | null;
      name: string;
      status: string;
      created: string;
      lastCheckin?: string | null;
      type: ClientIntegrationType;
      messages?: Array<{
        __typename: "IntegrationMessage";
        message: string;
        status: IntegrationMessageStatus;
      }> | null;
      configurationOptions?:
        | {
            __typename: "AWSConfigurationOptions";
            region: string;
            isOrganization?: boolean | null;
            snsEndpoint: string;
            originAWSAccountId: string;
            cloudFormationTemplateUrl: string;
            cloudFormationQuickcreateUrl: string;
            useWif: boolean;
            scanConfiguration: {
              __typename: "ScanConfiguration";
              accountScan: boolean;
              ec2Scan: boolean;
              ecrScan: boolean;
              ecsScan: boolean;
              cronScaninHours: number;
              ec2ScanOptions: {
                __typename: "Ec2ScanOptions";
                ebsVolumeScan: boolean;
                instanceConnect: boolean;
                instanceIdsFilter?: Array<string> | null;
                excludedInstanceIdsFilter?: Array<string> | null;
                regionsFilter?: Array<string> | null;
                excludedRegionsFilter?: Array<string> | null;
                ssm: boolean;
                tagsFilter: any;
                excludedTagsFilter?: any | null;
              };
              vpcConfiguration?: {
                __typename: "VPCConfiguration";
                CIDR?: string | null;
                vpcFlavour?: VpcFlavour | null;
                vpcTag?: {
                  __typename: "VPCTag";
                  key: string;
                  value: string;
                } | null;
              } | null;
            };
          }
        | {
            __typename: "AgentOptions";
            id: string;
            version?: string | null;
            notes: string;
            hostname: string;
            ipaddress: string;
            platform?: {
              __typename: "Platform";
              name: string;
              release: string;
              arch: string;
              kind: PlatformKind;
              runtime: string;
            } | null;
          }
        | { __typename: "AttackSurfaceConfigurationOptions" }
        | { __typename: "AuditLogExportConfigurationOptions" }
        | { __typename: "AwsS3ConfigurationOptions" }
        | { __typename: "AzureBlobConfigurationOptions" }
        | {
            __typename: "AzureConfigurationOptions";
            tenantId: string;
            clientId: string;
            subscriptionsWhitelist?: Array<string> | null;
            subscriptionsBlacklist?: Array<string> | null;
            scanVms?: boolean | null;
          }
        | { __typename: "AzureDevopsConfigurationOptions" }
        | { __typename: "BigqueryConfigurationOptions" }
        | { __typename: "CloudflareConfigurationOptions" }
        | {
            __typename: "CrowdstrikeFalconConfigurationOptions";
            clientId: string;
            cloud?: string | null;
            memberCID?: string | null;
            createAssets?: boolean | null;
            mondooEnrichment?: boolean | null;
          }
        | { __typename: "DigitaloceanConfigurationOptions" }
        | { __typename: "ElasticConfigurationOptions" }
        | {
            __typename: "EmailConfigurationOptions";
            autoCreateTickets: boolean;
            recipients: Array<{
              __typename: "EmailRecipient";
              name: string;
              email: string;
              isDefault: boolean;
              referenceUrl?: string | null;
            }>;
          }
        | {
            __typename: "GcpConfigurationOptions";
            projectId?: string | null;
            organizationId?: string | null;
            discoverAll?: boolean | null;
            wifAudience?: string | null;
            wifServiceAccountEmail?: string | null;
            wifSubject?: string | null;
          }
        | { __typename: "GcpServerlessConfigurationOptions" }
        | {
            __typename: "GcsBucketConfigurationOptions";
            output: BucketOutputType;
            bucket: string;
          }
        | {
            __typename: "GithubConfigurationOptions";
            owner?: string | null;
            repository?: string | null;
            reposAllowList?: Array<string> | null;
            reposDenyList?: Array<string> | null;
            enterpriseUrl?: string | null;
            githubOrg?: string | null;
            githubType: GithubIntegrationType;
            githubDiscoverK8sManifests: boolean;
            githubDiscoverTerraform: boolean;
          }
        | { __typename: "GithubTicketingConfigurationOptions" }
        | {
            __typename: "GitlabConfigurationOptions";
            group: string;
            type: GitlabIntegrationType;
            discoverGroups?: boolean | null;
            discoverProjects?: boolean | null;
            discoverTerraform?: boolean | null;
            discoverK8sManifests: boolean;
            baseUrl: string;
          }
        | { __typename: "GitlabTicketingConfigurationOptions" }
        | { __typename: "GoogleSccExportConfigurationOptions" }
        | { __typename: "GoogleSccImportConfigurationOptions" }
        | {
            __typename: "GoogleWorkspaceConfigurationOptions";
            customerId: string;
            impersonatedUserEmail: string;
          }
        | { __typename: "HetznerConfigurationOptions" }
        | {
            __typename: "HostConfigurationOptions";
            discoverSubdomains?: boolean | null;
            host: string;
            http?: boolean | null;
            https?: boolean | null;
          }
        | {
            __typename: "HostedAwsConfigurationOptions";
            accessKeyId?: string | null;
            role?: string | null;
            wifAudience?: string | null;
            wifRoleArn?: string | null;
            wifSubject?: string | null;
          }
        | { __typename: "JiraConfigurationOptions" }
        | {
            __typename: "K8sConfigurationOptions";
            scanNodes?: boolean | null;
            scanNodesStyle: K8sScanNodesStyle;
            scanWorkloads?: boolean | null;
            scanDeploys?: boolean | null;
            certificateManager: string;
            scanPublicImages?: boolean | null;
            namespaceAllowList?: Array<string> | null;
            namespaceDenyList?: Array<string> | null;
          }
        | {
            __typename: "MicrosoftDefenderConfigurationOptions";
            tenantId: string;
            clientId: string;
            subscriptionsAllowlist?: Array<string> | null;
            subscriptionsDenylist?: Array<string> | null;
            secretType?: string | null;
            createAssets?: boolean | null;
            mondooEnrichment?: boolean | null;
          }
        | {
            __typename: "Ms365ConfigurationOptions";
            tenantId: string;
            clientId: string;
          }
        | { __typename: "MsIntuneConfigurationOptions" }
        | { __typename: "NetworkScanConfigurationOptions" }
        | { __typename: "NextdnsConfigurationOptions" }
        | {
            __typename: "OciConfigurationOptions";
            tenancyOcid: string;
            userOcid: string;
            region: string;
            fingerprint: string;
          }
        | { __typename: "OktaConfigurationOptions"; organization: string }
        | { __typename: "OpenvasConfigurationOptions" }
        | {
            __typename: "PostgresConfigurationOptions";
            host: string;
            port: string;
            database: string;
            user: string;
          }
        | { __typename: "QualysConfigurationOptions" }
        | { __typename: "S3ConfigurationOptions" }
        | {
            __typename: "SecurityPipelineGithubConfigurationOptions";
            appInstallationLink: string;
            publicKey?: string | null;
            repositories?: Array<{
              __typename: "GithubRepository";
              link: string;
              fullName: string;
              spaceMrn?: string | null;
            }> | null;
          }
        | { __typename: "SecurityScorecardConfigurationOptions" }
        | {
            __typename: "SentinelOneConfigurationOptions";
            host: string;
            account: string;
            secretType?: string | null;
            createAssets?: boolean | null;
            mondooEnrichment?: boolean | null;
          }
        | {
            __typename: "ServiceNowConfigurationOptions";
            instanceUrl: string;
            clientId: string;
            autoCloseTickets: boolean;
            autoCreateTickets: boolean;
            userEmail?: string | null;
          }
        | {
            __typename: "ShodanConfigurationOptions";
            token: string;
            targets?: Array<string> | null;
          }
        | { __typename: "SlackConfigurationOptions"; placeholder: string }
        | { __typename: "SnowflakeConfigurationOptions" }
        | { __typename: "SnowflakeScanConfigurationOptions" }
        | { __typename: "SnykConfigurationOptions" }
        | { __typename: "SonarqubeConfigurationOptions" }
        | { __typename: "SplunkConfigurationOptions" }
        | { __typename: "StackitConfigurationOptions" }
        | { __typename: "TailscaleConfigurationOptions" }
        | { __typename: "TenableConfigurationOptions" }
        | { __typename: "TenableSCConfigurationOptions" }
        | {
            __typename: "WebhookConfigurationOptions";
            autoCreateTickets: boolean;
            autoCloseTickets: boolean;
            url: string;
          }
        | {
            __typename: "ZendeskConfigurationOptions";
            subdomain: string;
            email: string;
            autoCloseTickets: boolean;
            autoCreateTickets: boolean;
            customFields?: Array<{
              __typename: "ZendeskCustomField";
              id: number;
              value: string;
            }> | null;
          }
        | null;
    };
  };
};

export type CreateExceptionMutationVariables = Exact<{
  input: ExceptionMutationInput;
}>;

export type CreateExceptionMutation = {
  __typename: "Mutation";
  createException: {
    __typename: "CreateExceptionResponse";
    exceptionGroup: {
      __typename: "ExceptionGroup";
      id: string;
      exceptionId: string;
    };
  };
};

export type CreateExceptionForScopesMutationVariables = Exact<{
  input: ApplyExceptionForScopesInput;
}>;

export type CreateExceptionForScopesMutation = {
  __typename: "Mutation";
  applyExceptionForScopes: boolean;
};

export type CreateInvitationMutationVariables = Exact<{
  input: CreateInvitationInput;
}>;

export type CreateInvitationMutation = {
  __typename: "Mutation";
  createInvitation: { __typename: "Invitation"; mrn: string };
};

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;

export type CreateOrganizationMutation = {
  __typename: "Mutation";
  createOrganization?: {
    __typename: "Organization";
    id: string;
    mrn: string;
  } | null;
};

export type CreateServiceAccountMutationVariables = Exact<{
  input: CreateServiceAccountInput;
}>;

export type CreateServiceAccountMutation = {
  __typename: "Mutation";
  createServiceAccount?: {
    __typename: "ServiceAccountCredential";
    mrn: string;
    certificate: string;
    privateKey: string;
    scopeMrn: string;
    apiEndpoint: string;
    spaceMrn?: string | null;
  } | null;
};

export type CreateSpaceMutationVariables = Exact<{
  input: CreateSpaceInput;
}>;

export type CreateSpaceMutation = {
  __typename: "Mutation";
  createSpace?: { __typename: "Space"; id: string; mrn: string } | null;
};

export type CreateWorkspaceMutationVariables = Exact<{
  input: CreateWorkspaceInput;
}>;

export type CreateWorkspaceMutation = {
  __typename: "Mutation";
  createWorkspace: { __typename: "Workspace"; mrn: string };
};

export type DeclineInvitationMutationVariables = Exact<{
  invitationMrn: Scalars["ID"]["input"];
}>;

export type DeclineInvitationMutation = {
  __typename: "Mutation";
  declineInvitation: boolean;
};

export type DeleteAgentsMutationVariables = Exact<{
  input: DeleteAgentsInput;
}>;

export type DeleteAgentsMutation = {
  __typename: "Mutation";
  deleteAgents: {
    __typename: "DeleteAgentsPayload";
    agentMrns: Array<string>;
    errors: any;
  };
};

export type DeleteApiTokenMutationVariables = Exact<{
  input: DeleteApiTokenInput;
}>;

export type DeleteApiTokenMutation = {
  __typename: "Mutation";
  deleteAPIToken?: { __typename: "DeleteAPITokenResponse"; ok: boolean } | null;
};

export type DeleteAssetsMutationVariables = Exact<{
  input: DeleteAssetsInput;
}>;

export type DeleteAssetsMutation = {
  __typename: "Mutation";
  deleteAssets?: {
    __typename: "DeleteAssetsPayload";
    assetMrns?: Array<string> | null;
    errors: any;
  } | null;
};

export type DeleteCicdProjectsMutationVariables = Exact<{
  input: DeleteProjectsInput;
}>;

export type DeleteCicdProjectsMutation = {
  __typename: "Mutation";
  deleteCicdProjects: {
    __typename: "DeleteProjectsPayload";
    mrns: Array<string>;
  };
};

export type DeleteClientIntegrationMutationVariables = Exact<{
  input: DeleteClientIntegrationInput;
}>;

export type DeleteClientIntegrationMutation = {
  __typename: "Mutation";
  deleteClientIntegration: {
    __typename: "DeleteClientIntegrationPayload";
    mrn: string;
  };
};

export type DeleteCustomPolicyMutationVariables = Exact<{
  input: DeleteCustomPolicyInput;
}>;

export type DeleteCustomPolicyMutation = {
  __typename: "Mutation";
  deleteCustomPolicy: {
    __typename: "DeleteCustomPolicyPayload";
    policyMrn: string;
  };
};

export type DeleteCustomQueryPackMutationVariables = Exact<{
  input: DeleteCustomQueryPackInput;
}>;

export type DeleteCustomQueryPackMutation = {
  __typename: "Mutation";
  deleteCustomQueryPack: {
    __typename: "DeleteCustomQueryPackPayload";
    queryPackMrn: string;
  };
};

export type DeleteDocumentMutationVariables = Exact<{
  documentMrn: Scalars["String"]["input"];
}>;

export type DeleteDocumentMutation = {
  __typename: "Mutation";
  deleteDocument: boolean;
};

export type DeleteExceptionsMutationVariables = Exact<{
  input: ExceptionsDeleteInput;
}>;

export type DeleteExceptionsMutation = {
  __typename: "Mutation";
  deleteExceptions: boolean;
};

export type DeleteFrameworkMutationVariables = Exact<{
  input: DeleteFrameworkInput;
}>;

export type DeleteFrameworkMutation = {
  __typename: "Mutation";
  deleteFramework: boolean;
};

export type DeleteOrganizationMutationVariables = Exact<{
  orgMrn: Scalars["ID"]["input"];
}>;

export type DeleteOrganizationMutation = {
  __typename: "Mutation";
  deleteOrganization?: string | null;
};

export type DeletePolicyMutationVariables = Exact<{
  input: PolicyDeleteInput;
}>;

export type DeletePolicyMutation = {
  __typename: "Mutation";
  deletePolicy: boolean;
};

export type DeleteServiceAccountsMutationVariables = Exact<{
  input: DeleteServiceAccountsInput;
}>;

export type DeleteServiceAccountsMutation = {
  __typename: "Mutation";
  deleteServiceAccounts: {
    __typename: "DeleteServiceAccountsPayload";
    mrns: Array<string>;
    errors: any;
  };
};

export type DeleteSpaceMutationVariables = Exact<{
  spaceMrn: Scalars["ID"]["input"];
}>;

export type DeleteSpaceMutation = {
  __typename: "Mutation";
  deleteSpace?: string | null;
};

export type DeleteWorkspacesMutationVariables = Exact<{
  input: DeleteWorkspacesInput;
}>;

export type DeleteWorkspacesMutation = {
  __typename: "Mutation";
  deleteWorkspaces: boolean;
};

export type EditPropertiesMutationVariables = Exact<{
  input: PropertyQueryMutationInput;
}>;

export type EditPropertiesMutation = {
  __typename: "Mutation";
  applyPropertyQueryMutation:
    | {
        __typename: "PropertyQueryMutationInvalidProperty";
        message: string;
        code: string;
      }
    | {
        __typename: "PropertyQueryMutationInvalidTarget";
        message: string;
        code: string;
      }
    | { __typename: "PropertyQueryMutationSuccess"; success?: boolean | null };
};

export type EnableSsoProviderMutationVariables = Exact<{
  input: EnableSsoProviderInput;
}>;

export type EnableSsoProviderMutation = {
  __typename: "Mutation";
  enableSSOProvider: boolean;
};

export type ExtendExceptionMutationVariables = Exact<{
  input: ExtendExceptionInput;
}>;

export type ExtendExceptionMutation = {
  __typename: "Mutation";
  extendException: boolean;
};

export type GenerateApiTokenMutationVariables = Exact<{
  input: GenerateApiTokenInput;
}>;

export type GenerateApiTokenMutation = {
  __typename: "Mutation";
  generateAPIToken: {
    __typename: "GenerateAPITokenResponse";
    token: string;
    spaceMrn?: string | null;
    scopeMrn: string;
    name: string;
    mrn: string;
    description?: string | null;
    createdBy: string;
    createdAt: string;
  };
};

export type GenerateDocumentMutationVariables = Exact<{
  input: GenerateDocumentInput;
}>;

export type GenerateDocumentMutation = {
  __typename: "Mutation";
  generateDocument: { __typename: "GenerateDocumentPayload"; mrn: string };
};

export type GenerateRegistrationTokenMutationVariables = Exact<{
  input: RegistrationTokenInput;
}>;

export type GenerateRegistrationTokenMutation = {
  __typename: "Mutation";
  generateRegistrationToken: {
    __typename: "RegistrationToken";
    id: string;
    mrn: string;
    description: string;
    token: string;
    revoked: boolean;
    createdAt: string;
    createdBy: string;
    expiresAt: string;
    labels: Array<{
      __typename: "KeyValue";
      key: string;
      value?: string | null;
    }>;
  };
};

export type ModifySpaceRiskFactorsMutationVariables = Exact<{
  spaceMrn: Scalars["String"]["input"];
  riskFactors: Array<ModifyRiskFactorInput> | ModifyRiskFactorInput;
}>;

export type ModifySpaceRiskFactorsMutation = {
  __typename: "Mutation";
  modifyRiskFactors: boolean;
};

export type ProcessCaseEventsMutationVariables = Exact<{
  input: ProcessCaseEventsInput;
}>;

export type ProcessCaseEventsMutation = {
  __typename: "Mutation";
  processCaseEvents: boolean;
};

export type RefreshAggregateScoresMutationVariables = Exact<{
  groupMrn: Scalars["String"]["input"];
}>;

export type RefreshAggregateScoresMutation = {
  __typename: "Mutation";
  refreshAggregateScores: boolean;
};

export type RegisterUserActionMutationVariables = Exact<{
  input: RegisterUserActionInput;
}>;

export type RegisterUserActionMutation = {
  __typename: "Mutation";
  registerUserAction: boolean;
};

export type RemoveOrganizationMembershipMutationVariables = Exact<{
  input: RemoveOrganizationMembershipInput;
}>;

export type RemoveOrganizationMembershipMutation = {
  __typename: "Mutation";
  removeOrganizationMembership: boolean;
};

export type RemoveSpaceMembershipMutationVariables = Exact<{
  input: RemoveSpaceMembershipInput;
}>;

export type RemoveSpaceMembershipMutation = {
  __typename: "Mutation";
  removeSpaceMembership: boolean;
};

export type RequestDocumentDownloadUrlMutationVariables = Exact<{
  documentMrn: Scalars["String"]["input"];
}>;

export type RequestDocumentDownloadUrlMutation = {
  __typename: "Mutation";
  requestDocumentDownloadUrl: {
    __typename: "DocumentDownloadPayload";
    downloadUrl: string;
    expiresAt: string;
  };
};

export type ResendInvitationMutationVariables = Exact<{
  invitationMrn: Scalars["ID"]["input"];
}>;

export type ResendInvitationMutation = {
  __typename: "Mutation";
  resendInvitation: boolean;
};

export type RevokeRegistrationTokenMutationVariables = Exact<{
  input: RevokeRegistrationTokenInput;
}>;

export type RevokeRegistrationTokenMutation = {
  __typename: "Mutation";
  revokeRegistrationToken?:
    | {
        __typename: "RevokeRegistrationTokenFailure";
        message: string;
        code: string;
      }
    | { __typename: "RevokeRegistrationTokenSuccess"; ok: boolean }
    | null;
};

export type SetAssetAnnotationsMutationVariables = Exact<{
  input: SetAssetAnnotationsInput;
}>;

export type SetAssetAnnotationsMutation = {
  __typename: "Mutation";
  setAssetAnnotations?: {
    __typename: "SetAssetAnnotationsPayload";
    annotations: Array<{
      __typename: "KeyValue";
      key: string;
      value?: string | null;
    }>;
  } | null;
};

export type SetCustomPolicyMutationVariables = Exact<{
  input: Array<SetCustomPolicyInput> | SetCustomPolicyInput;
}>;

export type SetCustomPolicyMutation = {
  __typename: "Mutation";
  setCustomPolicy: {
    __typename: "SetCustomPolicyPayload";
    policyMrns?: Array<string> | null;
  };
};

export type SetEmailPreferenceMutationVariables = Exact<{
  input: Array<EmailPreferenceInput> | EmailPreferenceInput;
}>;

export type SetEmailPreferenceMutation = {
  __typename: "Mutation";
  setEmailPreference: boolean;
};

export type SetIntegrationMutationVariables = Exact<{
  input: IntegrationInput;
}>;

export type SetIntegrationMutation = {
  __typename: "Mutation";
  setIntegration: boolean;
};

export type SetOrganizationMembershipMutationVariables = Exact<{
  input: SetOrganizationMembershipInput;
}>;

export type SetOrganizationMembershipMutation = {
  __typename: "Mutation";
  setOrganizationMembership: boolean;
};

export type SetRolesMutationVariables = Exact<{
  input: SetRolesInput;
}>;

export type SetRolesMutation = {
  __typename: "Mutation";
  setRoles?: {
    __typename: "SetRolesPayload";
    mrns?: Array<string> | null;
    errors: any;
  } | null;
};

export type SetSsoProviderMutationVariables = Exact<{
  input: SetSsoProviderInput;
}>;

export type SetSsoProviderMutation = {
  __typename: "Mutation";
  setSSOProvider: boolean;
};

export type SetSpaceMembershipMutationVariables = Exact<{
  input: SetSpaceMembershipInput;
}>;

export type SetSpaceMembershipMutation = {
  __typename: "Mutation";
  setSpaceMembership: boolean;
};

export type SetViewerSettingMutationVariables = Exact<{
  key: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
}>;

export type SetViewerSettingMutation = {
  __typename: "Mutation";
  changeViewerSetting: boolean;
};

export type SuppressIntegrationMessageMutationVariables = Exact<{
  input: SuppressIntegrationMessageInput;
}>;

export type SuppressIntegrationMessageMutation = {
  __typename: "Mutation";
  suppressIntegrationMessage: {
    __typename: "SuppressIntegrationMessagePayload";
    mrn: string;
  };
};

export type UnassignPolicyMutationVariables = Exact<{
  input: PolicyAssignmentInput;
}>;

export type UnassignPolicyMutation = {
  __typename: "Mutation";
  unassignPolicy: boolean;
};

export type UpdateApiTokenMutationVariables = Exact<{
  input: UpdateApiTokenInput;
}>;

export type UpdateApiTokenMutation = {
  __typename: "Mutation";
  updateAPIToken?: {
    __typename: "APIToken";
    mrn: string;
    spaceMrn: string;
    name: string;
    description?: string | null;
    createdAt: string;
    lastUsed?: string | null;
    roles: Array<{ __typename: "Role"; mrn: string; title: string }>;
    creator?: {
      __typename: "APITokenCreator";
      mrn?: string | null;
      email?: string | null;
    } | null;
  } | null;
};

export type CloseCaseMutationVariables = Exact<{
  input: CloseCaseInput;
}>;

export type CloseCaseMutation = { __typename: "Mutation"; closeCase: boolean };

export type UpdateClientIntegrationConfigurationMutationVariables = Exact<{
  input: UpdateClientIntegrationConfigurationInput;
}>;

export type UpdateClientIntegrationConfigurationMutation = {
  __typename: "Mutation";
  updateClientIntegrationConfiguration: {
    __typename: "UpdateClientIntegrationConfigurationPayload";
    configurationOptions:
      | {
          __typename: "AWSConfigurationOptions";
          region: string;
          isOrganization?: boolean | null;
          snsEndpoint: string;
          scanConfiguration: {
            __typename: "ScanConfiguration";
            accountScan: boolean;
            ec2Scan: boolean;
            ecrScan: boolean;
            ecsScan: boolean;
            cronScaninHours: number;
            ec2ScanOptions: {
              __typename: "Ec2ScanOptions";
              ssm: boolean;
              instanceConnect: boolean;
              instanceIdsFilter?: Array<string> | null;
              excludedInstanceIdsFilter?: Array<string> | null;
              regionsFilter?: Array<string> | null;
              excludedRegionsFilter?: Array<string> | null;
              tagsFilter: any;
              excludedTagsFilter?: any | null;
              ebsVolumeScan: boolean;
            };
            vpcConfiguration?: {
              __typename: "VPCConfiguration";
              CIDR?: string | null;
              vpcFlavour?: VpcFlavour | null;
            } | null;
          };
        }
      | {
          __typename: "AgentOptions";
          id: string;
          version?: string | null;
          notes: string;
          hostname: string;
          ipaddress: string;
          platform?: {
            __typename: "Platform";
            name: string;
            release: string;
            arch: string;
            kind: PlatformKind;
            runtime: string;
          } | null;
        }
      | { __typename: "AttackSurfaceConfigurationOptions" }
      | { __typename: "AuditLogExportConfigurationOptions" }
      | { __typename: "AwsS3ConfigurationOptions" }
      | { __typename: "AzureBlobConfigurationOptions" }
      | {
          __typename: "AzureConfigurationOptions";
          tenantId: string;
          clientId: string;
          subscriptionsWhitelist?: Array<string> | null;
          subscriptionsBlacklist?: Array<string> | null;
          scanVms?: boolean | null;
          secretType?: string | null;
        }
      | {
          __typename: "AzureDevopsConfigurationOptions";
          defaultProjectName?: string | null;
          organizationUrl: string;
          servicePrincipalId: string;
          tenantId: string;
          autoCloseTickets: boolean;
          autoCreateTickets: boolean;
        }
      | { __typename: "BigqueryConfigurationOptions" }
      | { __typename: "CloudflareConfigurationOptions" }
      | {
          __typename: "CrowdstrikeFalconConfigurationOptions";
          clientId: string;
          cloud?: string | null;
          memberCID?: string | null;
          createAssets?: boolean | null;
          mondooEnrichment?: boolean | null;
        }
      | { __typename: "DigitaloceanConfigurationOptions" }
      | { __typename: "ElasticConfigurationOptions" }
      | { __typename: "EmailConfigurationOptions" }
      | {
          __typename: "GcpConfigurationOptions";
          projectId?: string | null;
          organizationId?: string | null;
          discoverAll?: boolean | null;
          wifAudience?: string | null;
          wifServiceAccountEmail?: string | null;
          wifSubject?: string | null;
        }
      | { __typename: "GcpServerlessConfigurationOptions" }
      | {
          __typename: "GcsBucketConfigurationOptions";
          output: BucketOutputType;
          bucket: string;
        }
      | {
          __typename: "GithubConfigurationOptions";
          owner?: string | null;
          repository?: string | null;
          reposAllowList?: Array<string> | null;
          reposDenyList?: Array<string> | null;
          enterpriseUrl?: string | null;
          githubOrg?: string | null;
          githubType: GithubIntegrationType;
          githubDiscoverK8sManifests: boolean;
          githubDiscoverTerraform: boolean;
        }
      | { __typename: "GithubTicketingConfigurationOptions" }
      | {
          __typename: "GitlabConfigurationOptions";
          group: string;
          type: GitlabIntegrationType;
          discoverGroups?: boolean | null;
          discoverProjects?: boolean | null;
          discoverTerraform?: boolean | null;
          discoverK8sManifests: boolean;
          baseUrl: string;
        }
      | { __typename: "GitlabTicketingConfigurationOptions" }
      | { __typename: "GoogleSccExportConfigurationOptions" }
      | { __typename: "GoogleSccImportConfigurationOptions" }
      | {
          __typename: "GoogleWorkspaceConfigurationOptions";
          customerId: string;
          impersonatedUserEmail: string;
        }
      | { __typename: "HetznerConfigurationOptions" }
      | {
          __typename: "HostConfigurationOptions";
          host: string;
          https?: boolean | null;
          http?: boolean | null;
          discoverSubdomains?: boolean | null;
        }
      | {
          __typename: "HostedAwsConfigurationOptions";
          accessKeyId?: string | null;
          role?: string | null;
          wifAudience?: string | null;
          wifRoleArn?: string | null;
          wifSubject?: string | null;
        }
      | { __typename: "JiraConfigurationOptions" }
      | {
          __typename: "K8sConfigurationOptions";
          scanNodes?: boolean | null;
          scanNodesStyle: K8sScanNodesStyle;
          scanWorkloads?: boolean | null;
          scanDeploys?: boolean | null;
          certificateManager: string;
          scanPublicImages?: boolean | null;
          namespaceAllowList?: Array<string> | null;
          namespaceDenyList?: Array<string> | null;
        }
      | {
          __typename: "MicrosoftDefenderConfigurationOptions";
          tenantId: string;
          clientId: string;
          subscriptionsAllowlist?: Array<string> | null;
          subscriptionsDenylist?: Array<string> | null;
          secretType?: string | null;
          createAssets?: boolean | null;
          mondooEnrichment?: boolean | null;
        }
      | {
          __typename: "Ms365ConfigurationOptions";
          tenantId: string;
          clientId: string;
        }
      | { __typename: "MsIntuneConfigurationOptions" }
      | { __typename: "NetworkScanConfigurationOptions" }
      | { __typename: "NextdnsConfigurationOptions" }
      | {
          __typename: "OciConfigurationOptions";
          tenancyOcid: string;
          userOcid: string;
          region: string;
          fingerprint: string;
        }
      | { __typename: "OktaConfigurationOptions"; organization: string }
      | { __typename: "OpenvasConfigurationOptions" }
      | { __typename: "PostgresConfigurationOptions" }
      | { __typename: "QualysConfigurationOptions" }
      | { __typename: "S3ConfigurationOptions" }
      | {
          __typename: "SecurityPipelineGithubConfigurationOptions";
          appInstallationLink: string;
          publicKey?: string | null;
          autoCreateWorkflows: boolean;
          repositories?: Array<{
            __typename: "GithubRepository";
            link: string;
            fullName: string;
            spaceMrn?: string | null;
          }> | null;
        }
      | { __typename: "SecurityScorecardConfigurationOptions" }
      | {
          __typename: "SentinelOneConfigurationOptions";
          host: string;
          account: string;
          secretType?: string | null;
          createAssets?: boolean | null;
          mondooEnrichment?: boolean | null;
        }
      | {
          __typename: "ServiceNowConfigurationOptions";
          instanceUrl: string;
          clientId: string;
          autoCloseTickets: boolean;
          autoCreateTickets: boolean;
          userEmail?: string | null;
        }
      | {
          __typename: "ShodanConfigurationOptions";
          token: string;
          targets?: Array<string> | null;
        }
      | { __typename: "SlackConfigurationOptions" }
      | { __typename: "SnowflakeConfigurationOptions" }
      | { __typename: "SnowflakeScanConfigurationOptions" }
      | { __typename: "SnykConfigurationOptions" }
      | { __typename: "SonarqubeConfigurationOptions" }
      | { __typename: "SplunkConfigurationOptions" }
      | { __typename: "StackitConfigurationOptions" }
      | { __typename: "TailscaleConfigurationOptions" }
      | { __typename: "TenableConfigurationOptions" }
      | { __typename: "TenableSCConfigurationOptions" }
      | {
          __typename: "WebhookConfigurationOptions";
          url: string;
          autoCloseTickets: boolean;
          autoCreateTickets: boolean;
        }
      | { __typename: "ZendeskConfigurationOptions" };
  };
};

export type UpdateOrganizationNameMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;

export type UpdateOrganizationNameMutation = {
  __typename: "Mutation";
  updateOrganization: {
    __typename: "UpdateOrganizationPayload";
    organization: {
      __typename: "Organization";
      name: string;
      mrn: string;
      company?: string | null;
      description: string;
    };
  };
};

export type UpdateSecurityModelMutationVariables = Exact<{
  input: UpdateSecurityModelInput;
}>;

export type UpdateSecurityModelMutation = {
  __typename: "Mutation";
  updateSecurityModel?: {
    __typename: "SecurityModel";
    scopeMrn: string;
    slas: {
      __typename: "SLAs";
      startDateConfig?: SlaStartDateConfig | null;
      findings: Array<{
        __typename: "FindingsSLA";
        rating: ScoreRating;
        daysToResolve: number;
        daysBeforeWarning: number;
      }>;
    };
  } | null;
};

export type UpdateSpaceMutationVariables = Exact<{
  input: UpdateSpaceInput;
}>;

export type UpdateSpaceMutation = {
  __typename: "Mutation";
  updateSpace: {
    __typename: "UpdateSpacePayload";
    space: {
      __typename: "Space";
      name: string;
      mrn: string;
      settings?: {
        __typename: "SpaceSettings";
        eolAssetsConfiguration: {
          __typename: "EolAssetsConfiguration";
          enable: boolean;
          monthsInAdvance: number;
        };
        exceptionsConfiguration?: {
          __typename: "ExceptionsConfiguration";
          requireApproval?: boolean | null;
          allowSelfApproval?: boolean | null;
          allowIndefiniteValidUntil?: boolean | null;
        } | null;
        garbageCollectAssetsConfiguration: {
          __typename: "GarbageCollectAssetsConfiguration";
          enable: boolean;
          afterDays: number;
        };
        terminatedAssetsConfiguration: {
          __typename: "TerminatedAssetsConfiguration";
          cleanup: boolean;
          after: number;
        };
        unusedServiceAccountsConfiguration: {
          __typename: "UnusedServiceAccountsConfiguration";
          cleanup: boolean;
          after: number;
        };
        platformVulnerabilityConfiguration: {
          __typename: "PlatformVulnerabilityConfiguration";
          enable: boolean;
        };
        casesConfiguration: {
          __typename: "CasesConfiguration";
          autoCreate: boolean;
          aggregationWindow: number;
        };
        platformMqlVexConfiguration: {
          __typename: "PlatformMqlVexConfiguration";
          enable: boolean;
        };
        mvdExperimentalSourcesConfiguration: {
          __typename: "MvdExperimentalSourcesConfiguration";
          sources?: Array<{
            __typename: "MvdSource";
            id: string;
            name: string;
            enabled: boolean;
          }> | null;
        };
      } | null;
    };
  };
};

export type UpdateUserNameMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserNameMutation = {
  __typename: "Mutation";
  updateUser: {
    __typename: "UpdateUserPayload";
    user: { __typename: "User"; name: string; mrn: string };
  };
};

export type UpdateWorkspaceMutationVariables = Exact<{
  input: UpdateWorkspaceInput;
}>;

export type UpdateWorkspaceMutation = {
  __typename: "Mutation";
  updateWorkspace: {
    __typename: "Workspace";
    mrn: string;
    name: string;
    description?: string | null;
    selections: {
      __typename: "WorkspaceSelections";
      selections: Array<{
        __typename: "WorkspaceSelection";
        conditions: Array<{
          __typename: "WorkspaceSelectionCondition";
          operator: WorkspaceSelectionConditionOperator;
          condition:
            | {
                __typename: "WorkspaceSelectionIntCondition";
                intField: WorkspaceSelectionConditionIntField;
                intOperator: WorkspaceSelectionConditionNumericOperator;
                intValues: Array<number>;
              }
            | {
                __typename: "WorkspaceSelectionKeyValueCondition";
                keyValueField: WorkspaceSelectionConditionKeyValueField;
                keyValueOperator: WorkspaceSelectionConditionKeyValueOperator;
                keyValueValues: Array<{
                  __typename: "KeyValue";
                  key: string;
                  value?: string | null;
                }>;
              }
            | {
                __typename: "WorkspaceSelectionRatingCondition";
                ratingField: WorkspaceSelectionConditionRatingField;
                ratingOperator: WorkspaceSelectionConditionRatingOperator;
                ratingValues: Array<ScoreRating>;
              }
            | {
                __typename: "WorkspaceSelectionStringCondition";
                stringField: WorkspaceSelectionConditionStringField;
                stringOperator: WorkspaceSelectionConditionStringOperator;
                stringValues: Array<{
                  __typename: "WorkspaceSelectionStringConditionValue";
                  value: string;
                  displayName: string;
                }>;
              };
        }>;
      }>;
    };
  };
};

export type UploadFrameworkMutationVariables = Exact<{
  input: UploadFrameworkInput;
}>;

export type UploadFrameworkMutation = {
  __typename: "Mutation";
  uploadFramework: boolean;
};

export type AgentForwardPaginationQueryVariables = Exact<{
  spaceMrn: Scalars["String"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  queryTerms?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  version?: InputMaybe<Array<AgentVersionFilter> | AgentVersionFilter>;
  state?: InputMaybe<Array<AgentState> | AgentState>;
  orderBy?: InputMaybe<AgentOrder>;
}>;

export type AgentForwardPaginationQuery = {
  __typename: "Query";
  agents?: {
    __typename: "AgentsConnection";
    totalCount: number;
    edges?: Array<{
      __typename: "AgentEdge";
      cursor: string;
      node?: {
        __typename: "Agent";
        id: string;
        mrn: string;
        name: string;
        hostname: string;
        ipaddress: string;
        createdAt: string;
        status?: {
          __typename: "AgentStatus";
          version?: string | null;
          state?: AgentState | null;
          lastCheckin?: string | null;
        } | null;
        labels: Array<{
          __typename: "KeyValue";
          key: string;
          value?: string | null;
        }>;
        platform?: {
          __typename: "Platform";
          name: string;
          release: string;
          arch: string;
        } | null;
      } | null;
    }> | null;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
    };
  } | null;
};

export type AssetForwardPaginationQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  queryTerms?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  platformTitle?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  platformName?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  platformKind?: InputMaybe<Array<PlatformKind> | PlatformKind>;
  platformRuntime?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  scoreType: ScoreType;
  labels?: InputMaybe<Array<KeyValueInput> | KeyValueInput>;
  updated?: InputMaybe<AssetUpdateFilter>;
  eol?: InputMaybe<AssetEolFilter>;
  reboot?: InputMaybe<AssetOsRebootFilter>;
  exploitable?: InputMaybe<AssetExploitableFilter>;
  orderBy?: InputMaybe<AssetOrder>;
  groups?: InputMaybe<Array<GroupFilter> | GroupFilter>;
  assetTypes?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  relatedToAssetMrn?: InputMaybe<Scalars["String"]["input"]>;
  assetUrlFilter?: InputMaybe<
    Array<AssetUrlSegmentInput> | AssetUrlSegmentInput
  >;
  rating?: InputMaybe<Array<ScoreRating> | ScoreRating>;
  initiativeMrn?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AssetForwardPaginationQuery = {
  __typename: "Query";
  assets?: {
    __typename: "AssetsConnection";
    totalCount: number;
    edges?: Array<{
      __typename: "AssetEdge";
      cursor: string;
      node?: {
        __typename: "Asset";
        id: string;
        mrn: string;
        name?: string | null;
        state: AssetState;
        updatedAt?: string | null;
        score: {
          __typename: "Score";
          id: string;
          value: number;
          type: number;
          completion: number;
          weight: number;
          message: string;
          riskRating: ScoreRating;
          riskValue: number;
        };
        labels: Array<{
          __typename: "KeyValue";
          key: string;
          value?: string | null;
        }>;
        platform?: {
          __typename: "Platform";
          name: string;
          title: string;
          release: string;
          arch: string;
          kind: PlatformKind;
          runtime: string;
        } | null;
      } | null;
    }> | null;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
    };
  } | null;
};

export type AssetSearchSuggestionsQueryVariables = Exact<{
  input: AssetSearchSuggestionsInput;
}>;

export type AssetSearchSuggestionsQuery = {
  __typename: "Query";
  assetSearchSuggestions: {
    __typename: "AssetSearchSuggestions";
    suggestions: Array<{ __typename: "Suggestion"; value: string }>;
  };
};

export type AuditLogForwardPaginationQueryVariables = Exact<{
  resourceMrn: Scalars["String"]["input"];
  actionFilter?: InputMaybe<Scalars["String"]["input"]>;
  identityFilter?: InputMaybe<IdentityFilter>;
  timestampFilter?: InputMaybe<TimestampFilter>;
  orderBy?: InputMaybe<AuditLogOrder>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AuditLogForwardPaginationQuery = {
  __typename: "Query";
  auditlog?: {
    __typename: "AuditLogConnection";
    totalCount: number;
    edges?: Array<{
      __typename: "AuditLogEdge";
      cursor: string;
      node?: {
        __typename: "AuditLogEntry";
        resource: string;
        action: string;
        timestamp: string;
        msg?: string | null;
        ip?: string | null;
        parent?: string | null;
        identity:
          | { __typename: "PendingUser"; name: string; mrn: string }
          | { __typename: "ServiceAccount"; name: string; mrn: string }
          | { __typename: "Team"; name: string; mrn: string }
          | { __typename: "User"; name: string; mrn: string };
      } | null;
    }> | null;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
    };
  } | null;
};

export type DownloadBundleQueryVariables = Exact<{
  input: DownloadBundleInput;
}>;

export type DownloadBundleQuery = {
  __typename: "Query";
  downloadBundle: { __typename: "PolicyBundleYaml"; yaml: string };
};

export type DownloadFrameworkQueryVariables = Exact<{
  input: DownloadFrameworkInput;
}>;

export type DownloadFrameworkQuery = {
  __typename: "Query";
  downloadFramework: { __typename: "FrameworkBundle"; yaml: string };
};

export type FindNewAwsAssetQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
}>;

export type FindNewAwsAssetQuery = {
  __typename: "Query";
  assets?: {
    __typename: "AssetsConnection";
    edges?: Array<{
      __typename: "AssetEdge";
      cursor: string;
      node?: {
        __typename: "Asset";
        mrn: string;
        platform?: { __typename: "Platform"; name: string } | null;
      } | null;
    }> | null;
  } | null;
};

export type GetActivePoliciesQueryVariables = Exact<{
  input: ActivePoliciesInput;
}>;

export type GetActivePoliciesQuery = {
  __typename: "Query";
  activePolicies?: {
    __typename: "ActivePoliciesConnection";
    totalCount: number;
    edges?: Array<{
      __typename: "ActivePolicyEdge";
      cursor: string;
      node?: {
        __typename: "ActivePolicy";
        mrn: string;
        name: string;
        icon: Icon_Ids;
        updatedAt: string;
        lastAppliedAt?: string | null;
        version?: string | null;
        created_at?: string | null;
        action: PolicyAction;
        score?: {
          __typename: "AggregateScore";
          riskValue?: number | null;
          rating: ScoreRating;
          blastRadius?: {
            __typename: "BlastRadius";
            indicator: string;
            assets: number;
            affected: number;
            critical: number;
            high: number;
            medium: number;
            low: number;
            none: number;
            error: number;
            pass: number;
          } | null;
        } | null;
      } | null;
    }> | null;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
};

export type GetActivePoliciesCountQueryVariables = Exact<{
  input: ActivePoliciesInput;
}>;

export type GetActivePoliciesCountQuery = {
  __typename: "Query";
  activePolicies?: {
    __typename: "ActivePoliciesConnection";
    totalCount: number;
  } | null;
};

export type GetAdvisoriesQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  filter?: InputMaybe<FindingsFilter>;
}>;

export type GetAdvisoriesQuery = {
  __typename: "Query";
  findings?:
    | {
        __typename: "FindingsConnection";
        totalCount: number;
        filteredTotalCount: number;
        edges?: Array<{
          __typename: "FindingsEdge";
          cursor: string;
          node?:
            | {
                __typename: "AdvisoryFinding";
                id: string;
                mrn: string;
                title: string;
                rating: ScoreRating;
                riskValue: number;
                lastUpdated: string;
                publishedAt?: string | null;
                firstDetectedAt: string;
                iconId: Icon_Ids;
                state: ScoreState;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                } | null;
                cases?: {
                  __typename: "CasesConnection";
                  totalCount: number;
                  edges?: Array<{
                    __typename: "CaseEdge";
                    node: {
                      __typename: "Case";
                      status: CaseStatus;
                      mrn: string;
                      createdAt: string;
                      ticketRefs?: Array<{
                        __typename: "TicketRef";
                        type: TicketRefType;
                      }> | null;
                    };
                  }> | null;
                } | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                exception?: {
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  scope: string;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  justification: string;
                  action: ExceptionMutationAction;
                  createdAt: string;
                  author?: {
                    __typename: "Author";
                    name: string;
                    mrn?: string | null;
                    email?: string | null;
                    type: AuthorType;
                  } | null;
                } | null;
                spaceRiskDelta?: {
                  __typename: "FindingSpaceRiskDelta";
                  delta: number;
                  effort: number;
                  manualEffort: {
                    __typename: "ManualEffort";
                    totalManualEffort: number;
                    research: number;
                    scripting: number;
                    rollout: number;
                    verification: number;
                  };
                } | null;
              }
            | { __typename: "CheckFinding" }
            | { __typename: "CveFinding" }
            | { __typename: "GenericFinding" }
            | { __typename: "PackageFinding" }
            | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetAffectedAssetsQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  filter?: InputMaybe<FindingsFilter>;
}>;

export type GetAffectedAssetsQuery = {
  __typename: "Query";
  findings?:
    | {
        __typename: "FindingsConnection";
        totalCount: number;
        filteredTotalCount: number;
        edges?: Array<{
          __typename: "FindingsEdge";
          cursor: string;
          node?:
            | {
                __typename: "AdvisoryFinding";
                id: string;
                iconId: Icon_Ids;
                lastUpdated: string;
                firstDetectedAt: string;
                mrn: string;
                riskValue: number;
                rating: ScoreRating;
                title: string;
                state: ScoreState;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  tags?: Array<{
                    __typename: "Tag";
                    key: string;
                    value: string;
                  } | null> | null;
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                spaceRiskDelta?: {
                  __typename: "FindingSpaceRiskDelta";
                  delta: number;
                  effort: number;
                  manualEffort: {
                    __typename: "ManualEffort";
                    research: number;
                    rollout: number;
                    scripting: number;
                    totalManualEffort: number;
                    verification: number;
                  };
                } | null;
                exception?: {
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  scope: string;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  justification: string;
                  action: ExceptionMutationAction;
                  createdAt: string;
                  author?: {
                    __typename: "Author";
                    name: string;
                    mrn?: string | null;
                    email?: string | null;
                    type: AuthorType;
                  } | null;
                } | null;
                cases?: {
                  __typename: "CasesConnection";
                  totalCount: number;
                  edges?: Array<{
                    __typename: "CaseEdge";
                    node: {
                      __typename: "Case";
                      status: CaseStatus;
                      mrn: string;
                      createdAt: string;
                      ticketRefs?: Array<{
                        __typename: "TicketRef";
                        type: TicketRefType;
                      }> | null;
                    };
                  }> | null;
                } | null;
              }
            | {
                __typename: "CheckFinding";
                id: string;
                iconId: Icon_Ids;
                lastUpdated: string;
                mrn: string;
                riskValue: number;
                rating: ScoreRating;
                title: string;
                state: ScoreState;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  tags?: Array<{
                    __typename: "Tag";
                    key: string;
                    value: string;
                  } | null> | null;
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                spaceRiskDelta?: {
                  __typename: "FindingSpaceRiskDelta";
                  delta: number;
                  effort: number;
                  manualEffort: {
                    __typename: "ManualEffort";
                    research: number;
                    rollout: number;
                    scripting: number;
                    totalManualEffort: number;
                    verification: number;
                  };
                } | null;
                exception?: {
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  action: ExceptionMutationAction;
                  createdAt: string;
                } | null;
                cases?: {
                  __typename: "CasesConnection";
                  totalCount: number;
                  edges?: Array<{
                    __typename: "CaseEdge";
                    node: {
                      __typename: "Case";
                      status: CaseStatus;
                      mrn: string;
                      createdAt: string;
                      ticketRefs?: Array<{
                        __typename: "TicketRef";
                        type: TicketRefType;
                      }> | null;
                    };
                  }> | null;
                } | null;
              }
            | {
                __typename: "CveFinding";
                id: string;
                iconId: Icon_Ids;
                lastUpdated: string;
                firstDetectedAt: string;
                mrn: string;
                riskValue: number;
                rating: ScoreRating;
                title: string;
                state: ScoreState;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  tags?: Array<{
                    __typename: "Tag";
                    key: string;
                    value: string;
                  } | null> | null;
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                spaceRiskDelta?: {
                  __typename: "FindingSpaceRiskDelta";
                  delta: number;
                  effort: number;
                  manualEffort: {
                    __typename: "ManualEffort";
                    research: number;
                    rollout: number;
                    scripting: number;
                    totalManualEffort: number;
                    verification: number;
                  };
                } | null;
                exception?: {
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  scope: string;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  justification: string;
                  action: ExceptionMutationAction;
                  createdAt: string;
                  author?: {
                    __typename: "Author";
                    name: string;
                    mrn?: string | null;
                    email?: string | null;
                    type: AuthorType;
                  } | null;
                } | null;
                cases?: {
                  __typename: "CasesConnection";
                  totalCount: number;
                  edges?: Array<{
                    __typename: "CaseEdge";
                    node: {
                      __typename: "Case";
                      status: CaseStatus;
                      mrn: string;
                      createdAt: string;
                      ticketRefs?: Array<{
                        __typename: "TicketRef";
                        type: TicketRefType;
                      }> | null;
                    };
                  }> | null;
                } | null;
              }
            | { __typename: "GenericFinding" }
            | {
                __typename: "PackageFinding";
                id: string;
                packageName?: string | null;
                mrn: string;
                rating: ScoreRating;
                riskValue: number;
                lastUpdated: string;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  tags?: Array<{
                    __typename: "Tag";
                    key: string;
                    value: string;
                  } | null> | null;
                } | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                cases?: {
                  __typename: "CasesConnection";
                  totalCount: number;
                  edges?: Array<{
                    __typename: "CaseEdge";
                    node: {
                      __typename: "Case";
                      status: CaseStatus;
                      mrn: string;
                      createdAt: string;
                      ticketRefs?: Array<{
                        __typename: "TicketRef";
                        type: TicketRefType;
                      }> | null;
                    };
                  }> | null;
                } | null;
              }
            | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetAggregateScoresQueryVariables = Exact<{
  entityMrn: Scalars["String"]["input"];
  filter?: InputMaybe<AggregateScoreFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<AggregateScoreOrder>;
  skipCases?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetAggregateScoresQuery = {
  __typename: "Query";
  aggregateScores?:
    | {
        __typename: "AggregateScoresConnection";
        totalCount: number;
        edges?: Array<{
          __typename: "AggregateScoreEdge";
          cursor: string;
          node?: {
            __typename: "AggregateScore";
            id: string;
            iconId: Icon_Ids;
            state: AggregateScoreState;
            effort: number;
            enforcementState: EnforcementState;
            previewUntil?: string | null;
            findingMrn: string;
            rank: number;
            baseScore?: number | null;
            baseValue: number;
            baseRating: ScoreRating;
            completion?: number | null;
            riskValue?: number | null;
            rankScore: number;
            scoreType: AggregateScoreType;
            rating: ScoreRating;
            title: string;
            description: string;
            lastScannedAt?: string | null;
            firstDetectedAt: string;
            remediatedAt: string;
            spaceId: string;
            spaceRiskImprovement: number;
            slaAtRiskCount: number;
            slaOverdueCount: number;
            manualEffort?: {
              __typename: "ManualEffort";
              totalManualEffort: number;
              research: number;
              scripting: number;
              rollout: number;
              verification: number;
            } | null;
            entity?:
              | {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                }
              | {
                  __typename: "EntityInfoOrganization";
                  id: string;
                  mrn: string;
                  name: string;
                  contacts?: Array<{
                    __typename: "ResourceContact";
                    contactType: ResourceContactType;
                    identity: string;
                    email?: string | null;
                    name?: string | null;
                  }> | null;
                }
              | { __typename: "EntityInfoPlatform" }
              | {
                  __typename: "EntityInfoSpace";
                  id: string;
                  mrn: string;
                  name: string;
                  contacts?: Array<{
                    __typename: "ResourceContact";
                    contactType: ResourceContactType;
                    identity: string;
                    email?: string | null;
                    name?: string | null;
                  }> | null;
                }
              | { __typename: "EntityInfoUnknown" }
              | {
                  __typename: "EntityInfoWorkspace";
                  id: string;
                  mrn: string;
                  name: string;
                  contacts?: Array<{
                    __typename: "ResourceContact";
                    contactType: ResourceContactType;
                    identity: string;
                    email?: string | null;
                    name?: string | null;
                  }> | null;
                }
              | null;
            findingStats?: {
              __typename: "FindingStats";
              pass: number;
              total: number;
            } | null;
            blastRadius?: {
              __typename: "BlastRadius";
              indicator: string;
              assets: number;
              affected: number;
              critical: number;
              high: number;
              medium: number;
              low: number;
              none: number;
              snoozed: number;
              disabled: number;
            } | null;
            epss?: {
              __typename: "EpssScore";
              probability: number;
              percentile: number;
            } | null;
            cvss?: {
              __typename: "CvssScore";
              id: string;
              value: number;
              type: number;
              vector: string;
              source: string;
              rating: ScoreRating;
            } | null;
            riskFactors?: Array<{
              __typename: "RiskFactorStats";
              mrn: string;
              indicator: string;
              title: string;
              total: number;
              affected: number;
              isPositive: boolean;
            } | null> | null;
            detectionSources: Array<{
              __typename: "ScoreSource";
              name: string;
              firstDetectedAt: string;
              lastUpdatedAt: string;
              affectedAssets: number;
              vendor?: string | null;
            }>;
            tags?: Array<{
              __typename: "Tag";
              key: string;
              value: string;
            }> | null;
            openCases?: {
              __typename: "CasesConnection";
              totalCount: number;
              edges?: Array<{
                __typename: "CaseEdge";
                node: {
                  __typename: "Case";
                  status: CaseStatus;
                  mrn: string;
                  createdAt: string;
                  ticketRefs?: Array<{
                    __typename: "TicketRef";
                    type: TicketRefType;
                  }> | null;
                };
              }> | null;
            } | null;
            exception?: {
              __typename: "FindingException";
              id: string;
              reviewStatus: ReviewStatus;
              status: ExceptionStatus;
              action: ExceptionMutationAction;
              justification: string;
              scope: string;
              exceptionId: string;
              exceptionMrn: string;
              createdAt: string;
              author?: {
                __typename: "Author";
                name: string;
                mrn?: string | null;
                email?: string | null;
                type: AuthorType;
              } | null;
            } | null;
          } | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetAggregateScoresCountQueryVariables = Exact<{
  entityMrn: Scalars["String"]["input"];
  filter?: InputMaybe<AggregateScoreFilter>;
}>;

export type GetAggregateScoresCountQuery = {
  __typename: "Query";
  aggregateScores?:
    | { __typename: "AggregateScoresConnection"; totalCount: number }
    | { __typename: "NotFoundError" }
    | { __typename: "RequestError" }
    | null;
};

export type GetAggregateScoresRefreshInfoQueryVariables = Exact<{
  groupMrn: Scalars["String"]["input"];
}>;

export type GetAggregateScoresRefreshInfoQuery = {
  __typename: "Query";
  aggregateScoresRefreshInfo: {
    __typename: "AggregateScoresRefreshInfo";
    refreshInProgress: boolean;
    lastUpdatedAt?: string | null;
  };
};

export type GetAggregateScoresSuggestionsQueryVariables = Exact<{
  entityMrn: Scalars["String"]["input"];
  filterType: AggScoresFilterType;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<AggregateScoreFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetAggregateScoresSuggestionsQuery = {
  __typename: "Query";
  aggregateScoresSuggestions?: Array<{
    __typename: "AggregateScoresFilterSuggestion";
    label: string;
    value:
      | { __typename: "AggregateScoreRatingValue"; ratingValue: ScoreRating }
      | {
          __typename: "AggregateScoreStateValue";
          stateValue: AggregateScoreState;
        }
      | { __typename: "AggregateScoreStatusValue" }
      | { __typename: "AggregateScoreTypeValue"; typeValue: AggregateScoreType }
      | { __typename: "RiskCategorySuggestion" }
      | { __typename: "StringValue"; stringValue: string };
  }> | null;
};

export type GetApiTokensQueryVariables = Exact<{
  spaceMrn: Scalars["String"]["input"];
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  queryTerms?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  orderBy?: InputMaybe<ApiTokenOrder>;
}>;

export type GetApiTokensQuery = {
  __typename: "Query";
  apiTokens?: {
    __typename: "APITokenConnection";
    totalCount: number;
    edges?: Array<{
      __typename: "APITokenEdge";
      cursor: string;
      node?: {
        __typename: "APIToken";
        mrn: string;
        spaceMrn: string;
        scopeMrn: string;
        name: string;
        description?: string | null;
        createdAt: string;
        lastUsed?: string | null;
        roles: Array<{ __typename: "Role"; mrn: string; title: string }>;
        creator?: {
          __typename: "APITokenCreator";
          mrn?: string | null;
          email?: string | null;
        } | null;
      } | null;
    }> | null;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
};

export type GetAssetFilterSuggestionsQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  filterType: AssetFilterType;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<AssetSearchFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetAssetFilterSuggestionsQuery = {
  __typename: "Query";
  assetFilterSuggestions?: Array<{
    __typename: "AssetFilterSuggestion";
    label: string;
    value:
      | { __typename: "RiskCategorySuggestion" }
      | { __typename: "ScoreRatingValue"; ratingValue: ScoreRating }
      | { __typename: "StringValue"; stringValue: string };
  }> | null;
};

export type GetAssetGroupStatsQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  queryTerms?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type GetAssetGroupStatsQuery = {
  __typename: "Query";
  assets?: {
    __typename: "AssetsConnection";
    assetGroupStats?: Array<{
      __typename: "AssetGroupStatistics";
      groupType: string;
      count: number;
      displayName: string;
      icon: Icon_Ids;
      listsAssetTypes: Array<{
        __typename: "AssetTypeInfo";
        assetType: string;
        displayName: string;
        shortName: string;
        aliases?: Array<string> | null;
      }>;
      statistics?: Array<{
        __typename: "AssetTypeStatistics";
        count: number;
        type: {
          __typename: "AssetTypeInfo";
          assetType: string;
          displayName: string;
          shortName: string;
          aliases?: Array<string> | null;
        };
      }> | null;
    }> | null;
  } | null;
};

export type GetAssetLinkInfoQueryVariables = Exact<{
  input: AssetLinkInfoInput;
}>;

export type GetAssetLinkInfoQuery = {
  __typename: "Query";
  getAssetLinkInfo?:
    | {
        __typename: "CiAssetLinkInfo";
        mrn: string;
        assetLinkType: AssetLinkType;
        projectID: string;
      }
    | {
        __typename: "FleetAssetLinkInfo";
        mrn: string;
        assetLinkType: AssetLinkType;
      }
    | null;
};

export type GetAssetPackagesQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  filter?: InputMaybe<FindingsFilter>;
}>;

export type GetAssetPackagesQuery = {
  __typename: "Query";
  findings?:
    | {
        __typename: "FindingsConnection";
        filteredTotalCount: number;
        totalCount: number;
        edges?: Array<{
          __typename: "FindingsEdge";
          cursor: string;
          node?:
            | { __typename: "AdvisoryFinding" }
            | { __typename: "CheckFinding" }
            | { __typename: "CveFinding" }
            | { __typename: "GenericFinding" }
            | {
                __typename: "PackageFinding";
                id: string;
                mrn: string;
                baseScore: number;
                riskValue: number;
                rating: ScoreRating;
                title?: string | null;
                packageName?: string | null;
                installedVersion?: string | null;
                availableVersion?: string | null;
                lastUpdated: string;
                firstFound: string;
                iconId?: Icon_Ids | null;
                packageType: PackageType;
                platform?: string | null;
                cvss: {
                  __typename: "CvssScore";
                  id: string;
                  value: number;
                  type: number;
                  vector: string;
                  source: string;
                  rating: ScoreRating;
                };
                epss?: {
                  __typename: "EpssScore";
                  probability: number;
                  percentile: number;
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  lastUpdated: string;
                  platform?: {
                    __typename: "Platform";
                    name: string;
                    title: string;
                    arch: string;
                    version: string;
                    kind: PlatformKind;
                    runtime: string;
                    family?: Array<string> | null;
                    labels?: Array<{
                      __typename: "KeyValue";
                      key: string;
                      value?: string | null;
                    }> | null;
                  } | null;
                } | null;
              }
            | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetAssetPackagesStatsQueryVariables = Exact<{
  input: AssetPackagesStatsInput;
}>;

export type GetAssetPackagesStatsQuery = {
  __typename: "Query";
  assetPackagesStats?: {
    __typename: "AssetPackagesStats";
    appsCount: number;
    osPackagesCount: number;
  } | null;
};

export type GetAssetSupportVulnerabilitiesQueryVariables = Exact<{
  assetMrn: Scalars["String"]["input"];
}>;

export type GetAssetSupportVulnerabilitiesQuery = {
  __typename: "Query";
  assetSupportVulnerabilities: boolean;
};

export type GetAssetSupportsVulnerabilitiesQueryVariables = Exact<{
  assetMrn: Scalars["String"]["input"];
}>;

export type GetAssetSupportsVulnerabilitiesQuery = {
  __typename: "Query";
  assetSupportVulnerabilities: boolean;
};

export type GetAssetUrlStatsQueryVariables = Exact<{
  input: AssetUrlStatsInput;
}>;

export type GetAssetUrlStatsQuery = {
  __typename: "Query";
  assetUrlStats?: {
    __typename: "AssetUrlStatsPayload";
    stats?: Array<{
      __typename: "AssetUrlStats";
      assetUrl: Array<{
        __typename: "AssetUrlSegment";
        key: string;
        value: string;
      }>;
      scoreDistribution: {
        __typename: "AssetUrlScoreDistribution";
        Unscored: number;
        Ok: number;
        Low: number;
        Medium: number;
        High: number;
        Critical: number;
      };
    }> | null;
  } | null;
};

export type GetAuditLogFilterSuggestionsQueryVariables = Exact<{
  resourceMrn: Scalars["String"]["input"];
  filterType: AuditLogFilterType;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<AuditLogsFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetAuditLogFilterSuggestionsQuery = {
  __typename: "Query";
  auditLogSuggestions: Array<{
    __typename: "AuditLogFilterSuggestion";
    label: string;
    value:
      | { __typename: "StringValue"; stringValue: string }
      | { __typename: "TimestampFilterValue" };
  }>;
};

export type GetCvEsQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  filter?: InputMaybe<FindingsFilter>;
}>;

export type GetCvEsQuery = {
  __typename: "Query";
  findings?:
    | {
        __typename: "FindingsConnection";
        totalCount: number;
        filteredTotalCount: number;
        edges?: Array<{
          __typename: "FindingsEdge";
          cursor: string;
          node?:
            | { __typename: "AdvisoryFinding" }
            | { __typename: "CheckFinding" }
            | {
                __typename: "CveFinding";
                id: string;
                mrn: string;
                title: string;
                rating: ScoreRating;
                riskValue: number;
                lastUpdated: string;
                publishedAt?: string | null;
                state: ScoreState;
                asset?: {
                  __typename: "EntityInfoAsset";
                  icon?: Icon_Ids | null;
                  name: string;
                  id: string;
                  mrn: string;
                  tags?: Array<{
                    __typename: "Tag";
                    key: string;
                    value: string;
                  } | null> | null;
                } | null;
                cases?: {
                  __typename: "CasesConnection";
                  totalCount: number;
                  edges?: Array<{
                    __typename: "CaseEdge";
                    node: {
                      __typename: "Case";
                      status: CaseStatus;
                      mrn: string;
                      createdAt: string;
                      ticketRefs?: Array<{
                        __typename: "TicketRef";
                        type: TicketRefType;
                      }> | null;
                    };
                  }> | null;
                } | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                exception?: {
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  scope: string;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  justification: string;
                  action: ExceptionMutationAction;
                  createdAt: string;
                  author?: {
                    __typename: "Author";
                    name: string;
                    email?: string | null;
                    type: AuthorType;
                  } | null;
                } | null;
                spaceRiskDelta?: {
                  __typename: "FindingSpaceRiskDelta";
                  delta: number;
                  effort: number;
                  manualEffort: {
                    __typename: "ManualEffort";
                    totalManualEffort: number;
                    research: number;
                    scripting: number;
                    rollout: number;
                    verification: number;
                  };
                } | null;
              }
            | { __typename: "GenericFinding" }
            | { __typename: "PackageFinding" }
            | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetCaseContentQueryVariables = Exact<{
  input: CaseContentInput;
}>;

export type GetCaseContentQuery = {
  __typename: "Query";
  caseContent: { __typename: "CaseContent"; title: string };
};

export type GetCaseDetailsQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  affectedAssetsFirst?: InputMaybe<Scalars["Int"]["input"]>;
  affectedAssetsAfter?: InputMaybe<Scalars["String"]["input"]>;
  mitigatedAssetsFirst?: InputMaybe<Scalars["Int"]["input"]>;
  mitigatedAssetsAfter?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCaseDetailsQuery = {
  __typename: "Query";
  case:
    | {
        __typename: "Case";
        status: CaseStatus;
        mrn: string;
        title: string;
        createdAt: string;
        modifiedAt: string;
        assetsCount: number;
        totalRefsCount: number;
        closedRefsCount: number;
        createdBy?: {
          __typename: "Author";
          name: string;
          email?: string | null;
          mrn?: string | null;
          type: AuthorType;
        } | null;
        tags?: Array<{ __typename: "Tag"; key: string; value: string }> | null;
        ticketRefs?: Array<{
          __typename: "TicketRef";
          url?: string | null;
          type: TicketRefType;
          ticketId?: string | null;
        }> | null;
        vulnerabilityRefs?: Array<{
          __typename: "CaseRef";
          findingMrn: string;
          scopeMrn: string;
        } | null> | null;
        queryRefs?: Array<{
          __typename: "CaseRef";
          findingMrn: string;
          scopeMrn: string;
        } | null> | null;
        affectedAssets?: {
          __typename: "CaseAssetsConnection";
          totalCount: number;
          pageInfo: {
            __typename: "PageInfo";
            endCursor: string;
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            startCursor: string;
          };
          edges?: Array<{
            __typename: "CaseAssetEdge";
            cursor: string;
            node: {
              __typename: "EntityInfoAsset";
              id: string;
              mrn: string;
              name: string;
              icon?: Icon_Ids | null;
              lastUpdated: string;
              tags?: Array<{
                __typename: "Tag";
                key: string;
                value: string;
              } | null> | null;
            };
          }> | null;
        } | null;
        mitigatedAssets?: {
          __typename: "CaseAssetsConnection";
          totalCount: number;
          pageInfo: {
            __typename: "PageInfo";
            endCursor: string;
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            startCursor: string;
          };
          edges?: Array<{
            __typename: "CaseAssetEdge";
            cursor: string;
            node: {
              __typename: "EntityInfoAsset";
              id: string;
              mrn: string;
              name: string;
              icon?: Icon_Ids | null;
              lastUpdated: string;
              tags?: Array<{
                __typename: "Tag";
                key: string;
                value: string;
              } | null> | null;
            };
          }> | null;
        } | null;
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string };
};

export type GetCasesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  input: CasesInput;
}>;

export type GetCasesQuery = {
  __typename: "Query";
  cases: {
    __typename: "CasesConnection";
    totalCount: number;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    edges?: Array<{
      __typename: "CaseEdge";
      cursor: string;
      node: {
        __typename: "Case";
        mrn: string;
        title: string;
        createdAt: string;
        status: CaseStatus;
        modifiedAt: string;
        assetsCount: number;
        totalRefsCount: number;
        closedRefsCount: number;
        spaceRiskDelta?: number | null;
        createdBy?: { __typename: "Author"; name: string } | null;
        tags?: Array<{ __typename: "Tag"; key: string; value: string }> | null;
        ticketRefs?: Array<{
          __typename: "TicketRef";
          url?: string | null;
          ticketId?: string | null;
          type: TicketRefType;
        }> | null;
      };
    }> | null;
  };
};

export type GetCasesCountQueryVariables = Exact<{
  input: CasesInput;
}>;

export type GetCasesCountQuery = {
  __typename: "Query";
  cases: { __typename: "CasesConnection"; totalCount: number };
};

export type GetCheckRowDataQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  filter?: InputMaybe<FindingsFilter>;
  renderedAssetQueryInput: RenderedAssetQueryDataInput;
}>;

export type GetCheckRowDataQuery = {
  __typename: "Query";
  findings?:
    | {
        __typename: "FindingsConnection";
        edges?: Array<{
          __typename: "FindingsEdge";
          node?:
            | { __typename: "AdvisoryFinding" }
            | {
                __typename: "CheckFinding";
                mrn: string;
                id: string;
                title: string;
                state: ScoreState;
                iconId: Icon_Ids;
                baseScore: number;
                rating: ScoreRating;
                riskValue: number;
                lastUpdated: string;
                resultType: ScoreResultType;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  lastUpdated: string;
                } | null;
                exception?: {
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  action: ExceptionMutationAction;
                  justification: string;
                } | null;
                mquery?: {
                  __typename: "Mquery";
                  uid: string;
                  mrn: string;
                  title: string;
                  mql: string;
                  parent?: string | null;
                  action: PolicyReportScoreEntryAction;
                  code: string;
                  codeId: string;
                  severity?: number | null;
                  docs?: {
                    __typename: "MqueryDocs";
                    desc: string;
                    audit: string;
                    remediation: string;
                    remediations?:
                      | {
                          __typename: "AuthenticationRequired";
                          message: string;
                          code: string;
                        }
                      | {
                          __typename: "Remediations";
                          entries: Array<{
                            __typename: "MqueryRemediation";
                            id: string;
                            idName: string;
                            desc: string;
                          }>;
                        }
                      | null;
                    references?: Array<{
                      __typename: "MqueryRef";
                      title: string;
                      url: string;
                    }> | null;
                  } | null;
                  impact?: {
                    __typename: "Impact";
                    value: number;
                    rating: string;
                  } | null;
                  properties?: Array<{
                    __typename: "MProperty";
                    uid: string;
                    mrn: string;
                    title: string;
                    mql: string;
                    defaultValue: string;
                    overrideValue: string;
                    setByPolicyMrn?: string | null;
                    for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
                  }> | null;
                  variants?: Array<{
                    __typename: "Variant";
                    id: string;
                    mrn: string;
                    title: string;
                    icon: string;
                  }> | null;
                  variantQueries?: Array<{
                    __typename: "MqueryVariant";
                    uid: string;
                    mrn: string;
                    title: string;
                    mql: string;
                    filter: string;
                    filterID: string;
                  } | null> | null;
                } | null;
              }
            | { __typename: "CveFinding" }
            | { __typename: "GenericFinding" }
            | { __typename: "PackageFinding" }
            | null;
        }> | null;
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
  renderedAssetQueryData?:
    | { __typename: "NotFoundError"; message: string; code: string }
    | {
        __typename: "RenderedAssetQueryData";
        data?: any | null;
        assessment?: string | null;
      }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetCheckScoresQueryVariables = Exact<{
  entityMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<CheckScoreOrder>;
  filter?: InputMaybe<CheckScoreFilter>;
}>;

export type GetCheckScoresQuery = {
  __typename: "Query";
  checkScores?:
    | {
        __typename: "CheckScoresConnection";
        totalCount: number;
        filteredTotalCount: number;
        edges?: Array<{
          __typename: "CheckScoresEdge";
          cursor: string;
          node?: {
            __typename: "CheckScore";
            mrn: string;
            id: string;
            title: string;
            state: ScoreState;
            iconId: Icon_Ids;
            baseScore?: number | null;
            riskValue?: number | null;
            queryState: MqueryState;
            severity: ScoreSeverity;
            resultType: ScoreResultType;
            impactRating: QueryImpact;
            rating: ScoreRating;
            lastUpdated: string;
            riskFactors?: Array<{
              __typename: "RiskFactorStats";
              mrn: string;
              indicator: string;
              title: string;
              affected: number;
              total: number;
              isPositive: boolean;
            } | null> | null;
            tags?: Array<{
              __typename: "Tag";
              key: string;
              value: string;
            }> | null;
            asset?: {
              __typename: "EntityInfoAsset";
              id: string;
              mrn: string;
              name: string;
              icon?: Icon_Ids | null;
            } | null;
            platform?: {
              __typename: "Platform";
              name: string;
              title: string;
              arch: string;
              version: string;
              kind: PlatformKind;
              runtime: string;
              release: string;
            } | null;
            exception?: {
              __typename: "FindingException";
              id: string;
              exceptionId: string;
              exceptionMrn: string;
              reviewStatus: ReviewStatus;
              status: ExceptionStatus;
              action: ExceptionMutationAction;
              justification: string;
              createdAt: string;
            } | null;
          } | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetChecksQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  filter?: InputMaybe<FindingsFilter>;
}>;

export type GetChecksQuery = {
  __typename: "Query";
  findings?:
    | {
        __typename: "FindingsConnection";
        totalCount: number;
        filteredTotalCount: number;
        edges?: Array<{
          __typename: "FindingsEdge";
          cursor: string;
          node?:
            | { __typename: "AdvisoryFinding" }
            | {
                __typename: "CheckFinding";
                id: string;
                mrn: string;
                title: string;
                rating: ScoreRating;
                state: ScoreState;
                resultType: ScoreResultType;
                riskValue: number;
                lastUpdated: string;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                } | null;
                cases?: {
                  __typename: "CasesConnection";
                  totalCount: number;
                  edges?: Array<{
                    __typename: "CaseEdge";
                    node: {
                      __typename: "Case";
                      status: CaseStatus;
                      mrn: string;
                      createdAt: string;
                      ticketRefs?: Array<{
                        __typename: "TicketRef";
                        type: TicketRefType;
                      }> | null;
                    };
                  }> | null;
                } | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                exception?: {
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  scope: string;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  action: ExceptionMutationAction;
                  justification: string;
                  createdAt: string;
                  author?: {
                    __typename: "Author";
                    name: string;
                    mrn?: string | null;
                    email?: string | null;
                    type: AuthorType;
                  } | null;
                } | null;
              }
            | { __typename: "CveFinding" }
            | { __typename: "GenericFinding" }
            | { __typename: "PackageFinding" }
            | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetClientIntegrationQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type GetClientIntegrationQuery = {
  __typename: "Query";
  clientIntegration: {
    __typename: "ClientIntegrationPayload";
    integration: {
      __typename: "ClientIntegration";
      mrn: string;
      name: string;
      status: string;
      type: ClientIntegrationType;
      created: string;
      lastModified?: string | null;
      scanJobAttempted?: string | null;
      scanJobStarted?: string | null;
      scanJobFinished?: string | null;
      lastCheckin?: string | null;
      lastStateInfo?: {
        __typename: "K8sIntegrationLastState";
        namespace?: string | null;
        k8sVersion?: string | null;
        operatorVersion?: string | null;
      } | null;
      evaluatedConfigurations?: Array<{
        __typename: "EvaluatedConfiguration";
        option?: string | null;
        configured?: boolean | null;
        applied?: boolean | null;
        msg?: string | null;
        msgStatus?: IntegrationMessageStatus | null;
        operatorMsg?: string | null;
        operatorMsgStatus?: IntegrationMessageStatus | null;
      }> | null;
      messages?: Array<{
        __typename: "IntegrationMessage";
        message: string;
        status: IntegrationMessageStatus;
        identifier?: string | null;
        timestamp?: string | null;
        suppressedByUser?: boolean | null;
      }> | null;
      labels?: Array<{
        __typename: "KeyValue";
        key: string;
        value?: string | null;
      }> | null;
      createdBy?: {
        __typename: "Author";
        name: string;
        email?: string | null;
      } | null;
      configurationOptions?:
        | {
            __typename: "AWSConfigurationOptions";
            accountIds?: Array<string> | null;
            awsAccountId: string;
            cloudFormationQuickcreateUrl: string;
            useWif: boolean;
            wifAuthBindingMrn: string;
            region: string;
            isOrganization?: boolean | null;
            snsEndpoint: string;
            originAWSAccountId: string;
            cloudFormationTemplateUrl: string;
            scanConfiguration: {
              __typename: "ScanConfiguration";
              ecrScan: boolean;
              ecsScan: boolean;
              cronScaninHours: number;
              accountScan: boolean;
              ec2Scan: boolean;
              propagateAccountTags: boolean;
              ec2ScanOptions: {
                __typename: "Ec2ScanOptions";
                ebsVolumeScan: boolean;
                vaultType?: string | null;
                tagsFilter: any;
                excludedTagsFilter?: any | null;
                regionsFilter?: Array<string> | null;
                excludedRegionsFilter?: Array<string> | null;
                instanceIdsFilter?: Array<string> | null;
                excludedInstanceIdsFilter?: Array<string> | null;
                secretsMetadataQuery?: string | null;
                awsSecretsManagerVault?: boolean | null;
                ssm: boolean;
                instanceConnect: boolean;
                ebsScanOptions?: {
                  __typename: "EbsScanOptions";
                  maxAsgInstances?: number | null;
                  targetInstancesPerScanner?: number | null;
                } | null;
              };
              eventScanTriggers?: Array<{
                __typename: "AWSEventPattern";
                eventDetailType: string;
                eventSource: string;
                scanType: string;
              } | null> | null;
              vpcConfiguration?: {
                __typename: "VPCConfiguration";
                CIDR?: string | null;
                vpcFlavour?: VpcFlavour | null;
                vpcTag?: {
                  __typename: "VPCTag";
                  key: string;
                  value: string;
                } | null;
              } | null;
            };
          }
        | { __typename: "AgentOptions" }
        | { __typename: "AttackSurfaceConfigurationOptions" }
        | { __typename: "AuditLogExportConfigurationOptions" }
        | {
            __typename: "AwsS3ConfigurationOptions";
            output: BucketOutputType;
            bucket: string;
            region: string;
            accessKey: string;
          }
        | {
            __typename: "AzureBlobConfigurationOptions";
            output: BucketOutputType;
          }
        | {
            __typename: "AzureConfigurationOptions";
            tenantId: string;
            clientId: string;
            subscriptionsWhitelist?: Array<string> | null;
            subscriptionsBlacklist?: Array<string> | null;
            scanVms?: boolean | null;
            secretType?: string | null;
          }
        | {
            __typename: "AzureDevopsConfigurationOptions";
            defaultProjectName?: string | null;
            organizationUrl: string;
            servicePrincipalId: string;
            tenantId: string;
            autoCloseTickets: boolean;
            autoCreateTickets: boolean;
          }
        | {
            __typename: "BigqueryConfigurationOptions";
            datasetId: string;
            wifAudience?: string | null;
            wifServiceAccountEmail?: string | null;
            wifSubject?: string | null;
          }
        | { __typename: "CloudflareConfigurationOptions" }
        | {
            __typename: "CrowdstrikeFalconConfigurationOptions";
            clientId: string;
            cloud?: string | null;
            memberCID?: string | null;
            createAssets?: boolean | null;
            mondooEnrichment?: boolean | null;
          }
        | { __typename: "DigitaloceanConfigurationOptions" }
        | { __typename: "ElasticConfigurationOptions" }
        | {
            __typename: "EmailConfigurationOptions";
            autoCreateTickets: boolean;
            recipients: Array<{
              __typename: "EmailRecipient";
              name: string;
              email: string;
              isDefault: boolean;
              referenceUrl?: string | null;
            }>;
          }
        | {
            __typename: "GcpConfigurationOptions";
            projectId?: string | null;
            organizationId?: string | null;
            discoverAll?: boolean | null;
            wifAudience?: string | null;
            wifServiceAccountEmail?: string | null;
            wifSubject?: string | null;
          }
        | { __typename: "GcpServerlessConfigurationOptions" }
        | {
            __typename: "GcsBucketConfigurationOptions";
            output: BucketOutputType;
            bucket: string;
            wifAudience?: string | null;
            wifServiceAccountEmail?: string | null;
            wifSubject?: string | null;
          }
        | {
            __typename: "GithubConfigurationOptions";
            owner?: string | null;
            repository?: string | null;
            reposAllowList?: Array<string> | null;
            reposDenyList?: Array<string> | null;
            enterpriseUrl?: string | null;
            githubOrg?: string | null;
            githubType: GithubIntegrationType;
            githubDiscoverK8sManifests: boolean;
            githubDiscoverTerraform: boolean;
          }
        | {
            __typename: "GithubTicketingConfigurationOptions";
            enterpriseUrl?: string | null;
            defaultRepoOwner?: string | null;
            defaultRepoName?: string | null;
            autoCloseTickets: boolean;
            autoCreateTickets: boolean;
          }
        | {
            __typename: "GitlabConfigurationOptions";
            group: string;
            type: GitlabIntegrationType;
            discoverGroups?: boolean | null;
            discoverProjects?: boolean | null;
            discoverTerraform?: boolean | null;
            discoverK8sManifests: boolean;
            baseUrl: string;
          }
        | {
            __typename: "GitlabTicketingConfigurationOptions";
            autoCloseTickets: boolean;
            autoCreateTickets: boolean;
            gitlabBaseUrl?: string | null;
            gitlabDefaultProject?: string | null;
          }
        | { __typename: "GoogleSccExportConfigurationOptions" }
        | { __typename: "GoogleSccImportConfigurationOptions" }
        | {
            __typename: "GoogleWorkspaceConfigurationOptions";
            impersonatedUserEmail: string;
            customerId: string;
          }
        | { __typename: "HetznerConfigurationOptions" }
        | {
            __typename: "HostConfigurationOptions";
            host: string;
            https?: boolean | null;
            http?: boolean | null;
            discoverSubdomains?: boolean | null;
          }
        | {
            __typename: "HostedAwsConfigurationOptions";
            accessKeyId?: string | null;
            role?: string | null;
            wifAudience?: string | null;
            wifRoleArn?: string | null;
            wifSubject?: string | null;
          }
        | {
            __typename: "JiraConfigurationOptions";
            host: string;
            email: string;
            autoCloseTickets: boolean;
            autoCreateCases: boolean;
            defaultProject: string;
            cloudId?: string | null;
          }
        | {
            __typename: "K8sConfigurationOptions";
            scanNodes?: boolean | null;
            scanNodesStyle: K8sScanNodesStyle;
            scanWorkloads?: boolean | null;
            scanDeploys?: boolean | null;
            certificateManager: string;
            scanPublicImages?: boolean | null;
            namespaceAllowList?: Array<string> | null;
            namespaceDenyList?: Array<string> | null;
          }
        | {
            __typename: "MicrosoftDefenderConfigurationOptions";
            tenantId: string;
            clientId: string;
            subscriptionsAllowlist?: Array<string> | null;
            subscriptionsDenylist?: Array<string> | null;
            secretType?: string | null;
            createAssets?: boolean | null;
            mondooEnrichment?: boolean | null;
          }
        | {
            __typename: "Ms365ConfigurationOptions";
            tenantId: string;
            clientId: string;
          }
        | { __typename: "MsIntuneConfigurationOptions" }
        | { __typename: "NetworkScanConfigurationOptions" }
        | { __typename: "NextdnsConfigurationOptions" }
        | {
            __typename: "OciConfigurationOptions";
            tenancyOcid: string;
            userOcid: string;
            region: string;
            fingerprint: string;
          }
        | { __typename: "OktaConfigurationOptions"; organization: string }
        | { __typename: "OpenvasConfigurationOptions" }
        | {
            __typename: "PostgresConfigurationOptions";
            host: string;
            port: string;
            database: string;
            user: string;
          }
        | { __typename: "QualysConfigurationOptions" }
        | {
            __typename: "S3ConfigurationOptions";
            output: BucketOutputType;
            endpoint: string;
            bucket: string;
            useLegacyList: boolean;
            usePathStyle: boolean;
            accessKey: string;
          }
        | {
            __typename: "SecurityPipelineGithubConfigurationOptions";
            appInstallationLink: string;
            publicKey?: string | null;
            autoCreateWorkflows: boolean;
            repositories?: Array<{
              __typename: "GithubRepository";
              link: string;
              fullName: string;
              spaceMrn?: string | null;
            }> | null;
          }
        | { __typename: "SecurityScorecardConfigurationOptions" }
        | {
            __typename: "SentinelOneConfigurationOptions";
            host: string;
            account: string;
            secretType?: string | null;
            createAssets?: boolean | null;
            mondooEnrichment?: boolean | null;
          }
        | {
            __typename: "ServiceNowConfigurationOptions";
            instanceUrl: string;
            clientId: string;
            autoCloseTickets: boolean;
            autoCreateTickets: boolean;
            userEmail?: string | null;
          }
        | {
            __typename: "ShodanConfigurationOptions";
            token: string;
            targets?: Array<string> | null;
          }
        | { __typename: "SlackConfigurationOptions" }
        | {
            __typename: "SnowflakeConfigurationOptions";
            accountId: string;
            database: string;
            schema: string;
            region: string;
            warehouse: string;
            role?: string | null;
            username: string;
          }
        | { __typename: "SnowflakeScanConfigurationOptions" }
        | { __typename: "SnykConfigurationOptions" }
        | { __typename: "SonarqubeConfigurationOptions" }
        | { __typename: "SplunkConfigurationOptions" }
        | { __typename: "StackitConfigurationOptions" }
        | { __typename: "TailscaleConfigurationOptions" }
        | { __typename: "TenableConfigurationOptions" }
        | { __typename: "TenableSCConfigurationOptions" }
        | {
            __typename: "WebhookConfigurationOptions";
            url: string;
            autoCreateTickets: boolean;
            autoCloseTickets: boolean;
          }
        | {
            __typename: "ZendeskConfigurationOptions";
            subdomain: string;
            email: string;
            autoCloseTickets: boolean;
            autoCreateTickets: boolean;
            customFields?: Array<{
              __typename: "ZendeskCustomField";
              id: number;
              value: string;
            }> | null;
          }
        | null;
      assetCounts?: Array<{
        __typename: "IntegrationAssetCount";
        assetType: string;
        total: number;
      }> | null;
    };
  };
};

export type GetClientIntegrationDeleteCommandQueryVariables = Exact<{
  input: GetClientIntegrationDeleteCommandInput;
}>;

export type GetClientIntegrationDeleteCommandQuery = {
  __typename: "Query";
  getClientIntegrationDeleteCommand: {
    __typename: "GetClientIntegrationDeleteCommandPayload";
    message: string;
  };
};

export type GetClientIntegrationTokenQueryVariables = Exact<{
  input: GetClientIntegrationTokenInput;
}>;

export type GetClientIntegrationTokenQuery = {
  __typename: "Query";
  getClientIntegrationToken: {
    __typename: "GetClientIntegrationTokenPayload";
    token: string;
  };
};

export type GetComplianceControlQueryVariables = Exact<{
  input: ComplianceControlInput;
}>;

export type GetComplianceControlQuery = {
  __typename: "Query";
  complianceControl: {
    __typename: "ComplianceControl";
    mrn: string;
    description: string;
    title: string;
    manual: boolean;
    completion: number;
    state: ControlState;
    framework?: {
      __typename: "ComplianceFramework";
      name: string;
      version: string;
    } | null;
    tags: Array<{ __typename: "Tag"; key: string; value: string } | null>;
    assetGroupStatistics: Array<{
      __typename: "AssetGroupStatistics";
      count: number;
      groupType: string;
      listsAssetTypes: Array<{
        __typename: "AssetTypeInfo";
        assetType: string;
        aliases?: Array<string> | null;
        displayName: string;
        shortName: string;
      }>;
      statistics?: Array<{
        __typename: "AssetTypeStatistics";
        count: number;
        type: {
          __typename: "AssetTypeInfo";
          assetType: string;
          aliases?: Array<string> | null;
          displayName: string;
          shortName: string;
        };
      }> | null;
    }>;
    assetsStats: {
      __typename: "ControlAssetsStats";
      compliantAssets: number;
      failedAssets: number;
      totalAssets: number;
    };
    checksStats: {
      __typename: "ControlChecksStats";
      activeChecks: number;
      activeQueries: number;
      totalChecks: number;
      totalExceptions: number;
      totalQueries: number;
    };
    exceptions: Array<{
      __typename: "ControlException";
      id: string;
      exceptionId: string;
      exceptionMrn: string;
      createdAt: string;
      modifiedAt?: string | null;
      title: string;
      justification?: string | null;
      reviewStatus: ReviewStatus;
      action: ExceptionMutationAction;
      author: {
        __typename: "Author";
        name: string;
        mrn?: string | null;
        email?: string | null;
        type: AuthorType;
      };
      reviewer?: {
        __typename: "Author";
        name: string;
        email?: string | null;
      } | null;
    }>;
  };
};

export type GetComplianceControlAssetsQueryVariables = Exact<{
  input: ComplianceControlInput;
  assetsInput: ComplianceAssetsSearchInput;
}>;

export type GetComplianceControlAssetsQuery = {
  __typename: "Query";
  complianceControl: {
    __typename: "ComplianceControl";
    mrn: string;
    description: string;
    title: string;
    assets?: {
      __typename: "ComplianceAssetsConnection";
      totalCount: number;
      edges?: Array<{
        __typename: "ComplianceAssetEdge";
        cursor: string;
        node?: {
          __typename: "ComplianceAsset";
          compliancePercentage?: number | null;
          asset: {
            __typename: "Asset";
            id: string;
            mrn: string;
            state: AssetState;
            name?: string | null;
            updatedAt?: string | null;
            referenceIDs: Array<string>;
            asset_type: string;
            labels: Array<{
              __typename: "KeyValue";
              key: string;
              value?: string | null;
            }>;
            platform?: {
              __typename: "Platform";
              name: string;
              title: string;
              arch: string;
              version: string;
              kind: PlatformKind;
              runtime: string;
              release: string;
            } | null;
            score: {
              __typename: "Score";
              id: string;
              value: number;
              type: number;
              completion: number;
              weight: number;
              message: string;
              grade: string;
            };
            annotations: Array<{
              __typename: "KeyValue";
              key: string;
              value?: string | null;
            }>;
          };
          exception?: {
            __typename: "ControlException";
            createdAt: string;
            action: ExceptionMutationAction;
            id: string;
            exceptionId: string;
            exceptionMrn: string;
            reviewStatus: ReviewStatus;
            status: ExceptionStatus;
            title: string;
            justification?: string | null;
            author: {
              __typename: "Author";
              name: string;
              mrn?: string | null;
              email?: string | null;
              type: AuthorType;
            };
          } | null;
        } | null;
      }> | null;
      pageInfo: {
        __typename: "PageInfo";
        startCursor: string;
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    } | null;
  };
};

export type GetComplianceControlChecksQueryVariables = Exact<{
  input: ComplianceControlInput;
  checksInput: ChecksSearchInput;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetComplianceControlChecksQuery = {
  __typename: "Query";
  complianceControl: {
    __typename: "ComplianceControl";
    mrn: string;
    description: string;
    title: string;
    checks?: {
      __typename: "ChecksConnection";
      totalCount: number;
      edges?: Array<{
        __typename: "ChecksEdge";
        cursor: string;
        node?:
          | {
              __typename: "PolicyCheck";
              state: CheckState;
              policyName: string;
              policyMrn: string;
              completion: number;
              assets: number;
            }
          | {
              __typename: "QueryCheck";
              state: CheckState;
              completion: number;
              assets: number;
              exception?: {
                __typename: "QueryCheckException";
                id: string;
                exceptionId: string;
                exceptionMrn: string;
                action: ExceptionMutationAction;
                justification: string;
                reviewStatus: ReviewStatus;
                status: ExceptionStatus;
              } | null;
              refs: Array<
                | {
                    __typename: "PolicyCheckRef";
                    name: string;
                    mrn: string;
                    group: string;
                  }
                | {
                    __typename: "QueryPackCheckRef";
                    name: string;
                    mrn: string;
                    group: string;
                  }
              >;
              mquery: {
                __typename: "Mquery";
                action: PolicyReportScoreEntryAction;
                uid: string;
                title: string;
                mrn: string;
                impact?: {
                  __typename: "Impact";
                  rating: string;
                  value: number;
                } | null;
              };
            }
          | null;
      }> | null;
      pageInfo: {
        __typename: "PageInfo";
        startCursor: string;
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    } | null;
  };
};

export type GetComplianceControlDataQueriesQueryVariables = Exact<{
  input: ComplianceControlInput;
  dataQueriesInput: ChecksSearchInput;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetComplianceControlDataQueriesQuery = {
  __typename: "Query";
  complianceControl: {
    __typename: "ComplianceControl";
    mrn: string;
    dataQueries?: {
      __typename: "QueriesConnection";
      totalCount: number;
      edges?: Array<{
        __typename: "QueryEdge";
        cursor: string;
        node?: {
          __typename: "QueryCheck";
          assets: number;
          completion: number;
          state: CheckState;
          mquery: {
            __typename: "Mquery";
            action: PolicyReportScoreEntryAction;
            mql: string;
            mrn: string;
            parent?: string | null;
            title: string;
            uid: string;
            docs?: {
              __typename: "MqueryDocs";
              desc: string;
              remediations?:
                | {
                    __typename: "AuthenticationRequired";
                    message: string;
                    code: string;
                  }
                | {
                    __typename: "Remediations";
                    entries: Array<{
                      __typename: "MqueryRemediation";
                      id: string;
                      desc: string;
                    }>;
                  }
                | null;
              references?: Array<{
                __typename: "MqueryRef";
                title: string;
                url: string;
              }> | null;
            } | null;
            impact?: {
              __typename: "Impact";
              value: number;
              rating: string;
            } | null;
            properties?: Array<{
              __typename: "MProperty";
              uid: string;
              title: string;
              setByPolicyMrn?: string | null;
              mrn: string;
              mql: string;
              defaultValue: string;
              overrideValue: string;
              for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
            }> | null;
            tags?: Array<{
              __typename: "Tag";
              key: string;
              value: string;
            }> | null;
            variantQueries?: Array<{
              __typename: "MqueryVariant";
              filter: string;
              filterID: string;
              mql: string;
              mrn: string;
              title: string;
              uid: string;
              impact?: {
                __typename: "Impact";
                value: number;
                rating: string;
              } | null;
              properties?: Array<{
                __typename: "MProperty";
                mql: string;
                mrn: string;
                defaultValue: string;
                overrideValue: string;
                setByPolicyMrn?: string | null;
                title: string;
                uid: string;
                for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
              } | null> | null;
              tags?: Array<{
                __typename: "Tag";
                key: string;
                value: string;
              }> | null;
              docs?: {
                __typename: "MqueryDocs";
                desc: string;
                references?: Array<{
                  __typename: "MqueryRef";
                  title: string;
                  url: string;
                }> | null;
                remediations?:
                  | {
                      __typename: "AuthenticationRequired";
                      message: string;
                      code: string;
                    }
                  | {
                      __typename: "Remediations";
                      entries: Array<{
                        __typename: "MqueryRemediation";
                        id: string;
                        desc: string;
                      }>;
                    }
                  | null;
              } | null;
            } | null> | null;
            variants?: Array<{
              __typename: "Variant";
              id: string;
              icon: string;
            }> | null;
          };
          queryStats?: {
            __typename: "ScoreStats";
            total: number;
            passed: number;
            failed: number;
            incomplete: number;
            errors: number;
            skipped: number;
            worst: number;
            unknown: number;
          } | null;
          refs: Array<
            | {
                __typename: "PolicyCheckRef";
                name: string;
                mrn: string;
                group: string;
              }
            | {
                __typename: "QueryPackCheckRef";
                name: string;
                mrn: string;
                group: string;
              }
          >;
        } | null;
      }> | null;
      pageInfo: {
        __typename: "PageInfo";
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor: string;
      };
    } | null;
  };
};

export type GetComplianceFrameworkQueryVariables = Exact<{
  input: ComplianceFrameworkInput;
}>;

export type GetComplianceFrameworkQuery = {
  __typename: "Query";
  complianceFramework: {
    __typename: "ComplianceFramework";
    mrn: string;
    name: string;
    version: string;
    createdAt: string;
    modifiedAt: string;
    description: string;
    summary: string;
    state: ComplianceFrameworkState;
    policiesMrns: Array<string>;
    scopeMrn: string;
    completion?: number | null;
    authors?: Array<{
      __typename: "Author";
      name: string;
      email?: string | null;
      type: AuthorType;
    }> | null;
    tags?: Array<{ __typename: "Tag"; key: string; value: string }> | null;
    stats: {
      __typename: "ComplianceFrameworkStats";
      checks: number;
      assets: number;
      exceptions: number;
      controls: {
        __typename: "ControlsStats";
        activeControls: number;
        averageCompletion: number;
        outOfScopeControls: number;
        previousAverageCompletion: number;
        totalControls: number;
        totalExceptions: number;
      };
    };
    assetGroupStatistics: Array<{
      __typename: "AssetGroupStatistics";
      groupType: string;
      count: number;
      listsAssetTypes: Array<{
        __typename: "AssetTypeInfo";
        assetType: string;
        aliases?: Array<string> | null;
        displayName: string;
        shortName: string;
      }>;
      statistics?: Array<{
        __typename: "AssetTypeStatistics";
        count: number;
        type: {
          __typename: "AssetTypeInfo";
          assetType: string;
          aliases?: Array<string> | null;
          displayName: string;
          shortName: string;
        };
      }> | null;
    }>;
    previousCompletionScores?: {
      __typename: "ComplianceScoresHistory";
      entries: Array<{
        __typename: "ComplianceScoreEntry";
        score: number;
        timestamp: string;
      }>;
    } | null;
  };
};

export type GetComplianceFrameworkAssetsQueryVariables = Exact<{
  input: ComplianceFrameworkInput;
  assetsInput: ComplianceAssetsSearchInput;
}>;

export type GetComplianceFrameworkAssetsQuery = {
  __typename: "Query";
  complianceFramework: {
    __typename: "ComplianceFramework";
    mrn: string;
    name: string;
    assetGroupStatistics: Array<{
      __typename: "AssetGroupStatistics";
      groupType: string;
      count: number;
      listsAssetTypes: Array<{
        __typename: "AssetTypeInfo";
        assetType: string;
        aliases?: Array<string> | null;
        displayName: string;
        shortName: string;
      }>;
      statistics?: Array<{
        __typename: "AssetTypeStatistics";
        count: number;
        type: {
          __typename: "AssetTypeInfo";
          assetType: string;
          aliases?: Array<string> | null;
          displayName: string;
          shortName: string;
        };
      }> | null;
    }>;
    assets?: {
      __typename: "ComplianceAssetsConnection";
      totalCount: number;
      edges?: Array<{
        __typename: "ComplianceAssetEdge";
        cursor: string;
        node?: {
          __typename: "ComplianceAsset";
          compliancePercentage?: number | null;
          asset: {
            __typename: "Asset";
            id: string;
            mrn: string;
            state: AssetState;
            name?: string | null;
            updatedAt?: string | null;
            referenceIDs: Array<string>;
            asset_type: string;
            labels: Array<{
              __typename: "KeyValue";
              key: string;
              value?: string | null;
            }>;
            platform?: {
              __typename: "Platform";
              name: string;
              title: string;
              arch: string;
              version: string;
              kind: PlatformKind;
              runtime: string;
              release: string;
            } | null;
            score: {
              __typename: "Score";
              completion: number;
              grade: string;
              id: string;
              message: string;
              type: number;
              value: number;
              weight: number;
            };
            annotations: Array<{
              __typename: "KeyValue";
              key: string;
              value?: string | null;
            }>;
          };
        } | null;
      }> | null;
      pageInfo: {
        __typename: "PageInfo";
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor: string;
      };
    } | null;
  };
};

export type GetComplianceFrameworkControlsQueryVariables = Exact<{
  input: ComplianceFrameworkInput;
  controlsInput: ControlsSearchInput;
}>;

export type GetComplianceFrameworkControlsQuery = {
  __typename: "Query";
  complianceFramework: {
    __typename: "ComplianceFramework";
    mrn: string;
    name: string;
    controls?: {
      __typename: "ControlsConnection";
      totalCount: number;
      edges?: Array<{
        __typename: "ControlsEdge";
        cursor: string;
        node?: {
          __typename: "ComplianceControl";
          mrn: string;
          description: string;
          title: string;
          manual: boolean;
          completion: number;
          state: ControlState;
          tags: Array<{ __typename: "Tag"; key: string; value: string } | null>;
          assetsStats: {
            __typename: "ControlAssetsStats";
            compliantAssets: number;
            failedAssets: number;
            totalAssets: number;
          };
          checksStats: {
            __typename: "ControlChecksStats";
            activeChecks: number;
            snoozedChecks: number;
            disabledChecks: number;
            totalChecks: number;
            totalQueries: number;
          };
          exception?: {
            __typename: "ControlException";
            createdAt: string;
            action: ExceptionMutationAction;
            id: string;
            exceptionId: string;
            exceptionMrn: string;
            reviewStatus: ReviewStatus;
            status: ExceptionStatus;
            title: string;
            justification?: string | null;
            author: {
              __typename: "Author";
              name: string;
              mrn?: string | null;
              email?: string | null;
              type: AuthorType;
            };
          } | null;
        } | null;
      }> | null;
      pageInfo: {
        __typename: "PageInfo";
        startCursor: string;
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    } | null;
  };
};

export type GetComplianceFrameworksQueryVariables = Exact<{
  input: ComplianceFrameworksInput;
}>;

export type GetComplianceFrameworksQuery = {
  __typename: "Query";
  complianceFrameworks?: Array<{
    __typename: "ComplianceFramework";
    createdAt: string;
    modifiedAt: string;
    completion?: number | null;
    description: string;
    mrn: string;
    name: string;
    scopeMrn: string;
    state: ComplianceFrameworkState;
    summary: string;
    version: string;
    authors?: Array<{
      __typename: "Author";
      name: string;
      email?: string | null;
    }> | null;
    previousCompletionScores?: {
      __typename: "ComplianceScoresHistory";
      entries: Array<{
        __typename: "ComplianceScoreEntry";
        score: number;
        timestamp: string;
      }>;
    } | null;
    stats: {
      __typename: "ComplianceFrameworkStats";
      checks: number;
      assets: number;
      exceptions: number;
      controls: {
        __typename: "ControlsStats";
        activeControls: number;
        averageCompletion: number;
        outOfScopeControls: number;
        previousAverageCompletion: number;
        totalControls: number;
        totalExceptions: number;
      };
    };
    tags?: Array<{ __typename: "Tag"; key: string; value: string }> | null;
  }> | null;
};

export type GetContentQueryVariables = Exact<{
  input: ContentSearchInput;
}>;

export type GetContentQuery = {
  __typename: "Query";
  content?: {
    __typename: "ContentSearchResultItemConnection";
    totalCount: number;
    edges: Array<{
      __typename: "ContentSearchResultItemEdge";
      cursor: string;
      node: {
        __typename: "Policy";
        access: Access;
        action?: PolicyAction | null;
        assigned: boolean;
        category: string;
        summary: string;
        docs: string;
        createdAt: string;
        featured: boolean;
        trustLevel: TrustLevel;
        mrn: string;
        name: string;
        uid: string;
        updatedAt: string;
        version: string;
        authors?: Array<{
          __typename: "Author";
          email?: string | null;
          name: string;
          type: AuthorType;
        }> | null;
        statistics: {
          __typename: "PolicyStatistics";
          checks: number;
          policies: number;
          queries: number;
        };
      };
    }>;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
};

export type GetCveAdvisoriesQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  scopeMrn: Scalars["String"]["input"];
  advisoriesFirst?: InputMaybe<Scalars["Int"]["input"]>;
  advisoriesAfter?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCveAdvisoriesQuery = {
  __typename: "Query";
  cve?: {
    __typename: "Cve";
    id: string;
    mrn: string;
    advisoryAggregateScores?:
      | {
          __typename: "AggregateScoresConnection";
          totalCount: number;
          pageInfo: {
            __typename: "PageInfo";
            startCursor: string;
            endCursor: string;
            hasNextPage: boolean;
            hasPreviousPage: boolean;
          };
          edges?: Array<{
            __typename: "AggregateScoreEdge";
            cursor: string;
            node?: {
              __typename: "AggregateScore";
              id: string;
              iconId: Icon_Ids;
              findingMrn: string;
              scoreType: AggregateScoreType;
              state: AggregateScoreState;
              effort: number;
              enforcementState: EnforcementState;
              previewUntil?: string | null;
              spaceRiskImprovement: number;
              description: string;
              remediatedAt: string;
              spaceId: string;
              title: string;
              firstDetectedAt: string;
              riskValue?: number | null;
              rankScore: number;
              rank: number;
              rating: ScoreRating;
              baseScore?: number | null;
              baseValue: number;
              baseRating: ScoreRating;
              slaAtRiskCount: number;
              slaOverdueCount: number;
              blastRadius?: {
                __typename: "BlastRadius";
                indicator: string;
                assets: number;
                affected: number;
                critical: number;
                high: number;
                medium: number;
                low: number;
                none: number;
                snoozed: number;
                disabled: number;
              } | null;
              riskFactors?: Array<{
                __typename: "RiskFactorStats";
                mrn: string;
                indicator: string;
                title: string;
                total: number;
                affected: number;
                isPositive: boolean;
              } | null> | null;
              detectionSources: Array<{
                __typename: "ScoreSource";
                name: string;
                firstDetectedAt: string;
                lastUpdatedAt: string;
                affectedAssets: number;
                vendor?: string | null;
              }>;
            } | null;
          }> | null;
        }
      | { __typename: "NotFoundError" }
      | { __typename: "RequestError" }
      | null;
  } | null;
};

export type GetDataQueriesListQueryVariables = Exact<{
  entityMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<DataQueryOrder>;
  filter?: InputMaybe<DataQueryFilter>;
}>;

export type GetDataQueriesListQuery = {
  __typename: "Query";
  dataQueries?:
    | {
        __typename: "DataQueriesConnection";
        totalCount: number;
        filteredTotalCount: number;
        edges?: Array<{
          __typename: "DataQueriesEdge";
          cursor: string;
          node?: {
            __typename: "DataQuery";
            mrn: string;
            id: string;
            title: string;
            iconId: Icon_Ids;
            lastUpdated: string;
            tags?: Array<{
              __typename: "Tag";
              key: string;
              value: string;
            }> | null;
            asset?: {
              __typename: "EntityInfoAsset";
              id: string;
              mrn: string;
              name: string;
              icon?: Icon_Ids | null;
            } | null;
            platform?: {
              __typename: "Platform";
              name: string;
              title: string;
              arch: string;
              version: string;
              kind: PlatformKind;
              runtime: string;
              family?: Array<string> | null;
              labels?: Array<{
                __typename: "KeyValue";
                key: string;
                value?: string | null;
              }> | null;
            } | null;
            mquery?: {
              __typename: "Mquery";
              uid: string;
              mrn: string;
              title: string;
              mql: string;
              action: PolicyReportScoreEntryAction;
              code: string;
              codeId: string;
            } | null;
          } | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetDataQueryQueryVariables = Exact<{
  entityMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<DataQueryOrder>;
  filter?: InputMaybe<DataQueryFilter>;
}>;

export type GetDataQueryQuery = {
  __typename: "Query";
  dataQueries?:
    | {
        __typename: "DataQueriesConnection";
        totalCount: number;
        filteredTotalCount: number;
        edges?: Array<{
          __typename: "DataQueriesEdge";
          cursor: string;
          node?: {
            __typename: "DataQuery";
            mrn: string;
            id: string;
            iconId: Icon_Ids;
            lastUpdated: string;
            value?: any | null;
            tags?: Array<{
              __typename: "Tag";
              key: string;
              value: string;
            }> | null;
            asset?: {
              __typename: "EntityInfoAsset";
              id: string;
              mrn: string;
              name: string;
              icon?: Icon_Ids | null;
            } | null;
            platform?: {
              __typename: "Platform";
              name: string;
              title: string;
              arch: string;
              version: string;
              kind: PlatformKind;
              runtime: string;
              family?: Array<string> | null;
              labels?: Array<{
                __typename: "KeyValue";
                key: string;
                value?: string | null;
              }> | null;
            } | null;
            mquery?: {
              __typename: "Mquery";
              uid: string;
              mrn: string;
              title: string;
              mql: string;
              parent?: string | null;
              action: PolicyReportScoreEntryAction;
              code: string;
              codeId: string;
              severity?: number | null;
              docs?: {
                __typename: "MqueryDocs";
                desc: string;
                audit: string;
                remediation: string;
                remediations?:
                  | {
                      __typename: "AuthenticationRequired";
                      message: string;
                      code: string;
                    }
                  | {
                      __typename: "Remediations";
                      entries: Array<{
                        __typename: "MqueryRemediation";
                        id: string;
                        desc: string;
                      }>;
                    }
                  | null;
                references?: Array<{
                  __typename: "MqueryRef";
                  title: string;
                  url: string;
                }> | null;
              } | null;
              impact?: {
                __typename: "Impact";
                value: number;
                rating: string;
              } | null;
              tags?: Array<{
                __typename: "Tag";
                key: string;
                value: string;
              }> | null;
              properties?: Array<{
                __typename: "MProperty";
                uid: string;
                mrn: string;
                title: string;
                mql: string;
                defaultValue: string;
                overrideValue: string;
                setByPolicyMrn?: string | null;
                for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
              }> | null;
              variants?: Array<{
                __typename: "Variant";
                id: string;
                mrn: string;
                title: string;
                icon: string;
              }> | null;
              variantQueries?: Array<{
                __typename: "MqueryVariant";
                uid: string;
                mrn: string;
                title: string;
                mql: string;
                filter: string;
                filterID: string;
              } | null> | null;
            } | null;
          } | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetEvidenceQueryVariables = Exact<{
  input: EvidenceInput;
}>;

export type GetEvidenceQuery = {
  __typename: "Query";
  evidence?: {
    __typename: "EvidenceResponse";
    items: Array<{
      __typename: "Evidence";
      id: string;
      vexMrn: string;
      source: string;
      details?:
        | { __typename: "EvidenceConnection" }
        | { __typename: "EvidenceContainer" }
        | { __typename: "EvidenceFile"; path: string }
        | { __typename: "EvidenceHttpRequest" }
        | { __typename: "EvidenceKubernetes" }
        | { __typename: "EvidenceProcess" }
        | {
            __typename: "EvidenceRegistryKey";
            path: string;
            name: string;
            data: string;
          }
        | { __typename: "EvidenceUser" }
        | null;
    }>;
  } | null;
};

export type GetExceptionFilterSuggestionsQueryVariables = Exact<{
  resourceMrn: Scalars["String"]["input"];
  filterType: ExceptionFilterType;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<ListExceptionGroupsFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetExceptionFilterSuggestionsQuery = {
  __typename: "Query";
  exceptionFilterSuggestions?: Array<{
    __typename: "ExceptionFilterSuggestion";
    label: string;
    value:
      | {
          __typename: "ExceptionReviewStatusValue";
          reviewStatusValue: ReviewStatus;
        }
      | { __typename: "ExceptionStatusValue"; statusValue: ExceptionStatus }
      | { __typename: "ExceptionTypeValue"; typeValue: ExceptionType }
      | { __typename: "StringValue"; stringValue: string }
      | {
          __typename: "TimeRangeValue";
          from?: string | null;
          to?: string | null;
        };
  }> | null;
};

export type GetFindingRiskFactorsQueryVariables = Exact<{
  entityMrn: Scalars["String"]["input"];
  filter?: InputMaybe<AggregateScoreFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<AggregateScoreOrder>;
}>;

export type GetFindingRiskFactorsQuery = {
  __typename: "Query";
  aggregateScores?:
    | {
        __typename: "AggregateScoresConnection";
        totalCount: number;
        edges?: Array<{
          __typename: "AggregateScoreEdge";
          cursor: string;
          node?: {
            __typename: "AggregateScore";
            id: string;
            findingMrn: string;
            riskFactors?: Array<{
              __typename: "RiskFactorStats";
              mrn: string;
              indicator: string;
              title: string;
              total: number;
              isPositive: boolean;
              affected: number;
              magnitude?: {
                __typename: "RiskMagnitude";
                value: number;
                isToxic: boolean;
              } | null;
            } | null> | null;
          } | null;
        }> | null;
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetFindingsQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  filter?: InputMaybe<FindingsFilter>;
}>;

export type GetFindingsQuery = {
  __typename: "Query";
  findings?:
    | {
        __typename: "FindingsConnection";
        totalCount: number;
        filteredTotalCount: number;
        edges?: Array<{
          __typename: "FindingsEdge";
          cursor: string;
          node?:
            | {
                __typename: "AdvisoryFinding";
                id: string;
                mrn: string;
                title: string;
                rating: ScoreRating;
                riskValue: number;
                lastUpdated: string;
                publishedAt?: string | null;
                firstDetectedAt: string;
                iconId: Icon_Ids;
                state: ScoreState;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                } | null;
                cases?: {
                  __typename: "CasesConnection";
                  totalCount: number;
                  edges?: Array<{
                    __typename: "CaseEdge";
                    node: {
                      __typename: "Case";
                      status: CaseStatus;
                      mrn: string;
                      createdAt: string;
                      ticketRefs?: Array<{
                        __typename: "TicketRef";
                        type: TicketRefType;
                      }> | null;
                    };
                  }> | null;
                } | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                spaceRiskDelta?: {
                  __typename: "FindingSpaceRiskDelta";
                  delta: number;
                  effort: number;
                  manualEffort: {
                    __typename: "ManualEffort";
                    research: number;
                    rollout: number;
                    scripting: number;
                    totalManualEffort: number;
                    verification: number;
                  };
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                states: {
                  __typename: "FindingState";
                  score: FindingScoreState;
                  age: FindingAgeState;
                  action: FindingActionState;
                  securityPipeline: FindingSecurityPipelineState;
                  ticket: FindingTicketState;
                  exception: FindingExceptionState;
                  overall: FindingOverallState;
                  enforcement: FindingEnforcementState;
                };
                exception?: {
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  scope: string;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  justification: string;
                  action: ExceptionMutationAction;
                  createdAt: string;
                  author?: {
                    __typename: "Author";
                    name: string;
                    mrn?: string | null;
                    email?: string | null;
                    type: AuthorType;
                  } | null;
                } | null;
              }
            | {
                __typename: "CheckFinding";
                id: string;
                mrn: string;
                title: string;
                rating: ScoreRating;
                state: ScoreState;
                resultType: ScoreResultType;
                riskValue: number;
                lastUpdated: string;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                } | null;
                cases?: {
                  __typename: "CasesConnection";
                  totalCount: number;
                  edges?: Array<{
                    __typename: "CaseEdge";
                    node: {
                      __typename: "Case";
                      status: CaseStatus;
                      mrn: string;
                      createdAt: string;
                      ticketRefs?: Array<{
                        __typename: "TicketRef";
                        type: TicketRefType;
                      }> | null;
                    };
                  }> | null;
                } | null;
                states: {
                  __typename: "FindingState";
                  score: FindingScoreState;
                  age: FindingAgeState;
                  action: FindingActionState;
                  securityPipeline: FindingSecurityPipelineState;
                  ticket: FindingTicketState;
                  exception: FindingExceptionState;
                  overall: FindingOverallState;
                  enforcement: FindingEnforcementState;
                };
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                spaceRiskDelta?: {
                  __typename: "FindingSpaceRiskDelta";
                  delta: number;
                  effort: number;
                  manualEffort: {
                    __typename: "ManualEffort";
                    research: number;
                    rollout: number;
                    scripting: number;
                    totalManualEffort: number;
                    verification: number;
                  };
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                exception?: {
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  scope: string;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  action: ExceptionMutationAction;
                  justification: string;
                  createdAt: string;
                  author?: {
                    __typename: "Author";
                    name: string;
                    mrn?: string | null;
                    email?: string | null;
                    type: AuthorType;
                  } | null;
                } | null;
              }
            | {
                __typename: "CveFinding";
                id: string;
                mrn: string;
                title: string;
                rating: ScoreRating;
                riskValue: number;
                lastUpdated: string;
                publishedAt?: string | null;
                state: ScoreState;
                asset?: {
                  __typename: "EntityInfoAsset";
                  icon?: Icon_Ids | null;
                  name: string;
                  id: string;
                  mrn: string;
                  tags?: Array<{
                    __typename: "Tag";
                    key: string;
                    value: string;
                  } | null> | null;
                } | null;
                cases?: {
                  __typename: "CasesConnection";
                  totalCount: number;
                  edges?: Array<{
                    __typename: "CaseEdge";
                    node: {
                      __typename: "Case";
                      status: CaseStatus;
                      mrn: string;
                      createdAt: string;
                      ticketRefs?: Array<{
                        __typename: "TicketRef";
                        type: TicketRefType;
                      }> | null;
                    };
                  }> | null;
                } | null;
                states: {
                  __typename: "FindingState";
                  score: FindingScoreState;
                  age: FindingAgeState;
                  action: FindingActionState;
                  securityPipeline: FindingSecurityPipelineState;
                  ticket: FindingTicketState;
                  exception: FindingExceptionState;
                  overall: FindingOverallState;
                  enforcement: FindingEnforcementState;
                };
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                spaceRiskDelta?: {
                  __typename: "FindingSpaceRiskDelta";
                  delta: number;
                  effort: number;
                  manualEffort: {
                    __typename: "ManualEffort";
                    research: number;
                    rollout: number;
                    scripting: number;
                    totalManualEffort: number;
                    verification: number;
                  };
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                exception?: {
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  scope: string;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  justification: string;
                  action: ExceptionMutationAction;
                  createdAt: string;
                  author?: {
                    __typename: "Author";
                    name: string;
                    email?: string | null;
                    type: AuthorType;
                  } | null;
                } | null;
              }
            | {
                __typename: "GenericFinding";
                id: string;
                mrn: string;
                title: string;
                rating: ScoreRating;
                riskValue: number;
                lastUpdated: string;
                state: ScoreState;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                } | null;
                states: {
                  __typename: "FindingState";
                  score: FindingScoreState;
                  age: FindingAgeState;
                  action: FindingActionState;
                  securityPipeline: FindingSecurityPipelineState;
                  ticket: FindingTicketState;
                  exception: FindingExceptionState;
                  overall: FindingOverallState;
                  enforcement: FindingEnforcementState;
                };
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                exceptions?: Array<{
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  scope: string;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  justification: string;
                  action: ExceptionMutationAction;
                  createdAt: string;
                  author?: {
                    __typename: "Author";
                    name: string;
                    email?: string | null;
                    type: AuthorType;
                  } | null;
                } | null> | null;
              }
            | { __typename: "PackageFinding" }
            | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetFindingsFilterSuggestionsQueryVariables = Exact<{
  resourceMrn: Scalars["String"]["input"];
  filterType: FindingFilterType;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<FindingsFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetFindingsFilterSuggestionsQuery = {
  __typename: "Query";
  findingsFilterSuggestions?: Array<{
    __typename: "FindingsFilterSuggestion";
    label: string;
    value:
      | { __typename: "FindingTypeValue"; findingTypeValue: FindingType }
      | { __typename: "ScoreRatingValue"; ratingValue: ScoreRating }
      | {
          __typename: "ScoreStateFilterValue";
          scoreStateValue: ScoreStateFilter;
        }
      | { __typename: "StringValue"; stringValue: string };
  }> | null;
};

export type GetInitiativesQueryVariables = Exact<{
  input: InitiativesInput;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<InitiativeOrder>;
}>;

export type GetInitiativesQuery = {
  __typename: "Query";
  initiatives: {
    __typename: "InitiativesConnection";
    totalCount: number;
    edges?: Array<{
      __typename: "InitiativeEdge";
      cursor: string;
      node: {
        __typename: "Initiative";
        mrn: string;
        title: string;
        status: InitiativeStatus;
        createdAt: string;
        updatedAt: string;
        scoreDelta: number;
        metadata?:
          | {
              __typename: "AggregateInitiativeMetadata";
              assetCount: number;
              fixedCount: number;
              findingCount: number;
              effort: number;
              securityPipelineSupportedCount: number;
              manualEffort: {
                __typename: "ManualEffort";
                research: number;
                rollout: number;
                scripting: number;
                verification: number;
                totalManualEffort: number;
              };
            }
          | {
              __typename: "AssetInitiativeMetadata";
              securityPipelineSupportedCount: number;
            }
          | null;
        references?: Array<{
          __typename: "InitiativeRef";
          findingMrn: string;
        }> | null;
      };
    }> | null;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type GetIntegrationsSummaryQueryVariables = Exact<{
  input: IntegrationsSummaryInput;
}>;

export type GetIntegrationsSummaryQuery = {
  __typename: "Query";
  integrationsSummary: {
    __typename: "IntegrationsSummaryPayload";
    total: number;
    integrationSummaries?: Array<{
      __typename: "IntegrationTypeSummary";
      totalCount: number;
      activeCount: number;
      failedCount: number;
      warningCount: number;
      assetsCount: number;
      policiesCount: number;
      checksCount: number;
      type: IntegrationType;
    }> | null;
  };
};

export type GetListFrameworksQueryVariables = Exact<{
  input: ListFrameworksInput;
}>;

export type GetListFrameworksQuery = {
  __typename: "Query";
  listFrameworks?: {
    __typename: "FrameworksConnection";
    edges?: Array<{
      __typename: "FrameworkEdge";
      cursor: string;
      node: {
        __typename: "Framework";
        mrn: string;
        title: string;
        description: string;
        state: ComplianceFrameworkState;
        uploadedAt: string;
        authors?: Array<{
          __typename: "Author";
          name: string;
          email?: string | null;
          type: AuthorType;
        }> | null;
        tags?: Array<{ __typename: "Tag"; key: string; value: string }> | null;
        score?: {
          __typename: "AggregateScore";
          id: string;
          iconId: Icon_Ids;
          spaceId: string;
          findingMrn: string;
          rank: number;
          baseScore?: number | null;
          riskValue?: number | null;
          completion?: number | null;
          scoreType: AggregateScoreType;
          title: string;
          description: string;
          lastScannedAt?: string | null;
          firstDetectedAt: string;
          remediatedAt: string;
          state: AggregateScoreState;
          entity?:
            | {
                __typename: "EntityInfoAsset";
                id: string;
                mrn: string;
                name: string;
                icon?: Icon_Ids | null;
                lastUpdated: string;
              }
            | { __typename: "EntityInfoOrganization" }
            | { __typename: "EntityInfoPlatform" }
            | {
                __typename: "EntityInfoSpace";
                id: string;
                mrn: string;
                name: string;
              }
            | { __typename: "EntityInfoUnknown" }
            | { __typename: "EntityInfoWorkspace" }
            | null;
          tags?: Array<{
            __typename: "Tag";
            key: string;
            value: string;
          }> | null;
          blastRadius?: {
            __typename: "BlastRadius";
            indicator: string;
            assets: number;
            affected: number;
            critical: number;
            high: number;
            medium: number;
            low: number;
            none: number;
            error: number;
            pass: number;
            disabled: number;
            snoozed: number;
          } | null;
          riskFactors?: Array<{
            __typename: "RiskFactorStats";
            mrn: string;
            indicator: string;
            title: string;
            affected: number;
            total: number;
            isPositive: boolean;
          } | null> | null;
          epss?: {
            __typename: "EpssScore";
            probability: number;
            percentile: number;
          } | null;
          cvss?: {
            __typename: "CvssScore";
            id: string;
            value: number;
            type: number;
            vector: string;
            source: string;
          } | null;
          versionDistribution?: {
            __typename: "VersionDistribution";
            total: number;
            assets: number;
            installations: number;
            distribution?: Array<{
              __typename: "VersionDistributionEntry";
              version: string;
              count: number;
              riskValue: number;
            }> | null;
          } | null;
        } | null;
      };
    }> | null;
  } | null;
};

export type GetMetricsQueryVariables = Exact<{
  entityMrn: Scalars["String"]["input"];
  metricMrns?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  startTime?: InputMaybe<Scalars["String"]["input"]>;
  endTime?: InputMaybe<Scalars["String"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetMetricsQuery = {
  __typename: "Query";
  metrics?: {
    __typename: "MetricsResponse";
    entries?: Array<{
      __typename: "MetricEntry";
      metricMrn: string;
      title: string;
      arrowResult?: string | null;
    }> | null;
  } | null;
};

export type GetOrganizationOverviewQueryVariables = Exact<{
  input: OrganizationOverviewInput;
}>;

export type GetOrganizationOverviewQuery = {
  __typename: "Query";
  organizationOverview?: {
    __typename: "OrganizationOverviewResponse";
    organizationMrn: string;
    eolAssets: number;
    reportDate?: string | null;
    assetScores?: Array<{
      __typename: "AssetScoresDistribution";
      date: string;
      scores: {
        __typename: "RiskDistribution";
        total: number;
        A: number;
        B: number;
        C: number;
        D: number;
        F: number;
        U: number;
        Error: number;
      };
    }> | null;
    assets: {
      __typename: "AssetsInfo";
      improved: number;
      regressed: number;
      unchanged: number;
      scores: {
        __typename: "RiskDistribution";
        total: number;
        A: number;
        B: number;
        C: number;
        D: number;
        F: number;
        U: number;
        Error: number;
      };
    };
    vulnerabilities?: Array<{
      __typename: "Vulnerabilities";
      date: string;
      critical: number;
      high: number;
    }> | null;
    topVulnerabilities?: Array<{
      __typename: "VulnerabilityInfo";
      totalAffectedAssets: number;
      stats?: Array<{
        __typename: "VulnerabilitiesPerSpace";
        amountAssets: number;
        spaceMrn: string;
        spaceName: string;
        spaceOwners: Array<string>;
      }> | null;
      cve: {
        __typename: "Cve";
        id: string;
        title?: string | null;
        description?: string | null;
        cvssScore: {
          __typename: "CvssScore";
          id: string;
          type: number;
          value: number;
        };
      };
    }> | null;
    newVulnerabilities?: Array<{
      __typename: "NewVulnerabilityInfo";
      date: string;
      assetsAffected: number;
      cve: {
        __typename: "Cve";
        id: string;
        title?: string | null;
        description?: string | null;
        cvssScore: { __typename: "CvssScore"; type: number; value: number };
      };
    }> | null;
    spacesOverview?: Array<{
      __typename: "SpaceInfo";
      spaceName: string;
      spaceMrn: string;
      scores: {
        __typename: "RiskDistribution";
        total: number;
        A: number;
        B: number;
        C: number;
        D: number;
        F: number;
        U: number;
        Error: number;
      };
    }> | null;
    integrationSummaries?: Array<{
      __typename: "IntegrationTypeSummary";
      type: IntegrationType;
      totalCount: number;
    }> | null;
  } | null;
};

export type GetOrganizationScopeQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  actions: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetOrganizationScopeQuery = {
  __typename: "Query";
  iamActions: Array<string>;
  organization?: {
    __typename: "Organization";
    id: string;
    mrn: string;
    name: string;
    description: string;
    company?: string | null;
  } | null;
};

export type GetPackagesQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  filter?: InputMaybe<FindingsFilter>;
}>;

export type GetPackagesQuery = {
  __typename: "Query";
  findings?:
    | {
        __typename: "FindingsConnection";
        totalCount: number;
        filteredTotalCount: number;
        edges?: Array<{
          __typename: "FindingsEdge";
          cursor: string;
          node?:
            | { __typename: "AdvisoryFinding" }
            | { __typename: "CheckFinding" }
            | { __typename: "CveFinding" }
            | { __typename: "GenericFinding" }
            | {
                __typename: "PackageFinding";
                id: string;
                mrn: string;
                riskValue: number;
                rating: ScoreRating;
                lastUpdated: string;
                title?: string | null;
                packageName?: string | null;
                installedVersion?: string | null;
                availableVersion?: string | null;
                firstFound: string;
                packageType: PackageType;
                iconId?: Icon_Ids | null;
                platform?: string | null;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  tags?: Array<{
                    __typename: "Tag";
                    key: string;
                    value: string;
                  } | null> | null;
                } | null;
                cvss: {
                  __typename: "CvssScore";
                  value: number;
                  id: string;
                  source: string;
                  type: number;
                  vector: string;
                };
                epss?: {
                  __typename: "EpssScore";
                  probability: number;
                  percentile: number;
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  total: number;
                  affected: number;
                  isPositive: boolean;
                } | null> | null;
              }
            | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetPolicyQueryVariables = Exact<{
  input: PolicyInput;
}>;

export type GetPolicyQuery = {
  __typename: "Query";
  policy?: {
    __typename: "Policy";
    mrn: string;
    name: string;
    version: string;
    action?: PolicyAction | null;
    assigned: boolean;
    assignedScope?: string | null;
    trustLevel: TrustLevel;
    docs: string;
    authors?: Array<{
      __typename: "Author";
      name: string;
      email?: string | null;
      type: AuthorType;
    }> | null;
    variantPlatformFilters?: Array<{
      __typename: "VariantPlatformFilter";
      id: string;
      title: string;
      icon: string;
    }> | null;
  } | null;
};

export type GetPolicyPropsQueryVariables = Exact<{
  input: PolicyInput;
  scopeInput: PolicyInput;
}>;

export type GetPolicyPropsQuery = {
  __typename: "Query";
  policy?: {
    __typename: "Policy";
    uid: string;
    mrn: string;
    properties?: Array<{
      __typename: "MProperty";
      uid: string;
      mrn: string;
      mql: string;
      defaultValue: string;
      overrideValue: string;
      title: string;
      for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
    }> | null;
    queries?: Array<{
      __typename: "Mquery";
      uid: string;
      mrn: string;
      properties?: Array<{
        __typename: "MProperty";
        uid: string;
        mrn: string;
        mql: string;
        defaultValue: string;
        overrideValue: string;
        title: string;
        for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
      }> | null;
    }> | null;
  } | null;
  scopePolicy?: {
    __typename: "Policy";
    uid: string;
    mrn: string;
    properties?: Array<{
      __typename: "MProperty";
      uid: string;
      mrn: string;
      mql: string;
      defaultValue: string;
      overrideValue: string;
      title: string;
      for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
    }> | null;
  } | null;
};

export type GetQueryDetectedAssetsQueryVariables = Exact<{
  entityMrn: Scalars["String"]["input"];
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<DataQueryFilter>;
}>;

export type GetQueryDetectedAssetsQuery = {
  __typename: "Query";
  dataQueries?:
    | {
        __typename: "DataQueriesConnection";
        totalCount: number;
        edges?: Array<{
          __typename: "DataQueriesEdge";
          cursor: string;
          node?: {
            __typename: "DataQuery";
            mrn: string;
            iconId: Icon_Ids;
            id: string;
            lastUpdated: string;
            value?: any | null;
            asset?: {
              __typename: "EntityInfoAsset";
              mrn: string;
              name: string;
            } | null;
            tags?: Array<{
              __typename: "Tag";
              key: string;
              value: string;
            }> | null;
          } | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError" }
    | { __typename: "RequestError" }
    | null;
};

export type GetQueryPackQueryVariables = Exact<{
  input: PolicyInput;
}>;

export type GetQueryPackQuery = {
  __typename: "Query";
  policy?: {
    __typename: "Policy";
    mrn: string;
    name: string;
    version: string;
    assigned: boolean;
    docs: string;
    trustLevel: TrustLevel;
    authors?: Array<{
      __typename: "Author";
      name: string;
      email?: string | null;
      type: AuthorType;
    }> | null;
    variantPlatformFilters?: Array<{
      __typename: "VariantPlatformFilter";
      id: string;
      title: string;
      icon: string;
    }> | null;
  } | null;
};

export type GetQueryPackQueriesQueryVariables = Exact<{
  input: PolicyInput;
}>;

export type GetQueryPackQueriesQuery = {
  __typename: "Query";
  policy?: {
    __typename: "Policy";
    mrn: string;
    queries?: Array<{
      __typename: "Mquery";
      uid: string;
      mrn: string;
      title: string;
      mql: string;
      action: PolicyReportScoreEntryAction;
      docs?: {
        __typename: "MqueryDocs";
        desc: string;
        remediations?:
          | {
              __typename: "AuthenticationRequired";
              message: string;
              code: string;
            }
          | {
              __typename: "Remediations";
              entries: Array<{
                __typename: "MqueryRemediation";
                id: string;
                desc: string;
              }>;
            }
          | null;
        references?: Array<{
          __typename: "MqueryRef";
          title: string;
          url: string;
        }> | null;
      } | null;
      impact?: { __typename: "Impact"; value: number; rating: string } | null;
      tags?: Array<{ __typename: "Tag"; key: string; value: string }> | null;
      properties?: Array<{
        __typename: "MProperty";
        uid: string;
        mrn: string;
        title: string;
        mql: string;
        defaultValue: string;
        overrideValue: string;
        setByPolicyMrn?: string | null;
        for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
      }> | null;
    }> | null;
    groups?: Array<{
      __typename: "PolicyGroup";
      title: string;
      summary: string;
      checks?: Array<{
        __typename: "QueryRef";
        mrn: string;
        action: PolicyReportScoreEntryAction;
        impact?: { __typename: "Impact"; value: number; rating: string } | null;
      }> | null;
      queries?: Array<{
        __typename: "QueryRef";
        mrn: string;
        action: PolicyReportScoreEntryAction;
        impact?: { __typename: "Impact"; value: number; rating: string } | null;
      }> | null;
      policies?: Array<{
        __typename: "PolicyRef";
        mrn: string;
        action: PolicyReportScoreEntryAction;
        impact?: { __typename: "Impact"; value: number; rating: string } | null;
      }> | null;
    }> | null;
  } | null;
};

export type GetRegionScopeQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  actions: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetRegionScopeQuery = {
  __typename: "Query";
  iamActions: Array<string>;
};

export type GetRenderedAssetDataQueryQueryVariables = Exact<{
  input: RenderedAssetQueryDataInput;
}>;

export type GetRenderedAssetDataQueryQuery = {
  __typename: "Query";
  renderedAssetQueryData?:
    | { __typename: "NotFoundError"; message: string; code: string }
    | {
        __typename: "RenderedAssetQueryData";
        assessment?: string | null;
        data?: any | null;
      }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetRiskFactorsDocsQueryVariables = Exact<{
  spaceMrn: Scalars["String"]["input"];
  mrns?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type GetRiskFactorsDocsQuery = {
  __typename: "Query";
  riskFactors: {
    __typename: "RiskFactorsResponse";
    edges?: Array<{
      __typename: "RiskFactor";
      mrn: string;
      title: string;
      docs?: {
        __typename: "RiskFactorDocs";
        active?: string | null;
        inactive?: string | null;
      } | null;
    }> | null;
  };
};

export type GetSearchResultsQueryVariables = Exact<{
  input: AssetSearchInput;
  orderBy?: InputMaybe<AssetOrder>;
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetSearchResultsQuery = {
  __typename: "Query";
  assetSearch?: {
    __typename: "AssetsConnection";
    totalCount: number;
    pageInfo: {
      __typename: "PageInfo";
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
    };
    edges?: Array<{
      __typename: "AssetEdge";
      cursor: string;
      node?: {
        __typename: "Asset";
        asset_type: string;
        id: string;
        mrn: string;
        name?: string | null;
        referenceIDs: Array<string>;
        state: AssetState;
        updatedAt?: string | null;
        platform?: {
          __typename: "Platform";
          arch: string;
          kind: PlatformKind;
          name: string;
          runtime: string;
          title: string;
          version: string;
        } | null;
        score: {
          __typename: "Score";
          completion: number;
          grade: string;
          id: string;
          message: string;
          type: number;
          value: number;
          weight: number;
        };
      } | null;
    }> | null;
  } | null;
};

export type GetSecurityModelQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
}>;

export type GetSecurityModelQuery = {
  __typename: "Query";
  securityModel?: {
    __typename: "SecurityModel";
    scopeMrn: string;
    slas: {
      __typename: "SLAs";
      startDateConfig?: SlaStartDateConfig | null;
      findings: Array<{
        __typename: "FindingsSLA";
        daysBeforeWarning: number;
        daysToResolve: number;
        rating: ScoreRating;
      }>;
    };
  } | null;
};

export type GetSharedSpacesCountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSharedSpacesCountQuery = {
  __typename: "Query";
  sharedSpaces?: {
    __typename: "UserSharedSpacesConnection";
    totalCount: number;
  } | null;
};

export type GetSpaceInventoryStatsQueryVariables = Exact<{
  spaceMrn: Scalars["String"]["input"];
  metricMrns?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type GetSpaceInventoryStatsQuery = {
  __typename: "Query";
  space?: {
    __typename: "Space";
    mrn: string;
    stats?: {
      __typename: "SpaceStatistics";
      integrationsStatistics: Array<{
        __typename: "IntegrationStatistics";
        active: number;
        pending: number;
        errored: number;
        total: number;
        type: IntegrationType;
      }>;
    } | null;
    metrics?: {
      __typename: "MetricsResponse";
      entries?: Array<{
        __typename: "MetricEntry";
        metricMrn: string;
        title: string;
        arrowResult?: string | null;
      }> | null;
    } | null;
  } | null;
};

export type GetSpaceRiskFactorsQueryVariables = Exact<{
  spaceMrn: Scalars["String"]["input"];
}>;

export type GetSpaceRiskFactorsQuery = {
  __typename: "Query";
  riskFactors: {
    __typename: "RiskFactorsResponse";
    edges?: Array<{
      __typename: "RiskFactor";
      mrn: string;
      title: string;
      indicator: string;
      action?: RiskFactorAction | null;
      docs?: {
        __typename: "RiskFactorDocs";
        active?: string | null;
        inactive?: string | null;
      } | null;
      magnitude: {
        __typename: "RiskMagnitude";
        value: number;
        isToxic: boolean;
      };
      defaultMagnitude: {
        __typename: "RiskMagnitude";
        value: number;
        isToxic: boolean;
      };
      assetFieldFilters?: {
        __typename: "AssetFieldFilters";
        labelBasedFilters?: Array<{
          __typename: "KeyValue";
          key: string;
          value?: string | null;
        }> | null;
        annotationBasedFilters?: Array<{
          __typename: "KeyValue";
          key: string;
          value?: string | null;
        }> | null;
      } | null;
    }> | null;
  };
};

export type GetSpaceScopeQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  actions: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetSpaceScopeQuery = {
  __typename: "Query";
  iamActions: Array<string>;
  space?: {
    __typename: "Space";
    id: string;
    mrn: string;
    name: string;
    description: string;
    shared: boolean;
    organization?: {
      __typename: "Organization";
      id: string;
      mrn: string;
    } | null;
  } | null;
};

export type GetTicketContextQueryVariables = Exact<{
  input: TicketContextInput;
}>;

export type GetTicketContextQuery = {
  __typename: "Query";
  ticketContext:
    | {
        __typename: "AzureDevopsTicketContextProjectsPayload";
        projects?: Array<{
          __typename: "AzureDevopsProject";
          name: string;
        }> | null;
      }
    | {
        __typename: "EmailTicketContextPayload";
        recipients: Array<{
          __typename: "EmailRecipient";
          name: string;
          email: string;
          isDefault: boolean;
          referenceUrl?: string | null;
        }>;
      }
    | {
        __typename: "JiraTicketContextProjectsPayload";
        projects?: Array<{
          __typename: "JiraProject";
          key: string;
          name: string;
        }> | null;
      }
    | { __typename: "JiraTicketContextUsersPayload" }
    | {
        __typename: "ZendeskTicketContextFieldsPayload";
        priority?: Array<{
          __typename: "ZendeskField";
          value: string;
          displayName: string;
        }> | null;
        type?: Array<{
          __typename: "ZendeskField";
          value: string;
          displayName: string;
        }> | null;
      };
};

export type GetTicketingIntegrationsQueryVariables = Exact<{
  input: TicketingIntegrationsInput;
}>;

export type GetTicketingIntegrationsQuery = {
  __typename: "Query";
  ticketingIntegrations: {
    __typename: "TicketingIntegrationsPayload";
    integrations: Array<{
      __typename: "ClientIntegration";
      mrn: string;
      name: string;
      type: ClientIntegrationType;
      configurationOptions?:
        | { __typename: "AWSConfigurationOptions" }
        | { __typename: "AgentOptions" }
        | { __typename: "AttackSurfaceConfigurationOptions" }
        | { __typename: "AuditLogExportConfigurationOptions" }
        | { __typename: "AwsS3ConfigurationOptions" }
        | { __typename: "AzureBlobConfigurationOptions" }
        | { __typename: "AzureConfigurationOptions" }
        | {
            __typename: "AzureDevopsConfigurationOptions";
            defaultProjectName?: string | null;
            organizationUrl: string;
            servicePrincipalId: string;
            tenantId: string;
            autoCloseTickets: boolean;
            autoCreateTickets: boolean;
          }
        | { __typename: "BigqueryConfigurationOptions" }
        | { __typename: "CloudflareConfigurationOptions" }
        | { __typename: "CrowdstrikeFalconConfigurationOptions" }
        | { __typename: "DigitaloceanConfigurationOptions" }
        | { __typename: "ElasticConfigurationOptions" }
        | {
            __typename: "EmailConfigurationOptions";
            autoCreateTickets: boolean;
            recipients: Array<{
              __typename: "EmailRecipient";
              name: string;
              email: string;
              isDefault: boolean;
              referenceUrl?: string | null;
            }>;
          }
        | { __typename: "GcpConfigurationOptions" }
        | { __typename: "GcpServerlessConfigurationOptions" }
        | { __typename: "GcsBucketConfigurationOptions" }
        | { __typename: "GithubConfigurationOptions" }
        | {
            __typename: "GithubTicketingConfigurationOptions";
            enterpriseUrl?: string | null;
            defaultRepoOwner?: string | null;
            defaultRepoName?: string | null;
            autoCloseTickets: boolean;
            autoCreateTickets: boolean;
          }
        | { __typename: "GitlabConfigurationOptions" }
        | {
            __typename: "GitlabTicketingConfigurationOptions";
            autoCloseTickets: boolean;
            autoCreateTickets: boolean;
            gitlabBaseUrl?: string | null;
            gitlabDefaultProject?: string | null;
          }
        | { __typename: "GoogleSccExportConfigurationOptions" }
        | { __typename: "GoogleSccImportConfigurationOptions" }
        | { __typename: "GoogleWorkspaceConfigurationOptions" }
        | { __typename: "HetznerConfigurationOptions" }
        | { __typename: "HostConfigurationOptions" }
        | { __typename: "HostedAwsConfigurationOptions" }
        | {
            __typename: "JiraConfigurationOptions";
            host: string;
            email: string;
            defaultProject: string;
            autoCloseTickets: boolean;
            autoCreateCases: boolean;
            cloudId?: string | null;
          }
        | { __typename: "K8sConfigurationOptions" }
        | { __typename: "MicrosoftDefenderConfigurationOptions" }
        | { __typename: "Ms365ConfigurationOptions" }
        | { __typename: "MsIntuneConfigurationOptions" }
        | { __typename: "NetworkScanConfigurationOptions" }
        | { __typename: "NextdnsConfigurationOptions" }
        | { __typename: "OciConfigurationOptions" }
        | { __typename: "OktaConfigurationOptions" }
        | { __typename: "OpenvasConfigurationOptions" }
        | { __typename: "PostgresConfigurationOptions" }
        | { __typename: "QualysConfigurationOptions" }
        | { __typename: "S3ConfigurationOptions" }
        | { __typename: "SecurityPipelineGithubConfigurationOptions" }
        | { __typename: "SecurityScorecardConfigurationOptions" }
        | { __typename: "SentinelOneConfigurationOptions" }
        | {
            __typename: "ServiceNowConfigurationOptions";
            instanceUrl: string;
            clientId: string;
            autoCloseTickets: boolean;
            autoCreateTickets: boolean;
            userEmail?: string | null;
          }
        | { __typename: "ShodanConfigurationOptions" }
        | { __typename: "SlackConfigurationOptions" }
        | { __typename: "SnowflakeConfigurationOptions" }
        | { __typename: "SnowflakeScanConfigurationOptions" }
        | { __typename: "SnykConfigurationOptions" }
        | { __typename: "SonarqubeConfigurationOptions" }
        | { __typename: "SplunkConfigurationOptions" }
        | { __typename: "StackitConfigurationOptions" }
        | { __typename: "TailscaleConfigurationOptions" }
        | { __typename: "TenableConfigurationOptions" }
        | { __typename: "TenableSCConfigurationOptions" }
        | { __typename: "WebhookConfigurationOptions"; url: string }
        | {
            __typename: "ZendeskConfigurationOptions";
            subdomain: string;
            email: string;
            autoCloseTickets: boolean;
            autoCreateTickets: boolean;
            customFields?: Array<{
              __typename: "ZendeskCustomField";
              id: number;
              value: string;
            }> | null;
          }
        | null;
    } | null>;
  };
};

export type GetTopAssetFindingsQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  filter?: InputMaybe<FindingsFilter>;
}>;

export type GetTopAssetFindingsQuery = {
  __typename: "Query";
  findings?:
    | {
        __typename: "FindingsConnection";
        edges?: Array<{
          __typename: "FindingsEdge";
          cursor: string;
          node?:
            | {
                __typename: "AdvisoryFinding";
                mrn: string;
                id: string;
                title: string;
                state: ScoreState;
                iconId: Icon_Ids;
                riskValue: number;
                rating: ScoreRating;
                firstDetectedAt: string;
                publishedAt?: string | null;
                lastUpdated: string;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  lastUpdated: string;
                  platform?: {
                    __typename: "Platform";
                    name: string;
                    title: string;
                    arch: string;
                    version: string;
                    kind: PlatformKind;
                    runtime: string;
                    release: string;
                    family?: Array<string> | null;
                    labels?: Array<{
                      __typename: "KeyValue";
                      key: string;
                      value?: string | null;
                    }> | null;
                  } | null;
                } | null;
                epss?: {
                  __typename: "EpssScore";
                  probability: number;
                  percentile: number;
                } | null;
                cvss?: {
                  __typename: "CvssScore";
                  id: string;
                  value: number;
                  type: number;
                  vector: string;
                  source: string;
                  rating: ScoreRating;
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                detectionSources: Array<{
                  __typename: "VulnerabilityScoreSource";
                  name: string;
                  url?: string | null;
                  firstDetectedAt: string;
                  lastUpdatedAt: string;
                  fixedAt?: string | null;
                  vendor?: VulnerabilityScoreSourceVendor | null;
                  version?: string | null;
                }>;
                exceptions?: Array<{
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  reviewStatus: ReviewStatus;
                  action: ExceptionMutationAction;
                  justification: string;
                } | null> | null;
              }
            | {
                __typename: "CheckFinding";
                mrn: string;
                id: string;
                title: string;
                state: ScoreState;
                iconId: Icon_Ids;
                baseScore: number;
                riskValue: number;
                rating: ScoreRating;
                lastUpdated: string;
                resultType: ScoreResultType;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  lastUpdated: string;
                  platform?: {
                    __typename: "Platform";
                    name: string;
                    title: string;
                    arch: string;
                    version: string;
                    kind: PlatformKind;
                    runtime: string;
                    release: string;
                    family?: Array<string> | null;
                    labels?: Array<{
                      __typename: "KeyValue";
                      key: string;
                      value?: string | null;
                    }> | null;
                  } | null;
                } | null;
                exceptions?: Array<{
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  reviewStatus: ReviewStatus;
                  action: ExceptionMutationAction;
                  justification: string;
                } | null> | null;
                mquery?: {
                  __typename: "Mquery";
                  uid: string;
                  mrn: string;
                  title: string;
                  mql: string;
                  parent?: string | null;
                  action: PolicyReportScoreEntryAction;
                  code: string;
                  codeId: string;
                  severity?: number | null;
                  docs?: {
                    __typename: "MqueryDocs";
                    desc: string;
                    audit: string;
                    remediation: string;
                    remediations?:
                      | {
                          __typename: "AuthenticationRequired";
                          message: string;
                          code: string;
                        }
                      | {
                          __typename: "Remediations";
                          entries: Array<{
                            __typename: "MqueryRemediation";
                            id: string;
                            desc: string;
                          }>;
                        }
                      | null;
                    references?: Array<{
                      __typename: "MqueryRef";
                      title: string;
                      url: string;
                    }> | null;
                  } | null;
                  impact?: {
                    __typename: "Impact";
                    value: number;
                    rating: string;
                  } | null;
                  properties?: Array<{
                    __typename: "MProperty";
                    uid: string;
                    mrn: string;
                    title: string;
                    mql: string;
                    defaultValue: string;
                    overrideValue: string;
                    setByPolicyMrn?: string | null;
                    for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
                  }> | null;
                  variants?: Array<{
                    __typename: "Variant";
                    id: string;
                    mrn: string;
                    title: string;
                    icon: string;
                  }> | null;
                  variantQueries?: Array<{
                    __typename: "MqueryVariant";
                    uid: string;
                    mrn: string;
                    title: string;
                    mql: string;
                    filter: string;
                    filterID: string;
                  } | null> | null;
                } | null;
              }
            | {
                __typename: "CveFinding";
                mrn: string;
                id: string;
                title: string;
                state: ScoreState;
                iconId: Icon_Ids;
                riskValue: number;
                rating: ScoreRating;
                firstDetectedAt: string;
                publishedAt?: string | null;
                lastUpdated: string;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  lastUpdated: string;
                  platform?: {
                    __typename: "Platform";
                    name: string;
                    title: string;
                    arch: string;
                    version: string;
                    kind: PlatformKind;
                    runtime: string;
                    release: string;
                    family?: Array<string> | null;
                    labels?: Array<{
                      __typename: "KeyValue";
                      key: string;
                      value?: string | null;
                    }> | null;
                  } | null;
                } | null;
                epss?: {
                  __typename: "EpssScore";
                  probability: number;
                  percentile: number;
                } | null;
                cvss?: {
                  __typename: "CvssScore";
                  id: string;
                  value: number;
                  type: number;
                  vector: string;
                  source: string;
                  rating: ScoreRating;
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                detectionSources: Array<{
                  __typename: "VulnerabilityScoreSource";
                  name: string;
                  url?: string | null;
                  firstDetectedAt: string;
                  lastUpdatedAt: string;
                  fixedAt?: string | null;
                  vendor?: VulnerabilityScoreSourceVendor | null;
                  version?: string | null;
                }>;
                exceptions?: Array<{
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  reviewStatus: ReviewStatus;
                  action: ExceptionMutationAction;
                  justification: string;
                } | null> | null;
              }
            | { __typename: "GenericFinding" }
            | { __typename: "PackageFinding" }
            | null;
        }> | null;
      }
    | { __typename: "NotFoundError" }
    | { __typename: "RequestError" }
    | null;
};

export type GetTotalAssetsQueryVariables = Exact<{
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  workflowMrn?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetTotalAssetsQuery = {
  __typename: "Query";
  assets?: { __typename: "AssetsConnection"; totalCount: number } | null;
};

export type GetUserProfileQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  identitiesFilter?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  includeChildrenOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetUserProfileQuery = {
  __typename: "Query";
  userInfo?: {
    __typename: "Organization";
    id: string;
    mrn: string;
    members?: {
      __typename: "MembersConnection";
      edges?: Array<{
        __typename: "MemberEdge";
        node?: {
          __typename: "Member";
          identity:
            | { __typename: "PendingUser" }
            | { __typename: "ServiceAccount" }
            | { __typename: "Team" }
            | {
                __typename: "User";
                createdAt?: string | null;
                email?: string | null;
                mrn: string;
                name: string;
              };
          roles: Array<{ __typename: "Role"; mrn: string; title: string }>;
        } | null;
      }> | null;
    } | null;
  } | null;
  spaceInfo?: {
    __typename: "Organization";
    id: string;
    mrn: string;
    members?: {
      __typename: "MembersConnection";
      totalCount: number;
      pageInfo: {
        __typename: "PageInfo";
        endCursor: string;
        hasNextPage: boolean;
      };
      edges?: Array<{
        __typename: "MemberEdge";
        cursor: string;
        node?: {
          __typename: "Member";
          roles: Array<{ __typename: "Role"; mrn: string; title: string }>;
          resource: { __typename: "ResourceInfo"; mrn: string; name: string };
        } | null;
      }> | null;
    } | null;
  } | null;
};

export type GetWorkspaceQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  metricMrns?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type GetWorkspaceQuery = {
  __typename: "Query";
  workspace:
    | { __typename: "NotFoundError"; code: string; message: string }
    | { __typename: "RequestError"; code: string; message: string }
    | {
        __typename: "Workspace";
        mrn: string;
        ownerMrn: string;
        name: string;
        description?: string | null;
        priorityFindings: number;
        assetGroupStats: Array<{
          __typename: "AssetGroupStatistics";
          count: number;
          groupType: string;
          displayName: string;
        }>;
        metrics?: {
          __typename: "MetricsResponse";
          entries?: Array<{
            __typename: "MetricEntry";
            metricMrn: string;
            title: string;
            arrowResult?: string | null;
          }> | null;
        } | null;
      };
};

export type GetWorkspacesGlobalCountQueryVariables = Exact<{
  input: WorkspacesInput;
}>;

export type GetWorkspacesGlobalCountQuery = {
  __typename: "Query";
  workspaces: {
    __typename: "WorkspacesConnection";
    totalCount: number;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type GetWorkspaceInventoryStatsQueryVariables = Exact<{
  workspaceMrn: Scalars["String"]["input"];
  metricMrns?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type GetWorkspaceInventoryStatsQuery = {
  __typename: "Query";
  workspace:
    | { __typename: "NotFoundError" }
    | { __typename: "RequestError" }
    | {
        __typename: "Workspace";
        mrn: string;
        metrics?: {
          __typename: "MetricsResponse";
          entries?: Array<{
            __typename: "MetricEntry";
            metricMrn: string;
            title: string;
            arrowResult?: string | null;
          }> | null;
        } | null;
      };
};

export type GetWorkspaceScopeQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  actions: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetWorkspaceScopeQuery = {
  __typename: "Query";
  iamActions: Array<string>;
  workspace:
    | { __typename: "NotFoundError" }
    | { __typename: "RequestError" }
    | {
        __typename: "Workspace";
        mrn: string;
        name: string;
        description?: string | null;
      };
};

export type GetWorkspacesQueryVariables = Exact<{
  input: WorkspacesInput;
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  metricMrns?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  startTime?: InputMaybe<Scalars["String"]["input"]>;
  endTime?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetWorkspacesQuery = {
  __typename: "Query";
  workspaces: {
    __typename: "WorkspacesConnection";
    totalCount: number;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    edges?: Array<{
      __typename: "WorkspaceEdge";
      cursor: string;
      node: {
        __typename: "Workspace";
        mrn: string;
        ownerMrn: string;
        name: string;
        description?: string | null;
        priorityFindings: number;
        assetGroupStats: Array<{
          __typename: "AssetGroupStatistics";
          count: number;
          displayName: string;
          groupType: string;
          icon: Icon_Ids;
          listsAssetTypes: Array<{
            __typename: "AssetTypeInfo";
            assetType: string;
            displayName: string;
            shortName: string;
            aliases?: Array<string> | null;
          }>;
          statistics?: Array<{
            __typename: "AssetTypeStatistics";
            count: number;
            type: {
              __typename: "AssetTypeInfo";
              assetType: string;
              displayName: string;
              shortName: string;
              aliases?: Array<string> | null;
            };
          }> | null;
        }>;
        metrics?: {
          __typename: "MetricsResponse";
          entries?: Array<{
            __typename: "MetricEntry";
            metricMrn: string;
            title: string;
            arrowResult?: string | null;
          }> | null;
        } | null;
      };
    }> | null;
  };
};

export type GetWorkspacesListQueryVariables = Exact<{
  input: WorkspacesInput;
}>;

export type GetWorkspacesListQuery = {
  __typename: "Query";
  workspaces: {
    __typename: "WorkspacesConnection";
    edges?: Array<{
      __typename: "WorkspaceEdge";
      node: { __typename: "Workspace"; mrn: string; name: string };
    }> | null;
  };
};

export type ListClientIntegrationsQueryVariables = Exact<{
  input: ListClientIntegrationsInput;
}>;

export type ListClientIntegrationsQuery = {
  __typename: "Query";
  listClientIntegrations: {
    __typename: "ListClientIntegrationsPayload";
    integrations: Array<{
      __typename: "ClientIntegration";
      mrn: string;
      name: string;
      status: string;
      created: string;
      type: ClientIntegrationType;
      lastCheckin?: string | null;
      lastModified?: string | null;
      createdBy?: {
        __typename: "Author";
        mrn?: string | null;
        name: string;
      } | null;
      messages?: Array<{
        __typename: "IntegrationMessage";
        message: string;
        status: IntegrationMessageStatus;
      }> | null;
      configurationOptions?:
        | {
            __typename: "AWSConfigurationOptions";
            accountIds?: Array<string> | null;
            region: string;
            isOrganization?: boolean | null;
            snsEndpoint: string;
            originAWSAccountId: string;
            scanConfiguration: {
              __typename: "ScanConfiguration";
              ecrScan: boolean;
              ecsScan: boolean;
              cronScaninHours: number;
              accountScan: boolean;
              ec2Scan: boolean;
              ec2ScanOptions: {
                __typename: "Ec2ScanOptions";
                ebsVolumeScan: boolean;
                vaultType?: string | null;
                tagsFilter: any;
                excludedTagsFilter?: any | null;
                regionsFilter?: Array<string> | null;
                excludedRegionsFilter?: Array<string> | null;
                instanceIdsFilter?: Array<string> | null;
                excludedInstanceIdsFilter?: Array<string> | null;
                secretsMetadataQuery?: string | null;
                awsSecretsManagerVault?: boolean | null;
                ssm: boolean;
                instanceConnect: boolean;
                ebsScanOptions?: {
                  __typename: "EbsScanOptions";
                  maxAsgInstances?: number | null;
                  targetInstancesPerScanner?: number | null;
                } | null;
              };
              eventScanTriggers?: Array<{
                __typename: "AWSEventPattern";
                eventDetailType: string;
                eventSource: string;
                scanType: string;
              } | null> | null;
            };
          }
        | { __typename: "AgentOptions" }
        | { __typename: "AttackSurfaceConfigurationOptions" }
        | { __typename: "AuditLogExportConfigurationOptions" }
        | { __typename: "AwsS3ConfigurationOptions" }
        | { __typename: "AzureBlobConfigurationOptions" }
        | { __typename: "AzureConfigurationOptions" }
        | { __typename: "AzureDevopsConfigurationOptions" }
        | { __typename: "BigqueryConfigurationOptions" }
        | { __typename: "CloudflareConfigurationOptions" }
        | {
            __typename: "CrowdstrikeFalconConfigurationOptions";
            clientId: string;
            cloud?: string | null;
            memberCID?: string | null;
            createAssets?: boolean | null;
            mondooEnrichment?: boolean | null;
          }
        | { __typename: "DigitaloceanConfigurationOptions" }
        | { __typename: "ElasticConfigurationOptions" }
        | { __typename: "EmailConfigurationOptions" }
        | { __typename: "GcpConfigurationOptions" }
        | { __typename: "GcpServerlessConfigurationOptions" }
        | { __typename: "GcsBucketConfigurationOptions" }
        | {
            __typename: "GithubConfigurationOptions";
            owner?: string | null;
            repository?: string | null;
            organization?: string | null;
            type: GithubIntegrationType;
            reposAllowList?: Array<string> | null;
            reposDenyList?: Array<string> | null;
          }
        | { __typename: "GithubTicketingConfigurationOptions" }
        | { __typename: "GitlabConfigurationOptions" }
        | { __typename: "GitlabTicketingConfigurationOptions" }
        | { __typename: "GoogleSccExportConfigurationOptions" }
        | { __typename: "GoogleSccImportConfigurationOptions" }
        | { __typename: "GoogleWorkspaceConfigurationOptions" }
        | { __typename: "HetznerConfigurationOptions" }
        | { __typename: "HostConfigurationOptions" }
        | {
            __typename: "HostedAwsConfigurationOptions";
            accessKeyId?: string | null;
            role?: string | null;
          }
        | { __typename: "JiraConfigurationOptions" }
        | {
            __typename: "K8sConfigurationOptions";
            scanDeploys?: boolean | null;
            scanNodes?: boolean | null;
            scanWorkloads?: boolean | null;
            scanPublicImages?: boolean | null;
            certificateManager: string;
          }
        | {
            __typename: "MicrosoftDefenderConfigurationOptions";
            tenantId: string;
            clientId: string;
            subscriptionsAllowlist?: Array<string> | null;
            subscriptionsDenylist?: Array<string> | null;
            secretType?: string | null;
            createAssets?: boolean | null;
            mondooEnrichment?: boolean | null;
          }
        | { __typename: "Ms365ConfigurationOptions" }
        | { __typename: "MsIntuneConfigurationOptions" }
        | { __typename: "NetworkScanConfigurationOptions" }
        | { __typename: "NextdnsConfigurationOptions" }
        | { __typename: "OciConfigurationOptions" }
        | { __typename: "OktaConfigurationOptions" }
        | { __typename: "OpenvasConfigurationOptions" }
        | { __typename: "PostgresConfigurationOptions" }
        | { __typename: "QualysConfigurationOptions" }
        | { __typename: "S3ConfigurationOptions" }
        | {
            __typename: "SecurityPipelineGithubConfigurationOptions";
            appInstallationLink: string;
            publicKey?: string | null;
            autoCreateWorkflows: boolean;
            repositories?: Array<{
              __typename: "GithubRepository";
              link: string;
              fullName: string;
              spaceMrn?: string | null;
            }> | null;
          }
        | { __typename: "SecurityScorecardConfigurationOptions" }
        | {
            __typename: "SentinelOneConfigurationOptions";
            host: string;
            account: string;
            secretType?: string | null;
            createAssets?: boolean | null;
            mondooEnrichment?: boolean | null;
          }
        | { __typename: "ServiceNowConfigurationOptions" }
        | {
            __typename: "ShodanConfigurationOptions";
            token: string;
            targets?: Array<string> | null;
          }
        | { __typename: "SlackConfigurationOptions" }
        | { __typename: "SnowflakeConfigurationOptions" }
        | { __typename: "SnowflakeScanConfigurationOptions" }
        | { __typename: "SnykConfigurationOptions" }
        | { __typename: "SonarqubeConfigurationOptions" }
        | { __typename: "SplunkConfigurationOptions" }
        | { __typename: "StackitConfigurationOptions" }
        | { __typename: "TailscaleConfigurationOptions" }
        | { __typename: "TenableConfigurationOptions" }
        | { __typename: "TenableSCConfigurationOptions" }
        | { __typename: "WebhookConfigurationOptions" }
        | { __typename: "ZendeskConfigurationOptions" }
        | null;
      lastStateInfo?: {
        __typename: "K8sIntegrationLastState";
        namespace?: string | null;
        k8sVersion?: string | null;
        operatorVersion?: string | null;
      } | null;
    } | null>;
  };
};

export type ListDiscoveryResultsQueryVariables = Exact<{
  input: ListDiscoveryResultsInput;
}>;

export type ListDiscoveryResultsQuery = {
  __typename: "Query";
  listDiscoveryResults: {
    __typename: "ListDiscoveryResultsPayload";
    stats?: Array<{
      __typename: "DiscoveryStat";
      identifier?: string | null;
      query: string;
      count: number;
      title: string;
    }> | null;
  };
};

export type ListDocumentsQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ListDocumentsQuery = {
  __typename: "Query";
  listDocuments: {
    __typename: "DocumentMetadataConnection";
    totalCount: number;
    edges: Array<{
      __typename: "DocumentMetadataEdge";
      cursor: string;
      node: {
        __typename: "DocumentMetadata";
        mrn: string;
        name: string;
        type: DocumentType;
        format: DocumentFormat;
        status: DocumentStatus;
        statusMessage?: string | null;
        requestedAt: string;
        generatedAt?: string | null;
        messages?: Array<{
          __typename: "IntegrationMessage";
          id: string;
          message: string;
          status: IntegrationMessageStatus;
          timestamp?: string | null;
        }> | null;
        createdBy?: {
          __typename: "Author";
          name: string;
          email?: string | null;
          type: AuthorType;
        } | null;
      };
    }>;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type ListExceptionGroupsQueryVariables = Exact<{
  input: ListExceptionGroupsInput;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ListExceptionGroupsQuery = {
  __typename: "Query";
  listExceptionGroups: {
    __typename: "ListExceptionGroupsConnection";
    totalCount: number;
    edges?: Array<{
      __typename: "ExceptionGroupEdge";
      cursor: string;
      node: {
        __typename: "ExceptionGroup";
        action: ExceptionMutationAction;
        createdAt: string;
        deletedAt?: string | null;
        exceptionId: string;
        mrn: string;
        id: string;
        justification?: string | null;
        modifiedAt?: string | null;
        reviewStatus: ReviewStatus;
        status: ExceptionStatus;
        scopeMrn: string;
        title: string;
        validUntil?: string | null;
        author?: {
          __typename: "Author";
          email?: string | null;
          mrn?: string | null;
          name: string;
          type: AuthorType;
        } | null;
        deletedBy?: {
          __typename: "Author";
          name: string;
          email?: string | null;
        } | null;
        reviewer?: {
          __typename: "Author";
          email?: string | null;
          name: string;
          type: AuthorType;
        } | null;
        extensions?: Array<{
          __typename: "ExceptionGroupExtension";
          validUntil: string;
          justification?: string | null;
          status: ExceptionGroupExtensionStatus;
          createDate: string;
          reviewDate?: string | null;
          author: {
            __typename: "Author";
            name: string;
            mrn?: string | null;
            type: AuthorType;
            email?: string | null;
          };
          reviewer?: {
            __typename: "Author";
            type: AuthorType;
            name: string;
            email?: string | null;
          } | null;
        }> | null;
        exceptions: Array<
          | {
              __typename: "AssetAdvisoryException";
              mrn: string;
              id: string;
              title: string;
              iconId: Icon_Ids;
              riskScore?: number | null;
              riskValue?: number | null;
              rating: ScoreRating;
              cvss?: {
                __typename: "CvssScore";
                id: string;
                value: number;
                type: number;
                vector: string;
                source: string;
                rating: ScoreRating;
              } | null;
            }
          | {
              __typename: "AssetCheckException";
              mrn: string;
              title: string;
              riskScore?: number | null;
              riskValue?: number | null;
              rating: ScoreRating;
              policyMrn: string;
              policyName: string;
              score?: {
                __typename: "Score";
                id: string;
                value: number;
                type: number;
                completion: number;
                weight: number;
                message: string;
                grade: string;
                riskScore: number;
                riskValue: number;
                riskRating: ScoreRating;
              } | null;
            }
          | {
              __typename: "AssetCveException";
              mrn: string;
              id: string;
              title: string;
              riskScore?: number | null;
              riskValue?: number | null;
              rating: ScoreRating;
              cvss?: {
                __typename: "CvssScore";
                id: string;
                value: number;
                type: number;
                vector: string;
                source: string;
                rating: ScoreRating;
              } | null;
            }
          | {
              __typename: "AssetFexException";
              mrn: string;
              title: string;
              riskValue?: number | null;
              rating: ScoreRating;
            }
          | {
              __typename: "ControlsEdge";
              cursor: string;
              node?: {
                __typename: "ComplianceControl";
                mrn: string;
                title: string;
                state: ControlState;
                scopeMrn: string;
                description: string;
                completion: number;
                exception?: {
                  __typename: "ControlException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  createdAt: string;
                  modifiedAt?: string | null;
                  title: string;
                  justification?: string | null;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  action: ExceptionMutationAction;
                  author: {
                    __typename: "Author";
                    name: string;
                    mrn?: string | null;
                    type: AuthorType;
                    email?: string | null;
                  };
                  reviewer?: {
                    __typename: "Author";
                    name: string;
                    email?: string | null;
                  } | null;
                } | null;
                assetsStats: {
                  __typename: "ControlAssetsStats";
                  compliantAssets: number;
                  failedAssets: number;
                  totalAssets: number;
                };
                framework?: {
                  __typename: "ComplianceFramework";
                  name: string;
                  mrn: string;
                } | null;
              } | null;
            }
          | {
              __typename: "SpaceAdvisoryException";
              mrn: string;
              id: string;
              title: string;
              iconId: Icon_Ids;
              riskScore?: number | null;
              riskValue?: number | null;
              rating: ScoreRating;
              cvss?: {
                __typename: "CvssScore";
                id: string;
                value: number;
                type: number;
                vector: string;
                source: string;
                rating: ScoreRating;
              } | null;
            }
          | {
              __typename: "SpaceCheckException";
              mrn: string;
              title: string;
              riskScore?: number | null;
              riskValue?: number | null;
              rating: ScoreRating;
              policyMrn: string;
              policyName: string;
              assetsStats: {
                __typename: "SpaceCheckExceptionAssetStats";
                passed: number;
                failed: number;
                errored: number;
                total: number;
              };
            }
          | {
              __typename: "SpaceCveException";
              mrn: string;
              id: string;
              title: string;
              riskScore?: number | null;
              riskValue?: number | null;
              rating: ScoreRating;
              cvss?: {
                __typename: "CvssScore";
                id: string;
                value: number;
                type: number;
                vector: string;
                source: string;
                rating: ScoreRating;
              } | null;
            }
          | {
              __typename: "SpaceFexException";
              mrn: string;
              title: string;
              riskValue?: number | null;
              rating: ScoreRating;
            }
        >;
      };
    }> | null;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type ListSpaceExceptionsQueryVariables = Exact<{
  input: ListExceptionGroupsInput;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ListSpaceExceptionsQuery = {
  __typename: "Query";
  listExceptionGroups: {
    __typename: "ListExceptionGroupsConnection";
    totalCount: number;
    pageInfo: {
      __typename: "PageInfo";
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
    };
    edges?: Array<{
      __typename: "ExceptionGroupEdge";
      cursor: string;
      node: {
        __typename: "ExceptionGroup";
        action: ExceptionMutationAction;
        createdAt: string;
        deletedAt?: string | null;
        id: string;
        mrn: string;
        exceptionId: string;
        scopeMrn: string;
        title: string;
        justification?: string | null;
        modifiedAt?: string | null;
        validUntil?: string | null;
        reviewStatus: ReviewStatus;
        isActive: boolean;
        status: ExceptionStatus;
        author?: {
          __typename: "Author";
          name: string;
          mrn?: string | null;
          email?: string | null;
          type: AuthorType;
        } | null;
        deletedBy?: {
          __typename: "Author";
          email?: string | null;
          name: string;
          type: AuthorType;
        } | null;
        extensions?: Array<{
          __typename: "ExceptionGroupExtension";
          validUntil: string;
          justification?: string | null;
          status: ExceptionGroupExtensionStatus;
          createDate: string;
          reviewDate?: string | null;
          author: {
            __typename: "Author";
            name: string;
            mrn?: string | null;
            type: AuthorType;
            email?: string | null;
          };
          reviewer?: {
            __typename: "Author";
            name: string;
            email?: string | null;
            type: AuthorType;
          } | null;
        }> | null;
        exceptions: Array<
          | {
              __typename: "AssetAdvisoryException";
              mrn: string;
              id: string;
              title: string;
              iconId: Icon_Ids;
              riskValue?: number | null;
              rating: ScoreRating;
              cvss?: {
                __typename: "CvssScore";
                id: string;
                value: number;
                type: number;
                vector: string;
                source: string;
                rating: ScoreRating;
              } | null;
            }
          | {
              __typename: "AssetCheckException";
              mrn: string;
              title: string;
              riskValue?: number | null;
              rating: ScoreRating;
              policyMrn: string;
              policyName: string;
            }
          | {
              __typename: "AssetCveException";
              mrn: string;
              id: string;
              title: string;
              riskValue?: number | null;
              rating: ScoreRating;
              cvss?: {
                __typename: "CvssScore";
                id: string;
                value: number;
                type: number;
                vector: string;
                source: string;
                rating: ScoreRating;
              } | null;
            }
          | {
              __typename: "AssetFexException";
              mrn: string;
              title: string;
              riskValue?: number | null;
              rating: ScoreRating;
            }
          | {
              __typename: "ControlsEdge";
              node?: {
                __typename: "ComplianceControl";
                mrn: string;
                description: string;
                title: string;
                manual: boolean;
                completion: number;
                state: ControlState;
                framework?: {
                  __typename: "ComplianceFramework";
                  name: string;
                  version: string;
                } | null;
                tags: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                } | null>;
                assetsStats: {
                  __typename: "ControlAssetsStats";
                  compliantAssets: number;
                  failedAssets: number;
                  totalAssets: number;
                };
                checksStats: {
                  __typename: "ControlChecksStats";
                  activeChecks: number;
                  snoozedChecks: number;
                  disabledChecks: number;
                  totalChecks: number;
                };
              } | null;
            }
          | {
              __typename: "SpaceAdvisoryException";
              mrn: string;
              id: string;
              title: string;
              iconId: Icon_Ids;
              riskValue?: number | null;
              rating: ScoreRating;
              cvss?: {
                __typename: "CvssScore";
                id: string;
                value: number;
                type: number;
                vector: string;
                source: string;
                rating: ScoreRating;
              } | null;
            }
          | {
              __typename: "SpaceCheckException";
              mrn: string;
              title: string;
              riskValue?: number | null;
              rating: ScoreRating;
              policyMrn: string;
              policyName: string;
              assetsStats: {
                __typename: "SpaceCheckExceptionAssetStats";
                passed: number;
                failed: number;
                errored: number;
                total: number;
              };
            }
          | {
              __typename: "SpaceCveException";
              mrn: string;
              id: string;
              title: string;
              riskValue?: number | null;
              rating: ScoreRating;
              cvss?: {
                __typename: "CvssScore";
                id: string;
                value: number;
                type: number;
                vector: string;
                source: string;
                rating: ScoreRating;
              } | null;
            }
          | {
              __typename: "SpaceFexException";
              mrn: string;
              title: string;
              riskValue?: number | null;
              rating: ScoreRating;
            }
        >;
        reviewer?: {
          __typename: "Author";
          email?: string | null;
          name: string;
          type: AuthorType;
        } | null;
      };
    }> | null;
  };
};

export type LoadAdvisoryQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type LoadAdvisoryQuery = {
  __typename: "Query";
  advisory?: {
    __typename: "Advisory";
    mrn: string;
    id: string;
    title?: string | null;
    publishedAt?: string | null;
    modifiedAt?: string | null;
    description?: string | null;
    vulnerabilityRiskFactors: {
      __typename: "VulnerabilityRiskFactors";
      knownExploited: boolean;
      remoteExploitable: boolean;
    };
    externalUrls?: Array<{
      __typename: "Reference";
      iconIDEnum?: Icon_Ids | null;
      url: string;
      title?: string | null;
    } | null> | null;
    cvssScore: {
      __typename: "CvssScore";
      id: string;
      value: number;
      type: number;
      vector: string;
      source: string;
      rating: ScoreRating;
    };
  } | null;
};

export type LoadAdvisoryCvesQueryVariables = Exact<{
  advisoryId: Scalars["ID"]["input"];
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type LoadAdvisoryCvesQuery = {
  __typename: "Query";
  advisory?: {
    __typename: "Advisory";
    id: string;
    mrn: string;
    cves?: Array<{
      __typename: "Cve";
      id: string;
      mrn: string;
      riskValue?: number | null;
      rating?: ScoreRating | null;
      title?: string | null;
      description?: string | null;
      summary?: string | null;
      publishedAt?: string | null;
      modifiedAt?: string | null;
      url?: string | null;
      cwe?: string | null;
      state?: CveState | null;
      source: { __typename: "Source"; id: string; name: string; url: string };
      cvssScore: {
        __typename: "CvssScore";
        id: string;
        value: number;
        type: number;
        vector: string;
        source: string;
      };
      epssScore?: {
        __typename: "EpssScore";
        percentile: number;
        probability: number;
      } | null;
      vulnerabilityRiskFactors: {
        __typename: "VulnerabilityRiskFactors";
        knownExploited: boolean;
        remoteExploitable: boolean;
      };
    }> | null;
  } | null;
};

export type LoadAgentQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type LoadAgentQuery = {
  __typename: "Query";
  agent?: {
    __typename: "Agent";
    id: string;
    mrn: string;
    name: string;
    hostname: string;
    ipaddress: string;
    createdAt: string;
    status?: {
      __typename: "AgentStatus";
      version?: string | null;
      state?: AgentState | null;
      lastCheckin?: string | null;
    } | null;
    labels: Array<{
      __typename: "KeyValue";
      key: string;
      value?: string | null;
    }>;
    platform?: {
      __typename: "Platform";
      name: string;
      release: string;
      arch: string;
    } | null;
    errors?: Array<{
      __typename: "AgentError";
      timestamp?: string | null;
      message?: string | null;
    }> | null;
    serviceAccounts: Array<{
      __typename: "AgentServiceAccount";
      mrn: string;
      name: string;
    }>;
    assets: Array<{ __typename: "AgentAsset"; mrn: string; name: string }>;
  } | null;
};

export type LoadAssetQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type LoadAssetQuery = {
  __typename: "Query";
  asset?: {
    __typename: "Asset";
    id: string;
    mrn: string;
    state: AssetState;
    name?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    lastScoredAt?: string | null;
    referenceIDs: Array<string>;
    asset_type: string;
    labels: Array<{
      __typename: "KeyValue";
      key: string;
      value?: string | null;
    }>;
    platform?: {
      __typename: "Platform";
      name: string;
      title: string;
      arch: string;
      version: string;
      kind: PlatformKind;
      runtime: string;
      release: string;
      family?: Array<string> | null;
    } | null;
    score: {
      __typename: "Score";
      id: string;
      value: number;
      type: number;
      completion: number;
      weight: number;
      message: string;
      grade: string;
      riskValue: number;
      riskRating: ScoreRating;
    };
    eol?: { __typename: "EOLAnalysis"; date: string; status: EolStatus } | null;
    annotations: Array<{
      __typename: "KeyValue";
      key: string;
      value?: string | null;
    }>;
    insights?: {
      __typename: "AssetInsights";
      security: {
        __typename: "AssetInsightsSecurity";
        policyCount: number;
        score: {
          __typename: "Score";
          id: string;
          value: number;
          type: number;
          completion: number;
          weight: number;
          message: string;
          grade: string;
          riskRating: ScoreRating;
          riskValue: number;
        };
      };
      vulnerability?: {
        __typename: "AssetInsightsVulnerability";
        score: {
          __typename: "Score";
          id: string;
          value: number;
          type: number;
          completion: number;
          weight: number;
          message: string;
          grade: string;
          riskRating: ScoreRating;
          riskValue: number;
        };
      } | null;
    } | null;
    overviewGroups: Array<{
      __typename: "AssetOverviewGroup";
      key: string;
      title: string;
      items: Array<{
        __typename: "AssetOverviewItem";
        key: string;
        name: string;
        sources?: Array<
          | { __typename: "KeyValueSource"; key: string; value: string }
          | { __typename: "QuerySource"; mrn: string }
        > | null;
        values: Array<
          | {
              __typename: "AssetOverviewArrayValue";
              arrayValue?: Array<
                | { __typename: "AssetOverviewArrayValue" }
                | { __typename: "AssetOverviewBoolValue"; boolValue: boolean }
                | {
                    __typename: "AssetOverviewDictValue";
                    dictValue?: Array<{
                      __typename: "KeyValue";
                      key: string;
                      value?: string | null;
                    }> | null;
                  }
                | {
                    __typename: "AssetOverviewError";
                    value:
                      | {
                          __typename: "AssetOverviewErrorExecutionFailed";
                          msg: string;
                          queryMrn?: string | null;
                        }
                      | {
                          __typename: "AssetOverviewGenericError";
                          code: string;
                          msg: string;
                        };
                  }
                | {
                    __typename: "AssetOverviewNullValue";
                    nullValue?: string | null;
                  }
                | {
                    __typename: "AssetOverviewReferenceValue";
                    displayValue: string;
                    mrn: string;
                    referenceType: AssetOverviewReferenceTypeEnum;
                  }
                | {
                    __typename: "AssetOverviewStringValue";
                    stringValue: string;
                  }
                | { __typename: "AssetOverviewTimeValue"; timeValue: string }
                | {
                    __typename: "AssetOverviewURLValue";
                    displayValue: string;
                    url: string;
                  }
              > | null;
            }
          | { __typename: "AssetOverviewBoolValue"; boolValue: boolean }
          | {
              __typename: "AssetOverviewDictValue";
              dictValue?: Array<{
                __typename: "KeyValue";
                key: string;
                value?: string | null;
              }> | null;
            }
          | {
              __typename: "AssetOverviewError";
              value:
                | {
                    __typename: "AssetOverviewErrorExecutionFailed";
                    msg: string;
                    queryMrn?: string | null;
                  }
                | {
                    __typename: "AssetOverviewGenericError";
                    code: string;
                    msg: string;
                  };
            }
          | { __typename: "AssetOverviewNullValue"; nullValue?: string | null }
          | {
              __typename: "AssetOverviewReferenceValue";
              displayValue: string;
              mrn: string;
              referenceType: AssetOverviewReferenceTypeEnum;
            }
          | { __typename: "AssetOverviewStringValue"; stringValue: string }
          | { __typename: "AssetOverviewTimeValue"; timeValue: string }
          | {
              __typename: "AssetOverviewURLValue";
              displayValue: string;
              url: string;
            }
        >;
      }>;
    }>;
    listPolicies?: {
      __typename: "AssetPolicyListConnection";
      totalCount: number;
      edges: Array<{
        __typename: "AssetPolicyListEdge";
        cursor: string;
        node: {
          __typename: "AssetPolicy";
          mrn: string;
          name: string;
          action: PolicyAction;
          category: string;
          score: {
            __typename: "Score";
            id: string;
            value: number;
            type: number;
            completion: number;
            weight: number;
            message: string;
            grade: string;
            riskRating: ScoreRating;
            riskValue: number;
          };
          scoreStats?: {
            __typename: "ScoreStats";
            total: number;
            passed: number;
            failed: number;
            incomplete: number;
            errors: number;
            skipped: number;
            worst: number;
            snoozed: number;
            disabled: number;
            exceptions: number;
            unknown: number;
            riskAccepted: number;
          } | null;
        };
      }>;
      pageInfo: {
        __typename: "PageInfo";
        startCursor: string;
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    } | null;
    riskFactors?: Array<{
      __typename: "AssetRiskFactor";
      mrn: string;
      indicator: string;
      title: string;
      isDetected: boolean;
      isPositive: boolean;
      affected: number;
      total: number;
      magnitude: {
        __typename: "RiskMagnitude";
        value: number;
        isToxic: boolean;
      };
      explanation?: {
        __typename: "RiskFactorExplanation";
        magnitudeExplanation: RiskMagnitudeExplaination;
        summary: string;
      } | null;
    }> | null;
  } | null;
};

export type LoadAssetListPoliciesQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<AssetListPoliciesFilter>;
}>;

export type LoadAssetListPoliciesQuery = {
  __typename: "Query";
  asset?: {
    __typename: "Asset";
    mrn: string;
    listPolicies?: {
      __typename: "AssetPolicyListConnection";
      totalCount: number;
      edges: Array<{
        __typename: "AssetPolicyListEdge";
        cursor: string;
        node: {
          __typename: "AssetPolicy";
          mrn: string;
          name: string;
          category: string;
          action: PolicyAction;
          score: {
            __typename: "Score";
            id: string;
            value: number;
            type: number;
            completion: number;
            weight: number;
            message: string;
            grade: string;
            riskRating: ScoreRating;
            riskValue: number;
          };
          scoreStats?: {
            __typename: "ScoreStats";
            total: number;
            passed: number;
            failed: number;
            incomplete: number;
            errors: number;
            exceptions: number;
            disabled: number;
            snoozed: number;
            skipped: number;
            worst: number;
            unknown: number;
            riskAccepted: number;
          } | null;
        };
      }>;
      pageInfo: {
        __typename: "PageInfo";
        startCursor: string;
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    } | null;
  } | null;
};

export type LoadCategoriesQueryVariables = Exact<{
  input: CategoriesListInput;
}>;

export type LoadCategoriesQuery = {
  __typename: "Query";
  categories?: Array<{
    __typename: "Category";
    name: string;
    packs: number;
    policies: number;
    queries: number;
  } | null> | null;
};

export type LoadCicdProjectJobsQueryVariables = Exact<{
  input: CicdProjectJobsInput;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  labelFilter?: InputMaybe<Array<KeyValueInput> | KeyValueInput>;
}>;

export type LoadCicdProjectJobsQuery = {
  __typename: "Query";
  cicdProjectJobs?: {
    __typename: "CicdProjectJobs";
    id: string;
    spaceMrn: string;
    project: {
      __typename: "CicdProject";
      id: string;
      mrn: string;
      type: string;
      name: string;
      projectURL: string;
      projectID?: string | null;
    };
    jobs?: {
      __typename: "JobsConnection";
      totalCount: number;
      edges?: Array<{
        __typename: "JobEdge";
        cursor: string;
        node:
          | {
              __typename: "AzureDevopsJob";
              id: string;
              mrn: string;
              name: string;
              target?: string | null;
              projectUrl: string;
              job: string;
              jobId: string;
              buildUrl: string;
              userName: string;
              commitSha: string;
              repositoryUrl: string;
              branch: string;
              pipelineKind: GitPipelineKind;
              updatedAt: string;
              score: {
                __typename: "Score";
                type: number;
                id: string;
                value: number;
                completion: number;
                weight: number;
                message: string;
                riskRating: ScoreRating;
                riskValue: number;
              };
            }
          | {
              __typename: "CircleCIJob";
              id: string;
              mrn: string;
              name: string;
              target?: string | null;
              projectUrl: string;
              mergeRequestUrl: string;
              job: string;
              jobId: string;
              buildUrl: string;
              userName: string;
              commitSha: string;
              repositoryUrl: string;
              branch: string;
              associatedPullRequests: string;
              workflowId: string;
              workflowJobId: string;
              workflowWorkspaceId: string;
              pipelineKind: GitPipelineKind;
              updatedAt: string;
              score: {
                __typename: "Score";
                type: number;
                id: string;
                value: number;
                completion: number;
                weight: number;
                message: string;
                riskRating: ScoreRating;
                riskValue: number;
              };
            }
          | {
              __typename: "GithubJob";
              id: string;
              mrn: string;
              name: string;
              target?: string | null;
              action: string;
              workflow: string;
              job: string;
              runId: string;
              runNumber: string;
              actor: string;
              repository: string;
              eventName: string;
              eventPath: string;
              workspace: string;
              sha: string;
              ref: string;
              headRef: string;
              baseRef: string;
              serverUrl: string;
              pipelineKind: GitPipelineKind;
              updatedAt: string;
              score: {
                __typename: "Score";
                type: number;
                id: string;
                value: number;
                completion: number;
                weight: number;
                message: string;
                riskRating: ScoreRating;
                riskValue: number;
              };
            }
          | {
              __typename: "GitlabJob";
              id: string;
              mrn: string;
              name: string;
              target?: string | null;
              projectUrl: string;
              projectId: string;
              projectTitle: string;
              pipelineUrl: string;
              jobId: string;
              jobName: string;
              jobURL: string;
              jobStage: string;
              commitSha: string;
              commitDescription: string;
              commitRefName: string;
              mergeRequestId: string;
              mergeRequestProjectUrl: string;
              userName: string;
              userId: string;
              userEmail: string;
              defaultBranch: string;
              pipelineKind: GitPipelineKind;
              updatedAt: string;
              score: {
                __typename: "Score";
                type: number;
                id: string;
                value: number;
                completion: number;
                weight: number;
                message: string;
                riskRating: ScoreRating;
                riskValue: number;
              };
            }
          | {
              __typename: "JenkinsJob";
              id: string;
              mrn: string;
              name: string;
              target?: string | null;
              projectUrl: string;
              job: string;
              jobId: string;
              buildUrl: string;
              userName: string;
              commitSha: string;
              repositoryUrl: string;
              branch: string;
              pipelineKind: GitPipelineKind;
              updatedAt: string;
              score: {
                __typename: "Score";
                type: number;
                id: string;
                value: number;
                completion: number;
                weight: number;
                message: string;
                riskRating: ScoreRating;
                riskValue: number;
              };
            }
          | {
              __typename: "KubernetesJob";
              id: string;
              mrn: string;
              updatedAt: string;
              clusterId: string;
              namespace: string;
              uid: string;
              name: string;
              target?: string | null;
              operation: string;
              kind: string;
              author: string;
              ownerName: string;
              ownerUid: string;
              ownerKind: string;
              resourceVersion: string;
              score: {
                __typename: "Score";
                type: number;
                id: string;
                value: number;
                completion: number;
                weight: number;
                message: string;
                riskRating: ScoreRating;
                riskValue: number;
              };
            };
      }> | null;
      pageInfo: {
        __typename: "PageInfo";
        startCursor: string;
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    } | null;
  } | null;
};

export type LoadCicdProjectsQueryVariables = Exact<{
  input: CicdProjectsInput;
}>;

export type LoadCicdProjectsQuery = {
  __typename: "Query";
  cicdProjects?: {
    __typename: "CicdProjects";
    spaceMrn: string;
    projects: {
      __typename: "CicdProjectsConnection";
      totalCount: number;
      edges: Array<{
        __typename: "CicdProjectEdge";
        cursor: string;
        node: {
          __typename: "CicdProject";
          id: string;
          mrn: string;
          type: string;
          name: string;
        };
      }>;
      pageInfo: {
        __typename: "PageInfo";
        startCursor: string;
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    };
  } | null;
};

export type LoadCveQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type LoadCveQuery = {
  __typename: "Query";
  cve?: {
    __typename: "Cve";
    cwe?: string | null;
    description?: string | null;
    id: string;
    modifiedAt?: string | null;
    mrn: string;
    publishedAt?: string | null;
    url?: string | null;
    references?: Array<string | null> | null;
    state?: CveState | null;
    summary?: string | null;
    title?: string | null;
    cvssScore: {
      __typename: "CvssScore";
      id: string;
      source: string;
      type: number;
      value: number;
      vector: string;
      rating: ScoreRating;
    };
    epssScore?: {
      __typename: "EpssScore";
      percentile: number;
      probability: number;
    } | null;
    source: { __typename: "Source"; id: string; name: string; url: string };
    externalUrls?: Array<{
      __typename: "Reference";
      iconIDEnum?: Icon_Ids | null;
      url: string;
      title?: string | null;
    } | null> | null;
    vulnerabilityRiskFactors: {
      __typename: "VulnerabilityRiskFactors";
      knownExploited: boolean;
      remoteExploitable: boolean;
    };
  } | null;
};

export type LoadEmailPreferencesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LoadEmailPreferencesQuery = {
  __typename: "Query";
  emailPreferences: Array<{
    __typename: "EmailPreference";
    listID: EmailPreferenceList;
    subscribed: boolean;
    subscribedAt: string;
  } | null>;
};

export type LoadIntegrationsQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type LoadIntegrationsQuery = {
  __typename: "Query";
  integrations: Array<{
    __typename: "Integration";
    mrn: string;
    name: string;
    enabled: boolean;
    options?: {
      __typename: "IntegrationOptions";
      url?: string | null;
      chatid?: string | null;
      token?: string | null;
      notificationType?: NotificationType | null;
    } | null;
  } | null>;
};

export type LoadLegalPolicyConsentQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type LoadLegalPolicyConsentQuery = {
  __typename: "Query";
  legalPolicies: Array<{
    __typename: "LegalPolicy";
    name: string;
    id: string;
    consent?: {
      __typename: "Consent";
      mrn: string;
      email: string;
      signatureAt: string;
    } | null;
  } | null>;
};

export type LoadMqueryQueryVariables = Exact<{
  input: MqueryInput;
}>;

export type LoadMqueryQuery = {
  __typename: "Query";
  mquery?: {
    __typename: "Mquery";
    uid: string;
    mrn: string;
    title: string;
    mql: string;
    parent?: string | null;
    action: PolicyReportScoreEntryAction;
    docs?: {
      __typename: "MqueryDocs";
      audit: string;
      desc: string;
      references?: Array<{
        __typename: "MqueryRef";
        title: string;
        url: string;
      }> | null;
      remediations?:
        | {
            __typename: "AuthenticationRequired";
            message: string;
            code: string;
          }
        | {
            __typename: "Remediations";
            entries: Array<{
              __typename: "MqueryRemediation";
              id: string;
              idName: string;
              desc: string;
            }>;
          }
        | null;
    } | null;
    impact?: { __typename: "Impact"; value: number; rating: string } | null;
    tags?: Array<{ __typename: "Tag"; key: string; value: string }> | null;
    properties?: Array<{
      __typename: "MProperty";
      uid: string;
      mrn: string;
      title: string;
      mql: string;
      defaultValue: string;
      overrideValue: string;
      setByPolicyMrn?: string | null;
      for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
    }> | null;
    variants?: Array<{
      __typename: "Variant";
      id: string;
      mrn: string;
      title: string;
      icon: string;
    }> | null;
    variantQueries?: Array<{
      __typename: "MqueryVariant";
      uid: string;
      mrn: string;
      title: string;
      mql: string;
      filter: string;
      filterID: string;
      docs?: {
        __typename: "MqueryDocs";
        audit: string;
        desc: string;
        references?: Array<{
          __typename: "MqueryRef";
          title: string;
          url: string;
        }> | null;
        remediations?:
          | {
              __typename: "AuthenticationRequired";
              message: string;
              code: string;
            }
          | {
              __typename: "Remediations";
              entries: Array<{
                __typename: "MqueryRemediation";
                id: string;
                idName: string;
                desc: string;
              }>;
            }
          | null;
      } | null;
      impact?: { __typename: "Impact"; value: number; rating: string } | null;
      tags?: Array<{ __typename: "Tag"; key: string; value: string }> | null;
      properties?: Array<{
        __typename: "MProperty";
        uid: string;
        mrn: string;
        title: string;
        mql: string;
        defaultValue: string;
        overrideValue: string;
        setByPolicyMrn?: string | null;
        for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type LoadOrganizationQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type LoadOrganizationQuery = {
  __typename: "Query";
  organization?: {
    __typename: "Organization";
    id: string;
    mrn: string;
    name: string;
    company?: string | null;
    capabilities: Array<string>;
  } | null;
};

export type LoadOrganizationForSpaceQueryVariables = Exact<{
  spaceMrn: Scalars["String"]["input"];
}>;

export type LoadOrganizationForSpaceQuery = {
  __typename: "Query";
  space?: {
    __typename: "Space";
    id: string;
    mrn: string;
    organization?: {
      __typename: "Organization";
      id: string;
      mrn: string;
      name: string;
      capabilities: Array<string>;
      description: string;
    } | null;
  } | null;
};

export type LoadOrganizationMembersQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<MembershipOrder>;
  query?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type LoadOrganizationMembersQuery = {
  __typename: "Query";
  organization?: {
    __typename: "Organization";
    id: string;
    mrn: string;
    company?: string | null;
    members?: {
      __typename: "MembersConnection";
      totalCount: number;
      edges?: Array<{
        __typename: "MemberEdge";
        cursor: string;
        node?: {
          __typename: "Member";
          identity:
            | { __typename: "PendingUser"; mrn: string; name: string }
            | { __typename: "ServiceAccount"; mrn: string; name: string }
            | { __typename: "Team"; mrn: string; name: string }
            | {
                __typename: "User";
                email?: string | null;
                mrn: string;
                name: string;
              };
          roles: Array<{ __typename: "Role"; mrn: string; title: string }>;
        } | null;
      }> | null;
      pageInfo: {
        __typename: "PageInfo";
        startCursor: string;
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    } | null;
  } | null;
};

export type LoadOrganizationSsoProviderQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type LoadOrganizationSsoProviderQuery = {
  __typename: "Query";
  ssoProvider: {
    __typename: "SSOProviderResponse";
    provider: {
      __typename: "SSOProvider";
      idpEntityID: string;
      ssoUrl: string;
      rpEntityID: string;
      x509Fingerprints: Array<string>;
      enabled: boolean;
    };
  };
};

export type LoadOrganizationSpacesQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type LoadOrganizationSpacesQuery = {
  __typename: "Query";
  organization?: {
    __typename: "Organization";
    id: string;
    spacesList: {
      __typename: "SpaceConnection";
      edges: Array<{
        __typename: "SpaceEdge";
        node: {
          __typename: "Space";
          id: string;
          mrn: string;
          name: string;
          description: string;
        };
      }>;
    };
  } | null;
};

export type LoadOrganizationStatsQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  metricMrns?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  startTime?: InputMaybe<Scalars["String"]["input"]>;
  endTime?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type LoadOrganizationStatsQuery = {
  __typename: "Query";
  organization?: {
    __typename: "Organization";
    id: string;
    mrn: string;
    name: string;
    company?: string | null;
    spacesCount: number;
    spacesList: {
      __typename: "SpaceConnection";
      totalCount: number;
      edges: Array<{
        __typename: "SpaceEdge";
        cursor: string;
        node: {
          __typename: "Space";
          id: string;
          mrn: string;
          name: string;
          description: string;
          priorityFindings: number;
          assetGroupStats: Array<{
            __typename: "AssetGroupStatistics";
            groupType: string;
            displayName: string;
            icon: Icon_Ids;
            count: number;
            listsAssetTypes: Array<{
              __typename: "AssetTypeInfo";
              assetType: string;
              aliases?: Array<string> | null;
              displayName: string;
              shortName: string;
            }>;
            statistics?: Array<{
              __typename: "AssetTypeStatistics";
              count: number;
              type: {
                __typename: "AssetTypeInfo";
                assetType: string;
                aliases?: Array<string> | null;
                displayName: string;
                shortName: string;
              };
            }> | null;
          }>;
          metrics?: {
            __typename: "MetricsResponse";
            entries?: Array<{
              __typename: "MetricEntry";
              metricMrn: string;
              title: string;
              arrowResult?: string | null;
            }> | null;
          } | null;
        };
      }>;
      pageInfo: {
        __typename: "PageInfo";
        startCursor: string;
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    };
  } | null;
};

export type LoadOrganizationUsersQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  identityTypeFilter?: InputMaybe<
    Array<MemberIdentityType> | MemberIdentityType
  >;
  rolesFilter?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type LoadOrganizationUsersQuery = {
  __typename: "Query";
  organization?: {
    __typename: "Organization";
    id: string;
    mrn: string;
    name: string;
    members?: {
      __typename: "MembersConnection";
      totalCount: number;
      pageInfo: {
        __typename: "PageInfo";
        endCursor: string;
        hasNextPage: boolean;
      };
      edges?: Array<{
        __typename: "MemberEdge";
        cursor: string;
        node?: {
          __typename: "Member";
          identity:
            | { __typename: "PendingUser"; mrn: string; name: string }
            | { __typename: "ServiceAccount"; mrn: string; name: string }
            | { __typename: "Team"; mrn: string; name: string }
            | {
                __typename: "User";
                email?: string | null;
                mrn: string;
                name: string;
              };
          roles: Array<{ __typename: "Role"; mrn: string; title: string }>;
        } | null;
      }> | null;
    } | null;
  } | null;
};

export type LoadPlatformsQueryVariables = Exact<{
  input: PlatformsListInput;
}>;

export type LoadPlatformsQuery = {
  __typename: "Query";
  platforms?: Array<{
    __typename: "ContentPlatform";
    id: string;
    name: string;
    version: string;
  }> | null;
};

export type LoadPolicyQueryVariables = Exact<{
  input: PolicyInput;
}>;

export type LoadPolicyQuery = {
  __typename: "Query";
  policy?: {
    __typename: "Policy";
    mrn: string;
    assigned: boolean;
    assignedScope?: string | null;
    action?: PolicyAction | null;
    access: Access;
    category: string;
    createdAt: string;
    docs: string;
    featured: boolean;
    githubUrl?: string | null;
    name: string;
    scoringSystem?: ScoringSystem | null;
    defaultScoringSystem?: ScoringSystem | null;
    summary: string;
    trustLevel: TrustLevel;
    uid: string;
    updatedAt: string;
    version: string;
    authors?: Array<{
      __typename: "Author";
      email?: string | null;
      name: string;
      type: AuthorType;
    }> | null;
    groups?: Array<{
      __typename: "PolicyGroup";
      title: string;
      summary: string;
      checks?: Array<{
        __typename: "QueryRef";
        action: PolicyReportScoreEntryAction;
        mrn: string;
        impact?: { __typename: "Impact"; rating: string; value: number } | null;
      }> | null;
      queries?: Array<{
        __typename: "QueryRef";
        action: PolicyReportScoreEntryAction;
        mrn: string;
        impact?: { __typename: "Impact"; rating: string; value: number } | null;
      }> | null;
      policies?: Array<{
        __typename: "PolicyRef";
        action: PolicyReportScoreEntryAction;
        mrn: string;
        impact?: { __typename: "Impact"; rating: string; value: number } | null;
      }> | null;
    }> | null;
    mutationStatistics?: {
      __typename: "PolicyMutationStatistics";
      checks: {
        __typename: "PolicyQueryStatistics";
        active: number;
        ignored: number;
        removed: number;
      };
      queries: {
        __typename: "PolicyQueryStatistics";
        removed: number;
        ignored: number;
        active: number;
      };
    } | null;
    platforms?: Array<{
      __typename: "ContentPlatform";
      id: string;
      name: string;
      version: string;
    }> | null;
    queries?: Array<{ __typename: "Mquery"; mrn: string }> | null;
    properties?: Array<{ __typename: "MProperty"; mrn: string }> | null;
    runCli?: {
      __typename: "RunCli";
      command: string;
      installDocsURL: string;
    } | null;
    statistics: {
      __typename: "PolicyStatistics";
      checks: number;
      policies: number;
      queries: number;
    };
    tags?: Array<{ __typename: "Tag"; key: string; value: string }> | null;
    variants?: Array<{
      __typename: "Variant";
      icon: string;
      id: string;
      title: string;
    }> | null;
  } | null;
};

export type LoadRegistrationTokensQueryVariables = Exact<{
  spaceMrn: Scalars["String"]["input"];
  orderBy?: InputMaybe<RegistrationTokenOrder>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type LoadRegistrationTokensQuery = {
  __typename: "Query";
  registrationTokens?: {
    __typename: "RegistrationTokensConnection";
    totalCount: number;
    edges: Array<{
      __typename: "RegistrationTokenEdge";
      cursor: string;
      node: {
        __typename: "RegistrationToken";
        id: string;
        mrn: string;
        description: string;
        token: string;
        createdBy: string;
        createdAt: string;
        expiresAt: string;
        revoked: boolean;
        labels: Array<{
          __typename: "KeyValue";
          key: string;
          value?: string | null;
        }>;
      };
    }>;
    pageInfo: {
      __typename: "PageInfo";
      hasPreviousPage: boolean;
      hasNextPage: boolean;
      endCursor: string;
      startCursor: string;
    };
  } | null;
};

export type LoadResourceInvitationsQueryVariables = Exact<{
  resourceMrn?: InputMaybe<Scalars["String"]["input"]>;
  inviteeMrn?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<InvitationOrder>;
}>;

export type LoadResourceInvitationsQuery = {
  __typename: "Query";
  invitations?: {
    __typename: "InvitationsConnection";
    totalCount: number;
    edges?: Array<{
      __typename: "InvitationEdge";
      cursor: string;
      node?: {
        __typename: "Invitation";
        mrn: string;
        resourceMrn: string;
        senderEmail: string;
        inviteeEmail: string;
        roleMrns?: Array<string> | null;
        expiresAt: string;
        message: string;
        state: InvitationState;
      } | null;
    }> | null;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
};

export type LoadServiceAccountQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type LoadServiceAccountQuery = {
  __typename: "Query";
  serviceAccount?: {
    __typename: "ServiceAccount";
    id: string;
    mrn: string;
    name: string;
    createdAt: string;
    lastUsed?: string | null;
    roles: Array<{ __typename: "Role"; mrn: string; title: string }>;
  } | null;
};

export type LoadSpaceQueryVariables = Exact<{
  spaceMrn: Scalars["String"]["input"];
  metricMrns?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type LoadSpaceQuery = {
  __typename: "Query";
  space?: {
    __typename: "Space";
    id: string;
    mrn: string;
    name: string;
    description: string;
    priorityFindings: number;
    assetGroupStats: Array<{
      __typename: "AssetGroupStatistics";
      groupType: string;
      displayName: string;
      icon: Icon_Ids;
      count: number;
      listsAssetTypes: Array<{
        __typename: "AssetTypeInfo";
        assetType: string;
        aliases?: Array<string> | null;
        displayName: string;
        shortName: string;
      }>;
      statistics?: Array<{
        __typename: "AssetTypeStatistics";
        count: number;
        type: {
          __typename: "AssetTypeInfo";
          assetType: string;
          aliases?: Array<string> | null;
          displayName: string;
          shortName: string;
        };
      }> | null;
    }>;
    organization?: {
      __typename: "Organization";
      id: string;
      mrn: string;
      name: string;
      description: string;
    } | null;
    settings?: {
      __typename: "SpaceSettings";
      exceptionsConfiguration?: {
        __typename: "ExceptionsConfiguration";
        requireApproval?: boolean | null;
        allowSelfApproval?: boolean | null;
        allowIndefiniteValidUntil?: boolean | null;
      } | null;
      garbageCollectAssetsConfiguration: {
        __typename: "GarbageCollectAssetsConfiguration";
        enable: boolean;
        afterDays: number;
      };
      terminatedAssetsConfiguration: {
        __typename: "TerminatedAssetsConfiguration";
        cleanup: boolean;
        after: number;
      };
      unusedServiceAccountsConfiguration: {
        __typename: "UnusedServiceAccountsConfiguration";
        cleanup: boolean;
        after: number;
      };
      platformVulnerabilityConfiguration: {
        __typename: "PlatformVulnerabilityConfiguration";
        enable: boolean;
      };
      eolAssetsConfiguration: {
        __typename: "EolAssetsConfiguration";
        enable: boolean;
        monthsInAdvance: number;
      };
      casesConfiguration: {
        __typename: "CasesConfiguration";
        autoCreate: boolean;
        aggregationWindow: number;
      };
      platformMqlVexConfiguration: {
        __typename: "PlatformMqlVexConfiguration";
        enable: boolean;
      };
      mvdExperimentalSourcesConfiguration: {
        __typename: "MvdExperimentalSourcesConfiguration";
        sources?: Array<{
          __typename: "MvdSource";
          id: string;
          name: string;
          enabled: boolean;
        }> | null;
      };
    } | null;
    stats?: {
      __typename: "SpaceStatistics";
      assetGroupStatistics: Array<{
        __typename: "AssetGroupStatistics";
        groupType: string;
        count: number;
      }>;
    } | null;
    metrics?: {
      __typename: "MetricsResponse";
      entries?: Array<{
        __typename: "MetricEntry";
        metricMrn: string;
        title: string;
        arrowResult?: string | null;
      }> | null;
    } | null;
  } | null;
};

export type LoadSpaceMembersQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<MembershipOrder>;
  query?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type LoadSpaceMembersQuery = {
  __typename: "Query";
  space?: {
    __typename: "Space";
    id: string;
    mrn: string;
    members?: {
      __typename: "MembersConnection";
      totalCount: number;
      edges?: Array<{
        __typename: "MemberEdge";
        node?: {
          __typename: "Member";
          roles: Array<{ __typename: "Role"; title: string; mrn: string }>;
          identity:
            | { __typename: "PendingUser"; mrn: string; name: string }
            | { __typename: "ServiceAccount"; mrn: string; name: string }
            | { __typename: "Team"; mrn: string; name: string }
            | {
                __typename: "User";
                email?: string | null;
                mrn: string;
                name: string;
              };
        } | null;
      }> | null;
      pageInfo: {
        __typename: "PageInfo";
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor: string;
      };
    } | null;
  } | null;
};

export type LoadSpaceStatsQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type LoadSpaceStatsQuery = {
  __typename: "Query";
  space?: {
    __typename: "Space";
    id: string;
    mrn: string;
    stats?: {
      __typename: "SpaceStatistics";
      assetGroupStatistics: Array<{
        __typename: "AssetGroupStatistics";
        groupType: string;
        count: number;
        listsAssetTypes: Array<{
          __typename: "AssetTypeInfo";
          assetType: string;
          displayName: string;
          shortName: string;
          aliases?: Array<string> | null;
        }>;
        statistics?: Array<{
          __typename: "AssetTypeStatistics";
          count: number;
          type: {
            __typename: "AssetTypeInfo";
            assetType: string;
            displayName: string;
            shortName: string;
          };
        }> | null;
      }>;
      integrationsStatistics: Array<{
        __typename: "IntegrationStatistics";
        active: number;
        pending: number;
        errored: number;
        total: number;
        type: IntegrationType;
      }>;
    } | null;
  } | null;
};

export type LoadTopMisconfigsQueryVariables = Exact<{
  input: SpacePolicySummaryInput;
}>;

export type LoadTopMisconfigsQuery = {
  __typename: "Query";
  spacePolicySummary?: {
    __typename: "SpacePolicySummaryPayload";
    spaceMrn: string;
    querySummaries?: {
      __typename: "SpacePolicySummaryQuerySummariesConnection";
      totalCount: number;
      edges?: Array<{
        __typename: "SpacePolicySummaryQuerySummaryEdge";
        cursor: string;
        node?: {
          __typename: "SpacePolicySummaryQuerySummary";
          id: string;
          mqueryState: MqueryState;
          mqueryType: MqueryType;
          mquery: {
            __typename: "Mquery";
            mrn: string;
            parent?: string | null;
            title: string;
            uid: string;
            action: PolicyReportScoreEntryAction;
            impact?: {
              __typename: "Impact";
              rating: string;
              value: number;
            } | null;
          };
        } | null;
      }> | null;
    } | null;
  } | null;
};

export type LoadUserInvitationsQueryVariables = Exact<{
  resourceMrn?: InputMaybe<Scalars["String"]["input"]>;
  inviteeMrn?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<InvitationOrder>;
}>;

export type LoadUserInvitationsQuery = {
  __typename: "Query";
  invitations?: {
    __typename: "InvitationsConnection";
    edges?: Array<{
      __typename: "InvitationEdge";
      cursor: string;
      node?: {
        __typename: "Invitation";
        mrn: string;
        resourceMrn: string;
        senderEmail: string;
        inviteeEmail: string;
        roleMrns?: Array<string> | null;
        expiresAt: string;
        message: string;
        state: InvitationState;
      } | null;
    }> | null;
  } | null;
};

export type LoadViewerQueryVariables = Exact<{
  metricMrns?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type LoadViewerQuery = {
  __typename: "Query";
  viewer?: {
    __typename: "User";
    mrn: string;
    email?: string | null;
    name: string;
    createdAt?: string | null;
    state?: UserState | null;
    organizations?: Array<{
      __typename: "Organization";
      id: string;
      mrn: string;
      name: string;
      company?: string | null;
      description: string;
      capabilities: Array<string>;
      spacesCount: number;
      subscriptionInfo?: {
        __typename: "SubscriptionInfo";
        basePlan: { __typename: "ProductInfo"; name: string; id: string };
      } | null;
      memberStats?: {
        __typename: "MemberStats";
        total: number;
        owners: Array<
          | { __typename: "PendingUser"; mrn: string; name: string }
          | { __typename: "ServiceAccount"; mrn: string; name: string }
          | { __typename: "Team"; mrn: string; name: string }
          | {
              __typename: "User";
              email?: string | null;
              mrn: string;
              name: string;
            }
        >;
      } | null;
      metrics?: {
        __typename: "MetricsResponse";
        entries?: Array<{
          __typename: "MetricEntry";
          metricMrn: string;
          title: string;
          arrowResult?: string | null;
        }> | null;
      } | null;
    }> | null;
    firstSpace?: {
      __typename: "Space";
      id: string;
      mrn: string;
      name: string;
      description: string;
      priorityFindings: number;
      organization?: {
        __typename: "Organization";
        id: string;
        mrn: string;
        name: string;
        description: string;
      } | null;
      settings?: {
        __typename: "SpaceSettings";
        eolAssetsConfiguration: {
          __typename: "EolAssetsConfiguration";
          enable: boolean;
          monthsInAdvance: number;
        };
        garbageCollectAssetsConfiguration: {
          __typename: "GarbageCollectAssetsConfiguration";
          enable: boolean;
          afterDays: number;
        };
        terminatedAssetsConfiguration: {
          __typename: "TerminatedAssetsConfiguration";
          cleanup: boolean;
          after: number;
        };
        unusedServiceAccountsConfiguration: {
          __typename: "UnusedServiceAccountsConfiguration";
          cleanup: boolean;
          after: number;
        };
        platformVulnerabilityConfiguration: {
          __typename: "PlatformVulnerabilityConfiguration";
          enable: boolean;
        };
        casesConfiguration: {
          __typename: "CasesConfiguration";
          autoCreate: boolean;
          aggregationWindow: number;
        };
        platformMqlVexConfiguration: {
          __typename: "PlatformMqlVexConfiguration";
          enable: boolean;
        };
        mvdExperimentalSourcesConfiguration: {
          __typename: "MvdExperimentalSourcesConfiguration";
          sources?: Array<{
            __typename: "MvdSource";
            id: string;
            name: string;
            enabled: boolean;
          }> | null;
        };
      } | null;
      assetGroupStats: Array<{
        __typename: "AssetGroupStatistics";
        groupType: string;
        displayName: string;
        icon: Icon_Ids;
        count: number;
        listsAssetTypes: Array<{
          __typename: "AssetTypeInfo";
          assetType: string;
          aliases?: Array<string> | null;
          displayName: string;
          shortName: string;
        }>;
        statistics?: Array<{
          __typename: "AssetTypeStatistics";
          count: number;
          type: {
            __typename: "AssetTypeInfo";
            assetType: string;
            aliases?: Array<string> | null;
            displayName: string;
            shortName: string;
          };
        }> | null;
      }>;
      stats?: {
        __typename: "SpaceStatistics";
        assetGroupStatistics: Array<{
          __typename: "AssetGroupStatistics";
          groupType: string;
          count: number;
        }>;
      } | null;
    } | null;
  } | null;
  viewerSettings: Array<{
    __typename: "UserSetting";
    key: string;
    value: string;
  }>;
};

export type MqueryAssetScoresQueryVariables = Exact<{
  input: MqueryAssetScoresInput;
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<AssetOrder>;
}>;

export type MqueryAssetScoresQuery = {
  __typename: "Query";
  mqueryAssetScores?: {
    __typename: "MqueryAssetScoresConnection";
    title: string;
    description: string;
    totalCount: number;
    mql: string;
    scoreDistribution: {
      __typename: "MqueryResultsDistribution";
      pass: number;
      fail: number;
      error: number;
      unknown: number;
    };
    edges?: Array<{
      __typename: "MqueryAssetScoresEdge";
      cursor: string;
      node?: {
        __typename: "QueryAssetScore";
        assetMrn?: string | null;
        assetName?: string | null;
        assetPlatform?: {
          __typename: "Platform";
          name: string;
          title: string;
          arch: string;
          version: string;
          kind: PlatformKind;
          runtime: string;
          release: string;
        } | null;
        score?: {
          __typename: "Score";
          id: string;
          value: number;
          type: number;
          completion: number;
          weight: number;
          message: string;
          grade: string;
        } | null;
      } | null;
    }> | null;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    docs?: {
      __typename: "MqueryDocs";
      desc: string;
      remediations?:
        | {
            __typename: "AuthenticationRequired";
            message: string;
            code: string;
          }
        | {
            __typename: "Remediations";
            entries: Array<{
              __typename: "MqueryRemediation";
              id: string;
              desc: string;
            }>;
          }
        | null;
      references?: Array<{
        __typename: "MqueryRef";
        title: string;
        url: string;
      }> | null;
    } | null;
  } | null;
};

export type OrganizationIdSuggestionQueryVariables = Exact<{
  input: IdSuggestionInput;
}>;

export type OrganizationIdSuggestionQuery = {
  __typename: "Query";
  organizationIDSuggestion?: {
    __typename: "IDSuggestionResponse";
    id: string;
    available: boolean;
  } | null;
};

export type PingIntegrationQueryVariables = Exact<{
  input: PingIntegrationInput;
}>;

export type PingIntegrationQuery = {
  __typename: "Query";
  pingIntegration: { __typename: "PingIntegrationPayload"; mrn: string };
};

export type QueryPackQueryVariables = Exact<{
  input: PolicyInput;
}>;

export type QueryPackQuery = {
  __typename: "Query";
  policy?: {
    __typename: "Policy";
    uid: string;
    mrn: string;
    name: string;
    version: string;
    summary: string;
    docs: string;
    category: string;
    trustLevel: TrustLevel;
    access: Access;
    featured: boolean;
    githubUrl?: string | null;
    assigned: boolean;
    updatedAt: string;
    createdAt: string;
    authors?: Array<{
      __typename: "Author";
      name: string;
      email?: string | null;
      type: AuthorType;
    }> | null;
    platforms?: Array<{
      __typename: "ContentPlatform";
      id: string;
      name: string;
      version: string;
    }> | null;
    statistics: {
      __typename: "PolicyStatistics";
      checks: number;
      queries: number;
      policies: number;
    };
    tags?: Array<{ __typename: "Tag"; key: string; value: string }> | null;
    queries?: Array<{
      __typename: "Mquery";
      uid: string;
      mrn: string;
      title: string;
      mql: string;
      action: PolicyReportScoreEntryAction;
      docs?: {
        __typename: "MqueryDocs";
        desc: string;
        remediations?:
          | {
              __typename: "AuthenticationRequired";
              message: string;
              code: string;
            }
          | {
              __typename: "Remediations";
              entries: Array<{
                __typename: "MqueryRemediation";
                id: string;
                desc: string;
              }>;
            }
          | null;
        references?: Array<{
          __typename: "MqueryRef";
          title: string;
          url: string;
        }> | null;
      } | null;
      impact?: { __typename: "Impact"; value: number; rating: string } | null;
      tags?: Array<{ __typename: "Tag"; key: string; value: string }> | null;
      properties?: Array<{
        __typename: "MProperty";
        uid: string;
        mrn: string;
        title: string;
        mql: string;
        defaultValue: string;
        overrideValue: string;
        setByPolicyMrn?: string | null;
        for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
      }> | null;
    }> | null;
    properties?: Array<{
      __typename: "MProperty";
      uid: string;
      mrn: string;
      title: string;
      mql: string;
      defaultValue: string;
      overrideValue: string;
      setByPolicyMrn?: string | null;
      for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
    }> | null;
    groups?: Array<{
      __typename: "PolicyGroup";
      title: string;
      summary: string;
      checks?: Array<{
        __typename: "QueryRef";
        mrn: string;
        action: PolicyReportScoreEntryAction;
        impact?: { __typename: "Impact"; value: number; rating: string } | null;
      }> | null;
      queries?: Array<{
        __typename: "QueryRef";
        mrn: string;
        action: PolicyReportScoreEntryAction;
        impact?: { __typename: "Impact"; value: number; rating: string } | null;
      }> | null;
      policies?: Array<{
        __typename: "PolicyRef";
        mrn: string;
        action: PolicyReportScoreEntryAction;
        impact?: { __typename: "Impact"; value: number; rating: string } | null;
      }> | null;
    }> | null;
    runCli?: {
      __typename: "RunCli";
      command: string;
      installDocsURL: string;
    } | null;
    mutationStatistics?: {
      __typename: "PolicyMutationStatistics";
      checks: {
        __typename: "PolicyQueryStatistics";
        active: number;
        ignored: number;
        removed: number;
      };
      queries: {
        __typename: "PolicyQueryStatistics";
        active: number;
        ignored: number;
        removed: number;
      };
    } | null;
    variantPlatformFilters?: Array<{
      __typename: "VariantPlatformFilter";
      id: string;
      title: string;
      icon: string;
    }> | null;
  } | null;
};

export type SearchAggregateScoreQueryVariables = Exact<{
  query: Scalars["String"]["input"];
  type: SearchType;
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  scope?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SearchFilters>;
}>;

export type SearchAggregateScoreQuery = {
  __typename: "Query";
  search: {
    __typename: "SearchResultItemConnection";
    scoreTypeDistribution: {
      __typename: "SearchResultScoreTypeDistribution";
      vulnerability: number;
      advisory: number;
      check: number;
      policy: number;
      risk: number;
      asset: number;
      software: number;
      control: number;
      framework: number;
    };
    edges?: Array<{
      __typename: "SearchResultItemEdge";
      searchItemStatus?: SearchItemStatus | null;
      node?:
        | {
            __typename: "Advisory";
            id: string;
            iconID?: string | null;
            iconIDEnum?: Icon_Ids | null;
            mrn: string;
            title?: string | null;
            description?: string | null;
            vendorscore?: number | null;
            published?: string | null;
            modified?: string | null;
            publishedAt?: string | null;
            modifiedAt?: string | null;
            source: {
              __typename: "Source";
              id: string;
              name: string;
              url: string;
            };
            externalUrls?: Array<{
              __typename: "Reference";
              title?: string | null;
              url: string;
              iconIDEnum?: Icon_Ids | null;
            } | null> | null;
            cves?: Array<{
              __typename: "Cve";
              id: string;
              mrn: string;
              title?: string | null;
              description?: string | null;
              summary?: string | null;
              published?: string | null;
              modified?: string | null;
              publishedAt?: string | null;
              modifiedAt?: string | null;
              url?: string | null;
              cwe?: string | null;
              state?: CveState | null;
              exploitable?: boolean | null;
              references?: Array<string | null> | null;
            }> | null;
            score: {
              __typename: "CvssScore";
              id: string;
              value: number;
              type: number;
              vector: string;
              source: string;
            };
            cvssScore: {
              __typename: "CvssScore";
              id: string;
              value: number;
              type: number;
              vector: string;
              source: string;
            };
            affectedPackages?: Array<{
              __typename: "Package";
              id: string;
              iconID?: string | null;
              iconIDEnum?: Icon_Ids | null;
              name: string;
              version?: string | null;
              arch?: string | null;
              format?: string | null;
              namespace?: string | null;
              description?: string | null;
              status?: string | null;
              available?: string | null;
              origin?: string | null;
              vulnDiscoveryTime?: string | null;
              type: PackageType;
            }> | null;
            vulnerabilityRiskFactors: {
              __typename: "VulnerabilityRiskFactors";
              knownExploited: boolean;
              remoteExploitable: boolean;
            };
          }
        | {
            __typename: "AggregateScore";
            iconId: Icon_Ids;
            findingMrn: string;
            rank: number;
            baseScore?: number | null;
            riskValue?: number | null;
            rating: ScoreRating;
            scoreType: AggregateScoreType;
            lastScannedAt?: string | null;
            firstDetectedAt: string;
            remediatedAt: string;
            spaceId: string;
            nodeId: string;
            nodeTitle: string;
            nodeDescription: string;
            entity?:
              | {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                }
              | { __typename: "EntityInfoOrganization" }
              | { __typename: "EntityInfoPlatform" }
              | {
                  __typename: "EntityInfoSpace";
                  id: string;
                  mrn: string;
                  name: string;
                }
              | { __typename: "EntityInfoUnknown" }
              | { __typename: "EntityInfoWorkspace" }
              | null;
            blastRadius?: {
              __typename: "BlastRadius";
              indicator: string;
              assets: number;
              affected: number;
              critical: number;
              high: number;
              medium: number;
              low: number;
              none: number;
            } | null;
            riskFactors?: Array<{
              __typename: "RiskFactorStats";
              mrn: string;
              indicator: string;
              title: string;
              affected: number;
              total: number;
              isPositive: boolean;
            } | null> | null;
            tags?: Array<{
              __typename: "Tag";
              key: string;
              value: string;
            }> | null;
            epss?: {
              __typename: "EpssScore";
              probability: number;
              percentile: number;
            } | null;
            cvss?: {
              __typename: "CvssScore";
              id: string;
              value: number;
              type: number;
              vector: string;
              source: string;
            } | null;
          }
        | {
            __typename: "Cve";
            id: string;
            mrn: string;
            description?: string | null;
            publishedAt?: string | null;
            modifiedAt?: string | null;
            cwe?: string | null;
            state?: CveState | null;
            references?: Array<string | null> | null;
            cveTitle?: string | null;
            cvssScores: Array<{
              __typename: "CvssScore";
              id: string;
              value: number;
              type: number;
              vector: string;
              source: string;
            } | null>;
            epssScore?: {
              __typename: "EpssScore";
              probability: number;
              percentile: number;
            } | null;
          }
        | null;
    } | null> | null;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type SearchPolicyQueryVariables = Exact<{
  input: ContentSearchInput;
}>;

export type SearchPolicyQuery = {
  __typename: "Query";
  content?: {
    __typename: "ContentSearchResultItemConnection";
    totalCount: number;
    edges: Array<{
      __typename: "ContentSearchResultItemEdge";
      cursor: string;
      node: {
        __typename: "Policy";
        uid: string;
        mrn: string;
        name: string;
        action?: PolicyAction | null;
        version: string;
        summary: string;
        docs: string;
        category: string;
        trustLevel: TrustLevel;
        access: Access;
        featured: boolean;
        assigned: boolean;
        assignedScope?: string | null;
        authors?: Array<{
          __typename: "Author";
          name: string;
          email?: string | null;
          type: AuthorType;
        }> | null;
        statistics: {
          __typename: "PolicyStatistics";
          checks: number;
          queries: number;
          policies: number;
        };
      };
    }>;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
};

export type SearchQueryPackQueryVariables = Exact<{
  input: ContentSearchInput;
}>;

export type SearchQueryPackQuery = {
  __typename: "Query";
  content?: {
    __typename: "ContentSearchResultItemConnection";
    totalCount: number;
    edges: Array<{
      __typename: "ContentSearchResultItemEdge";
      cursor: string;
      node: {
        __typename: "Policy";
        uid: string;
        mrn: string;
        name: string;
        version: string;
        summary: string;
        docs: string;
        category: string;
        trustLevel: TrustLevel;
        access: Access;
        featured: boolean;
        assigned: boolean;
        authors?: Array<{
          __typename: "Author";
          name: string;
          email?: string | null;
          type: AuthorType;
        }> | null;
        statistics: {
          __typename: "PolicyStatistics";
          checks: number;
          queries: number;
          policies: number;
        };
      };
    }>;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
};

export type ServiceAccountAssetCountQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  queryTerms?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ServiceAccountAssetCountQuery = {
  __typename: "Query";
  assets?: { __typename: "AssetsConnection"; totalCount: number } | null;
};

export type ServiceAccountForwardPaginationQueryVariables = Exact<{
  spaceMrn?: InputMaybe<Scalars["String"]["input"]>;
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  queryTerms?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  orderBy?: InputMaybe<ServiceAccountOrder>;
}>;

export type ServiceAccountForwardPaginationQuery = {
  __typename: "Query";
  serviceAccounts?: {
    __typename: "ServiceAccountConnection";
    totalCount: number;
    edges?: Array<{
      __typename: "ServiceAccountEdge";
      cursor: string;
      node?: {
        __typename: "ServiceAccount";
        id: string;
        mrn: string;
        name: string;
        description?: string | null;
        createdAt: string;
        lastUsed?: string | null;
        notes?: string | null;
        roles: Array<{ __typename: "Role"; mrn: string; title: string }>;
        labels: Array<{
          __typename: "KeyValue";
          key: string;
          value?: string | null;
        }>;
        creator?: {
          __typename: "ServiceAccountCreator";
          mrn?: string | null;
          email?: string | null;
          service?: string | null;
        } | null;
      } | null;
    }> | null;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
    };
  } | null;
};

export type SpaceIdSuggestionQueryVariables = Exact<{
  input: IdSuggestionInput;
}>;

export type SpaceIdSuggestionQuery = {
  __typename: "Query";
  spaceIDSuggestion?: {
    __typename: "IDSuggestionResponse";
    id: string;
    available: boolean;
  } | null;
};

export type SubscriptionInfoQueryVariables = Exact<{
  orgMrn: Scalars["ID"]["input"];
}>;

export type SubscriptionInfoQuery = {
  __typename: "Query";
  subscriptionInfo?: {
    __typename: "SubscriptionInfo";
    isSelfService: boolean;
    pendingCancel: boolean;
    basePlan: {
      __typename: "ProductInfo";
      id: string;
      key: string;
      name: string;
    };
    additions?: Array<{
      __typename: "ProductInfo";
      id: string;
      key: string;
      name: string;
      quantity: number;
    }> | null;
    utilizationMetrics?: Array<{
      __typename: "UtilizationMetric";
      name: string;
      description: string;
      units: string;
      value: number;
      limit?: number | null;
    }> | null;
  } | null;
  subscriptionPlans?: Array<{
    __typename: "SubscriptionPlan";
    isSelfService: boolean;
    isCurrent: boolean;
    isDowngrade: boolean;
    isUpgrade: boolean;
    basePlan: {
      __typename: "Product";
      id: string;
      key: string;
      name: string;
      description: string;
      price: {
        __typename: "Price";
        id: string;
        currency: string;
        cost: number;
      };
      entitlements?: Array<{
        __typename: "Entitlement";
        name: string;
        key: string;
        description: string;
        units: string;
        value: number;
      }> | null;
    };
    additions?: Array<{
      __typename: "Product";
      id: string;
      key: string;
      name: string;
      description: string;
      maxQuantity: number;
      price: {
        __typename: "Price";
        id: string;
        currency: string;
        cost: number;
      };
      entitlements?: Array<{
        __typename: "Entitlement";
        name: string;
        key: string;
        description: string;
        units: string;
        value: number;
      }> | null;
    }> | null;
  }> | null;
};

export type TestIamActionsQueryVariables = Exact<{
  resourceMrn: Scalars["String"]["input"];
  actions: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type TestIamActionsQuery = {
  __typename: "Query";
  testIamActions: Array<string>;
};

export type TriggerActionQueryVariables = Exact<{
  input: TriggerActionInput;
}>;

export type TriggerActionQuery = {
  __typename: "Query";
  triggerAction: { __typename: "TriggerActionPayload"; mrn: string };
};

export type GetRelatedAdvisoryFindingsQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  filter?: InputMaybe<FindingsFilter>;
}>;

export type GetRelatedAdvisoryFindingsQuery = {
  __typename: "Query";
  findings?:
    | {
        __typename: "FindingsConnection";
        totalCount: number;
        filteredTotalCount: number;
        edges?: Array<{
          __typename: "FindingsEdge";
          cursor: string;
          node?:
            | {
                __typename: "AdvisoryFinding";
                mrn: string;
                id: string;
                title: string;
                state: ScoreState;
                iconId: Icon_Ids;
                riskScore: number;
                riskValue: number;
                rating: ScoreRating;
                firstDetectedAt: string;
                publishedAt?: string | null;
                lastUpdated: string;
                baseRating: ScoreRating;
                baseValue: number;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  lastUpdated: string;
                  platform?: {
                    __typename: "Platform";
                    name: string;
                    title: string;
                    arch: string;
                    version: string;
                    kind: PlatformKind;
                    runtime: string;
                    release: string;
                    family?: Array<string> | null;
                    labels?: Array<{
                      __typename: "KeyValue";
                      key: string;
                      value?: string | null;
                    }> | null;
                  } | null;
                } | null;
                epss?: {
                  __typename: "EpssScore";
                  probability: number;
                  percentile: number;
                } | null;
                cvss?: {
                  __typename: "CvssScore";
                  id: string;
                  value: number;
                  type: number;
                  vector: string;
                  source: string;
                  rating: ScoreRating;
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                  magnitude?: {
                    __typename: "RiskMagnitude";
                    value: number;
                    isToxic: boolean;
                  } | null;
                } | null> | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                detectionSources: Array<{
                  __typename: "VulnerabilityScoreSource";
                  name: string;
                  url?: string | null;
                  firstDetectedAt: string;
                  lastUpdatedAt: string;
                  fixedAt?: string | null;
                  vendor?: VulnerabilityScoreSourceVendor | null;
                  version?: string | null;
                }>;
                exception?: {
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  reviewStatus: ReviewStatus;
                  status: ExceptionStatus;
                  action: ExceptionMutationAction;
                  justification: string;
                  scope: string;
                  createdAt: string;
                  author?: {
                    __typename: "Author";
                    name: string;
                    email?: string | null;
                    mrn?: string | null;
                    type: AuthorType;
                  } | null;
                } | null;
                exceptions?: Array<{
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  reviewStatus: ReviewStatus;
                  action: ExceptionMutationAction;
                  justification: string;
                  scope: string;
                  createdAt: string;
                } | null> | null;
              }
            | { __typename: "CheckFinding" }
            | { __typename: "CveFinding" }
            | { __typename: "GenericFinding" }
            | { __typename: "PackageFinding" }
            | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetFindingOnAssetQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  filter?: InputMaybe<FindingsFilter>;
}>;

export type GetFindingOnAssetQuery = {
  __typename: "Query";
  findings?:
    | {
        __typename: "FindingsConnection";
        filteredTotalCount: number;
        totalCount: number;
        edges?: Array<{
          __typename: "FindingsEdge";
          cursor: string;
          node?:
            | {
                __typename: "AdvisoryFinding";
                mrn: string;
                id: string;
                title: string;
                state: ScoreState;
                iconId: Icon_Ids;
                riskValue: number;
                rating: ScoreRating;
                baseValue: number;
                baseRating: ScoreRating;
                firstDetectedAt: string;
                publishedAt?: string | null;
                lastUpdated: string;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  lastUpdated: string;
                  platform?: {
                    __typename: "Platform";
                    name: string;
                    title: string;
                    arch: string;
                    version: string;
                    kind: PlatformKind;
                    runtime: string;
                    family?: Array<string> | null;
                    labels?: Array<{
                      __typename: "KeyValue";
                      key: string;
                      value?: string | null;
                    }> | null;
                  } | null;
                } | null;
                epss?: {
                  __typename: "EpssScore";
                  probability: number;
                  percentile: number;
                } | null;
                cvss?: {
                  __typename: "CvssScore";
                  id: string;
                  value: number;
                  type: number;
                  vector: string;
                  source: string;
                  rating: ScoreRating;
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                riskCategories?: Array<{
                  __typename: "CveRiskCategory";
                  categoryMrn: string;
                  applicable: boolean;
                  impact: number;
                }> | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                detectionSources: Array<{
                  __typename: "VulnerabilityScoreSource";
                  name: string;
                  url?: string | null;
                  firstDetectedAt: string;
                  lastUpdatedAt: string;
                  fixedAt?: string | null;
                  vendor?: VulnerabilityScoreSourceVendor | null;
                  version?: string | null;
                }>;
                exceptions?: Array<{
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  reviewStatus: ReviewStatus;
                  action: ExceptionMutationAction;
                  scope: string;
                  justification: string;
                  createdAt: string;
                } | null> | null;
                spaceRiskDelta?: {
                  __typename: "FindingSpaceRiskDelta";
                  delta: number;
                  effort: number;
                  manualEffort: {
                    __typename: "ManualEffort";
                    totalManualEffort: number;
                    research: number;
                    scripting: number;
                    rollout: number;
                    verification: number;
                  };
                } | null;
              }
            | {
                __typename: "CheckFinding";
                mrn: string;
                id: string;
                title: string;
                state: ScoreState;
                iconId: Icon_Ids;
                riskValue: number;
                rating: ScoreRating;
                baseValue: number;
                baseRating: ScoreRating;
                lastUpdated: string;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  lastUpdated: string;
                  platform?: {
                    __typename: "Platform";
                    name: string;
                    title: string;
                    arch: string;
                    version: string;
                    kind: PlatformKind;
                    runtime: string;
                    family?: Array<string> | null;
                    labels?: Array<{
                      __typename: "KeyValue";
                      key: string;
                      value?: string | null;
                    }> | null;
                  } | null;
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                riskCategories?: Array<{
                  __typename: "CheckRiskCategory";
                  categoryMrn: string;
                  applicable: boolean;
                  impact: number;
                }> | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                exceptions?: Array<{
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  reviewStatus: ReviewStatus;
                  action: ExceptionMutationAction;
                  scope: string;
                } | null> | null;
                mquery?: {
                  __typename: "Mquery";
                  mrn: string;
                  mql: string;
                  impact?: { __typename: "Impact"; value: number } | null;
                  properties?: Array<{
                    __typename: "MProperty";
                    uid: string;
                    mrn: string;
                    title: string;
                    mql: string;
                    defaultValue: string;
                    overrideValue: string;
                    setByPolicyMrn?: string | null;
                    for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
                  }> | null;
                  docs?: {
                    __typename: "MqueryDocs";
                    audit: string;
                    desc: string;
                    references?: Array<{
                      __typename: "MqueryRef";
                      title: string;
                      url: string;
                    }> | null;
                    remediations?:
                      | {
                          __typename: "AuthenticationRequired";
                          message: string;
                          code: string;
                        }
                      | {
                          __typename: "Remediations";
                          entries: Array<{
                            __typename: "MqueryRemediation";
                            id: string;
                            idName: string;
                            desc: string;
                          }>;
                        }
                      | null;
                  } | null;
                } | null;
                relatedPolicies?: Array<{
                  __typename: "ActivePolicy";
                  mrn: string;
                  name: string;
                  icon: Icon_Ids;
                  updatedAt: string;
                  lastAppliedAt?: string | null;
                  action: PolicyAction;
                  score?: {
                    __typename: "AggregateScore";
                    riskValue?: number | null;
                    rating: ScoreRating;
                    blastRadius?: {
                      __typename: "BlastRadius";
                      indicator: string;
                      assets: number;
                      affected: number;
                      critical: number;
                      high: number;
                      medium: number;
                      low: number;
                      none: number;
                      error: number;
                      pass: number;
                    } | null;
                  } | null;
                }> | null;
                spaceRiskDelta?: {
                  __typename: "FindingSpaceRiskDelta";
                  delta: number;
                  effort: number;
                  manualEffort: {
                    __typename: "ManualEffort";
                    totalManualEffort: number;
                    research: number;
                    scripting: number;
                    rollout: number;
                    verification: number;
                  };
                } | null;
              }
            | {
                __typename: "CveFinding";
                mrn: string;
                id: string;
                title: string;
                state: ScoreState;
                iconId: Icon_Ids;
                riskValue: number;
                rating: ScoreRating;
                baseValue: number;
                baseRating: ScoreRating;
                firstDetectedAt: string;
                publishedAt?: string | null;
                lastUpdated: string;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  lastUpdated: string;
                  platform?: {
                    __typename: "Platform";
                    name: string;
                    title: string;
                    arch: string;
                    version: string;
                    kind: PlatformKind;
                    runtime: string;
                    family?: Array<string> | null;
                    labels?: Array<{
                      __typename: "KeyValue";
                      key: string;
                      value?: string | null;
                    }> | null;
                  } | null;
                } | null;
                epss?: {
                  __typename: "EpssScore";
                  probability: number;
                  percentile: number;
                } | null;
                cvss?: {
                  __typename: "CvssScore";
                  id: string;
                  value: number;
                  type: number;
                  vector: string;
                  source: string;
                  rating: ScoreRating;
                } | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                riskCategories?: Array<{
                  __typename: "CveRiskCategory";
                  categoryMrn: string;
                  applicable: boolean;
                  impact: number;
                }> | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                detectionSources: Array<{
                  __typename: "VulnerabilityScoreSource";
                  name: string;
                  url?: string | null;
                  firstDetectedAt: string;
                  lastUpdatedAt: string;
                  fixedAt?: string | null;
                  vendor?: VulnerabilityScoreSourceVendor | null;
                  version?: string | null;
                }>;
                exceptions?: Array<{
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  reviewStatus: ReviewStatus;
                  action: ExceptionMutationAction;
                  scope: string;
                  justification: string;
                  createdAt: string;
                } | null> | null;
                spaceRiskDelta?: {
                  __typename: "FindingSpaceRiskDelta";
                  delta: number;
                  effort: number;
                  manualEffort: {
                    __typename: "ManualEffort";
                    totalManualEffort: number;
                    research: number;
                    scripting: number;
                    rollout: number;
                    verification: number;
                  };
                } | null;
              }
            | {
                __typename: "GenericFinding";
                mrn: string;
                id: string;
                description: string;
                title: string;
                state: ScoreState;
                iconId: Icon_Ids;
                riskValue: number;
                rating: ScoreRating;
                baseValue: number;
                baseRating: ScoreRating;
                firstDetectedAt: string;
                lastUpdated: string;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                  icon?: Icon_Ids | null;
                  lastUpdated: string;
                  platform?: {
                    __typename: "Platform";
                    name: string;
                    title: string;
                    arch: string;
                    version: string;
                    kind: PlatformKind;
                    runtime: string;
                    family?: Array<string> | null;
                    labels?: Array<{
                      __typename: "KeyValue";
                      key: string;
                      value?: string | null;
                    }> | null;
                  } | null;
                } | null;
                tags?: Array<{
                  __typename: "Tag";
                  key: string;
                  value: string;
                }> | null;
                riskFactors?: Array<{
                  __typename: "RiskFactorStats";
                  mrn: string;
                  indicator: string;
                  title: string;
                  affected: number;
                  total: number;
                  isPositive: boolean;
                } | null> | null;
                exceptions?: Array<{
                  __typename: "FindingException";
                  id: string;
                  exceptionId: string;
                  exceptionMrn: string;
                  reviewStatus: ReviewStatus;
                  action: ExceptionMutationAction;
                  scope: string;
                  justification: string;
                  createdAt: string;
                } | null> | null;
              }
            | { __typename: "PackageFinding" }
            | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type CreateSecurityPipelineScheduledWorkflowMutationVariables = Exact<{
  input: CreateSecurityPipelineScheduledWorkflowInput;
}>;

export type CreateSecurityPipelineScheduledWorkflowMutation = {
  __typename: "Mutation";
  createSecurityPipelineScheduledWorkflow: {
    __typename: "CreateSecurityPipelineScheduledWorkflowResponse";
    workflow: {
      __typename: "SecurityPipelineScheduledWorkflow";
      mrn: string;
      configuration: {
        __typename: "SecurityPipelineScheduledWorkflowConfiguration";
        cadence: SecurityPipelineScheduledWorkflowCadence;
        day?: number | null;
      };
      selection: {
        __typename: "SecurityPipelineScheduledWorkflowSelection";
        scopeMrn: string;
      };
    };
  };
};

export type CreateSecurityPipelineWorkflowMutationVariables = Exact<{
  input: CreateSecurityPipelineWorkflowInput;
}>;

export type CreateSecurityPipelineWorkflowMutation = {
  __typename: "Mutation";
  createSecurityPipelineWorkflow: {
    __typename: "CreateSecurityPipelineWorkflowResponse";
    workflow: {
      __typename: "SecurityPipelineWorkflow";
      mrn: string;
      title: string;
      pullRequest?: {
        __typename: "PullRequestInfo";
        title: string;
        url: string;
      } | null;
      createdBy: { __typename: "Author"; name: string; email?: string | null };
    };
  };
};

export type DeleteSecurityPipelineScheduledWorkflowMutationVariables = Exact<{
  mrns: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type DeleteSecurityPipelineScheduledWorkflowMutation = {
  __typename: "Mutation";
  deleteSecurityPipelineScheduledWorkflow: boolean;
};

export type TriggerSecurityPipelineScheduledWorkflowMutationVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type TriggerSecurityPipelineScheduledWorkflowMutation = {
  __typename: "Mutation";
  triggerSecurityPipelineScheduledWorkflow: boolean;
};

export type UpdateSecurityPipelineScheduledWorkflowMutationVariables = Exact<{
  input: UpdateSecurityPipelineScheduledWorkflowInput;
}>;

export type UpdateSecurityPipelineScheduledWorkflowMutation = {
  __typename: "Mutation";
  updateSecurityPipelineScheduledWorkflow: {
    __typename: "UpdateSecurityPipelineScheduledWorkflowResponse";
    workflow: {
      __typename: "SecurityPipelineScheduledWorkflow";
      mrn: string;
      nextRunAt: string;
      configuration: {
        __typename: "SecurityPipelineScheduledWorkflowConfiguration";
        cadence: SecurityPipelineScheduledWorkflowCadence;
        day?: number | null;
      };
      selection: {
        __typename: "SecurityPipelineScheduledWorkflowSelection";
        scopeMrn: string;
      };
    };
  };
};

export type GetSecurityPipelineFindingsGroupsQueryVariables = Exact<{
  ownerMrn: Scalars["String"]["input"];
  findingMrns?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  initiativeMrns?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  assetMrns?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type GetSecurityPipelineFindingsGroupsQuery = {
  __typename: "Query";
  securityPipelineFindingGroups: {
    __typename: "SecurityPipelineFindingGroupsResponse";
    findingGroups: Array<{
      __typename: "SecurityPipelineWorkflowFindingGroup";
      findingMrn: string;
      title: string;
      riskScore: number;
      riskValue: number;
      rating: ScoreRating;
      assetsCount: number;
      method: WorkflowRefMethod;
    }>;
  };
};

export type GetSecurityPipelineScheduledWorkflowsQueryVariables = Exact<{
  input: SecurityPipelineScheduledWorkflowsInput;
}>;

export type GetSecurityPipelineScheduledWorkflowsQuery = {
  __typename: "Query";
  securityPipelineScheduledWorkflows: {
    __typename: "SecurityPipelineScheduledWorkflowConnection";
    totalCount: number;
    edges?: Array<{
      __typename: "SecurityPipelineScheduledWorkflowEdge";
      cursor: string;
      node: {
        __typename: "SecurityPipelineScheduledWorkflow";
        mrn: string;
        nextRunAt: string;
        configuration: {
          __typename: "SecurityPipelineScheduledWorkflowConfiguration";
          cadence: SecurityPipelineScheduledWorkflowCadence;
          day?: number | null;
        };
        selection: {
          __typename: "SecurityPipelineScheduledWorkflowSelection";
          scopeMrn: string;
        };
      };
    }> | null;
  };
};

export type GetSecurityPipelineWorkflowsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  input: SecurityPipelineWorkflowsInput;
  orderBy?: InputMaybe<SecurityPipelineWorkflowOrder>;
}>;

export type GetSecurityPipelineWorkflowsQuery = {
  __typename: "Query";
  securityPipelineWorkflows: {
    __typename: "SecurityPipelineWorkflowConnection";
    totalCount: number;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    edges?: Array<{
      __typename: "SecurityPipelineWorkflowEdge";
      node: {
        __typename: "SecurityPipelineWorkflow";
        mrn: string;
        title: string;
        status: WorkflowStatus;
        updatedAt: string;
        createdBy: { __typename: "Author"; name: string; mrn?: string | null };
        pullRequest?: {
          __typename: "PullRequestInfo";
          title: string;
          url: string;
        } | null;
      };
    }> | null;
  };
};

export type CancelSecurityPipelineWorkflowMutationVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type CancelSecurityPipelineWorkflowMutation = {
  __typename: "Mutation";
  cancelSecurityPipelineWorkflow: boolean;
};

export type GetWorkflowAssetsQueryVariables = Exact<{
  workflowMrn?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  scopeMrn?: InputMaybe<Scalars["String"]["input"]>;
  queryTerms?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  rating?: InputMaybe<Array<ScoreRating> | ScoreRating>;
}>;

export type GetWorkflowAssetsQuery = {
  __typename: "Query";
  assets?: {
    __typename: "AssetsConnection";
    totalCount: number;
    edges?: Array<{
      __typename: "AssetEdge";
      cursor: string;
      node?: {
        __typename: "Asset";
        id: string;
        mrn: string;
        name?: string | null;
        updatedAt?: string | null;
        state: AssetState;
        asset_type: string;
        score: { __typename: "Score"; riskRating: ScoreRating };
        labels: Array<{
          __typename: "KeyValue";
          key: string;
          value?: string | null;
        }>;
        riskFactors?: Array<{
          __typename: "AssetRiskFactor";
          mrn: string;
          indicator: string;
          isDetected: boolean;
        }> | null;
      } | null;
    }> | null;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
};

export type GetWorkflowInitialQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type GetWorkflowInitialQuery = {
  __typename: "Query";
  securityPipelineWorkflow?:
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | {
        __typename: "SecurityPipelineWorkflow";
        mrn: string;
        ownerMrn: string;
        integrationMrn: string;
        title: string;
        status: WorkflowStatus;
        createdAt: string;
        updatedAt: string;
        scheduledWorkflowMrn?: string | null;
        pullRequest?: {
          __typename: "PullRequestInfo";
          title: string;
          url: string;
        } | null;
        createdBy: {
          __typename: "Author";
          name: string;
          email?: string | null;
          mrn?: string | null;
          type: AuthorType;
        };
        tasks: Array<{
          __typename: "SecurityPipelineWorkflowTask";
          type: WorkflowTaskType;
          status: WorkflowTaskStatus;
          createdAt: string;
          updatedAt: string;
        }>;
        labels?: Array<{
          __typename: "KeyValue";
          key: string;
          value?: string | null;
        }> | null;
        findingGroups?: Array<{
          __typename: "SecurityPipelineWorkflowFindingGroup";
          findingMrn: string;
          title: string;
          riskScore: number;
          riskValue: number;
          rating: ScoreRating;
          assetsCount: number;
          method: WorkflowRefMethod;
        }> | null;
      }
    | null;
};

export type GetSoftwareDetailsQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<FindingsOrder>;
  filter?: InputMaybe<FindingsFilter>;
}>;

export type GetSoftwareDetailsQuery = {
  __typename: "Query";
  findings?:
    | {
        __typename: "FindingsConnection";
        totalCount: number;
        edges?: Array<{
          __typename: "FindingsEdge";
          cursor: string;
          node?:
            | { __typename: "AdvisoryFinding" }
            | { __typename: "CheckFinding" }
            | { __typename: "CveFinding" }
            | { __typename: "GenericFinding" }
            | {
                __typename: "PackageFinding";
                id: string;
                mrn: string;
                title?: string | null;
                packageName?: string | null;
                installedVersion?: string | null;
                availableVersion?: string | null;
                iconId?: Icon_Ids | null;
                firstFound: string;
                lastUpdated: string;
                asset?: {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                } | null;
                cvss: {
                  __typename: "CvssScore";
                  value: number;
                  id: string;
                  source: string;
                  type: number;
                  vector: string;
                };
                epss?: {
                  __typename: "EpssScore";
                  probability: number;
                  percentile: number;
                } | null;
              }
            | null;
        }> | null;
      }
    | { __typename: "NotFoundError" }
    | { __typename: "RequestError" }
    | null;
};

export type GetAssetInsightsQueryVariables = Exact<{
  findingsScopeMrn: Scalars["String"]["input"];
  cveFindingsFilter?: InputMaybe<FindingsFilter>;
  cveExceptionsFilter?: InputMaybe<FindingsFilter>;
  checkFindingsFilter?: InputMaybe<FindingsFilter>;
  checkExceptionsFilter?: InputMaybe<FindingsFilter>;
  findingsFirst?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetAssetInsightsQuery = {
  __typename: "Query";
  cveFindings?:
    | { __typename: "FindingsConnection"; totalCount: number }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
  cveExceptions?:
    | { __typename: "FindingsConnection"; totalCount: number }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
  checkFindings?:
    | { __typename: "FindingsConnection"; totalCount: number }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
  checkExceptions?:
    | { __typename: "FindingsConnection"; totalCount: number }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type GetPlatformPoliciesQueryVariables = Exact<{
  input: PolicyAnalyticsInput;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetPlatformPoliciesQuery = {
  __typename: "Query";
  policyAnalytics?: {
    __typename: "ActivePoliciesConnection";
    totalCount: number;
    pageInfo: {
      __typename: "PageInfo";
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
    };
    edges?: Array<{
      __typename: "ActivePolicyEdge";
      cursor: string;
      node?: {
        __typename: "ActivePolicy";
        mrn: string;
        name: string;
        icon: Icon_Ids;
        action: PolicyAction;
        score?: {
          __typename: "AggregateScore";
          completion?: number | null;
          blastRadius?: { __typename: "BlastRadius"; assets: number } | null;
          findingStats?: {
            __typename: "FindingStats";
            pass: number;
            total: number;
          } | null;
        } | null;
      } | null;
    }> | null;
  } | null;
};

export type GetCheckMqueryQueryVariables = Exact<{
  input: MqueryInput;
}>;

export type GetCheckMqueryQuery = {
  __typename: "Query";
  mquery?: {
    __typename: "Mquery";
    mql: string;
    mrn: string;
    title: string;
    docs?: {
      __typename: "MqueryDocs";
      desc: string;
      references?: Array<{
        __typename: "MqueryRef";
        title: string;
        url: string;
      }> | null;
      remediations?:
        | {
            __typename: "AuthenticationRequired";
            code: string;
            message: string;
          }
        | {
            __typename: "Remediations";
            entries: Array<{
              __typename: "MqueryRemediation";
              id: string;
              desc: string;
            }>;
          }
        | null;
    } | null;
    properties?: Array<{
      __typename: "MProperty";
      uid: string;
      mrn: string;
      title: string;
      mql: string;
      defaultValue: string;
      overrideValue: string;
      setByPolicyMrn?: string | null;
      for: Array<{ __typename: "MPropertyFor"; mrn: string }>;
    }> | null;
    variants?: Array<{
      __typename: "Variant";
      id: string;
      mrn: string;
      title: string;
      icon: string;
    }> | null;
  } | null;
};

export type GetCheckReportAggregateNodeDataQueryVariables = Exact<{
  entityMrn: Scalars["String"]["input"];
  filter?: InputMaybe<AggregateScoreFilter>;
}>;

export type GetCheckReportAggregateNodeDataQuery = {
  __typename: "Query";
  aggregateScores?:
    | {
        __typename: "AggregateScoresConnection";
        edges?: Array<{
          __typename: "AggregateScoreEdge";
          node?: {
            __typename: "AggregateScore";
            rating: ScoreRating;
            riskValue?: number | null;
            cvss?: {
              __typename: "CvssScore";
              id: string;
              value: number;
              type: number;
              vector: string;
              source: string;
              rating: ScoreRating;
            } | null;
            blastRadius?: {
              __typename: "BlastRadius";
              indicator: string;
              assets: number;
              affected: number;
              critical: number;
              high: number;
              medium: number;
              low: number;
              none: number;
              error: number;
              pass: number;
              disabled: number;
              snoozed: number;
            } | null;
          } | null;
        }> | null;
      }
    | { __typename: "NotFoundError" }
    | { __typename: "RequestError" }
    | null;
};

export type GetSpaceNameQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type GetSpaceNameQuery = {
  __typename: "Query";
  space?: { __typename: "Space"; id: string; name: string } | null;
};

export type CreateWifAuthBindingMutationVariables = Exact<{
  input: CreateWifAuthBindingInput;
}>;

export type CreateWifAuthBindingMutation = {
  __typename: "Mutation";
  createWIFAuthBinding?: {
    __typename: "CreateWIFAuthBindingPayload";
    binding?: { __typename: "WIFAuthBinding"; mrn: string } | null;
    config?: {
      __typename: "WIFExternalAuthConfig";
      universeDomain: string;
      scopes?: Array<string> | null;
      type: string;
      audience: string;
      subjectTokenType: string;
      issuerUri: string;
    } | null;
  } | null;
};

export type RemoveWifAuthBindingMutationVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type RemoveWifAuthBindingMutation = {
  __typename: "Mutation";
  removeWIFAuthBinding?: {
    __typename: "RemoveWIFAuthBindingPayload";
    mrn?: string | null;
  } | null;
};

export type GetWifAuthBindingConfigQueryVariables = Exact<{
  bindingMrn: Scalars["String"]["input"];
}>;

export type GetWifAuthBindingConfigQuery = {
  __typename: "Query";
  getWIFAuthBinding?: {
    __typename: "GetWIFAuthBindingPayload";
    config?: {
      __typename: "WIFExternalAuthConfig";
      universeDomain: string;
      scopes?: Array<string> | null;
      type: string;
      audience: string;
      subjectTokenType: string;
      issuerUri: string;
    } | null;
  } | null;
};

export type GetWifAuthBindingsQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  orderBy?: InputMaybe<WifAuthBindingOrder>;
}>;

export type GetWifAuthBindingsQuery = {
  __typename: "Query";
  listWIFAuthBindings?: {
    __typename: "ListWIFAuthBindingsPayload";
    bindings?: Array<{
      __typename: "WIFAuthBinding";
      mrn: string;
      name: string;
      description?: string | null;
      expiration: number;
      issuerUri: string;
      createdAt?: string | null;
      lastUsed?: string | null;
      iconId?: string | null;
    } | null> | null;
  } | null;
};

export type GetSpaceSoftwareQueryVariables = Exact<{
  entityMrn: Scalars["String"]["input"];
  filter?: InputMaybe<AggregateScoreFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<AggregateScoreOrder>;
}>;

export type GetSpaceSoftwareQuery = {
  __typename: "Query";
  aggregateScores?:
    | {
        __typename: "AggregateScoresConnection";
        totalCount: number;
        edges?: Array<{
          __typename: "AggregateScoreEdge";
          cursor: string;
          node?: {
            __typename: "AggregateScore";
            id: string;
            iconId: Icon_Ids;
            state: AggregateScoreState;
            effort: number;
            enforcementState: EnforcementState;
            previewUntil?: string | null;
            spaceRiskImprovement: number;
            findingMrn: string;
            rank: number;
            rankScore: number;
            baseScore?: number | null;
            riskValue?: number | null;
            scoreType: AggregateScoreType;
            rating: ScoreRating;
            baseValue: number;
            baseRating: ScoreRating;
            title: string;
            description: string;
            lastScannedAt?: string | null;
            firstDetectedAt: string;
            remediatedAt: string;
            spaceId: string;
            slaAtRiskCount: number;
            slaOverdueCount: number;
            versionDistribution?: {
              __typename: "VersionDistribution";
              total: number;
              assets: number;
              installations: number;
              distribution?: Array<{
                __typename: "VersionDistributionEntry";
                version: string;
                count: number;
                riskScoreRating: ScoreRating;
                riskValue: number;
              }> | null;
            } | null;
            entity?:
              | {
                  __typename: "EntityInfoAsset";
                  id: string;
                  mrn: string;
                  name: string;
                }
              | {
                  __typename: "EntityInfoOrganization";
                  id: string;
                  mrn: string;
                  name: string;
                }
              | { __typename: "EntityInfoPlatform" }
              | {
                  __typename: "EntityInfoSpace";
                  id: string;
                  mrn: string;
                  name: string;
                }
              | { __typename: "EntityInfoUnknown" }
              | {
                  __typename: "EntityInfoWorkspace";
                  id: string;
                  mrn: string;
                  name: string;
                }
              | null;
            blastRadius?: {
              __typename: "BlastRadius";
              indicator: string;
              assets: number;
              affected: number;
              critical: number;
              high: number;
              medium: number;
              low: number;
              none: number;
              snoozed: number;
              disabled: number;
            } | null;
            riskFactors?: Array<{
              __typename: "RiskFactorStats";
              mrn: string;
              indicator: string;
              title: string;
              total: number;
              affected: number;
              isPositive: boolean;
            } | null> | null;
            detectionSources: Array<{
              __typename: "ScoreSource";
              name: string;
              firstDetectedAt: string;
              lastUpdatedAt: string;
              affectedAssets: number;
              vendor?: string | null;
            }>;
            tags?: Array<{
              __typename: "Tag";
              key: string;
              value: string;
            }> | null;
            epss?: {
              __typename: "EpssScore";
              percentile: number;
              probability: number;
            } | null;
            cvss?: {
              __typename: "CvssScore";
              value: number;
              id: string;
              type: number;
              vector: string;
              source: string;
              rating: ScoreRating;
            } | null;
          } | null;
        }> | null;
        pageInfo: {
          __typename: "PageInfo";
          startCursor: string;
          endCursor: string;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      }
    | { __typename: "NotFoundError"; message: string; code: string }
    | { __typename: "RequestError"; message: string; code: string }
    | null;
};

export type WorkspaceSelectionFragment = {
  __typename: "WorkspaceSelections";
  selections: Array<{
    __typename: "WorkspaceSelection";
    conditions: Array<{
      __typename: "WorkspaceSelectionCondition";
      operator: WorkspaceSelectionConditionOperator;
      condition:
        | {
            __typename: "WorkspaceSelectionIntCondition";
            intField: WorkspaceSelectionConditionIntField;
            intOperator: WorkspaceSelectionConditionNumericOperator;
            intValues: Array<number>;
          }
        | {
            __typename: "WorkspaceSelectionKeyValueCondition";
            keyValueField: WorkspaceSelectionConditionKeyValueField;
            keyValueOperator: WorkspaceSelectionConditionKeyValueOperator;
            keyValueValues: Array<{
              __typename: "KeyValue";
              key: string;
              value?: string | null;
            }>;
          }
        | {
            __typename: "WorkspaceSelectionRatingCondition";
            ratingField: WorkspaceSelectionConditionRatingField;
            ratingOperator: WorkspaceSelectionConditionRatingOperator;
            ratingValues: Array<ScoreRating>;
          }
        | {
            __typename: "WorkspaceSelectionStringCondition";
            stringField: WorkspaceSelectionConditionStringField;
            stringOperator: WorkspaceSelectionConditionStringOperator;
            stringValues: Array<{
              __typename: "WorkspaceSelectionStringConditionValue";
              value: string;
              displayName: string;
            }>;
          };
    }>;
  }>;
};

export type GetAnnotationSuggestionsQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetAnnotationSuggestionsQuery = {
  __typename: "Query";
  annotationSuggestions?: Array<string> | null;
};

export type GetLabelSuggestionsQueryVariables = Exact<{
  scopeMrn: Scalars["String"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetLabelSuggestionsQuery = {
  __typename: "Query";
  labelSuggestions?: Array<string> | null;
};

export type GetWorkspaceConditionPossibleValuesQueryVariables = Exact<{
  input: WorkspaceConditionPossibleValuesInput;
}>;

export type GetWorkspaceConditionPossibleValuesQuery = {
  __typename: "Query";
  workspaceConditionPossibleValues:
    | {
        __typename: "WorkspaceConditionIntValues";
        suggestions?: Array<{
          __typename: "WorkspaceConditionIntValueSuggestion";
          intValue: number;
          intDisplayName: string;
        }> | null;
      }
    | {
        __typename: "WorkspaceConditionRatingValues";
        suggestions?: Array<{
          __typename: "WorkspaceConditionRatingValueSuggestion";
          ratingValue: ScoreRating;
          ratingDisplayName: string;
        }> | null;
      }
    | {
        __typename: "WorkspaceConditionStringValues";
        suggestions?: Array<{
          __typename: "WorkspaceConditionStringValueSuggestion";
          stringValue: string;
          stringDisplayName: string;
        }> | null;
      };
};

export type GetWorkspaceSelectionsQueryVariables = Exact<{
  mrn: Scalars["String"]["input"];
}>;

export type GetWorkspaceSelectionsQuery = {
  __typename: "Query";
  workspace:
    | { __typename: "NotFoundError" }
    | { __typename: "RequestError" }
    | {
        __typename: "Workspace";
        mrn: string;
        selections: {
          __typename: "WorkspaceSelections";
          selections: Array<{
            __typename: "WorkspaceSelection";
            conditions: Array<{
              __typename: "WorkspaceSelectionCondition";
              operator: WorkspaceSelectionConditionOperator;
              condition:
                | {
                    __typename: "WorkspaceSelectionIntCondition";
                    intField: WorkspaceSelectionConditionIntField;
                    intOperator: WorkspaceSelectionConditionNumericOperator;
                    intValues: Array<number>;
                  }
                | {
                    __typename: "WorkspaceSelectionKeyValueCondition";
                    keyValueField: WorkspaceSelectionConditionKeyValueField;
                    keyValueOperator: WorkspaceSelectionConditionKeyValueOperator;
                    keyValueValues: Array<{
                      __typename: "KeyValue";
                      key: string;
                      value?: string | null;
                    }>;
                  }
                | {
                    __typename: "WorkspaceSelectionRatingCondition";
                    ratingField: WorkspaceSelectionConditionRatingField;
                    ratingOperator: WorkspaceSelectionConditionRatingOperator;
                    ratingValues: Array<ScoreRating>;
                  }
                | {
                    __typename: "WorkspaceSelectionStringCondition";
                    stringField: WorkspaceSelectionConditionStringField;
                    stringOperator: WorkspaceSelectionConditionStringOperator;
                    stringValues: Array<{
                      __typename: "WorkspaceSelectionStringConditionValue";
                      value: string;
                      displayName: string;
                    }>;
                  };
            }>;
          }>;
        };
      };
};

export const VulnerabilityRiskFactorsFieldsFragmentDoc = gql`
  fragment VulnerabilityRiskFactorsFields on VulnerabilityRiskFactors {
    knownExploited
    remoteExploitable
  }
`;
export const AdvisoryNodeFieldsFragmentDoc = gql`
  fragment AdvisoryNodeFields on Advisory {
    id
    title
    publishedAt
    iconIDEnum
    cvssScore {
      id
      source
      type
      value
      vector
      rating
    }
    vulnerabilityRiskFactors {
      ...VulnerabilityRiskFactorsFields
    }
    cves {
      id
      vulnerabilityRiskFactors {
        ...VulnerabilityRiskFactorsFields
      }
    }
  }
  ${VulnerabilityRiskFactorsFieldsFragmentDoc}
`;
export const AffectedAssetStatsFieldsFragmentDoc = gql`
  fragment AffectedAssetStatsFields on AffectedAssetStats {
    affectedCount
    fixedCount
    totalCount
  }
`;
export const AgentFieldsFragmentDoc = gql`
  fragment AgentFields on AgentsConnection {
    totalCount
    edges {
      cursor
      node {
        id
        mrn
        name
        status {
          version
          state
          lastCheckin
        }
        labels {
          key
          value
        }
        platform {
          name
          release
          arch
        }
        hostname
        ipaddress
        createdAt
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
  }
`;
export const AssetFieldsFragmentDoc = gql`
  fragment AssetFields on AssetsConnection {
    totalCount
    edges {
      cursor
      node {
        id
        mrn
        name
        state
        score {
          id
          value
          type
          completion
          weight
          message
          riskRating
          riskValue
        }
        updatedAt
        labels {
          key
          value
        }
        platform {
          name
          title
          release
          arch
          kind
          runtime
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
  }
`;
export const AssetGradeDistributionFieldsFragmentDoc = gql`
  fragment AssetGradeDistributionFields on AssetGradeDistribution {
    total
    A
    B
    C
    D
    F
    U
    X
  }
`;
export const BlastRadiusFieldsFragmentDoc = gql`
  fragment BlastRadiusFields on BlastRadius {
    indicator
    assets
    affected
    critical
    high
    medium
    low
    none
    snoozed
    disabled
  }
`;
export const CveNodeFieldsFragmentDoc = gql`
  fragment CveNodeFields on Cve {
    id
    state
    published
    title
    vulnerabilityRiskFactors {
      ...VulnerabilityRiskFactorsFields
    }
    epssScore {
      probability
    }
    cvssScore {
      type
      value
      vector
      rating
    }
    score {
      value
      type
    }
  }
  ${VulnerabilityRiskFactorsFieldsFragmentDoc}
`;
export const CvssScoreFieldsFragmentDoc = gql`
  fragment CvssScoreFields on CvssScore {
    id
    value
    type
    vector
    source
  }
`;
export const FindingStatesFieldsFragmentDoc = gql`
  fragment FindingStatesFields on FindingState {
    score
    age
    action
    securityPipeline
    ticket
    exception
    overall
    enforcement
  }
`;
export const MqueryDocsFieldsFragmentDoc = gql`
  fragment MqueryDocsFields on MqueryDocs {
    audit
    desc
    references {
      title
      url
    }
    remediations {
      ... on Remediations {
        entries {
          id
          idName
          desc
        }
      }
      ... on AuthenticationRequired {
        message
        code
      }
    }
  }
`;
export const PackageFieldsFragmentDoc = gql`
  fragment PackageFields on Package {
    id
    name
    version
    arch
    available
    status
    vulnDiscoveryTime
    iconIDEnum
    cvssScore {
      type
      value
      vector
    }
    epssScore {
      percentile
      probability
    }
  }
`;
export const PageInfoFieldsFragmentDoc = gql`
  fragment PageInfoFields on PageInfo {
    startCursor
    endCursor
    hasNextPage
    hasPreviousPage
  }
`;
export const PlatformFieldsFragmentDoc = gql`
  fragment PlatformFields on Platform {
    name
    release
    arch
    kind
    runtime
  }
`;
export const RemediationPackageFieldsFragmentDoc = gql`
  fragment RemediationPackageFields on Package {
    id
    name
    version
    namespace
    ecosystem
    arch
  }
`;
export const RemediationScriptFieldsFragmentDoc = gql`
  fragment RemediationScriptFields on RemediationScript {
    type
    script
    packageManager
    platformName
    platformVersion
  }
`;
export const ServiceAccountFieldsFragmentDoc = gql`
  fragment ServiceAccountFields on ServiceAccountConnection {
    totalCount
    edges {
      cursor
      node {
        id
        mrn
        name
        description
        roles {
          mrn
          title
        }
        createdAt
        lastUsed
        labels {
          key
          value
        }
        creator {
          mrn
          email
          service
        }
        notes
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
  }
`;
export const WorkspaceSelectionFragmentDoc = gql`
  fragment WorkspaceSelection on WorkspaceSelections {
    selections {
      conditions {
        operator
        condition {
          ... on WorkspaceSelectionStringCondition {
            stringField: field
            stringOperator: operator
            stringValues: values {
              value
              displayName
            }
          }
          ... on WorkspaceSelectionIntCondition {
            intField: field
            intOperator: operator
            intValues: values
          }
          ... on WorkspaceSelectionRatingCondition {
            ratingField: field
            ratingOperator: operator
            ratingValues: values
          }
          ... on WorkspaceSelectionKeyValueCondition {
            keyValueField: field
            keyValueOperator: operator
            keyValueValues: values {
              key
              value
            }
          }
        }
      }
    }
  }
`;
export const GetAffectedEcosystemsDocument = gql`
  query GetAffectedEcosystems(
    $vulnId: String!
    $scopeMrn: String!
    $initiativeMrn: String
  ) {
    affectedEcosystems(
      vulnId: $vulnId
      scopeMrn: $scopeMrn
      initiativeMrn: $initiativeMrn
    ) {
      friendlyName
      icon
      versions {
        friendlyName
        ecosystem
      }
    }
  }
`;

/**
 * __useGetAffectedEcosystemsQuery__
 *
 * To run a query within a React component, call `useGetAffectedEcosystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAffectedEcosystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAffectedEcosystemsQuery({
 *   variables: {
 *      vulnId: // value for 'vulnId'
 *      scopeMrn: // value for 'scopeMrn'
 *      initiativeMrn: // value for 'initiativeMrn'
 *   },
 * });
 */
export function useGetAffectedEcosystemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAffectedEcosystemsQuery,
    GetAffectedEcosystemsQueryVariables
  > &
    (
      | { variables: GetAffectedEcosystemsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAffectedEcosystemsQuery,
    GetAffectedEcosystemsQueryVariables
  >(GetAffectedEcosystemsDocument, options);
}
export function useGetAffectedEcosystemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAffectedEcosystemsQuery,
    GetAffectedEcosystemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAffectedEcosystemsQuery,
    GetAffectedEcosystemsQueryVariables
  >(GetAffectedEcosystemsDocument, options);
}
// @ts-ignore
export function useGetAffectedEcosystemsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAffectedEcosystemsQuery,
    GetAffectedEcosystemsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAffectedEcosystemsQuery,
  GetAffectedEcosystemsQueryVariables
>;
export function useGetAffectedEcosystemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAffectedEcosystemsQuery,
        GetAffectedEcosystemsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAffectedEcosystemsQuery | undefined,
  GetAffectedEcosystemsQueryVariables
>;
export function useGetAffectedEcosystemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAffectedEcosystemsQuery,
        GetAffectedEcosystemsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAffectedEcosystemsQuery,
    GetAffectedEcosystemsQueryVariables
  >(GetAffectedEcosystemsDocument, options);
}
export type GetAffectedEcosystemsQueryHookResult = ReturnType<
  typeof useGetAffectedEcosystemsQuery
>;
export type GetAffectedEcosystemsLazyQueryHookResult = ReturnType<
  typeof useGetAffectedEcosystemsLazyQuery
>;
export type GetAffectedEcosystemsSuspenseQueryHookResult = ReturnType<
  typeof useGetAffectedEcosystemsSuspenseQuery
>;
export type GetAffectedEcosystemsQueryResult = Apollo.QueryResult<
  GetAffectedEcosystemsQuery,
  GetAffectedEcosystemsQueryVariables
>;
export const GetRemediationDocument = gql`
  query GetRemediation(
    $vulnId: String
    $scopeMrn: String!
    $ecosystem: String
    $packages: [PackageReferenceInput!]
    $initiativeMrn: String
  ) {
    remediationForScope(
      vulnId: $vulnId
      scopeMrn: $scopeMrn
      ecosystem: $ecosystem
      packages: $packages
      initiativeMrn: $initiativeMrn
    ) {
      ... on Remediation {
        scopeMrn
        scripts {
          ...RemediationScriptFields
        }
        allPackages {
          ...RemediationPackageFields
        }
      }
      ... on VulnerabilityRemediationNotFound {
        message
      }
      ... on VulnerabilityRemediationNotSupported {
        message
      }
      ... on VulnerabilityRemediationUnknown {
        message
      }
    }
  }
  ${RemediationScriptFieldsFragmentDoc}
  ${RemediationPackageFieldsFragmentDoc}
`;

/**
 * __useGetRemediationQuery__
 *
 * To run a query within a React component, call `useGetRemediationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemediationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemediationQuery({
 *   variables: {
 *      vulnId: // value for 'vulnId'
 *      scopeMrn: // value for 'scopeMrn'
 *      ecosystem: // value for 'ecosystem'
 *      packages: // value for 'packages'
 *      initiativeMrn: // value for 'initiativeMrn'
 *   },
 * });
 */
export function useGetRemediationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRemediationQuery,
    GetRemediationQueryVariables
  > &
    (
      | { variables: GetRemediationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRemediationQuery, GetRemediationQueryVariables>(
    GetRemediationDocument,
    options,
  );
}
export function useGetRemediationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRemediationQuery,
    GetRemediationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRemediationQuery, GetRemediationQueryVariables>(
    GetRemediationDocument,
    options,
  );
}
// @ts-ignore
export function useGetRemediationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRemediationQuery,
    GetRemediationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetRemediationQuery,
  GetRemediationQueryVariables
>;
export function useGetRemediationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRemediationQuery,
        GetRemediationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetRemediationQuery | undefined,
  GetRemediationQueryVariables
>;
export function useGetRemediationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRemediationQuery,
        GetRemediationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRemediationQuery,
    GetRemediationQueryVariables
  >(GetRemediationDocument, options);
}
export type GetRemediationQueryHookResult = ReturnType<
  typeof useGetRemediationQuery
>;
export type GetRemediationLazyQueryHookResult = ReturnType<
  typeof useGetRemediationLazyQuery
>;
export type GetRemediationSuspenseQueryHookResult = ReturnType<
  typeof useGetRemediationSuspenseQuery
>;
export type GetRemediationQueryResult = Apollo.QueryResult<
  GetRemediationQuery,
  GetRemediationQueryVariables
>;
export const StartConversationDocument = gql`
  query StartConversation($input: FindingsWebhookPostRequest) {
    createFindingsWebhookPost(input: $input) {
      status
    }
  }
`;

/**
 * __useStartConversationQuery__
 *
 * To run a query within a React component, call `useStartConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartConversationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartConversationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StartConversationQuery,
    StartConversationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StartConversationQuery,
    StartConversationQueryVariables
  >(StartConversationDocument, options);
}
export function useStartConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StartConversationQuery,
    StartConversationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StartConversationQuery,
    StartConversationQueryVariables
  >(StartConversationDocument, options);
}
// @ts-ignore
export function useStartConversationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StartConversationQuery,
    StartConversationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  StartConversationQuery,
  StartConversationQueryVariables
>;
export function useStartConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StartConversationQuery,
        StartConversationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  StartConversationQuery | undefined,
  StartConversationQueryVariables
>;
export function useStartConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StartConversationQuery,
        StartConversationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StartConversationQuery,
    StartConversationQueryVariables
  >(StartConversationDocument, options);
}
export type StartConversationQueryHookResult = ReturnType<
  typeof useStartConversationQuery
>;
export type StartConversationLazyQueryHookResult = ReturnType<
  typeof useStartConversationLazyQuery
>;
export type StartConversationSuspenseQueryHookResult = ReturnType<
  typeof useStartConversationSuspenseQuery
>;
export type StartConversationQueryResult = Apollo.QueryResult<
  StartConversationQuery,
  StartConversationQueryVariables
>;
export const GetIntercomTokenDocument = gql`
  query GetIntercomToken {
    intercomToken
  }
`;

/**
 * __useGetIntercomTokenQuery__
 *
 * To run a query within a React component, call `useGetIntercomTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntercomTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntercomTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntercomTokenQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetIntercomTokenQuery,
    GetIntercomTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIntercomTokenQuery, GetIntercomTokenQueryVariables>(
    GetIntercomTokenDocument,
    options,
  );
}
export function useGetIntercomTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIntercomTokenQuery,
    GetIntercomTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIntercomTokenQuery,
    GetIntercomTokenQueryVariables
  >(GetIntercomTokenDocument, options);
}
// @ts-ignore
export function useGetIntercomTokenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIntercomTokenQuery,
    GetIntercomTokenQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetIntercomTokenQuery,
  GetIntercomTokenQueryVariables
>;
export function useGetIntercomTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntercomTokenQuery,
        GetIntercomTokenQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetIntercomTokenQuery | undefined,
  GetIntercomTokenQueryVariables
>;
export function useGetIntercomTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntercomTokenQuery,
        GetIntercomTokenQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIntercomTokenQuery,
    GetIntercomTokenQueryVariables
  >(GetIntercomTokenDocument, options);
}
export type GetIntercomTokenQueryHookResult = ReturnType<
  typeof useGetIntercomTokenQuery
>;
export type GetIntercomTokenLazyQueryHookResult = ReturnType<
  typeof useGetIntercomTokenLazyQuery
>;
export type GetIntercomTokenSuspenseQueryHookResult = ReturnType<
  typeof useGetIntercomTokenSuspenseQuery
>;
export type GetIntercomTokenQueryResult = Apollo.QueryResult<
  GetIntercomTokenQuery,
  GetIntercomTokenQueryVariables
>;
export const AcceptInvitationDocument = gql`
  mutation AcceptInvitation($invitationMrn: ID!) {
    acceptInvitation(invitationMrn: $invitationMrn)
  }
`;
export type AcceptInvitationMutationFn = Apollo.MutationFunction<
  AcceptInvitationMutation,
  AcceptInvitationMutationVariables
>;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      invitationMrn: // value for 'invitationMrn'
 *   },
 * });
 */
export function useAcceptInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptInvitationMutation,
    AcceptInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptInvitationMutation,
    AcceptInvitationMutationVariables
  >(AcceptInvitationDocument, options);
}
export type AcceptInvitationMutationHookResult = ReturnType<
  typeof useAcceptInvitationMutation
>;
export type AcceptInvitationMutationResult =
  Apollo.MutationResult<AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<
  AcceptInvitationMutation,
  AcceptInvitationMutationVariables
>;
export const AcceptLegalPolicyDocument = gql`
  mutation AcceptLegalPolicy($input: AcceptLegalPolicy!) {
    acceptLegalPolicy(input: $input)
  }
`;
export type AcceptLegalPolicyMutationFn = Apollo.MutationFunction<
  AcceptLegalPolicyMutation,
  AcceptLegalPolicyMutationVariables
>;

/**
 * __useAcceptLegalPolicyMutation__
 *
 * To run a mutation, you first call `useAcceptLegalPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptLegalPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptLegalPolicyMutation, { data, loading, error }] = useAcceptLegalPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptLegalPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptLegalPolicyMutation,
    AcceptLegalPolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptLegalPolicyMutation,
    AcceptLegalPolicyMutationVariables
  >(AcceptLegalPolicyDocument, options);
}
export type AcceptLegalPolicyMutationHookResult = ReturnType<
  typeof useAcceptLegalPolicyMutation
>;
export type AcceptLegalPolicyMutationResult =
  Apollo.MutationResult<AcceptLegalPolicyMutation>;
export type AcceptLegalPolicyMutationOptions = Apollo.BaseMutationOptions<
  AcceptLegalPolicyMutation,
  AcceptLegalPolicyMutationVariables
>;
export const ActivateUserInRegionDocument = gql`
  mutation ActivateUserInRegion {
    activateUserInRegion {
      user {
        mrn
      }
    }
  }
`;
export type ActivateUserInRegionMutationFn = Apollo.MutationFunction<
  ActivateUserInRegionMutation,
  ActivateUserInRegionMutationVariables
>;

/**
 * __useActivateUserInRegionMutation__
 *
 * To run a mutation, you first call `useActivateUserInRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUserInRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUserInRegionMutation, { data, loading, error }] = useActivateUserInRegionMutation({
 *   variables: {
 *   },
 * });
 */
export function useActivateUserInRegionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateUserInRegionMutation,
    ActivateUserInRegionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ActivateUserInRegionMutation,
    ActivateUserInRegionMutationVariables
  >(ActivateUserInRegionDocument, options);
}
export type ActivateUserInRegionMutationHookResult = ReturnType<
  typeof useActivateUserInRegionMutation
>;
export type ActivateUserInRegionMutationResult =
  Apollo.MutationResult<ActivateUserInRegionMutation>;
export type ActivateUserInRegionMutationOptions = Apollo.BaseMutationOptions<
  ActivateUserInRegionMutation,
  ActivateUserInRegionMutationVariables
>;
export const AddQueryPackDocument = gql`
  mutation AddQueryPack($input: [QueryPackAddInput!]!) {
    addQueryPack(input: $input)
  }
`;
export type AddQueryPackMutationFn = Apollo.MutationFunction<
  AddQueryPackMutation,
  AddQueryPackMutationVariables
>;

/**
 * __useAddQueryPackMutation__
 *
 * To run a mutation, you first call `useAddQueryPackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQueryPackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQueryPackMutation, { data, loading, error }] = useAddQueryPackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQueryPackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddQueryPackMutation,
    AddQueryPackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddQueryPackMutation,
    AddQueryPackMutationVariables
  >(AddQueryPackDocument, options);
}
export type AddQueryPackMutationHookResult = ReturnType<
  typeof useAddQueryPackMutation
>;
export type AddQueryPackMutationResult =
  Apollo.MutationResult<AddQueryPackMutation>;
export type AddQueryPackMutationOptions = Apollo.BaseMutationOptions<
  AddQueryPackMutation,
  AddQueryPackMutationVariables
>;
export const ApplyExceptionDocument = gql`
  mutation ApplyException($input: ExceptionMutationInput!) {
    applyException(input: $input)
  }
`;
export type ApplyExceptionMutationFn = Apollo.MutationFunction<
  ApplyExceptionMutation,
  ApplyExceptionMutationVariables
>;

/**
 * __useApplyExceptionMutation__
 *
 * To run a mutation, you first call `useApplyExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyExceptionMutation, { data, loading, error }] = useApplyExceptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyExceptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyExceptionMutation,
    ApplyExceptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplyExceptionMutation,
    ApplyExceptionMutationVariables
  >(ApplyExceptionDocument, options);
}
export type ApplyExceptionMutationHookResult = ReturnType<
  typeof useApplyExceptionMutation
>;
export type ApplyExceptionMutationResult =
  Apollo.MutationResult<ApplyExceptionMutation>;
export type ApplyExceptionMutationOptions = Apollo.BaseMutationOptions<
  ApplyExceptionMutation,
  ApplyExceptionMutationVariables
>;
export const ApplyExceptionExtensionReviewDocument = gql`
  mutation ApplyExceptionExtensionReview($input: ExtendExceptionReviewInput!) {
    applyExceptionExtensionReview(input: $input)
  }
`;
export type ApplyExceptionExtensionReviewMutationFn = Apollo.MutationFunction<
  ApplyExceptionExtensionReviewMutation,
  ApplyExceptionExtensionReviewMutationVariables
>;

/**
 * __useApplyExceptionExtensionReviewMutation__
 *
 * To run a mutation, you first call `useApplyExceptionExtensionReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyExceptionExtensionReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyExceptionExtensionReviewMutation, { data, loading, error }] = useApplyExceptionExtensionReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyExceptionExtensionReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyExceptionExtensionReviewMutation,
    ApplyExceptionExtensionReviewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplyExceptionExtensionReviewMutation,
    ApplyExceptionExtensionReviewMutationVariables
  >(ApplyExceptionExtensionReviewDocument, options);
}
export type ApplyExceptionExtensionReviewMutationHookResult = ReturnType<
  typeof useApplyExceptionExtensionReviewMutation
>;
export type ApplyExceptionExtensionReviewMutationResult =
  Apollo.MutationResult<ApplyExceptionExtensionReviewMutation>;
export type ApplyExceptionExtensionReviewMutationOptions =
  Apollo.BaseMutationOptions<
    ApplyExceptionExtensionReviewMutation,
    ApplyExceptionExtensionReviewMutationVariables
  >;
export const ApplyExceptionReviewDocument = gql`
  mutation ApplyExceptionReview($input: ExceptionReviewInput!) {
    applyExceptionReview(input: $input)
  }
`;
export type ApplyExceptionReviewMutationFn = Apollo.MutationFunction<
  ApplyExceptionReviewMutation,
  ApplyExceptionReviewMutationVariables
>;

/**
 * __useApplyExceptionReviewMutation__
 *
 * To run a mutation, you first call `useApplyExceptionReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyExceptionReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyExceptionReviewMutation, { data, loading, error }] = useApplyExceptionReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyExceptionReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyExceptionReviewMutation,
    ApplyExceptionReviewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplyExceptionReviewMutation,
    ApplyExceptionReviewMutationVariables
  >(ApplyExceptionReviewDocument, options);
}
export type ApplyExceptionReviewMutationHookResult = ReturnType<
  typeof useApplyExceptionReviewMutation
>;
export type ApplyExceptionReviewMutationResult =
  Apollo.MutationResult<ApplyExceptionReviewMutation>;
export type ApplyExceptionReviewMutationOptions = Apollo.BaseMutationOptions<
  ApplyExceptionReviewMutation,
  ApplyExceptionReviewMutationVariables
>;
export const ApplyFrameworkDocument = gql`
  mutation ApplyFramework($input: ComplianceFrameworkMutationInput!) {
    applyFrameworkMutation(input: $input)
  }
`;
export type ApplyFrameworkMutationFn = Apollo.MutationFunction<
  ApplyFrameworkMutation,
  ApplyFrameworkMutationVariables
>;

/**
 * __useApplyFrameworkMutation__
 *
 * To run a mutation, you first call `useApplyFrameworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyFrameworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyFrameworkMutation, { data, loading, error }] = useApplyFrameworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyFrameworkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyFrameworkMutation,
    ApplyFrameworkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplyFrameworkMutation,
    ApplyFrameworkMutationVariables
  >(ApplyFrameworkDocument, options);
}
export type ApplyFrameworkMutationHookResult = ReturnType<
  typeof useApplyFrameworkMutation
>;
export type ApplyFrameworkMutationResult =
  Apollo.MutationResult<ApplyFrameworkMutation>;
export type ApplyFrameworkMutationOptions = Apollo.BaseMutationOptions<
  ApplyFrameworkMutation,
  ApplyFrameworkMutationVariables
>;
export const AssignPolicyDocument = gql`
  mutation AssignPolicy($input: PolicyAssignmentInput!) {
    assignPolicy(input: $input)
  }
`;
export type AssignPolicyMutationFn = Apollo.MutationFunction<
  AssignPolicyMutation,
  AssignPolicyMutationVariables
>;

/**
 * __useAssignPolicyMutation__
 *
 * To run a mutation, you first call `useAssignPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPolicyMutation, { data, loading, error }] = useAssignPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignPolicyMutation,
    AssignPolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignPolicyMutation,
    AssignPolicyMutationVariables
  >(AssignPolicyDocument, options);
}
export type AssignPolicyMutationHookResult = ReturnType<
  typeof useAssignPolicyMutation
>;
export type AssignPolicyMutationResult =
  Apollo.MutationResult<AssignPolicyMutation>;
export type AssignPolicyMutationOptions = Apollo.BaseMutationOptions<
  AssignPolicyMutation,
  AssignPolicyMutationVariables
>;
export const CancelInvitationDocument = gql`
  mutation CancelInvitation($invitationMrn: ID!) {
    cancelInvitation(invitationMrn: $invitationMrn)
  }
`;
export type CancelInvitationMutationFn = Apollo.MutationFunction<
  CancelInvitationMutation,
  CancelInvitationMutationVariables
>;

/**
 * __useCancelInvitationMutation__
 *
 * To run a mutation, you first call `useCancelInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInvitationMutation, { data, loading, error }] = useCancelInvitationMutation({
 *   variables: {
 *      invitationMrn: // value for 'invitationMrn'
 *   },
 * });
 */
export function useCancelInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelInvitationMutation,
    CancelInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelInvitationMutation,
    CancelInvitationMutationVariables
  >(CancelInvitationDocument, options);
}
export type CancelInvitationMutationHookResult = ReturnType<
  typeof useCancelInvitationMutation
>;
export type CancelInvitationMutationResult =
  Apollo.MutationResult<CancelInvitationMutation>;
export type CancelInvitationMutationOptions = Apollo.BaseMutationOptions<
  CancelInvitationMutation,
  CancelInvitationMutationVariables
>;
export const ChangeSubscriptionPlanDocument = gql`
  mutation ChangeSubscriptionPlan($input: ChangeSubscriptionPlanInput!) {
    changeSubscriptionPlan(input: $input) {
      __typename
      ... on BillingSession {
        url
      }
      ... on PaymentPreview {
        currency
        recurringCost
        dueToday
        prorationDate
        effectiveDate
      }
    }
  }
`;
export type ChangeSubscriptionPlanMutationFn = Apollo.MutationFunction<
  ChangeSubscriptionPlanMutation,
  ChangeSubscriptionPlanMutationVariables
>;

/**
 * __useChangeSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionPlanMutation, { data, loading, error }] = useChangeSubscriptionPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeSubscriptionPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeSubscriptionPlanMutation,
    ChangeSubscriptionPlanMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeSubscriptionPlanMutation,
    ChangeSubscriptionPlanMutationVariables
  >(ChangeSubscriptionPlanDocument, options);
}
export type ChangeSubscriptionPlanMutationHookResult = ReturnType<
  typeof useChangeSubscriptionPlanMutation
>;
export type ChangeSubscriptionPlanMutationResult =
  Apollo.MutationResult<ChangeSubscriptionPlanMutation>;
export type ChangeSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<
  ChangeSubscriptionPlanMutation,
  ChangeSubscriptionPlanMutationVariables
>;
export const CreateBillingSessionDocument = gql`
  mutation CreateBillingSession($input: BillingSessionInput!) {
    createBillingSession(input: $input) {
      url
    }
  }
`;
export type CreateBillingSessionMutationFn = Apollo.MutationFunction<
  CreateBillingSessionMutation,
  CreateBillingSessionMutationVariables
>;

/**
 * __useCreateBillingSessionMutation__
 *
 * To run a mutation, you first call `useCreateBillingSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingSessionMutation, { data, loading, error }] = useCreateBillingSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBillingSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBillingSessionMutation,
    CreateBillingSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateBillingSessionMutation,
    CreateBillingSessionMutationVariables
  >(CreateBillingSessionDocument, options);
}
export type CreateBillingSessionMutationHookResult = ReturnType<
  typeof useCreateBillingSessionMutation
>;
export type CreateBillingSessionMutationResult =
  Apollo.MutationResult<CreateBillingSessionMutation>;
export type CreateBillingSessionMutationOptions = Apollo.BaseMutationOptions<
  CreateBillingSessionMutation,
  CreateBillingSessionMutationVariables
>;
export const CreateCaseDocument = gql`
  mutation CreateCase($input: CreateCaseInput!) {
    createCase(input: $input) {
      mrn
      ticketRefs {
        ticketId
      }
    }
  }
`;
export type CreateCaseMutationFn = Apollo.MutationFunction<
  CreateCaseMutation,
  CreateCaseMutationVariables
>;

/**
 * __useCreateCaseMutation__
 *
 * To run a mutation, you first call `useCreateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseMutation, { data, loading, error }] = useCreateCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCaseMutation,
    CreateCaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCaseMutation, CreateCaseMutationVariables>(
    CreateCaseDocument,
    options,
  );
}
export type CreateCaseMutationHookResult = ReturnType<
  typeof useCreateCaseMutation
>;
export type CreateCaseMutationResult =
  Apollo.MutationResult<CreateCaseMutation>;
export type CreateCaseMutationOptions = Apollo.BaseMutationOptions<
  CreateCaseMutation,
  CreateCaseMutationVariables
>;
export const CreateClientIntegrationDocument = gql`
  mutation CreateClientIntegration($input: CreateClientIntegrationInput!) {
    createClientIntegration(input: $input) {
      integration {
        mrn
        token
        name
        status
        created
        lastCheckin
        type
        messages {
          message
          status
        }
        configurationOptions {
          ... on K8sConfigurationOptions {
            scanNodes
            scanNodesStyle
            scanWorkloads
            scanDeploys
            certificateManager
            scanPublicImages
            namespaceAllowList
            namespaceDenyList
          }
          ... on AWSConfigurationOptions {
            region
            isOrganization
            snsEndpoint
            originAWSAccountId
            cloudFormationTemplateUrl
            cloudFormationQuickcreateUrl
            useWif
            scanConfiguration {
              accountScan
              ec2Scan
              ecrScan
              ecsScan
              cronScaninHours
              ec2ScanOptions {
                ebsVolumeScan
                instanceConnect
                instanceIdsFilter
                excludedInstanceIdsFilter
                regionsFilter
                excludedRegionsFilter
                ssm
                tagsFilter
                excludedTagsFilter
              }
              vpcConfiguration {
                CIDR
                vpcFlavour
                vpcTag {
                  key
                  value
                }
              }
            }
          }
          ... on HostedAwsConfigurationOptions {
            accessKeyId
            role
            wifAudience
            wifRoleArn
            wifSubject
          }
          ... on AgentOptions {
            id
            version
            notes
            platform {
              name
              release
              arch
              kind
              runtime
            }
            hostname
            ipaddress
          }
          ... on AzureConfigurationOptions {
            tenantId
            clientId
            subscriptionsWhitelist
            subscriptionsBlacklist
            scanVms
          }
          ... on Ms365ConfigurationOptions {
            tenantId
            clientId
          }
          ... on MicrosoftDefenderConfigurationOptions {
            tenantId
            clientId
            subscriptionsAllowlist
            subscriptionsDenylist
            secretType
            createAssets
            mondooEnrichment
          }
          ... on GcpConfigurationOptions {
            projectId
            organizationId
            discoverAll
            wifAudience
            wifServiceAccountEmail
            wifSubject
          }
          ... on OktaConfigurationOptions {
            organization
          }
          ... on GcsBucketConfigurationOptions {
            output
            bucket
          }
          ... on GitlabConfigurationOptions {
            group
            type
            discoverGroups
            discoverProjects
            discoverTerraform
            discoverK8sManifests
            baseUrl
          }
          ... on GithubConfigurationOptions {
            owner
            repository
            githubOrg: organization
            githubType: type
            reposAllowList
            reposDenyList
            githubDiscoverK8sManifests: discoverK8sManifests
            githubDiscoverTerraform: discoverTerraform
            enterpriseUrl
          }
          ... on GoogleWorkspaceConfigurationOptions {
            customerId
            impersonatedUserEmail
          }
          ... on SlackConfigurationOptions {
            placeholder
          }
          ... on PostgresConfigurationOptions {
            host
            port
            database
            user
          }
          ... on OciConfigurationOptions {
            tenancyOcid
            userOcid
            region
            fingerprint
          }
          ... on HostConfigurationOptions {
            discoverSubdomains
            host
            http
            https
          }
          ... on EmailConfigurationOptions {
            autoCreateTickets
            recipients {
              name
              email
              isDefault
              referenceUrl
            }
          }
          ... on ShodanConfigurationOptions {
            token
            targets
          }
          ... on ZendeskConfigurationOptions {
            subdomain
            email
            autoCloseTickets
            autoCreateTickets
            customFields {
              id
              value
            }
          }
          ... on SentinelOneConfigurationOptions {
            host
            account
            secretType
            createAssets
            mondooEnrichment
          }
          ... on CrowdstrikeFalconConfigurationOptions {
            clientId
            cloud
            memberCID
            createAssets
            mondooEnrichment
          }
          ... on SecurityPipelineGithubConfigurationOptions {
            appInstallationLink
            publicKey
            repositories {
              link
              fullName
              spaceMrn
            }
          }
          ... on WebhookConfigurationOptions {
            autoCreateTickets
            autoCloseTickets
            url
          }
          ... on ServiceNowConfigurationOptions {
            instanceUrl
            clientId
            autoCloseTickets
            autoCreateTickets
            userEmail
          }
        }
      }
    }
  }
`;
export type CreateClientIntegrationMutationFn = Apollo.MutationFunction<
  CreateClientIntegrationMutation,
  CreateClientIntegrationMutationVariables
>;

/**
 * __useCreateClientIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateClientIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientIntegrationMutation, { data, loading, error }] = useCreateClientIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClientIntegrationMutation,
    CreateClientIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateClientIntegrationMutation,
    CreateClientIntegrationMutationVariables
  >(CreateClientIntegrationDocument, options);
}
export type CreateClientIntegrationMutationHookResult = ReturnType<
  typeof useCreateClientIntegrationMutation
>;
export type CreateClientIntegrationMutationResult =
  Apollo.MutationResult<CreateClientIntegrationMutation>;
export type CreateClientIntegrationMutationOptions = Apollo.BaseMutationOptions<
  CreateClientIntegrationMutation,
  CreateClientIntegrationMutationVariables
>;
export const CreateExceptionDocument = gql`
  mutation CreateException($input: ExceptionMutationInput!) {
    createException(input: $input) {
      exceptionGroup {
        id
        exceptionId
      }
    }
  }
`;
export type CreateExceptionMutationFn = Apollo.MutationFunction<
  CreateExceptionMutation,
  CreateExceptionMutationVariables
>;

/**
 * __useCreateExceptionMutation__
 *
 * To run a mutation, you first call `useCreateExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExceptionMutation, { data, loading, error }] = useCreateExceptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExceptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExceptionMutation,
    CreateExceptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExceptionMutation,
    CreateExceptionMutationVariables
  >(CreateExceptionDocument, options);
}
export type CreateExceptionMutationHookResult = ReturnType<
  typeof useCreateExceptionMutation
>;
export type CreateExceptionMutationResult =
  Apollo.MutationResult<CreateExceptionMutation>;
export type CreateExceptionMutationOptions = Apollo.BaseMutationOptions<
  CreateExceptionMutation,
  CreateExceptionMutationVariables
>;
export const CreateExceptionForScopesDocument = gql`
  mutation CreateExceptionForScopes($input: ApplyExceptionForScopesInput!) {
    applyExceptionForScopes(input: $input)
  }
`;
export type CreateExceptionForScopesMutationFn = Apollo.MutationFunction<
  CreateExceptionForScopesMutation,
  CreateExceptionForScopesMutationVariables
>;

/**
 * __useCreateExceptionForScopesMutation__
 *
 * To run a mutation, you first call `useCreateExceptionForScopesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExceptionForScopesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExceptionForScopesMutation, { data, loading, error }] = useCreateExceptionForScopesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExceptionForScopesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExceptionForScopesMutation,
    CreateExceptionForScopesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExceptionForScopesMutation,
    CreateExceptionForScopesMutationVariables
  >(CreateExceptionForScopesDocument, options);
}
export type CreateExceptionForScopesMutationHookResult = ReturnType<
  typeof useCreateExceptionForScopesMutation
>;
export type CreateExceptionForScopesMutationResult =
  Apollo.MutationResult<CreateExceptionForScopesMutation>;
export type CreateExceptionForScopesMutationOptions =
  Apollo.BaseMutationOptions<
    CreateExceptionForScopesMutation,
    CreateExceptionForScopesMutationVariables
  >;
export const CreateInvitationDocument = gql`
  mutation CreateInvitation($input: CreateInvitationInput!) {
    createInvitation(input: $input) {
      mrn
    }
  }
`;
export type CreateInvitationMutationFn = Apollo.MutationFunction<
  CreateInvitationMutation,
  CreateInvitationMutationVariables
>;

/**
 * __useCreateInvitationMutation__
 *
 * To run a mutation, you first call `useCreateInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvitationMutation, { data, loading, error }] = useCreateInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInvitationMutation,
    CreateInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateInvitationMutation,
    CreateInvitationMutationVariables
  >(CreateInvitationDocument, options);
}
export type CreateInvitationMutationHookResult = ReturnType<
  typeof useCreateInvitationMutation
>;
export type CreateInvitationMutationResult =
  Apollo.MutationResult<CreateInvitationMutation>;
export type CreateInvitationMutationOptions = Apollo.BaseMutationOptions<
  CreateInvitationMutation,
  CreateInvitationMutationVariables
>;
export const CreateOrganizationDocument = gql`
  mutation CreateOrganization($input: CreateOrganizationInput!) {
    createOrganization(input: $input) {
      id
      mrn
    }
  }
`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrganizationMutation,
    CreateOrganizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOrganizationMutation,
    CreateOrganizationMutationVariables
  >(CreateOrganizationDocument, options);
}
export type CreateOrganizationMutationHookResult = ReturnType<
  typeof useCreateOrganizationMutation
>;
export type CreateOrganizationMutationResult =
  Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>;
export const CreateServiceAccountDocument = gql`
  mutation CreateServiceAccount($input: CreateServiceAccountInput!) {
    createServiceAccount(input: $input) {
      mrn
      certificate
      privateKey
      scopeMrn
      apiEndpoint
      spaceMrn
    }
  }
`;
export type CreateServiceAccountMutationFn = Apollo.MutationFunction<
  CreateServiceAccountMutation,
  CreateServiceAccountMutationVariables
>;

/**
 * __useCreateServiceAccountMutation__
 *
 * To run a mutation, you first call `useCreateServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceAccountMutation, { data, loading, error }] = useCreateServiceAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateServiceAccountMutation,
    CreateServiceAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateServiceAccountMutation,
    CreateServiceAccountMutationVariables
  >(CreateServiceAccountDocument, options);
}
export type CreateServiceAccountMutationHookResult = ReturnType<
  typeof useCreateServiceAccountMutation
>;
export type CreateServiceAccountMutationResult =
  Apollo.MutationResult<CreateServiceAccountMutation>;
export type CreateServiceAccountMutationOptions = Apollo.BaseMutationOptions<
  CreateServiceAccountMutation,
  CreateServiceAccountMutationVariables
>;
export const CreateSpaceDocument = gql`
  mutation CreateSpace($input: CreateSpaceInput!) {
    createSpace(input: $input) {
      id
      mrn
    }
  }
`;
export type CreateSpaceMutationFn = Apollo.MutationFunction<
  CreateSpaceMutation,
  CreateSpaceMutationVariables
>;

/**
 * __useCreateSpaceMutation__
 *
 * To run a mutation, you first call `useCreateSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpaceMutation, { data, loading, error }] = useCreateSpaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSpaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSpaceMutation,
    CreateSpaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateSpaceMutation, CreateSpaceMutationVariables>(
    CreateSpaceDocument,
    options,
  );
}
export type CreateSpaceMutationHookResult = ReturnType<
  typeof useCreateSpaceMutation
>;
export type CreateSpaceMutationResult =
  Apollo.MutationResult<CreateSpaceMutation>;
export type CreateSpaceMutationOptions = Apollo.BaseMutationOptions<
  CreateSpaceMutation,
  CreateSpaceMutationVariables
>;
export const CreateWorkspaceDocument = gql`
  mutation CreateWorkspace($input: CreateWorkspaceInput!) {
    createWorkspace(input: $input) {
      mrn
    }
  }
`;
export type CreateWorkspaceMutationFn = Apollo.MutationFunction<
  CreateWorkspaceMutation,
  CreateWorkspaceMutationVariables
>;

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkspaceMutation,
    CreateWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkspaceMutation,
    CreateWorkspaceMutationVariables
  >(CreateWorkspaceDocument, options);
}
export type CreateWorkspaceMutationHookResult = ReturnType<
  typeof useCreateWorkspaceMutation
>;
export type CreateWorkspaceMutationResult =
  Apollo.MutationResult<CreateWorkspaceMutation>;
export type CreateWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkspaceMutation,
  CreateWorkspaceMutationVariables
>;
export const DeclineInvitationDocument = gql`
  mutation DeclineInvitation($invitationMrn: ID!) {
    declineInvitation(invitationMrn: $invitationMrn)
  }
`;
export type DeclineInvitationMutationFn = Apollo.MutationFunction<
  DeclineInvitationMutation,
  DeclineInvitationMutationVariables
>;

/**
 * __useDeclineInvitationMutation__
 *
 * To run a mutation, you first call `useDeclineInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineInvitationMutation, { data, loading, error }] = useDeclineInvitationMutation({
 *   variables: {
 *      invitationMrn: // value for 'invitationMrn'
 *   },
 * });
 */
export function useDeclineInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeclineInvitationMutation,
    DeclineInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeclineInvitationMutation,
    DeclineInvitationMutationVariables
  >(DeclineInvitationDocument, options);
}
export type DeclineInvitationMutationHookResult = ReturnType<
  typeof useDeclineInvitationMutation
>;
export type DeclineInvitationMutationResult =
  Apollo.MutationResult<DeclineInvitationMutation>;
export type DeclineInvitationMutationOptions = Apollo.BaseMutationOptions<
  DeclineInvitationMutation,
  DeclineInvitationMutationVariables
>;
export const DeleteAgentsDocument = gql`
  mutation DeleteAgents($input: DeleteAgentsInput!) {
    deleteAgents(input: $input) {
      agentMrns
      errors
    }
  }
`;
export type DeleteAgentsMutationFn = Apollo.MutationFunction<
  DeleteAgentsMutation,
  DeleteAgentsMutationVariables
>;

/**
 * __useDeleteAgentsMutation__
 *
 * To run a mutation, you first call `useDeleteAgentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentsMutation, { data, loading, error }] = useDeleteAgentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAgentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAgentsMutation,
    DeleteAgentsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAgentsMutation,
    DeleteAgentsMutationVariables
  >(DeleteAgentsDocument, options);
}
export type DeleteAgentsMutationHookResult = ReturnType<
  typeof useDeleteAgentsMutation
>;
export type DeleteAgentsMutationResult =
  Apollo.MutationResult<DeleteAgentsMutation>;
export type DeleteAgentsMutationOptions = Apollo.BaseMutationOptions<
  DeleteAgentsMutation,
  DeleteAgentsMutationVariables
>;
export const DeleteApiTokenDocument = gql`
  mutation DeleteAPIToken($input: DeleteAPITokenInput!) {
    deleteAPIToken(input: $input) {
      ok
    }
  }
`;
export type DeleteApiTokenMutationFn = Apollo.MutationFunction<
  DeleteApiTokenMutation,
  DeleteApiTokenMutationVariables
>;

/**
 * __useDeleteApiTokenMutation__
 *
 * To run a mutation, you first call `useDeleteApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiTokenMutation, { data, loading, error }] = useDeleteApiTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteApiTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteApiTokenMutation,
    DeleteApiTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteApiTokenMutation,
    DeleteApiTokenMutationVariables
  >(DeleteApiTokenDocument, options);
}
export type DeleteApiTokenMutationHookResult = ReturnType<
  typeof useDeleteApiTokenMutation
>;
export type DeleteApiTokenMutationResult =
  Apollo.MutationResult<DeleteApiTokenMutation>;
export type DeleteApiTokenMutationOptions = Apollo.BaseMutationOptions<
  DeleteApiTokenMutation,
  DeleteApiTokenMutationVariables
>;
export const DeleteAssetsDocument = gql`
  mutation DeleteAssets($input: DeleteAssetsInput!) {
    deleteAssets(input: $input) {
      assetMrns
      errors
    }
  }
`;
export type DeleteAssetsMutationFn = Apollo.MutationFunction<
  DeleteAssetsMutation,
  DeleteAssetsMutationVariables
>;

/**
 * __useDeleteAssetsMutation__
 *
 * To run a mutation, you first call `useDeleteAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetsMutation, { data, loading, error }] = useDeleteAssetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAssetsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAssetsMutation,
    DeleteAssetsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAssetsMutation,
    DeleteAssetsMutationVariables
  >(DeleteAssetsDocument, options);
}
export type DeleteAssetsMutationHookResult = ReturnType<
  typeof useDeleteAssetsMutation
>;
export type DeleteAssetsMutationResult =
  Apollo.MutationResult<DeleteAssetsMutation>;
export type DeleteAssetsMutationOptions = Apollo.BaseMutationOptions<
  DeleteAssetsMutation,
  DeleteAssetsMutationVariables
>;
export const DeleteCicdProjectsDocument = gql`
  mutation DeleteCicdProjects($input: DeleteProjectsInput!) {
    deleteCicdProjects(input: $input) {
      mrns
    }
  }
`;
export type DeleteCicdProjectsMutationFn = Apollo.MutationFunction<
  DeleteCicdProjectsMutation,
  DeleteCicdProjectsMutationVariables
>;

/**
 * __useDeleteCicdProjectsMutation__
 *
 * To run a mutation, you first call `useDeleteCicdProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCicdProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCicdProjectsMutation, { data, loading, error }] = useDeleteCicdProjectsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCicdProjectsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCicdProjectsMutation,
    DeleteCicdProjectsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCicdProjectsMutation,
    DeleteCicdProjectsMutationVariables
  >(DeleteCicdProjectsDocument, options);
}
export type DeleteCicdProjectsMutationHookResult = ReturnType<
  typeof useDeleteCicdProjectsMutation
>;
export type DeleteCicdProjectsMutationResult =
  Apollo.MutationResult<DeleteCicdProjectsMutation>;
export type DeleteCicdProjectsMutationOptions = Apollo.BaseMutationOptions<
  DeleteCicdProjectsMutation,
  DeleteCicdProjectsMutationVariables
>;
export const DeleteClientIntegrationDocument = gql`
  mutation DeleteClientIntegration($input: DeleteClientIntegrationInput!) {
    deleteClientIntegration(input: $input) {
      mrn
    }
  }
`;
export type DeleteClientIntegrationMutationFn = Apollo.MutationFunction<
  DeleteClientIntegrationMutation,
  DeleteClientIntegrationMutationVariables
>;

/**
 * __useDeleteClientIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteClientIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientIntegrationMutation, { data, loading, error }] = useDeleteClientIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteClientIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteClientIntegrationMutation,
    DeleteClientIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteClientIntegrationMutation,
    DeleteClientIntegrationMutationVariables
  >(DeleteClientIntegrationDocument, options);
}
export type DeleteClientIntegrationMutationHookResult = ReturnType<
  typeof useDeleteClientIntegrationMutation
>;
export type DeleteClientIntegrationMutationResult =
  Apollo.MutationResult<DeleteClientIntegrationMutation>;
export type DeleteClientIntegrationMutationOptions = Apollo.BaseMutationOptions<
  DeleteClientIntegrationMutation,
  DeleteClientIntegrationMutationVariables
>;
export const DeleteCustomPolicyDocument = gql`
  mutation DeleteCustomPolicy($input: DeleteCustomPolicyInput!) {
    deleteCustomPolicy(input: $input) {
      policyMrn
    }
  }
`;
export type DeleteCustomPolicyMutationFn = Apollo.MutationFunction<
  DeleteCustomPolicyMutation,
  DeleteCustomPolicyMutationVariables
>;

/**
 * __useDeleteCustomPolicyMutation__
 *
 * To run a mutation, you first call `useDeleteCustomPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomPolicyMutation, { data, loading, error }] = useDeleteCustomPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomPolicyMutation,
    DeleteCustomPolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCustomPolicyMutation,
    DeleteCustomPolicyMutationVariables
  >(DeleteCustomPolicyDocument, options);
}
export type DeleteCustomPolicyMutationHookResult = ReturnType<
  typeof useDeleteCustomPolicyMutation
>;
export type DeleteCustomPolicyMutationResult =
  Apollo.MutationResult<DeleteCustomPolicyMutation>;
export type DeleteCustomPolicyMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomPolicyMutation,
  DeleteCustomPolicyMutationVariables
>;
export const DeleteCustomQueryPackDocument = gql`
  mutation DeleteCustomQueryPack($input: DeleteCustomQueryPackInput!) {
    deleteCustomQueryPack(input: $input) {
      queryPackMrn
    }
  }
`;
export type DeleteCustomQueryPackMutationFn = Apollo.MutationFunction<
  DeleteCustomQueryPackMutation,
  DeleteCustomQueryPackMutationVariables
>;

/**
 * __useDeleteCustomQueryPackMutation__
 *
 * To run a mutation, you first call `useDeleteCustomQueryPackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomQueryPackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomQueryPackMutation, { data, loading, error }] = useDeleteCustomQueryPackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomQueryPackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomQueryPackMutation,
    DeleteCustomQueryPackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCustomQueryPackMutation,
    DeleteCustomQueryPackMutationVariables
  >(DeleteCustomQueryPackDocument, options);
}
export type DeleteCustomQueryPackMutationHookResult = ReturnType<
  typeof useDeleteCustomQueryPackMutation
>;
export type DeleteCustomQueryPackMutationResult =
  Apollo.MutationResult<DeleteCustomQueryPackMutation>;
export type DeleteCustomQueryPackMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomQueryPackMutation,
  DeleteCustomQueryPackMutationVariables
>;
export const DeleteDocumentDocument = gql`
  mutation DeleteDocument($documentMrn: String!) {
    deleteDocument(documentMRN: $documentMrn)
  }
`;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      documentMrn: // value for 'documentMrn'
 *   },
 * });
 */
export function useDeleteDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDocumentMutation,
    DeleteDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDocumentMutation,
    DeleteDocumentMutationVariables
  >(DeleteDocumentDocument, options);
}
export type DeleteDocumentMutationHookResult = ReturnType<
  typeof useDeleteDocumentMutation
>;
export type DeleteDocumentMutationResult =
  Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>;
export const DeleteExceptionsDocument = gql`
  mutation DeleteExceptions($input: ExceptionsDeleteInput!) {
    deleteExceptions(input: $input)
  }
`;
export type DeleteExceptionsMutationFn = Apollo.MutationFunction<
  DeleteExceptionsMutation,
  DeleteExceptionsMutationVariables
>;

/**
 * __useDeleteExceptionsMutation__
 *
 * To run a mutation, you first call `useDeleteExceptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExceptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExceptionsMutation, { data, loading, error }] = useDeleteExceptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteExceptionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteExceptionsMutation,
    DeleteExceptionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteExceptionsMutation,
    DeleteExceptionsMutationVariables
  >(DeleteExceptionsDocument, options);
}
export type DeleteExceptionsMutationHookResult = ReturnType<
  typeof useDeleteExceptionsMutation
>;
export type DeleteExceptionsMutationResult =
  Apollo.MutationResult<DeleteExceptionsMutation>;
export type DeleteExceptionsMutationOptions = Apollo.BaseMutationOptions<
  DeleteExceptionsMutation,
  DeleteExceptionsMutationVariables
>;
export const DeleteFrameworkDocument = gql`
  mutation DeleteFramework($input: DeleteFrameworkInput!) {
    deleteFramework(input: $input)
  }
`;
export type DeleteFrameworkMutationFn = Apollo.MutationFunction<
  DeleteFrameworkMutation,
  DeleteFrameworkMutationVariables
>;

/**
 * __useDeleteFrameworkMutation__
 *
 * To run a mutation, you first call `useDeleteFrameworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFrameworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFrameworkMutation, { data, loading, error }] = useDeleteFrameworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFrameworkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFrameworkMutation,
    DeleteFrameworkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFrameworkMutation,
    DeleteFrameworkMutationVariables
  >(DeleteFrameworkDocument, options);
}
export type DeleteFrameworkMutationHookResult = ReturnType<
  typeof useDeleteFrameworkMutation
>;
export type DeleteFrameworkMutationResult =
  Apollo.MutationResult<DeleteFrameworkMutation>;
export type DeleteFrameworkMutationOptions = Apollo.BaseMutationOptions<
  DeleteFrameworkMutation,
  DeleteFrameworkMutationVariables
>;
export const DeleteOrganizationDocument = gql`
  mutation DeleteOrganization($orgMrn: ID!) {
    deleteOrganization(orgMrn: $orgMrn)
  }
`;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<
  DeleteOrganizationMutation,
  DeleteOrganizationMutationVariables
>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      orgMrn: // value for 'orgMrn'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteOrganizationMutation,
    DeleteOrganizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteOrganizationMutation,
    DeleteOrganizationMutationVariables
  >(DeleteOrganizationDocument, options);
}
export type DeleteOrganizationMutationHookResult = ReturnType<
  typeof useDeleteOrganizationMutation
>;
export type DeleteOrganizationMutationResult =
  Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<
  DeleteOrganizationMutation,
  DeleteOrganizationMutationVariables
>;
export const DeletePolicyDocument = gql`
  mutation DeletePolicy($input: PolicyDeleteInput!) {
    deletePolicy(input: $input)
  }
`;
export type DeletePolicyMutationFn = Apollo.MutationFunction<
  DeletePolicyMutation,
  DeletePolicyMutationVariables
>;

/**
 * __useDeletePolicyMutation__
 *
 * To run a mutation, you first call `useDeletePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePolicyMutation, { data, loading, error }] = useDeletePolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePolicyMutation,
    DeletePolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePolicyMutation,
    DeletePolicyMutationVariables
  >(DeletePolicyDocument, options);
}
export type DeletePolicyMutationHookResult = ReturnType<
  typeof useDeletePolicyMutation
>;
export type DeletePolicyMutationResult =
  Apollo.MutationResult<DeletePolicyMutation>;
export type DeletePolicyMutationOptions = Apollo.BaseMutationOptions<
  DeletePolicyMutation,
  DeletePolicyMutationVariables
>;
export const DeleteServiceAccountsDocument = gql`
  mutation DeleteServiceAccounts($input: DeleteServiceAccountsInput!) {
    deleteServiceAccounts(input: $input) {
      mrns
      errors
    }
  }
`;
export type DeleteServiceAccountsMutationFn = Apollo.MutationFunction<
  DeleteServiceAccountsMutation,
  DeleteServiceAccountsMutationVariables
>;

/**
 * __useDeleteServiceAccountsMutation__
 *
 * To run a mutation, you first call `useDeleteServiceAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceAccountsMutation, { data, loading, error }] = useDeleteServiceAccountsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteServiceAccountsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteServiceAccountsMutation,
    DeleteServiceAccountsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteServiceAccountsMutation,
    DeleteServiceAccountsMutationVariables
  >(DeleteServiceAccountsDocument, options);
}
export type DeleteServiceAccountsMutationHookResult = ReturnType<
  typeof useDeleteServiceAccountsMutation
>;
export type DeleteServiceAccountsMutationResult =
  Apollo.MutationResult<DeleteServiceAccountsMutation>;
export type DeleteServiceAccountsMutationOptions = Apollo.BaseMutationOptions<
  DeleteServiceAccountsMutation,
  DeleteServiceAccountsMutationVariables
>;
export const DeleteSpaceDocument = gql`
  mutation DeleteSpace($spaceMrn: ID!) {
    deleteSpace(spaceMrn: $spaceMrn)
  }
`;
export type DeleteSpaceMutationFn = Apollo.MutationFunction<
  DeleteSpaceMutation,
  DeleteSpaceMutationVariables
>;

/**
 * __useDeleteSpaceMutation__
 *
 * To run a mutation, you first call `useDeleteSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpaceMutation, { data, loading, error }] = useDeleteSpaceMutation({
 *   variables: {
 *      spaceMrn: // value for 'spaceMrn'
 *   },
 * });
 */
export function useDeleteSpaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSpaceMutation,
    DeleteSpaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteSpaceMutation, DeleteSpaceMutationVariables>(
    DeleteSpaceDocument,
    options,
  );
}
export type DeleteSpaceMutationHookResult = ReturnType<
  typeof useDeleteSpaceMutation
>;
export type DeleteSpaceMutationResult =
  Apollo.MutationResult<DeleteSpaceMutation>;
export type DeleteSpaceMutationOptions = Apollo.BaseMutationOptions<
  DeleteSpaceMutation,
  DeleteSpaceMutationVariables
>;
export const DeleteWorkspacesDocument = gql`
  mutation DeleteWorkspaces($input: DeleteWorkspacesInput!) {
    deleteWorkspaces(input: $input)
  }
`;
export type DeleteWorkspacesMutationFn = Apollo.MutationFunction<
  DeleteWorkspacesMutation,
  DeleteWorkspacesMutationVariables
>;

/**
 * __useDeleteWorkspacesMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspacesMutation, { data, loading, error }] = useDeleteWorkspacesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorkspacesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorkspacesMutation,
    DeleteWorkspacesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteWorkspacesMutation,
    DeleteWorkspacesMutationVariables
  >(DeleteWorkspacesDocument, options);
}
export type DeleteWorkspacesMutationHookResult = ReturnType<
  typeof useDeleteWorkspacesMutation
>;
export type DeleteWorkspacesMutationResult =
  Apollo.MutationResult<DeleteWorkspacesMutation>;
export type DeleteWorkspacesMutationOptions = Apollo.BaseMutationOptions<
  DeleteWorkspacesMutation,
  DeleteWorkspacesMutationVariables
>;
export const EditPropertiesDocument = gql`
  mutation EditProperties($input: PropertyQueryMutationInput!) {
    applyPropertyQueryMutation(input: $input) {
      ... on PropertyQueryMutationInvalidTarget {
        message
        code
      }
      ... on PropertyQueryMutationInvalidProperty {
        message
        code
      }
      ... on PropertyQueryMutationSuccess {
        success
      }
    }
  }
`;
export type EditPropertiesMutationFn = Apollo.MutationFunction<
  EditPropertiesMutation,
  EditPropertiesMutationVariables
>;

/**
 * __useEditPropertiesMutation__
 *
 * To run a mutation, you first call `useEditPropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPropertiesMutation, { data, loading, error }] = useEditPropertiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPropertiesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditPropertiesMutation,
    EditPropertiesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditPropertiesMutation,
    EditPropertiesMutationVariables
  >(EditPropertiesDocument, options);
}
export type EditPropertiesMutationHookResult = ReturnType<
  typeof useEditPropertiesMutation
>;
export type EditPropertiesMutationResult =
  Apollo.MutationResult<EditPropertiesMutation>;
export type EditPropertiesMutationOptions = Apollo.BaseMutationOptions<
  EditPropertiesMutation,
  EditPropertiesMutationVariables
>;
export const EnableSsoProviderDocument = gql`
  mutation EnableSSOProvider($input: EnableSSOProviderInput!) {
    enableSSOProvider(input: $input)
  }
`;
export type EnableSsoProviderMutationFn = Apollo.MutationFunction<
  EnableSsoProviderMutation,
  EnableSsoProviderMutationVariables
>;

/**
 * __useEnableSsoProviderMutation__
 *
 * To run a mutation, you first call `useEnableSsoProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableSsoProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableSsoProviderMutation, { data, loading, error }] = useEnableSsoProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableSsoProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnableSsoProviderMutation,
    EnableSsoProviderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EnableSsoProviderMutation,
    EnableSsoProviderMutationVariables
  >(EnableSsoProviderDocument, options);
}
export type EnableSsoProviderMutationHookResult = ReturnType<
  typeof useEnableSsoProviderMutation
>;
export type EnableSsoProviderMutationResult =
  Apollo.MutationResult<EnableSsoProviderMutation>;
export type EnableSsoProviderMutationOptions = Apollo.BaseMutationOptions<
  EnableSsoProviderMutation,
  EnableSsoProviderMutationVariables
>;
export const ExtendExceptionDocument = gql`
  mutation ExtendException($input: ExtendExceptionInput!) {
    extendException(input: $input)
  }
`;
export type ExtendExceptionMutationFn = Apollo.MutationFunction<
  ExtendExceptionMutation,
  ExtendExceptionMutationVariables
>;

/**
 * __useExtendExceptionMutation__
 *
 * To run a mutation, you first call `useExtendExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendExceptionMutation, { data, loading, error }] = useExtendExceptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtendExceptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExtendExceptionMutation,
    ExtendExceptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExtendExceptionMutation,
    ExtendExceptionMutationVariables
  >(ExtendExceptionDocument, options);
}
export type ExtendExceptionMutationHookResult = ReturnType<
  typeof useExtendExceptionMutation
>;
export type ExtendExceptionMutationResult =
  Apollo.MutationResult<ExtendExceptionMutation>;
export type ExtendExceptionMutationOptions = Apollo.BaseMutationOptions<
  ExtendExceptionMutation,
  ExtendExceptionMutationVariables
>;
export const GenerateApiTokenDocument = gql`
  mutation GenerateAPIToken($input: GenerateAPITokenInput!) {
    generateAPIToken(input: $input) {
      token
      spaceMrn
      scopeMrn
      name
      mrn
      description
      createdBy
      createdAt
    }
  }
`;
export type GenerateApiTokenMutationFn = Apollo.MutationFunction<
  GenerateApiTokenMutation,
  GenerateApiTokenMutationVariables
>;

/**
 * __useGenerateApiTokenMutation__
 *
 * To run a mutation, you first call `useGenerateApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateApiTokenMutation, { data, loading, error }] = useGenerateApiTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateApiTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateApiTokenMutation,
    GenerateApiTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateApiTokenMutation,
    GenerateApiTokenMutationVariables
  >(GenerateApiTokenDocument, options);
}
export type GenerateApiTokenMutationHookResult = ReturnType<
  typeof useGenerateApiTokenMutation
>;
export type GenerateApiTokenMutationResult =
  Apollo.MutationResult<GenerateApiTokenMutation>;
export type GenerateApiTokenMutationOptions = Apollo.BaseMutationOptions<
  GenerateApiTokenMutation,
  GenerateApiTokenMutationVariables
>;
export const GenerateDocumentDocument = gql`
  mutation GenerateDocument($input: GenerateDocumentInput!) {
    generateDocument(input: $input) {
      mrn
    }
  }
`;
export type GenerateDocumentMutationFn = Apollo.MutationFunction<
  GenerateDocumentMutation,
  GenerateDocumentMutationVariables
>;

/**
 * __useGenerateDocumentMutation__
 *
 * To run a mutation, you first call `useGenerateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDocumentMutation, { data, loading, error }] = useGenerateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateDocumentMutation,
    GenerateDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateDocumentMutation,
    GenerateDocumentMutationVariables
  >(GenerateDocumentDocument, options);
}
export type GenerateDocumentMutationHookResult = ReturnType<
  typeof useGenerateDocumentMutation
>;
export type GenerateDocumentMutationResult =
  Apollo.MutationResult<GenerateDocumentMutation>;
export type GenerateDocumentMutationOptions = Apollo.BaseMutationOptions<
  GenerateDocumentMutation,
  GenerateDocumentMutationVariables
>;
export const GenerateRegistrationTokenDocument = gql`
  mutation GenerateRegistrationToken($input: RegistrationTokenInput!) {
    generateRegistrationToken(input: $input) {
      id
      mrn
      description
      labels {
        key
        value
      }
      token
      revoked
      createdAt
      createdBy
      expiresAt
    }
  }
`;
export type GenerateRegistrationTokenMutationFn = Apollo.MutationFunction<
  GenerateRegistrationTokenMutation,
  GenerateRegistrationTokenMutationVariables
>;

/**
 * __useGenerateRegistrationTokenMutation__
 *
 * To run a mutation, you first call `useGenerateRegistrationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRegistrationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRegistrationTokenMutation, { data, loading, error }] = useGenerateRegistrationTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateRegistrationTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateRegistrationTokenMutation,
    GenerateRegistrationTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateRegistrationTokenMutation,
    GenerateRegistrationTokenMutationVariables
  >(GenerateRegistrationTokenDocument, options);
}
export type GenerateRegistrationTokenMutationHookResult = ReturnType<
  typeof useGenerateRegistrationTokenMutation
>;
export type GenerateRegistrationTokenMutationResult =
  Apollo.MutationResult<GenerateRegistrationTokenMutation>;
export type GenerateRegistrationTokenMutationOptions =
  Apollo.BaseMutationOptions<
    GenerateRegistrationTokenMutation,
    GenerateRegistrationTokenMutationVariables
  >;
export const ModifySpaceRiskFactorsDocument = gql`
  mutation ModifySpaceRiskFactors(
    $spaceMrn: String!
    $riskFactors: [ModifyRiskFactorInput!]!
  ) {
    modifyRiskFactors(spaceMrn: $spaceMrn, riskFactors: $riskFactors)
  }
`;
export type ModifySpaceRiskFactorsMutationFn = Apollo.MutationFunction<
  ModifySpaceRiskFactorsMutation,
  ModifySpaceRiskFactorsMutationVariables
>;

/**
 * __useModifySpaceRiskFactorsMutation__
 *
 * To run a mutation, you first call `useModifySpaceRiskFactorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifySpaceRiskFactorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifySpaceRiskFactorsMutation, { data, loading, error }] = useModifySpaceRiskFactorsMutation({
 *   variables: {
 *      spaceMrn: // value for 'spaceMrn'
 *      riskFactors: // value for 'riskFactors'
 *   },
 * });
 */
export function useModifySpaceRiskFactorsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ModifySpaceRiskFactorsMutation,
    ModifySpaceRiskFactorsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ModifySpaceRiskFactorsMutation,
    ModifySpaceRiskFactorsMutationVariables
  >(ModifySpaceRiskFactorsDocument, options);
}
export type ModifySpaceRiskFactorsMutationHookResult = ReturnType<
  typeof useModifySpaceRiskFactorsMutation
>;
export type ModifySpaceRiskFactorsMutationResult =
  Apollo.MutationResult<ModifySpaceRiskFactorsMutation>;
export type ModifySpaceRiskFactorsMutationOptions = Apollo.BaseMutationOptions<
  ModifySpaceRiskFactorsMutation,
  ModifySpaceRiskFactorsMutationVariables
>;
export const ProcessCaseEventsDocument = gql`
  mutation ProcessCaseEvents($input: ProcessCaseEventsInput!) {
    processCaseEvents(input: $input)
  }
`;
export type ProcessCaseEventsMutationFn = Apollo.MutationFunction<
  ProcessCaseEventsMutation,
  ProcessCaseEventsMutationVariables
>;

/**
 * __useProcessCaseEventsMutation__
 *
 * To run a mutation, you first call `useProcessCaseEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessCaseEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processCaseEventsMutation, { data, loading, error }] = useProcessCaseEventsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessCaseEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProcessCaseEventsMutation,
    ProcessCaseEventsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ProcessCaseEventsMutation,
    ProcessCaseEventsMutationVariables
  >(ProcessCaseEventsDocument, options);
}
export type ProcessCaseEventsMutationHookResult = ReturnType<
  typeof useProcessCaseEventsMutation
>;
export type ProcessCaseEventsMutationResult =
  Apollo.MutationResult<ProcessCaseEventsMutation>;
export type ProcessCaseEventsMutationOptions = Apollo.BaseMutationOptions<
  ProcessCaseEventsMutation,
  ProcessCaseEventsMutationVariables
>;
export const RefreshAggregateScoresDocument = gql`
  mutation RefreshAggregateScores($groupMrn: String!) {
    refreshAggregateScores(groupMrn: $groupMrn)
  }
`;
export type RefreshAggregateScoresMutationFn = Apollo.MutationFunction<
  RefreshAggregateScoresMutation,
  RefreshAggregateScoresMutationVariables
>;

/**
 * __useRefreshAggregateScoresMutation__
 *
 * To run a mutation, you first call `useRefreshAggregateScoresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAggregateScoresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAggregateScoresMutation, { data, loading, error }] = useRefreshAggregateScoresMutation({
 *   variables: {
 *      groupMrn: // value for 'groupMrn'
 *   },
 * });
 */
export function useRefreshAggregateScoresMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshAggregateScoresMutation,
    RefreshAggregateScoresMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RefreshAggregateScoresMutation,
    RefreshAggregateScoresMutationVariables
  >(RefreshAggregateScoresDocument, options);
}
export type RefreshAggregateScoresMutationHookResult = ReturnType<
  typeof useRefreshAggregateScoresMutation
>;
export type RefreshAggregateScoresMutationResult =
  Apollo.MutationResult<RefreshAggregateScoresMutation>;
export type RefreshAggregateScoresMutationOptions = Apollo.BaseMutationOptions<
  RefreshAggregateScoresMutation,
  RefreshAggregateScoresMutationVariables
>;
export const RegisterUserActionDocument = gql`
  mutation RegisterUserAction($input: RegisterUserActionInput!) {
    registerUserAction(input: $input)
  }
`;
export type RegisterUserActionMutationFn = Apollo.MutationFunction<
  RegisterUserActionMutation,
  RegisterUserActionMutationVariables
>;

/**
 * __useRegisterUserActionMutation__
 *
 * To run a mutation, you first call `useRegisterUserActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserActionMutation, { data, loading, error }] = useRegisterUserActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterUserActionMutation,
    RegisterUserActionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterUserActionMutation,
    RegisterUserActionMutationVariables
  >(RegisterUserActionDocument, options);
}
export type RegisterUserActionMutationHookResult = ReturnType<
  typeof useRegisterUserActionMutation
>;
export type RegisterUserActionMutationResult =
  Apollo.MutationResult<RegisterUserActionMutation>;
export type RegisterUserActionMutationOptions = Apollo.BaseMutationOptions<
  RegisterUserActionMutation,
  RegisterUserActionMutationVariables
>;
export const RemoveOrganizationMembershipDocument = gql`
  mutation RemoveOrganizationMembership(
    $input: RemoveOrganizationMembershipInput!
  ) {
    removeOrganizationMembership(input: $input)
  }
`;
export type RemoveOrganizationMembershipMutationFn = Apollo.MutationFunction<
  RemoveOrganizationMembershipMutation,
  RemoveOrganizationMembershipMutationVariables
>;

/**
 * __useRemoveOrganizationMembershipMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizationMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizationMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizationMembershipMutation, { data, loading, error }] = useRemoveOrganizationMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveOrganizationMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveOrganizationMembershipMutation,
    RemoveOrganizationMembershipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveOrganizationMembershipMutation,
    RemoveOrganizationMembershipMutationVariables
  >(RemoveOrganizationMembershipDocument, options);
}
export type RemoveOrganizationMembershipMutationHookResult = ReturnType<
  typeof useRemoveOrganizationMembershipMutation
>;
export type RemoveOrganizationMembershipMutationResult =
  Apollo.MutationResult<RemoveOrganizationMembershipMutation>;
export type RemoveOrganizationMembershipMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveOrganizationMembershipMutation,
    RemoveOrganizationMembershipMutationVariables
  >;
export const RemoveSpaceMembershipDocument = gql`
  mutation RemoveSpaceMembership($input: RemoveSpaceMembershipInput!) {
    removeSpaceMembership(input: $input)
  }
`;
export type RemoveSpaceMembershipMutationFn = Apollo.MutationFunction<
  RemoveSpaceMembershipMutation,
  RemoveSpaceMembershipMutationVariables
>;

/**
 * __useRemoveSpaceMembershipMutation__
 *
 * To run a mutation, you first call `useRemoveSpaceMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSpaceMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSpaceMembershipMutation, { data, loading, error }] = useRemoveSpaceMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSpaceMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSpaceMembershipMutation,
    RemoveSpaceMembershipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveSpaceMembershipMutation,
    RemoveSpaceMembershipMutationVariables
  >(RemoveSpaceMembershipDocument, options);
}
export type RemoveSpaceMembershipMutationHookResult = ReturnType<
  typeof useRemoveSpaceMembershipMutation
>;
export type RemoveSpaceMembershipMutationResult =
  Apollo.MutationResult<RemoveSpaceMembershipMutation>;
export type RemoveSpaceMembershipMutationOptions = Apollo.BaseMutationOptions<
  RemoveSpaceMembershipMutation,
  RemoveSpaceMembershipMutationVariables
>;
export const RequestDocumentDownloadUrlDocument = gql`
  mutation RequestDocumentDownloadUrl($documentMrn: String!) {
    requestDocumentDownloadUrl(documentMRN: $documentMrn) {
      downloadUrl
      expiresAt
    }
  }
`;
export type RequestDocumentDownloadUrlMutationFn = Apollo.MutationFunction<
  RequestDocumentDownloadUrlMutation,
  RequestDocumentDownloadUrlMutationVariables
>;

/**
 * __useRequestDocumentDownloadUrlMutation__
 *
 * To run a mutation, you first call `useRequestDocumentDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDocumentDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDocumentDownloadUrlMutation, { data, loading, error }] = useRequestDocumentDownloadUrlMutation({
 *   variables: {
 *      documentMrn: // value for 'documentMrn'
 *   },
 * });
 */
export function useRequestDocumentDownloadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestDocumentDownloadUrlMutation,
    RequestDocumentDownloadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestDocumentDownloadUrlMutation,
    RequestDocumentDownloadUrlMutationVariables
  >(RequestDocumentDownloadUrlDocument, options);
}
export type RequestDocumentDownloadUrlMutationHookResult = ReturnType<
  typeof useRequestDocumentDownloadUrlMutation
>;
export type RequestDocumentDownloadUrlMutationResult =
  Apollo.MutationResult<RequestDocumentDownloadUrlMutation>;
export type RequestDocumentDownloadUrlMutationOptions =
  Apollo.BaseMutationOptions<
    RequestDocumentDownloadUrlMutation,
    RequestDocumentDownloadUrlMutationVariables
  >;
export const ResendInvitationDocument = gql`
  mutation ResendInvitation($invitationMrn: ID!) {
    resendInvitation(invitationMrn: $invitationMrn)
  }
`;
export type ResendInvitationMutationFn = Apollo.MutationFunction<
  ResendInvitationMutation,
  ResendInvitationMutationVariables
>;

/**
 * __useResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitationMutation({
 *   variables: {
 *      invitationMrn: // value for 'invitationMrn'
 *   },
 * });
 */
export function useResendInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendInvitationMutation,
    ResendInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendInvitationMutation,
    ResendInvitationMutationVariables
  >(ResendInvitationDocument, options);
}
export type ResendInvitationMutationHookResult = ReturnType<
  typeof useResendInvitationMutation
>;
export type ResendInvitationMutationResult =
  Apollo.MutationResult<ResendInvitationMutation>;
export type ResendInvitationMutationOptions = Apollo.BaseMutationOptions<
  ResendInvitationMutation,
  ResendInvitationMutationVariables
>;
export const RevokeRegistrationTokenDocument = gql`
  mutation RevokeRegistrationToken($input: RevokeRegistrationTokenInput!) {
    revokeRegistrationToken(input: $input) {
      ... on RevokeRegistrationTokenSuccess {
        ok
      }
      ... on RevokeRegistrationTokenFailure {
        message
        code
      }
    }
  }
`;
export type RevokeRegistrationTokenMutationFn = Apollo.MutationFunction<
  RevokeRegistrationTokenMutation,
  RevokeRegistrationTokenMutationVariables
>;

/**
 * __useRevokeRegistrationTokenMutation__
 *
 * To run a mutation, you first call `useRevokeRegistrationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeRegistrationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeRegistrationTokenMutation, { data, loading, error }] = useRevokeRegistrationTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeRegistrationTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeRegistrationTokenMutation,
    RevokeRegistrationTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeRegistrationTokenMutation,
    RevokeRegistrationTokenMutationVariables
  >(RevokeRegistrationTokenDocument, options);
}
export type RevokeRegistrationTokenMutationHookResult = ReturnType<
  typeof useRevokeRegistrationTokenMutation
>;
export type RevokeRegistrationTokenMutationResult =
  Apollo.MutationResult<RevokeRegistrationTokenMutation>;
export type RevokeRegistrationTokenMutationOptions = Apollo.BaseMutationOptions<
  RevokeRegistrationTokenMutation,
  RevokeRegistrationTokenMutationVariables
>;
export const SetAssetAnnotationsDocument = gql`
  mutation SetAssetAnnotations($input: SetAssetAnnotationsInput!) {
    setAssetAnnotations(input: $input) {
      annotations {
        key
        value
      }
    }
  }
`;
export type SetAssetAnnotationsMutationFn = Apollo.MutationFunction<
  SetAssetAnnotationsMutation,
  SetAssetAnnotationsMutationVariables
>;

/**
 * __useSetAssetAnnotationsMutation__
 *
 * To run a mutation, you first call `useSetAssetAnnotationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAssetAnnotationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAssetAnnotationsMutation, { data, loading, error }] = useSetAssetAnnotationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAssetAnnotationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAssetAnnotationsMutation,
    SetAssetAnnotationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAssetAnnotationsMutation,
    SetAssetAnnotationsMutationVariables
  >(SetAssetAnnotationsDocument, options);
}
export type SetAssetAnnotationsMutationHookResult = ReturnType<
  typeof useSetAssetAnnotationsMutation
>;
export type SetAssetAnnotationsMutationResult =
  Apollo.MutationResult<SetAssetAnnotationsMutation>;
export type SetAssetAnnotationsMutationOptions = Apollo.BaseMutationOptions<
  SetAssetAnnotationsMutation,
  SetAssetAnnotationsMutationVariables
>;
export const SetCustomPolicyDocument = gql`
  mutation SetCustomPolicy($input: [SetCustomPolicyInput!]!) {
    setCustomPolicy(input: $input) {
      policyMrns
    }
  }
`;
export type SetCustomPolicyMutationFn = Apollo.MutationFunction<
  SetCustomPolicyMutation,
  SetCustomPolicyMutationVariables
>;

/**
 * __useSetCustomPolicyMutation__
 *
 * To run a mutation, you first call `useSetCustomPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomPolicyMutation, { data, loading, error }] = useSetCustomPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCustomPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCustomPolicyMutation,
    SetCustomPolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCustomPolicyMutation,
    SetCustomPolicyMutationVariables
  >(SetCustomPolicyDocument, options);
}
export type SetCustomPolicyMutationHookResult = ReturnType<
  typeof useSetCustomPolicyMutation
>;
export type SetCustomPolicyMutationResult =
  Apollo.MutationResult<SetCustomPolicyMutation>;
export type SetCustomPolicyMutationOptions = Apollo.BaseMutationOptions<
  SetCustomPolicyMutation,
  SetCustomPolicyMutationVariables
>;
export const SetEmailPreferenceDocument = gql`
  mutation SetEmailPreference($input: [EmailPreferenceInput!]!) {
    setEmailPreference(input: $input)
  }
`;
export type SetEmailPreferenceMutationFn = Apollo.MutationFunction<
  SetEmailPreferenceMutation,
  SetEmailPreferenceMutationVariables
>;

/**
 * __useSetEmailPreferenceMutation__
 *
 * To run a mutation, you first call `useSetEmailPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEmailPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEmailPreferenceMutation, { data, loading, error }] = useSetEmailPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEmailPreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetEmailPreferenceMutation,
    SetEmailPreferenceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetEmailPreferenceMutation,
    SetEmailPreferenceMutationVariables
  >(SetEmailPreferenceDocument, options);
}
export type SetEmailPreferenceMutationHookResult = ReturnType<
  typeof useSetEmailPreferenceMutation
>;
export type SetEmailPreferenceMutationResult =
  Apollo.MutationResult<SetEmailPreferenceMutation>;
export type SetEmailPreferenceMutationOptions = Apollo.BaseMutationOptions<
  SetEmailPreferenceMutation,
  SetEmailPreferenceMutationVariables
>;
export const SetIntegrationDocument = gql`
  mutation SetIntegration($input: IntegrationInput!) {
    setIntegration(input: $input)
  }
`;
export type SetIntegrationMutationFn = Apollo.MutationFunction<
  SetIntegrationMutation,
  SetIntegrationMutationVariables
>;

/**
 * __useSetIntegrationMutation__
 *
 * To run a mutation, you first call `useSetIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIntegrationMutation, { data, loading, error }] = useSetIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetIntegrationMutation,
    SetIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetIntegrationMutation,
    SetIntegrationMutationVariables
  >(SetIntegrationDocument, options);
}
export type SetIntegrationMutationHookResult = ReturnType<
  typeof useSetIntegrationMutation
>;
export type SetIntegrationMutationResult =
  Apollo.MutationResult<SetIntegrationMutation>;
export type SetIntegrationMutationOptions = Apollo.BaseMutationOptions<
  SetIntegrationMutation,
  SetIntegrationMutationVariables
>;
export const SetOrganizationMembershipDocument = gql`
  mutation SetOrganizationMembership($input: SetOrganizationMembershipInput!) {
    setOrganizationMembership(input: $input)
  }
`;
export type SetOrganizationMembershipMutationFn = Apollo.MutationFunction<
  SetOrganizationMembershipMutation,
  SetOrganizationMembershipMutationVariables
>;

/**
 * __useSetOrganizationMembershipMutation__
 *
 * To run a mutation, you first call `useSetOrganizationMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganizationMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganizationMembershipMutation, { data, loading, error }] = useSetOrganizationMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOrganizationMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetOrganizationMembershipMutation,
    SetOrganizationMembershipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetOrganizationMembershipMutation,
    SetOrganizationMembershipMutationVariables
  >(SetOrganizationMembershipDocument, options);
}
export type SetOrganizationMembershipMutationHookResult = ReturnType<
  typeof useSetOrganizationMembershipMutation
>;
export type SetOrganizationMembershipMutationResult =
  Apollo.MutationResult<SetOrganizationMembershipMutation>;
export type SetOrganizationMembershipMutationOptions =
  Apollo.BaseMutationOptions<
    SetOrganizationMembershipMutation,
    SetOrganizationMembershipMutationVariables
  >;
export const SetRolesDocument = gql`
  mutation SetRoles($input: SetRolesInput!) {
    setRoles(input: $input) {
      mrns
      errors
    }
  }
`;
export type SetRolesMutationFn = Apollo.MutationFunction<
  SetRolesMutation,
  SetRolesMutationVariables
>;

/**
 * __useSetRolesMutation__
 *
 * To run a mutation, you first call `useSetRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRolesMutation, { data, loading, error }] = useSetRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetRolesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetRolesMutation,
    SetRolesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetRolesMutation, SetRolesMutationVariables>(
    SetRolesDocument,
    options,
  );
}
export type SetRolesMutationHookResult = ReturnType<typeof useSetRolesMutation>;
export type SetRolesMutationResult = Apollo.MutationResult<SetRolesMutation>;
export type SetRolesMutationOptions = Apollo.BaseMutationOptions<
  SetRolesMutation,
  SetRolesMutationVariables
>;
export const SetSsoProviderDocument = gql`
  mutation SetSSOProvider($input: SetSSOProviderInput!) {
    setSSOProvider(input: $input)
  }
`;
export type SetSsoProviderMutationFn = Apollo.MutationFunction<
  SetSsoProviderMutation,
  SetSsoProviderMutationVariables
>;

/**
 * __useSetSsoProviderMutation__
 *
 * To run a mutation, you first call `useSetSsoProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSsoProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSsoProviderMutation, { data, loading, error }] = useSetSsoProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSsoProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSsoProviderMutation,
    SetSsoProviderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetSsoProviderMutation,
    SetSsoProviderMutationVariables
  >(SetSsoProviderDocument, options);
}
export type SetSsoProviderMutationHookResult = ReturnType<
  typeof useSetSsoProviderMutation
>;
export type SetSsoProviderMutationResult =
  Apollo.MutationResult<SetSsoProviderMutation>;
export type SetSsoProviderMutationOptions = Apollo.BaseMutationOptions<
  SetSsoProviderMutation,
  SetSsoProviderMutationVariables
>;
export const SetSpaceMembershipDocument = gql`
  mutation SetSpaceMembership($input: SetSpaceMembershipInput!) {
    setSpaceMembership(input: $input)
  }
`;
export type SetSpaceMembershipMutationFn = Apollo.MutationFunction<
  SetSpaceMembershipMutation,
  SetSpaceMembershipMutationVariables
>;

/**
 * __useSetSpaceMembershipMutation__
 *
 * To run a mutation, you first call `useSetSpaceMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSpaceMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSpaceMembershipMutation, { data, loading, error }] = useSetSpaceMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSpaceMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSpaceMembershipMutation,
    SetSpaceMembershipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetSpaceMembershipMutation,
    SetSpaceMembershipMutationVariables
  >(SetSpaceMembershipDocument, options);
}
export type SetSpaceMembershipMutationHookResult = ReturnType<
  typeof useSetSpaceMembershipMutation
>;
export type SetSpaceMembershipMutationResult =
  Apollo.MutationResult<SetSpaceMembershipMutation>;
export type SetSpaceMembershipMutationOptions = Apollo.BaseMutationOptions<
  SetSpaceMembershipMutation,
  SetSpaceMembershipMutationVariables
>;
export const SetViewerSettingDocument = gql`
  mutation SetViewerSetting($key: String!, $value: String!) {
    changeViewerSetting(key: $key, value: $value)
  }
`;
export type SetViewerSettingMutationFn = Apollo.MutationFunction<
  SetViewerSettingMutation,
  SetViewerSettingMutationVariables
>;

/**
 * __useSetViewerSettingMutation__
 *
 * To run a mutation, you first call `useSetViewerSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetViewerSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setViewerSettingMutation, { data, loading, error }] = useSetViewerSettingMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetViewerSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetViewerSettingMutation,
    SetViewerSettingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetViewerSettingMutation,
    SetViewerSettingMutationVariables
  >(SetViewerSettingDocument, options);
}
export type SetViewerSettingMutationHookResult = ReturnType<
  typeof useSetViewerSettingMutation
>;
export type SetViewerSettingMutationResult =
  Apollo.MutationResult<SetViewerSettingMutation>;
export type SetViewerSettingMutationOptions = Apollo.BaseMutationOptions<
  SetViewerSettingMutation,
  SetViewerSettingMutationVariables
>;
export const SuppressIntegrationMessageDocument = gql`
  mutation SuppressIntegrationMessage(
    $input: SuppressIntegrationMessageInput!
  ) {
    suppressIntegrationMessage(input: $input) {
      mrn
    }
  }
`;
export type SuppressIntegrationMessageMutationFn = Apollo.MutationFunction<
  SuppressIntegrationMessageMutation,
  SuppressIntegrationMessageMutationVariables
>;

/**
 * __useSuppressIntegrationMessageMutation__
 *
 * To run a mutation, you first call `useSuppressIntegrationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuppressIntegrationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suppressIntegrationMessageMutation, { data, loading, error }] = useSuppressIntegrationMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuppressIntegrationMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SuppressIntegrationMessageMutation,
    SuppressIntegrationMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SuppressIntegrationMessageMutation,
    SuppressIntegrationMessageMutationVariables
  >(SuppressIntegrationMessageDocument, options);
}
export type SuppressIntegrationMessageMutationHookResult = ReturnType<
  typeof useSuppressIntegrationMessageMutation
>;
export type SuppressIntegrationMessageMutationResult =
  Apollo.MutationResult<SuppressIntegrationMessageMutation>;
export type SuppressIntegrationMessageMutationOptions =
  Apollo.BaseMutationOptions<
    SuppressIntegrationMessageMutation,
    SuppressIntegrationMessageMutationVariables
  >;
export const UnassignPolicyDocument = gql`
  mutation UnassignPolicy($input: PolicyAssignmentInput!) {
    unassignPolicy(input: $input)
  }
`;
export type UnassignPolicyMutationFn = Apollo.MutationFunction<
  UnassignPolicyMutation,
  UnassignPolicyMutationVariables
>;

/**
 * __useUnassignPolicyMutation__
 *
 * To run a mutation, you first call `useUnassignPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignPolicyMutation, { data, loading, error }] = useUnassignPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnassignPolicyMutation,
    UnassignPolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnassignPolicyMutation,
    UnassignPolicyMutationVariables
  >(UnassignPolicyDocument, options);
}
export type UnassignPolicyMutationHookResult = ReturnType<
  typeof useUnassignPolicyMutation
>;
export type UnassignPolicyMutationResult =
  Apollo.MutationResult<UnassignPolicyMutation>;
export type UnassignPolicyMutationOptions = Apollo.BaseMutationOptions<
  UnassignPolicyMutation,
  UnassignPolicyMutationVariables
>;
export const UpdateApiTokenDocument = gql`
  mutation UpdateAPIToken($input: UpdateAPITokenInput!) {
    updateAPIToken(input: $input) {
      mrn
      spaceMrn
      name
      description
      roles {
        mrn
        title
      }
      createdAt
      lastUsed
      creator {
        mrn
        email
      }
    }
  }
`;
export type UpdateApiTokenMutationFn = Apollo.MutationFunction<
  UpdateApiTokenMutation,
  UpdateApiTokenMutationVariables
>;

/**
 * __useUpdateApiTokenMutation__
 *
 * To run a mutation, you first call `useUpdateApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiTokenMutation, { data, loading, error }] = useUpdateApiTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApiTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateApiTokenMutation,
    UpdateApiTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateApiTokenMutation,
    UpdateApiTokenMutationVariables
  >(UpdateApiTokenDocument, options);
}
export type UpdateApiTokenMutationHookResult = ReturnType<
  typeof useUpdateApiTokenMutation
>;
export type UpdateApiTokenMutationResult =
  Apollo.MutationResult<UpdateApiTokenMutation>;
export type UpdateApiTokenMutationOptions = Apollo.BaseMutationOptions<
  UpdateApiTokenMutation,
  UpdateApiTokenMutationVariables
>;
export const CloseCaseDocument = gql`
  mutation CloseCase($input: CloseCaseInput!) {
    closeCase(input: $input)
  }
`;
export type CloseCaseMutationFn = Apollo.MutationFunction<
  CloseCaseMutation,
  CloseCaseMutationVariables
>;

/**
 * __useCloseCaseMutation__
 *
 * To run a mutation, you first call `useCloseCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeCaseMutation, { data, loading, error }] = useCloseCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloseCaseMutation,
    CloseCaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloseCaseMutation, CloseCaseMutationVariables>(
    CloseCaseDocument,
    options,
  );
}
export type CloseCaseMutationHookResult = ReturnType<
  typeof useCloseCaseMutation
>;
export type CloseCaseMutationResult = Apollo.MutationResult<CloseCaseMutation>;
export type CloseCaseMutationOptions = Apollo.BaseMutationOptions<
  CloseCaseMutation,
  CloseCaseMutationVariables
>;
export const UpdateClientIntegrationConfigurationDocument = gql`
  mutation UpdateClientIntegrationConfiguration(
    $input: UpdateClientIntegrationConfigurationInput!
  ) {
    updateClientIntegrationConfiguration(input: $input) {
      configurationOptions {
        ... on K8sConfigurationOptions {
          scanNodes
          scanNodesStyle
          scanWorkloads
          scanDeploys
          certificateManager
          scanPublicImages
          namespaceAllowList
          namespaceDenyList
        }
        ... on AWSConfigurationOptions {
          region
          isOrganization
          snsEndpoint
          scanConfiguration {
            accountScan
            ec2Scan
            ecrScan
            ecsScan
            cronScaninHours
            ec2ScanOptions {
              ssm
              instanceConnect
              instanceIdsFilter
              excludedInstanceIdsFilter
              regionsFilter
              excludedRegionsFilter
              tagsFilter
              excludedTagsFilter
              ebsVolumeScan
            }
            vpcConfiguration {
              CIDR
              vpcFlavour
            }
          }
        }
        ... on HostedAwsConfigurationOptions {
          accessKeyId
          role
          wifAudience
          wifRoleArn
          wifSubject
        }
        ... on AzureConfigurationOptions {
          tenantId
          clientId
          subscriptionsWhitelist
          subscriptionsBlacklist
          scanVms
          secretType
        }
        ... on Ms365ConfigurationOptions {
          tenantId
          clientId
        }
        ... on MicrosoftDefenderConfigurationOptions {
          tenantId
          clientId
          subscriptionsAllowlist
          subscriptionsDenylist
          secretType
          createAssets
          mondooEnrichment
        }
        ... on GcpConfigurationOptions {
          projectId
          organizationId
          discoverAll
          wifAudience
          wifServiceAccountEmail
          wifSubject
        }
        ... on GcsBucketConfigurationOptions {
          output
          bucket
        }
        ... on GitlabConfigurationOptions {
          group
          type
          discoverGroups
          discoverProjects
          discoverTerraform
          discoverK8sManifests
          baseUrl
        }
        ... on GithubConfigurationOptions {
          owner
          repository
          githubOrg: organization
          githubType: type
          reposAllowList
          reposDenyList
          githubDiscoverK8sManifests: discoverK8sManifests
          githubDiscoverTerraform: discoverTerraform
          enterpriseUrl
        }
        ... on AzureDevopsConfigurationOptions {
          defaultProjectName
          organizationUrl
          servicePrincipalId
          tenantId
          autoCloseTickets
          autoCreateTickets
        }
        ... on HostConfigurationOptions {
          host
          https
          http
          discoverSubdomains
        }
        ... on AgentOptions {
          id
          version
          notes
          platform {
            name
            release
            arch
            kind
            runtime
          }
          hostname
          ipaddress
        }
        ... on OktaConfigurationOptions {
          organization
        }
        ... on GoogleWorkspaceConfigurationOptions {
          customerId
          impersonatedUserEmail
        }
        ... on OciConfigurationOptions {
          tenancyOcid
          userOcid
          region
          fingerprint
        }
        ... on ShodanConfigurationOptions {
          token
          targets
        }
        ... on SentinelOneConfigurationOptions {
          host
          account
          secretType
          createAssets
          mondooEnrichment
        }
        ... on CrowdstrikeFalconConfigurationOptions {
          clientId
          cloud
          memberCID
          createAssets
          mondooEnrichment
        }
        ... on SecurityPipelineGithubConfigurationOptions {
          appInstallationLink
          publicKey
          autoCreateWorkflows
          repositories {
            link
            fullName
            spaceMrn
          }
        }
        ... on WebhookConfigurationOptions {
          url
          autoCloseTickets
          autoCreateTickets
        }
        ... on ServiceNowConfigurationOptions {
          instanceUrl
          clientId
          autoCloseTickets
          autoCreateTickets
          userEmail
        }
      }
    }
  }
`;
export type UpdateClientIntegrationConfigurationMutationFn =
  Apollo.MutationFunction<
    UpdateClientIntegrationConfigurationMutation,
    UpdateClientIntegrationConfigurationMutationVariables
  >;

/**
 * __useUpdateClientIntegrationConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateClientIntegrationConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientIntegrationConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientIntegrationConfigurationMutation, { data, loading, error }] = useUpdateClientIntegrationConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientIntegrationConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClientIntegrationConfigurationMutation,
    UpdateClientIntegrationConfigurationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateClientIntegrationConfigurationMutation,
    UpdateClientIntegrationConfigurationMutationVariables
  >(UpdateClientIntegrationConfigurationDocument, options);
}
export type UpdateClientIntegrationConfigurationMutationHookResult = ReturnType<
  typeof useUpdateClientIntegrationConfigurationMutation
>;
export type UpdateClientIntegrationConfigurationMutationResult =
  Apollo.MutationResult<UpdateClientIntegrationConfigurationMutation>;
export type UpdateClientIntegrationConfigurationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateClientIntegrationConfigurationMutation,
    UpdateClientIntegrationConfigurationMutationVariables
  >;
export const UpdateOrganizationNameDocument = gql`
  mutation UpdateOrganizationName($input: UpdateOrganizationInput!) {
    updateOrganization(input: $input) {
      organization {
        name
        mrn
        company
        description
      }
    }
  }
`;
export type UpdateOrganizationNameMutationFn = Apollo.MutationFunction<
  UpdateOrganizationNameMutation,
  UpdateOrganizationNameMutationVariables
>;

/**
 * __useUpdateOrganizationNameMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationNameMutation, { data, loading, error }] = useUpdateOrganizationNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrganizationNameMutation,
    UpdateOrganizationNameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrganizationNameMutation,
    UpdateOrganizationNameMutationVariables
  >(UpdateOrganizationNameDocument, options);
}
export type UpdateOrganizationNameMutationHookResult = ReturnType<
  typeof useUpdateOrganizationNameMutation
>;
export type UpdateOrganizationNameMutationResult =
  Apollo.MutationResult<UpdateOrganizationNameMutation>;
export type UpdateOrganizationNameMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrganizationNameMutation,
  UpdateOrganizationNameMutationVariables
>;
export const UpdateSecurityModelDocument = gql`
  mutation UpdateSecurityModel($input: UpdateSecurityModelInput!) {
    updateSecurityModel(input: $input) {
      scopeMrn
      slas {
        startDateConfig
        findings {
          rating
          daysToResolve
          daysBeforeWarning
        }
      }
    }
  }
`;
export type UpdateSecurityModelMutationFn = Apollo.MutationFunction<
  UpdateSecurityModelMutation,
  UpdateSecurityModelMutationVariables
>;

/**
 * __useUpdateSecurityModelMutation__
 *
 * To run a mutation, you first call `useUpdateSecurityModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSecurityModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSecurityModelMutation, { data, loading, error }] = useUpdateSecurityModelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSecurityModelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSecurityModelMutation,
    UpdateSecurityModelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSecurityModelMutation,
    UpdateSecurityModelMutationVariables
  >(UpdateSecurityModelDocument, options);
}
export type UpdateSecurityModelMutationHookResult = ReturnType<
  typeof useUpdateSecurityModelMutation
>;
export type UpdateSecurityModelMutationResult =
  Apollo.MutationResult<UpdateSecurityModelMutation>;
export type UpdateSecurityModelMutationOptions = Apollo.BaseMutationOptions<
  UpdateSecurityModelMutation,
  UpdateSecurityModelMutationVariables
>;
export const UpdateSpaceDocument = gql`
  mutation UpdateSpace($input: UpdateSpaceInput!) {
    updateSpace(input: $input) {
      space {
        name
        mrn
        settings {
          eolAssetsConfiguration {
            enable
            monthsInAdvance
          }
          exceptionsConfiguration {
            requireApproval
            allowSelfApproval
            allowIndefiniteValidUntil
          }
          garbageCollectAssetsConfiguration {
            enable
            afterDays
          }
          terminatedAssetsConfiguration {
            cleanup
            after
          }
          unusedServiceAccountsConfiguration {
            cleanup
            after
          }
          platformVulnerabilityConfiguration {
            enable
          }
          casesConfiguration {
            autoCreate
            aggregationWindow
          }
          platformMqlVexConfiguration {
            enable
          }
          mvdExperimentalSourcesConfiguration {
            sources {
              id
              name
              enabled
            }
          }
        }
      }
    }
  }
`;
export type UpdateSpaceMutationFn = Apollo.MutationFunction<
  UpdateSpaceMutation,
  UpdateSpaceMutationVariables
>;

/**
 * __useUpdateSpaceMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceMutation, { data, loading, error }] = useUpdateSpaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSpaceMutation,
    UpdateSpaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateSpaceMutation, UpdateSpaceMutationVariables>(
    UpdateSpaceDocument,
    options,
  );
}
export type UpdateSpaceMutationHookResult = ReturnType<
  typeof useUpdateSpaceMutation
>;
export type UpdateSpaceMutationResult =
  Apollo.MutationResult<UpdateSpaceMutation>;
export type UpdateSpaceMutationOptions = Apollo.BaseMutationOptions<
  UpdateSpaceMutation,
  UpdateSpaceMutationVariables
>;
export const UpdateUserNameDocument = gql`
  mutation UpdateUserName($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        name
        mrn
      }
    }
  }
`;
export type UpdateUserNameMutationFn = Apollo.MutationFunction<
  UpdateUserNameMutation,
  UpdateUserNameMutationVariables
>;

/**
 * __useUpdateUserNameMutation__
 *
 * To run a mutation, you first call `useUpdateUserNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNameMutation, { data, loading, error }] = useUpdateUserNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserNameMutation,
    UpdateUserNameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserNameMutation,
    UpdateUserNameMutationVariables
  >(UpdateUserNameDocument, options);
}
export type UpdateUserNameMutationHookResult = ReturnType<
  typeof useUpdateUserNameMutation
>;
export type UpdateUserNameMutationResult =
  Apollo.MutationResult<UpdateUserNameMutation>;
export type UpdateUserNameMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserNameMutation,
  UpdateUserNameMutationVariables
>;
export const UpdateWorkspaceDocument = gql`
  mutation UpdateWorkspace($input: UpdateWorkspaceInput!) {
    updateWorkspace(input: $input) {
      mrn
      name
      description
      selections {
        ...WorkspaceSelection
      }
    }
  }
  ${WorkspaceSelectionFragmentDoc}
`;
export type UpdateWorkspaceMutationFn = Apollo.MutationFunction<
  UpdateWorkspaceMutation,
  UpdateWorkspaceMutationVariables
>;

/**
 * __useUpdateWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMutation, { data, loading, error }] = useUpdateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkspaceMutation,
    UpdateWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkspaceMutation,
    UpdateWorkspaceMutationVariables
  >(UpdateWorkspaceDocument, options);
}
export type UpdateWorkspaceMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceMutation
>;
export type UpdateWorkspaceMutationResult =
  Apollo.MutationResult<UpdateWorkspaceMutation>;
export type UpdateWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkspaceMutation,
  UpdateWorkspaceMutationVariables
>;
export const UploadFrameworkDocument = gql`
  mutation UploadFramework($input: UploadFrameworkInput!) {
    uploadFramework(input: $input)
  }
`;
export type UploadFrameworkMutationFn = Apollo.MutationFunction<
  UploadFrameworkMutation,
  UploadFrameworkMutationVariables
>;

/**
 * __useUploadFrameworkMutation__
 *
 * To run a mutation, you first call `useUploadFrameworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFrameworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFrameworkMutation, { data, loading, error }] = useUploadFrameworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadFrameworkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadFrameworkMutation,
    UploadFrameworkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadFrameworkMutation,
    UploadFrameworkMutationVariables
  >(UploadFrameworkDocument, options);
}
export type UploadFrameworkMutationHookResult = ReturnType<
  typeof useUploadFrameworkMutation
>;
export type UploadFrameworkMutationResult =
  Apollo.MutationResult<UploadFrameworkMutation>;
export type UploadFrameworkMutationOptions = Apollo.BaseMutationOptions<
  UploadFrameworkMutation,
  UploadFrameworkMutationVariables
>;
export const AgentForwardPaginationDocument = gql`
  query AgentForwardPagination(
    $spaceMrn: String!
    $after: String
    $first: Int
    $query: String
    $queryTerms: [String!]
    $version: [AgentVersionFilter!]
    $state: [AgentState!]
    $orderBy: AgentOrder
  ) {
    agents(
      spaceMrn: $spaceMrn
      first: $first
      after: $after
      query: $query
      queryTerms: $queryTerms
      version: $version
      state: $state
      orderBy: $orderBy
    ) {
      ...AgentFields
    }
  }
  ${AgentFieldsFragmentDoc}
`;

/**
 * __useAgentForwardPaginationQuery__
 *
 * To run a query within a React component, call `useAgentForwardPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentForwardPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentForwardPaginationQuery({
 *   variables: {
 *      spaceMrn: // value for 'spaceMrn'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *      queryTerms: // value for 'queryTerms'
 *      version: // value for 'version'
 *      state: // value for 'state'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAgentForwardPaginationQuery(
  baseOptions: Apollo.QueryHookOptions<
    AgentForwardPaginationQuery,
    AgentForwardPaginationQueryVariables
  > &
    (
      | { variables: AgentForwardPaginationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AgentForwardPaginationQuery,
    AgentForwardPaginationQueryVariables
  >(AgentForwardPaginationDocument, options);
}
export function useAgentForwardPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AgentForwardPaginationQuery,
    AgentForwardPaginationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AgentForwardPaginationQuery,
    AgentForwardPaginationQueryVariables
  >(AgentForwardPaginationDocument, options);
}
// @ts-ignore
export function useAgentForwardPaginationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AgentForwardPaginationQuery,
    AgentForwardPaginationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AgentForwardPaginationQuery,
  AgentForwardPaginationQueryVariables
>;
export function useAgentForwardPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AgentForwardPaginationQuery,
        AgentForwardPaginationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AgentForwardPaginationQuery | undefined,
  AgentForwardPaginationQueryVariables
>;
export function useAgentForwardPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AgentForwardPaginationQuery,
        AgentForwardPaginationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AgentForwardPaginationQuery,
    AgentForwardPaginationQueryVariables
  >(AgentForwardPaginationDocument, options);
}
export type AgentForwardPaginationQueryHookResult = ReturnType<
  typeof useAgentForwardPaginationQuery
>;
export type AgentForwardPaginationLazyQueryHookResult = ReturnType<
  typeof useAgentForwardPaginationLazyQuery
>;
export type AgentForwardPaginationSuspenseQueryHookResult = ReturnType<
  typeof useAgentForwardPaginationSuspenseQuery
>;
export type AgentForwardPaginationQueryResult = Apollo.QueryResult<
  AgentForwardPaginationQuery,
  AgentForwardPaginationQueryVariables
>;
export const AssetForwardPaginationDocument = gql`
  query AssetForwardPagination(
    $scopeMrn: String!
    $after: String
    $first: Int
    $queryTerms: [String!]
    $platformTitle: [String!]
    $platformName: [String!]
    $platformKind: [PlatformKind!]
    $platformRuntime: [String!]
    $scoreType: ScoreType!
    $labels: [KeyValueInput!]
    $updated: AssetUpdateFilter
    $eol: AssetEolFilter
    $reboot: AssetOSRebootFilter
    $exploitable: AssetExploitableFilter
    $orderBy: AssetOrder
    $groups: [GroupFilter!]
    $assetTypes: [String!]
    $relatedToAssetMrn: String
    $assetUrlFilter: [AssetUrlSegmentInput!]
    $rating: [ScoreRating!]
    $initiativeMrn: String
  ) {
    assets(
      scopeMrn: $scopeMrn
      after: $after
      first: $first
      orderBy: $orderBy
      queryTerms: $queryTerms
      platformTitle: $platformTitle
      platformName: $platformName
      platformKind: $platformKind
      platformRuntime: $platformRuntime
      scoreType: $scoreType
      labels: $labels
      updated: $updated
      eol: $eol
      reboot: $reboot
      exploitable: $exploitable
      groups: $groups
      assetTypes: $assetTypes
      relatedToAssetMrn: $relatedToAssetMrn
      assetUrlFilter: $assetUrlFilter
      rating: $rating
      initiativeMrn: $initiativeMrn
    ) {
      ...AssetFields
    }
  }
  ${AssetFieldsFragmentDoc}
`;

/**
 * __useAssetForwardPaginationQuery__
 *
 * To run a query within a React component, call `useAssetForwardPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetForwardPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetForwardPaginationQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      queryTerms: // value for 'queryTerms'
 *      platformTitle: // value for 'platformTitle'
 *      platformName: // value for 'platformName'
 *      platformKind: // value for 'platformKind'
 *      platformRuntime: // value for 'platformRuntime'
 *      scoreType: // value for 'scoreType'
 *      labels: // value for 'labels'
 *      updated: // value for 'updated'
 *      eol: // value for 'eol'
 *      reboot: // value for 'reboot'
 *      exploitable: // value for 'exploitable'
 *      orderBy: // value for 'orderBy'
 *      groups: // value for 'groups'
 *      assetTypes: // value for 'assetTypes'
 *      relatedToAssetMrn: // value for 'relatedToAssetMrn'
 *      assetUrlFilter: // value for 'assetUrlFilter'
 *      rating: // value for 'rating'
 *      initiativeMrn: // value for 'initiativeMrn'
 *   },
 * });
 */
export function useAssetForwardPaginationQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssetForwardPaginationQuery,
    AssetForwardPaginationQueryVariables
  > &
    (
      | { variables: AssetForwardPaginationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssetForwardPaginationQuery,
    AssetForwardPaginationQueryVariables
  >(AssetForwardPaginationDocument, options);
}
export function useAssetForwardPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssetForwardPaginationQuery,
    AssetForwardPaginationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssetForwardPaginationQuery,
    AssetForwardPaginationQueryVariables
  >(AssetForwardPaginationDocument, options);
}
// @ts-ignore
export function useAssetForwardPaginationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssetForwardPaginationQuery,
    AssetForwardPaginationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssetForwardPaginationQuery,
  AssetForwardPaginationQueryVariables
>;
export function useAssetForwardPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssetForwardPaginationQuery,
        AssetForwardPaginationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssetForwardPaginationQuery | undefined,
  AssetForwardPaginationQueryVariables
>;
export function useAssetForwardPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssetForwardPaginationQuery,
        AssetForwardPaginationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssetForwardPaginationQuery,
    AssetForwardPaginationQueryVariables
  >(AssetForwardPaginationDocument, options);
}
export type AssetForwardPaginationQueryHookResult = ReturnType<
  typeof useAssetForwardPaginationQuery
>;
export type AssetForwardPaginationLazyQueryHookResult = ReturnType<
  typeof useAssetForwardPaginationLazyQuery
>;
export type AssetForwardPaginationSuspenseQueryHookResult = ReturnType<
  typeof useAssetForwardPaginationSuspenseQuery
>;
export type AssetForwardPaginationQueryResult = Apollo.QueryResult<
  AssetForwardPaginationQuery,
  AssetForwardPaginationQueryVariables
>;
export const AssetSearchSuggestionsDocument = gql`
  query AssetSearchSuggestions($input: AssetSearchSuggestionsInput!) {
    assetSearchSuggestions(input: $input) {
      ... on AssetSearchSuggestions {
        suggestions {
          value
        }
      }
    }
  }
`;

/**
 * __useAssetSearchSuggestionsQuery__
 *
 * To run a query within a React component, call `useAssetSearchSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetSearchSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetSearchSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssetSearchSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssetSearchSuggestionsQuery,
    AssetSearchSuggestionsQueryVariables
  > &
    (
      | { variables: AssetSearchSuggestionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssetSearchSuggestionsQuery,
    AssetSearchSuggestionsQueryVariables
  >(AssetSearchSuggestionsDocument, options);
}
export function useAssetSearchSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssetSearchSuggestionsQuery,
    AssetSearchSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssetSearchSuggestionsQuery,
    AssetSearchSuggestionsQueryVariables
  >(AssetSearchSuggestionsDocument, options);
}
// @ts-ignore
export function useAssetSearchSuggestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssetSearchSuggestionsQuery,
    AssetSearchSuggestionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssetSearchSuggestionsQuery,
  AssetSearchSuggestionsQueryVariables
>;
export function useAssetSearchSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssetSearchSuggestionsQuery,
        AssetSearchSuggestionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssetSearchSuggestionsQuery | undefined,
  AssetSearchSuggestionsQueryVariables
>;
export function useAssetSearchSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssetSearchSuggestionsQuery,
        AssetSearchSuggestionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssetSearchSuggestionsQuery,
    AssetSearchSuggestionsQueryVariables
  >(AssetSearchSuggestionsDocument, options);
}
export type AssetSearchSuggestionsQueryHookResult = ReturnType<
  typeof useAssetSearchSuggestionsQuery
>;
export type AssetSearchSuggestionsLazyQueryHookResult = ReturnType<
  typeof useAssetSearchSuggestionsLazyQuery
>;
export type AssetSearchSuggestionsSuspenseQueryHookResult = ReturnType<
  typeof useAssetSearchSuggestionsSuspenseQuery
>;
export type AssetSearchSuggestionsQueryResult = Apollo.QueryResult<
  AssetSearchSuggestionsQuery,
  AssetSearchSuggestionsQueryVariables
>;
export const AuditLogForwardPaginationDocument = gql`
  query AuditLogForwardPagination(
    $resourceMrn: String!
    $actionFilter: String
    $identityFilter: IdentityFilter
    $timestampFilter: TimestampFilter
    $orderBy: AuditLogOrder = { direction: DESC, field: TIMESTAMP }
    $first: Int
    $after: String
  ) {
    auditlog(
      resourceMrn: $resourceMrn
      actionFilter: $actionFilter
      identityFilter: $identityFilter
      timestampFilter: $timestampFilter
      orderBy: $orderBy
      first: $first
      after: $after
    ) {
      totalCount
      edges {
        cursor
        node {
          identity {
            name
            mrn
          }
          resource
          action
          timestamp
          msg
          ip
          parent
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useAuditLogForwardPaginationQuery__
 *
 * To run a query within a React component, call `useAuditLogForwardPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogForwardPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogForwardPaginationQuery({
 *   variables: {
 *      resourceMrn: // value for 'resourceMrn'
 *      actionFilter: // value for 'actionFilter'
 *      identityFilter: // value for 'identityFilter'
 *      timestampFilter: // value for 'timestampFilter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAuditLogForwardPaginationQuery(
  baseOptions: Apollo.QueryHookOptions<
    AuditLogForwardPaginationQuery,
    AuditLogForwardPaginationQueryVariables
  > &
    (
      | { variables: AuditLogForwardPaginationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AuditLogForwardPaginationQuery,
    AuditLogForwardPaginationQueryVariables
  >(AuditLogForwardPaginationDocument, options);
}
export function useAuditLogForwardPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuditLogForwardPaginationQuery,
    AuditLogForwardPaginationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AuditLogForwardPaginationQuery,
    AuditLogForwardPaginationQueryVariables
  >(AuditLogForwardPaginationDocument, options);
}
// @ts-ignore
export function useAuditLogForwardPaginationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AuditLogForwardPaginationQuery,
    AuditLogForwardPaginationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AuditLogForwardPaginationQuery,
  AuditLogForwardPaginationQueryVariables
>;
export function useAuditLogForwardPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AuditLogForwardPaginationQuery,
        AuditLogForwardPaginationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AuditLogForwardPaginationQuery | undefined,
  AuditLogForwardPaginationQueryVariables
>;
export function useAuditLogForwardPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AuditLogForwardPaginationQuery,
        AuditLogForwardPaginationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AuditLogForwardPaginationQuery,
    AuditLogForwardPaginationQueryVariables
  >(AuditLogForwardPaginationDocument, options);
}
export type AuditLogForwardPaginationQueryHookResult = ReturnType<
  typeof useAuditLogForwardPaginationQuery
>;
export type AuditLogForwardPaginationLazyQueryHookResult = ReturnType<
  typeof useAuditLogForwardPaginationLazyQuery
>;
export type AuditLogForwardPaginationSuspenseQueryHookResult = ReturnType<
  typeof useAuditLogForwardPaginationSuspenseQuery
>;
export type AuditLogForwardPaginationQueryResult = Apollo.QueryResult<
  AuditLogForwardPaginationQuery,
  AuditLogForwardPaginationQueryVariables
>;
export const DownloadBundleDocument = gql`
  query DownloadBundle($input: DownloadBundleInput!) {
    downloadBundle(input: $input) {
      ... on PolicyBundleYaml {
        yaml
      }
    }
  }
`;

/**
 * __useDownloadBundleQuery__
 *
 * To run a query within a React component, call `useDownloadBundleQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadBundleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadBundleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadBundleQuery(
  baseOptions: Apollo.QueryHookOptions<
    DownloadBundleQuery,
    DownloadBundleQueryVariables
  > &
    (
      | { variables: DownloadBundleQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DownloadBundleQuery, DownloadBundleQueryVariables>(
    DownloadBundleDocument,
    options,
  );
}
export function useDownloadBundleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DownloadBundleQuery,
    DownloadBundleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DownloadBundleQuery, DownloadBundleQueryVariables>(
    DownloadBundleDocument,
    options,
  );
}
// @ts-ignore
export function useDownloadBundleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DownloadBundleQuery,
    DownloadBundleQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DownloadBundleQuery,
  DownloadBundleQueryVariables
>;
export function useDownloadBundleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DownloadBundleQuery,
        DownloadBundleQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DownloadBundleQuery | undefined,
  DownloadBundleQueryVariables
>;
export function useDownloadBundleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DownloadBundleQuery,
        DownloadBundleQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DownloadBundleQuery,
    DownloadBundleQueryVariables
  >(DownloadBundleDocument, options);
}
export type DownloadBundleQueryHookResult = ReturnType<
  typeof useDownloadBundleQuery
>;
export type DownloadBundleLazyQueryHookResult = ReturnType<
  typeof useDownloadBundleLazyQuery
>;
export type DownloadBundleSuspenseQueryHookResult = ReturnType<
  typeof useDownloadBundleSuspenseQuery
>;
export type DownloadBundleQueryResult = Apollo.QueryResult<
  DownloadBundleQuery,
  DownloadBundleQueryVariables
>;
export const DownloadFrameworkDocument = gql`
  query DownloadFramework($input: DownloadFrameworkInput!) {
    downloadFramework(input: $input) {
      ... on FrameworkBundle {
        yaml
      }
    }
  }
`;

/**
 * __useDownloadFrameworkQuery__
 *
 * To run a query within a React component, call `useDownloadFrameworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadFrameworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadFrameworkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadFrameworkQuery(
  baseOptions: Apollo.QueryHookOptions<
    DownloadFrameworkQuery,
    DownloadFrameworkQueryVariables
  > &
    (
      | { variables: DownloadFrameworkQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DownloadFrameworkQuery,
    DownloadFrameworkQueryVariables
  >(DownloadFrameworkDocument, options);
}
export function useDownloadFrameworkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DownloadFrameworkQuery,
    DownloadFrameworkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DownloadFrameworkQuery,
    DownloadFrameworkQueryVariables
  >(DownloadFrameworkDocument, options);
}
// @ts-ignore
export function useDownloadFrameworkSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DownloadFrameworkQuery,
    DownloadFrameworkQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DownloadFrameworkQuery,
  DownloadFrameworkQueryVariables
>;
export function useDownloadFrameworkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DownloadFrameworkQuery,
        DownloadFrameworkQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DownloadFrameworkQuery | undefined,
  DownloadFrameworkQueryVariables
>;
export function useDownloadFrameworkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DownloadFrameworkQuery,
        DownloadFrameworkQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DownloadFrameworkQuery,
    DownloadFrameworkQueryVariables
  >(DownloadFrameworkDocument, options);
}
export type DownloadFrameworkQueryHookResult = ReturnType<
  typeof useDownloadFrameworkQuery
>;
export type DownloadFrameworkLazyQueryHookResult = ReturnType<
  typeof useDownloadFrameworkLazyQuery
>;
export type DownloadFrameworkSuspenseQueryHookResult = ReturnType<
  typeof useDownloadFrameworkSuspenseQuery
>;
export type DownloadFrameworkQueryResult = Apollo.QueryResult<
  DownloadFrameworkQuery,
  DownloadFrameworkQueryVariables
>;
export const FindNewAwsAssetDocument = gql`
  query FindNewAwsAsset($scopeMrn: String!) {
    assets(scopeMrn: $scopeMrn, platformName: "aws") {
      edges {
        cursor
        node {
          mrn
          platform {
            name
          }
        }
      }
    }
  }
`;

/**
 * __useFindNewAwsAssetQuery__
 *
 * To run a query within a React component, call `useFindNewAwsAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindNewAwsAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindNewAwsAssetQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *   },
 * });
 */
export function useFindNewAwsAssetQuery(
  baseOptions: Apollo.QueryHookOptions<
    FindNewAwsAssetQuery,
    FindNewAwsAssetQueryVariables
  > &
    (
      | { variables: FindNewAwsAssetQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FindNewAwsAssetQuery, FindNewAwsAssetQueryVariables>(
    FindNewAwsAssetDocument,
    options,
  );
}
export function useFindNewAwsAssetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindNewAwsAssetQuery,
    FindNewAwsAssetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FindNewAwsAssetQuery,
    FindNewAwsAssetQueryVariables
  >(FindNewAwsAssetDocument, options);
}
// @ts-ignore
export function useFindNewAwsAssetSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FindNewAwsAssetQuery,
    FindNewAwsAssetQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FindNewAwsAssetQuery,
  FindNewAwsAssetQueryVariables
>;
export function useFindNewAwsAssetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FindNewAwsAssetQuery,
        FindNewAwsAssetQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FindNewAwsAssetQuery | undefined,
  FindNewAwsAssetQueryVariables
>;
export function useFindNewAwsAssetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FindNewAwsAssetQuery,
        FindNewAwsAssetQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FindNewAwsAssetQuery,
    FindNewAwsAssetQueryVariables
  >(FindNewAwsAssetDocument, options);
}
export type FindNewAwsAssetQueryHookResult = ReturnType<
  typeof useFindNewAwsAssetQuery
>;
export type FindNewAwsAssetLazyQueryHookResult = ReturnType<
  typeof useFindNewAwsAssetLazyQuery
>;
export type FindNewAwsAssetSuspenseQueryHookResult = ReturnType<
  typeof useFindNewAwsAssetSuspenseQuery
>;
export type FindNewAwsAssetQueryResult = Apollo.QueryResult<
  FindNewAwsAssetQuery,
  FindNewAwsAssetQueryVariables
>;
export const GetActivePoliciesDocument = gql`
  query GetActivePolicies($input: ActivePoliciesInput!) {
    activePolicies(input: $input) {
      totalCount
      edges {
        cursor
        node {
          mrn
          name
          icon
          updatedAt
          lastAppliedAt
          version
          created_at
          action
          score {
            riskValue
            rating
            blastRadius {
              indicator
              assets
              affected
              critical
              high
              medium
              low
              none
              error
              pass
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetActivePoliciesQuery__
 *
 * To run a query within a React component, call `useGetActivePoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivePoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivePoliciesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetActivePoliciesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetActivePoliciesQuery,
    GetActivePoliciesQueryVariables
  > &
    (
      | { variables: GetActivePoliciesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetActivePoliciesQuery,
    GetActivePoliciesQueryVariables
  >(GetActivePoliciesDocument, options);
}
export function useGetActivePoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActivePoliciesQuery,
    GetActivePoliciesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetActivePoliciesQuery,
    GetActivePoliciesQueryVariables
  >(GetActivePoliciesDocument, options);
}
// @ts-ignore
export function useGetActivePoliciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActivePoliciesQuery,
    GetActivePoliciesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetActivePoliciesQuery,
  GetActivePoliciesQueryVariables
>;
export function useGetActivePoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActivePoliciesQuery,
        GetActivePoliciesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetActivePoliciesQuery | undefined,
  GetActivePoliciesQueryVariables
>;
export function useGetActivePoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActivePoliciesQuery,
        GetActivePoliciesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetActivePoliciesQuery,
    GetActivePoliciesQueryVariables
  >(GetActivePoliciesDocument, options);
}
export type GetActivePoliciesQueryHookResult = ReturnType<
  typeof useGetActivePoliciesQuery
>;
export type GetActivePoliciesLazyQueryHookResult = ReturnType<
  typeof useGetActivePoliciesLazyQuery
>;
export type GetActivePoliciesSuspenseQueryHookResult = ReturnType<
  typeof useGetActivePoliciesSuspenseQuery
>;
export type GetActivePoliciesQueryResult = Apollo.QueryResult<
  GetActivePoliciesQuery,
  GetActivePoliciesQueryVariables
>;
export const GetActivePoliciesCountDocument = gql`
  query GetActivePoliciesCount($input: ActivePoliciesInput!) {
    activePolicies(input: $input) {
      totalCount
    }
  }
`;

/**
 * __useGetActivePoliciesCountQuery__
 *
 * To run a query within a React component, call `useGetActivePoliciesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivePoliciesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivePoliciesCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetActivePoliciesCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetActivePoliciesCountQuery,
    GetActivePoliciesCountQueryVariables
  > &
    (
      | { variables: GetActivePoliciesCountQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetActivePoliciesCountQuery,
    GetActivePoliciesCountQueryVariables
  >(GetActivePoliciesCountDocument, options);
}
export function useGetActivePoliciesCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActivePoliciesCountQuery,
    GetActivePoliciesCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetActivePoliciesCountQuery,
    GetActivePoliciesCountQueryVariables
  >(GetActivePoliciesCountDocument, options);
}
// @ts-ignore
export function useGetActivePoliciesCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActivePoliciesCountQuery,
    GetActivePoliciesCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetActivePoliciesCountQuery,
  GetActivePoliciesCountQueryVariables
>;
export function useGetActivePoliciesCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActivePoliciesCountQuery,
        GetActivePoliciesCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetActivePoliciesCountQuery | undefined,
  GetActivePoliciesCountQueryVariables
>;
export function useGetActivePoliciesCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActivePoliciesCountQuery,
        GetActivePoliciesCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetActivePoliciesCountQuery,
    GetActivePoliciesCountQueryVariables
  >(GetActivePoliciesCountDocument, options);
}
export type GetActivePoliciesCountQueryHookResult = ReturnType<
  typeof useGetActivePoliciesCountQuery
>;
export type GetActivePoliciesCountLazyQueryHookResult = ReturnType<
  typeof useGetActivePoliciesCountLazyQuery
>;
export type GetActivePoliciesCountSuspenseQueryHookResult = ReturnType<
  typeof useGetActivePoliciesCountSuspenseQuery
>;
export type GetActivePoliciesCountQueryResult = Apollo.QueryResult<
  GetActivePoliciesCountQuery,
  GetActivePoliciesCountQueryVariables
>;
export const GetAdvisoriesDocument = gql`
  query GetAdvisories(
    $scopeMrn: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        totalCount
        filteredTotalCount
        edges {
          cursor
          node {
            ... on AdvisoryFinding {
              id
              mrn
              title
              asset {
                id
                mrn
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
              rating
              riskValue
              lastUpdated
              publishedAt
              firstDetectedAt
              iconId
              tags {
                key
                value
              }
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              state
              exception {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                justification
                action
                author {
                  name
                  mrn
                  email
                  type
                }
                createdAt
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  totalManualEffort
                  research
                  scripting
                  rollout
                  verification
                }
              }
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetAdvisoriesQuery__
 *
 * To run a query within a React component, call `useGetAdvisoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisoriesQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAdvisoriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdvisoriesQuery,
    GetAdvisoriesQueryVariables
  > &
    (
      | { variables: GetAdvisoriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAdvisoriesQuery, GetAdvisoriesQueryVariables>(
    GetAdvisoriesDocument,
    options,
  );
}
export function useGetAdvisoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdvisoriesQuery,
    GetAdvisoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAdvisoriesQuery, GetAdvisoriesQueryVariables>(
    GetAdvisoriesDocument,
    options,
  );
}
// @ts-ignore
export function useGetAdvisoriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAdvisoriesQuery,
    GetAdvisoriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAdvisoriesQuery,
  GetAdvisoriesQueryVariables
>;
export function useGetAdvisoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAdvisoriesQuery,
        GetAdvisoriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAdvisoriesQuery | undefined,
  GetAdvisoriesQueryVariables
>;
export function useGetAdvisoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAdvisoriesQuery,
        GetAdvisoriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAdvisoriesQuery,
    GetAdvisoriesQueryVariables
  >(GetAdvisoriesDocument, options);
}
export type GetAdvisoriesQueryHookResult = ReturnType<
  typeof useGetAdvisoriesQuery
>;
export type GetAdvisoriesLazyQueryHookResult = ReturnType<
  typeof useGetAdvisoriesLazyQuery
>;
export type GetAdvisoriesSuspenseQueryHookResult = ReturnType<
  typeof useGetAdvisoriesSuspenseQuery
>;
export type GetAdvisoriesQueryResult = Apollo.QueryResult<
  GetAdvisoriesQuery,
  GetAdvisoriesQueryVariables
>;
export const GetAffectedAssetsDocument = gql`
  query GetAffectedAssets(
    $scopeMrn: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        totalCount
        filteredTotalCount
        edges {
          cursor
          node {
            ... on CheckFinding {
              id
              asset {
                id
                mrn
                name
                icon
                tags {
                  key
                  value
                }
              }
              iconId
              lastUpdated
              mrn
              riskValue
              rating
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  research
                  rollout
                  scripting
                  totalManualEffort
                  verification
                }
              }
              title
              state
              exception {
                id
                exceptionId
                exceptionMrn
                reviewStatus
                status
                action
                createdAt
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
            }
            ... on CveFinding {
              id
              asset {
                id
                mrn
                name
                icon
                tags {
                  key
                  value
                }
              }
              iconId
              lastUpdated
              firstDetectedAt
              mrn
              riskValue
              rating
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  research
                  rollout
                  scripting
                  totalManualEffort
                  verification
                }
              }
              title
              state
              exception {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                justification
                action
                author {
                  name
                  mrn
                  email
                  type
                }
                createdAt
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
            }
            ... on AdvisoryFinding {
              id
              asset {
                id
                mrn
                name
                icon
                tags {
                  key
                  value
                }
              }
              iconId
              lastUpdated
              firstDetectedAt
              mrn
              riskValue
              rating
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  research
                  rollout
                  scripting
                  totalManualEffort
                  verification
                }
              }
              title
              state
              exception {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                justification
                action
                author {
                  name
                  mrn
                  email
                  type
                }
                createdAt
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
            }
            ... on PackageFinding {
              id
              packageName
              mrn
              asset {
                id
                mrn
                name
                icon
                tags {
                  key
                  value
                }
              }
              rating
              riskValue
              lastUpdated
              tags {
                key
                value
              }
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetAffectedAssetsQuery__
 *
 * To run a query within a React component, call `useGetAffectedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAffectedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAffectedAssetsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAffectedAssetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAffectedAssetsQuery,
    GetAffectedAssetsQueryVariables
  > &
    (
      | { variables: GetAffectedAssetsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAffectedAssetsQuery,
    GetAffectedAssetsQueryVariables
  >(GetAffectedAssetsDocument, options);
}
export function useGetAffectedAssetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAffectedAssetsQuery,
    GetAffectedAssetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAffectedAssetsQuery,
    GetAffectedAssetsQueryVariables
  >(GetAffectedAssetsDocument, options);
}
// @ts-ignore
export function useGetAffectedAssetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAffectedAssetsQuery,
    GetAffectedAssetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAffectedAssetsQuery,
  GetAffectedAssetsQueryVariables
>;
export function useGetAffectedAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAffectedAssetsQuery,
        GetAffectedAssetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAffectedAssetsQuery | undefined,
  GetAffectedAssetsQueryVariables
>;
export function useGetAffectedAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAffectedAssetsQuery,
        GetAffectedAssetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAffectedAssetsQuery,
    GetAffectedAssetsQueryVariables
  >(GetAffectedAssetsDocument, options);
}
export type GetAffectedAssetsQueryHookResult = ReturnType<
  typeof useGetAffectedAssetsQuery
>;
export type GetAffectedAssetsLazyQueryHookResult = ReturnType<
  typeof useGetAffectedAssetsLazyQuery
>;
export type GetAffectedAssetsSuspenseQueryHookResult = ReturnType<
  typeof useGetAffectedAssetsSuspenseQuery
>;
export type GetAffectedAssetsQueryResult = Apollo.QueryResult<
  GetAffectedAssetsQuery,
  GetAffectedAssetsQueryVariables
>;
export const GetAggregateScoresDocument = gql`
  query GetAggregateScores(
    $entityMrn: String!
    $filter: AggregateScoreFilter
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: AggregateScoreOrder
    $skipCases: Boolean = false
  ) {
    aggregateScores(
      entityMrn: $entityMrn
      filter: $filter
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
    ) {
      ... on AggregateScoresConnection {
        totalCount
        edges {
          cursor
          node {
            id
            iconId
            state
            effort
            enforcementState
            previewUntil
            manualEffort {
              totalManualEffort
              research
              scripting
              rollout
              verification
            }
            entity {
              ... on EntityInfoAsset {
                id
                mrn
                name
              }
              ... on EntityInfoSpace {
                id
                mrn
                name
                contacts {
                  contactType
                  identity
                  email
                  name
                }
              }
              ... on EntityInfoWorkspace {
                id
                mrn
                name
                contacts {
                  contactType
                  identity
                  email
                  name
                }
              }
              ... on EntityInfoOrganization {
                id
                mrn
                name
                contacts {
                  contactType
                  identity
                  email
                  name
                }
              }
            }
            findingMrn
            rank
            baseScore
            baseValue
            baseRating
            completion
            findingStats {
              pass
              total
            }
            riskValue
            rankScore
            scoreType
            rating
            blastRadius {
              ...BlastRadiusFields
            }
            epss {
              probability
              percentile
            }
            cvss {
              id
              value
              type
              vector
              source
              rating
            }
            riskFactors {
              mrn
              indicator
              title
              total
              affected
              isPositive
            }
            detectionSources {
              name
              firstDetectedAt
              lastUpdatedAt
              affectedAssets
              vendor
            }
            title
            description
            tags {
              key
              value
            }
            lastScannedAt
            firstDetectedAt
            remediatedAt
            spaceId
            spaceRiskImprovement
            openCases @skip(if: $skipCases) {
              totalCount
              edges {
                node {
                  status
                  mrn
                  createdAt
                  ticketRefs {
                    type
                  }
                }
              }
            }
            exception {
              id
              reviewStatus
              status
              action
              justification
              scope
              exceptionId
              exceptionMrn
              createdAt
              author {
                name
                mrn
                email
                type
              }
            }
            slaAtRiskCount
            slaOverdueCount
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
  ${BlastRadiusFieldsFragmentDoc}
`;

/**
 * __useGetAggregateScoresQuery__
 *
 * To run a query within a React component, call `useGetAggregateScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregateScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregateScoresQuery({
 *   variables: {
 *      entityMrn: // value for 'entityMrn'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *      skipCases: // value for 'skipCases'
 *   },
 * });
 */
export function useGetAggregateScoresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAggregateScoresQuery,
    GetAggregateScoresQueryVariables
  > &
    (
      | { variables: GetAggregateScoresQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAggregateScoresQuery,
    GetAggregateScoresQueryVariables
  >(GetAggregateScoresDocument, options);
}
export function useGetAggregateScoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAggregateScoresQuery,
    GetAggregateScoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAggregateScoresQuery,
    GetAggregateScoresQueryVariables
  >(GetAggregateScoresDocument, options);
}
// @ts-ignore
export function useGetAggregateScoresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAggregateScoresQuery,
    GetAggregateScoresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAggregateScoresQuery,
  GetAggregateScoresQueryVariables
>;
export function useGetAggregateScoresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAggregateScoresQuery,
        GetAggregateScoresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAggregateScoresQuery | undefined,
  GetAggregateScoresQueryVariables
>;
export function useGetAggregateScoresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAggregateScoresQuery,
        GetAggregateScoresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAggregateScoresQuery,
    GetAggregateScoresQueryVariables
  >(GetAggregateScoresDocument, options);
}
export type GetAggregateScoresQueryHookResult = ReturnType<
  typeof useGetAggregateScoresQuery
>;
export type GetAggregateScoresLazyQueryHookResult = ReturnType<
  typeof useGetAggregateScoresLazyQuery
>;
export type GetAggregateScoresSuspenseQueryHookResult = ReturnType<
  typeof useGetAggregateScoresSuspenseQuery
>;
export type GetAggregateScoresQueryResult = Apollo.QueryResult<
  GetAggregateScoresQuery,
  GetAggregateScoresQueryVariables
>;
export const GetAggregateScoresCountDocument = gql`
  query GetAggregateScoresCount(
    $entityMrn: String!
    $filter: AggregateScoreFilter
  ) {
    aggregateScores(entityMrn: $entityMrn, filter: $filter, first: 0) {
      ... on AggregateScoresConnection {
        totalCount
      }
    }
  }
`;

/**
 * __useGetAggregateScoresCountQuery__
 *
 * To run a query within a React component, call `useGetAggregateScoresCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregateScoresCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregateScoresCountQuery({
 *   variables: {
 *      entityMrn: // value for 'entityMrn'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAggregateScoresCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAggregateScoresCountQuery,
    GetAggregateScoresCountQueryVariables
  > &
    (
      | { variables: GetAggregateScoresCountQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAggregateScoresCountQuery,
    GetAggregateScoresCountQueryVariables
  >(GetAggregateScoresCountDocument, options);
}
export function useGetAggregateScoresCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAggregateScoresCountQuery,
    GetAggregateScoresCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAggregateScoresCountQuery,
    GetAggregateScoresCountQueryVariables
  >(GetAggregateScoresCountDocument, options);
}
// @ts-ignore
export function useGetAggregateScoresCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAggregateScoresCountQuery,
    GetAggregateScoresCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAggregateScoresCountQuery,
  GetAggregateScoresCountQueryVariables
>;
export function useGetAggregateScoresCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAggregateScoresCountQuery,
        GetAggregateScoresCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAggregateScoresCountQuery | undefined,
  GetAggregateScoresCountQueryVariables
>;
export function useGetAggregateScoresCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAggregateScoresCountQuery,
        GetAggregateScoresCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAggregateScoresCountQuery,
    GetAggregateScoresCountQueryVariables
  >(GetAggregateScoresCountDocument, options);
}
export type GetAggregateScoresCountQueryHookResult = ReturnType<
  typeof useGetAggregateScoresCountQuery
>;
export type GetAggregateScoresCountLazyQueryHookResult = ReturnType<
  typeof useGetAggregateScoresCountLazyQuery
>;
export type GetAggregateScoresCountSuspenseQueryHookResult = ReturnType<
  typeof useGetAggregateScoresCountSuspenseQuery
>;
export type GetAggregateScoresCountQueryResult = Apollo.QueryResult<
  GetAggregateScoresCountQuery,
  GetAggregateScoresCountQueryVariables
>;
export const GetAggregateScoresRefreshInfoDocument = gql`
  query GetAggregateScoresRefreshInfo($groupMrn: String!) {
    aggregateScoresRefreshInfo(groupMrn: $groupMrn) {
      refreshInProgress
      lastUpdatedAt
    }
  }
`;

/**
 * __useGetAggregateScoresRefreshInfoQuery__
 *
 * To run a query within a React component, call `useGetAggregateScoresRefreshInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregateScoresRefreshInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregateScoresRefreshInfoQuery({
 *   variables: {
 *      groupMrn: // value for 'groupMrn'
 *   },
 * });
 */
export function useGetAggregateScoresRefreshInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAggregateScoresRefreshInfoQuery,
    GetAggregateScoresRefreshInfoQueryVariables
  > &
    (
      | {
          variables: GetAggregateScoresRefreshInfoQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAggregateScoresRefreshInfoQuery,
    GetAggregateScoresRefreshInfoQueryVariables
  >(GetAggregateScoresRefreshInfoDocument, options);
}
export function useGetAggregateScoresRefreshInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAggregateScoresRefreshInfoQuery,
    GetAggregateScoresRefreshInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAggregateScoresRefreshInfoQuery,
    GetAggregateScoresRefreshInfoQueryVariables
  >(GetAggregateScoresRefreshInfoDocument, options);
}
// @ts-ignore
export function useGetAggregateScoresRefreshInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAggregateScoresRefreshInfoQuery,
    GetAggregateScoresRefreshInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAggregateScoresRefreshInfoQuery,
  GetAggregateScoresRefreshInfoQueryVariables
>;
export function useGetAggregateScoresRefreshInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAggregateScoresRefreshInfoQuery,
        GetAggregateScoresRefreshInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAggregateScoresRefreshInfoQuery | undefined,
  GetAggregateScoresRefreshInfoQueryVariables
>;
export function useGetAggregateScoresRefreshInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAggregateScoresRefreshInfoQuery,
        GetAggregateScoresRefreshInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAggregateScoresRefreshInfoQuery,
    GetAggregateScoresRefreshInfoQueryVariables
  >(GetAggregateScoresRefreshInfoDocument, options);
}
export type GetAggregateScoresRefreshInfoQueryHookResult = ReturnType<
  typeof useGetAggregateScoresRefreshInfoQuery
>;
export type GetAggregateScoresRefreshInfoLazyQueryHookResult = ReturnType<
  typeof useGetAggregateScoresRefreshInfoLazyQuery
>;
export type GetAggregateScoresRefreshInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetAggregateScoresRefreshInfoSuspenseQuery
>;
export type GetAggregateScoresRefreshInfoQueryResult = Apollo.QueryResult<
  GetAggregateScoresRefreshInfoQuery,
  GetAggregateScoresRefreshInfoQueryVariables
>;
export const GetAggregateScoresSuggestionsDocument = gql`
  query GetAggregateScoresSuggestions(
    $entityMrn: String!
    $filterType: AggScoresFilterType!
    $searchText: String
    $filter: AggregateScoreFilter
    $limit: Int
  ) {
    aggregateScoresSuggestions(
      entityMrn: $entityMrn
      filterType: $filterType
      searchText: $searchText
      filter: $filter
      limit: $limit
    ) {
      label
      value {
        ... on StringValue {
          stringValue: value
        }
        ... on AggregateScoreStateValue {
          stateValue: value
        }
        ... on AggregateScoreTypeValue {
          typeValue: value
        }
        ... on AggregateScoreRatingValue {
          ratingValue: value
        }
      }
    }
  }
`;

/**
 * __useGetAggregateScoresSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetAggregateScoresSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregateScoresSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregateScoresSuggestionsQuery({
 *   variables: {
 *      entityMrn: // value for 'entityMrn'
 *      filterType: // value for 'filterType'
 *      searchText: // value for 'searchText'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAggregateScoresSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAggregateScoresSuggestionsQuery,
    GetAggregateScoresSuggestionsQueryVariables
  > &
    (
      | {
          variables: GetAggregateScoresSuggestionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAggregateScoresSuggestionsQuery,
    GetAggregateScoresSuggestionsQueryVariables
  >(GetAggregateScoresSuggestionsDocument, options);
}
export function useGetAggregateScoresSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAggregateScoresSuggestionsQuery,
    GetAggregateScoresSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAggregateScoresSuggestionsQuery,
    GetAggregateScoresSuggestionsQueryVariables
  >(GetAggregateScoresSuggestionsDocument, options);
}
// @ts-ignore
export function useGetAggregateScoresSuggestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAggregateScoresSuggestionsQuery,
    GetAggregateScoresSuggestionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAggregateScoresSuggestionsQuery,
  GetAggregateScoresSuggestionsQueryVariables
>;
export function useGetAggregateScoresSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAggregateScoresSuggestionsQuery,
        GetAggregateScoresSuggestionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAggregateScoresSuggestionsQuery | undefined,
  GetAggregateScoresSuggestionsQueryVariables
>;
export function useGetAggregateScoresSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAggregateScoresSuggestionsQuery,
        GetAggregateScoresSuggestionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAggregateScoresSuggestionsQuery,
    GetAggregateScoresSuggestionsQueryVariables
  >(GetAggregateScoresSuggestionsDocument, options);
}
export type GetAggregateScoresSuggestionsQueryHookResult = ReturnType<
  typeof useGetAggregateScoresSuggestionsQuery
>;
export type GetAggregateScoresSuggestionsLazyQueryHookResult = ReturnType<
  typeof useGetAggregateScoresSuggestionsLazyQuery
>;
export type GetAggregateScoresSuggestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetAggregateScoresSuggestionsSuspenseQuery
>;
export type GetAggregateScoresSuggestionsQueryResult = Apollo.QueryResult<
  GetAggregateScoresSuggestionsQuery,
  GetAggregateScoresSuggestionsQueryVariables
>;
export const GetApiTokensDocument = gql`
  query GetApiTokens(
    $spaceMrn: String!
    $scopeMrn: String
    $first: Int
    $after: String
    $queryTerms: [String!]
    $orderBy: APITokenOrder
  ) {
    apiTokens(
      spaceMrn: $spaceMrn
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      queryTerms: $queryTerms
      orderBy: $orderBy
    ) {
      totalCount
      edges {
        cursor
        node {
          mrn
          spaceMrn
          scopeMrn
          name
          description
          roles {
            mrn
            title
          }
          createdAt
          lastUsed
          creator {
            mrn
            email
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetApiTokensQuery__
 *
 * To run a query within a React component, call `useGetApiTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiTokensQuery({
 *   variables: {
 *      spaceMrn: // value for 'spaceMrn'
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      queryTerms: // value for 'queryTerms'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetApiTokensQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetApiTokensQuery,
    GetApiTokensQueryVariables
  > &
    (
      | { variables: GetApiTokensQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetApiTokensQuery, GetApiTokensQueryVariables>(
    GetApiTokensDocument,
    options,
  );
}
export function useGetApiTokensLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetApiTokensQuery,
    GetApiTokensQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetApiTokensQuery, GetApiTokensQueryVariables>(
    GetApiTokensDocument,
    options,
  );
}
// @ts-ignore
export function useGetApiTokensSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetApiTokensQuery,
    GetApiTokensQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetApiTokensQuery, GetApiTokensQueryVariables>;
export function useGetApiTokensSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetApiTokensQuery,
        GetApiTokensQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetApiTokensQuery | undefined,
  GetApiTokensQueryVariables
>;
export function useGetApiTokensSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetApiTokensQuery,
        GetApiTokensQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetApiTokensQuery, GetApiTokensQueryVariables>(
    GetApiTokensDocument,
    options,
  );
}
export type GetApiTokensQueryHookResult = ReturnType<
  typeof useGetApiTokensQuery
>;
export type GetApiTokensLazyQueryHookResult = ReturnType<
  typeof useGetApiTokensLazyQuery
>;
export type GetApiTokensSuspenseQueryHookResult = ReturnType<
  typeof useGetApiTokensSuspenseQuery
>;
export type GetApiTokensQueryResult = Apollo.QueryResult<
  GetApiTokensQuery,
  GetApiTokensQueryVariables
>;
export const GetAssetFilterSuggestionsDocument = gql`
  query GetAssetFilterSuggestions(
    $scopeMrn: String!
    $filterType: AssetFilterType!
    $searchText: String
    $filter: AssetSearchFilter
    $limit: Int
  ) {
    assetFilterSuggestions(
      scopeMrn: $scopeMrn
      filterType: $filterType
      searchText: $searchText
      filter: $filter
      limit: $limit
    ) {
      label
      value {
        ... on StringValue {
          stringValue: value
        }
        ... on ScoreRatingValue {
          ratingValue: value
        }
      }
    }
  }
`;

/**
 * __useGetAssetFilterSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetAssetFilterSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetFilterSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetFilterSuggestionsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      filterType: // value for 'filterType'
 *      searchText: // value for 'searchText'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAssetFilterSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssetFilterSuggestionsQuery,
    GetAssetFilterSuggestionsQueryVariables
  > &
    (
      | { variables: GetAssetFilterSuggestionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAssetFilterSuggestionsQuery,
    GetAssetFilterSuggestionsQueryVariables
  >(GetAssetFilterSuggestionsDocument, options);
}
export function useGetAssetFilterSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssetFilterSuggestionsQuery,
    GetAssetFilterSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssetFilterSuggestionsQuery,
    GetAssetFilterSuggestionsQueryVariables
  >(GetAssetFilterSuggestionsDocument, options);
}
// @ts-ignore
export function useGetAssetFilterSuggestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssetFilterSuggestionsQuery,
    GetAssetFilterSuggestionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssetFilterSuggestionsQuery,
  GetAssetFilterSuggestionsQueryVariables
>;
export function useGetAssetFilterSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetFilterSuggestionsQuery,
        GetAssetFilterSuggestionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssetFilterSuggestionsQuery | undefined,
  GetAssetFilterSuggestionsQueryVariables
>;
export function useGetAssetFilterSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetFilterSuggestionsQuery,
        GetAssetFilterSuggestionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssetFilterSuggestionsQuery,
    GetAssetFilterSuggestionsQueryVariables
  >(GetAssetFilterSuggestionsDocument, options);
}
export type GetAssetFilterSuggestionsQueryHookResult = ReturnType<
  typeof useGetAssetFilterSuggestionsQuery
>;
export type GetAssetFilterSuggestionsLazyQueryHookResult = ReturnType<
  typeof useGetAssetFilterSuggestionsLazyQuery
>;
export type GetAssetFilterSuggestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetAssetFilterSuggestionsSuspenseQuery
>;
export type GetAssetFilterSuggestionsQueryResult = Apollo.QueryResult<
  GetAssetFilterSuggestionsQuery,
  GetAssetFilterSuggestionsQueryVariables
>;
export const GetAssetGroupStatsDocument = gql`
  query GetAssetGroupStats($scopeMrn: String!, $queryTerms: [String!]) {
    assets(scopeMrn: $scopeMrn, queryTerms: $queryTerms, first: 1) {
      assetGroupStats {
        groupType
        count
        displayName
        icon
        listsAssetTypes {
          assetType
          displayName
          shortName
          aliases
        }
        statistics {
          type {
            assetType
            displayName
            shortName
            aliases
          }
          count
        }
      }
    }
  }
`;

/**
 * __useGetAssetGroupStatsQuery__
 *
 * To run a query within a React component, call `useGetAssetGroupStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetGroupStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetGroupStatsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      queryTerms: // value for 'queryTerms'
 *   },
 * });
 */
export function useGetAssetGroupStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssetGroupStatsQuery,
    GetAssetGroupStatsQueryVariables
  > &
    (
      | { variables: GetAssetGroupStatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAssetGroupStatsQuery,
    GetAssetGroupStatsQueryVariables
  >(GetAssetGroupStatsDocument, options);
}
export function useGetAssetGroupStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssetGroupStatsQuery,
    GetAssetGroupStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssetGroupStatsQuery,
    GetAssetGroupStatsQueryVariables
  >(GetAssetGroupStatsDocument, options);
}
// @ts-ignore
export function useGetAssetGroupStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssetGroupStatsQuery,
    GetAssetGroupStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssetGroupStatsQuery,
  GetAssetGroupStatsQueryVariables
>;
export function useGetAssetGroupStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetGroupStatsQuery,
        GetAssetGroupStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssetGroupStatsQuery | undefined,
  GetAssetGroupStatsQueryVariables
>;
export function useGetAssetGroupStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetGroupStatsQuery,
        GetAssetGroupStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssetGroupStatsQuery,
    GetAssetGroupStatsQueryVariables
  >(GetAssetGroupStatsDocument, options);
}
export type GetAssetGroupStatsQueryHookResult = ReturnType<
  typeof useGetAssetGroupStatsQuery
>;
export type GetAssetGroupStatsLazyQueryHookResult = ReturnType<
  typeof useGetAssetGroupStatsLazyQuery
>;
export type GetAssetGroupStatsSuspenseQueryHookResult = ReturnType<
  typeof useGetAssetGroupStatsSuspenseQuery
>;
export type GetAssetGroupStatsQueryResult = Apollo.QueryResult<
  GetAssetGroupStatsQuery,
  GetAssetGroupStatsQueryVariables
>;
export const GetAssetLinkInfoDocument = gql`
  query GetAssetLinkInfo($input: AssetLinkInfoInput!) {
    getAssetLinkInfo(input: $input) {
      ... on FleetAssetLinkInfo {
        mrn
        assetLinkType
      }
      ... on CiAssetLinkInfo {
        mrn
        assetLinkType
        projectID
      }
    }
  }
`;

/**
 * __useGetAssetLinkInfoQuery__
 *
 * To run a query within a React component, call `useGetAssetLinkInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetLinkInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetLinkInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssetLinkInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssetLinkInfoQuery,
    GetAssetLinkInfoQueryVariables
  > &
    (
      | { variables: GetAssetLinkInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssetLinkInfoQuery, GetAssetLinkInfoQueryVariables>(
    GetAssetLinkInfoDocument,
    options,
  );
}
export function useGetAssetLinkInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssetLinkInfoQuery,
    GetAssetLinkInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssetLinkInfoQuery,
    GetAssetLinkInfoQueryVariables
  >(GetAssetLinkInfoDocument, options);
}
// @ts-ignore
export function useGetAssetLinkInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssetLinkInfoQuery,
    GetAssetLinkInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssetLinkInfoQuery,
  GetAssetLinkInfoQueryVariables
>;
export function useGetAssetLinkInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetLinkInfoQuery,
        GetAssetLinkInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssetLinkInfoQuery | undefined,
  GetAssetLinkInfoQueryVariables
>;
export function useGetAssetLinkInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetLinkInfoQuery,
        GetAssetLinkInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssetLinkInfoQuery,
    GetAssetLinkInfoQueryVariables
  >(GetAssetLinkInfoDocument, options);
}
export type GetAssetLinkInfoQueryHookResult = ReturnType<
  typeof useGetAssetLinkInfoQuery
>;
export type GetAssetLinkInfoLazyQueryHookResult = ReturnType<
  typeof useGetAssetLinkInfoLazyQuery
>;
export type GetAssetLinkInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetAssetLinkInfoSuspenseQuery
>;
export type GetAssetLinkInfoQueryResult = Apollo.QueryResult<
  GetAssetLinkInfoQuery,
  GetAssetLinkInfoQueryVariables
>;
export const GetAssetPackagesDocument = gql`
  query GetAssetPackages(
    $scopeMrn: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        edges {
          cursor
          node {
            ... on PackageFinding {
              id
              mrn
              baseScore
              riskValue
              rating
              title
              packageName
              installedVersion
              availableVersion
              lastUpdated
              firstFound
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
              epss {
                probability
                percentile
              }
              iconId
              packageType
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              platform
              tags {
                key
                value
              }
              asset {
                id
                mrn
                name
                icon
                lastUpdated
                platform {
                  name
                  title
                  arch
                  version
                  kind
                  runtime
                  family
                  labels {
                    key
                    value
                  }
                }
              }
            }
          }
        }
        filteredTotalCount
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetAssetPackagesQuery__
 *
 * To run a query within a React component, call `useGetAssetPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetPackagesQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAssetPackagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssetPackagesQuery,
    GetAssetPackagesQueryVariables
  > &
    (
      | { variables: GetAssetPackagesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssetPackagesQuery, GetAssetPackagesQueryVariables>(
    GetAssetPackagesDocument,
    options,
  );
}
export function useGetAssetPackagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssetPackagesQuery,
    GetAssetPackagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssetPackagesQuery,
    GetAssetPackagesQueryVariables
  >(GetAssetPackagesDocument, options);
}
// @ts-ignore
export function useGetAssetPackagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssetPackagesQuery,
    GetAssetPackagesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssetPackagesQuery,
  GetAssetPackagesQueryVariables
>;
export function useGetAssetPackagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetPackagesQuery,
        GetAssetPackagesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssetPackagesQuery | undefined,
  GetAssetPackagesQueryVariables
>;
export function useGetAssetPackagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetPackagesQuery,
        GetAssetPackagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssetPackagesQuery,
    GetAssetPackagesQueryVariables
  >(GetAssetPackagesDocument, options);
}
export type GetAssetPackagesQueryHookResult = ReturnType<
  typeof useGetAssetPackagesQuery
>;
export type GetAssetPackagesLazyQueryHookResult = ReturnType<
  typeof useGetAssetPackagesLazyQuery
>;
export type GetAssetPackagesSuspenseQueryHookResult = ReturnType<
  typeof useGetAssetPackagesSuspenseQuery
>;
export type GetAssetPackagesQueryResult = Apollo.QueryResult<
  GetAssetPackagesQuery,
  GetAssetPackagesQueryVariables
>;
export const GetAssetPackagesStatsDocument = gql`
  query GetAssetPackagesStats($input: AssetPackagesStatsInput!) {
    assetPackagesStats(input: $input) {
      appsCount
      osPackagesCount
    }
  }
`;

/**
 * __useGetAssetPackagesStatsQuery__
 *
 * To run a query within a React component, call `useGetAssetPackagesStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetPackagesStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetPackagesStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssetPackagesStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssetPackagesStatsQuery,
    GetAssetPackagesStatsQueryVariables
  > &
    (
      | { variables: GetAssetPackagesStatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAssetPackagesStatsQuery,
    GetAssetPackagesStatsQueryVariables
  >(GetAssetPackagesStatsDocument, options);
}
export function useGetAssetPackagesStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssetPackagesStatsQuery,
    GetAssetPackagesStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssetPackagesStatsQuery,
    GetAssetPackagesStatsQueryVariables
  >(GetAssetPackagesStatsDocument, options);
}
// @ts-ignore
export function useGetAssetPackagesStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssetPackagesStatsQuery,
    GetAssetPackagesStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssetPackagesStatsQuery,
  GetAssetPackagesStatsQueryVariables
>;
export function useGetAssetPackagesStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetPackagesStatsQuery,
        GetAssetPackagesStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssetPackagesStatsQuery | undefined,
  GetAssetPackagesStatsQueryVariables
>;
export function useGetAssetPackagesStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetPackagesStatsQuery,
        GetAssetPackagesStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssetPackagesStatsQuery,
    GetAssetPackagesStatsQueryVariables
  >(GetAssetPackagesStatsDocument, options);
}
export type GetAssetPackagesStatsQueryHookResult = ReturnType<
  typeof useGetAssetPackagesStatsQuery
>;
export type GetAssetPackagesStatsLazyQueryHookResult = ReturnType<
  typeof useGetAssetPackagesStatsLazyQuery
>;
export type GetAssetPackagesStatsSuspenseQueryHookResult = ReturnType<
  typeof useGetAssetPackagesStatsSuspenseQuery
>;
export type GetAssetPackagesStatsQueryResult = Apollo.QueryResult<
  GetAssetPackagesStatsQuery,
  GetAssetPackagesStatsQueryVariables
>;
export const GetAssetSupportVulnerabilitiesDocument = gql`
  query GetAssetSupportVulnerabilities($assetMrn: String!) {
    assetSupportVulnerabilities(assetMrn: $assetMrn)
  }
`;

/**
 * __useGetAssetSupportVulnerabilitiesQuery__
 *
 * To run a query within a React component, call `useGetAssetSupportVulnerabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetSupportVulnerabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetSupportVulnerabilitiesQuery({
 *   variables: {
 *      assetMrn: // value for 'assetMrn'
 *   },
 * });
 */
export function useGetAssetSupportVulnerabilitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssetSupportVulnerabilitiesQuery,
    GetAssetSupportVulnerabilitiesQueryVariables
  > &
    (
      | {
          variables: GetAssetSupportVulnerabilitiesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAssetSupportVulnerabilitiesQuery,
    GetAssetSupportVulnerabilitiesQueryVariables
  >(GetAssetSupportVulnerabilitiesDocument, options);
}
export function useGetAssetSupportVulnerabilitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssetSupportVulnerabilitiesQuery,
    GetAssetSupportVulnerabilitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssetSupportVulnerabilitiesQuery,
    GetAssetSupportVulnerabilitiesQueryVariables
  >(GetAssetSupportVulnerabilitiesDocument, options);
}
// @ts-ignore
export function useGetAssetSupportVulnerabilitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssetSupportVulnerabilitiesQuery,
    GetAssetSupportVulnerabilitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssetSupportVulnerabilitiesQuery,
  GetAssetSupportVulnerabilitiesQueryVariables
>;
export function useGetAssetSupportVulnerabilitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetSupportVulnerabilitiesQuery,
        GetAssetSupportVulnerabilitiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssetSupportVulnerabilitiesQuery | undefined,
  GetAssetSupportVulnerabilitiesQueryVariables
>;
export function useGetAssetSupportVulnerabilitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetSupportVulnerabilitiesQuery,
        GetAssetSupportVulnerabilitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssetSupportVulnerabilitiesQuery,
    GetAssetSupportVulnerabilitiesQueryVariables
  >(GetAssetSupportVulnerabilitiesDocument, options);
}
export type GetAssetSupportVulnerabilitiesQueryHookResult = ReturnType<
  typeof useGetAssetSupportVulnerabilitiesQuery
>;
export type GetAssetSupportVulnerabilitiesLazyQueryHookResult = ReturnType<
  typeof useGetAssetSupportVulnerabilitiesLazyQuery
>;
export type GetAssetSupportVulnerabilitiesSuspenseQueryHookResult = ReturnType<
  typeof useGetAssetSupportVulnerabilitiesSuspenseQuery
>;
export type GetAssetSupportVulnerabilitiesQueryResult = Apollo.QueryResult<
  GetAssetSupportVulnerabilitiesQuery,
  GetAssetSupportVulnerabilitiesQueryVariables
>;
export const GetAssetSupportsVulnerabilitiesDocument = gql`
  query GetAssetSupportsVulnerabilities($assetMrn: String!) {
    assetSupportVulnerabilities(assetMrn: $assetMrn)
  }
`;

/**
 * __useGetAssetSupportsVulnerabilitiesQuery__
 *
 * To run a query within a React component, call `useGetAssetSupportsVulnerabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetSupportsVulnerabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetSupportsVulnerabilitiesQuery({
 *   variables: {
 *      assetMrn: // value for 'assetMrn'
 *   },
 * });
 */
export function useGetAssetSupportsVulnerabilitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssetSupportsVulnerabilitiesQuery,
    GetAssetSupportsVulnerabilitiesQueryVariables
  > &
    (
      | {
          variables: GetAssetSupportsVulnerabilitiesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAssetSupportsVulnerabilitiesQuery,
    GetAssetSupportsVulnerabilitiesQueryVariables
  >(GetAssetSupportsVulnerabilitiesDocument, options);
}
export function useGetAssetSupportsVulnerabilitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssetSupportsVulnerabilitiesQuery,
    GetAssetSupportsVulnerabilitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssetSupportsVulnerabilitiesQuery,
    GetAssetSupportsVulnerabilitiesQueryVariables
  >(GetAssetSupportsVulnerabilitiesDocument, options);
}
// @ts-ignore
export function useGetAssetSupportsVulnerabilitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssetSupportsVulnerabilitiesQuery,
    GetAssetSupportsVulnerabilitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssetSupportsVulnerabilitiesQuery,
  GetAssetSupportsVulnerabilitiesQueryVariables
>;
export function useGetAssetSupportsVulnerabilitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetSupportsVulnerabilitiesQuery,
        GetAssetSupportsVulnerabilitiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssetSupportsVulnerabilitiesQuery | undefined,
  GetAssetSupportsVulnerabilitiesQueryVariables
>;
export function useGetAssetSupportsVulnerabilitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetSupportsVulnerabilitiesQuery,
        GetAssetSupportsVulnerabilitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssetSupportsVulnerabilitiesQuery,
    GetAssetSupportsVulnerabilitiesQueryVariables
  >(GetAssetSupportsVulnerabilitiesDocument, options);
}
export type GetAssetSupportsVulnerabilitiesQueryHookResult = ReturnType<
  typeof useGetAssetSupportsVulnerabilitiesQuery
>;
export type GetAssetSupportsVulnerabilitiesLazyQueryHookResult = ReturnType<
  typeof useGetAssetSupportsVulnerabilitiesLazyQuery
>;
export type GetAssetSupportsVulnerabilitiesSuspenseQueryHookResult = ReturnType<
  typeof useGetAssetSupportsVulnerabilitiesSuspenseQuery
>;
export type GetAssetSupportsVulnerabilitiesQueryResult = Apollo.QueryResult<
  GetAssetSupportsVulnerabilitiesQuery,
  GetAssetSupportsVulnerabilitiesQueryVariables
>;
export const GetAssetUrlStatsDocument = gql`
  query GetAssetUrlStats($input: AssetUrlStatsInput!) {
    assetUrlStats(input: $input) {
      stats {
        assetUrl {
          key
          value
        }
        scoreDistribution {
          Unscored
          Ok
          Low
          Medium
          High
          Critical
        }
      }
    }
  }
`;

/**
 * __useGetAssetUrlStatsQuery__
 *
 * To run a query within a React component, call `useGetAssetUrlStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetUrlStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetUrlStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssetUrlStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssetUrlStatsQuery,
    GetAssetUrlStatsQueryVariables
  > &
    (
      | { variables: GetAssetUrlStatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssetUrlStatsQuery, GetAssetUrlStatsQueryVariables>(
    GetAssetUrlStatsDocument,
    options,
  );
}
export function useGetAssetUrlStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssetUrlStatsQuery,
    GetAssetUrlStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssetUrlStatsQuery,
    GetAssetUrlStatsQueryVariables
  >(GetAssetUrlStatsDocument, options);
}
// @ts-ignore
export function useGetAssetUrlStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssetUrlStatsQuery,
    GetAssetUrlStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssetUrlStatsQuery,
  GetAssetUrlStatsQueryVariables
>;
export function useGetAssetUrlStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetUrlStatsQuery,
        GetAssetUrlStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssetUrlStatsQuery | undefined,
  GetAssetUrlStatsQueryVariables
>;
export function useGetAssetUrlStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetUrlStatsQuery,
        GetAssetUrlStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssetUrlStatsQuery,
    GetAssetUrlStatsQueryVariables
  >(GetAssetUrlStatsDocument, options);
}
export type GetAssetUrlStatsQueryHookResult = ReturnType<
  typeof useGetAssetUrlStatsQuery
>;
export type GetAssetUrlStatsLazyQueryHookResult = ReturnType<
  typeof useGetAssetUrlStatsLazyQuery
>;
export type GetAssetUrlStatsSuspenseQueryHookResult = ReturnType<
  typeof useGetAssetUrlStatsSuspenseQuery
>;
export type GetAssetUrlStatsQueryResult = Apollo.QueryResult<
  GetAssetUrlStatsQuery,
  GetAssetUrlStatsQueryVariables
>;
export const GetAuditLogFilterSuggestionsDocument = gql`
  query GetAuditLogFilterSuggestions(
    $resourceMrn: String!
    $filterType: AuditLogFilterType!
    $searchText: String
    $filter: AuditLogsFilter
    $limit: Int
  ) {
    auditLogSuggestions(
      resourceMrn: $resourceMrn
      filterType: $filterType
      searchText: $searchText
      filter: $filter
      limit: $limit
    ) {
      label
      value {
        ... on StringValue {
          stringValue: value
        }
      }
    }
  }
`;

/**
 * __useGetAuditLogFilterSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetAuditLogFilterSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogFilterSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLogFilterSuggestionsQuery({
 *   variables: {
 *      resourceMrn: // value for 'resourceMrn'
 *      filterType: // value for 'filterType'
 *      searchText: // value for 'searchText'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAuditLogFilterSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAuditLogFilterSuggestionsQuery,
    GetAuditLogFilterSuggestionsQueryVariables
  > &
    (
      | {
          variables: GetAuditLogFilterSuggestionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAuditLogFilterSuggestionsQuery,
    GetAuditLogFilterSuggestionsQueryVariables
  >(GetAuditLogFilterSuggestionsDocument, options);
}
export function useGetAuditLogFilterSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAuditLogFilterSuggestionsQuery,
    GetAuditLogFilterSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAuditLogFilterSuggestionsQuery,
    GetAuditLogFilterSuggestionsQueryVariables
  >(GetAuditLogFilterSuggestionsDocument, options);
}
// @ts-ignore
export function useGetAuditLogFilterSuggestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAuditLogFilterSuggestionsQuery,
    GetAuditLogFilterSuggestionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAuditLogFilterSuggestionsQuery,
  GetAuditLogFilterSuggestionsQueryVariables
>;
export function useGetAuditLogFilterSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAuditLogFilterSuggestionsQuery,
        GetAuditLogFilterSuggestionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAuditLogFilterSuggestionsQuery | undefined,
  GetAuditLogFilterSuggestionsQueryVariables
>;
export function useGetAuditLogFilterSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAuditLogFilterSuggestionsQuery,
        GetAuditLogFilterSuggestionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAuditLogFilterSuggestionsQuery,
    GetAuditLogFilterSuggestionsQueryVariables
  >(GetAuditLogFilterSuggestionsDocument, options);
}
export type GetAuditLogFilterSuggestionsQueryHookResult = ReturnType<
  typeof useGetAuditLogFilterSuggestionsQuery
>;
export type GetAuditLogFilterSuggestionsLazyQueryHookResult = ReturnType<
  typeof useGetAuditLogFilterSuggestionsLazyQuery
>;
export type GetAuditLogFilterSuggestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetAuditLogFilterSuggestionsSuspenseQuery
>;
export type GetAuditLogFilterSuggestionsQueryResult = Apollo.QueryResult<
  GetAuditLogFilterSuggestionsQuery,
  GetAuditLogFilterSuggestionsQueryVariables
>;
export const GetCvEsDocument = gql`
  query GetCVEs(
    $scopeMrn: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        totalCount
        filteredTotalCount
        edges {
          cursor
          node {
            ... on CveFinding {
              id
              mrn
              title
              asset {
                icon
                name
                id
                mrn
                tags {
                  key
                  value
                }
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
              rating
              riskValue
              lastUpdated
              publishedAt
              state
              tags {
                key
                value
              }
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              lastUpdated
              exception {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                justification
                action
                author {
                  name
                  email
                  type
                }
                createdAt
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  totalManualEffort
                  research
                  scripting
                  rollout
                  verification
                }
              }
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetCvEsQuery__
 *
 * To run a query within a React component, call `useGetCvEsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCvEsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCvEsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCvEsQuery(
  baseOptions: Apollo.QueryHookOptions<GetCvEsQuery, GetCvEsQueryVariables> &
    ({ variables: GetCvEsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCvEsQuery, GetCvEsQueryVariables>(
    GetCvEsDocument,
    options,
  );
}
export function useGetCvEsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCvEsQuery,
    GetCvEsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCvEsQuery, GetCvEsQueryVariables>(
    GetCvEsDocument,
    options,
  );
}
// @ts-ignore
export function useGetCvEsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCvEsQuery,
    GetCvEsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetCvEsQuery, GetCvEsQueryVariables>;
export function useGetCvEsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCvEsQuery, GetCvEsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetCvEsQuery | undefined,
  GetCvEsQueryVariables
>;
export function useGetCvEsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCvEsQuery, GetCvEsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCvEsQuery, GetCvEsQueryVariables>(
    GetCvEsDocument,
    options,
  );
}
export type GetCvEsQueryHookResult = ReturnType<typeof useGetCvEsQuery>;
export type GetCvEsLazyQueryHookResult = ReturnType<typeof useGetCvEsLazyQuery>;
export type GetCvEsSuspenseQueryHookResult = ReturnType<
  typeof useGetCvEsSuspenseQuery
>;
export type GetCvEsQueryResult = Apollo.QueryResult<
  GetCvEsQuery,
  GetCvEsQueryVariables
>;
export const GetCaseContentDocument = gql`
  query GetCaseContent($input: CaseContentInput!) {
    caseContent(input: $input) {
      title
    }
  }
`;

/**
 * __useGetCaseContentQuery__
 *
 * To run a query within a React component, call `useGetCaseContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCaseContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCaseContentQuery,
    GetCaseContentQueryVariables
  > &
    (
      | { variables: GetCaseContentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCaseContentQuery, GetCaseContentQueryVariables>(
    GetCaseContentDocument,
    options,
  );
}
export function useGetCaseContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCaseContentQuery,
    GetCaseContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCaseContentQuery, GetCaseContentQueryVariables>(
    GetCaseContentDocument,
    options,
  );
}
// @ts-ignore
export function useGetCaseContentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCaseContentQuery,
    GetCaseContentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCaseContentQuery,
  GetCaseContentQueryVariables
>;
export function useGetCaseContentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCaseContentQuery,
        GetCaseContentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCaseContentQuery | undefined,
  GetCaseContentQueryVariables
>;
export function useGetCaseContentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCaseContentQuery,
        GetCaseContentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCaseContentQuery,
    GetCaseContentQueryVariables
  >(GetCaseContentDocument, options);
}
export type GetCaseContentQueryHookResult = ReturnType<
  typeof useGetCaseContentQuery
>;
export type GetCaseContentLazyQueryHookResult = ReturnType<
  typeof useGetCaseContentLazyQuery
>;
export type GetCaseContentSuspenseQueryHookResult = ReturnType<
  typeof useGetCaseContentSuspenseQuery
>;
export type GetCaseContentQueryResult = Apollo.QueryResult<
  GetCaseContentQuery,
  GetCaseContentQueryVariables
>;
export const GetCaseDetailsDocument = gql`
  query GetCaseDetails(
    $mrn: String!
    $affectedAssetsFirst: Int
    $affectedAssetsAfter: String
    $mitigatedAssetsFirst: Int
    $mitigatedAssetsAfter: String
  ) {
    case(mrn: $mrn) {
      ... on NotFoundError {
        message
        code
      }
      ... on RequestError {
        message
        code
      }
      ... on Case {
        status
        mrn
        title
        createdAt
        createdBy {
          name
          email
          mrn
          type
        }
        modifiedAt
        tags {
          key
          value
        }
        assetsCount
        totalRefsCount
        closedRefsCount
        ticketRefs {
          url
          type
          ticketId
        }
        vulnerabilityRefs {
          findingMrn
          scopeMrn
        }
        queryRefs {
          findingMrn
          scopeMrn
        }
        affectedAssets(
          first: $affectedAssetsFirst
          after: $affectedAssetsAfter
        ) {
          totalCount
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
          edges {
            cursor
            node {
              id
              mrn
              name
              icon
              tags {
                key
                value
              }
              lastUpdated
            }
          }
        }
        mitigatedAssets(
          first: $mitigatedAssetsFirst
          after: $mitigatedAssetsAfter
        ) {
          totalCount
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
          edges {
            cursor
            node {
              id
              mrn
              name
              icon
              tags {
                key
                value
              }
              lastUpdated
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetCaseDetailsQuery__
 *
 * To run a query within a React component, call `useGetCaseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseDetailsQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      affectedAssetsFirst: // value for 'affectedAssetsFirst'
 *      affectedAssetsAfter: // value for 'affectedAssetsAfter'
 *      mitigatedAssetsFirst: // value for 'mitigatedAssetsFirst'
 *      mitigatedAssetsAfter: // value for 'mitigatedAssetsAfter'
 *   },
 * });
 */
export function useGetCaseDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCaseDetailsQuery,
    GetCaseDetailsQueryVariables
  > &
    (
      | { variables: GetCaseDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>(
    GetCaseDetailsDocument,
    options,
  );
}
export function useGetCaseDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCaseDetailsQuery,
    GetCaseDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>(
    GetCaseDetailsDocument,
    options,
  );
}
// @ts-ignore
export function useGetCaseDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCaseDetailsQuery,
    GetCaseDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCaseDetailsQuery,
  GetCaseDetailsQueryVariables
>;
export function useGetCaseDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCaseDetailsQuery,
        GetCaseDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCaseDetailsQuery | undefined,
  GetCaseDetailsQueryVariables
>;
export function useGetCaseDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCaseDetailsQuery,
        GetCaseDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCaseDetailsQuery,
    GetCaseDetailsQueryVariables
  >(GetCaseDetailsDocument, options);
}
export type GetCaseDetailsQueryHookResult = ReturnType<
  typeof useGetCaseDetailsQuery
>;
export type GetCaseDetailsLazyQueryHookResult = ReturnType<
  typeof useGetCaseDetailsLazyQuery
>;
export type GetCaseDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetCaseDetailsSuspenseQuery
>;
export type GetCaseDetailsQueryResult = Apollo.QueryResult<
  GetCaseDetailsQuery,
  GetCaseDetailsQueryVariables
>;
export const GetCasesDocument = gql`
  query GetCases(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $input: CasesInput!
  ) {
    cases(
      first: $first
      after: $after
      before: $before
      input: $input
      last: $last
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
      edges {
        cursor
        node {
          mrn
          title
          createdAt
          status
          createdBy {
            name
          }
          modifiedAt
          tags {
            key
            value
          }
          assetsCount
          totalRefsCount
          closedRefsCount
          spaceRiskDelta
          ticketRefs {
            url
            ticketId
            type
          }
        }
      }
    }
  }
`;

/**
 * __useGetCasesQuery__
 *
 * To run a query within a React component, call `useGetCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCasesQuery(
  baseOptions: Apollo.QueryHookOptions<GetCasesQuery, GetCasesQueryVariables> &
    ({ variables: GetCasesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCasesQuery, GetCasesQueryVariables>(
    GetCasesDocument,
    options,
  );
}
export function useGetCasesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCasesQuery,
    GetCasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCasesQuery, GetCasesQueryVariables>(
    GetCasesDocument,
    options,
  );
}
// @ts-ignore
export function useGetCasesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCasesQuery,
    GetCasesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetCasesQuery, GetCasesQueryVariables>;
export function useGetCasesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCasesQuery, GetCasesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetCasesQuery | undefined,
  GetCasesQueryVariables
>;
export function useGetCasesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCasesQuery, GetCasesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCasesQuery, GetCasesQueryVariables>(
    GetCasesDocument,
    options,
  );
}
export type GetCasesQueryHookResult = ReturnType<typeof useGetCasesQuery>;
export type GetCasesLazyQueryHookResult = ReturnType<
  typeof useGetCasesLazyQuery
>;
export type GetCasesSuspenseQueryHookResult = ReturnType<
  typeof useGetCasesSuspenseQuery
>;
export type GetCasesQueryResult = Apollo.QueryResult<
  GetCasesQuery,
  GetCasesQueryVariables
>;
export const GetCasesCountDocument = gql`
  query GetCasesCount($input: CasesInput!) {
    cases(input: $input) {
      totalCount
    }
  }
`;

/**
 * __useGetCasesCountQuery__
 *
 * To run a query within a React component, call `useGetCasesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCasesCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCasesCountQuery,
    GetCasesCountQueryVariables
  > &
    (
      | { variables: GetCasesCountQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCasesCountQuery, GetCasesCountQueryVariables>(
    GetCasesCountDocument,
    options,
  );
}
export function useGetCasesCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCasesCountQuery,
    GetCasesCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCasesCountQuery, GetCasesCountQueryVariables>(
    GetCasesCountDocument,
    options,
  );
}
// @ts-ignore
export function useGetCasesCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCasesCountQuery,
    GetCasesCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCasesCountQuery,
  GetCasesCountQueryVariables
>;
export function useGetCasesCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCasesCountQuery,
        GetCasesCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCasesCountQuery | undefined,
  GetCasesCountQueryVariables
>;
export function useGetCasesCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCasesCountQuery,
        GetCasesCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCasesCountQuery,
    GetCasesCountQueryVariables
  >(GetCasesCountDocument, options);
}
export type GetCasesCountQueryHookResult = ReturnType<
  typeof useGetCasesCountQuery
>;
export type GetCasesCountLazyQueryHookResult = ReturnType<
  typeof useGetCasesCountLazyQuery
>;
export type GetCasesCountSuspenseQueryHookResult = ReturnType<
  typeof useGetCasesCountSuspenseQuery
>;
export type GetCasesCountQueryResult = Apollo.QueryResult<
  GetCasesCountQuery,
  GetCasesCountQueryVariables
>;
export const GetCheckRowDataDocument = gql`
  query GetCheckRowData(
    $scopeMrn: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
    $renderedAssetQueryInput: RenderedAssetQueryDataInput!
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        edges {
          node {
            ... on CheckFinding {
              mrn
              id
              title
              state
              iconId
              baseScore
              rating
              riskValue
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              lastUpdated
              tags {
                key
                value
              }
              asset {
                id
                mrn
                name
                icon
                lastUpdated
              }
              exception {
                id
                exceptionId
                exceptionMrn
                reviewStatus
                status
                action
                justification
              }
              resultType
              mquery {
                uid
                mrn
                title
                docs {
                  desc
                  remediations {
                    ... on Remediations {
                      entries {
                        id
                        idName
                        desc
                      }
                    }
                    ... on AuthenticationRequired {
                      message
                      code
                    }
                  }
                  references {
                    title
                    url
                  }
                  audit
                  remediation
                }
                impact {
                  value
                  rating
                }
                mql
                properties {
                  uid
                  mrn
                  title
                  mql
                  defaultValue
                  overrideValue
                  setByPolicyMrn
                  for {
                    mrn
                  }
                }
                parent
                variants {
                  id
                  mrn
                  title
                  icon
                }
                variantQueries {
                  uid
                  mrn
                  title
                  mql
                  filter
                  filterID
                }
                action
                code
                codeId
                severity
              }
            }
          }
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
    renderedAssetQueryData(input: $renderedAssetQueryInput) {
      ... on RenderedAssetQueryData {
        data
        assessment
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetCheckRowDataQuery__
 *
 * To run a query within a React component, call `useGetCheckRowDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckRowDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckRowDataQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *      renderedAssetQueryInput: // value for 'renderedAssetQueryInput'
 *   },
 * });
 */
export function useGetCheckRowDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCheckRowDataQuery,
    GetCheckRowDataQueryVariables
  > &
    (
      | { variables: GetCheckRowDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCheckRowDataQuery, GetCheckRowDataQueryVariables>(
    GetCheckRowDataDocument,
    options,
  );
}
export function useGetCheckRowDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCheckRowDataQuery,
    GetCheckRowDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCheckRowDataQuery,
    GetCheckRowDataQueryVariables
  >(GetCheckRowDataDocument, options);
}
// @ts-ignore
export function useGetCheckRowDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCheckRowDataQuery,
    GetCheckRowDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCheckRowDataQuery,
  GetCheckRowDataQueryVariables
>;
export function useGetCheckRowDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCheckRowDataQuery,
        GetCheckRowDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCheckRowDataQuery | undefined,
  GetCheckRowDataQueryVariables
>;
export function useGetCheckRowDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCheckRowDataQuery,
        GetCheckRowDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCheckRowDataQuery,
    GetCheckRowDataQueryVariables
  >(GetCheckRowDataDocument, options);
}
export type GetCheckRowDataQueryHookResult = ReturnType<
  typeof useGetCheckRowDataQuery
>;
export type GetCheckRowDataLazyQueryHookResult = ReturnType<
  typeof useGetCheckRowDataLazyQuery
>;
export type GetCheckRowDataSuspenseQueryHookResult = ReturnType<
  typeof useGetCheckRowDataSuspenseQuery
>;
export type GetCheckRowDataQueryResult = Apollo.QueryResult<
  GetCheckRowDataQuery,
  GetCheckRowDataQueryVariables
>;
export const GetCheckScoresDocument = gql`
  query GetCheckScores(
    $entityMrn: String!
    $first: Int
    $after: String
    $orderBy: CheckScoreOrder
    $filter: CheckScoreFilter
  ) {
    checkScores(
      entityMrn: $entityMrn
      first: $first
      after: $after
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on CheckScoresConnection {
        totalCount
        filteredTotalCount
        edges {
          cursor
          node {
            mrn
            id
            title
            state
            iconId
            baseScore
            riskValue
            queryState
            severity
            resultType
            impactRating
            rating
            riskFactors {
              mrn
              indicator
              title
              affected
              total
              isPositive
            }
            lastUpdated
            tags {
              key
              value
            }
            asset {
              id
              mrn
              name
              icon
            }
            platform {
              name
              title
              arch
              version
              kind
              runtime
              release
            }
            exception {
              id
              exceptionId
              exceptionMrn
              reviewStatus
              status
              action
              justification
              createdAt
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetCheckScoresQuery__
 *
 * To run a query within a React component, call `useGetCheckScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckScoresQuery({
 *   variables: {
 *      entityMrn: // value for 'entityMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCheckScoresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCheckScoresQuery,
    GetCheckScoresQueryVariables
  > &
    (
      | { variables: GetCheckScoresQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCheckScoresQuery, GetCheckScoresQueryVariables>(
    GetCheckScoresDocument,
    options,
  );
}
export function useGetCheckScoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCheckScoresQuery,
    GetCheckScoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCheckScoresQuery, GetCheckScoresQueryVariables>(
    GetCheckScoresDocument,
    options,
  );
}
// @ts-ignore
export function useGetCheckScoresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCheckScoresQuery,
    GetCheckScoresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCheckScoresQuery,
  GetCheckScoresQueryVariables
>;
export function useGetCheckScoresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCheckScoresQuery,
        GetCheckScoresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCheckScoresQuery | undefined,
  GetCheckScoresQueryVariables
>;
export function useGetCheckScoresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCheckScoresQuery,
        GetCheckScoresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCheckScoresQuery,
    GetCheckScoresQueryVariables
  >(GetCheckScoresDocument, options);
}
export type GetCheckScoresQueryHookResult = ReturnType<
  typeof useGetCheckScoresQuery
>;
export type GetCheckScoresLazyQueryHookResult = ReturnType<
  typeof useGetCheckScoresLazyQuery
>;
export type GetCheckScoresSuspenseQueryHookResult = ReturnType<
  typeof useGetCheckScoresSuspenseQuery
>;
export type GetCheckScoresQueryResult = Apollo.QueryResult<
  GetCheckScoresQuery,
  GetCheckScoresQueryVariables
>;
export const GetChecksDocument = gql`
  query GetChecks(
    $scopeMrn: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        totalCount
        filteredTotalCount
        edges {
          cursor
          node {
            ... on CheckFinding {
              id
              mrn
              title
              asset {
                id
                mrn
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
              rating
              state
              resultType
              riskValue
              state
              lastUpdated
              tags {
                key
                value
              }
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              exception {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                action
                justification
                author {
                  name
                  mrn
                  email
                  type
                }
                createdAt
              }
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetChecksQuery__
 *
 * To run a query within a React component, call `useGetChecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChecksQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetChecksQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChecksQuery,
    GetChecksQueryVariables
  > &
    (
      | { variables: GetChecksQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChecksQuery, GetChecksQueryVariables>(
    GetChecksDocument,
    options,
  );
}
export function useGetChecksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChecksQuery,
    GetChecksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChecksQuery, GetChecksQueryVariables>(
    GetChecksDocument,
    options,
  );
}
// @ts-ignore
export function useGetChecksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetChecksQuery,
    GetChecksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetChecksQuery, GetChecksQueryVariables>;
export function useGetChecksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChecksQuery, GetChecksQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetChecksQuery | undefined,
  GetChecksQueryVariables
>;
export function useGetChecksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChecksQuery, GetChecksQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetChecksQuery, GetChecksQueryVariables>(
    GetChecksDocument,
    options,
  );
}
export type GetChecksQueryHookResult = ReturnType<typeof useGetChecksQuery>;
export type GetChecksLazyQueryHookResult = ReturnType<
  typeof useGetChecksLazyQuery
>;
export type GetChecksSuspenseQueryHookResult = ReturnType<
  typeof useGetChecksSuspenseQuery
>;
export type GetChecksQueryResult = Apollo.QueryResult<
  GetChecksQuery,
  GetChecksQueryVariables
>;
export const GetClientIntegrationDocument = gql`
  query GetClientIntegration($mrn: String!) {
    clientIntegration(input: { mrn: $mrn }) {
      integration {
        mrn
        name
        status
        type
        created
        lastModified
        scanJobAttempted
        scanJobStarted
        scanJobFinished
        lastCheckin
        lastStateInfo {
          ... on K8sIntegrationLastState {
            namespace
            k8sVersion
            operatorVersion
          }
        }
        evaluatedConfigurations {
          option
          configured
          applied
          msg
          msgStatus
          operatorMsg
          operatorMsgStatus
        }
        messages {
          message
          status
          identifier
          timestamp
          suppressedByUser
        }
        labels {
          key
          value
        }
        createdBy {
          name
          email
        }
        configurationOptions {
          ... on AWSConfigurationOptions {
            accountIds
            awsAccountId
            cloudFormationQuickcreateUrl
            useWif
            wifAuthBindingMrn
            region
            isOrganization
            scanConfiguration {
              ec2ScanOptions {
                ebsScanOptions {
                  maxAsgInstances
                  targetInstancesPerScanner
                }
                ebsVolumeScan
                vaultType
                tagsFilter
                excludedTagsFilter
                regionsFilter
                excludedRegionsFilter
                instanceIdsFilter
                excludedInstanceIdsFilter
                secretsMetadataQuery
                awsSecretsManagerVault
                ssm
                instanceConnect
              }
              eventScanTriggers {
                eventDetailType
                eventSource
                scanType
              }
              ecrScan
              ecsScan
              cronScaninHours
              accountScan
              ec2Scan
              propagateAccountTags
              vpcConfiguration {
                CIDR
                vpcFlavour
                vpcTag {
                  key
                  value
                }
              }
            }
            snsEndpoint
            originAWSAccountId
            cloudFormationTemplateUrl
          }
          ... on HostedAwsConfigurationOptions {
            accessKeyId
            role
            wifAudience
            wifRoleArn
            wifSubject
          }
          ... on K8sConfigurationOptions {
            scanNodes
            scanNodesStyle
            scanWorkloads
            scanDeploys
            certificateManager
            scanPublicImages
            namespaceAllowList
            namespaceDenyList
          }
          ... on AzureConfigurationOptions {
            tenantId
            clientId
            subscriptionsWhitelist
            subscriptionsBlacklist
            scanVms
            secretType
          }
          ... on BigqueryConfigurationOptions {
            datasetId
            wifAudience
            wifServiceAccountEmail
            wifSubject
          }
          ... on SnowflakeConfigurationOptions {
            accountId
            database
            schema
            region
            warehouse
            role
            username
          }
          ... on AwsS3ConfigurationOptions {
            output
            bucket
            region
            accessKey
          }
          ... on S3ConfigurationOptions {
            output
            endpoint
            bucket
            useLegacyList
            usePathStyle
            accessKey
          }
          ... on Ms365ConfigurationOptions {
            tenantId
            clientId
          }
          ... on MicrosoftDefenderConfigurationOptions {
            tenantId
            clientId
            subscriptionsAllowlist
            subscriptionsDenylist
            secretType
            createAssets
            mondooEnrichment
          }
          ... on GcpConfigurationOptions {
            projectId
            organizationId
            discoverAll
            wifAudience
            wifServiceAccountEmail
            wifSubject
          }
          ... on GithubConfigurationOptions {
            owner
            repository
            githubOrg: organization
            githubType: type
            reposAllowList
            reposDenyList
            githubDiscoverK8sManifests: discoverK8sManifests
            githubDiscoverTerraform: discoverTerraform
            enterpriseUrl
          }
          ... on OktaConfigurationOptions {
            organization
          }
          ... on GitlabConfigurationOptions {
            group
            type
            discoverGroups
            discoverProjects
            discoverTerraform
            discoverK8sManifests
            baseUrl
          }
          ... on GoogleWorkspaceConfigurationOptions {
            impersonatedUserEmail
            customerId
          }
          ... on GcsBucketConfigurationOptions {
            output
            bucket
            wifAudience
            wifServiceAccountEmail
            wifSubject
          }
          ... on HostConfigurationOptions {
            host
            https
            http
            discoverSubdomains
          }
          ... on PostgresConfigurationOptions {
            host
            port
            database
            user
          }
          ... on JiraConfigurationOptions {
            host
            email
            autoCloseTickets
            autoCreateCases
            defaultProject
            cloudId
          }
          ... on EmailConfigurationOptions {
            autoCreateTickets
            recipients {
              name
              email
              isDefault
              referenceUrl
            }
          }
          ... on ShodanConfigurationOptions {
            token
            targets
          }
          ... on ZendeskConfigurationOptions {
            subdomain
            email
            autoCloseTickets
            autoCreateTickets
            customFields {
              id
              value
            }
          }
          ... on GithubTicketingConfigurationOptions {
            enterpriseUrl
            defaultRepoOwner
            defaultRepoName
            autoCloseTickets
            autoCreateTickets
          }
          ... on GitlabTicketingConfigurationOptions {
            gitlabBaseUrl: baseUrl
            gitlabDefaultProject: defaultProject
            autoCloseTickets
            autoCreateTickets
          }
          ... on AzureDevopsConfigurationOptions {
            defaultProjectName
            organizationUrl
            servicePrincipalId
            tenantId
            autoCloseTickets
            autoCreateTickets
          }
          ... on WebhookConfigurationOptions {
            url
            autoCreateTickets
            autoCloseTickets
          }
          ... on ServiceNowConfigurationOptions {
            instanceUrl
            clientId
            autoCloseTickets
            autoCreateTickets
            userEmail
          }
          ... on OciConfigurationOptions {
            tenancyOcid
            userOcid
            region
            fingerprint
          }
          ... on AzureBlobConfigurationOptions {
            output
          }
          ... on SentinelOneConfigurationOptions {
            host
            account
            secretType
            createAssets
            mondooEnrichment
          }
          ... on CrowdstrikeFalconConfigurationOptions {
            clientId
            cloud
            memberCID
            createAssets
            mondooEnrichment
          }
          ... on SecurityPipelineGithubConfigurationOptions {
            appInstallationLink
            publicKey
            autoCreateWorkflows
            repositories {
              link
              fullName
              spaceMrn
            }
          }
        }
        assetCounts {
          assetType
          total
        }
      }
    }
  }
`;

/**
 * __useGetClientIntegrationQuery__
 *
 * To run a query within a React component, call `useGetClientIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientIntegrationQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useGetClientIntegrationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientIntegrationQuery,
    GetClientIntegrationQueryVariables
  > &
    (
      | { variables: GetClientIntegrationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClientIntegrationQuery,
    GetClientIntegrationQueryVariables
  >(GetClientIntegrationDocument, options);
}
export function useGetClientIntegrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientIntegrationQuery,
    GetClientIntegrationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClientIntegrationQuery,
    GetClientIntegrationQueryVariables
  >(GetClientIntegrationDocument, options);
}
// @ts-ignore
export function useGetClientIntegrationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetClientIntegrationQuery,
    GetClientIntegrationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetClientIntegrationQuery,
  GetClientIntegrationQueryVariables
>;
export function useGetClientIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetClientIntegrationQuery,
        GetClientIntegrationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetClientIntegrationQuery | undefined,
  GetClientIntegrationQueryVariables
>;
export function useGetClientIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetClientIntegrationQuery,
        GetClientIntegrationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetClientIntegrationQuery,
    GetClientIntegrationQueryVariables
  >(GetClientIntegrationDocument, options);
}
export type GetClientIntegrationQueryHookResult = ReturnType<
  typeof useGetClientIntegrationQuery
>;
export type GetClientIntegrationLazyQueryHookResult = ReturnType<
  typeof useGetClientIntegrationLazyQuery
>;
export type GetClientIntegrationSuspenseQueryHookResult = ReturnType<
  typeof useGetClientIntegrationSuspenseQuery
>;
export type GetClientIntegrationQueryResult = Apollo.QueryResult<
  GetClientIntegrationQuery,
  GetClientIntegrationQueryVariables
>;
export const GetClientIntegrationDeleteCommandDocument = gql`
  query GetClientIntegrationDeleteCommand(
    $input: GetClientIntegrationDeleteCommandInput!
  ) {
    getClientIntegrationDeleteCommand(input: $input) {
      message
    }
  }
`;

/**
 * __useGetClientIntegrationDeleteCommandQuery__
 *
 * To run a query within a React component, call `useGetClientIntegrationDeleteCommandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientIntegrationDeleteCommandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientIntegrationDeleteCommandQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientIntegrationDeleteCommandQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientIntegrationDeleteCommandQuery,
    GetClientIntegrationDeleteCommandQueryVariables
  > &
    (
      | {
          variables: GetClientIntegrationDeleteCommandQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClientIntegrationDeleteCommandQuery,
    GetClientIntegrationDeleteCommandQueryVariables
  >(GetClientIntegrationDeleteCommandDocument, options);
}
export function useGetClientIntegrationDeleteCommandLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientIntegrationDeleteCommandQuery,
    GetClientIntegrationDeleteCommandQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClientIntegrationDeleteCommandQuery,
    GetClientIntegrationDeleteCommandQueryVariables
  >(GetClientIntegrationDeleteCommandDocument, options);
}
// @ts-ignore
export function useGetClientIntegrationDeleteCommandSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetClientIntegrationDeleteCommandQuery,
    GetClientIntegrationDeleteCommandQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetClientIntegrationDeleteCommandQuery,
  GetClientIntegrationDeleteCommandQueryVariables
>;
export function useGetClientIntegrationDeleteCommandSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetClientIntegrationDeleteCommandQuery,
        GetClientIntegrationDeleteCommandQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetClientIntegrationDeleteCommandQuery | undefined,
  GetClientIntegrationDeleteCommandQueryVariables
>;
export function useGetClientIntegrationDeleteCommandSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetClientIntegrationDeleteCommandQuery,
        GetClientIntegrationDeleteCommandQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetClientIntegrationDeleteCommandQuery,
    GetClientIntegrationDeleteCommandQueryVariables
  >(GetClientIntegrationDeleteCommandDocument, options);
}
export type GetClientIntegrationDeleteCommandQueryHookResult = ReturnType<
  typeof useGetClientIntegrationDeleteCommandQuery
>;
export type GetClientIntegrationDeleteCommandLazyQueryHookResult = ReturnType<
  typeof useGetClientIntegrationDeleteCommandLazyQuery
>;
export type GetClientIntegrationDeleteCommandSuspenseQueryHookResult =
  ReturnType<typeof useGetClientIntegrationDeleteCommandSuspenseQuery>;
export type GetClientIntegrationDeleteCommandQueryResult = Apollo.QueryResult<
  GetClientIntegrationDeleteCommandQuery,
  GetClientIntegrationDeleteCommandQueryVariables
>;
export const GetClientIntegrationTokenDocument = gql`
  query GetClientIntegrationToken($input: GetClientIntegrationTokenInput!) {
    getClientIntegrationToken(input: $input) {
      token
    }
  }
`;

/**
 * __useGetClientIntegrationTokenQuery__
 *
 * To run a query within a React component, call `useGetClientIntegrationTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientIntegrationTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientIntegrationTokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientIntegrationTokenQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientIntegrationTokenQuery,
    GetClientIntegrationTokenQueryVariables
  > &
    (
      | { variables: GetClientIntegrationTokenQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClientIntegrationTokenQuery,
    GetClientIntegrationTokenQueryVariables
  >(GetClientIntegrationTokenDocument, options);
}
export function useGetClientIntegrationTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientIntegrationTokenQuery,
    GetClientIntegrationTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClientIntegrationTokenQuery,
    GetClientIntegrationTokenQueryVariables
  >(GetClientIntegrationTokenDocument, options);
}
// @ts-ignore
export function useGetClientIntegrationTokenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetClientIntegrationTokenQuery,
    GetClientIntegrationTokenQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetClientIntegrationTokenQuery,
  GetClientIntegrationTokenQueryVariables
>;
export function useGetClientIntegrationTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetClientIntegrationTokenQuery,
        GetClientIntegrationTokenQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetClientIntegrationTokenQuery | undefined,
  GetClientIntegrationTokenQueryVariables
>;
export function useGetClientIntegrationTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetClientIntegrationTokenQuery,
        GetClientIntegrationTokenQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetClientIntegrationTokenQuery,
    GetClientIntegrationTokenQueryVariables
  >(GetClientIntegrationTokenDocument, options);
}
export type GetClientIntegrationTokenQueryHookResult = ReturnType<
  typeof useGetClientIntegrationTokenQuery
>;
export type GetClientIntegrationTokenLazyQueryHookResult = ReturnType<
  typeof useGetClientIntegrationTokenLazyQuery
>;
export type GetClientIntegrationTokenSuspenseQueryHookResult = ReturnType<
  typeof useGetClientIntegrationTokenSuspenseQuery
>;
export type GetClientIntegrationTokenQueryResult = Apollo.QueryResult<
  GetClientIntegrationTokenQuery,
  GetClientIntegrationTokenQueryVariables
>;
export const GetComplianceControlDocument = gql`
  query GetComplianceControl($input: ComplianceControlInput!) {
    complianceControl(input: $input) {
      framework {
        name
        version
      }
      mrn
      description
      title
      manual
      completion
      tags {
        key
        value
      }
      state
      assetGroupStatistics {
        count
        groupType
        listsAssetTypes {
          assetType
          aliases
          displayName
          shortName
        }
        statistics {
          count
          type {
            assetType
            aliases
            displayName
            shortName
          }
        }
      }
      assetsStats {
        compliantAssets
        failedAssets
        totalAssets
      }
      checksStats {
        activeChecks
        activeQueries
        totalChecks
        totalExceptions
        totalQueries
      }
      exceptions {
        id
        exceptionId
        exceptionMrn
        author {
          name
          mrn
          email
          type
        }
        reviewer {
          name
          email
        }
        createdAt
        modifiedAt
        title
        justification
        reviewStatus
        action
      }
    }
  }
`;

/**
 * __useGetComplianceControlQuery__
 *
 * To run a query within a React component, call `useGetComplianceControlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceControlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceControlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetComplianceControlQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetComplianceControlQuery,
    GetComplianceControlQueryVariables
  > &
    (
      | { variables: GetComplianceControlQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetComplianceControlQuery,
    GetComplianceControlQueryVariables
  >(GetComplianceControlDocument, options);
}
export function useGetComplianceControlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetComplianceControlQuery,
    GetComplianceControlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetComplianceControlQuery,
    GetComplianceControlQueryVariables
  >(GetComplianceControlDocument, options);
}
// @ts-ignore
export function useGetComplianceControlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetComplianceControlQuery,
    GetComplianceControlQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceControlQuery,
  GetComplianceControlQueryVariables
>;
export function useGetComplianceControlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceControlQuery,
        GetComplianceControlQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceControlQuery | undefined,
  GetComplianceControlQueryVariables
>;
export function useGetComplianceControlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceControlQuery,
        GetComplianceControlQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetComplianceControlQuery,
    GetComplianceControlQueryVariables
  >(GetComplianceControlDocument, options);
}
export type GetComplianceControlQueryHookResult = ReturnType<
  typeof useGetComplianceControlQuery
>;
export type GetComplianceControlLazyQueryHookResult = ReturnType<
  typeof useGetComplianceControlLazyQuery
>;
export type GetComplianceControlSuspenseQueryHookResult = ReturnType<
  typeof useGetComplianceControlSuspenseQuery
>;
export type GetComplianceControlQueryResult = Apollo.QueryResult<
  GetComplianceControlQuery,
  GetComplianceControlQueryVariables
>;
export const GetComplianceControlAssetsDocument = gql`
  query GetComplianceControlAssets(
    $input: ComplianceControlInput!
    $assetsInput: ComplianceAssetsSearchInput!
  ) {
    complianceControl(input: $input) {
      mrn
      description
      title
      assets(input: $assetsInput) {
        totalCount
        edges {
          cursor
          node {
            asset {
              id
              mrn
              state
              name
              labels {
                key
                value
              }
              updatedAt
              platform {
                name
                title
                arch
                version
                kind
                runtime
                release
              }
              score {
                id
                value
                type
                completion
                weight
                message
                grade
              }
              referenceIDs
              annotations {
                key
                value
              }
              asset_type
            }
            compliancePercentage
            exception {
              author {
                name
                mrn
                email
                type
              }
              createdAt
              action
              id
              exceptionId
              exceptionMrn
              reviewStatus
              status
              title
              justification
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;

/**
 * __useGetComplianceControlAssetsQuery__
 *
 * To run a query within a React component, call `useGetComplianceControlAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceControlAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceControlAssetsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      assetsInput: // value for 'assetsInput'
 *   },
 * });
 */
export function useGetComplianceControlAssetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetComplianceControlAssetsQuery,
    GetComplianceControlAssetsQueryVariables
  > &
    (
      | { variables: GetComplianceControlAssetsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetComplianceControlAssetsQuery,
    GetComplianceControlAssetsQueryVariables
  >(GetComplianceControlAssetsDocument, options);
}
export function useGetComplianceControlAssetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetComplianceControlAssetsQuery,
    GetComplianceControlAssetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetComplianceControlAssetsQuery,
    GetComplianceControlAssetsQueryVariables
  >(GetComplianceControlAssetsDocument, options);
}
// @ts-ignore
export function useGetComplianceControlAssetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetComplianceControlAssetsQuery,
    GetComplianceControlAssetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceControlAssetsQuery,
  GetComplianceControlAssetsQueryVariables
>;
export function useGetComplianceControlAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceControlAssetsQuery,
        GetComplianceControlAssetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceControlAssetsQuery | undefined,
  GetComplianceControlAssetsQueryVariables
>;
export function useGetComplianceControlAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceControlAssetsQuery,
        GetComplianceControlAssetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetComplianceControlAssetsQuery,
    GetComplianceControlAssetsQueryVariables
  >(GetComplianceControlAssetsDocument, options);
}
export type GetComplianceControlAssetsQueryHookResult = ReturnType<
  typeof useGetComplianceControlAssetsQuery
>;
export type GetComplianceControlAssetsLazyQueryHookResult = ReturnType<
  typeof useGetComplianceControlAssetsLazyQuery
>;
export type GetComplianceControlAssetsSuspenseQueryHookResult = ReturnType<
  typeof useGetComplianceControlAssetsSuspenseQuery
>;
export type GetComplianceControlAssetsQueryResult = Apollo.QueryResult<
  GetComplianceControlAssetsQuery,
  GetComplianceControlAssetsQueryVariables
>;
export const GetComplianceControlChecksDocument = gql`
  query GetComplianceControlChecks(
    $input: ComplianceControlInput!
    $checksInput: ChecksSearchInput!
    $first: Int
    $after: String
  ) {
    complianceControl(input: $input) {
      mrn
      description
      title
      checks(input: $checksInput, first: $first, after: $after) {
        totalCount
        edges {
          cursor
          node {
            ... on PolicyCheck {
              state
              policyName
              policyMrn
              completion
              assets
            }
            ... on QueryCheck {
              exception {
                id
                exceptionId
                exceptionMrn
                action
                justification
                reviewStatus
                status
              }
              state
              refs {
                ... on QueryPackCheckRef {
                  name
                  mrn
                  group
                }
                ... on PolicyCheckRef {
                  name
                  mrn
                  group
                }
              }
              mquery {
                action
                impact {
                  rating
                  value
                }
                uid
                title
                mrn
              }
              completion
              assets
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;

/**
 * __useGetComplianceControlChecksQuery__
 *
 * To run a query within a React component, call `useGetComplianceControlChecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceControlChecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceControlChecksQuery({
 *   variables: {
 *      input: // value for 'input'
 *      checksInput: // value for 'checksInput'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetComplianceControlChecksQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetComplianceControlChecksQuery,
    GetComplianceControlChecksQueryVariables
  > &
    (
      | { variables: GetComplianceControlChecksQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetComplianceControlChecksQuery,
    GetComplianceControlChecksQueryVariables
  >(GetComplianceControlChecksDocument, options);
}
export function useGetComplianceControlChecksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetComplianceControlChecksQuery,
    GetComplianceControlChecksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetComplianceControlChecksQuery,
    GetComplianceControlChecksQueryVariables
  >(GetComplianceControlChecksDocument, options);
}
// @ts-ignore
export function useGetComplianceControlChecksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetComplianceControlChecksQuery,
    GetComplianceControlChecksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceControlChecksQuery,
  GetComplianceControlChecksQueryVariables
>;
export function useGetComplianceControlChecksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceControlChecksQuery,
        GetComplianceControlChecksQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceControlChecksQuery | undefined,
  GetComplianceControlChecksQueryVariables
>;
export function useGetComplianceControlChecksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceControlChecksQuery,
        GetComplianceControlChecksQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetComplianceControlChecksQuery,
    GetComplianceControlChecksQueryVariables
  >(GetComplianceControlChecksDocument, options);
}
export type GetComplianceControlChecksQueryHookResult = ReturnType<
  typeof useGetComplianceControlChecksQuery
>;
export type GetComplianceControlChecksLazyQueryHookResult = ReturnType<
  typeof useGetComplianceControlChecksLazyQuery
>;
export type GetComplianceControlChecksSuspenseQueryHookResult = ReturnType<
  typeof useGetComplianceControlChecksSuspenseQuery
>;
export type GetComplianceControlChecksQueryResult = Apollo.QueryResult<
  GetComplianceControlChecksQuery,
  GetComplianceControlChecksQueryVariables
>;
export const GetComplianceControlDataQueriesDocument = gql`
  query GetComplianceControlDataQueries(
    $input: ComplianceControlInput!
    $dataQueriesInput: ChecksSearchInput!
    $first: Int
    $after: String
  ) {
    complianceControl(input: $input) {
      mrn
      dataQueries(input: $dataQueriesInput, first: $first, after: $after) {
        totalCount
        edges {
          cursor
          node {
            assets
            completion
            mquery {
              action
              docs {
                desc
                remediations {
                  ... on Remediations {
                    entries {
                      id
                      desc
                    }
                  }
                  ... on AuthenticationRequired {
                    message
                    code
                  }
                }
                references {
                  title
                  url
                }
              }
              impact {
                value
                rating
              }
              mql
              mrn
              parent
              properties {
                uid
                title
                setByPolicyMrn
                mrn
                mql
                defaultValue
                overrideValue
                for {
                  mrn
                }
              }
              tags {
                key
                value
              }
              title
              uid
              variantQueries {
                filter
                filterID
                impact {
                  value
                  rating
                }
                mql
                mrn
                properties {
                  mql
                  mrn
                  defaultValue
                  overrideValue
                  setByPolicyMrn
                  title
                  uid
                  for {
                    mrn
                  }
                }
                tags {
                  key
                  value
                }
                title
                uid
                docs {
                  desc
                  references {
                    title
                    url
                  }
                  remediations {
                    ... on Remediations {
                      entries {
                        id
                        desc
                      }
                    }
                    ... on AuthenticationRequired {
                      message
                      code
                    }
                  }
                }
              }
              variants {
                id
                icon
              }
            }
            queryStats {
              total
              passed
              failed
              incomplete
              errors
              skipped
              worst
              unknown
            }
            refs {
              ... on QueryPackCheckRef {
                name
                mrn
                group
              }
              ... on PolicyCheckRef {
                name
                mrn
                group
              }
            }
            state
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetComplianceControlDataQueriesQuery__
 *
 * To run a query within a React component, call `useGetComplianceControlDataQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceControlDataQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceControlDataQueriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      dataQueriesInput: // value for 'dataQueriesInput'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetComplianceControlDataQueriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetComplianceControlDataQueriesQuery,
    GetComplianceControlDataQueriesQueryVariables
  > &
    (
      | {
          variables: GetComplianceControlDataQueriesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetComplianceControlDataQueriesQuery,
    GetComplianceControlDataQueriesQueryVariables
  >(GetComplianceControlDataQueriesDocument, options);
}
export function useGetComplianceControlDataQueriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetComplianceControlDataQueriesQuery,
    GetComplianceControlDataQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetComplianceControlDataQueriesQuery,
    GetComplianceControlDataQueriesQueryVariables
  >(GetComplianceControlDataQueriesDocument, options);
}
// @ts-ignore
export function useGetComplianceControlDataQueriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetComplianceControlDataQueriesQuery,
    GetComplianceControlDataQueriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceControlDataQueriesQuery,
  GetComplianceControlDataQueriesQueryVariables
>;
export function useGetComplianceControlDataQueriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceControlDataQueriesQuery,
        GetComplianceControlDataQueriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceControlDataQueriesQuery | undefined,
  GetComplianceControlDataQueriesQueryVariables
>;
export function useGetComplianceControlDataQueriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceControlDataQueriesQuery,
        GetComplianceControlDataQueriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetComplianceControlDataQueriesQuery,
    GetComplianceControlDataQueriesQueryVariables
  >(GetComplianceControlDataQueriesDocument, options);
}
export type GetComplianceControlDataQueriesQueryHookResult = ReturnType<
  typeof useGetComplianceControlDataQueriesQuery
>;
export type GetComplianceControlDataQueriesLazyQueryHookResult = ReturnType<
  typeof useGetComplianceControlDataQueriesLazyQuery
>;
export type GetComplianceControlDataQueriesSuspenseQueryHookResult = ReturnType<
  typeof useGetComplianceControlDataQueriesSuspenseQuery
>;
export type GetComplianceControlDataQueriesQueryResult = Apollo.QueryResult<
  GetComplianceControlDataQueriesQuery,
  GetComplianceControlDataQueriesQueryVariables
>;
export const GetComplianceFrameworkDocument = gql`
  query GetComplianceFramework($input: ComplianceFrameworkInput!) {
    complianceFramework(input: $input) {
      mrn
      name
      version
      createdAt
      modifiedAt
      authors {
        name
        email
        type
      }
      tags {
        key
        value
      }
      description
      summary
      stats {
        controls {
          activeControls
          averageCompletion
          outOfScopeControls
          previousAverageCompletion
          totalControls
          totalExceptions
        }
        checks
        assets
        exceptions
      }
      state
      policiesMrns
      scopeMrn
      completion
      assetGroupStatistics {
        listsAssetTypes {
          assetType
          aliases
          displayName
          shortName
        }
        groupType
        count
        statistics {
          type {
            assetType
            aliases
            displayName
            shortName
          }
          count
        }
      }
      previousCompletionScores {
        entries {
          score
          timestamp
        }
      }
    }
  }
`;

/**
 * __useGetComplianceFrameworkQuery__
 *
 * To run a query within a React component, call `useGetComplianceFrameworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceFrameworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceFrameworkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetComplianceFrameworkQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetComplianceFrameworkQuery,
    GetComplianceFrameworkQueryVariables
  > &
    (
      | { variables: GetComplianceFrameworkQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetComplianceFrameworkQuery,
    GetComplianceFrameworkQueryVariables
  >(GetComplianceFrameworkDocument, options);
}
export function useGetComplianceFrameworkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetComplianceFrameworkQuery,
    GetComplianceFrameworkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetComplianceFrameworkQuery,
    GetComplianceFrameworkQueryVariables
  >(GetComplianceFrameworkDocument, options);
}
// @ts-ignore
export function useGetComplianceFrameworkSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetComplianceFrameworkQuery,
    GetComplianceFrameworkQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceFrameworkQuery,
  GetComplianceFrameworkQueryVariables
>;
export function useGetComplianceFrameworkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceFrameworkQuery,
        GetComplianceFrameworkQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceFrameworkQuery | undefined,
  GetComplianceFrameworkQueryVariables
>;
export function useGetComplianceFrameworkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceFrameworkQuery,
        GetComplianceFrameworkQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetComplianceFrameworkQuery,
    GetComplianceFrameworkQueryVariables
  >(GetComplianceFrameworkDocument, options);
}
export type GetComplianceFrameworkQueryHookResult = ReturnType<
  typeof useGetComplianceFrameworkQuery
>;
export type GetComplianceFrameworkLazyQueryHookResult = ReturnType<
  typeof useGetComplianceFrameworkLazyQuery
>;
export type GetComplianceFrameworkSuspenseQueryHookResult = ReturnType<
  typeof useGetComplianceFrameworkSuspenseQuery
>;
export type GetComplianceFrameworkQueryResult = Apollo.QueryResult<
  GetComplianceFrameworkQuery,
  GetComplianceFrameworkQueryVariables
>;
export const GetComplianceFrameworkAssetsDocument = gql`
  query GetComplianceFrameworkAssets(
    $input: ComplianceFrameworkInput!
    $assetsInput: ComplianceAssetsSearchInput!
  ) {
    complianceFramework(input: $input) {
      mrn
      name
      assetGroupStatistics {
        listsAssetTypes {
          assetType
          aliases
          displayName
          shortName
        }
        groupType
        count
        statistics {
          type {
            assetType
            aliases
            displayName
            shortName
          }
          count
        }
      }
      assets(input: $assetsInput) {
        totalCount
        edges {
          cursor
          node {
            compliancePercentage
            asset {
              id
              mrn
              state
              name
              labels {
                key
                value
              }
              updatedAt
              platform {
                name
                title
                arch
                version
                kind
                runtime
                release
              }
              score {
                completion
                grade
                id
                message
                type
                value
                weight
              }
              referenceIDs
              annotations {
                key
                value
              }
              asset_type
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetComplianceFrameworkAssetsQuery__
 *
 * To run a query within a React component, call `useGetComplianceFrameworkAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceFrameworkAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceFrameworkAssetsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      assetsInput: // value for 'assetsInput'
 *   },
 * });
 */
export function useGetComplianceFrameworkAssetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetComplianceFrameworkAssetsQuery,
    GetComplianceFrameworkAssetsQueryVariables
  > &
    (
      | {
          variables: GetComplianceFrameworkAssetsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetComplianceFrameworkAssetsQuery,
    GetComplianceFrameworkAssetsQueryVariables
  >(GetComplianceFrameworkAssetsDocument, options);
}
export function useGetComplianceFrameworkAssetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetComplianceFrameworkAssetsQuery,
    GetComplianceFrameworkAssetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetComplianceFrameworkAssetsQuery,
    GetComplianceFrameworkAssetsQueryVariables
  >(GetComplianceFrameworkAssetsDocument, options);
}
// @ts-ignore
export function useGetComplianceFrameworkAssetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetComplianceFrameworkAssetsQuery,
    GetComplianceFrameworkAssetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceFrameworkAssetsQuery,
  GetComplianceFrameworkAssetsQueryVariables
>;
export function useGetComplianceFrameworkAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceFrameworkAssetsQuery,
        GetComplianceFrameworkAssetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceFrameworkAssetsQuery | undefined,
  GetComplianceFrameworkAssetsQueryVariables
>;
export function useGetComplianceFrameworkAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceFrameworkAssetsQuery,
        GetComplianceFrameworkAssetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetComplianceFrameworkAssetsQuery,
    GetComplianceFrameworkAssetsQueryVariables
  >(GetComplianceFrameworkAssetsDocument, options);
}
export type GetComplianceFrameworkAssetsQueryHookResult = ReturnType<
  typeof useGetComplianceFrameworkAssetsQuery
>;
export type GetComplianceFrameworkAssetsLazyQueryHookResult = ReturnType<
  typeof useGetComplianceFrameworkAssetsLazyQuery
>;
export type GetComplianceFrameworkAssetsSuspenseQueryHookResult = ReturnType<
  typeof useGetComplianceFrameworkAssetsSuspenseQuery
>;
export type GetComplianceFrameworkAssetsQueryResult = Apollo.QueryResult<
  GetComplianceFrameworkAssetsQuery,
  GetComplianceFrameworkAssetsQueryVariables
>;
export const GetComplianceFrameworkControlsDocument = gql`
  query GetComplianceFrameworkControls(
    $input: ComplianceFrameworkInput!
    $controlsInput: ControlsSearchInput!
  ) {
    complianceFramework(input: $input) {
      mrn
      name
      controls(input: $controlsInput) {
        totalCount
        edges {
          cursor
          node {
            mrn
            description
            title
            manual
            completion
            tags {
              key
              value
            }
            state
            assetsStats {
              compliantAssets
              failedAssets
              totalAssets
            }
            checksStats {
              activeChecks
              snoozedChecks
              disabledChecks
              totalChecks
              totalQueries
            }
            exception {
              author {
                name
                mrn
                email
                type
              }
              createdAt
              action
              id
              exceptionId
              exceptionMrn
              reviewStatus
              status
              title
              justification
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;

/**
 * __useGetComplianceFrameworkControlsQuery__
 *
 * To run a query within a React component, call `useGetComplianceFrameworkControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceFrameworkControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceFrameworkControlsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      controlsInput: // value for 'controlsInput'
 *   },
 * });
 */
export function useGetComplianceFrameworkControlsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetComplianceFrameworkControlsQuery,
    GetComplianceFrameworkControlsQueryVariables
  > &
    (
      | {
          variables: GetComplianceFrameworkControlsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetComplianceFrameworkControlsQuery,
    GetComplianceFrameworkControlsQueryVariables
  >(GetComplianceFrameworkControlsDocument, options);
}
export function useGetComplianceFrameworkControlsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetComplianceFrameworkControlsQuery,
    GetComplianceFrameworkControlsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetComplianceFrameworkControlsQuery,
    GetComplianceFrameworkControlsQueryVariables
  >(GetComplianceFrameworkControlsDocument, options);
}
// @ts-ignore
export function useGetComplianceFrameworkControlsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetComplianceFrameworkControlsQuery,
    GetComplianceFrameworkControlsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceFrameworkControlsQuery,
  GetComplianceFrameworkControlsQueryVariables
>;
export function useGetComplianceFrameworkControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceFrameworkControlsQuery,
        GetComplianceFrameworkControlsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceFrameworkControlsQuery | undefined,
  GetComplianceFrameworkControlsQueryVariables
>;
export function useGetComplianceFrameworkControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceFrameworkControlsQuery,
        GetComplianceFrameworkControlsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetComplianceFrameworkControlsQuery,
    GetComplianceFrameworkControlsQueryVariables
  >(GetComplianceFrameworkControlsDocument, options);
}
export type GetComplianceFrameworkControlsQueryHookResult = ReturnType<
  typeof useGetComplianceFrameworkControlsQuery
>;
export type GetComplianceFrameworkControlsLazyQueryHookResult = ReturnType<
  typeof useGetComplianceFrameworkControlsLazyQuery
>;
export type GetComplianceFrameworkControlsSuspenseQueryHookResult = ReturnType<
  typeof useGetComplianceFrameworkControlsSuspenseQuery
>;
export type GetComplianceFrameworkControlsQueryResult = Apollo.QueryResult<
  GetComplianceFrameworkControlsQuery,
  GetComplianceFrameworkControlsQueryVariables
>;
export const GetComplianceFrameworksDocument = gql`
  query GetComplianceFrameworks($input: ComplianceFrameworksInput!) {
    complianceFrameworks(input: $input) {
      authors {
        name
        email
      }
      createdAt
      modifiedAt
      completion
      description
      mrn
      name
      previousCompletionScores {
        entries {
          score
          timestamp
        }
      }
      scopeMrn
      state
      stats {
        controls {
          activeControls
          averageCompletion
          outOfScopeControls
          previousAverageCompletion
          totalControls
          totalExceptions
        }
        checks
        assets
        exceptions
      }
      summary
      version
      tags {
        key
        value
      }
    }
  }
`;

/**
 * __useGetComplianceFrameworksQuery__
 *
 * To run a query within a React component, call `useGetComplianceFrameworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceFrameworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceFrameworksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetComplianceFrameworksQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetComplianceFrameworksQuery,
    GetComplianceFrameworksQueryVariables
  > &
    (
      | { variables: GetComplianceFrameworksQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetComplianceFrameworksQuery,
    GetComplianceFrameworksQueryVariables
  >(GetComplianceFrameworksDocument, options);
}
export function useGetComplianceFrameworksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetComplianceFrameworksQuery,
    GetComplianceFrameworksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetComplianceFrameworksQuery,
    GetComplianceFrameworksQueryVariables
  >(GetComplianceFrameworksDocument, options);
}
// @ts-ignore
export function useGetComplianceFrameworksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetComplianceFrameworksQuery,
    GetComplianceFrameworksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceFrameworksQuery,
  GetComplianceFrameworksQueryVariables
>;
export function useGetComplianceFrameworksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceFrameworksQuery,
        GetComplianceFrameworksQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetComplianceFrameworksQuery | undefined,
  GetComplianceFrameworksQueryVariables
>;
export function useGetComplianceFrameworksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetComplianceFrameworksQuery,
        GetComplianceFrameworksQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetComplianceFrameworksQuery,
    GetComplianceFrameworksQueryVariables
  >(GetComplianceFrameworksDocument, options);
}
export type GetComplianceFrameworksQueryHookResult = ReturnType<
  typeof useGetComplianceFrameworksQuery
>;
export type GetComplianceFrameworksLazyQueryHookResult = ReturnType<
  typeof useGetComplianceFrameworksLazyQuery
>;
export type GetComplianceFrameworksSuspenseQueryHookResult = ReturnType<
  typeof useGetComplianceFrameworksSuspenseQuery
>;
export type GetComplianceFrameworksQueryResult = Apollo.QueryResult<
  GetComplianceFrameworksQuery,
  GetComplianceFrameworksQueryVariables
>;
export const GetContentDocument = gql`
  query GetContent($input: ContentSearchInput!) {
    content(input: $input) {
      totalCount
      edges {
        cursor
        node {
          ... on Policy {
            access
            action
            assigned
            authors {
              email
              name
              type
            }
            category
            summary
            docs
            createdAt
            featured
            trustLevel
            mrn
            name
            statistics {
              checks
              policies
              queries
            }
            uid
            updatedAt
            version
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetContentQuery__
 *
 * To run a query within a React component, call `useGetContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContentQuery,
    GetContentQueryVariables
  > &
    (
      | { variables: GetContentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContentQuery, GetContentQueryVariables>(
    GetContentDocument,
    options,
  );
}
export function useGetContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContentQuery,
    GetContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContentQuery, GetContentQueryVariables>(
    GetContentDocument,
    options,
  );
}
// @ts-ignore
export function useGetContentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContentQuery,
    GetContentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetContentQuery, GetContentQueryVariables>;
export function useGetContentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetContentQuery,
        GetContentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetContentQuery | undefined,
  GetContentQueryVariables
>;
export function useGetContentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetContentQuery,
        GetContentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetContentQuery, GetContentQueryVariables>(
    GetContentDocument,
    options,
  );
}
export type GetContentQueryHookResult = ReturnType<typeof useGetContentQuery>;
export type GetContentLazyQueryHookResult = ReturnType<
  typeof useGetContentLazyQuery
>;
export type GetContentSuspenseQueryHookResult = ReturnType<
  typeof useGetContentSuspenseQuery
>;
export type GetContentQueryResult = Apollo.QueryResult<
  GetContentQuery,
  GetContentQueryVariables
>;
export const GetCveAdvisoriesDocument = gql`
  query GetCveAdvisories(
    $id: ID!
    $scopeMrn: String!
    $advisoriesFirst: Int
    $advisoriesAfter: String
  ) {
    cve(id: $id) {
      id
      mrn
      advisoryAggregateScores(
        first: $advisoriesFirst
        after: $advisoriesAfter
        scopeMrn: $scopeMrn
      ) {
        ... on AggregateScoresConnection {
          totalCount
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          edges {
            cursor
            node {
              id
              iconId
              findingMrn
              scoreType
              state
              effort
              enforcementState
              previewUntil
              spaceRiskImprovement
              description
              remediatedAt
              spaceId
              title
              firstDetectedAt
              riskValue
              rankScore
              rank
              rating
              baseScore
              baseValue
              baseRating
              blastRadius {
                ...BlastRadiusFields
              }
              riskFactors {
                mrn
                indicator
                title
                total
                affected
                isPositive
              }
              detectionSources {
                name
                firstDetectedAt
                lastUpdatedAt
                affectedAssets
                vendor
              }
              slaAtRiskCount
              slaOverdueCount
            }
          }
        }
      }
    }
  }
  ${BlastRadiusFieldsFragmentDoc}
`;

/**
 * __useGetCveAdvisoriesQuery__
 *
 * To run a query within a React component, call `useGetCveAdvisoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCveAdvisoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCveAdvisoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      scopeMrn: // value for 'scopeMrn'
 *      advisoriesFirst: // value for 'advisoriesFirst'
 *      advisoriesAfter: // value for 'advisoriesAfter'
 *   },
 * });
 */
export function useGetCveAdvisoriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCveAdvisoriesQuery,
    GetCveAdvisoriesQueryVariables
  > &
    (
      | { variables: GetCveAdvisoriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCveAdvisoriesQuery, GetCveAdvisoriesQueryVariables>(
    GetCveAdvisoriesDocument,
    options,
  );
}
export function useGetCveAdvisoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCveAdvisoriesQuery,
    GetCveAdvisoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCveAdvisoriesQuery,
    GetCveAdvisoriesQueryVariables
  >(GetCveAdvisoriesDocument, options);
}
// @ts-ignore
export function useGetCveAdvisoriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCveAdvisoriesQuery,
    GetCveAdvisoriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCveAdvisoriesQuery,
  GetCveAdvisoriesQueryVariables
>;
export function useGetCveAdvisoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCveAdvisoriesQuery,
        GetCveAdvisoriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCveAdvisoriesQuery | undefined,
  GetCveAdvisoriesQueryVariables
>;
export function useGetCveAdvisoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCveAdvisoriesQuery,
        GetCveAdvisoriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCveAdvisoriesQuery,
    GetCveAdvisoriesQueryVariables
  >(GetCveAdvisoriesDocument, options);
}
export type GetCveAdvisoriesQueryHookResult = ReturnType<
  typeof useGetCveAdvisoriesQuery
>;
export type GetCveAdvisoriesLazyQueryHookResult = ReturnType<
  typeof useGetCveAdvisoriesLazyQuery
>;
export type GetCveAdvisoriesSuspenseQueryHookResult = ReturnType<
  typeof useGetCveAdvisoriesSuspenseQuery
>;
export type GetCveAdvisoriesQueryResult = Apollo.QueryResult<
  GetCveAdvisoriesQuery,
  GetCveAdvisoriesQueryVariables
>;
export const GetDataQueriesListDocument = gql`
  query GetDataQueriesList(
    $entityMrn: String!
    $first: Int
    $after: String
    $orderBy: DataQueryOrder
    $filter: DataQueryFilter
  ) {
    dataQueries(
      entityMrn: $entityMrn
      first: $first
      after: $after
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on DataQueriesConnection {
        totalCount
        edges {
          cursor
          node {
            mrn
            id
            title
            iconId
            lastUpdated
            tags {
              key
              value
            }
            asset {
              id
              mrn
              name
              icon
            }
            platform {
              name
              title
              arch
              version
              kind
              runtime
              family
              labels {
                key
                value
              }
            }
            mquery {
              uid
              mrn
              title
              mql
              action
              code
              codeId
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        filteredTotalCount
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetDataQueriesListQuery__
 *
 * To run a query within a React component, call `useGetDataQueriesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataQueriesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataQueriesListQuery({
 *   variables: {
 *      entityMrn: // value for 'entityMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDataQueriesListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDataQueriesListQuery,
    GetDataQueriesListQueryVariables
  > &
    (
      | { variables: GetDataQueriesListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDataQueriesListQuery,
    GetDataQueriesListQueryVariables
  >(GetDataQueriesListDocument, options);
}
export function useGetDataQueriesListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDataQueriesListQuery,
    GetDataQueriesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDataQueriesListQuery,
    GetDataQueriesListQueryVariables
  >(GetDataQueriesListDocument, options);
}
// @ts-ignore
export function useGetDataQueriesListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDataQueriesListQuery,
    GetDataQueriesListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDataQueriesListQuery,
  GetDataQueriesListQueryVariables
>;
export function useGetDataQueriesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDataQueriesListQuery,
        GetDataQueriesListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDataQueriesListQuery | undefined,
  GetDataQueriesListQueryVariables
>;
export function useGetDataQueriesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDataQueriesListQuery,
        GetDataQueriesListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDataQueriesListQuery,
    GetDataQueriesListQueryVariables
  >(GetDataQueriesListDocument, options);
}
export type GetDataQueriesListQueryHookResult = ReturnType<
  typeof useGetDataQueriesListQuery
>;
export type GetDataQueriesListLazyQueryHookResult = ReturnType<
  typeof useGetDataQueriesListLazyQuery
>;
export type GetDataQueriesListSuspenseQueryHookResult = ReturnType<
  typeof useGetDataQueriesListSuspenseQuery
>;
export type GetDataQueriesListQueryResult = Apollo.QueryResult<
  GetDataQueriesListQuery,
  GetDataQueriesListQueryVariables
>;
export const GetDataQueryDocument = gql`
  query GetDataQuery(
    $entityMrn: String!
    $first: Int
    $after: String
    $orderBy: DataQueryOrder
    $filter: DataQueryFilter
  ) {
    dataQueries(
      entityMrn: $entityMrn
      first: $first
      after: $after
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on DataQueriesConnection {
        totalCount
        edges {
          cursor
          node {
            mrn
            id
            iconId
            lastUpdated
            tags {
              key
              value
            }
            asset {
              id
              mrn
              name
              icon
            }
            platform {
              name
              title
              arch
              version
              kind
              runtime
              family
              labels {
                key
                value
              }
            }
            value
            mquery {
              uid
              mrn
              title
              docs {
                desc
                remediations {
                  ... on Remediations {
                    entries {
                      id
                      desc
                    }
                  }
                  ... on AuthenticationRequired {
                    message
                    code
                  }
                }
                references {
                  title
                  url
                }
                audit
                remediation
              }
              impact {
                value
                rating
              }
              mql
              tags {
                key
                value
              }
              properties {
                uid
                mrn
                title
                mql
                defaultValue
                overrideValue
                setByPolicyMrn
                for {
                  mrn
                }
              }
              parent
              variants {
                id
                mrn
                title
                icon
              }
              variantQueries {
                uid
                mrn
                title
                mql
                filter
                filterID
              }
              action
              code
              codeId
              severity
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        filteredTotalCount
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetDataQueryQuery__
 *
 * To run a query within a React component, call `useGetDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataQueryQuery({
 *   variables: {
 *      entityMrn: // value for 'entityMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDataQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDataQueryQuery,
    GetDataQueryQueryVariables
  > &
    (
      | { variables: GetDataQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDataQueryQuery, GetDataQueryQueryVariables>(
    GetDataQueryDocument,
    options,
  );
}
export function useGetDataQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDataQueryQuery,
    GetDataQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDataQueryQuery, GetDataQueryQueryVariables>(
    GetDataQueryDocument,
    options,
  );
}
// @ts-ignore
export function useGetDataQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDataQueryQuery,
    GetDataQueryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetDataQueryQuery, GetDataQueryQueryVariables>;
export function useGetDataQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDataQueryQuery,
        GetDataQueryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDataQueryQuery | undefined,
  GetDataQueryQueryVariables
>;
export function useGetDataQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDataQueryQuery,
        GetDataQueryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDataQueryQuery, GetDataQueryQueryVariables>(
    GetDataQueryDocument,
    options,
  );
}
export type GetDataQueryQueryHookResult = ReturnType<
  typeof useGetDataQueryQuery
>;
export type GetDataQueryLazyQueryHookResult = ReturnType<
  typeof useGetDataQueryLazyQuery
>;
export type GetDataQuerySuspenseQueryHookResult = ReturnType<
  typeof useGetDataQuerySuspenseQuery
>;
export type GetDataQueryQueryResult = Apollo.QueryResult<
  GetDataQueryQuery,
  GetDataQueryQueryVariables
>;
export const GetEvidenceDocument = gql`
  query GetEvidence($input: EvidenceInput!) {
    evidence(input: $input) {
      items {
        id
        vexMrn
        details {
          ... on EvidenceFile {
            path
          }
          ... on EvidenceRegistryKey {
            path
            name
            data
          }
        }
        source
      }
    }
  }
`;

/**
 * __useGetEvidenceQuery__
 *
 * To run a query within a React component, call `useGetEvidenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEvidenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEvidenceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEvidenceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEvidenceQuery,
    GetEvidenceQueryVariables
  > &
    (
      | { variables: GetEvidenceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEvidenceQuery, GetEvidenceQueryVariables>(
    GetEvidenceDocument,
    options,
  );
}
export function useGetEvidenceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEvidenceQuery,
    GetEvidenceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEvidenceQuery, GetEvidenceQueryVariables>(
    GetEvidenceDocument,
    options,
  );
}
// @ts-ignore
export function useGetEvidenceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEvidenceQuery,
    GetEvidenceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetEvidenceQuery, GetEvidenceQueryVariables>;
export function useGetEvidenceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEvidenceQuery,
        GetEvidenceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEvidenceQuery | undefined,
  GetEvidenceQueryVariables
>;
export function useGetEvidenceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEvidenceQuery,
        GetEvidenceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEvidenceQuery, GetEvidenceQueryVariables>(
    GetEvidenceDocument,
    options,
  );
}
export type GetEvidenceQueryHookResult = ReturnType<typeof useGetEvidenceQuery>;
export type GetEvidenceLazyQueryHookResult = ReturnType<
  typeof useGetEvidenceLazyQuery
>;
export type GetEvidenceSuspenseQueryHookResult = ReturnType<
  typeof useGetEvidenceSuspenseQuery
>;
export type GetEvidenceQueryResult = Apollo.QueryResult<
  GetEvidenceQuery,
  GetEvidenceQueryVariables
>;
export const GetExceptionFilterSuggestionsDocument = gql`
  query GetExceptionFilterSuggestions(
    $resourceMrn: String!
    $filterType: ExceptionFilterType!
    $searchText: String
    $filter: ListExceptionGroupsFilter
    $limit: Int
  ) {
    exceptionFilterSuggestions(
      resourceMrn: $resourceMrn
      filterType: $filterType
      searchText: $searchText
      filter: $filter
      limit: $limit
    ) {
      label
      value {
        ... on StringValue {
          stringValue: value
        }
        ... on ExceptionReviewStatusValue {
          reviewStatusValue: value
        }
        ... on ExceptionStatusValue {
          statusValue: value
        }
        ... on ExceptionTypeValue {
          typeValue: value
        }
        ... on TimeRangeValue {
          from
          to
        }
      }
    }
  }
`;

/**
 * __useGetExceptionFilterSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetExceptionFilterSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExceptionFilterSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExceptionFilterSuggestionsQuery({
 *   variables: {
 *      resourceMrn: // value for 'resourceMrn'
 *      filterType: // value for 'filterType'
 *      searchText: // value for 'searchText'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetExceptionFilterSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetExceptionFilterSuggestionsQuery,
    GetExceptionFilterSuggestionsQueryVariables
  > &
    (
      | {
          variables: GetExceptionFilterSuggestionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetExceptionFilterSuggestionsQuery,
    GetExceptionFilterSuggestionsQueryVariables
  >(GetExceptionFilterSuggestionsDocument, options);
}
export function useGetExceptionFilterSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExceptionFilterSuggestionsQuery,
    GetExceptionFilterSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetExceptionFilterSuggestionsQuery,
    GetExceptionFilterSuggestionsQueryVariables
  >(GetExceptionFilterSuggestionsDocument, options);
}
// @ts-ignore
export function useGetExceptionFilterSuggestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetExceptionFilterSuggestionsQuery,
    GetExceptionFilterSuggestionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetExceptionFilterSuggestionsQuery,
  GetExceptionFilterSuggestionsQueryVariables
>;
export function useGetExceptionFilterSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetExceptionFilterSuggestionsQuery,
        GetExceptionFilterSuggestionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetExceptionFilterSuggestionsQuery | undefined,
  GetExceptionFilterSuggestionsQueryVariables
>;
export function useGetExceptionFilterSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetExceptionFilterSuggestionsQuery,
        GetExceptionFilterSuggestionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetExceptionFilterSuggestionsQuery,
    GetExceptionFilterSuggestionsQueryVariables
  >(GetExceptionFilterSuggestionsDocument, options);
}
export type GetExceptionFilterSuggestionsQueryHookResult = ReturnType<
  typeof useGetExceptionFilterSuggestionsQuery
>;
export type GetExceptionFilterSuggestionsLazyQueryHookResult = ReturnType<
  typeof useGetExceptionFilterSuggestionsLazyQuery
>;
export type GetExceptionFilterSuggestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetExceptionFilterSuggestionsSuspenseQuery
>;
export type GetExceptionFilterSuggestionsQueryResult = Apollo.QueryResult<
  GetExceptionFilterSuggestionsQuery,
  GetExceptionFilterSuggestionsQueryVariables
>;
export const GetFindingRiskFactorsDocument = gql`
  query GetFindingRiskFactors(
    $entityMrn: String!
    $filter: AggregateScoreFilter
    $first: Int
    $after: String
    $orderBy: AggregateScoreOrder
  ) {
    aggregateScores(
      entityMrn: $entityMrn
      filter: $filter
      first: $first
      after: $after
      orderBy: $orderBy
    ) {
      ... on AggregateScoresConnection {
        totalCount
        edges {
          cursor
          node {
            id
            findingMrn
            riskFactors {
              mrn
              indicator
              title
              total
              isPositive
              magnitude {
                value
                isToxic
              }
              affected
            }
          }
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetFindingRiskFactorsQuery__
 *
 * To run a query within a React component, call `useGetFindingRiskFactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFindingRiskFactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFindingRiskFactorsQuery({
 *   variables: {
 *      entityMrn: // value for 'entityMrn'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetFindingRiskFactorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFindingRiskFactorsQuery,
    GetFindingRiskFactorsQueryVariables
  > &
    (
      | { variables: GetFindingRiskFactorsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFindingRiskFactorsQuery,
    GetFindingRiskFactorsQueryVariables
  >(GetFindingRiskFactorsDocument, options);
}
export function useGetFindingRiskFactorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFindingRiskFactorsQuery,
    GetFindingRiskFactorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFindingRiskFactorsQuery,
    GetFindingRiskFactorsQueryVariables
  >(GetFindingRiskFactorsDocument, options);
}
// @ts-ignore
export function useGetFindingRiskFactorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFindingRiskFactorsQuery,
    GetFindingRiskFactorsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFindingRiskFactorsQuery,
  GetFindingRiskFactorsQueryVariables
>;
export function useGetFindingRiskFactorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFindingRiskFactorsQuery,
        GetFindingRiskFactorsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFindingRiskFactorsQuery | undefined,
  GetFindingRiskFactorsQueryVariables
>;
export function useGetFindingRiskFactorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFindingRiskFactorsQuery,
        GetFindingRiskFactorsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFindingRiskFactorsQuery,
    GetFindingRiskFactorsQueryVariables
  >(GetFindingRiskFactorsDocument, options);
}
export type GetFindingRiskFactorsQueryHookResult = ReturnType<
  typeof useGetFindingRiskFactorsQuery
>;
export type GetFindingRiskFactorsLazyQueryHookResult = ReturnType<
  typeof useGetFindingRiskFactorsLazyQuery
>;
export type GetFindingRiskFactorsSuspenseQueryHookResult = ReturnType<
  typeof useGetFindingRiskFactorsSuspenseQuery
>;
export type GetFindingRiskFactorsQueryResult = Apollo.QueryResult<
  GetFindingRiskFactorsQuery,
  GetFindingRiskFactorsQueryVariables
>;
export const GetFindingsDocument = gql`
  query GetFindings(
    $scopeMrn: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        totalCount
        filteredTotalCount
        edges {
          cursor
          node {
            ... on CveFinding {
              id
              mrn
              title
              asset {
                icon
                name
                id
                mrn
                tags {
                  key
                  value
                }
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
              rating
              riskValue
              lastUpdated
              publishedAt
              state
              states {
                ...FindingStatesFields
              }
              tags {
                key
                value
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  research
                  rollout
                  scripting
                  totalManualEffort
                  verification
                }
              }
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              exception {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                justification
                action
                author {
                  name
                  email
                  type
                }
                createdAt
              }
            }
            ... on AdvisoryFinding {
              id
              mrn
              title
              asset {
                id
                mrn
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
              rating
              riskValue
              lastUpdated
              publishedAt
              firstDetectedAt
              iconId
              tags {
                key
                value
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  research
                  rollout
                  scripting
                  totalManualEffort
                  verification
                }
              }
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              state
              states {
                ...FindingStatesFields
              }
              exception {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                justification
                action
                author {
                  name
                  mrn
                  email
                  type
                }
                createdAt
              }
            }
            ... on CheckFinding {
              id
              mrn
              title
              asset {
                id
                mrn
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
              rating
              state
              states {
                ...FindingStatesFields
              }
              resultType
              riskValue
              lastUpdated
              tags {
                key
                value
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  research
                  rollout
                  scripting
                  totalManualEffort
                  verification
                }
              }
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              exception {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                action
                justification
                author {
                  name
                  mrn
                  email
                  type
                }
                createdAt
              }
            }
            ... on GenericFinding {
              id
              mrn
              title
              asset {
                id
                mrn
              }
              rating
              riskValue
              lastUpdated
              state
              states {
                ...FindingStatesFields
              }
              tags {
                key
                value
              }
              exceptions {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                justification
                action
                author {
                  name
                  email
                  type
                }
                createdAt
              }
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
  ${FindingStatesFieldsFragmentDoc}
`;

/**
 * __useGetFindingsQuery__
 *
 * To run a query within a React component, call `useGetFindingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFindingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFindingsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFindingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFindingsQuery,
    GetFindingsQueryVariables
  > &
    (
      | { variables: GetFindingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFindingsQuery, GetFindingsQueryVariables>(
    GetFindingsDocument,
    options,
  );
}
export function useGetFindingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFindingsQuery,
    GetFindingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFindingsQuery, GetFindingsQueryVariables>(
    GetFindingsDocument,
    options,
  );
}
// @ts-ignore
export function useGetFindingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFindingsQuery,
    GetFindingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetFindingsQuery, GetFindingsQueryVariables>;
export function useGetFindingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFindingsQuery,
        GetFindingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFindingsQuery | undefined,
  GetFindingsQueryVariables
>;
export function useGetFindingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFindingsQuery,
        GetFindingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFindingsQuery, GetFindingsQueryVariables>(
    GetFindingsDocument,
    options,
  );
}
export type GetFindingsQueryHookResult = ReturnType<typeof useGetFindingsQuery>;
export type GetFindingsLazyQueryHookResult = ReturnType<
  typeof useGetFindingsLazyQuery
>;
export type GetFindingsSuspenseQueryHookResult = ReturnType<
  typeof useGetFindingsSuspenseQuery
>;
export type GetFindingsQueryResult = Apollo.QueryResult<
  GetFindingsQuery,
  GetFindingsQueryVariables
>;
export const GetFindingsFilterSuggestionsDocument = gql`
  query GetFindingsFilterSuggestions(
    $resourceMrn: String!
    $filterType: FindingFilterType!
    $searchText: String
    $filter: FindingsFilter
    $limit: Int
  ) {
    findingsFilterSuggestions(
      resourceMrn: $resourceMrn
      filterType: $filterType
      searchText: $searchText
      filter: $filter
      limit: $limit
    ) {
      label
      value {
        ... on StringValue {
          stringValue: value
        }
        ... on ScoreRatingValue {
          ratingValue: value
        }
        ... on FindingTypeValue {
          findingTypeValue: value
        }
        ... on ScoreStateFilterValue {
          scoreStateValue: value
        }
      }
    }
  }
`;

/**
 * __useGetFindingsFilterSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetFindingsFilterSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFindingsFilterSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFindingsFilterSuggestionsQuery({
 *   variables: {
 *      resourceMrn: // value for 'resourceMrn'
 *      filterType: // value for 'filterType'
 *      searchText: // value for 'searchText'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFindingsFilterSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFindingsFilterSuggestionsQuery,
    GetFindingsFilterSuggestionsQueryVariables
  > &
    (
      | {
          variables: GetFindingsFilterSuggestionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFindingsFilterSuggestionsQuery,
    GetFindingsFilterSuggestionsQueryVariables
  >(GetFindingsFilterSuggestionsDocument, options);
}
export function useGetFindingsFilterSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFindingsFilterSuggestionsQuery,
    GetFindingsFilterSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFindingsFilterSuggestionsQuery,
    GetFindingsFilterSuggestionsQueryVariables
  >(GetFindingsFilterSuggestionsDocument, options);
}
// @ts-ignore
export function useGetFindingsFilterSuggestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFindingsFilterSuggestionsQuery,
    GetFindingsFilterSuggestionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFindingsFilterSuggestionsQuery,
  GetFindingsFilterSuggestionsQueryVariables
>;
export function useGetFindingsFilterSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFindingsFilterSuggestionsQuery,
        GetFindingsFilterSuggestionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFindingsFilterSuggestionsQuery | undefined,
  GetFindingsFilterSuggestionsQueryVariables
>;
export function useGetFindingsFilterSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFindingsFilterSuggestionsQuery,
        GetFindingsFilterSuggestionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFindingsFilterSuggestionsQuery,
    GetFindingsFilterSuggestionsQueryVariables
  >(GetFindingsFilterSuggestionsDocument, options);
}
export type GetFindingsFilterSuggestionsQueryHookResult = ReturnType<
  typeof useGetFindingsFilterSuggestionsQuery
>;
export type GetFindingsFilterSuggestionsLazyQueryHookResult = ReturnType<
  typeof useGetFindingsFilterSuggestionsLazyQuery
>;
export type GetFindingsFilterSuggestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetFindingsFilterSuggestionsSuspenseQuery
>;
export type GetFindingsFilterSuggestionsQueryResult = Apollo.QueryResult<
  GetFindingsFilterSuggestionsQuery,
  GetFindingsFilterSuggestionsQueryVariables
>;
export const GetInitiativesDocument = gql`
  query GetInitiatives(
    $input: InitiativesInput!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: InitiativeOrder
  ) {
    initiatives(
      input: $input
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
    ) {
      totalCount
      edges {
        cursor
        node {
          mrn
          title
          status
          createdAt
          updatedAt
          scoreDelta
          metadata {
            ... on AggregateInitiativeMetadata {
              assetCount
              fixedCount
              findingCount
              effort
              manualEffort {
                research
                rollout
                scripting
                verification
                totalManualEffort
              }
              securityPipelineSupportedCount
            }
            ... on AssetInitiativeMetadata {
              securityPipelineSupportedCount
            }
          }
          references {
            findingMrn
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetInitiativesQuery__
 *
 * To run a query within a React component, call `useGetInitiativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitiativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitiativesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetInitiativesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInitiativesQuery,
    GetInitiativesQueryVariables
  > &
    (
      | { variables: GetInitiativesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInitiativesQuery, GetInitiativesQueryVariables>(
    GetInitiativesDocument,
    options,
  );
}
export function useGetInitiativesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInitiativesQuery,
    GetInitiativesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInitiativesQuery, GetInitiativesQueryVariables>(
    GetInitiativesDocument,
    options,
  );
}
// @ts-ignore
export function useGetInitiativesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetInitiativesQuery,
    GetInitiativesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetInitiativesQuery,
  GetInitiativesQueryVariables
>;
export function useGetInitiativesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInitiativesQuery,
        GetInitiativesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetInitiativesQuery | undefined,
  GetInitiativesQueryVariables
>;
export function useGetInitiativesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInitiativesQuery,
        GetInitiativesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetInitiativesQuery,
    GetInitiativesQueryVariables
  >(GetInitiativesDocument, options);
}
export type GetInitiativesQueryHookResult = ReturnType<
  typeof useGetInitiativesQuery
>;
export type GetInitiativesLazyQueryHookResult = ReturnType<
  typeof useGetInitiativesLazyQuery
>;
export type GetInitiativesSuspenseQueryHookResult = ReturnType<
  typeof useGetInitiativesSuspenseQuery
>;
export type GetInitiativesQueryResult = Apollo.QueryResult<
  GetInitiativesQuery,
  GetInitiativesQueryVariables
>;
export const GetIntegrationsSummaryDocument = gql`
  query GetIntegrationsSummary($input: IntegrationsSummaryInput!) {
    integrationsSummary(input: $input) {
      integrationSummaries {
        totalCount
        activeCount
        failedCount
        warningCount
        assetsCount
        policiesCount
        checksCount
        type
      }
      total
    }
  }
`;

/**
 * __useGetIntegrationsSummaryQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIntegrationsSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIntegrationsSummaryQuery,
    GetIntegrationsSummaryQueryVariables
  > &
    (
      | { variables: GetIntegrationsSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIntegrationsSummaryQuery,
    GetIntegrationsSummaryQueryVariables
  >(GetIntegrationsSummaryDocument, options);
}
export function useGetIntegrationsSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIntegrationsSummaryQuery,
    GetIntegrationsSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIntegrationsSummaryQuery,
    GetIntegrationsSummaryQueryVariables
  >(GetIntegrationsSummaryDocument, options);
}
// @ts-ignore
export function useGetIntegrationsSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIntegrationsSummaryQuery,
    GetIntegrationsSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetIntegrationsSummaryQuery,
  GetIntegrationsSummaryQueryVariables
>;
export function useGetIntegrationsSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntegrationsSummaryQuery,
        GetIntegrationsSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetIntegrationsSummaryQuery | undefined,
  GetIntegrationsSummaryQueryVariables
>;
export function useGetIntegrationsSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntegrationsSummaryQuery,
        GetIntegrationsSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIntegrationsSummaryQuery,
    GetIntegrationsSummaryQueryVariables
  >(GetIntegrationsSummaryDocument, options);
}
export type GetIntegrationsSummaryQueryHookResult = ReturnType<
  typeof useGetIntegrationsSummaryQuery
>;
export type GetIntegrationsSummaryLazyQueryHookResult = ReturnType<
  typeof useGetIntegrationsSummaryLazyQuery
>;
export type GetIntegrationsSummarySuspenseQueryHookResult = ReturnType<
  typeof useGetIntegrationsSummarySuspenseQuery
>;
export type GetIntegrationsSummaryQueryResult = Apollo.QueryResult<
  GetIntegrationsSummaryQuery,
  GetIntegrationsSummaryQueryVariables
>;
export const GetListFrameworksDocument = gql`
  query GetListFrameworks($input: ListFrameworksInput!) {
    listFrameworks(input: $input) {
      edges {
        cursor
        node {
          mrn
          authors {
            name
            email
            type
          }
          title
          description
          state
          tags {
            key
            value
          }
          score {
            id
            iconId
            spaceId
            entity {
              ... on EntityInfoAsset {
                id
                mrn
                name
                icon
                lastUpdated
              }
              ... on EntityInfoSpace {
                id
                mrn
                name
              }
            }
            tags {
              key
              value
            }
            findingMrn
            rank
            baseScore
            riskValue
            completion
            scoreType
            blastRadius {
              indicator
              assets
              affected
              critical
              high
              medium
              low
              none
              error
              pass
              disabled
              snoozed
            }
            riskFactors {
              mrn
              indicator
              title
              affected
              total
              isPositive
            }
            title
            description
            epss {
              probability
              percentile
            }
            cvss {
              id
              value
              type
              vector
              source
            }
            lastScannedAt
            firstDetectedAt
            remediatedAt
            versionDistribution {
              total
              distribution {
                version
                count
                riskValue
              }
              assets
              installations
            }
            state
          }
          uploadedAt
        }
      }
    }
  }
`;

/**
 * __useGetListFrameworksQuery__
 *
 * To run a query within a React component, call `useGetListFrameworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListFrameworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListFrameworksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetListFrameworksQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetListFrameworksQuery,
    GetListFrameworksQueryVariables
  > &
    (
      | { variables: GetListFrameworksQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetListFrameworksQuery,
    GetListFrameworksQueryVariables
  >(GetListFrameworksDocument, options);
}
export function useGetListFrameworksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetListFrameworksQuery,
    GetListFrameworksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetListFrameworksQuery,
    GetListFrameworksQueryVariables
  >(GetListFrameworksDocument, options);
}
// @ts-ignore
export function useGetListFrameworksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetListFrameworksQuery,
    GetListFrameworksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetListFrameworksQuery,
  GetListFrameworksQueryVariables
>;
export function useGetListFrameworksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetListFrameworksQuery,
        GetListFrameworksQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetListFrameworksQuery | undefined,
  GetListFrameworksQueryVariables
>;
export function useGetListFrameworksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetListFrameworksQuery,
        GetListFrameworksQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetListFrameworksQuery,
    GetListFrameworksQueryVariables
  >(GetListFrameworksDocument, options);
}
export type GetListFrameworksQueryHookResult = ReturnType<
  typeof useGetListFrameworksQuery
>;
export type GetListFrameworksLazyQueryHookResult = ReturnType<
  typeof useGetListFrameworksLazyQuery
>;
export type GetListFrameworksSuspenseQueryHookResult = ReturnType<
  typeof useGetListFrameworksSuspenseQuery
>;
export type GetListFrameworksQueryResult = Apollo.QueryResult<
  GetListFrameworksQuery,
  GetListFrameworksQueryVariables
>;
export const GetMetricsDocument = gql`
  query GetMetrics(
    $entityMrn: String!
    $metricMrns: [String!]
    $startTime: String
    $endTime: String
    $key: String
  ) {
    metrics(
      entityMrn: $entityMrn
      metricMrns: $metricMrns
      startTime: $startTime
      endTime: $endTime
      key: $key
    ) {
      ... on MetricsResponse {
        entries {
          metricMrn
          title
          arrowResult
        }
      }
    }
  }
`;

/**
 * __useGetMetricsQuery__
 *
 * To run a query within a React component, call `useGetMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricsQuery({
 *   variables: {
 *      entityMrn: // value for 'entityMrn'
 *      metricMrns: // value for 'metricMrns'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMetricsQuery,
    GetMetricsQueryVariables
  > &
    (
      | { variables: GetMetricsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetricsQuery, GetMetricsQueryVariables>(
    GetMetricsDocument,
    options,
  );
}
export function useGetMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMetricsQuery,
    GetMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMetricsQuery, GetMetricsQueryVariables>(
    GetMetricsDocument,
    options,
  );
}
// @ts-ignore
export function useGetMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMetricsQuery,
    GetMetricsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetMetricsQuery, GetMetricsQueryVariables>;
export function useGetMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMetricsQuery,
        GetMetricsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetMetricsQuery | undefined,
  GetMetricsQueryVariables
>;
export function useGetMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMetricsQuery,
        GetMetricsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMetricsQuery, GetMetricsQueryVariables>(
    GetMetricsDocument,
    options,
  );
}
export type GetMetricsQueryHookResult = ReturnType<typeof useGetMetricsQuery>;
export type GetMetricsLazyQueryHookResult = ReturnType<
  typeof useGetMetricsLazyQuery
>;
export type GetMetricsSuspenseQueryHookResult = ReturnType<
  typeof useGetMetricsSuspenseQuery
>;
export type GetMetricsQueryResult = Apollo.QueryResult<
  GetMetricsQuery,
  GetMetricsQueryVariables
>;
export const GetOrganizationOverviewDocument = gql`
  query GetOrganizationOverview($input: OrganizationOverviewInput!) {
    organizationOverview(input: $input) {
      organizationMrn
      assetScores {
        date
        scores {
          total
          A
          B
          C
          D
          F
          U
          Error
        }
      }
      assets {
        scores {
          total
          A
          B
          C
          D
          F
          U
          Error
        }
        improved
        regressed
        unchanged
      }
      vulnerabilities {
        date
        critical
        high
      }
      topVulnerabilities {
        totalAffectedAssets
        stats {
          amountAssets
          spaceMrn
          spaceName
          spaceOwners
        }
        cve {
          id
          title
          description
          cvssScore {
            id
            type
            value
          }
        }
      }
      newVulnerabilities {
        date
        assetsAffected
        cve {
          id
          title
          description
          cvssScore {
            type
            value
          }
        }
      }
      spacesOverview {
        spaceName
        spaceMrn
        scores {
          total
          A
          B
          C
          D
          F
          U
          Error
        }
      }
      integrationSummaries {
        type
        totalCount
      }
      eolAssets
      reportDate
    }
  }
`;

/**
 * __useGetOrganizationOverviewQuery__
 *
 * To run a query within a React component, call `useGetOrganizationOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationOverviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrganizationOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganizationOverviewQuery,
    GetOrganizationOverviewQueryVariables
  > &
    (
      | { variables: GetOrganizationOverviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganizationOverviewQuery,
    GetOrganizationOverviewQueryVariables
  >(GetOrganizationOverviewDocument, options);
}
export function useGetOrganizationOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationOverviewQuery,
    GetOrganizationOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationOverviewQuery,
    GetOrganizationOverviewQueryVariables
  >(GetOrganizationOverviewDocument, options);
}
// @ts-ignore
export function useGetOrganizationOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrganizationOverviewQuery,
    GetOrganizationOverviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetOrganizationOverviewQuery,
  GetOrganizationOverviewQueryVariables
>;
export function useGetOrganizationOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOrganizationOverviewQuery,
        GetOrganizationOverviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetOrganizationOverviewQuery | undefined,
  GetOrganizationOverviewQueryVariables
>;
export function useGetOrganizationOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOrganizationOverviewQuery,
        GetOrganizationOverviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrganizationOverviewQuery,
    GetOrganizationOverviewQueryVariables
  >(GetOrganizationOverviewDocument, options);
}
export type GetOrganizationOverviewQueryHookResult = ReturnType<
  typeof useGetOrganizationOverviewQuery
>;
export type GetOrganizationOverviewLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationOverviewLazyQuery
>;
export type GetOrganizationOverviewSuspenseQueryHookResult = ReturnType<
  typeof useGetOrganizationOverviewSuspenseQuery
>;
export type GetOrganizationOverviewQueryResult = Apollo.QueryResult<
  GetOrganizationOverviewQuery,
  GetOrganizationOverviewQueryVariables
>;
export const GetOrganizationScopeDocument = gql`
  query GetOrganizationScope($mrn: String!, $actions: [String!]!) {
    organization(mrn: $mrn) {
      id
      mrn
      name
      description
      company
    }
    iamActions: testIamActions(resourceMrn: $mrn, actions: $actions)
  }
`;

/**
 * __useGetOrganizationScopeQuery__
 *
 * To run a query within a React component, call `useGetOrganizationScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationScopeQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      actions: // value for 'actions'
 *   },
 * });
 */
export function useGetOrganizationScopeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganizationScopeQuery,
    GetOrganizationScopeQueryVariables
  > &
    (
      | { variables: GetOrganizationScopeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganizationScopeQuery,
    GetOrganizationScopeQueryVariables
  >(GetOrganizationScopeDocument, options);
}
export function useGetOrganizationScopeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationScopeQuery,
    GetOrganizationScopeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationScopeQuery,
    GetOrganizationScopeQueryVariables
  >(GetOrganizationScopeDocument, options);
}
// @ts-ignore
export function useGetOrganizationScopeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrganizationScopeQuery,
    GetOrganizationScopeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetOrganizationScopeQuery,
  GetOrganizationScopeQueryVariables
>;
export function useGetOrganizationScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOrganizationScopeQuery,
        GetOrganizationScopeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetOrganizationScopeQuery | undefined,
  GetOrganizationScopeQueryVariables
>;
export function useGetOrganizationScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOrganizationScopeQuery,
        GetOrganizationScopeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrganizationScopeQuery,
    GetOrganizationScopeQueryVariables
  >(GetOrganizationScopeDocument, options);
}
export type GetOrganizationScopeQueryHookResult = ReturnType<
  typeof useGetOrganizationScopeQuery
>;
export type GetOrganizationScopeLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationScopeLazyQuery
>;
export type GetOrganizationScopeSuspenseQueryHookResult = ReturnType<
  typeof useGetOrganizationScopeSuspenseQuery
>;
export type GetOrganizationScopeQueryResult = Apollo.QueryResult<
  GetOrganizationScopeQuery,
  GetOrganizationScopeQueryVariables
>;
export const GetPackagesDocument = gql`
  query GetPackages(
    $scopeMrn: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        totalCount
        filteredTotalCount
        edges {
          cursor
          node {
            ... on PackageFinding {
              id
              mrn
              asset {
                id
                mrn
                name
                icon
                tags {
                  key
                  value
                }
              }
              riskValue
              rating
              lastUpdated
              title
              packageName
              installedVersion
              availableVersion
              firstFound
              packageType
              iconId
              cvss {
                value
                id
                source
                type
                vector
              }
              epss {
                probability
                percentile
              }
              riskFactors {
                mrn
                indicator
                title
                total
                affected
                isPositive
              }
              platform
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetPackagesQuery__
 *
 * To run a query within a React component, call `useGetPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackagesQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPackagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPackagesQuery,
    GetPackagesQueryVariables
  > &
    (
      | { variables: GetPackagesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPackagesQuery, GetPackagesQueryVariables>(
    GetPackagesDocument,
    options,
  );
}
export function useGetPackagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPackagesQuery,
    GetPackagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPackagesQuery, GetPackagesQueryVariables>(
    GetPackagesDocument,
    options,
  );
}
// @ts-ignore
export function useGetPackagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPackagesQuery,
    GetPackagesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetPackagesQuery, GetPackagesQueryVariables>;
export function useGetPackagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPackagesQuery,
        GetPackagesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPackagesQuery | undefined,
  GetPackagesQueryVariables
>;
export function useGetPackagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPackagesQuery,
        GetPackagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPackagesQuery, GetPackagesQueryVariables>(
    GetPackagesDocument,
    options,
  );
}
export type GetPackagesQueryHookResult = ReturnType<typeof useGetPackagesQuery>;
export type GetPackagesLazyQueryHookResult = ReturnType<
  typeof useGetPackagesLazyQuery
>;
export type GetPackagesSuspenseQueryHookResult = ReturnType<
  typeof useGetPackagesSuspenseQuery
>;
export type GetPackagesQueryResult = Apollo.QueryResult<
  GetPackagesQuery,
  GetPackagesQueryVariables
>;
export const GetPolicyDocument = gql`
  query GetPolicy($input: PolicyInput!) {
    policy(input: $input) {
      mrn
      name
      version
      action
      assigned
      assignedScope
      trustLevel
      docs
      authors {
        name
        email
        type
      }
      variantPlatformFilters {
        id
        title
        icon
      }
    }
  }
`;

/**
 * __useGetPolicyQuery__
 *
 * To run a query within a React component, call `useGetPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPolicyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPolicyQuery,
    GetPolicyQueryVariables
  > &
    (
      | { variables: GetPolicyQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPolicyQuery, GetPolicyQueryVariables>(
    GetPolicyDocument,
    options,
  );
}
export function useGetPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPolicyQuery,
    GetPolicyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPolicyQuery, GetPolicyQueryVariables>(
    GetPolicyDocument,
    options,
  );
}
// @ts-ignore
export function useGetPolicySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPolicyQuery,
    GetPolicyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetPolicyQuery, GetPolicyQueryVariables>;
export function useGetPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPolicyQuery, GetPolicyQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetPolicyQuery | undefined,
  GetPolicyQueryVariables
>;
export function useGetPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPolicyQuery, GetPolicyQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPolicyQuery, GetPolicyQueryVariables>(
    GetPolicyDocument,
    options,
  );
}
export type GetPolicyQueryHookResult = ReturnType<typeof useGetPolicyQuery>;
export type GetPolicyLazyQueryHookResult = ReturnType<
  typeof useGetPolicyLazyQuery
>;
export type GetPolicySuspenseQueryHookResult = ReturnType<
  typeof useGetPolicySuspenseQuery
>;
export type GetPolicyQueryResult = Apollo.QueryResult<
  GetPolicyQuery,
  GetPolicyQueryVariables
>;
export const GetPolicyPropsDocument = gql`
  query GetPolicyProps($input: PolicyInput!, $scopeInput: PolicyInput!) {
    policy(input: $input) {
      uid
      mrn
      properties {
        uid
        mrn
        mql
        defaultValue
        overrideValue
        title
        for {
          mrn
        }
      }
      queries {
        uid
        mrn
        properties {
          uid
          mrn
          mql
          defaultValue
          overrideValue
          title
          for {
            mrn
          }
        }
      }
    }
    scopePolicy: policy(input: $scopeInput) {
      uid
      mrn
      properties {
        uid
        mrn
        mql
        defaultValue
        overrideValue
        title
        for {
          mrn
        }
      }
    }
  }
`;

/**
 * __useGetPolicyPropsQuery__
 *
 * To run a query within a React component, call `useGetPolicyPropsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyPropsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyPropsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      scopeInput: // value for 'scopeInput'
 *   },
 * });
 */
export function useGetPolicyPropsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPolicyPropsQuery,
    GetPolicyPropsQueryVariables
  > &
    (
      | { variables: GetPolicyPropsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPolicyPropsQuery, GetPolicyPropsQueryVariables>(
    GetPolicyPropsDocument,
    options,
  );
}
export function useGetPolicyPropsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPolicyPropsQuery,
    GetPolicyPropsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPolicyPropsQuery, GetPolicyPropsQueryVariables>(
    GetPolicyPropsDocument,
    options,
  );
}
// @ts-ignore
export function useGetPolicyPropsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPolicyPropsQuery,
    GetPolicyPropsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPolicyPropsQuery,
  GetPolicyPropsQueryVariables
>;
export function useGetPolicyPropsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPolicyPropsQuery,
        GetPolicyPropsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPolicyPropsQuery | undefined,
  GetPolicyPropsQueryVariables
>;
export function useGetPolicyPropsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPolicyPropsQuery,
        GetPolicyPropsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPolicyPropsQuery,
    GetPolicyPropsQueryVariables
  >(GetPolicyPropsDocument, options);
}
export type GetPolicyPropsQueryHookResult = ReturnType<
  typeof useGetPolicyPropsQuery
>;
export type GetPolicyPropsLazyQueryHookResult = ReturnType<
  typeof useGetPolicyPropsLazyQuery
>;
export type GetPolicyPropsSuspenseQueryHookResult = ReturnType<
  typeof useGetPolicyPropsSuspenseQuery
>;
export type GetPolicyPropsQueryResult = Apollo.QueryResult<
  GetPolicyPropsQuery,
  GetPolicyPropsQueryVariables
>;
export const GetQueryDetectedAssetsDocument = gql`
  query GetQueryDetectedAssets(
    $entityMrn: String!
    $first: Int!
    $after: String
    $filter: DataQueryFilter
  ) {
    dataQueries(
      entityMrn: $entityMrn
      filter: $filter
      first: $first
      after: $after
    ) {
      ... on DataQueriesConnection {
        edges {
          node {
            mrn
            asset {
              mrn
              name
            }
            tags {
              key
              value
            }
            iconId
            id
            lastUpdated
            value
          }
          cursor
        }
        totalCount
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;

/**
 * __useGetQueryDetectedAssetsQuery__
 *
 * To run a query within a React component, call `useGetQueryDetectedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryDetectedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryDetectedAssetsQuery({
 *   variables: {
 *      entityMrn: // value for 'entityMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetQueryDetectedAssetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQueryDetectedAssetsQuery,
    GetQueryDetectedAssetsQueryVariables
  > &
    (
      | { variables: GetQueryDetectedAssetsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetQueryDetectedAssetsQuery,
    GetQueryDetectedAssetsQueryVariables
  >(GetQueryDetectedAssetsDocument, options);
}
export function useGetQueryDetectedAssetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQueryDetectedAssetsQuery,
    GetQueryDetectedAssetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQueryDetectedAssetsQuery,
    GetQueryDetectedAssetsQueryVariables
  >(GetQueryDetectedAssetsDocument, options);
}
// @ts-ignore
export function useGetQueryDetectedAssetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetQueryDetectedAssetsQuery,
    GetQueryDetectedAssetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetQueryDetectedAssetsQuery,
  GetQueryDetectedAssetsQueryVariables
>;
export function useGetQueryDetectedAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueryDetectedAssetsQuery,
        GetQueryDetectedAssetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetQueryDetectedAssetsQuery | undefined,
  GetQueryDetectedAssetsQueryVariables
>;
export function useGetQueryDetectedAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueryDetectedAssetsQuery,
        GetQueryDetectedAssetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetQueryDetectedAssetsQuery,
    GetQueryDetectedAssetsQueryVariables
  >(GetQueryDetectedAssetsDocument, options);
}
export type GetQueryDetectedAssetsQueryHookResult = ReturnType<
  typeof useGetQueryDetectedAssetsQuery
>;
export type GetQueryDetectedAssetsLazyQueryHookResult = ReturnType<
  typeof useGetQueryDetectedAssetsLazyQuery
>;
export type GetQueryDetectedAssetsSuspenseQueryHookResult = ReturnType<
  typeof useGetQueryDetectedAssetsSuspenseQuery
>;
export type GetQueryDetectedAssetsQueryResult = Apollo.QueryResult<
  GetQueryDetectedAssetsQuery,
  GetQueryDetectedAssetsQueryVariables
>;
export const GetQueryPackDocument = gql`
  query GetQueryPack($input: PolicyInput!) {
    policy(input: $input) {
      mrn
      name
      version
      assigned
      authors {
        name
        email
        type
      }
      docs
      trustLevel
      variantPlatformFilters {
        id
        title
        icon
      }
    }
  }
`;

/**
 * __useGetQueryPackQuery__
 *
 * To run a query within a React component, call `useGetQueryPackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryPackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryPackQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQueryPackQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQueryPackQuery,
    GetQueryPackQueryVariables
  > &
    (
      | { variables: GetQueryPackQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQueryPackQuery, GetQueryPackQueryVariables>(
    GetQueryPackDocument,
    options,
  );
}
export function useGetQueryPackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQueryPackQuery,
    GetQueryPackQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQueryPackQuery, GetQueryPackQueryVariables>(
    GetQueryPackDocument,
    options,
  );
}
// @ts-ignore
export function useGetQueryPackSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetQueryPackQuery,
    GetQueryPackQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetQueryPackQuery, GetQueryPackQueryVariables>;
export function useGetQueryPackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueryPackQuery,
        GetQueryPackQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetQueryPackQuery | undefined,
  GetQueryPackQueryVariables
>;
export function useGetQueryPackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueryPackQuery,
        GetQueryPackQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetQueryPackQuery, GetQueryPackQueryVariables>(
    GetQueryPackDocument,
    options,
  );
}
export type GetQueryPackQueryHookResult = ReturnType<
  typeof useGetQueryPackQuery
>;
export type GetQueryPackLazyQueryHookResult = ReturnType<
  typeof useGetQueryPackLazyQuery
>;
export type GetQueryPackSuspenseQueryHookResult = ReturnType<
  typeof useGetQueryPackSuspenseQuery
>;
export type GetQueryPackQueryResult = Apollo.QueryResult<
  GetQueryPackQuery,
  GetQueryPackQueryVariables
>;
export const GetQueryPackQueriesDocument = gql`
  query GetQueryPackQueries($input: PolicyInput!) {
    policy(input: $input) {
      mrn
      queries {
        uid
        mrn
        title
        docs {
          desc
          remediations {
            ... on Remediations {
              entries {
                id
                desc
              }
            }
            ... on AuthenticationRequired {
              message
              code
            }
          }
          references {
            title
            url
          }
        }
        impact {
          value
          rating
        }
        mql
        tags {
          key
          value
        }
        properties {
          uid
          mrn
          title
          mql
          defaultValue
          overrideValue
          setByPolicyMrn
          for {
            mrn
          }
        }
        action
      }
      groups {
        title
        summary
        checks {
          mrn
          impact {
            value
            rating
          }
          action
        }
        queries {
          mrn
          impact {
            value
            rating
          }
          action
        }
        policies {
          mrn
          impact {
            value
            rating
          }
          action
        }
      }
    }
  }
`;

/**
 * __useGetQueryPackQueriesQuery__
 *
 * To run a query within a React component, call `useGetQueryPackQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryPackQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryPackQueriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQueryPackQueriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQueryPackQueriesQuery,
    GetQueryPackQueriesQueryVariables
  > &
    (
      | { variables: GetQueryPackQueriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetQueryPackQueriesQuery,
    GetQueryPackQueriesQueryVariables
  >(GetQueryPackQueriesDocument, options);
}
export function useGetQueryPackQueriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQueryPackQueriesQuery,
    GetQueryPackQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQueryPackQueriesQuery,
    GetQueryPackQueriesQueryVariables
  >(GetQueryPackQueriesDocument, options);
}
// @ts-ignore
export function useGetQueryPackQueriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetQueryPackQueriesQuery,
    GetQueryPackQueriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetQueryPackQueriesQuery,
  GetQueryPackQueriesQueryVariables
>;
export function useGetQueryPackQueriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueryPackQueriesQuery,
        GetQueryPackQueriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetQueryPackQueriesQuery | undefined,
  GetQueryPackQueriesQueryVariables
>;
export function useGetQueryPackQueriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueryPackQueriesQuery,
        GetQueryPackQueriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetQueryPackQueriesQuery,
    GetQueryPackQueriesQueryVariables
  >(GetQueryPackQueriesDocument, options);
}
export type GetQueryPackQueriesQueryHookResult = ReturnType<
  typeof useGetQueryPackQueriesQuery
>;
export type GetQueryPackQueriesLazyQueryHookResult = ReturnType<
  typeof useGetQueryPackQueriesLazyQuery
>;
export type GetQueryPackQueriesSuspenseQueryHookResult = ReturnType<
  typeof useGetQueryPackQueriesSuspenseQuery
>;
export type GetQueryPackQueriesQueryResult = Apollo.QueryResult<
  GetQueryPackQueriesQuery,
  GetQueryPackQueriesQueryVariables
>;
export const GetRegionScopeDocument = gql`
  query GetRegionScope($mrn: String!, $actions: [String!]!) {
    iamActions: testIamActions(resourceMrn: $mrn, actions: $actions)
  }
`;

/**
 * __useGetRegionScopeQuery__
 *
 * To run a query within a React component, call `useGetRegionScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionScopeQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      actions: // value for 'actions'
 *   },
 * });
 */
export function useGetRegionScopeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRegionScopeQuery,
    GetRegionScopeQueryVariables
  > &
    (
      | { variables: GetRegionScopeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRegionScopeQuery, GetRegionScopeQueryVariables>(
    GetRegionScopeDocument,
    options,
  );
}
export function useGetRegionScopeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRegionScopeQuery,
    GetRegionScopeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRegionScopeQuery, GetRegionScopeQueryVariables>(
    GetRegionScopeDocument,
    options,
  );
}
// @ts-ignore
export function useGetRegionScopeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRegionScopeQuery,
    GetRegionScopeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetRegionScopeQuery,
  GetRegionScopeQueryVariables
>;
export function useGetRegionScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRegionScopeQuery,
        GetRegionScopeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetRegionScopeQuery | undefined,
  GetRegionScopeQueryVariables
>;
export function useGetRegionScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRegionScopeQuery,
        GetRegionScopeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRegionScopeQuery,
    GetRegionScopeQueryVariables
  >(GetRegionScopeDocument, options);
}
export type GetRegionScopeQueryHookResult = ReturnType<
  typeof useGetRegionScopeQuery
>;
export type GetRegionScopeLazyQueryHookResult = ReturnType<
  typeof useGetRegionScopeLazyQuery
>;
export type GetRegionScopeSuspenseQueryHookResult = ReturnType<
  typeof useGetRegionScopeSuspenseQuery
>;
export type GetRegionScopeQueryResult = Apollo.QueryResult<
  GetRegionScopeQuery,
  GetRegionScopeQueryVariables
>;
export const GetRenderedAssetDataQueryDocument = gql`
  query GetRenderedAssetDataQuery($input: RenderedAssetQueryDataInput!) {
    renderedAssetQueryData(input: $input) {
      ... on RenderedAssetQueryData {
        assessment
        data
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetRenderedAssetDataQueryQuery__
 *
 * To run a query within a React component, call `useGetRenderedAssetDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderedAssetDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderedAssetDataQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRenderedAssetDataQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRenderedAssetDataQueryQuery,
    GetRenderedAssetDataQueryQueryVariables
  > &
    (
      | { variables: GetRenderedAssetDataQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRenderedAssetDataQueryQuery,
    GetRenderedAssetDataQueryQueryVariables
  >(GetRenderedAssetDataQueryDocument, options);
}
export function useGetRenderedAssetDataQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRenderedAssetDataQueryQuery,
    GetRenderedAssetDataQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRenderedAssetDataQueryQuery,
    GetRenderedAssetDataQueryQueryVariables
  >(GetRenderedAssetDataQueryDocument, options);
}
// @ts-ignore
export function useGetRenderedAssetDataQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRenderedAssetDataQueryQuery,
    GetRenderedAssetDataQueryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetRenderedAssetDataQueryQuery,
  GetRenderedAssetDataQueryQueryVariables
>;
export function useGetRenderedAssetDataQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRenderedAssetDataQueryQuery,
        GetRenderedAssetDataQueryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetRenderedAssetDataQueryQuery | undefined,
  GetRenderedAssetDataQueryQueryVariables
>;
export function useGetRenderedAssetDataQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRenderedAssetDataQueryQuery,
        GetRenderedAssetDataQueryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRenderedAssetDataQueryQuery,
    GetRenderedAssetDataQueryQueryVariables
  >(GetRenderedAssetDataQueryDocument, options);
}
export type GetRenderedAssetDataQueryQueryHookResult = ReturnType<
  typeof useGetRenderedAssetDataQueryQuery
>;
export type GetRenderedAssetDataQueryLazyQueryHookResult = ReturnType<
  typeof useGetRenderedAssetDataQueryLazyQuery
>;
export type GetRenderedAssetDataQuerySuspenseQueryHookResult = ReturnType<
  typeof useGetRenderedAssetDataQuerySuspenseQuery
>;
export type GetRenderedAssetDataQueryQueryResult = Apollo.QueryResult<
  GetRenderedAssetDataQueryQuery,
  GetRenderedAssetDataQueryQueryVariables
>;
export const GetRiskFactorsDocsDocument = gql`
  query GetRiskFactorsDocs($spaceMrn: String!, $mrns: [String!]) {
    riskFactors(spaceMrn: $spaceMrn, mrns: $mrns) {
      edges {
        mrn
        title
        docs {
          active
          inactive
        }
      }
    }
  }
`;

/**
 * __useGetRiskFactorsDocsQuery__
 *
 * To run a query within a React component, call `useGetRiskFactorsDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskFactorsDocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskFactorsDocsQuery({
 *   variables: {
 *      spaceMrn: // value for 'spaceMrn'
 *      mrns: // value for 'mrns'
 *   },
 * });
 */
export function useGetRiskFactorsDocsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRiskFactorsDocsQuery,
    GetRiskFactorsDocsQueryVariables
  > &
    (
      | { variables: GetRiskFactorsDocsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRiskFactorsDocsQuery,
    GetRiskFactorsDocsQueryVariables
  >(GetRiskFactorsDocsDocument, options);
}
export function useGetRiskFactorsDocsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRiskFactorsDocsQuery,
    GetRiskFactorsDocsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRiskFactorsDocsQuery,
    GetRiskFactorsDocsQueryVariables
  >(GetRiskFactorsDocsDocument, options);
}
// @ts-ignore
export function useGetRiskFactorsDocsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRiskFactorsDocsQuery,
    GetRiskFactorsDocsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetRiskFactorsDocsQuery,
  GetRiskFactorsDocsQueryVariables
>;
export function useGetRiskFactorsDocsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRiskFactorsDocsQuery,
        GetRiskFactorsDocsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetRiskFactorsDocsQuery | undefined,
  GetRiskFactorsDocsQueryVariables
>;
export function useGetRiskFactorsDocsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRiskFactorsDocsQuery,
        GetRiskFactorsDocsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRiskFactorsDocsQuery,
    GetRiskFactorsDocsQueryVariables
  >(GetRiskFactorsDocsDocument, options);
}
export type GetRiskFactorsDocsQueryHookResult = ReturnType<
  typeof useGetRiskFactorsDocsQuery
>;
export type GetRiskFactorsDocsLazyQueryHookResult = ReturnType<
  typeof useGetRiskFactorsDocsLazyQuery
>;
export type GetRiskFactorsDocsSuspenseQueryHookResult = ReturnType<
  typeof useGetRiskFactorsDocsSuspenseQuery
>;
export type GetRiskFactorsDocsQueryResult = Apollo.QueryResult<
  GetRiskFactorsDocsQuery,
  GetRiskFactorsDocsQueryVariables
>;
export const GetSearchResultsDocument = gql`
  query GetSearchResults(
    $input: AssetSearchInput!
    $orderBy: AssetOrder
    $first: Int!
    $after: String
  ) {
    assetSearch(
      input: $input
      first: $first
      after: $after
      orderBy: $orderBy
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          asset_type
          id
          mrn
          name
          platform {
            arch
            kind
            name
            runtime
            title
            version
          }
          referenceIDs
          score {
            completion
            grade
            id
            message
            type
            value
            weight
          }
          state
          updatedAt
        }
      }
    }
  }
`;

/**
 * __useGetSearchResultsQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetSearchResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSearchResultsQuery,
    GetSearchResultsQueryVariables
  > &
    (
      | { variables: GetSearchResultsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(
    GetSearchResultsDocument,
    options,
  );
}
export function useGetSearchResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSearchResultsQuery,
    GetSearchResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSearchResultsQuery,
    GetSearchResultsQueryVariables
  >(GetSearchResultsDocument, options);
}
// @ts-ignore
export function useGetSearchResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSearchResultsQuery,
    GetSearchResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSearchResultsQuery,
  GetSearchResultsQueryVariables
>;
export function useGetSearchResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSearchResultsQuery,
        GetSearchResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSearchResultsQuery | undefined,
  GetSearchResultsQueryVariables
>;
export function useGetSearchResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSearchResultsQuery,
        GetSearchResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSearchResultsQuery,
    GetSearchResultsQueryVariables
  >(GetSearchResultsDocument, options);
}
export type GetSearchResultsQueryHookResult = ReturnType<
  typeof useGetSearchResultsQuery
>;
export type GetSearchResultsLazyQueryHookResult = ReturnType<
  typeof useGetSearchResultsLazyQuery
>;
export type GetSearchResultsSuspenseQueryHookResult = ReturnType<
  typeof useGetSearchResultsSuspenseQuery
>;
export type GetSearchResultsQueryResult = Apollo.QueryResult<
  GetSearchResultsQuery,
  GetSearchResultsQueryVariables
>;
export const GetSecurityModelDocument = gql`
  query GetSecurityModel($scopeMrn: String!) {
    securityModel(scopeMrn: $scopeMrn) {
      scopeMrn
      slas {
        startDateConfig
        findings {
          daysBeforeWarning
          daysToResolve
          rating
        }
      }
    }
  }
`;

/**
 * __useGetSecurityModelQuery__
 *
 * To run a query within a React component, call `useGetSecurityModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSecurityModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSecurityModelQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *   },
 * });
 */
export function useGetSecurityModelQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSecurityModelQuery,
    GetSecurityModelQueryVariables
  > &
    (
      | { variables: GetSecurityModelQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSecurityModelQuery, GetSecurityModelQueryVariables>(
    GetSecurityModelDocument,
    options,
  );
}
export function useGetSecurityModelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSecurityModelQuery,
    GetSecurityModelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSecurityModelQuery,
    GetSecurityModelQueryVariables
  >(GetSecurityModelDocument, options);
}
// @ts-ignore
export function useGetSecurityModelSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSecurityModelQuery,
    GetSecurityModelQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSecurityModelQuery,
  GetSecurityModelQueryVariables
>;
export function useGetSecurityModelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSecurityModelQuery,
        GetSecurityModelQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSecurityModelQuery | undefined,
  GetSecurityModelQueryVariables
>;
export function useGetSecurityModelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSecurityModelQuery,
        GetSecurityModelQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSecurityModelQuery,
    GetSecurityModelQueryVariables
  >(GetSecurityModelDocument, options);
}
export type GetSecurityModelQueryHookResult = ReturnType<
  typeof useGetSecurityModelQuery
>;
export type GetSecurityModelLazyQueryHookResult = ReturnType<
  typeof useGetSecurityModelLazyQuery
>;
export type GetSecurityModelSuspenseQueryHookResult = ReturnType<
  typeof useGetSecurityModelSuspenseQuery
>;
export type GetSecurityModelQueryResult = Apollo.QueryResult<
  GetSecurityModelQuery,
  GetSecurityModelQueryVariables
>;
export const GetSharedSpacesCountDocument = gql`
  query GetSharedSpacesCount {
    sharedSpaces(first: 0) {
      totalCount
    }
  }
`;

/**
 * __useGetSharedSpacesCountQuery__
 *
 * To run a query within a React component, call `useGetSharedSpacesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedSpacesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedSpacesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSharedSpacesCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSharedSpacesCountQuery,
    GetSharedSpacesCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSharedSpacesCountQuery,
    GetSharedSpacesCountQueryVariables
  >(GetSharedSpacesCountDocument, options);
}
export function useGetSharedSpacesCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSharedSpacesCountQuery,
    GetSharedSpacesCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSharedSpacesCountQuery,
    GetSharedSpacesCountQueryVariables
  >(GetSharedSpacesCountDocument, options);
}
// @ts-ignore
export function useGetSharedSpacesCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSharedSpacesCountQuery,
    GetSharedSpacesCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSharedSpacesCountQuery,
  GetSharedSpacesCountQueryVariables
>;
export function useGetSharedSpacesCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSharedSpacesCountQuery,
        GetSharedSpacesCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSharedSpacesCountQuery | undefined,
  GetSharedSpacesCountQueryVariables
>;
export function useGetSharedSpacesCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSharedSpacesCountQuery,
        GetSharedSpacesCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSharedSpacesCountQuery,
    GetSharedSpacesCountQueryVariables
  >(GetSharedSpacesCountDocument, options);
}
export type GetSharedSpacesCountQueryHookResult = ReturnType<
  typeof useGetSharedSpacesCountQuery
>;
export type GetSharedSpacesCountLazyQueryHookResult = ReturnType<
  typeof useGetSharedSpacesCountLazyQuery
>;
export type GetSharedSpacesCountSuspenseQueryHookResult = ReturnType<
  typeof useGetSharedSpacesCountSuspenseQuery
>;
export type GetSharedSpacesCountQueryResult = Apollo.QueryResult<
  GetSharedSpacesCountQuery,
  GetSharedSpacesCountQueryVariables
>;
export const GetSpaceInventoryStatsDocument = gql`
  query GetSpaceInventoryStats($spaceMrn: String!, $metricMrns: [String!]) {
    space(mrn: $spaceMrn) {
      mrn
      stats {
        integrationsStatistics {
          active
          pending
          errored
          total
          type
        }
      }
      metrics(metricMrns: $metricMrns) {
        ... on MetricsResponse {
          entries {
            metricMrn
            title
            arrowResult
          }
        }
      }
    }
  }
`;

/**
 * __useGetSpaceInventoryStatsQuery__
 *
 * To run a query within a React component, call `useGetSpaceInventoryStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpaceInventoryStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpaceInventoryStatsQuery({
 *   variables: {
 *      spaceMrn: // value for 'spaceMrn'
 *      metricMrns: // value for 'metricMrns'
 *   },
 * });
 */
export function useGetSpaceInventoryStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSpaceInventoryStatsQuery,
    GetSpaceInventoryStatsQueryVariables
  > &
    (
      | { variables: GetSpaceInventoryStatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSpaceInventoryStatsQuery,
    GetSpaceInventoryStatsQueryVariables
  >(GetSpaceInventoryStatsDocument, options);
}
export function useGetSpaceInventoryStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSpaceInventoryStatsQuery,
    GetSpaceInventoryStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSpaceInventoryStatsQuery,
    GetSpaceInventoryStatsQueryVariables
  >(GetSpaceInventoryStatsDocument, options);
}
// @ts-ignore
export function useGetSpaceInventoryStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSpaceInventoryStatsQuery,
    GetSpaceInventoryStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSpaceInventoryStatsQuery,
  GetSpaceInventoryStatsQueryVariables
>;
export function useGetSpaceInventoryStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSpaceInventoryStatsQuery,
        GetSpaceInventoryStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSpaceInventoryStatsQuery | undefined,
  GetSpaceInventoryStatsQueryVariables
>;
export function useGetSpaceInventoryStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSpaceInventoryStatsQuery,
        GetSpaceInventoryStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSpaceInventoryStatsQuery,
    GetSpaceInventoryStatsQueryVariables
  >(GetSpaceInventoryStatsDocument, options);
}
export type GetSpaceInventoryStatsQueryHookResult = ReturnType<
  typeof useGetSpaceInventoryStatsQuery
>;
export type GetSpaceInventoryStatsLazyQueryHookResult = ReturnType<
  typeof useGetSpaceInventoryStatsLazyQuery
>;
export type GetSpaceInventoryStatsSuspenseQueryHookResult = ReturnType<
  typeof useGetSpaceInventoryStatsSuspenseQuery
>;
export type GetSpaceInventoryStatsQueryResult = Apollo.QueryResult<
  GetSpaceInventoryStatsQuery,
  GetSpaceInventoryStatsQueryVariables
>;
export const GetSpaceRiskFactorsDocument = gql`
  query GetSpaceRiskFactors($spaceMrn: String!) {
    riskFactors(spaceMrn: $spaceMrn) {
      edges {
        mrn
        title
        indicator
        action
        docs {
          active
          inactive
        }
        magnitude {
          value
          isToxic
        }
        defaultMagnitude {
          value
          isToxic
        }
        assetFieldFilters {
          labelBasedFilters {
            key
            value
          }
          annotationBasedFilters {
            key
            value
          }
        }
      }
    }
  }
`;

/**
 * __useGetSpaceRiskFactorsQuery__
 *
 * To run a query within a React component, call `useGetSpaceRiskFactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpaceRiskFactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpaceRiskFactorsQuery({
 *   variables: {
 *      spaceMrn: // value for 'spaceMrn'
 *   },
 * });
 */
export function useGetSpaceRiskFactorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSpaceRiskFactorsQuery,
    GetSpaceRiskFactorsQueryVariables
  > &
    (
      | { variables: GetSpaceRiskFactorsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSpaceRiskFactorsQuery,
    GetSpaceRiskFactorsQueryVariables
  >(GetSpaceRiskFactorsDocument, options);
}
export function useGetSpaceRiskFactorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSpaceRiskFactorsQuery,
    GetSpaceRiskFactorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSpaceRiskFactorsQuery,
    GetSpaceRiskFactorsQueryVariables
  >(GetSpaceRiskFactorsDocument, options);
}
// @ts-ignore
export function useGetSpaceRiskFactorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSpaceRiskFactorsQuery,
    GetSpaceRiskFactorsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSpaceRiskFactorsQuery,
  GetSpaceRiskFactorsQueryVariables
>;
export function useGetSpaceRiskFactorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSpaceRiskFactorsQuery,
        GetSpaceRiskFactorsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSpaceRiskFactorsQuery | undefined,
  GetSpaceRiskFactorsQueryVariables
>;
export function useGetSpaceRiskFactorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSpaceRiskFactorsQuery,
        GetSpaceRiskFactorsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSpaceRiskFactorsQuery,
    GetSpaceRiskFactorsQueryVariables
  >(GetSpaceRiskFactorsDocument, options);
}
export type GetSpaceRiskFactorsQueryHookResult = ReturnType<
  typeof useGetSpaceRiskFactorsQuery
>;
export type GetSpaceRiskFactorsLazyQueryHookResult = ReturnType<
  typeof useGetSpaceRiskFactorsLazyQuery
>;
export type GetSpaceRiskFactorsSuspenseQueryHookResult = ReturnType<
  typeof useGetSpaceRiskFactorsSuspenseQuery
>;
export type GetSpaceRiskFactorsQueryResult = Apollo.QueryResult<
  GetSpaceRiskFactorsQuery,
  GetSpaceRiskFactorsQueryVariables
>;
export const GetSpaceScopeDocument = gql`
  query GetSpaceScope($mrn: String!, $actions: [String!]!) {
    space(mrn: $mrn) {
      id
      mrn
      name
      description
      shared
      organization {
        id
        mrn
      }
    }
    iamActions: testIamActions(resourceMrn: $mrn, actions: $actions)
  }
`;

/**
 * __useGetSpaceScopeQuery__
 *
 * To run a query within a React component, call `useGetSpaceScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpaceScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpaceScopeQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      actions: // value for 'actions'
 *   },
 * });
 */
export function useGetSpaceScopeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSpaceScopeQuery,
    GetSpaceScopeQueryVariables
  > &
    (
      | { variables: GetSpaceScopeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSpaceScopeQuery, GetSpaceScopeQueryVariables>(
    GetSpaceScopeDocument,
    options,
  );
}
export function useGetSpaceScopeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSpaceScopeQuery,
    GetSpaceScopeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSpaceScopeQuery, GetSpaceScopeQueryVariables>(
    GetSpaceScopeDocument,
    options,
  );
}
// @ts-ignore
export function useGetSpaceScopeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSpaceScopeQuery,
    GetSpaceScopeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSpaceScopeQuery,
  GetSpaceScopeQueryVariables
>;
export function useGetSpaceScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSpaceScopeQuery,
        GetSpaceScopeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSpaceScopeQuery | undefined,
  GetSpaceScopeQueryVariables
>;
export function useGetSpaceScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSpaceScopeQuery,
        GetSpaceScopeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSpaceScopeQuery,
    GetSpaceScopeQueryVariables
  >(GetSpaceScopeDocument, options);
}
export type GetSpaceScopeQueryHookResult = ReturnType<
  typeof useGetSpaceScopeQuery
>;
export type GetSpaceScopeLazyQueryHookResult = ReturnType<
  typeof useGetSpaceScopeLazyQuery
>;
export type GetSpaceScopeSuspenseQueryHookResult = ReturnType<
  typeof useGetSpaceScopeSuspenseQuery
>;
export type GetSpaceScopeQueryResult = Apollo.QueryResult<
  GetSpaceScopeQuery,
  GetSpaceScopeQueryVariables
>;
export const GetTicketContextDocument = gql`
  query GetTicketContext($input: TicketContextInput!) {
    ticketContext(input: $input) {
      ... on JiraTicketContextProjectsPayload {
        projects {
          key
          name
        }
      }
      ... on EmailTicketContextPayload {
        recipients {
          name
          email
          isDefault
          referenceUrl
        }
      }
      ... on AzureDevopsTicketContextProjectsPayload {
        projects {
          name
        }
      }
      ... on ZendeskTicketContextFieldsPayload {
        priority {
          value
          displayName
        }
        type {
          value
          displayName
        }
      }
    }
  }
`;

/**
 * __useGetTicketContextQuery__
 *
 * To run a query within a React component, call `useGetTicketContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketContextQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTicketContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTicketContextQuery,
    GetTicketContextQueryVariables
  > &
    (
      | { variables: GetTicketContextQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTicketContextQuery, GetTicketContextQueryVariables>(
    GetTicketContextDocument,
    options,
  );
}
export function useGetTicketContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTicketContextQuery,
    GetTicketContextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTicketContextQuery,
    GetTicketContextQueryVariables
  >(GetTicketContextDocument, options);
}
// @ts-ignore
export function useGetTicketContextSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTicketContextQuery,
    GetTicketContextQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTicketContextQuery,
  GetTicketContextQueryVariables
>;
export function useGetTicketContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTicketContextQuery,
        GetTicketContextQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTicketContextQuery | undefined,
  GetTicketContextQueryVariables
>;
export function useGetTicketContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTicketContextQuery,
        GetTicketContextQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTicketContextQuery,
    GetTicketContextQueryVariables
  >(GetTicketContextDocument, options);
}
export type GetTicketContextQueryHookResult = ReturnType<
  typeof useGetTicketContextQuery
>;
export type GetTicketContextLazyQueryHookResult = ReturnType<
  typeof useGetTicketContextLazyQuery
>;
export type GetTicketContextSuspenseQueryHookResult = ReturnType<
  typeof useGetTicketContextSuspenseQuery
>;
export type GetTicketContextQueryResult = Apollo.QueryResult<
  GetTicketContextQuery,
  GetTicketContextQueryVariables
>;
export const GetTicketingIntegrationsDocument = gql`
  query GetTicketingIntegrations($input: TicketingIntegrationsInput!) {
    ticketingIntegrations(input: $input) {
      integrations {
        mrn
        name
        type
        configurationOptions {
          ... on JiraConfigurationOptions {
            host
            email
            defaultProject
            autoCloseTickets
            autoCreateCases
            cloudId
          }
          ... on EmailConfigurationOptions {
            autoCreateTickets
            recipients {
              name
              email
              isDefault
              referenceUrl
            }
          }
          ... on ZendeskConfigurationOptions {
            subdomain
            email
            autoCloseTickets
            autoCreateTickets
            customFields {
              id
              value
            }
          }
          ... on GithubTicketingConfigurationOptions {
            enterpriseUrl
            defaultRepoOwner
            defaultRepoName
            autoCloseTickets
            autoCreateTickets
          }
          ... on GitlabTicketingConfigurationOptions {
            gitlabBaseUrl: baseUrl
            gitlabDefaultProject: defaultProject
            autoCloseTickets
            autoCreateTickets
          }
          ... on AzureDevopsConfigurationOptions {
            defaultProjectName
            organizationUrl
            servicePrincipalId
            tenantId
            autoCloseTickets
            autoCreateTickets
          }
          ... on WebhookConfigurationOptions {
            url
          }
          ... on ServiceNowConfigurationOptions {
            instanceUrl
            clientId
            autoCloseTickets
            autoCreateTickets
            userEmail
          }
        }
      }
    }
  }
`;

/**
 * __useGetTicketingIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetTicketingIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketingIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketingIntegrationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTicketingIntegrationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTicketingIntegrationsQuery,
    GetTicketingIntegrationsQueryVariables
  > &
    (
      | { variables: GetTicketingIntegrationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTicketingIntegrationsQuery,
    GetTicketingIntegrationsQueryVariables
  >(GetTicketingIntegrationsDocument, options);
}
export function useGetTicketingIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTicketingIntegrationsQuery,
    GetTicketingIntegrationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTicketingIntegrationsQuery,
    GetTicketingIntegrationsQueryVariables
  >(GetTicketingIntegrationsDocument, options);
}
// @ts-ignore
export function useGetTicketingIntegrationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTicketingIntegrationsQuery,
    GetTicketingIntegrationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTicketingIntegrationsQuery,
  GetTicketingIntegrationsQueryVariables
>;
export function useGetTicketingIntegrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTicketingIntegrationsQuery,
        GetTicketingIntegrationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTicketingIntegrationsQuery | undefined,
  GetTicketingIntegrationsQueryVariables
>;
export function useGetTicketingIntegrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTicketingIntegrationsQuery,
        GetTicketingIntegrationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTicketingIntegrationsQuery,
    GetTicketingIntegrationsQueryVariables
  >(GetTicketingIntegrationsDocument, options);
}
export type GetTicketingIntegrationsQueryHookResult = ReturnType<
  typeof useGetTicketingIntegrationsQuery
>;
export type GetTicketingIntegrationsLazyQueryHookResult = ReturnType<
  typeof useGetTicketingIntegrationsLazyQuery
>;
export type GetTicketingIntegrationsSuspenseQueryHookResult = ReturnType<
  typeof useGetTicketingIntegrationsSuspenseQuery
>;
export type GetTicketingIntegrationsQueryResult = Apollo.QueryResult<
  GetTicketingIntegrationsQuery,
  GetTicketingIntegrationsQueryVariables
>;
export const GetTopAssetFindingsDocument = gql`
  query GetTopAssetFindings(
    $scopeMrn: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        edges {
          cursor
          node {
            ... on CheckFinding {
              mrn
              id
              title
              state
              iconId
              baseScore
              riskValue
              rating
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              lastUpdated
              tags {
                key
                value
              }
              asset {
                id
                mrn
                name
                icon
                lastUpdated
                platform {
                  name
                  title
                  arch
                  version
                  kind
                  runtime
                  release
                  family
                  labels {
                    key
                    value
                  }
                }
              }
              exceptions {
                id
                exceptionId
                exceptionMrn
                reviewStatus
                action
                justification
              }
              resultType
              mquery {
                uid
                mrn
                title
                docs {
                  desc
                  remediations {
                    ... on Remediations {
                      entries {
                        id
                        desc
                      }
                    }
                    ... on AuthenticationRequired {
                      message
                      code
                    }
                  }
                  references {
                    title
                    url
                  }
                  audit
                  remediation
                }
                impact {
                  value
                  rating
                }
                mql
                properties {
                  uid
                  mrn
                  title
                  mql
                  defaultValue
                  overrideValue
                  setByPolicyMrn
                  for {
                    mrn
                  }
                }
                parent
                variants {
                  id
                  mrn
                  title
                  icon
                }
                variantQueries {
                  uid
                  mrn
                  title
                  mql
                  filter
                  filterID
                }
                action
                code
                codeId
                severity
              }
            }
            ... on CveFinding {
              mrn
              id
              asset {
                id
                mrn
                name
                icon
                lastUpdated
                platform {
                  name
                  title
                  arch
                  version
                  kind
                  runtime
                  release
                  family
                  labels {
                    key
                    value
                  }
                }
              }
              title
              state
              iconId
              epss {
                probability
                percentile
              }
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
              riskValue
              rating
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              firstDetectedAt
              publishedAt
              tags {
                key
                value
              }
              lastUpdated
              detectionSources {
                name
                url
                firstDetectedAt
                lastUpdatedAt
                fixedAt
                vendor
                version
              }
              exceptions {
                id
                exceptionId
                exceptionMrn
                reviewStatus
                action
                justification
              }
            }
            ... on AdvisoryFinding {
              mrn
              id
              asset {
                id
                mrn
                name
                icon
                lastUpdated
                platform {
                  name
                  title
                  arch
                  version
                  kind
                  runtime
                  release
                  family
                  labels {
                    key
                    value
                  }
                }
              }
              title
              state
              iconId
              epss {
                probability
                percentile
              }
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
              riskValue
              rating
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              firstDetectedAt
              publishedAt
              tags {
                key
                value
              }
              lastUpdated
              detectionSources {
                name
                url
                firstDetectedAt
                lastUpdatedAt
                fixedAt
                vendor
                version
              }
              exceptions {
                id
                exceptionId
                exceptionMrn
                reviewStatus
                action
                justification
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetTopAssetFindingsQuery__
 *
 * To run a query within a React component, call `useGetTopAssetFindingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopAssetFindingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopAssetFindingsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTopAssetFindingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTopAssetFindingsQuery,
    GetTopAssetFindingsQueryVariables
  > &
    (
      | { variables: GetTopAssetFindingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTopAssetFindingsQuery,
    GetTopAssetFindingsQueryVariables
  >(GetTopAssetFindingsDocument, options);
}
export function useGetTopAssetFindingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTopAssetFindingsQuery,
    GetTopAssetFindingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTopAssetFindingsQuery,
    GetTopAssetFindingsQueryVariables
  >(GetTopAssetFindingsDocument, options);
}
// @ts-ignore
export function useGetTopAssetFindingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTopAssetFindingsQuery,
    GetTopAssetFindingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTopAssetFindingsQuery,
  GetTopAssetFindingsQueryVariables
>;
export function useGetTopAssetFindingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTopAssetFindingsQuery,
        GetTopAssetFindingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTopAssetFindingsQuery | undefined,
  GetTopAssetFindingsQueryVariables
>;
export function useGetTopAssetFindingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTopAssetFindingsQuery,
        GetTopAssetFindingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTopAssetFindingsQuery,
    GetTopAssetFindingsQueryVariables
  >(GetTopAssetFindingsDocument, options);
}
export type GetTopAssetFindingsQueryHookResult = ReturnType<
  typeof useGetTopAssetFindingsQuery
>;
export type GetTopAssetFindingsLazyQueryHookResult = ReturnType<
  typeof useGetTopAssetFindingsLazyQuery
>;
export type GetTopAssetFindingsSuspenseQueryHookResult = ReturnType<
  typeof useGetTopAssetFindingsSuspenseQuery
>;
export type GetTopAssetFindingsQueryResult = Apollo.QueryResult<
  GetTopAssetFindingsQuery,
  GetTopAssetFindingsQueryVariables
>;
export const GetTotalAssetsDocument = gql`
  query GetTotalAssets($scopeMrn: String, $workflowMrn: String) {
    assets(scopeMrn: $scopeMrn, workflowMrn: $workflowMrn) {
      totalCount
    }
  }
`;

/**
 * __useGetTotalAssetsQuery__
 *
 * To run a query within a React component, call `useGetTotalAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalAssetsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      workflowMrn: // value for 'workflowMrn'
 *   },
 * });
 */
export function useGetTotalAssetsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTotalAssetsQuery,
    GetTotalAssetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTotalAssetsQuery, GetTotalAssetsQueryVariables>(
    GetTotalAssetsDocument,
    options,
  );
}
export function useGetTotalAssetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTotalAssetsQuery,
    GetTotalAssetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTotalAssetsQuery, GetTotalAssetsQueryVariables>(
    GetTotalAssetsDocument,
    options,
  );
}
// @ts-ignore
export function useGetTotalAssetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTotalAssetsQuery,
    GetTotalAssetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTotalAssetsQuery,
  GetTotalAssetsQueryVariables
>;
export function useGetTotalAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTotalAssetsQuery,
        GetTotalAssetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTotalAssetsQuery | undefined,
  GetTotalAssetsQueryVariables
>;
export function useGetTotalAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTotalAssetsQuery,
        GetTotalAssetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTotalAssetsQuery,
    GetTotalAssetsQueryVariables
  >(GetTotalAssetsDocument, options);
}
export type GetTotalAssetsQueryHookResult = ReturnType<
  typeof useGetTotalAssetsQuery
>;
export type GetTotalAssetsLazyQueryHookResult = ReturnType<
  typeof useGetTotalAssetsLazyQuery
>;
export type GetTotalAssetsSuspenseQueryHookResult = ReturnType<
  typeof useGetTotalAssetsSuspenseQuery
>;
export type GetTotalAssetsQueryResult = Apollo.QueryResult<
  GetTotalAssetsQuery,
  GetTotalAssetsQueryVariables
>;
export const GetUserProfileDocument = gql`
  query GetUserProfile(
    $mrn: String!
    $identitiesFilter: [String!]
    $includeChildrenOnly: Boolean
    $first: Int
    $after: String
  ) {
    userInfo: organization(mrn: $mrn) {
      id
      mrn
      members(identitiesFilter: $identitiesFilter) {
        edges {
          node {
            identity {
              ... on User {
                createdAt
                email
                mrn
                name
              }
            }
            roles {
              mrn
              title
            }
          }
        }
      }
    }
    spaceInfo: organization(mrn: $mrn) {
      id
      mrn
      members(
        identitiesFilter: $identitiesFilter
        includeChildrenOnly: $includeChildrenOnly
        first: $first
        after: $after
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            roles {
              mrn
              title
            }
            resource {
              mrn
              name
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      identitiesFilter: // value for 'identitiesFilter'
 *      includeChildrenOnly: // value for 'includeChildrenOnly'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetUserProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserProfileQuery,
    GetUserProfileQueryVariables
  > &
    (
      | { variables: GetUserProfileQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(
    GetUserProfileDocument,
    options,
  );
}
export function useGetUserProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserProfileQuery,
    GetUserProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(
    GetUserProfileDocument,
    options,
  );
}
// @ts-ignore
export function useGetUserProfileSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserProfileQuery,
    GetUserProfileQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetUserProfileQuery,
  GetUserProfileQueryVariables
>;
export function useGetUserProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUserProfileQuery,
        GetUserProfileQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetUserProfileQuery | undefined,
  GetUserProfileQueryVariables
>;
export function useGetUserProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUserProfileQuery,
        GetUserProfileQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUserProfileQuery,
    GetUserProfileQueryVariables
  >(GetUserProfileDocument, options);
}
export type GetUserProfileQueryHookResult = ReturnType<
  typeof useGetUserProfileQuery
>;
export type GetUserProfileLazyQueryHookResult = ReturnType<
  typeof useGetUserProfileLazyQuery
>;
export type GetUserProfileSuspenseQueryHookResult = ReturnType<
  typeof useGetUserProfileSuspenseQuery
>;
export type GetUserProfileQueryResult = Apollo.QueryResult<
  GetUserProfileQuery,
  GetUserProfileQueryVariables
>;
export const GetWorkspaceDocument = gql`
  query GetWorkspace($mrn: String!, $metricMrns: [String!]) {
    workspace(mrn: $mrn) {
      ... on Workspace {
        mrn
        ownerMrn
        name
        description
        priorityFindings
        assetGroupStats {
          count
          groupType
          displayName
        }
        metrics(metricMrns: $metricMrns) {
          ... on MetricsResponse {
            entries {
              metricMrn
              title
              arrowResult
            }
          }
        }
      }
      ... on RequestError {
        code
        message
      }
      ... on NotFoundError {
        code
        message
      }
    }
  }
`;

/**
 * __useGetWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      metricMrns: // value for 'metricMrns'
 *   },
 * });
 */
export function useGetWorkspaceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkspaceQuery,
    GetWorkspaceQueryVariables
  > &
    (
      | { variables: GetWorkspaceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkspaceQuery, GetWorkspaceQueryVariables>(
    GetWorkspaceDocument,
    options,
  );
}
export function useGetWorkspaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkspaceQuery,
    GetWorkspaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkspaceQuery, GetWorkspaceQueryVariables>(
    GetWorkspaceDocument,
    options,
  );
}
// @ts-ignore
export function useGetWorkspaceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkspaceQuery,
    GetWorkspaceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetWorkspaceQuery, GetWorkspaceQueryVariables>;
export function useGetWorkspaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspaceQuery,
        GetWorkspaceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspaceQuery | undefined,
  GetWorkspaceQueryVariables
>;
export function useGetWorkspaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspaceQuery,
        GetWorkspaceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWorkspaceQuery, GetWorkspaceQueryVariables>(
    GetWorkspaceDocument,
    options,
  );
}
export type GetWorkspaceQueryHookResult = ReturnType<
  typeof useGetWorkspaceQuery
>;
export type GetWorkspaceLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceLazyQuery
>;
export type GetWorkspaceSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspaceSuspenseQuery
>;
export type GetWorkspaceQueryResult = Apollo.QueryResult<
  GetWorkspaceQuery,
  GetWorkspaceQueryVariables
>;
export const GetWorkspacesGlobalCountDocument = gql`
  query GetWorkspacesGlobalCount($input: WorkspacesInput!) {
    workspaces(input: $input) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetWorkspacesGlobalCountQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesGlobalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesGlobalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesGlobalCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkspacesGlobalCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkspacesGlobalCountQuery,
    GetWorkspacesGlobalCountQueryVariables
  > &
    (
      | { variables: GetWorkspacesGlobalCountQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkspacesGlobalCountQuery,
    GetWorkspacesGlobalCountQueryVariables
  >(GetWorkspacesGlobalCountDocument, options);
}
export function useGetWorkspacesGlobalCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkspacesGlobalCountQuery,
    GetWorkspacesGlobalCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkspacesGlobalCountQuery,
    GetWorkspacesGlobalCountQueryVariables
  >(GetWorkspacesGlobalCountDocument, options);
}
// @ts-ignore
export function useGetWorkspacesGlobalCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkspacesGlobalCountQuery,
    GetWorkspacesGlobalCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspacesGlobalCountQuery,
  GetWorkspacesGlobalCountQueryVariables
>;
export function useGetWorkspacesGlobalCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspacesGlobalCountQuery,
        GetWorkspacesGlobalCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspacesGlobalCountQuery | undefined,
  GetWorkspacesGlobalCountQueryVariables
>;
export function useGetWorkspacesGlobalCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspacesGlobalCountQuery,
        GetWorkspacesGlobalCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkspacesGlobalCountQuery,
    GetWorkspacesGlobalCountQueryVariables
  >(GetWorkspacesGlobalCountDocument, options);
}
export type GetWorkspacesGlobalCountQueryHookResult = ReturnType<
  typeof useGetWorkspacesGlobalCountQuery
>;
export type GetWorkspacesGlobalCountLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacesGlobalCountLazyQuery
>;
export type GetWorkspacesGlobalCountSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspacesGlobalCountSuspenseQuery
>;
export type GetWorkspacesGlobalCountQueryResult = Apollo.QueryResult<
  GetWorkspacesGlobalCountQuery,
  GetWorkspacesGlobalCountQueryVariables
>;
export const GetWorkspaceInventoryStatsDocument = gql`
  query GetWorkspaceInventoryStats(
    $workspaceMrn: String!
    $metricMrns: [String!]
  ) {
    workspace(mrn: $workspaceMrn) {
      ... on Workspace {
        mrn
        metrics(metricMrns: $metricMrns) {
          ... on MetricsResponse {
            entries {
              metricMrn
              title
              arrowResult
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetWorkspaceInventoryStatsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceInventoryStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceInventoryStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceInventoryStatsQuery({
 *   variables: {
 *      workspaceMrn: // value for 'workspaceMrn'
 *      metricMrns: // value for 'metricMrns'
 *   },
 * });
 */
export function useGetWorkspaceInventoryStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkspaceInventoryStatsQuery,
    GetWorkspaceInventoryStatsQueryVariables
  > &
    (
      | { variables: GetWorkspaceInventoryStatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkspaceInventoryStatsQuery,
    GetWorkspaceInventoryStatsQueryVariables
  >(GetWorkspaceInventoryStatsDocument, options);
}
export function useGetWorkspaceInventoryStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkspaceInventoryStatsQuery,
    GetWorkspaceInventoryStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkspaceInventoryStatsQuery,
    GetWorkspaceInventoryStatsQueryVariables
  >(GetWorkspaceInventoryStatsDocument, options);
}
// @ts-ignore
export function useGetWorkspaceInventoryStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkspaceInventoryStatsQuery,
    GetWorkspaceInventoryStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspaceInventoryStatsQuery,
  GetWorkspaceInventoryStatsQueryVariables
>;
export function useGetWorkspaceInventoryStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspaceInventoryStatsQuery,
        GetWorkspaceInventoryStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspaceInventoryStatsQuery | undefined,
  GetWorkspaceInventoryStatsQueryVariables
>;
export function useGetWorkspaceInventoryStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspaceInventoryStatsQuery,
        GetWorkspaceInventoryStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkspaceInventoryStatsQuery,
    GetWorkspaceInventoryStatsQueryVariables
  >(GetWorkspaceInventoryStatsDocument, options);
}
export type GetWorkspaceInventoryStatsQueryHookResult = ReturnType<
  typeof useGetWorkspaceInventoryStatsQuery
>;
export type GetWorkspaceInventoryStatsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceInventoryStatsLazyQuery
>;
export type GetWorkspaceInventoryStatsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspaceInventoryStatsSuspenseQuery
>;
export type GetWorkspaceInventoryStatsQueryResult = Apollo.QueryResult<
  GetWorkspaceInventoryStatsQuery,
  GetWorkspaceInventoryStatsQueryVariables
>;
export const GetWorkspaceScopeDocument = gql`
  query GetWorkspaceScope($mrn: String!, $actions: [String!]!) {
    workspace(mrn: $mrn) {
      ... on Workspace {
        mrn
        name
        description
      }
    }
    iamActions: testIamActions(resourceMrn: $mrn, actions: $actions)
  }
`;

/**
 * __useGetWorkspaceScopeQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceScopeQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      actions: // value for 'actions'
 *   },
 * });
 */
export function useGetWorkspaceScopeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkspaceScopeQuery,
    GetWorkspaceScopeQueryVariables
  > &
    (
      | { variables: GetWorkspaceScopeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkspaceScopeQuery,
    GetWorkspaceScopeQueryVariables
  >(GetWorkspaceScopeDocument, options);
}
export function useGetWorkspaceScopeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkspaceScopeQuery,
    GetWorkspaceScopeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkspaceScopeQuery,
    GetWorkspaceScopeQueryVariables
  >(GetWorkspaceScopeDocument, options);
}
// @ts-ignore
export function useGetWorkspaceScopeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkspaceScopeQuery,
    GetWorkspaceScopeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspaceScopeQuery,
  GetWorkspaceScopeQueryVariables
>;
export function useGetWorkspaceScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspaceScopeQuery,
        GetWorkspaceScopeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspaceScopeQuery | undefined,
  GetWorkspaceScopeQueryVariables
>;
export function useGetWorkspaceScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspaceScopeQuery,
        GetWorkspaceScopeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkspaceScopeQuery,
    GetWorkspaceScopeQueryVariables
  >(GetWorkspaceScopeDocument, options);
}
export type GetWorkspaceScopeQueryHookResult = ReturnType<
  typeof useGetWorkspaceScopeQuery
>;
export type GetWorkspaceScopeLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceScopeLazyQuery
>;
export type GetWorkspaceScopeSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspaceScopeSuspenseQuery
>;
export type GetWorkspaceScopeQueryResult = Apollo.QueryResult<
  GetWorkspaceScopeQuery,
  GetWorkspaceScopeQueryVariables
>;
export const GetWorkspacesDocument = gql`
  query GetWorkspaces(
    $input: WorkspacesInput!
    $after: String
    $first: Int
    $metricMrns: [String!]
    $startTime: String
    $endTime: String
  ) {
    workspaces(input: $input, after: $after, first: $first) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          mrn
          ownerMrn
          name
          description
          assetGroupStats {
            count
            displayName
            groupType
            icon
            listsAssetTypes {
              assetType
              displayName
              shortName
              aliases
            }
            statistics {
              count
              type {
                assetType
                displayName
                shortName
                aliases
              }
            }
          }
          metrics(
            metricMrns: $metricMrns
            startTime: $startTime
            endTime: $endTime
          ) {
            ... on MetricsResponse {
              entries {
                metricMrn
                title
                arrowResult
              }
            }
          }
          priorityFindings
        }
      }
    }
  }
`;

/**
 * __useGetWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      metricMrns: // value for 'metricMrns'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetWorkspacesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkspacesQuery,
    GetWorkspacesQueryVariables
  > &
    (
      | { variables: GetWorkspacesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkspacesQuery, GetWorkspacesQueryVariables>(
    GetWorkspacesDocument,
    options,
  );
}
export function useGetWorkspacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkspacesQuery,
    GetWorkspacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkspacesQuery, GetWorkspacesQueryVariables>(
    GetWorkspacesDocument,
    options,
  );
}
// @ts-ignore
export function useGetWorkspacesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkspacesQuery,
    GetWorkspacesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspacesQuery,
  GetWorkspacesQueryVariables
>;
export function useGetWorkspacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspacesQuery,
        GetWorkspacesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspacesQuery | undefined,
  GetWorkspacesQueryVariables
>;
export function useGetWorkspacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspacesQuery,
        GetWorkspacesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkspacesQuery,
    GetWorkspacesQueryVariables
  >(GetWorkspacesDocument, options);
}
export type GetWorkspacesQueryHookResult = ReturnType<
  typeof useGetWorkspacesQuery
>;
export type GetWorkspacesLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacesLazyQuery
>;
export type GetWorkspacesSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspacesSuspenseQuery
>;
export type GetWorkspacesQueryResult = Apollo.QueryResult<
  GetWorkspacesQuery,
  GetWorkspacesQueryVariables
>;
export const GetWorkspacesListDocument = gql`
  query GetWorkspacesList($input: WorkspacesInput!) {
    workspaces(input: $input) {
      edges {
        node {
          mrn
          name
        }
      }
    }
  }
`;

/**
 * __useGetWorkspacesListQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkspacesListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkspacesListQuery,
    GetWorkspacesListQueryVariables
  > &
    (
      | { variables: GetWorkspacesListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkspacesListQuery,
    GetWorkspacesListQueryVariables
  >(GetWorkspacesListDocument, options);
}
export function useGetWorkspacesListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkspacesListQuery,
    GetWorkspacesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkspacesListQuery,
    GetWorkspacesListQueryVariables
  >(GetWorkspacesListDocument, options);
}
// @ts-ignore
export function useGetWorkspacesListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkspacesListQuery,
    GetWorkspacesListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspacesListQuery,
  GetWorkspacesListQueryVariables
>;
export function useGetWorkspacesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspacesListQuery,
        GetWorkspacesListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspacesListQuery | undefined,
  GetWorkspacesListQueryVariables
>;
export function useGetWorkspacesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspacesListQuery,
        GetWorkspacesListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkspacesListQuery,
    GetWorkspacesListQueryVariables
  >(GetWorkspacesListDocument, options);
}
export type GetWorkspacesListQueryHookResult = ReturnType<
  typeof useGetWorkspacesListQuery
>;
export type GetWorkspacesListLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacesListLazyQuery
>;
export type GetWorkspacesListSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspacesListSuspenseQuery
>;
export type GetWorkspacesListQueryResult = Apollo.QueryResult<
  GetWorkspacesListQuery,
  GetWorkspacesListQueryVariables
>;
export const ListClientIntegrationsDocument = gql`
  query ListClientIntegrations($input: ListClientIntegrationsInput!) {
    listClientIntegrations(input: $input) {
      integrations {
        mrn
        name
        status
        created
        type
        lastCheckin
        lastModified
        createdBy {
          mrn
          name
        }
        messages {
          message
          status
        }
        configurationOptions {
          ... on AWSConfigurationOptions {
            accountIds
            region
            isOrganization
            scanConfiguration {
              ec2ScanOptions {
                ebsScanOptions {
                  maxAsgInstances
                  targetInstancesPerScanner
                }
                ebsVolumeScan
                vaultType
                tagsFilter
                excludedTagsFilter
                regionsFilter
                excludedRegionsFilter
                instanceIdsFilter
                excludedInstanceIdsFilter
                secretsMetadataQuery
                awsSecretsManagerVault
                ssm
                instanceConnect
              }
              eventScanTriggers {
                eventDetailType
                eventSource
                scanType
              }
              ecrScan
              ecsScan
              cronScaninHours
              accountScan
              ec2Scan
            }
            snsEndpoint
            originAWSAccountId
          }
          ... on HostedAwsConfigurationOptions {
            accessKeyId
            role
          }
          ... on K8sConfigurationOptions {
            scanDeploys
            scanNodes
            scanWorkloads
            scanPublicImages
            certificateManager
          }
          ... on MicrosoftDefenderConfigurationOptions {
            tenantId
            clientId
            subscriptionsAllowlist
            subscriptionsDenylist
            secretType
            createAssets
            mondooEnrichment
          }
          ... on GithubConfigurationOptions {
            owner
            repository
            organization
            type
            reposAllowList
            reposDenyList
          }
          ... on ShodanConfigurationOptions {
            token
            targets
          }
          ... on SentinelOneConfigurationOptions {
            host
            account
            secretType
            createAssets
            mondooEnrichment
          }
          ... on CrowdstrikeFalconConfigurationOptions {
            clientId
            cloud
            memberCID
            createAssets
            mondooEnrichment
          }
          ... on SecurityPipelineGithubConfigurationOptions {
            appInstallationLink
            publicKey
            autoCreateWorkflows
            repositories {
              link
              fullName
              spaceMrn
            }
          }
        }
        lastStateInfo {
          ... on K8sIntegrationLastState {
            namespace
            k8sVersion
            operatorVersion
          }
        }
      }
    }
  }
`;

/**
 * __useListClientIntegrationsQuery__
 *
 * To run a query within a React component, call `useListClientIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClientIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClientIntegrationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListClientIntegrationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListClientIntegrationsQuery,
    ListClientIntegrationsQueryVariables
  > &
    (
      | { variables: ListClientIntegrationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListClientIntegrationsQuery,
    ListClientIntegrationsQueryVariables
  >(ListClientIntegrationsDocument, options);
}
export function useListClientIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListClientIntegrationsQuery,
    ListClientIntegrationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListClientIntegrationsQuery,
    ListClientIntegrationsQueryVariables
  >(ListClientIntegrationsDocument, options);
}
// @ts-ignore
export function useListClientIntegrationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListClientIntegrationsQuery,
    ListClientIntegrationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListClientIntegrationsQuery,
  ListClientIntegrationsQueryVariables
>;
export function useListClientIntegrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListClientIntegrationsQuery,
        ListClientIntegrationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListClientIntegrationsQuery | undefined,
  ListClientIntegrationsQueryVariables
>;
export function useListClientIntegrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListClientIntegrationsQuery,
        ListClientIntegrationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListClientIntegrationsQuery,
    ListClientIntegrationsQueryVariables
  >(ListClientIntegrationsDocument, options);
}
export type ListClientIntegrationsQueryHookResult = ReturnType<
  typeof useListClientIntegrationsQuery
>;
export type ListClientIntegrationsLazyQueryHookResult = ReturnType<
  typeof useListClientIntegrationsLazyQuery
>;
export type ListClientIntegrationsSuspenseQueryHookResult = ReturnType<
  typeof useListClientIntegrationsSuspenseQuery
>;
export type ListClientIntegrationsQueryResult = Apollo.QueryResult<
  ListClientIntegrationsQuery,
  ListClientIntegrationsQueryVariables
>;
export const ListDiscoveryResultsDocument = gql`
  query ListDiscoveryResults($input: ListDiscoveryResultsInput!) {
    listDiscoveryResults(input: $input) {
      stats {
        identifier
        query
        count
        title
      }
    }
  }
`;

/**
 * __useListDiscoveryResultsQuery__
 *
 * To run a query within a React component, call `useListDiscoveryResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDiscoveryResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDiscoveryResultsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListDiscoveryResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListDiscoveryResultsQuery,
    ListDiscoveryResultsQueryVariables
  > &
    (
      | { variables: ListDiscoveryResultsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListDiscoveryResultsQuery,
    ListDiscoveryResultsQueryVariables
  >(ListDiscoveryResultsDocument, options);
}
export function useListDiscoveryResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListDiscoveryResultsQuery,
    ListDiscoveryResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListDiscoveryResultsQuery,
    ListDiscoveryResultsQueryVariables
  >(ListDiscoveryResultsDocument, options);
}
// @ts-ignore
export function useListDiscoveryResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListDiscoveryResultsQuery,
    ListDiscoveryResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListDiscoveryResultsQuery,
  ListDiscoveryResultsQueryVariables
>;
export function useListDiscoveryResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDiscoveryResultsQuery,
        ListDiscoveryResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListDiscoveryResultsQuery | undefined,
  ListDiscoveryResultsQueryVariables
>;
export function useListDiscoveryResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDiscoveryResultsQuery,
        ListDiscoveryResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListDiscoveryResultsQuery,
    ListDiscoveryResultsQueryVariables
  >(ListDiscoveryResultsDocument, options);
}
export type ListDiscoveryResultsQueryHookResult = ReturnType<
  typeof useListDiscoveryResultsQuery
>;
export type ListDiscoveryResultsLazyQueryHookResult = ReturnType<
  typeof useListDiscoveryResultsLazyQuery
>;
export type ListDiscoveryResultsSuspenseQueryHookResult = ReturnType<
  typeof useListDiscoveryResultsSuspenseQuery
>;
export type ListDiscoveryResultsQueryResult = Apollo.QueryResult<
  ListDiscoveryResultsQuery,
  ListDiscoveryResultsQueryVariables
>;
export const ListDocumentsDocument = gql`
  query ListDocuments($scopeMrn: String!, $first: Int!, $after: String) {
    listDocuments(scopeMRN: $scopeMrn, first: $first, after: $after) {
      totalCount
      edges {
        cursor
        node {
          mrn
          name
          type
          format
          status
          statusMessage
          messages {
            id
            message
            status
            timestamp
          }
          createdBy {
            name
            email
            type
          }
          requestedAt
          generatedAt
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useListDocumentsQuery__
 *
 * To run a query within a React component, call `useListDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDocumentsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListDocumentsQuery,
    ListDocumentsQueryVariables
  > &
    (
      | { variables: ListDocumentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(
    ListDocumentsDocument,
    options,
  );
}
export function useListDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListDocumentsQuery,
    ListDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(
    ListDocumentsDocument,
    options,
  );
}
// @ts-ignore
export function useListDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListDocumentsQuery,
    ListDocumentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListDocumentsQuery,
  ListDocumentsQueryVariables
>;
export function useListDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDocumentsQuery,
        ListDocumentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListDocumentsQuery | undefined,
  ListDocumentsQueryVariables
>;
export function useListDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDocumentsQuery,
        ListDocumentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListDocumentsQuery,
    ListDocumentsQueryVariables
  >(ListDocumentsDocument, options);
}
export type ListDocumentsQueryHookResult = ReturnType<
  typeof useListDocumentsQuery
>;
export type ListDocumentsLazyQueryHookResult = ReturnType<
  typeof useListDocumentsLazyQuery
>;
export type ListDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useListDocumentsSuspenseQuery
>;
export type ListDocumentsQueryResult = Apollo.QueryResult<
  ListDocumentsQuery,
  ListDocumentsQueryVariables
>;
export const ListExceptionGroupsDocument = gql`
  query ListExceptionGroups(
    $input: ListExceptionGroupsInput!
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    listExceptionGroups(
      input: $input
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      edges {
        cursor
        node {
          action
          author {
            email
            mrn
            name
            type
          }
          createdAt
          deletedAt
          deletedBy {
            name
            email
          }
          exceptionId
          mrn
          id
          justification
          modifiedAt
          reviewStatus
          status
          reviewer {
            email
            name
            type
          }
          scopeMrn
          title
          validUntil
          extensions {
            validUntil
            author {
              name
              mrn
              type
              email
            }
            reviewer {
              type
              name
              email
            }
            justification
            status
            createDate
            reviewDate
          }
          exceptions {
            ... on AssetCheckException {
              mrn
              score {
                id
                value
                type
                completion
                weight
                message
                grade
                riskScore
                riskValue
                riskRating
              }
              title
              riskScore
              riskValue
              rating
              policyMrn
              policyName
            }
            ... on SpaceCheckException {
              mrn
              title
              riskScore
              riskValue
              rating
              assetsStats {
                passed
                failed
                errored
                total
              }
              policyMrn
              policyName
            }
            ... on AssetCveException {
              mrn
              id
              title
              riskScore
              riskValue
              rating
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
            }
            ... on AssetAdvisoryException {
              mrn
              id
              title
              iconId
              riskScore
              riskValue
              rating
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
            }
            ... on SpaceCveException {
              mrn
              id
              title
              riskScore
              riskValue
              rating
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
            }
            ... on SpaceAdvisoryException {
              mrn
              id
              title
              iconId
              riskScore
              riskValue
              rating
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
            }
            ... on SpaceFexException {
              mrn
              title
              riskValue
              rating
            }
            ... on AssetFexException {
              mrn
              title
              riskValue
              rating
            }
            ... on ControlsEdge {
              cursor
              node {
                exception {
                  id
                  exceptionId
                  exceptionMrn
                  author {
                    name
                    mrn
                    type
                    email
                  }
                  reviewer {
                    name
                    email
                  }
                  createdAt
                  modifiedAt
                  title
                  justification
                  reviewStatus
                  status
                  action
                }
                mrn
                assetsStats {
                  compliantAssets
                  failedAssets
                  totalAssets
                }
                title
                state
                scopeMrn
                description
                completion
                framework {
                  name
                  mrn
                }
              }
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;

/**
 * __useListExceptionGroupsQuery__
 *
 * To run a query within a React component, call `useListExceptionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListExceptionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListExceptionGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useListExceptionGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListExceptionGroupsQuery,
    ListExceptionGroupsQueryVariables
  > &
    (
      | { variables: ListExceptionGroupsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListExceptionGroupsQuery,
    ListExceptionGroupsQueryVariables
  >(ListExceptionGroupsDocument, options);
}
export function useListExceptionGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListExceptionGroupsQuery,
    ListExceptionGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListExceptionGroupsQuery,
    ListExceptionGroupsQueryVariables
  >(ListExceptionGroupsDocument, options);
}
// @ts-ignore
export function useListExceptionGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListExceptionGroupsQuery,
    ListExceptionGroupsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListExceptionGroupsQuery,
  ListExceptionGroupsQueryVariables
>;
export function useListExceptionGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListExceptionGroupsQuery,
        ListExceptionGroupsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListExceptionGroupsQuery | undefined,
  ListExceptionGroupsQueryVariables
>;
export function useListExceptionGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListExceptionGroupsQuery,
        ListExceptionGroupsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListExceptionGroupsQuery,
    ListExceptionGroupsQueryVariables
  >(ListExceptionGroupsDocument, options);
}
export type ListExceptionGroupsQueryHookResult = ReturnType<
  typeof useListExceptionGroupsQuery
>;
export type ListExceptionGroupsLazyQueryHookResult = ReturnType<
  typeof useListExceptionGroupsLazyQuery
>;
export type ListExceptionGroupsSuspenseQueryHookResult = ReturnType<
  typeof useListExceptionGroupsSuspenseQuery
>;
export type ListExceptionGroupsQueryResult = Apollo.QueryResult<
  ListExceptionGroupsQuery,
  ListExceptionGroupsQueryVariables
>;
export const ListSpaceExceptionsDocument = gql`
  query ListSpaceExceptions(
    $input: ListExceptionGroupsInput!
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    listExceptionGroups(
      input: $input
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          action
          author {
            name
            mrn
            email
            type
          }
          createdAt
          deletedAt
          deletedBy {
            email
            name
            type
          }
          extensions {
            validUntil
            author {
              name
              mrn
              type
              email
            }
            reviewer {
              name
              email
              type
            }
            justification
            status
            createDate
            reviewDate
          }
          exceptions {
            ... on ControlsEdge {
              node {
                framework {
                  name
                  version
                }
                mrn
                description
                title
                manual
                completion
                tags {
                  key
                  value
                }
                state
                assetsStats {
                  compliantAssets
                  failedAssets
                  totalAssets
                }
                checksStats {
                  activeChecks
                  snoozedChecks
                  disabledChecks
                  totalChecks
                }
              }
            }
            ... on SpaceAdvisoryException {
              mrn
              id
              title
              iconId
              riskValue
              rating
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
            }
            ... on SpaceCheckException {
              mrn
              title
              riskValue
              rating
              assetsStats {
                passed
                failed
                errored
                total
              }
              policyMrn
              policyName
            }
            ... on SpaceCveException {
              mrn
              id
              title
              riskValue
              rating
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
            }
            ... on AssetAdvisoryException {
              mrn
              id
              title
              iconId
              riskValue
              rating
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
            }
            ... on AssetCheckException {
              mrn
              title
              riskValue
              rating
              policyMrn
              policyName
            }
            ... on AssetCveException {
              mrn
              id
              title
              riskValue
              rating
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
            }
            ... on SpaceFexException {
              mrn
              title
              riskValue
              rating
            }
            ... on AssetFexException {
              mrn
              title
              riskValue
              rating
            }
          }
          id
          mrn
          exceptionId
          scopeMrn
          title
          justification
          modifiedAt
          validUntil
          reviewStatus
          isActive
          status
          reviewer {
            email
            name
            type
          }
        }
      }
    }
  }
`;

/**
 * __useListSpaceExceptionsQuery__
 *
 * To run a query within a React component, call `useListSpaceExceptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSpaceExceptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSpaceExceptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useListSpaceExceptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListSpaceExceptionsQuery,
    ListSpaceExceptionsQueryVariables
  > &
    (
      | { variables: ListSpaceExceptionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListSpaceExceptionsQuery,
    ListSpaceExceptionsQueryVariables
  >(ListSpaceExceptionsDocument, options);
}
export function useListSpaceExceptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListSpaceExceptionsQuery,
    ListSpaceExceptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListSpaceExceptionsQuery,
    ListSpaceExceptionsQueryVariables
  >(ListSpaceExceptionsDocument, options);
}
// @ts-ignore
export function useListSpaceExceptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListSpaceExceptionsQuery,
    ListSpaceExceptionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListSpaceExceptionsQuery,
  ListSpaceExceptionsQueryVariables
>;
export function useListSpaceExceptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListSpaceExceptionsQuery,
        ListSpaceExceptionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListSpaceExceptionsQuery | undefined,
  ListSpaceExceptionsQueryVariables
>;
export function useListSpaceExceptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListSpaceExceptionsQuery,
        ListSpaceExceptionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListSpaceExceptionsQuery,
    ListSpaceExceptionsQueryVariables
  >(ListSpaceExceptionsDocument, options);
}
export type ListSpaceExceptionsQueryHookResult = ReturnType<
  typeof useListSpaceExceptionsQuery
>;
export type ListSpaceExceptionsLazyQueryHookResult = ReturnType<
  typeof useListSpaceExceptionsLazyQuery
>;
export type ListSpaceExceptionsSuspenseQueryHookResult = ReturnType<
  typeof useListSpaceExceptionsSuspenseQuery
>;
export type ListSpaceExceptionsQueryResult = Apollo.QueryResult<
  ListSpaceExceptionsQuery,
  ListSpaceExceptionsQueryVariables
>;
export const LoadAdvisoryDocument = gql`
  query LoadAdvisory($id: ID!, $spaceMrn: String) {
    advisory(id: $id, spaceMrn: $spaceMrn) {
      mrn
      id
      title
      vulnerabilityRiskFactors {
        ...VulnerabilityRiskFactorsFields
      }
      externalUrls {
        iconIDEnum
        url
        title
      }
      publishedAt
      modifiedAt
      description
      cvssScore {
        id
        value
        type
        vector
        source
        rating
      }
    }
  }
  ${VulnerabilityRiskFactorsFieldsFragmentDoc}
`;

/**
 * __useLoadAdvisoryQuery__
 *
 * To run a query within a React component, call `useLoadAdvisoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAdvisoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAdvisoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      spaceMrn: // value for 'spaceMrn'
 *   },
 * });
 */
export function useLoadAdvisoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadAdvisoryQuery,
    LoadAdvisoryQueryVariables
  > &
    (
      | { variables: LoadAdvisoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadAdvisoryQuery, LoadAdvisoryQueryVariables>(
    LoadAdvisoryDocument,
    options,
  );
}
export function useLoadAdvisoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadAdvisoryQuery,
    LoadAdvisoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoadAdvisoryQuery, LoadAdvisoryQueryVariables>(
    LoadAdvisoryDocument,
    options,
  );
}
// @ts-ignore
export function useLoadAdvisorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadAdvisoryQuery,
    LoadAdvisoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LoadAdvisoryQuery, LoadAdvisoryQueryVariables>;
export function useLoadAdvisorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadAdvisoryQuery,
        LoadAdvisoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadAdvisoryQuery | undefined,
  LoadAdvisoryQueryVariables
>;
export function useLoadAdvisorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadAdvisoryQuery,
        LoadAdvisoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LoadAdvisoryQuery, LoadAdvisoryQueryVariables>(
    LoadAdvisoryDocument,
    options,
  );
}
export type LoadAdvisoryQueryHookResult = ReturnType<
  typeof useLoadAdvisoryQuery
>;
export type LoadAdvisoryLazyQueryHookResult = ReturnType<
  typeof useLoadAdvisoryLazyQuery
>;
export type LoadAdvisorySuspenseQueryHookResult = ReturnType<
  typeof useLoadAdvisorySuspenseQuery
>;
export type LoadAdvisoryQueryResult = Apollo.QueryResult<
  LoadAdvisoryQuery,
  LoadAdvisoryQueryVariables
>;
export const LoadAdvisoryCvesDocument = gql`
  query LoadAdvisoryCves($advisoryId: ID!, $scopeMrn: String) {
    advisory(id: $advisoryId) {
      id
      mrn
      cves(scopeMrn: $scopeMrn) {
        id
        mrn
        riskValue
        rating
        source {
          id
          name
          url
        }
        title
        description
        summary
        publishedAt
        modifiedAt
        url
        cvssScore {
          id
          value
          type
          vector
          source
        }
        epssScore {
          percentile
          probability
        }
        cwe
        state
        vulnerabilityRiskFactors {
          ...VulnerabilityRiskFactorsFields
        }
      }
    }
  }
  ${VulnerabilityRiskFactorsFieldsFragmentDoc}
`;

/**
 * __useLoadAdvisoryCvesQuery__
 *
 * To run a query within a React component, call `useLoadAdvisoryCvesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAdvisoryCvesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAdvisoryCvesQuery({
 *   variables: {
 *      advisoryId: // value for 'advisoryId'
 *      scopeMrn: // value for 'scopeMrn'
 *   },
 * });
 */
export function useLoadAdvisoryCvesQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadAdvisoryCvesQuery,
    LoadAdvisoryCvesQueryVariables
  > &
    (
      | { variables: LoadAdvisoryCvesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadAdvisoryCvesQuery, LoadAdvisoryCvesQueryVariables>(
    LoadAdvisoryCvesDocument,
    options,
  );
}
export function useLoadAdvisoryCvesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadAdvisoryCvesQuery,
    LoadAdvisoryCvesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadAdvisoryCvesQuery,
    LoadAdvisoryCvesQueryVariables
  >(LoadAdvisoryCvesDocument, options);
}
// @ts-ignore
export function useLoadAdvisoryCvesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadAdvisoryCvesQuery,
    LoadAdvisoryCvesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadAdvisoryCvesQuery,
  LoadAdvisoryCvesQueryVariables
>;
export function useLoadAdvisoryCvesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadAdvisoryCvesQuery,
        LoadAdvisoryCvesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadAdvisoryCvesQuery | undefined,
  LoadAdvisoryCvesQueryVariables
>;
export function useLoadAdvisoryCvesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadAdvisoryCvesQuery,
        LoadAdvisoryCvesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadAdvisoryCvesQuery,
    LoadAdvisoryCvesQueryVariables
  >(LoadAdvisoryCvesDocument, options);
}
export type LoadAdvisoryCvesQueryHookResult = ReturnType<
  typeof useLoadAdvisoryCvesQuery
>;
export type LoadAdvisoryCvesLazyQueryHookResult = ReturnType<
  typeof useLoadAdvisoryCvesLazyQuery
>;
export type LoadAdvisoryCvesSuspenseQueryHookResult = ReturnType<
  typeof useLoadAdvisoryCvesSuspenseQuery
>;
export type LoadAdvisoryCvesQueryResult = Apollo.QueryResult<
  LoadAdvisoryCvesQuery,
  LoadAdvisoryCvesQueryVariables
>;
export const LoadAgentDocument = gql`
  query LoadAgent($mrn: String!) {
    agent(mrn: $mrn) {
      id
      mrn
      name
      status {
        version
        state
        lastCheckin
      }
      labels {
        key
        value
      }
      platform {
        name
        release
        arch
      }
      hostname
      ipaddress
      createdAt
      errors {
        timestamp
        message
      }
      serviceAccounts {
        mrn
        name
      }
      assets {
        mrn
        name
      }
    }
  }
`;

/**
 * __useLoadAgentQuery__
 *
 * To run a query within a React component, call `useLoadAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAgentQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useLoadAgentQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadAgentQuery,
    LoadAgentQueryVariables
  > &
    (
      | { variables: LoadAgentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadAgentQuery, LoadAgentQueryVariables>(
    LoadAgentDocument,
    options,
  );
}
export function useLoadAgentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadAgentQuery,
    LoadAgentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoadAgentQuery, LoadAgentQueryVariables>(
    LoadAgentDocument,
    options,
  );
}
// @ts-ignore
export function useLoadAgentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadAgentQuery,
    LoadAgentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LoadAgentQuery, LoadAgentQueryVariables>;
export function useLoadAgentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoadAgentQuery, LoadAgentQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  LoadAgentQuery | undefined,
  LoadAgentQueryVariables
>;
export function useLoadAgentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoadAgentQuery, LoadAgentQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LoadAgentQuery, LoadAgentQueryVariables>(
    LoadAgentDocument,
    options,
  );
}
export type LoadAgentQueryHookResult = ReturnType<typeof useLoadAgentQuery>;
export type LoadAgentLazyQueryHookResult = ReturnType<
  typeof useLoadAgentLazyQuery
>;
export type LoadAgentSuspenseQueryHookResult = ReturnType<
  typeof useLoadAgentSuspenseQuery
>;
export type LoadAgentQueryResult = Apollo.QueryResult<
  LoadAgentQuery,
  LoadAgentQueryVariables
>;
export const LoadAssetDocument = gql`
  query LoadAsset($mrn: String!) {
    asset(mrn: $mrn) {
      id
      mrn
      state
      name
      labels {
        key
        value
      }
      createdAt
      updatedAt
      lastScoredAt
      platform {
        name
        title
        arch
        version
        kind
        runtime
        release
        family
      }
      score {
        id
        value
        type
        completion
        weight
        message
        grade
        riskValue
        riskRating
      }
      eol {
        date
        status
      }
      referenceIDs
      annotations {
        key
        value
      }
      asset_type
      insights {
        security {
          policyCount
          score {
            id
            value
            type
            completion
            weight
            message
            grade
            riskRating
            riskValue
          }
        }
        vulnerability {
          score {
            id
            value
            type
            completion
            weight
            message
            grade
            riskRating
            riskValue
          }
        }
      }
      overviewGroups {
        items {
          key
          name
          sources {
            ... on KeyValueSource {
              key
              value
            }
            ... on QuerySource {
              mrn
            }
          }
          values {
            ... on AssetOverviewStringValue {
              stringValue: value
            }
            ... on AssetOverviewNullValue {
              nullValue: value
            }
            ... on AssetOverviewTimeValue {
              timeValue: value
            }
            ... on AssetOverviewArrayValue {
              arrayValue: value {
                ... on AssetOverviewStringValue {
                  stringValue: value
                }
                ... on AssetOverviewNullValue {
                  nullValue: value
                }
                ... on AssetOverviewTimeValue {
                  timeValue: value
                }
                ... on AssetOverviewDictValue {
                  dictValue: value {
                    key
                    value
                  }
                }
                ... on AssetOverviewBoolValue {
                  boolValue: value
                }
                ... on AssetOverviewReferenceValue {
                  displayValue
                  mrn
                  referenceType
                }
                ... on AssetOverviewError {
                  value {
                    ... on AssetOverviewErrorExecutionFailed {
                      msg
                      queryMrn
                    }
                    ... on AssetOverviewGenericError {
                      code
                      msg
                    }
                  }
                }
                ... on AssetOverviewURLValue {
                  displayValue
                  url
                }
              }
            }
            ... on AssetOverviewDictValue {
              dictValue: value {
                key
                value
              }
            }
            ... on AssetOverviewBoolValue {
              boolValue: value
            }
            ... on AssetOverviewReferenceValue {
              displayValue
              mrn
              referenceType
            }
            ... on AssetOverviewError {
              value {
                ... on AssetOverviewErrorExecutionFailed {
                  msg
                  queryMrn
                }
                ... on AssetOverviewGenericError {
                  code
                  msg
                }
              }
            }
            ... on AssetOverviewURLValue {
              displayValue
              url
            }
          }
        }
        key
        title
      }
      listPolicies {
        totalCount
        edges {
          cursor
          node {
            mrn
            name
            action
            category
            score {
              id
              value
              type
              completion
              weight
              message
              grade
              riskRating
              riskValue
            }
            scoreStats {
              total
              passed
              failed
              incomplete
              errors
              skipped
              worst
              snoozed
              disabled
              exceptions
              unknown
              riskAccepted
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
      riskFactors {
        mrn
        indicator
        title
        magnitude {
          value
          isToxic
        }
        isDetected
        isPositive
        explanation {
          magnitudeExplanation
          summary
        }
        affected
        total
      }
    }
  }
`;

/**
 * __useLoadAssetQuery__
 *
 * To run a query within a React component, call `useLoadAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAssetQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useLoadAssetQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadAssetQuery,
    LoadAssetQueryVariables
  > &
    (
      | { variables: LoadAssetQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadAssetQuery, LoadAssetQueryVariables>(
    LoadAssetDocument,
    options,
  );
}
export function useLoadAssetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadAssetQuery,
    LoadAssetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoadAssetQuery, LoadAssetQueryVariables>(
    LoadAssetDocument,
    options,
  );
}
// @ts-ignore
export function useLoadAssetSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadAssetQuery,
    LoadAssetQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LoadAssetQuery, LoadAssetQueryVariables>;
export function useLoadAssetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoadAssetQuery, LoadAssetQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  LoadAssetQuery | undefined,
  LoadAssetQueryVariables
>;
export function useLoadAssetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoadAssetQuery, LoadAssetQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LoadAssetQuery, LoadAssetQueryVariables>(
    LoadAssetDocument,
    options,
  );
}
export type LoadAssetQueryHookResult = ReturnType<typeof useLoadAssetQuery>;
export type LoadAssetLazyQueryHookResult = ReturnType<
  typeof useLoadAssetLazyQuery
>;
export type LoadAssetSuspenseQueryHookResult = ReturnType<
  typeof useLoadAssetSuspenseQuery
>;
export type LoadAssetQueryResult = Apollo.QueryResult<
  LoadAssetQuery,
  LoadAssetQueryVariables
>;
export const LoadAssetListPoliciesDocument = gql`
  query LoadAssetListPolicies(
    $mrn: String!
    $first: Int
    $after: String
    $filter: AssetListPoliciesFilter
  ) {
    asset(mrn: $mrn) {
      mrn
      listPolicies(first: $first, after: $after, filter: $filter) {
        totalCount
        edges {
          cursor
          node {
            mrn
            name
            category
            action
            score {
              id
              value
              type
              completion
              weight
              message
              grade
              riskRating
              riskValue
            }
            scoreStats {
              total
              passed
              failed
              incomplete
              errors
              exceptions
              disabled
              snoozed
              skipped
              worst
              unknown
              riskAccepted
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;

/**
 * __useLoadAssetListPoliciesQuery__
 *
 * To run a query within a React component, call `useLoadAssetListPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAssetListPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAssetListPoliciesQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLoadAssetListPoliciesQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadAssetListPoliciesQuery,
    LoadAssetListPoliciesQueryVariables
  > &
    (
      | { variables: LoadAssetListPoliciesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadAssetListPoliciesQuery,
    LoadAssetListPoliciesQueryVariables
  >(LoadAssetListPoliciesDocument, options);
}
export function useLoadAssetListPoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadAssetListPoliciesQuery,
    LoadAssetListPoliciesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadAssetListPoliciesQuery,
    LoadAssetListPoliciesQueryVariables
  >(LoadAssetListPoliciesDocument, options);
}
// @ts-ignore
export function useLoadAssetListPoliciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadAssetListPoliciesQuery,
    LoadAssetListPoliciesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadAssetListPoliciesQuery,
  LoadAssetListPoliciesQueryVariables
>;
export function useLoadAssetListPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadAssetListPoliciesQuery,
        LoadAssetListPoliciesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadAssetListPoliciesQuery | undefined,
  LoadAssetListPoliciesQueryVariables
>;
export function useLoadAssetListPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadAssetListPoliciesQuery,
        LoadAssetListPoliciesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadAssetListPoliciesQuery,
    LoadAssetListPoliciesQueryVariables
  >(LoadAssetListPoliciesDocument, options);
}
export type LoadAssetListPoliciesQueryHookResult = ReturnType<
  typeof useLoadAssetListPoliciesQuery
>;
export type LoadAssetListPoliciesLazyQueryHookResult = ReturnType<
  typeof useLoadAssetListPoliciesLazyQuery
>;
export type LoadAssetListPoliciesSuspenseQueryHookResult = ReturnType<
  typeof useLoadAssetListPoliciesSuspenseQuery
>;
export type LoadAssetListPoliciesQueryResult = Apollo.QueryResult<
  LoadAssetListPoliciesQuery,
  LoadAssetListPoliciesQueryVariables
>;
export const LoadCategoriesDocument = gql`
  query LoadCategories($input: CategoriesListInput!) {
    categories(input: $input) {
      name
      packs
      policies
      queries
    }
  }
`;

/**
 * __useLoadCategoriesQuery__
 *
 * To run a query within a React component, call `useLoadCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadCategoriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoadCategoriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadCategoriesQuery,
    LoadCategoriesQueryVariables
  > &
    (
      | { variables: LoadCategoriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadCategoriesQuery, LoadCategoriesQueryVariables>(
    LoadCategoriesDocument,
    options,
  );
}
export function useLoadCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadCategoriesQuery,
    LoadCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoadCategoriesQuery, LoadCategoriesQueryVariables>(
    LoadCategoriesDocument,
    options,
  );
}
// @ts-ignore
export function useLoadCategoriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadCategoriesQuery,
    LoadCategoriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadCategoriesQuery,
  LoadCategoriesQueryVariables
>;
export function useLoadCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadCategoriesQuery,
        LoadCategoriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadCategoriesQuery | undefined,
  LoadCategoriesQueryVariables
>;
export function useLoadCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadCategoriesQuery,
        LoadCategoriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadCategoriesQuery,
    LoadCategoriesQueryVariables
  >(LoadCategoriesDocument, options);
}
export type LoadCategoriesQueryHookResult = ReturnType<
  typeof useLoadCategoriesQuery
>;
export type LoadCategoriesLazyQueryHookResult = ReturnType<
  typeof useLoadCategoriesLazyQuery
>;
export type LoadCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useLoadCategoriesSuspenseQuery
>;
export type LoadCategoriesQueryResult = Apollo.QueryResult<
  LoadCategoriesQuery,
  LoadCategoriesQueryVariables
>;
export const LoadCicdProjectJobsDocument = gql`
  query LoadCicdProjectJobs(
    $input: CicdProjectJobsInput!
    $first: Int
    $after: String
    $labelFilter: [KeyValueInput!]
  ) {
    cicdProjectJobs(input: $input) {
      ... on CicdProjectJobs {
        id
        spaceMrn
        project {
          id
          mrn
          type
          name
          projectURL
          projectID
        }
        jobs(first: $first, after: $after, labelFilter: $labelFilter) {
          totalCount
          edges {
            cursor
            node {
              ... on GitlabJob {
                id
                mrn
                name
                target
                projectUrl
                projectId
                projectTitle
                pipelineUrl
                jobId
                jobName
                jobURL
                jobStage
                commitSha
                commitDescription
                commitRefName
                mergeRequestId
                mergeRequestProjectUrl
                userName
                userId
                userEmail
                defaultBranch
                score {
                  type
                  id
                  value
                  type
                  completion
                  weight
                  message
                  riskRating
                  riskValue
                }
                pipelineKind
                updatedAt
              }
              ... on GithubJob {
                id
                mrn
                name
                target
                action
                workflow
                job
                runId
                runNumber
                actor
                repository
                eventName
                eventPath
                workspace
                sha
                ref
                headRef
                baseRef
                serverUrl
                score {
                  type
                  id
                  value
                  type
                  completion
                  weight
                  message
                  riskRating
                  riskValue
                }
                pipelineKind
                updatedAt
              }
              ... on CircleCIJob {
                id
                mrn
                name
                target
                projectUrl
                mergeRequestUrl
                job
                jobId
                buildUrl
                userName
                commitSha
                repositoryUrl
                branch
                associatedPullRequests
                workflowId
                workflowJobId
                workflowWorkspaceId
                score {
                  type
                  id
                  value
                  type
                  completion
                  weight
                  message
                  riskRating
                  riskValue
                }
                pipelineKind
                updatedAt
              }
              ... on AzureDevopsJob {
                id
                mrn
                name
                target
                projectUrl
                job
                jobId
                buildUrl
                userName
                commitSha
                repositoryUrl
                branch
                score {
                  type
                  id
                  value
                  type
                  completion
                  weight
                  message
                  riskRating
                  riskValue
                }
                pipelineKind
                updatedAt
              }
              ... on JenkinsJob {
                id
                mrn
                name
                target
                projectUrl
                job
                jobId
                buildUrl
                userName
                commitSha
                repositoryUrl
                branch
                score {
                  type
                  id
                  value
                  type
                  completion
                  weight
                  message
                  riskRating
                  riskValue
                }
                pipelineKind
                updatedAt
              }
              ... on KubernetesJob {
                id
                mrn
                score {
                  type
                  id
                  value
                  type
                  completion
                  weight
                  message
                  riskRating
                  riskValue
                }
                updatedAt
                clusterId
                namespace
                uid
                name
                target
                operation
                kind
                author
                ownerName
                ownerUid
                ownerKind
                resourceVersion
              }
            }
          }
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
        }
      }
    }
  }
`;

/**
 * __useLoadCicdProjectJobsQuery__
 *
 * To run a query within a React component, call `useLoadCicdProjectJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadCicdProjectJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadCicdProjectJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      labelFilter: // value for 'labelFilter'
 *   },
 * });
 */
export function useLoadCicdProjectJobsQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadCicdProjectJobsQuery,
    LoadCicdProjectJobsQueryVariables
  > &
    (
      | { variables: LoadCicdProjectJobsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadCicdProjectJobsQuery,
    LoadCicdProjectJobsQueryVariables
  >(LoadCicdProjectJobsDocument, options);
}
export function useLoadCicdProjectJobsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadCicdProjectJobsQuery,
    LoadCicdProjectJobsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadCicdProjectJobsQuery,
    LoadCicdProjectJobsQueryVariables
  >(LoadCicdProjectJobsDocument, options);
}
// @ts-ignore
export function useLoadCicdProjectJobsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadCicdProjectJobsQuery,
    LoadCicdProjectJobsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadCicdProjectJobsQuery,
  LoadCicdProjectJobsQueryVariables
>;
export function useLoadCicdProjectJobsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadCicdProjectJobsQuery,
        LoadCicdProjectJobsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadCicdProjectJobsQuery | undefined,
  LoadCicdProjectJobsQueryVariables
>;
export function useLoadCicdProjectJobsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadCicdProjectJobsQuery,
        LoadCicdProjectJobsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadCicdProjectJobsQuery,
    LoadCicdProjectJobsQueryVariables
  >(LoadCicdProjectJobsDocument, options);
}
export type LoadCicdProjectJobsQueryHookResult = ReturnType<
  typeof useLoadCicdProjectJobsQuery
>;
export type LoadCicdProjectJobsLazyQueryHookResult = ReturnType<
  typeof useLoadCicdProjectJobsLazyQuery
>;
export type LoadCicdProjectJobsSuspenseQueryHookResult = ReturnType<
  typeof useLoadCicdProjectJobsSuspenseQuery
>;
export type LoadCicdProjectJobsQueryResult = Apollo.QueryResult<
  LoadCicdProjectJobsQuery,
  LoadCicdProjectJobsQueryVariables
>;
export const LoadCicdProjectsDocument = gql`
  query LoadCicdProjects($input: CicdProjectsInput!) {
    cicdProjects(input: $input) {
      ... on CicdProjects {
        spaceMrn
        projects {
          totalCount
          edges {
            cursor
            node {
              id
              mrn
              type
              name
            }
          }
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
        }
      }
    }
  }
`;

/**
 * __useLoadCicdProjectsQuery__
 *
 * To run a query within a React component, call `useLoadCicdProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadCicdProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadCicdProjectsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoadCicdProjectsQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadCicdProjectsQuery,
    LoadCicdProjectsQueryVariables
  > &
    (
      | { variables: LoadCicdProjectsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadCicdProjectsQuery, LoadCicdProjectsQueryVariables>(
    LoadCicdProjectsDocument,
    options,
  );
}
export function useLoadCicdProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadCicdProjectsQuery,
    LoadCicdProjectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadCicdProjectsQuery,
    LoadCicdProjectsQueryVariables
  >(LoadCicdProjectsDocument, options);
}
// @ts-ignore
export function useLoadCicdProjectsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadCicdProjectsQuery,
    LoadCicdProjectsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadCicdProjectsQuery,
  LoadCicdProjectsQueryVariables
>;
export function useLoadCicdProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadCicdProjectsQuery,
        LoadCicdProjectsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadCicdProjectsQuery | undefined,
  LoadCicdProjectsQueryVariables
>;
export function useLoadCicdProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadCicdProjectsQuery,
        LoadCicdProjectsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadCicdProjectsQuery,
    LoadCicdProjectsQueryVariables
  >(LoadCicdProjectsDocument, options);
}
export type LoadCicdProjectsQueryHookResult = ReturnType<
  typeof useLoadCicdProjectsQuery
>;
export type LoadCicdProjectsLazyQueryHookResult = ReturnType<
  typeof useLoadCicdProjectsLazyQuery
>;
export type LoadCicdProjectsSuspenseQueryHookResult = ReturnType<
  typeof useLoadCicdProjectsSuspenseQuery
>;
export type LoadCicdProjectsQueryResult = Apollo.QueryResult<
  LoadCicdProjectsQuery,
  LoadCicdProjectsQueryVariables
>;
export const LoadCveDocument = gql`
  query LoadCve($id: ID!) {
    cve(id: $id) {
      cvssScore {
        id
        source
        type
        value
        vector
        rating
      }
      epssScore {
        percentile
        probability
      }
      cwe
      description
      id
      modifiedAt
      mrn
      publishedAt
      source {
        id
        name
        url
      }
      externalUrls {
        iconIDEnum
        url
        title
      }
      url
      references
      state
      summary
      title
      vulnerabilityRiskFactors {
        ...VulnerabilityRiskFactorsFields
      }
    }
  }
  ${VulnerabilityRiskFactorsFieldsFragmentDoc}
`;

/**
 * __useLoadCveQuery__
 *
 * To run a query within a React component, call `useLoadCveQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadCveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadCveQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadCveQuery(
  baseOptions: Apollo.QueryHookOptions<LoadCveQuery, LoadCveQueryVariables> &
    ({ variables: LoadCveQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadCveQuery, LoadCveQueryVariables>(
    LoadCveDocument,
    options,
  );
}
export function useLoadCveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadCveQuery,
    LoadCveQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoadCveQuery, LoadCveQueryVariables>(
    LoadCveDocument,
    options,
  );
}
// @ts-ignore
export function useLoadCveSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadCveQuery,
    LoadCveQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LoadCveQuery, LoadCveQueryVariables>;
export function useLoadCveSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoadCveQuery, LoadCveQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  LoadCveQuery | undefined,
  LoadCveQueryVariables
>;
export function useLoadCveSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoadCveQuery, LoadCveQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LoadCveQuery, LoadCveQueryVariables>(
    LoadCveDocument,
    options,
  );
}
export type LoadCveQueryHookResult = ReturnType<typeof useLoadCveQuery>;
export type LoadCveLazyQueryHookResult = ReturnType<typeof useLoadCveLazyQuery>;
export type LoadCveSuspenseQueryHookResult = ReturnType<
  typeof useLoadCveSuspenseQuery
>;
export type LoadCveQueryResult = Apollo.QueryResult<
  LoadCveQuery,
  LoadCveQueryVariables
>;
export const LoadEmailPreferencesDocument = gql`
  query LoadEmailPreferences {
    emailPreferences {
      listID
      subscribed
      subscribedAt
    }
  }
`;

/**
 * __useLoadEmailPreferencesQuery__
 *
 * To run a query within a React component, call `useLoadEmailPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadEmailPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadEmailPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoadEmailPreferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LoadEmailPreferencesQuery,
    LoadEmailPreferencesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadEmailPreferencesQuery,
    LoadEmailPreferencesQueryVariables
  >(LoadEmailPreferencesDocument, options);
}
export function useLoadEmailPreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadEmailPreferencesQuery,
    LoadEmailPreferencesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadEmailPreferencesQuery,
    LoadEmailPreferencesQueryVariables
  >(LoadEmailPreferencesDocument, options);
}
// @ts-ignore
export function useLoadEmailPreferencesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadEmailPreferencesQuery,
    LoadEmailPreferencesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadEmailPreferencesQuery,
  LoadEmailPreferencesQueryVariables
>;
export function useLoadEmailPreferencesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadEmailPreferencesQuery,
        LoadEmailPreferencesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadEmailPreferencesQuery | undefined,
  LoadEmailPreferencesQueryVariables
>;
export function useLoadEmailPreferencesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadEmailPreferencesQuery,
        LoadEmailPreferencesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadEmailPreferencesQuery,
    LoadEmailPreferencesQueryVariables
  >(LoadEmailPreferencesDocument, options);
}
export type LoadEmailPreferencesQueryHookResult = ReturnType<
  typeof useLoadEmailPreferencesQuery
>;
export type LoadEmailPreferencesLazyQueryHookResult = ReturnType<
  typeof useLoadEmailPreferencesLazyQuery
>;
export type LoadEmailPreferencesSuspenseQueryHookResult = ReturnType<
  typeof useLoadEmailPreferencesSuspenseQuery
>;
export type LoadEmailPreferencesQueryResult = Apollo.QueryResult<
  LoadEmailPreferencesQuery,
  LoadEmailPreferencesQueryVariables
>;
export const LoadIntegrationsDocument = gql`
  query LoadIntegrations($mrn: String!) {
    integrations(mrn: $mrn) {
      mrn
      name
      enabled
      options {
        url
        chatid
        token
        notificationType
      }
    }
  }
`;

/**
 * __useLoadIntegrationsQuery__
 *
 * To run a query within a React component, call `useLoadIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadIntegrationsQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useLoadIntegrationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadIntegrationsQuery,
    LoadIntegrationsQueryVariables
  > &
    (
      | { variables: LoadIntegrationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadIntegrationsQuery, LoadIntegrationsQueryVariables>(
    LoadIntegrationsDocument,
    options,
  );
}
export function useLoadIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadIntegrationsQuery,
    LoadIntegrationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadIntegrationsQuery,
    LoadIntegrationsQueryVariables
  >(LoadIntegrationsDocument, options);
}
// @ts-ignore
export function useLoadIntegrationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadIntegrationsQuery,
    LoadIntegrationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadIntegrationsQuery,
  LoadIntegrationsQueryVariables
>;
export function useLoadIntegrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadIntegrationsQuery,
        LoadIntegrationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadIntegrationsQuery | undefined,
  LoadIntegrationsQueryVariables
>;
export function useLoadIntegrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadIntegrationsQuery,
        LoadIntegrationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadIntegrationsQuery,
    LoadIntegrationsQueryVariables
  >(LoadIntegrationsDocument, options);
}
export type LoadIntegrationsQueryHookResult = ReturnType<
  typeof useLoadIntegrationsQuery
>;
export type LoadIntegrationsLazyQueryHookResult = ReturnType<
  typeof useLoadIntegrationsLazyQuery
>;
export type LoadIntegrationsSuspenseQueryHookResult = ReturnType<
  typeof useLoadIntegrationsSuspenseQuery
>;
export type LoadIntegrationsQueryResult = Apollo.QueryResult<
  LoadIntegrationsQuery,
  LoadIntegrationsQueryVariables
>;
export const LoadLegalPolicyConsentDocument = gql`
  query LoadLegalPolicyConsent($mrn: String!) {
    legalPolicies(mrn: $mrn) {
      name
      id
      consent {
        mrn
        email
        signatureAt
      }
    }
  }
`;

/**
 * __useLoadLegalPolicyConsentQuery__
 *
 * To run a query within a React component, call `useLoadLegalPolicyConsentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadLegalPolicyConsentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadLegalPolicyConsentQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useLoadLegalPolicyConsentQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadLegalPolicyConsentQuery,
    LoadLegalPolicyConsentQueryVariables
  > &
    (
      | { variables: LoadLegalPolicyConsentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadLegalPolicyConsentQuery,
    LoadLegalPolicyConsentQueryVariables
  >(LoadLegalPolicyConsentDocument, options);
}
export function useLoadLegalPolicyConsentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadLegalPolicyConsentQuery,
    LoadLegalPolicyConsentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadLegalPolicyConsentQuery,
    LoadLegalPolicyConsentQueryVariables
  >(LoadLegalPolicyConsentDocument, options);
}
// @ts-ignore
export function useLoadLegalPolicyConsentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadLegalPolicyConsentQuery,
    LoadLegalPolicyConsentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadLegalPolicyConsentQuery,
  LoadLegalPolicyConsentQueryVariables
>;
export function useLoadLegalPolicyConsentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadLegalPolicyConsentQuery,
        LoadLegalPolicyConsentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadLegalPolicyConsentQuery | undefined,
  LoadLegalPolicyConsentQueryVariables
>;
export function useLoadLegalPolicyConsentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadLegalPolicyConsentQuery,
        LoadLegalPolicyConsentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadLegalPolicyConsentQuery,
    LoadLegalPolicyConsentQueryVariables
  >(LoadLegalPolicyConsentDocument, options);
}
export type LoadLegalPolicyConsentQueryHookResult = ReturnType<
  typeof useLoadLegalPolicyConsentQuery
>;
export type LoadLegalPolicyConsentLazyQueryHookResult = ReturnType<
  typeof useLoadLegalPolicyConsentLazyQuery
>;
export type LoadLegalPolicyConsentSuspenseQueryHookResult = ReturnType<
  typeof useLoadLegalPolicyConsentSuspenseQuery
>;
export type LoadLegalPolicyConsentQueryResult = Apollo.QueryResult<
  LoadLegalPolicyConsentQuery,
  LoadLegalPolicyConsentQueryVariables
>;
export const LoadMqueryDocument = gql`
  query LoadMquery($input: MqueryInput!) {
    mquery(input: $input) {
      uid
      mrn
      title
      docs {
        ...MqueryDocsFields
      }
      impact {
        value
        rating
      }
      mql
      tags {
        key
        value
      }
      properties {
        uid
        mrn
        title
        mql
        defaultValue
        overrideValue
        setByPolicyMrn
        for {
          mrn
        }
      }
      parent
      variants {
        id
        mrn
        title
        icon
      }
      variantQueries {
        uid
        mrn
        title
        docs {
          ...MqueryDocsFields
        }
        impact {
          value
          rating
        }
        mql
        tags {
          key
          value
        }
        properties {
          uid
          mrn
          title
          mql
          defaultValue
          overrideValue
          setByPolicyMrn
          for {
            mrn
          }
        }
        filter
        filterID
      }
      action
    }
  }
  ${MqueryDocsFieldsFragmentDoc}
`;

/**
 * __useLoadMqueryQuery__
 *
 * To run a query within a React component, call `useLoadMqueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadMqueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadMqueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoadMqueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadMqueryQuery,
    LoadMqueryQueryVariables
  > &
    (
      | { variables: LoadMqueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadMqueryQuery, LoadMqueryQueryVariables>(
    LoadMqueryDocument,
    options,
  );
}
export function useLoadMqueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadMqueryQuery,
    LoadMqueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoadMqueryQuery, LoadMqueryQueryVariables>(
    LoadMqueryDocument,
    options,
  );
}
// @ts-ignore
export function useLoadMquerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadMqueryQuery,
    LoadMqueryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LoadMqueryQuery, LoadMqueryQueryVariables>;
export function useLoadMquerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadMqueryQuery,
        LoadMqueryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadMqueryQuery | undefined,
  LoadMqueryQueryVariables
>;
export function useLoadMquerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadMqueryQuery,
        LoadMqueryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LoadMqueryQuery, LoadMqueryQueryVariables>(
    LoadMqueryDocument,
    options,
  );
}
export type LoadMqueryQueryHookResult = ReturnType<typeof useLoadMqueryQuery>;
export type LoadMqueryLazyQueryHookResult = ReturnType<
  typeof useLoadMqueryLazyQuery
>;
export type LoadMquerySuspenseQueryHookResult = ReturnType<
  typeof useLoadMquerySuspenseQuery
>;
export type LoadMqueryQueryResult = Apollo.QueryResult<
  LoadMqueryQuery,
  LoadMqueryQueryVariables
>;
export const LoadOrganizationDocument = gql`
  query LoadOrganization($mrn: String!) {
    organization(mrn: $mrn) {
      id
      mrn
      name
      company
      capabilities
    }
  }
`;

/**
 * __useLoadOrganizationQuery__
 *
 * To run a query within a React component, call `useLoadOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadOrganizationQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useLoadOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadOrganizationQuery,
    LoadOrganizationQueryVariables
  > &
    (
      | { variables: LoadOrganizationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadOrganizationQuery, LoadOrganizationQueryVariables>(
    LoadOrganizationDocument,
    options,
  );
}
export function useLoadOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadOrganizationQuery,
    LoadOrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadOrganizationQuery,
    LoadOrganizationQueryVariables
  >(LoadOrganizationDocument, options);
}
// @ts-ignore
export function useLoadOrganizationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadOrganizationQuery,
    LoadOrganizationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationQuery,
  LoadOrganizationQueryVariables
>;
export function useLoadOrganizationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationQuery,
        LoadOrganizationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationQuery | undefined,
  LoadOrganizationQueryVariables
>;
export function useLoadOrganizationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationQuery,
        LoadOrganizationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadOrganizationQuery,
    LoadOrganizationQueryVariables
  >(LoadOrganizationDocument, options);
}
export type LoadOrganizationQueryHookResult = ReturnType<
  typeof useLoadOrganizationQuery
>;
export type LoadOrganizationLazyQueryHookResult = ReturnType<
  typeof useLoadOrganizationLazyQuery
>;
export type LoadOrganizationSuspenseQueryHookResult = ReturnType<
  typeof useLoadOrganizationSuspenseQuery
>;
export type LoadOrganizationQueryResult = Apollo.QueryResult<
  LoadOrganizationQuery,
  LoadOrganizationQueryVariables
>;
export const LoadOrganizationForSpaceDocument = gql`
  query LoadOrganizationForSpace($spaceMrn: String!) {
    space(mrn: $spaceMrn) {
      id
      mrn
      organization {
        id
        mrn
        name
        capabilities
        description
      }
    }
  }
`;

/**
 * __useLoadOrganizationForSpaceQuery__
 *
 * To run a query within a React component, call `useLoadOrganizationForSpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadOrganizationForSpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadOrganizationForSpaceQuery({
 *   variables: {
 *      spaceMrn: // value for 'spaceMrn'
 *   },
 * });
 */
export function useLoadOrganizationForSpaceQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadOrganizationForSpaceQuery,
    LoadOrganizationForSpaceQueryVariables
  > &
    (
      | { variables: LoadOrganizationForSpaceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadOrganizationForSpaceQuery,
    LoadOrganizationForSpaceQueryVariables
  >(LoadOrganizationForSpaceDocument, options);
}
export function useLoadOrganizationForSpaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadOrganizationForSpaceQuery,
    LoadOrganizationForSpaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadOrganizationForSpaceQuery,
    LoadOrganizationForSpaceQueryVariables
  >(LoadOrganizationForSpaceDocument, options);
}
// @ts-ignore
export function useLoadOrganizationForSpaceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadOrganizationForSpaceQuery,
    LoadOrganizationForSpaceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationForSpaceQuery,
  LoadOrganizationForSpaceQueryVariables
>;
export function useLoadOrganizationForSpaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationForSpaceQuery,
        LoadOrganizationForSpaceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationForSpaceQuery | undefined,
  LoadOrganizationForSpaceQueryVariables
>;
export function useLoadOrganizationForSpaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationForSpaceQuery,
        LoadOrganizationForSpaceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadOrganizationForSpaceQuery,
    LoadOrganizationForSpaceQueryVariables
  >(LoadOrganizationForSpaceDocument, options);
}
export type LoadOrganizationForSpaceQueryHookResult = ReturnType<
  typeof useLoadOrganizationForSpaceQuery
>;
export type LoadOrganizationForSpaceLazyQueryHookResult = ReturnType<
  typeof useLoadOrganizationForSpaceLazyQuery
>;
export type LoadOrganizationForSpaceSuspenseQueryHookResult = ReturnType<
  typeof useLoadOrganizationForSpaceSuspenseQuery
>;
export type LoadOrganizationForSpaceQueryResult = Apollo.QueryResult<
  LoadOrganizationForSpaceQuery,
  LoadOrganizationForSpaceQueryVariables
>;
export const LoadOrganizationMembersDocument = gql`
  query LoadOrganizationMembers(
    $mrn: String!
    $first: Int
    $after: String
    $orderBy: MembershipOrder
    $query: String
  ) {
    organization(mrn: $mrn) {
      id
      mrn
      company
      members(
        first: $first
        after: $after
        orderBy: $orderBy
        query: $query
        identityTypeFilter: [USER]
      ) {
        edges {
          cursor
          node {
            identity {
              mrn
              name
              ... on User {
                email
              }
            }
            roles {
              mrn
              title
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
      }
    }
  }
`;

/**
 * __useLoadOrganizationMembersQuery__
 *
 * To run a query within a React component, call `useLoadOrganizationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadOrganizationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadOrganizationMembersQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useLoadOrganizationMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadOrganizationMembersQuery,
    LoadOrganizationMembersQueryVariables
  > &
    (
      | { variables: LoadOrganizationMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadOrganizationMembersQuery,
    LoadOrganizationMembersQueryVariables
  >(LoadOrganizationMembersDocument, options);
}
export function useLoadOrganizationMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadOrganizationMembersQuery,
    LoadOrganizationMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadOrganizationMembersQuery,
    LoadOrganizationMembersQueryVariables
  >(LoadOrganizationMembersDocument, options);
}
// @ts-ignore
export function useLoadOrganizationMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadOrganizationMembersQuery,
    LoadOrganizationMembersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationMembersQuery,
  LoadOrganizationMembersQueryVariables
>;
export function useLoadOrganizationMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationMembersQuery,
        LoadOrganizationMembersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationMembersQuery | undefined,
  LoadOrganizationMembersQueryVariables
>;
export function useLoadOrganizationMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationMembersQuery,
        LoadOrganizationMembersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadOrganizationMembersQuery,
    LoadOrganizationMembersQueryVariables
  >(LoadOrganizationMembersDocument, options);
}
export type LoadOrganizationMembersQueryHookResult = ReturnType<
  typeof useLoadOrganizationMembersQuery
>;
export type LoadOrganizationMembersLazyQueryHookResult = ReturnType<
  typeof useLoadOrganizationMembersLazyQuery
>;
export type LoadOrganizationMembersSuspenseQueryHookResult = ReturnType<
  typeof useLoadOrganizationMembersSuspenseQuery
>;
export type LoadOrganizationMembersQueryResult = Apollo.QueryResult<
  LoadOrganizationMembersQuery,
  LoadOrganizationMembersQueryVariables
>;
export const LoadOrganizationSsoProviderDocument = gql`
  query LoadOrganizationSSOProvider($mrn: String!) {
    ssoProvider(mrn: $mrn) {
      provider {
        idpEntityID
        ssoUrl
        rpEntityID
        x509Fingerprints
        enabled
      }
    }
  }
`;

/**
 * __useLoadOrganizationSsoProviderQuery__
 *
 * To run a query within a React component, call `useLoadOrganizationSsoProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadOrganizationSsoProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadOrganizationSsoProviderQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useLoadOrganizationSsoProviderQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadOrganizationSsoProviderQuery,
    LoadOrganizationSsoProviderQueryVariables
  > &
    (
      | { variables: LoadOrganizationSsoProviderQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadOrganizationSsoProviderQuery,
    LoadOrganizationSsoProviderQueryVariables
  >(LoadOrganizationSsoProviderDocument, options);
}
export function useLoadOrganizationSsoProviderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadOrganizationSsoProviderQuery,
    LoadOrganizationSsoProviderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadOrganizationSsoProviderQuery,
    LoadOrganizationSsoProviderQueryVariables
  >(LoadOrganizationSsoProviderDocument, options);
}
// @ts-ignore
export function useLoadOrganizationSsoProviderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadOrganizationSsoProviderQuery,
    LoadOrganizationSsoProviderQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationSsoProviderQuery,
  LoadOrganizationSsoProviderQueryVariables
>;
export function useLoadOrganizationSsoProviderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationSsoProviderQuery,
        LoadOrganizationSsoProviderQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationSsoProviderQuery | undefined,
  LoadOrganizationSsoProviderQueryVariables
>;
export function useLoadOrganizationSsoProviderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationSsoProviderQuery,
        LoadOrganizationSsoProviderQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadOrganizationSsoProviderQuery,
    LoadOrganizationSsoProviderQueryVariables
  >(LoadOrganizationSsoProviderDocument, options);
}
export type LoadOrganizationSsoProviderQueryHookResult = ReturnType<
  typeof useLoadOrganizationSsoProviderQuery
>;
export type LoadOrganizationSsoProviderLazyQueryHookResult = ReturnType<
  typeof useLoadOrganizationSsoProviderLazyQuery
>;
export type LoadOrganizationSsoProviderSuspenseQueryHookResult = ReturnType<
  typeof useLoadOrganizationSsoProviderSuspenseQuery
>;
export type LoadOrganizationSsoProviderQueryResult = Apollo.QueryResult<
  LoadOrganizationSsoProviderQuery,
  LoadOrganizationSsoProviderQueryVariables
>;
export const LoadOrganizationSpacesDocument = gql`
  query LoadOrganizationSpaces($mrn: String!, $query: String, $first: Int) {
    organization(mrn: $mrn) {
      id
      spacesList(first: $first, query: $query) {
        edges {
          node {
            id
            mrn
            name
            description
          }
        }
      }
    }
  }
`;

/**
 * __useLoadOrganizationSpacesQuery__
 *
 * To run a query within a React component, call `useLoadOrganizationSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadOrganizationSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadOrganizationSpacesQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useLoadOrganizationSpacesQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadOrganizationSpacesQuery,
    LoadOrganizationSpacesQueryVariables
  > &
    (
      | { variables: LoadOrganizationSpacesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadOrganizationSpacesQuery,
    LoadOrganizationSpacesQueryVariables
  >(LoadOrganizationSpacesDocument, options);
}
export function useLoadOrganizationSpacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadOrganizationSpacesQuery,
    LoadOrganizationSpacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadOrganizationSpacesQuery,
    LoadOrganizationSpacesQueryVariables
  >(LoadOrganizationSpacesDocument, options);
}
// @ts-ignore
export function useLoadOrganizationSpacesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadOrganizationSpacesQuery,
    LoadOrganizationSpacesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationSpacesQuery,
  LoadOrganizationSpacesQueryVariables
>;
export function useLoadOrganizationSpacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationSpacesQuery,
        LoadOrganizationSpacesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationSpacesQuery | undefined,
  LoadOrganizationSpacesQueryVariables
>;
export function useLoadOrganizationSpacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationSpacesQuery,
        LoadOrganizationSpacesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadOrganizationSpacesQuery,
    LoadOrganizationSpacesQueryVariables
  >(LoadOrganizationSpacesDocument, options);
}
export type LoadOrganizationSpacesQueryHookResult = ReturnType<
  typeof useLoadOrganizationSpacesQuery
>;
export type LoadOrganizationSpacesLazyQueryHookResult = ReturnType<
  typeof useLoadOrganizationSpacesLazyQuery
>;
export type LoadOrganizationSpacesSuspenseQueryHookResult = ReturnType<
  typeof useLoadOrganizationSpacesSuspenseQuery
>;
export type LoadOrganizationSpacesQueryResult = Apollo.QueryResult<
  LoadOrganizationSpacesQuery,
  LoadOrganizationSpacesQueryVariables
>;
export const LoadOrganizationStatsDocument = gql`
  query LoadOrganizationStats(
    $mrn: String!
    $first: Int
    $after: String
    $query: String
    $metricMrns: [String!]
    $startTime: String
    $endTime: String
  ) {
    organization(mrn: $mrn) {
      id
      mrn
      name
      company
      spacesCount
      spacesList(first: $first, after: $after, query: $query) {
        totalCount
        edges {
          cursor
          node {
            id
            mrn
            name
            description
            priorityFindings
            assetGroupStats {
              listsAssetTypes {
                assetType
                aliases
                displayName
                shortName
              }
              groupType
              displayName
              icon
              count
              statistics {
                type {
                  assetType
                  aliases
                  displayName
                  shortName
                }
                count
              }
            }
            metrics(
              metricMrns: $metricMrns
              startTime: $startTime
              endTime: $endTime
            ) {
              ... on MetricsResponse {
                entries {
                  metricMrn
                  title
                  arrowResult
                }
              }
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;

/**
 * __useLoadOrganizationStatsQuery__
 *
 * To run a query within a React component, call `useLoadOrganizationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadOrganizationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadOrganizationStatsQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *      metricMrns: // value for 'metricMrns'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useLoadOrganizationStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadOrganizationStatsQuery,
    LoadOrganizationStatsQueryVariables
  > &
    (
      | { variables: LoadOrganizationStatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadOrganizationStatsQuery,
    LoadOrganizationStatsQueryVariables
  >(LoadOrganizationStatsDocument, options);
}
export function useLoadOrganizationStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadOrganizationStatsQuery,
    LoadOrganizationStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadOrganizationStatsQuery,
    LoadOrganizationStatsQueryVariables
  >(LoadOrganizationStatsDocument, options);
}
// @ts-ignore
export function useLoadOrganizationStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadOrganizationStatsQuery,
    LoadOrganizationStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationStatsQuery,
  LoadOrganizationStatsQueryVariables
>;
export function useLoadOrganizationStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationStatsQuery,
        LoadOrganizationStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationStatsQuery | undefined,
  LoadOrganizationStatsQueryVariables
>;
export function useLoadOrganizationStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationStatsQuery,
        LoadOrganizationStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadOrganizationStatsQuery,
    LoadOrganizationStatsQueryVariables
  >(LoadOrganizationStatsDocument, options);
}
export type LoadOrganizationStatsQueryHookResult = ReturnType<
  typeof useLoadOrganizationStatsQuery
>;
export type LoadOrganizationStatsLazyQueryHookResult = ReturnType<
  typeof useLoadOrganizationStatsLazyQuery
>;
export type LoadOrganizationStatsSuspenseQueryHookResult = ReturnType<
  typeof useLoadOrganizationStatsSuspenseQuery
>;
export type LoadOrganizationStatsQueryResult = Apollo.QueryResult<
  LoadOrganizationStatsQuery,
  LoadOrganizationStatsQueryVariables
>;
export const LoadOrganizationUsersDocument = gql`
  query LoadOrganizationUsers(
    $mrn: String!
    $first: Int
    $after: String
    $query: String
    $identityTypeFilter: [MemberIdentityType!]
    $rolesFilter: [String!]
  ) {
    organization(mrn: $mrn) {
      id
      mrn
      name
      members(
        first: $first
        after: $after
        query: $query
        identityTypeFilter: $identityTypeFilter
        rolesFilter: $rolesFilter
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            identity {
              mrn
              name
              ... on User {
                email
              }
            }
            roles {
              mrn
              title
            }
          }
        }
      }
    }
  }
`;

/**
 * __useLoadOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useLoadOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadOrganizationUsersQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *      identityTypeFilter: // value for 'identityTypeFilter'
 *      rolesFilter: // value for 'rolesFilter'
 *   },
 * });
 */
export function useLoadOrganizationUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadOrganizationUsersQuery,
    LoadOrganizationUsersQueryVariables
  > &
    (
      | { variables: LoadOrganizationUsersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadOrganizationUsersQuery,
    LoadOrganizationUsersQueryVariables
  >(LoadOrganizationUsersDocument, options);
}
export function useLoadOrganizationUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadOrganizationUsersQuery,
    LoadOrganizationUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadOrganizationUsersQuery,
    LoadOrganizationUsersQueryVariables
  >(LoadOrganizationUsersDocument, options);
}
// @ts-ignore
export function useLoadOrganizationUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadOrganizationUsersQuery,
    LoadOrganizationUsersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationUsersQuery,
  LoadOrganizationUsersQueryVariables
>;
export function useLoadOrganizationUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationUsersQuery,
        LoadOrganizationUsersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadOrganizationUsersQuery | undefined,
  LoadOrganizationUsersQueryVariables
>;
export function useLoadOrganizationUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadOrganizationUsersQuery,
        LoadOrganizationUsersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadOrganizationUsersQuery,
    LoadOrganizationUsersQueryVariables
  >(LoadOrganizationUsersDocument, options);
}
export type LoadOrganizationUsersQueryHookResult = ReturnType<
  typeof useLoadOrganizationUsersQuery
>;
export type LoadOrganizationUsersLazyQueryHookResult = ReturnType<
  typeof useLoadOrganizationUsersLazyQuery
>;
export type LoadOrganizationUsersSuspenseQueryHookResult = ReturnType<
  typeof useLoadOrganizationUsersSuspenseQuery
>;
export type LoadOrganizationUsersQueryResult = Apollo.QueryResult<
  LoadOrganizationUsersQuery,
  LoadOrganizationUsersQueryVariables
>;
export const LoadPlatformsDocument = gql`
  query LoadPlatforms($input: PlatformsListInput!) {
    platforms(input: $input) {
      id
      name
      version
    }
  }
`;

/**
 * __useLoadPlatformsQuery__
 *
 * To run a query within a React component, call `useLoadPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadPlatformsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoadPlatformsQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadPlatformsQuery,
    LoadPlatformsQueryVariables
  > &
    (
      | { variables: LoadPlatformsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadPlatformsQuery, LoadPlatformsQueryVariables>(
    LoadPlatformsDocument,
    options,
  );
}
export function useLoadPlatformsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadPlatformsQuery,
    LoadPlatformsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoadPlatformsQuery, LoadPlatformsQueryVariables>(
    LoadPlatformsDocument,
    options,
  );
}
// @ts-ignore
export function useLoadPlatformsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadPlatformsQuery,
    LoadPlatformsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadPlatformsQuery,
  LoadPlatformsQueryVariables
>;
export function useLoadPlatformsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadPlatformsQuery,
        LoadPlatformsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadPlatformsQuery | undefined,
  LoadPlatformsQueryVariables
>;
export function useLoadPlatformsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadPlatformsQuery,
        LoadPlatformsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadPlatformsQuery,
    LoadPlatformsQueryVariables
  >(LoadPlatformsDocument, options);
}
export type LoadPlatformsQueryHookResult = ReturnType<
  typeof useLoadPlatformsQuery
>;
export type LoadPlatformsLazyQueryHookResult = ReturnType<
  typeof useLoadPlatformsLazyQuery
>;
export type LoadPlatformsSuspenseQueryHookResult = ReturnType<
  typeof useLoadPlatformsSuspenseQuery
>;
export type LoadPlatformsQueryResult = Apollo.QueryResult<
  LoadPlatformsQuery,
  LoadPlatformsQueryVariables
>;
export const LoadPolicyDocument = gql`
  query LoadPolicy($input: PolicyInput!) {
    policy(input: $input) {
      mrn
      assigned
      assignedScope
      action
      access
      authors {
        email
        name
        type
      }
      category
      createdAt
      docs
      featured
      githubUrl
      groups {
        title
        summary
        checks {
          action
          mrn
          impact {
            rating
            value
          }
        }
        queries {
          action
          impact {
            rating
            value
          }
          mrn
        }
        policies {
          action
          impact {
            rating
            value
          }
          mrn
        }
      }
      mutationStatistics {
        checks {
          active
          ignored
          removed
        }
        queries {
          removed
          ignored
          active
        }
      }
      name
      platforms {
        id
        name
        version
      }
      queries {
        mrn
      }
      properties {
        mrn
      }
      runCli {
        command
        installDocsURL
      }
      scoringSystem
      defaultScoringSystem
      statistics {
        checks
        policies
        queries
      }
      summary
      tags {
        key
        value
      }
      trustLevel
      uid
      updatedAt
      variants {
        icon
        id
        title
      }
      version
    }
  }
`;

/**
 * __useLoadPolicyQuery__
 *
 * To run a query within a React component, call `useLoadPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadPolicyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoadPolicyQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadPolicyQuery,
    LoadPolicyQueryVariables
  > &
    (
      | { variables: LoadPolicyQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadPolicyQuery, LoadPolicyQueryVariables>(
    LoadPolicyDocument,
    options,
  );
}
export function useLoadPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadPolicyQuery,
    LoadPolicyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoadPolicyQuery, LoadPolicyQueryVariables>(
    LoadPolicyDocument,
    options,
  );
}
// @ts-ignore
export function useLoadPolicySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadPolicyQuery,
    LoadPolicyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LoadPolicyQuery, LoadPolicyQueryVariables>;
export function useLoadPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadPolicyQuery,
        LoadPolicyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadPolicyQuery | undefined,
  LoadPolicyQueryVariables
>;
export function useLoadPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadPolicyQuery,
        LoadPolicyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LoadPolicyQuery, LoadPolicyQueryVariables>(
    LoadPolicyDocument,
    options,
  );
}
export type LoadPolicyQueryHookResult = ReturnType<typeof useLoadPolicyQuery>;
export type LoadPolicyLazyQueryHookResult = ReturnType<
  typeof useLoadPolicyLazyQuery
>;
export type LoadPolicySuspenseQueryHookResult = ReturnType<
  typeof useLoadPolicySuspenseQuery
>;
export type LoadPolicyQueryResult = Apollo.QueryResult<
  LoadPolicyQuery,
  LoadPolicyQueryVariables
>;
export const LoadRegistrationTokensDocument = gql`
  query LoadRegistrationTokens(
    $spaceMrn: String!
    $orderBy: RegistrationTokenOrder
    $first: Int
    $after: String
  ) {
    registrationTokens(
      spaceMrn: $spaceMrn
      orderBy: $orderBy
      first: $first
      after: $after
    ) {
      edges {
        cursor
        node {
          id
          mrn
          description
          token
          createdBy
          createdAt
          expiresAt
          revoked
          labels {
            key
            value
          }
        }
      }
      totalCount
      pageInfo {
        hasPreviousPage
        hasNextPage
        endCursor
        startCursor
      }
    }
  }
`;

/**
 * __useLoadRegistrationTokensQuery__
 *
 * To run a query within a React component, call `useLoadRegistrationTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadRegistrationTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadRegistrationTokensQuery({
 *   variables: {
 *      spaceMrn: // value for 'spaceMrn'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLoadRegistrationTokensQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadRegistrationTokensQuery,
    LoadRegistrationTokensQueryVariables
  > &
    (
      | { variables: LoadRegistrationTokensQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadRegistrationTokensQuery,
    LoadRegistrationTokensQueryVariables
  >(LoadRegistrationTokensDocument, options);
}
export function useLoadRegistrationTokensLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadRegistrationTokensQuery,
    LoadRegistrationTokensQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadRegistrationTokensQuery,
    LoadRegistrationTokensQueryVariables
  >(LoadRegistrationTokensDocument, options);
}
// @ts-ignore
export function useLoadRegistrationTokensSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadRegistrationTokensQuery,
    LoadRegistrationTokensQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadRegistrationTokensQuery,
  LoadRegistrationTokensQueryVariables
>;
export function useLoadRegistrationTokensSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadRegistrationTokensQuery,
        LoadRegistrationTokensQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadRegistrationTokensQuery | undefined,
  LoadRegistrationTokensQueryVariables
>;
export function useLoadRegistrationTokensSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadRegistrationTokensQuery,
        LoadRegistrationTokensQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadRegistrationTokensQuery,
    LoadRegistrationTokensQueryVariables
  >(LoadRegistrationTokensDocument, options);
}
export type LoadRegistrationTokensQueryHookResult = ReturnType<
  typeof useLoadRegistrationTokensQuery
>;
export type LoadRegistrationTokensLazyQueryHookResult = ReturnType<
  typeof useLoadRegistrationTokensLazyQuery
>;
export type LoadRegistrationTokensSuspenseQueryHookResult = ReturnType<
  typeof useLoadRegistrationTokensSuspenseQuery
>;
export type LoadRegistrationTokensQueryResult = Apollo.QueryResult<
  LoadRegistrationTokensQuery,
  LoadRegistrationTokensQueryVariables
>;
export const LoadResourceInvitationsDocument = gql`
  query LoadResourceInvitations(
    $resourceMrn: String
    $inviteeMrn: String
    $first: Int
    $after: String
    $orderBy: InvitationOrder = { direction: ASC, field: CREATED }
  ) {
    invitations(
      resourceMrn: $resourceMrn
      inviteeMrn: $inviteeMrn
      first: $first
      after: $after
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          mrn
          resourceMrn
          senderEmail
          inviteeEmail
          roleMrns
          expiresAt
          message
          state
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useLoadResourceInvitationsQuery__
 *
 * To run a query within a React component, call `useLoadResourceInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadResourceInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadResourceInvitationsQuery({
 *   variables: {
 *      resourceMrn: // value for 'resourceMrn'
 *      inviteeMrn: // value for 'inviteeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLoadResourceInvitationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LoadResourceInvitationsQuery,
    LoadResourceInvitationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadResourceInvitationsQuery,
    LoadResourceInvitationsQueryVariables
  >(LoadResourceInvitationsDocument, options);
}
export function useLoadResourceInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadResourceInvitationsQuery,
    LoadResourceInvitationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadResourceInvitationsQuery,
    LoadResourceInvitationsQueryVariables
  >(LoadResourceInvitationsDocument, options);
}
// @ts-ignore
export function useLoadResourceInvitationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadResourceInvitationsQuery,
    LoadResourceInvitationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadResourceInvitationsQuery,
  LoadResourceInvitationsQueryVariables
>;
export function useLoadResourceInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadResourceInvitationsQuery,
        LoadResourceInvitationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadResourceInvitationsQuery | undefined,
  LoadResourceInvitationsQueryVariables
>;
export function useLoadResourceInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadResourceInvitationsQuery,
        LoadResourceInvitationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadResourceInvitationsQuery,
    LoadResourceInvitationsQueryVariables
  >(LoadResourceInvitationsDocument, options);
}
export type LoadResourceInvitationsQueryHookResult = ReturnType<
  typeof useLoadResourceInvitationsQuery
>;
export type LoadResourceInvitationsLazyQueryHookResult = ReturnType<
  typeof useLoadResourceInvitationsLazyQuery
>;
export type LoadResourceInvitationsSuspenseQueryHookResult = ReturnType<
  typeof useLoadResourceInvitationsSuspenseQuery
>;
export type LoadResourceInvitationsQueryResult = Apollo.QueryResult<
  LoadResourceInvitationsQuery,
  LoadResourceInvitationsQueryVariables
>;
export const LoadServiceAccountDocument = gql`
  query LoadServiceAccount($mrn: String!) {
    serviceAccount(mrn: $mrn) {
      id
      mrn
      name
      roles {
        mrn
        title
      }
      createdAt
      lastUsed
    }
  }
`;

/**
 * __useLoadServiceAccountQuery__
 *
 * To run a query within a React component, call `useLoadServiceAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadServiceAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadServiceAccountQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useLoadServiceAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadServiceAccountQuery,
    LoadServiceAccountQueryVariables
  > &
    (
      | { variables: LoadServiceAccountQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadServiceAccountQuery,
    LoadServiceAccountQueryVariables
  >(LoadServiceAccountDocument, options);
}
export function useLoadServiceAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadServiceAccountQuery,
    LoadServiceAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadServiceAccountQuery,
    LoadServiceAccountQueryVariables
  >(LoadServiceAccountDocument, options);
}
// @ts-ignore
export function useLoadServiceAccountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadServiceAccountQuery,
    LoadServiceAccountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadServiceAccountQuery,
  LoadServiceAccountQueryVariables
>;
export function useLoadServiceAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadServiceAccountQuery,
        LoadServiceAccountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadServiceAccountQuery | undefined,
  LoadServiceAccountQueryVariables
>;
export function useLoadServiceAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadServiceAccountQuery,
        LoadServiceAccountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadServiceAccountQuery,
    LoadServiceAccountQueryVariables
  >(LoadServiceAccountDocument, options);
}
export type LoadServiceAccountQueryHookResult = ReturnType<
  typeof useLoadServiceAccountQuery
>;
export type LoadServiceAccountLazyQueryHookResult = ReturnType<
  typeof useLoadServiceAccountLazyQuery
>;
export type LoadServiceAccountSuspenseQueryHookResult = ReturnType<
  typeof useLoadServiceAccountSuspenseQuery
>;
export type LoadServiceAccountQueryResult = Apollo.QueryResult<
  LoadServiceAccountQuery,
  LoadServiceAccountQueryVariables
>;
export const LoadSpaceDocument = gql`
  query LoadSpace($spaceMrn: String!, $metricMrns: [String!]) {
    space(mrn: $spaceMrn) {
      id
      mrn
      name
      description
      priorityFindings
      assetGroupStats {
        listsAssetTypes {
          assetType
          aliases
          displayName
          shortName
        }
        groupType
        displayName
        icon
        count
        statistics {
          type {
            assetType
            aliases
            displayName
            shortName
          }
          count
        }
      }
      organization {
        id
        mrn
        name
        description
      }
      settings {
        exceptionsConfiguration {
          requireApproval
          allowSelfApproval
          allowIndefiniteValidUntil
        }
        garbageCollectAssetsConfiguration {
          enable
          afterDays
        }
        terminatedAssetsConfiguration {
          cleanup
          after
        }
        unusedServiceAccountsConfiguration {
          cleanup
          after
        }
        platformVulnerabilityConfiguration {
          enable
        }
        eolAssetsConfiguration {
          enable
          monthsInAdvance
        }
        casesConfiguration {
          autoCreate
          aggregationWindow
        }
        platformMqlVexConfiguration {
          enable
        }
        mvdExperimentalSourcesConfiguration {
          sources {
            id
            name
            enabled
          }
        }
      }
      stats {
        assetGroupStatistics {
          groupType
          count
        }
      }
      metrics(metricMrns: $metricMrns) {
        ... on MetricsResponse {
          entries {
            metricMrn
            title
            arrowResult
          }
        }
      }
    }
  }
`;

/**
 * __useLoadSpaceQuery__
 *
 * To run a query within a React component, call `useLoadSpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadSpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadSpaceQuery({
 *   variables: {
 *      spaceMrn: // value for 'spaceMrn'
 *      metricMrns: // value for 'metricMrns'
 *   },
 * });
 */
export function useLoadSpaceQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadSpaceQuery,
    LoadSpaceQueryVariables
  > &
    (
      | { variables: LoadSpaceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadSpaceQuery, LoadSpaceQueryVariables>(
    LoadSpaceDocument,
    options,
  );
}
export function useLoadSpaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadSpaceQuery,
    LoadSpaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoadSpaceQuery, LoadSpaceQueryVariables>(
    LoadSpaceDocument,
    options,
  );
}
// @ts-ignore
export function useLoadSpaceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadSpaceQuery,
    LoadSpaceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LoadSpaceQuery, LoadSpaceQueryVariables>;
export function useLoadSpaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoadSpaceQuery, LoadSpaceQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  LoadSpaceQuery | undefined,
  LoadSpaceQueryVariables
>;
export function useLoadSpaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoadSpaceQuery, LoadSpaceQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LoadSpaceQuery, LoadSpaceQueryVariables>(
    LoadSpaceDocument,
    options,
  );
}
export type LoadSpaceQueryHookResult = ReturnType<typeof useLoadSpaceQuery>;
export type LoadSpaceLazyQueryHookResult = ReturnType<
  typeof useLoadSpaceLazyQuery
>;
export type LoadSpaceSuspenseQueryHookResult = ReturnType<
  typeof useLoadSpaceSuspenseQuery
>;
export type LoadSpaceQueryResult = Apollo.QueryResult<
  LoadSpaceQuery,
  LoadSpaceQueryVariables
>;
export const LoadSpaceMembersDocument = gql`
  query LoadSpaceMembers(
    $mrn: String!
    $first: Int
    $after: String
    $orderBy: MembershipOrder
    $query: String
  ) {
    space(mrn: $mrn) {
      members(
        first: $first
        after: $after
        orderBy: $orderBy
        query: $query
        identityTypeFilter: [USER]
      ) {
        edges {
          node {
            roles {
              title
              mrn
            }
            identity {
              mrn
              name
              ... on User {
                email
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        totalCount
      }
      id
      mrn
    }
  }
`;

/**
 * __useLoadSpaceMembersQuery__
 *
 * To run a query within a React component, call `useLoadSpaceMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadSpaceMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadSpaceMembersQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useLoadSpaceMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadSpaceMembersQuery,
    LoadSpaceMembersQueryVariables
  > &
    (
      | { variables: LoadSpaceMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadSpaceMembersQuery, LoadSpaceMembersQueryVariables>(
    LoadSpaceMembersDocument,
    options,
  );
}
export function useLoadSpaceMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadSpaceMembersQuery,
    LoadSpaceMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadSpaceMembersQuery,
    LoadSpaceMembersQueryVariables
  >(LoadSpaceMembersDocument, options);
}
// @ts-ignore
export function useLoadSpaceMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadSpaceMembersQuery,
    LoadSpaceMembersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadSpaceMembersQuery,
  LoadSpaceMembersQueryVariables
>;
export function useLoadSpaceMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadSpaceMembersQuery,
        LoadSpaceMembersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadSpaceMembersQuery | undefined,
  LoadSpaceMembersQueryVariables
>;
export function useLoadSpaceMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadSpaceMembersQuery,
        LoadSpaceMembersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadSpaceMembersQuery,
    LoadSpaceMembersQueryVariables
  >(LoadSpaceMembersDocument, options);
}
export type LoadSpaceMembersQueryHookResult = ReturnType<
  typeof useLoadSpaceMembersQuery
>;
export type LoadSpaceMembersLazyQueryHookResult = ReturnType<
  typeof useLoadSpaceMembersLazyQuery
>;
export type LoadSpaceMembersSuspenseQueryHookResult = ReturnType<
  typeof useLoadSpaceMembersSuspenseQuery
>;
export type LoadSpaceMembersQueryResult = Apollo.QueryResult<
  LoadSpaceMembersQuery,
  LoadSpaceMembersQueryVariables
>;
export const LoadSpaceStatsDocument = gql`
  query LoadSpaceStats($mrn: String!) {
    space(mrn: $mrn) {
      id
      mrn
      stats {
        assetGroupStatistics {
          groupType
          count
          listsAssetTypes {
            assetType
            displayName
            shortName
            aliases
          }
          statistics {
            type {
              assetType
              displayName
              shortName
            }
            count
          }
        }
        integrationsStatistics {
          active
          pending
          errored
          total
          type
        }
      }
    }
  }
`;

/**
 * __useLoadSpaceStatsQuery__
 *
 * To run a query within a React component, call `useLoadSpaceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadSpaceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadSpaceStatsQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useLoadSpaceStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadSpaceStatsQuery,
    LoadSpaceStatsQueryVariables
  > &
    (
      | { variables: LoadSpaceStatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadSpaceStatsQuery, LoadSpaceStatsQueryVariables>(
    LoadSpaceStatsDocument,
    options,
  );
}
export function useLoadSpaceStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadSpaceStatsQuery,
    LoadSpaceStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoadSpaceStatsQuery, LoadSpaceStatsQueryVariables>(
    LoadSpaceStatsDocument,
    options,
  );
}
// @ts-ignore
export function useLoadSpaceStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadSpaceStatsQuery,
    LoadSpaceStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadSpaceStatsQuery,
  LoadSpaceStatsQueryVariables
>;
export function useLoadSpaceStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadSpaceStatsQuery,
        LoadSpaceStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadSpaceStatsQuery | undefined,
  LoadSpaceStatsQueryVariables
>;
export function useLoadSpaceStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadSpaceStatsQuery,
        LoadSpaceStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadSpaceStatsQuery,
    LoadSpaceStatsQueryVariables
  >(LoadSpaceStatsDocument, options);
}
export type LoadSpaceStatsQueryHookResult = ReturnType<
  typeof useLoadSpaceStatsQuery
>;
export type LoadSpaceStatsLazyQueryHookResult = ReturnType<
  typeof useLoadSpaceStatsLazyQuery
>;
export type LoadSpaceStatsSuspenseQueryHookResult = ReturnType<
  typeof useLoadSpaceStatsSuspenseQuery
>;
export type LoadSpaceStatsQueryResult = Apollo.QueryResult<
  LoadSpaceStatsQuery,
  LoadSpaceStatsQueryVariables
>;
export const LoadTopMisconfigsDocument = gql`
  query LoadTopMisconfigs($input: SpacePolicySummaryInput!) {
    spacePolicySummary(input: $input) {
      spaceMrn
      querySummaries {
        edges {
          cursor
          node {
            id
            mquery {
              impact {
                rating
                value
              }
              mrn
              parent
              title
              uid
              action
            }
            mqueryState
            mqueryType
          }
        }
        totalCount
      }
    }
  }
`;

/**
 * __useLoadTopMisconfigsQuery__
 *
 * To run a query within a React component, call `useLoadTopMisconfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadTopMisconfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadTopMisconfigsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoadTopMisconfigsQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoadTopMisconfigsQuery,
    LoadTopMisconfigsQueryVariables
  > &
    (
      | { variables: LoadTopMisconfigsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadTopMisconfigsQuery,
    LoadTopMisconfigsQueryVariables
  >(LoadTopMisconfigsDocument, options);
}
export function useLoadTopMisconfigsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadTopMisconfigsQuery,
    LoadTopMisconfigsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadTopMisconfigsQuery,
    LoadTopMisconfigsQueryVariables
  >(LoadTopMisconfigsDocument, options);
}
// @ts-ignore
export function useLoadTopMisconfigsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadTopMisconfigsQuery,
    LoadTopMisconfigsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadTopMisconfigsQuery,
  LoadTopMisconfigsQueryVariables
>;
export function useLoadTopMisconfigsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadTopMisconfigsQuery,
        LoadTopMisconfigsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadTopMisconfigsQuery | undefined,
  LoadTopMisconfigsQueryVariables
>;
export function useLoadTopMisconfigsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadTopMisconfigsQuery,
        LoadTopMisconfigsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadTopMisconfigsQuery,
    LoadTopMisconfigsQueryVariables
  >(LoadTopMisconfigsDocument, options);
}
export type LoadTopMisconfigsQueryHookResult = ReturnType<
  typeof useLoadTopMisconfigsQuery
>;
export type LoadTopMisconfigsLazyQueryHookResult = ReturnType<
  typeof useLoadTopMisconfigsLazyQuery
>;
export type LoadTopMisconfigsSuspenseQueryHookResult = ReturnType<
  typeof useLoadTopMisconfigsSuspenseQuery
>;
export type LoadTopMisconfigsQueryResult = Apollo.QueryResult<
  LoadTopMisconfigsQuery,
  LoadTopMisconfigsQueryVariables
>;
export const LoadUserInvitationsDocument = gql`
  query LoadUserInvitations(
    $resourceMrn: String
    $inviteeMrn: String
    $first: Int
    $after: String
    $orderBy: InvitationOrder = { direction: ASC, field: CREATED }
  ) {
    invitations(
      resourceMrn: $resourceMrn
      inviteeMrn: $inviteeMrn
      first: $first
      after: $after
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          mrn
          resourceMrn
          senderEmail
          inviteeEmail
          roleMrns
          expiresAt
          message
          state
        }
      }
    }
  }
`;

/**
 * __useLoadUserInvitationsQuery__
 *
 * To run a query within a React component, call `useLoadUserInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadUserInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadUserInvitationsQuery({
 *   variables: {
 *      resourceMrn: // value for 'resourceMrn'
 *      inviteeMrn: // value for 'inviteeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLoadUserInvitationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LoadUserInvitationsQuery,
    LoadUserInvitationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoadUserInvitationsQuery,
    LoadUserInvitationsQueryVariables
  >(LoadUserInvitationsDocument, options);
}
export function useLoadUserInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadUserInvitationsQuery,
    LoadUserInvitationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoadUserInvitationsQuery,
    LoadUserInvitationsQueryVariables
  >(LoadUserInvitationsDocument, options);
}
// @ts-ignore
export function useLoadUserInvitationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadUserInvitationsQuery,
    LoadUserInvitationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LoadUserInvitationsQuery,
  LoadUserInvitationsQueryVariables
>;
export function useLoadUserInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadUserInvitationsQuery,
        LoadUserInvitationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadUserInvitationsQuery | undefined,
  LoadUserInvitationsQueryVariables
>;
export function useLoadUserInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadUserInvitationsQuery,
        LoadUserInvitationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoadUserInvitationsQuery,
    LoadUserInvitationsQueryVariables
  >(LoadUserInvitationsDocument, options);
}
export type LoadUserInvitationsQueryHookResult = ReturnType<
  typeof useLoadUserInvitationsQuery
>;
export type LoadUserInvitationsLazyQueryHookResult = ReturnType<
  typeof useLoadUserInvitationsLazyQuery
>;
export type LoadUserInvitationsSuspenseQueryHookResult = ReturnType<
  typeof useLoadUserInvitationsSuspenseQuery
>;
export type LoadUserInvitationsQueryResult = Apollo.QueryResult<
  LoadUserInvitationsQuery,
  LoadUserInvitationsQueryVariables
>;
export const LoadViewerDocument = gql`
  query LoadViewer($metricMrns: [String!]) {
    viewer {
      mrn
      email
      name
      createdAt
      state
      organizations {
        id
        mrn
        name
        company
        description
        capabilities
        spacesCount
        subscriptionInfo {
          basePlan {
            name
            id
          }
        }
        memberStats {
          total
          owners {
            mrn
            name
            ... on User {
              email
            }
          }
        }
        metrics(metricMrns: $metricMrns) {
          ... on MetricsResponse {
            entries {
              metricMrn
              title
              arrowResult
            }
          }
        }
      }
      firstSpace {
        id
        mrn
        name
        description
        priorityFindings
        organization {
          id
          mrn
          name
          description
        }
        settings {
          eolAssetsConfiguration {
            enable
            monthsInAdvance
          }
          garbageCollectAssetsConfiguration {
            enable
            afterDays
          }
          terminatedAssetsConfiguration {
            cleanup
            after
          }
          unusedServiceAccountsConfiguration {
            cleanup
            after
          }
          platformVulnerabilityConfiguration {
            enable
          }
          casesConfiguration {
            autoCreate
            aggregationWindow
          }
          platformMqlVexConfiguration {
            enable
          }
          mvdExperimentalSourcesConfiguration {
            sources {
              id
              name
              enabled
            }
          }
        }
        assetGroupStats {
          listsAssetTypes {
            assetType
            aliases
            displayName
            shortName
          }
          groupType
          displayName
          icon
          count
          statistics {
            type {
              assetType
              aliases
              displayName
              shortName
            }
            count
          }
        }
        stats {
          assetGroupStatistics {
            groupType
            count
          }
        }
      }
    }
    viewerSettings {
      key
      value
    }
  }
`;

/**
 * __useLoadViewerQuery__
 *
 * To run a query within a React component, call `useLoadViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadViewerQuery({
 *   variables: {
 *      metricMrns: // value for 'metricMrns'
 *   },
 * });
 */
export function useLoadViewerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LoadViewerQuery,
    LoadViewerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoadViewerQuery, LoadViewerQueryVariables>(
    LoadViewerDocument,
    options,
  );
}
export function useLoadViewerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoadViewerQuery,
    LoadViewerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoadViewerQuery, LoadViewerQueryVariables>(
    LoadViewerDocument,
    options,
  );
}
// @ts-ignore
export function useLoadViewerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoadViewerQuery,
    LoadViewerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LoadViewerQuery, LoadViewerQueryVariables>;
export function useLoadViewerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadViewerQuery,
        LoadViewerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LoadViewerQuery | undefined,
  LoadViewerQueryVariables
>;
export function useLoadViewerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoadViewerQuery,
        LoadViewerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LoadViewerQuery, LoadViewerQueryVariables>(
    LoadViewerDocument,
    options,
  );
}
export type LoadViewerQueryHookResult = ReturnType<typeof useLoadViewerQuery>;
export type LoadViewerLazyQueryHookResult = ReturnType<
  typeof useLoadViewerLazyQuery
>;
export type LoadViewerSuspenseQueryHookResult = ReturnType<
  typeof useLoadViewerSuspenseQuery
>;
export type LoadViewerQueryResult = Apollo.QueryResult<
  LoadViewerQuery,
  LoadViewerQueryVariables
>;
export const MqueryAssetScoresDocument = gql`
  query MqueryAssetScores(
    $input: MqueryAssetScoresInput!
    $first: Int!
    $after: String
    $orderBy: AssetOrder
  ) {
    mqueryAssetScores(
      input: $input
      first: $first
      after: $after
      orderBy: $orderBy
    ) {
      title
      description
      totalCount
      scoreDistribution {
        pass
        fail
        error
        unknown
      }
      edges {
        cursor
        node {
          assetMrn
          assetName
          assetPlatform {
            name
            title
            arch
            version
            kind
            runtime
            release
          }
          score {
            id
            value
            type
            completion
            weight
            message
            grade
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      docs {
        desc
        remediations {
          ... on Remediations {
            entries {
              id
              desc
            }
          }
          ... on AuthenticationRequired {
            message
            code
          }
        }
        references {
          title
          url
        }
      }
      mql
    }
  }
`;

/**
 * __useMqueryAssetScoresQuery__
 *
 * To run a query within a React component, call `useMqueryAssetScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useMqueryAssetScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMqueryAssetScoresQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMqueryAssetScoresQuery(
  baseOptions: Apollo.QueryHookOptions<
    MqueryAssetScoresQuery,
    MqueryAssetScoresQueryVariables
  > &
    (
      | { variables: MqueryAssetScoresQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MqueryAssetScoresQuery,
    MqueryAssetScoresQueryVariables
  >(MqueryAssetScoresDocument, options);
}
export function useMqueryAssetScoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MqueryAssetScoresQuery,
    MqueryAssetScoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MqueryAssetScoresQuery,
    MqueryAssetScoresQueryVariables
  >(MqueryAssetScoresDocument, options);
}
// @ts-ignore
export function useMqueryAssetScoresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MqueryAssetScoresQuery,
    MqueryAssetScoresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MqueryAssetScoresQuery,
  MqueryAssetScoresQueryVariables
>;
export function useMqueryAssetScoresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MqueryAssetScoresQuery,
        MqueryAssetScoresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MqueryAssetScoresQuery | undefined,
  MqueryAssetScoresQueryVariables
>;
export function useMqueryAssetScoresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MqueryAssetScoresQuery,
        MqueryAssetScoresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MqueryAssetScoresQuery,
    MqueryAssetScoresQueryVariables
  >(MqueryAssetScoresDocument, options);
}
export type MqueryAssetScoresQueryHookResult = ReturnType<
  typeof useMqueryAssetScoresQuery
>;
export type MqueryAssetScoresLazyQueryHookResult = ReturnType<
  typeof useMqueryAssetScoresLazyQuery
>;
export type MqueryAssetScoresSuspenseQueryHookResult = ReturnType<
  typeof useMqueryAssetScoresSuspenseQuery
>;
export type MqueryAssetScoresQueryResult = Apollo.QueryResult<
  MqueryAssetScoresQuery,
  MqueryAssetScoresQueryVariables
>;
export const OrganizationIdSuggestionDocument = gql`
  query OrganizationIDSuggestion($input: IDSuggestionInput!) {
    organizationIDSuggestion(input: $input) {
      id
      available
    }
  }
`;

/**
 * __useOrganizationIdSuggestionQuery__
 *
 * To run a query within a React component, call `useOrganizationIdSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationIdSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationIdSuggestionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationIdSuggestionQuery(
  baseOptions: Apollo.QueryHookOptions<
    OrganizationIdSuggestionQuery,
    OrganizationIdSuggestionQueryVariables
  > &
    (
      | { variables: OrganizationIdSuggestionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrganizationIdSuggestionQuery,
    OrganizationIdSuggestionQueryVariables
  >(OrganizationIdSuggestionDocument, options);
}
export function useOrganizationIdSuggestionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationIdSuggestionQuery,
    OrganizationIdSuggestionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganizationIdSuggestionQuery,
    OrganizationIdSuggestionQueryVariables
  >(OrganizationIdSuggestionDocument, options);
}
// @ts-ignore
export function useOrganizationIdSuggestionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrganizationIdSuggestionQuery,
    OrganizationIdSuggestionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OrganizationIdSuggestionQuery,
  OrganizationIdSuggestionQueryVariables
>;
export function useOrganizationIdSuggestionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationIdSuggestionQuery,
        OrganizationIdSuggestionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OrganizationIdSuggestionQuery | undefined,
  OrganizationIdSuggestionQueryVariables
>;
export function useOrganizationIdSuggestionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationIdSuggestionQuery,
        OrganizationIdSuggestionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OrganizationIdSuggestionQuery,
    OrganizationIdSuggestionQueryVariables
  >(OrganizationIdSuggestionDocument, options);
}
export type OrganizationIdSuggestionQueryHookResult = ReturnType<
  typeof useOrganizationIdSuggestionQuery
>;
export type OrganizationIdSuggestionLazyQueryHookResult = ReturnType<
  typeof useOrganizationIdSuggestionLazyQuery
>;
export type OrganizationIdSuggestionSuspenseQueryHookResult = ReturnType<
  typeof useOrganizationIdSuggestionSuspenseQuery
>;
export type OrganizationIdSuggestionQueryResult = Apollo.QueryResult<
  OrganizationIdSuggestionQuery,
  OrganizationIdSuggestionQueryVariables
>;
export const PingIntegrationDocument = gql`
  query PingIntegration($input: PingIntegrationInput!) {
    pingIntegration(input: $input) {
      mrn
    }
  }
`;

/**
 * __usePingIntegrationQuery__
 *
 * To run a query within a React component, call `usePingIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePingIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingIntegrationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePingIntegrationQuery(
  baseOptions: Apollo.QueryHookOptions<
    PingIntegrationQuery,
    PingIntegrationQueryVariables
  > &
    (
      | { variables: PingIntegrationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PingIntegrationQuery, PingIntegrationQueryVariables>(
    PingIntegrationDocument,
    options,
  );
}
export function usePingIntegrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PingIntegrationQuery,
    PingIntegrationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PingIntegrationQuery,
    PingIntegrationQueryVariables
  >(PingIntegrationDocument, options);
}
// @ts-ignore
export function usePingIntegrationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PingIntegrationQuery,
    PingIntegrationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PingIntegrationQuery,
  PingIntegrationQueryVariables
>;
export function usePingIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PingIntegrationQuery,
        PingIntegrationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PingIntegrationQuery | undefined,
  PingIntegrationQueryVariables
>;
export function usePingIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PingIntegrationQuery,
        PingIntegrationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PingIntegrationQuery,
    PingIntegrationQueryVariables
  >(PingIntegrationDocument, options);
}
export type PingIntegrationQueryHookResult = ReturnType<
  typeof usePingIntegrationQuery
>;
export type PingIntegrationLazyQueryHookResult = ReturnType<
  typeof usePingIntegrationLazyQuery
>;
export type PingIntegrationSuspenseQueryHookResult = ReturnType<
  typeof usePingIntegrationSuspenseQuery
>;
export type PingIntegrationQueryResult = Apollo.QueryResult<
  PingIntegrationQuery,
  PingIntegrationQueryVariables
>;
export const QueryPackDocument = gql`
  query QueryPack($input: PolicyInput!) {
    policy(input: $input) {
      uid
      mrn
      name
      version
      summary
      docs
      authors {
        name
        email
        type
      }
      platforms {
        id
        name
        version
      }
      category
      trustLevel
      access
      statistics {
        checks
        queries
        policies
      }
      tags {
        key
        value
      }
      featured
      queries {
        uid
        mrn
        title
        docs {
          desc
          remediations {
            ... on Remediations {
              entries {
                id
                desc
              }
            }
            ... on AuthenticationRequired {
              message
              code
            }
          }
          references {
            title
            url
          }
        }
        impact {
          value
          rating
        }
        mql
        tags {
          key
          value
        }
        properties {
          uid
          mrn
          title
          mql
          defaultValue
          overrideValue
          setByPolicyMrn
          for {
            mrn
          }
        }
        action
      }
      properties {
        uid
        mrn
        title
        mql
        defaultValue
        overrideValue
        setByPolicyMrn
        for {
          mrn
        }
      }
      groups {
        title
        summary
        checks {
          mrn
          impact {
            value
            rating
          }
          action
        }
        queries {
          mrn
          impact {
            value
            rating
          }
          action
        }
        policies {
          mrn
          impact {
            value
            rating
          }
          action
        }
      }
      runCli {
        command
        installDocsURL
      }
      githubUrl
      assigned
      mutationStatistics {
        checks {
          active
          ignored
          removed
        }
        queries {
          active
          ignored
          removed
        }
      }
      updatedAt
      createdAt
      variantPlatformFilters {
        id
        title
        icon
      }
    }
  }
`;

/**
 * __useQueryPackQuery__
 *
 * To run a query within a React component, call `useQueryPackQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPackQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQueryPackQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryPackQuery,
    QueryPackQueryVariables
  > &
    (
      | { variables: QueryPackQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<QueryPackQuery, QueryPackQueryVariables>(
    QueryPackDocument,
    options,
  );
}
export function useQueryPackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryPackQuery,
    QueryPackQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<QueryPackQuery, QueryPackQueryVariables>(
    QueryPackDocument,
    options,
  );
}
// @ts-ignore
export function useQueryPackSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryPackQuery,
    QueryPackQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<QueryPackQuery, QueryPackQueryVariables>;
export function useQueryPackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<QueryPackQuery, QueryPackQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  QueryPackQuery | undefined,
  QueryPackQueryVariables
>;
export function useQueryPackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<QueryPackQuery, QueryPackQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<QueryPackQuery, QueryPackQueryVariables>(
    QueryPackDocument,
    options,
  );
}
export type QueryPackQueryHookResult = ReturnType<typeof useQueryPackQuery>;
export type QueryPackLazyQueryHookResult = ReturnType<
  typeof useQueryPackLazyQuery
>;
export type QueryPackSuspenseQueryHookResult = ReturnType<
  typeof useQueryPackSuspenseQuery
>;
export type QueryPackQueryResult = Apollo.QueryResult<
  QueryPackQuery,
  QueryPackQueryVariables
>;
export const SearchAggregateScoreDocument = gql`
  query SearchAggregateScore(
    $query: String!
    $type: SearchType!
    $first: Int!
    $after: String
    $scope: String
    $filters: SearchFilters
  ) {
    search(
      query: $query
      type: $type
      first: $first
      after: $after
      scope: $scope
      filters: $filters
    ) {
      scoreTypeDistribution {
        vulnerability
        advisory
        check
        policy
        risk
        asset
        software
        control
        framework
      }
      edges {
        searchItemStatus
        node {
          ... on AggregateScore {
            nodeId: id
            iconId
            entity {
              ... on EntityInfoAsset {
                id
                mrn
                name
              }
              ... on EntityInfoSpace {
                id
                mrn
                name
              }
            }
            findingMrn
            rank
            baseScore
            riskValue
            rating
            scoreType
            blastRadius {
              indicator
              assets
              affected
              critical
              high
              medium
              low
              none
            }
            riskFactors {
              mrn
              indicator
              title
              affected
              total
              isPositive
            }
            nodeTitle: title
            nodeDescription: description
            tags {
              key
              value
            }
            epss {
              probability
              percentile
            }
            cvss {
              id
              value
              type
              vector
              source
            }
            lastScannedAt
            firstDetectedAt
            remediatedAt
            spaceId
          }
          ... on Advisory {
            id
            iconID
            iconIDEnum
            mrn
            source {
              id
              name
              url
            }
            externalUrls {
              title
              url
              iconIDEnum
            }
            title
            description
            cves {
              id
              mrn
              title
              description
              summary
              published
              modified
              publishedAt
              modifiedAt
              url
              cwe
              state
              exploitable
              references
            }
            score {
              id
              value
              type
              vector
              source
            }
            cvssScore {
              id
              value
              type
              vector
              source
            }
            vendorscore
            affectedPackages {
              id
              iconID
              iconIDEnum
              name
              version
              arch
              format
              namespace
              description
              status
              available
              origin
              vulnDiscoveryTime
              type
            }
            published
            modified
            publishedAt
            modifiedAt
            vulnerabilityRiskFactors {
              knownExploited
              remoteExploitable
            }
          }
          ... on Cve {
            id
            mrn
            cveTitle: title
            description
            publishedAt
            modifiedAt
            cvssScores {
              id
              value
              type
              vector
              source
            }
            cwe
            state
            references
            epssScore {
              probability
              percentile
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useSearchAggregateScoreQuery__
 *
 * To run a query within a React component, call `useSearchAggregateScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAggregateScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAggregateScoreQuery({
 *   variables: {
 *      query: // value for 'query'
 *      type: // value for 'type'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSearchAggregateScoreQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchAggregateScoreQuery,
    SearchAggregateScoreQueryVariables
  > &
    (
      | { variables: SearchAggregateScoreQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchAggregateScoreQuery,
    SearchAggregateScoreQueryVariables
  >(SearchAggregateScoreDocument, options);
}
export function useSearchAggregateScoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchAggregateScoreQuery,
    SearchAggregateScoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchAggregateScoreQuery,
    SearchAggregateScoreQueryVariables
  >(SearchAggregateScoreDocument, options);
}
// @ts-ignore
export function useSearchAggregateScoreSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchAggregateScoreQuery,
    SearchAggregateScoreQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SearchAggregateScoreQuery,
  SearchAggregateScoreQueryVariables
>;
export function useSearchAggregateScoreSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchAggregateScoreQuery,
        SearchAggregateScoreQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchAggregateScoreQuery | undefined,
  SearchAggregateScoreQueryVariables
>;
export function useSearchAggregateScoreSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchAggregateScoreQuery,
        SearchAggregateScoreQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchAggregateScoreQuery,
    SearchAggregateScoreQueryVariables
  >(SearchAggregateScoreDocument, options);
}
export type SearchAggregateScoreQueryHookResult = ReturnType<
  typeof useSearchAggregateScoreQuery
>;
export type SearchAggregateScoreLazyQueryHookResult = ReturnType<
  typeof useSearchAggregateScoreLazyQuery
>;
export type SearchAggregateScoreSuspenseQueryHookResult = ReturnType<
  typeof useSearchAggregateScoreSuspenseQuery
>;
export type SearchAggregateScoreQueryResult = Apollo.QueryResult<
  SearchAggregateScoreQuery,
  SearchAggregateScoreQueryVariables
>;
export const SearchPolicyDocument = gql`
  query SearchPolicy($input: ContentSearchInput!) {
    content(input: $input) {
      totalCount
      edges {
        cursor
        node {
          ... on Policy {
            uid
            mrn
            name
            action
            version
            summary
            docs
            authors {
              name
              email
              type
            }
            category
            trustLevel
            access
            statistics {
              checks
              queries
              policies
            }
            featured
            assigned
            assignedScope
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useSearchPolicyQuery__
 *
 * To run a query within a React component, call `useSearchPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPolicyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchPolicyQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchPolicyQuery,
    SearchPolicyQueryVariables
  > &
    (
      | { variables: SearchPolicyQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchPolicyQuery, SearchPolicyQueryVariables>(
    SearchPolicyDocument,
    options,
  );
}
export function useSearchPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchPolicyQuery,
    SearchPolicyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchPolicyQuery, SearchPolicyQueryVariables>(
    SearchPolicyDocument,
    options,
  );
}
// @ts-ignore
export function useSearchPolicySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchPolicyQuery,
    SearchPolicyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SearchPolicyQuery, SearchPolicyQueryVariables>;
export function useSearchPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchPolicyQuery,
        SearchPolicyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchPolicyQuery | undefined,
  SearchPolicyQueryVariables
>;
export function useSearchPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchPolicyQuery,
        SearchPolicyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchPolicyQuery, SearchPolicyQueryVariables>(
    SearchPolicyDocument,
    options,
  );
}
export type SearchPolicyQueryHookResult = ReturnType<
  typeof useSearchPolicyQuery
>;
export type SearchPolicyLazyQueryHookResult = ReturnType<
  typeof useSearchPolicyLazyQuery
>;
export type SearchPolicySuspenseQueryHookResult = ReturnType<
  typeof useSearchPolicySuspenseQuery
>;
export type SearchPolicyQueryResult = Apollo.QueryResult<
  SearchPolicyQuery,
  SearchPolicyQueryVariables
>;
export const SearchQueryPackDocument = gql`
  query SearchQueryPack($input: ContentSearchInput!) {
    content(input: $input) {
      totalCount
      edges {
        cursor
        node {
          ... on Policy {
            uid
            mrn
            name
            version
            summary
            docs
            authors {
              name
              email
              type
            }
            category
            trustLevel
            access
            statistics {
              checks
              queries
              policies
            }
            featured
            assigned
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useSearchQueryPackQuery__
 *
 * To run a query within a React component, call `useSearchQueryPackQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQueryPackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQueryPackQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchQueryPackQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchQueryPackQuery,
    SearchQueryPackQueryVariables
  > &
    (
      | { variables: SearchQueryPackQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchQueryPackQuery, SearchQueryPackQueryVariables>(
    SearchQueryPackDocument,
    options,
  );
}
export function useSearchQueryPackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchQueryPackQuery,
    SearchQueryPackQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchQueryPackQuery,
    SearchQueryPackQueryVariables
  >(SearchQueryPackDocument, options);
}
// @ts-ignore
export function useSearchQueryPackSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchQueryPackQuery,
    SearchQueryPackQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SearchQueryPackQuery,
  SearchQueryPackQueryVariables
>;
export function useSearchQueryPackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchQueryPackQuery,
        SearchQueryPackQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchQueryPackQuery | undefined,
  SearchQueryPackQueryVariables
>;
export function useSearchQueryPackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchQueryPackQuery,
        SearchQueryPackQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchQueryPackQuery,
    SearchQueryPackQueryVariables
  >(SearchQueryPackDocument, options);
}
export type SearchQueryPackQueryHookResult = ReturnType<
  typeof useSearchQueryPackQuery
>;
export type SearchQueryPackLazyQueryHookResult = ReturnType<
  typeof useSearchQueryPackLazyQuery
>;
export type SearchQueryPackSuspenseQueryHookResult = ReturnType<
  typeof useSearchQueryPackSuspenseQuery
>;
export type SearchQueryPackQueryResult = Apollo.QueryResult<
  SearchQueryPackQuery,
  SearchQueryPackQueryVariables
>;
export const ServiceAccountAssetCountDocument = gql`
  query ServiceAccountAssetCount(
    $scopeMrn: String!
    $queryTerms: [String!]
    $first: Int
  ) {
    assets(scopeMrn: $scopeMrn, queryTerms: $queryTerms, first: $first) {
      totalCount
    }
  }
`;

/**
 * __useServiceAccountAssetCountQuery__
 *
 * To run a query within a React component, call `useServiceAccountAssetCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAccountAssetCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAccountAssetCountQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      queryTerms: // value for 'queryTerms'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useServiceAccountAssetCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServiceAccountAssetCountQuery,
    ServiceAccountAssetCountQueryVariables
  > &
    (
      | { variables: ServiceAccountAssetCountQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ServiceAccountAssetCountQuery,
    ServiceAccountAssetCountQueryVariables
  >(ServiceAccountAssetCountDocument, options);
}
export function useServiceAccountAssetCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServiceAccountAssetCountQuery,
    ServiceAccountAssetCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ServiceAccountAssetCountQuery,
    ServiceAccountAssetCountQueryVariables
  >(ServiceAccountAssetCountDocument, options);
}
// @ts-ignore
export function useServiceAccountAssetCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServiceAccountAssetCountQuery,
    ServiceAccountAssetCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServiceAccountAssetCountQuery,
  ServiceAccountAssetCountQueryVariables
>;
export function useServiceAccountAssetCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceAccountAssetCountQuery,
        ServiceAccountAssetCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServiceAccountAssetCountQuery | undefined,
  ServiceAccountAssetCountQueryVariables
>;
export function useServiceAccountAssetCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceAccountAssetCountQuery,
        ServiceAccountAssetCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ServiceAccountAssetCountQuery,
    ServiceAccountAssetCountQueryVariables
  >(ServiceAccountAssetCountDocument, options);
}
export type ServiceAccountAssetCountQueryHookResult = ReturnType<
  typeof useServiceAccountAssetCountQuery
>;
export type ServiceAccountAssetCountLazyQueryHookResult = ReturnType<
  typeof useServiceAccountAssetCountLazyQuery
>;
export type ServiceAccountAssetCountSuspenseQueryHookResult = ReturnType<
  typeof useServiceAccountAssetCountSuspenseQuery
>;
export type ServiceAccountAssetCountQueryResult = Apollo.QueryResult<
  ServiceAccountAssetCountQuery,
  ServiceAccountAssetCountQueryVariables
>;
export const ServiceAccountForwardPaginationDocument = gql`
  query ServiceAccountForwardPagination(
    $spaceMrn: String
    $scopeMrn: String
    $first: Int
    $after: String
    $query: String
    $queryTerms: [String!]
    $orderBy: ServiceAccountOrder
  ) {
    serviceAccounts(
      spaceMrn: $spaceMrn
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      query: $query
      queryTerms: $queryTerms
      orderBy: $orderBy
    ) {
      ...ServiceAccountFields
    }
  }
  ${ServiceAccountFieldsFragmentDoc}
`;

/**
 * __useServiceAccountForwardPaginationQuery__
 *
 * To run a query within a React component, call `useServiceAccountForwardPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAccountForwardPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAccountForwardPaginationQuery({
 *   variables: {
 *      spaceMrn: // value for 'spaceMrn'
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *      queryTerms: // value for 'queryTerms'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useServiceAccountForwardPaginationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ServiceAccountForwardPaginationQuery,
    ServiceAccountForwardPaginationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ServiceAccountForwardPaginationQuery,
    ServiceAccountForwardPaginationQueryVariables
  >(ServiceAccountForwardPaginationDocument, options);
}
export function useServiceAccountForwardPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServiceAccountForwardPaginationQuery,
    ServiceAccountForwardPaginationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ServiceAccountForwardPaginationQuery,
    ServiceAccountForwardPaginationQueryVariables
  >(ServiceAccountForwardPaginationDocument, options);
}
// @ts-ignore
export function useServiceAccountForwardPaginationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServiceAccountForwardPaginationQuery,
    ServiceAccountForwardPaginationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServiceAccountForwardPaginationQuery,
  ServiceAccountForwardPaginationQueryVariables
>;
export function useServiceAccountForwardPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceAccountForwardPaginationQuery,
        ServiceAccountForwardPaginationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServiceAccountForwardPaginationQuery | undefined,
  ServiceAccountForwardPaginationQueryVariables
>;
export function useServiceAccountForwardPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceAccountForwardPaginationQuery,
        ServiceAccountForwardPaginationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ServiceAccountForwardPaginationQuery,
    ServiceAccountForwardPaginationQueryVariables
  >(ServiceAccountForwardPaginationDocument, options);
}
export type ServiceAccountForwardPaginationQueryHookResult = ReturnType<
  typeof useServiceAccountForwardPaginationQuery
>;
export type ServiceAccountForwardPaginationLazyQueryHookResult = ReturnType<
  typeof useServiceAccountForwardPaginationLazyQuery
>;
export type ServiceAccountForwardPaginationSuspenseQueryHookResult = ReturnType<
  typeof useServiceAccountForwardPaginationSuspenseQuery
>;
export type ServiceAccountForwardPaginationQueryResult = Apollo.QueryResult<
  ServiceAccountForwardPaginationQuery,
  ServiceAccountForwardPaginationQueryVariables
>;
export const SpaceIdSuggestionDocument = gql`
  query SpaceIDSuggestion($input: IDSuggestionInput!) {
    spaceIDSuggestion(input: $input) {
      id
      available
    }
  }
`;

/**
 * __useSpaceIdSuggestionQuery__
 *
 * To run a query within a React component, call `useSpaceIdSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceIdSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceIdSuggestionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSpaceIdSuggestionQuery(
  baseOptions: Apollo.QueryHookOptions<
    SpaceIdSuggestionQuery,
    SpaceIdSuggestionQueryVariables
  > &
    (
      | { variables: SpaceIdSuggestionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SpaceIdSuggestionQuery,
    SpaceIdSuggestionQueryVariables
  >(SpaceIdSuggestionDocument, options);
}
export function useSpaceIdSuggestionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SpaceIdSuggestionQuery,
    SpaceIdSuggestionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SpaceIdSuggestionQuery,
    SpaceIdSuggestionQueryVariables
  >(SpaceIdSuggestionDocument, options);
}
// @ts-ignore
export function useSpaceIdSuggestionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SpaceIdSuggestionQuery,
    SpaceIdSuggestionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SpaceIdSuggestionQuery,
  SpaceIdSuggestionQueryVariables
>;
export function useSpaceIdSuggestionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SpaceIdSuggestionQuery,
        SpaceIdSuggestionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SpaceIdSuggestionQuery | undefined,
  SpaceIdSuggestionQueryVariables
>;
export function useSpaceIdSuggestionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SpaceIdSuggestionQuery,
        SpaceIdSuggestionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SpaceIdSuggestionQuery,
    SpaceIdSuggestionQueryVariables
  >(SpaceIdSuggestionDocument, options);
}
export type SpaceIdSuggestionQueryHookResult = ReturnType<
  typeof useSpaceIdSuggestionQuery
>;
export type SpaceIdSuggestionLazyQueryHookResult = ReturnType<
  typeof useSpaceIdSuggestionLazyQuery
>;
export type SpaceIdSuggestionSuspenseQueryHookResult = ReturnType<
  typeof useSpaceIdSuggestionSuspenseQuery
>;
export type SpaceIdSuggestionQueryResult = Apollo.QueryResult<
  SpaceIdSuggestionQuery,
  SpaceIdSuggestionQueryVariables
>;
export const SubscriptionInfoDocument = gql`
  query SubscriptionInfo($orgMrn: ID!) {
    subscriptionInfo(orgMrn: $orgMrn) {
      isSelfService
      basePlan {
        id
        key
        name
      }
      additions {
        id
        key
        name
        quantity
      }
      utilizationMetrics {
        name
        description
        units
        value
        limit
      }
      pendingCancel
    }
    subscriptionPlans(orgMrn: $orgMrn) {
      basePlan {
        id
        key
        name
        description
        price {
          id
          currency
          cost
        }
        entitlements {
          name
          key
          description
          units
          value
        }
      }
      additions {
        id
        key
        name
        description
        maxQuantity
        price {
          id
          currency
          cost
        }
        entitlements {
          name
          key
          description
          units
          value
        }
      }
      isSelfService
      isCurrent
      isDowngrade
      isUpgrade
    }
  }
`;

/**
 * __useSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionInfoQuery({
 *   variables: {
 *      orgMrn: // value for 'orgMrn'
 *   },
 * });
 */
export function useSubscriptionInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubscriptionInfoQuery,
    SubscriptionInfoQueryVariables
  > &
    (
      | { variables: SubscriptionInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>(
    SubscriptionInfoDocument,
    options,
  );
}
export function useSubscriptionInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubscriptionInfoQuery,
    SubscriptionInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SubscriptionInfoQuery,
    SubscriptionInfoQueryVariables
  >(SubscriptionInfoDocument, options);
}
// @ts-ignore
export function useSubscriptionInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SubscriptionInfoQuery,
    SubscriptionInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SubscriptionInfoQuery,
  SubscriptionInfoQueryVariables
>;
export function useSubscriptionInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubscriptionInfoQuery,
        SubscriptionInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SubscriptionInfoQuery | undefined,
  SubscriptionInfoQueryVariables
>;
export function useSubscriptionInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubscriptionInfoQuery,
        SubscriptionInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SubscriptionInfoQuery,
    SubscriptionInfoQueryVariables
  >(SubscriptionInfoDocument, options);
}
export type SubscriptionInfoQueryHookResult = ReturnType<
  typeof useSubscriptionInfoQuery
>;
export type SubscriptionInfoLazyQueryHookResult = ReturnType<
  typeof useSubscriptionInfoLazyQuery
>;
export type SubscriptionInfoSuspenseQueryHookResult = ReturnType<
  typeof useSubscriptionInfoSuspenseQuery
>;
export type SubscriptionInfoQueryResult = Apollo.QueryResult<
  SubscriptionInfoQuery,
  SubscriptionInfoQueryVariables
>;
export const TestIamActionsDocument = gql`
  query TestIAMActions($resourceMrn: String!, $actions: [String!]!) {
    testIamActions(resourceMrn: $resourceMrn, actions: $actions)
  }
`;

/**
 * __useTestIamActionsQuery__
 *
 * To run a query within a React component, call `useTestIamActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestIamActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestIamActionsQuery({
 *   variables: {
 *      resourceMrn: // value for 'resourceMrn'
 *      actions: // value for 'actions'
 *   },
 * });
 */
export function useTestIamActionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TestIamActionsQuery,
    TestIamActionsQueryVariables
  > &
    (
      | { variables: TestIamActionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TestIamActionsQuery, TestIamActionsQueryVariables>(
    TestIamActionsDocument,
    options,
  );
}
export function useTestIamActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TestIamActionsQuery,
    TestIamActionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TestIamActionsQuery, TestIamActionsQueryVariables>(
    TestIamActionsDocument,
    options,
  );
}
// @ts-ignore
export function useTestIamActionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TestIamActionsQuery,
    TestIamActionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TestIamActionsQuery,
  TestIamActionsQueryVariables
>;
export function useTestIamActionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TestIamActionsQuery,
        TestIamActionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TestIamActionsQuery | undefined,
  TestIamActionsQueryVariables
>;
export function useTestIamActionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TestIamActionsQuery,
        TestIamActionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TestIamActionsQuery,
    TestIamActionsQueryVariables
  >(TestIamActionsDocument, options);
}
export type TestIamActionsQueryHookResult = ReturnType<
  typeof useTestIamActionsQuery
>;
export type TestIamActionsLazyQueryHookResult = ReturnType<
  typeof useTestIamActionsLazyQuery
>;
export type TestIamActionsSuspenseQueryHookResult = ReturnType<
  typeof useTestIamActionsSuspenseQuery
>;
export type TestIamActionsQueryResult = Apollo.QueryResult<
  TestIamActionsQuery,
  TestIamActionsQueryVariables
>;
export const TriggerActionDocument = gql`
  query TriggerAction($input: TriggerActionInput!) {
    triggerAction(input: $input) {
      mrn
    }
  }
`;

/**
 * __useTriggerActionQuery__
 *
 * To run a query within a React component, call `useTriggerActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggerActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggerActionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerActionQuery(
  baseOptions: Apollo.QueryHookOptions<
    TriggerActionQuery,
    TriggerActionQueryVariables
  > &
    (
      | { variables: TriggerActionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TriggerActionQuery, TriggerActionQueryVariables>(
    TriggerActionDocument,
    options,
  );
}
export function useTriggerActionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TriggerActionQuery,
    TriggerActionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TriggerActionQuery, TriggerActionQueryVariables>(
    TriggerActionDocument,
    options,
  );
}
// @ts-ignore
export function useTriggerActionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TriggerActionQuery,
    TriggerActionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TriggerActionQuery,
  TriggerActionQueryVariables
>;
export function useTriggerActionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TriggerActionQuery,
        TriggerActionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TriggerActionQuery | undefined,
  TriggerActionQueryVariables
>;
export function useTriggerActionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TriggerActionQuery,
        TriggerActionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TriggerActionQuery,
    TriggerActionQueryVariables
  >(TriggerActionDocument, options);
}
export type TriggerActionQueryHookResult = ReturnType<
  typeof useTriggerActionQuery
>;
export type TriggerActionLazyQueryHookResult = ReturnType<
  typeof useTriggerActionLazyQuery
>;
export type TriggerActionSuspenseQueryHookResult = ReturnType<
  typeof useTriggerActionSuspenseQuery
>;
export type TriggerActionQueryResult = Apollo.QueryResult<
  TriggerActionQuery,
  TriggerActionQueryVariables
>;
export const GetRelatedAdvisoryFindingsDocument = gql`
  query GetRelatedAdvisoryFindings(
    $scopeMrn: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        totalCount
        edges {
          cursor
          node {
            ... on AdvisoryFinding {
              mrn
              id
              asset {
                id
                mrn
                name
                icon
                lastUpdated
                platform {
                  name
                  title
                  arch
                  version
                  kind
                  runtime
                  release
                  family
                  labels {
                    key
                    value
                  }
                }
              }
              title
              state
              iconId
              epss {
                probability
                percentile
              }
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
              riskScore
              riskValue
              rating
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
                magnitude {
                  value
                  isToxic
                }
              }
              firstDetectedAt
              publishedAt
              tags {
                key
                value
              }
              lastUpdated
              detectionSources {
                name
                url
                firstDetectedAt
                lastUpdatedAt
                fixedAt
                vendor
                version
              }
              exception {
                id
                exceptionId
                exceptionMrn
                reviewStatus
                status
                action
                justification
                scope
                author {
                  name
                  email
                  mrn
                  type
                }
                createdAt
              }
              exceptions {
                id
                exceptionId
                exceptionMrn
                reviewStatus
                action
                justification
                scope
                createdAt
              }
              baseRating
              baseValue
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        filteredTotalCount
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetRelatedAdvisoryFindingsQuery__
 *
 * To run a query within a React component, call `useGetRelatedAdvisoryFindingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedAdvisoryFindingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedAdvisoryFindingsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetRelatedAdvisoryFindingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRelatedAdvisoryFindingsQuery,
    GetRelatedAdvisoryFindingsQueryVariables
  > &
    (
      | { variables: GetRelatedAdvisoryFindingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRelatedAdvisoryFindingsQuery,
    GetRelatedAdvisoryFindingsQueryVariables
  >(GetRelatedAdvisoryFindingsDocument, options);
}
export function useGetRelatedAdvisoryFindingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRelatedAdvisoryFindingsQuery,
    GetRelatedAdvisoryFindingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRelatedAdvisoryFindingsQuery,
    GetRelatedAdvisoryFindingsQueryVariables
  >(GetRelatedAdvisoryFindingsDocument, options);
}
// @ts-ignore
export function useGetRelatedAdvisoryFindingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRelatedAdvisoryFindingsQuery,
    GetRelatedAdvisoryFindingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetRelatedAdvisoryFindingsQuery,
  GetRelatedAdvisoryFindingsQueryVariables
>;
export function useGetRelatedAdvisoryFindingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRelatedAdvisoryFindingsQuery,
        GetRelatedAdvisoryFindingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetRelatedAdvisoryFindingsQuery | undefined,
  GetRelatedAdvisoryFindingsQueryVariables
>;
export function useGetRelatedAdvisoryFindingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRelatedAdvisoryFindingsQuery,
        GetRelatedAdvisoryFindingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRelatedAdvisoryFindingsQuery,
    GetRelatedAdvisoryFindingsQueryVariables
  >(GetRelatedAdvisoryFindingsDocument, options);
}
export type GetRelatedAdvisoryFindingsQueryHookResult = ReturnType<
  typeof useGetRelatedAdvisoryFindingsQuery
>;
export type GetRelatedAdvisoryFindingsLazyQueryHookResult = ReturnType<
  typeof useGetRelatedAdvisoryFindingsLazyQuery
>;
export type GetRelatedAdvisoryFindingsSuspenseQueryHookResult = ReturnType<
  typeof useGetRelatedAdvisoryFindingsSuspenseQuery
>;
export type GetRelatedAdvisoryFindingsQueryResult = Apollo.QueryResult<
  GetRelatedAdvisoryFindingsQuery,
  GetRelatedAdvisoryFindingsQueryVariables
>;
export const GetFindingOnAssetDocument = gql`
  query GetFindingOnAsset(
    $scopeMrn: String!
    $first: Int
    $after: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        edges {
          cursor
          node {
            ... on CveFinding {
              mrn
              id
              asset {
                id
                mrn
                name
                icon
                lastUpdated
                platform {
                  name
                  title
                  arch
                  version
                  kind
                  runtime
                  family
                  labels {
                    key
                    value
                  }
                }
              }
              title
              state
              iconId
              epss {
                probability
                percentile
              }
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
              riskValue
              rating
              baseValue
              baseRating
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              riskCategories {
                categoryMrn
                applicable
                impact
              }
              firstDetectedAt
              publishedAt
              tags {
                key
                value
              }
              lastUpdated
              detectionSources {
                name
                url
                firstDetectedAt
                lastUpdatedAt
                fixedAt
                vendor
                version
              }
              exceptions {
                id
                exceptionId
                exceptionMrn
                reviewStatus
                action
                scope
                justification
                createdAt
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  totalManualEffort
                  research
                  scripting
                  rollout
                  verification
                }
              }
            }
            ... on AdvisoryFinding {
              mrn
              id
              asset {
                id
                mrn
                name
                icon
                lastUpdated
                platform {
                  name
                  title
                  arch
                  version
                  kind
                  runtime
                  family
                  labels {
                    key
                    value
                  }
                }
              }
              title
              state
              iconId
              epss {
                probability
                percentile
              }
              cvss {
                id
                value
                type
                vector
                source
                rating
              }
              riskValue
              rating
              baseValue
              baseRating
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              riskCategories {
                categoryMrn
                applicable
                impact
              }
              firstDetectedAt
              publishedAt
              tags {
                key
                value
              }
              lastUpdated
              detectionSources {
                name
                url
                firstDetectedAt
                lastUpdatedAt
                fixedAt
                vendor
                version
              }
              exceptions {
                id
                exceptionId
                exceptionMrn
                reviewStatus
                action
                scope
                justification
                createdAt
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  totalManualEffort
                  research
                  scripting
                  rollout
                  verification
                }
              }
            }
            ... on CheckFinding {
              mrn
              id
              asset {
                id
                mrn
                name
                icon
                lastUpdated
                platform {
                  name
                  title
                  arch
                  version
                  kind
                  runtime
                  family
                  labels {
                    key
                    value
                  }
                }
              }
              title
              state
              iconId
              riskValue
              rating
              baseValue
              baseRating
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              riskCategories {
                categoryMrn
                applicable
                impact
              }
              tags {
                key
                value
              }
              lastUpdated
              exceptions {
                id
                exceptionId
                exceptionMrn
                reviewStatus
                action
                scope
              }
              mquery {
                mrn
                mql
                impact {
                  value
                }
                properties {
                  uid
                  mrn
                  title
                  mql
                  defaultValue
                  overrideValue
                  setByPolicyMrn
                  for {
                    mrn
                  }
                }
                docs {
                  ...MqueryDocsFields
                }
              }
              relatedPolicies {
                mrn
                name
                icon
                updatedAt
                lastAppliedAt
                action
                score {
                  riskValue
                  rating
                  blastRadius {
                    indicator
                    assets
                    affected
                    critical
                    high
                    medium
                    low
                    none
                    error
                    pass
                  }
                }
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  totalManualEffort
                  research
                  scripting
                  rollout
                  verification
                }
              }
            }
            ... on GenericFinding {
              mrn
              id
              description
              asset {
                id
                mrn
                name
                icon
                lastUpdated
                platform {
                  name
                  title
                  arch
                  version
                  kind
                  runtime
                  family
                  labels {
                    key
                    value
                  }
                }
              }
              title
              state
              iconId
              riskValue
              rating
              baseValue
              baseRating
              tags {
                key
                value
              }
              firstDetectedAt
              lastUpdated
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              exceptions {
                id
                exceptionId
                exceptionMrn
                reviewStatus
                action
                scope
                justification
                createdAt
              }
            }
          }
        }
        filteredTotalCount
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
  ${MqueryDocsFieldsFragmentDoc}
`;

/**
 * __useGetFindingOnAssetQuery__
 *
 * To run a query within a React component, call `useGetFindingOnAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFindingOnAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFindingOnAssetQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFindingOnAssetQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFindingOnAssetQuery,
    GetFindingOnAssetQueryVariables
  > &
    (
      | { variables: GetFindingOnAssetQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFindingOnAssetQuery,
    GetFindingOnAssetQueryVariables
  >(GetFindingOnAssetDocument, options);
}
export function useGetFindingOnAssetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFindingOnAssetQuery,
    GetFindingOnAssetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFindingOnAssetQuery,
    GetFindingOnAssetQueryVariables
  >(GetFindingOnAssetDocument, options);
}
// @ts-ignore
export function useGetFindingOnAssetSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFindingOnAssetQuery,
    GetFindingOnAssetQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFindingOnAssetQuery,
  GetFindingOnAssetQueryVariables
>;
export function useGetFindingOnAssetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFindingOnAssetQuery,
        GetFindingOnAssetQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFindingOnAssetQuery | undefined,
  GetFindingOnAssetQueryVariables
>;
export function useGetFindingOnAssetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFindingOnAssetQuery,
        GetFindingOnAssetQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFindingOnAssetQuery,
    GetFindingOnAssetQueryVariables
  >(GetFindingOnAssetDocument, options);
}
export type GetFindingOnAssetQueryHookResult = ReturnType<
  typeof useGetFindingOnAssetQuery
>;
export type GetFindingOnAssetLazyQueryHookResult = ReturnType<
  typeof useGetFindingOnAssetLazyQuery
>;
export type GetFindingOnAssetSuspenseQueryHookResult = ReturnType<
  typeof useGetFindingOnAssetSuspenseQuery
>;
export type GetFindingOnAssetQueryResult = Apollo.QueryResult<
  GetFindingOnAssetQuery,
  GetFindingOnAssetQueryVariables
>;
export const CreateSecurityPipelineScheduledWorkflowDocument = gql`
  mutation CreateSecurityPipelineScheduledWorkflow(
    $input: CreateSecurityPipelineScheduledWorkflowInput!
  ) {
    createSecurityPipelineScheduledWorkflow(input: $input) {
      workflow {
        mrn
        configuration {
          cadence
          day
        }
        selection {
          scopeMrn
        }
      }
    }
  }
`;
export type CreateSecurityPipelineScheduledWorkflowMutationFn =
  Apollo.MutationFunction<
    CreateSecurityPipelineScheduledWorkflowMutation,
    CreateSecurityPipelineScheduledWorkflowMutationVariables
  >;

/**
 * __useCreateSecurityPipelineScheduledWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateSecurityPipelineScheduledWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSecurityPipelineScheduledWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSecurityPipelineScheduledWorkflowMutation, { data, loading, error }] = useCreateSecurityPipelineScheduledWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSecurityPipelineScheduledWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSecurityPipelineScheduledWorkflowMutation,
    CreateSecurityPipelineScheduledWorkflowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSecurityPipelineScheduledWorkflowMutation,
    CreateSecurityPipelineScheduledWorkflowMutationVariables
  >(CreateSecurityPipelineScheduledWorkflowDocument, options);
}
export type CreateSecurityPipelineScheduledWorkflowMutationHookResult =
  ReturnType<typeof useCreateSecurityPipelineScheduledWorkflowMutation>;
export type CreateSecurityPipelineScheduledWorkflowMutationResult =
  Apollo.MutationResult<CreateSecurityPipelineScheduledWorkflowMutation>;
export type CreateSecurityPipelineScheduledWorkflowMutationOptions =
  Apollo.BaseMutationOptions<
    CreateSecurityPipelineScheduledWorkflowMutation,
    CreateSecurityPipelineScheduledWorkflowMutationVariables
  >;
export const CreateSecurityPipelineWorkflowDocument = gql`
  mutation CreateSecurityPipelineWorkflow(
    $input: CreateSecurityPipelineWorkflowInput!
  ) {
    createSecurityPipelineWorkflow(input: $input) {
      workflow {
        mrn
        pullRequest {
          title
          url
        }
        title
        createdBy {
          name
          email
        }
      }
    }
  }
`;
export type CreateSecurityPipelineWorkflowMutationFn = Apollo.MutationFunction<
  CreateSecurityPipelineWorkflowMutation,
  CreateSecurityPipelineWorkflowMutationVariables
>;

/**
 * __useCreateSecurityPipelineWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateSecurityPipelineWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSecurityPipelineWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSecurityPipelineWorkflowMutation, { data, loading, error }] = useCreateSecurityPipelineWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSecurityPipelineWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSecurityPipelineWorkflowMutation,
    CreateSecurityPipelineWorkflowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSecurityPipelineWorkflowMutation,
    CreateSecurityPipelineWorkflowMutationVariables
  >(CreateSecurityPipelineWorkflowDocument, options);
}
export type CreateSecurityPipelineWorkflowMutationHookResult = ReturnType<
  typeof useCreateSecurityPipelineWorkflowMutation
>;
export type CreateSecurityPipelineWorkflowMutationResult =
  Apollo.MutationResult<CreateSecurityPipelineWorkflowMutation>;
export type CreateSecurityPipelineWorkflowMutationOptions =
  Apollo.BaseMutationOptions<
    CreateSecurityPipelineWorkflowMutation,
    CreateSecurityPipelineWorkflowMutationVariables
  >;
export const DeleteSecurityPipelineScheduledWorkflowDocument = gql`
  mutation DeleteSecurityPipelineScheduledWorkflow($mrns: [String!]!) {
    deleteSecurityPipelineScheduledWorkflow(mrns: $mrns)
  }
`;
export type DeleteSecurityPipelineScheduledWorkflowMutationFn =
  Apollo.MutationFunction<
    DeleteSecurityPipelineScheduledWorkflowMutation,
    DeleteSecurityPipelineScheduledWorkflowMutationVariables
  >;

/**
 * __useDeleteSecurityPipelineScheduledWorkflowMutation__
 *
 * To run a mutation, you first call `useDeleteSecurityPipelineScheduledWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSecurityPipelineScheduledWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSecurityPipelineScheduledWorkflowMutation, { data, loading, error }] = useDeleteSecurityPipelineScheduledWorkflowMutation({
 *   variables: {
 *      mrns: // value for 'mrns'
 *   },
 * });
 */
export function useDeleteSecurityPipelineScheduledWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSecurityPipelineScheduledWorkflowMutation,
    DeleteSecurityPipelineScheduledWorkflowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSecurityPipelineScheduledWorkflowMutation,
    DeleteSecurityPipelineScheduledWorkflowMutationVariables
  >(DeleteSecurityPipelineScheduledWorkflowDocument, options);
}
export type DeleteSecurityPipelineScheduledWorkflowMutationHookResult =
  ReturnType<typeof useDeleteSecurityPipelineScheduledWorkflowMutation>;
export type DeleteSecurityPipelineScheduledWorkflowMutationResult =
  Apollo.MutationResult<DeleteSecurityPipelineScheduledWorkflowMutation>;
export type DeleteSecurityPipelineScheduledWorkflowMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteSecurityPipelineScheduledWorkflowMutation,
    DeleteSecurityPipelineScheduledWorkflowMutationVariables
  >;
export const TriggerSecurityPipelineScheduledWorkflowDocument = gql`
  mutation TriggerSecurityPipelineScheduledWorkflow($mrn: String!) {
    triggerSecurityPipelineScheduledWorkflow(mrn: $mrn)
  }
`;
export type TriggerSecurityPipelineScheduledWorkflowMutationFn =
  Apollo.MutationFunction<
    TriggerSecurityPipelineScheduledWorkflowMutation,
    TriggerSecurityPipelineScheduledWorkflowMutationVariables
  >;

/**
 * __useTriggerSecurityPipelineScheduledWorkflowMutation__
 *
 * To run a mutation, you first call `useTriggerSecurityPipelineScheduledWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerSecurityPipelineScheduledWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerSecurityPipelineScheduledWorkflowMutation, { data, loading, error }] = useTriggerSecurityPipelineScheduledWorkflowMutation({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useTriggerSecurityPipelineScheduledWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerSecurityPipelineScheduledWorkflowMutation,
    TriggerSecurityPipelineScheduledWorkflowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriggerSecurityPipelineScheduledWorkflowMutation,
    TriggerSecurityPipelineScheduledWorkflowMutationVariables
  >(TriggerSecurityPipelineScheduledWorkflowDocument, options);
}
export type TriggerSecurityPipelineScheduledWorkflowMutationHookResult =
  ReturnType<typeof useTriggerSecurityPipelineScheduledWorkflowMutation>;
export type TriggerSecurityPipelineScheduledWorkflowMutationResult =
  Apollo.MutationResult<TriggerSecurityPipelineScheduledWorkflowMutation>;
export type TriggerSecurityPipelineScheduledWorkflowMutationOptions =
  Apollo.BaseMutationOptions<
    TriggerSecurityPipelineScheduledWorkflowMutation,
    TriggerSecurityPipelineScheduledWorkflowMutationVariables
  >;
export const UpdateSecurityPipelineScheduledWorkflowDocument = gql`
  mutation UpdateSecurityPipelineScheduledWorkflow(
    $input: UpdateSecurityPipelineScheduledWorkflowInput!
  ) {
    updateSecurityPipelineScheduledWorkflow(input: $input) {
      workflow {
        mrn
        configuration {
          cadence
          day
        }
        selection {
          scopeMrn
        }
        nextRunAt
      }
    }
  }
`;
export type UpdateSecurityPipelineScheduledWorkflowMutationFn =
  Apollo.MutationFunction<
    UpdateSecurityPipelineScheduledWorkflowMutation,
    UpdateSecurityPipelineScheduledWorkflowMutationVariables
  >;

/**
 * __useUpdateSecurityPipelineScheduledWorkflowMutation__
 *
 * To run a mutation, you first call `useUpdateSecurityPipelineScheduledWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSecurityPipelineScheduledWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSecurityPipelineScheduledWorkflowMutation, { data, loading, error }] = useUpdateSecurityPipelineScheduledWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSecurityPipelineScheduledWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSecurityPipelineScheduledWorkflowMutation,
    UpdateSecurityPipelineScheduledWorkflowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSecurityPipelineScheduledWorkflowMutation,
    UpdateSecurityPipelineScheduledWorkflowMutationVariables
  >(UpdateSecurityPipelineScheduledWorkflowDocument, options);
}
export type UpdateSecurityPipelineScheduledWorkflowMutationHookResult =
  ReturnType<typeof useUpdateSecurityPipelineScheduledWorkflowMutation>;
export type UpdateSecurityPipelineScheduledWorkflowMutationResult =
  Apollo.MutationResult<UpdateSecurityPipelineScheduledWorkflowMutation>;
export type UpdateSecurityPipelineScheduledWorkflowMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateSecurityPipelineScheduledWorkflowMutation,
    UpdateSecurityPipelineScheduledWorkflowMutationVariables
  >;
export const GetSecurityPipelineFindingsGroupsDocument = gql`
  query GetSecurityPipelineFindingsGroups(
    $ownerMrn: String!
    $findingMrns: [String!]
    $initiativeMrns: [String!]
    $assetMrns: [String!]
  ) {
    securityPipelineFindingGroups(
      ownerMrn: $ownerMrn
      findingMrns: $findingMrns
      initiativeMrns: $initiativeMrns
      assetMrns: $assetMrns
    ) {
      findingGroups {
        findingMrn
        title
        riskScore
        riskValue
        rating
        assetsCount
        method
      }
    }
  }
`;

/**
 * __useGetSecurityPipelineFindingsGroupsQuery__
 *
 * To run a query within a React component, call `useGetSecurityPipelineFindingsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSecurityPipelineFindingsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSecurityPipelineFindingsGroupsQuery({
 *   variables: {
 *      ownerMrn: // value for 'ownerMrn'
 *      findingMrns: // value for 'findingMrns'
 *      initiativeMrns: // value for 'initiativeMrns'
 *      assetMrns: // value for 'assetMrns'
 *   },
 * });
 */
export function useGetSecurityPipelineFindingsGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSecurityPipelineFindingsGroupsQuery,
    GetSecurityPipelineFindingsGroupsQueryVariables
  > &
    (
      | {
          variables: GetSecurityPipelineFindingsGroupsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSecurityPipelineFindingsGroupsQuery,
    GetSecurityPipelineFindingsGroupsQueryVariables
  >(GetSecurityPipelineFindingsGroupsDocument, options);
}
export function useGetSecurityPipelineFindingsGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSecurityPipelineFindingsGroupsQuery,
    GetSecurityPipelineFindingsGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSecurityPipelineFindingsGroupsQuery,
    GetSecurityPipelineFindingsGroupsQueryVariables
  >(GetSecurityPipelineFindingsGroupsDocument, options);
}
// @ts-ignore
export function useGetSecurityPipelineFindingsGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSecurityPipelineFindingsGroupsQuery,
    GetSecurityPipelineFindingsGroupsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSecurityPipelineFindingsGroupsQuery,
  GetSecurityPipelineFindingsGroupsQueryVariables
>;
export function useGetSecurityPipelineFindingsGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSecurityPipelineFindingsGroupsQuery,
        GetSecurityPipelineFindingsGroupsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSecurityPipelineFindingsGroupsQuery | undefined,
  GetSecurityPipelineFindingsGroupsQueryVariables
>;
export function useGetSecurityPipelineFindingsGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSecurityPipelineFindingsGroupsQuery,
        GetSecurityPipelineFindingsGroupsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSecurityPipelineFindingsGroupsQuery,
    GetSecurityPipelineFindingsGroupsQueryVariables
  >(GetSecurityPipelineFindingsGroupsDocument, options);
}
export type GetSecurityPipelineFindingsGroupsQueryHookResult = ReturnType<
  typeof useGetSecurityPipelineFindingsGroupsQuery
>;
export type GetSecurityPipelineFindingsGroupsLazyQueryHookResult = ReturnType<
  typeof useGetSecurityPipelineFindingsGroupsLazyQuery
>;
export type GetSecurityPipelineFindingsGroupsSuspenseQueryHookResult =
  ReturnType<typeof useGetSecurityPipelineFindingsGroupsSuspenseQuery>;
export type GetSecurityPipelineFindingsGroupsQueryResult = Apollo.QueryResult<
  GetSecurityPipelineFindingsGroupsQuery,
  GetSecurityPipelineFindingsGroupsQueryVariables
>;
export const GetSecurityPipelineScheduledWorkflowsDocument = gql`
  query GetSecurityPipelineScheduledWorkflows(
    $input: SecurityPipelineScheduledWorkflowsInput!
  ) {
    securityPipelineScheduledWorkflows(input: $input) {
      totalCount
      edges {
        cursor
        node {
          configuration {
            cadence
            day
          }
          selection {
            scopeMrn
          }
          mrn
          nextRunAt
        }
      }
    }
  }
`;

/**
 * __useGetSecurityPipelineScheduledWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetSecurityPipelineScheduledWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSecurityPipelineScheduledWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSecurityPipelineScheduledWorkflowsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSecurityPipelineScheduledWorkflowsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSecurityPipelineScheduledWorkflowsQuery,
    GetSecurityPipelineScheduledWorkflowsQueryVariables
  > &
    (
      | {
          variables: GetSecurityPipelineScheduledWorkflowsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSecurityPipelineScheduledWorkflowsQuery,
    GetSecurityPipelineScheduledWorkflowsQueryVariables
  >(GetSecurityPipelineScheduledWorkflowsDocument, options);
}
export function useGetSecurityPipelineScheduledWorkflowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSecurityPipelineScheduledWorkflowsQuery,
    GetSecurityPipelineScheduledWorkflowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSecurityPipelineScheduledWorkflowsQuery,
    GetSecurityPipelineScheduledWorkflowsQueryVariables
  >(GetSecurityPipelineScheduledWorkflowsDocument, options);
}
// @ts-ignore
export function useGetSecurityPipelineScheduledWorkflowsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSecurityPipelineScheduledWorkflowsQuery,
    GetSecurityPipelineScheduledWorkflowsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSecurityPipelineScheduledWorkflowsQuery,
  GetSecurityPipelineScheduledWorkflowsQueryVariables
>;
export function useGetSecurityPipelineScheduledWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSecurityPipelineScheduledWorkflowsQuery,
        GetSecurityPipelineScheduledWorkflowsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSecurityPipelineScheduledWorkflowsQuery | undefined,
  GetSecurityPipelineScheduledWorkflowsQueryVariables
>;
export function useGetSecurityPipelineScheduledWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSecurityPipelineScheduledWorkflowsQuery,
        GetSecurityPipelineScheduledWorkflowsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSecurityPipelineScheduledWorkflowsQuery,
    GetSecurityPipelineScheduledWorkflowsQueryVariables
  >(GetSecurityPipelineScheduledWorkflowsDocument, options);
}
export type GetSecurityPipelineScheduledWorkflowsQueryHookResult = ReturnType<
  typeof useGetSecurityPipelineScheduledWorkflowsQuery
>;
export type GetSecurityPipelineScheduledWorkflowsLazyQueryHookResult =
  ReturnType<typeof useGetSecurityPipelineScheduledWorkflowsLazyQuery>;
export type GetSecurityPipelineScheduledWorkflowsSuspenseQueryHookResult =
  ReturnType<typeof useGetSecurityPipelineScheduledWorkflowsSuspenseQuery>;
export type GetSecurityPipelineScheduledWorkflowsQueryResult =
  Apollo.QueryResult<
    GetSecurityPipelineScheduledWorkflowsQuery,
    GetSecurityPipelineScheduledWorkflowsQueryVariables
  >;
export const GetSecurityPipelineWorkflowsDocument = gql`
  query GetSecurityPipelineWorkflows(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $input: SecurityPipelineWorkflowsInput!
    $orderBy: SecurityPipelineWorkflowOrder
  ) {
    securityPipelineWorkflows(
      first: $first
      after: $after
      last: $last
      before: $before
      input: $input
      orderBy: $orderBy
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          mrn
          title
          status
          createdBy {
            name
            mrn
          }
          pullRequest {
            title
            url
          }
          updatedAt
        }
      }
    }
  }
`;

/**
 * __useGetSecurityPipelineWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetSecurityPipelineWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSecurityPipelineWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSecurityPipelineWorkflowsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      input: // value for 'input'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetSecurityPipelineWorkflowsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSecurityPipelineWorkflowsQuery,
    GetSecurityPipelineWorkflowsQueryVariables
  > &
    (
      | {
          variables: GetSecurityPipelineWorkflowsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSecurityPipelineWorkflowsQuery,
    GetSecurityPipelineWorkflowsQueryVariables
  >(GetSecurityPipelineWorkflowsDocument, options);
}
export function useGetSecurityPipelineWorkflowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSecurityPipelineWorkflowsQuery,
    GetSecurityPipelineWorkflowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSecurityPipelineWorkflowsQuery,
    GetSecurityPipelineWorkflowsQueryVariables
  >(GetSecurityPipelineWorkflowsDocument, options);
}
// @ts-ignore
export function useGetSecurityPipelineWorkflowsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSecurityPipelineWorkflowsQuery,
    GetSecurityPipelineWorkflowsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSecurityPipelineWorkflowsQuery,
  GetSecurityPipelineWorkflowsQueryVariables
>;
export function useGetSecurityPipelineWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSecurityPipelineWorkflowsQuery,
        GetSecurityPipelineWorkflowsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSecurityPipelineWorkflowsQuery | undefined,
  GetSecurityPipelineWorkflowsQueryVariables
>;
export function useGetSecurityPipelineWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSecurityPipelineWorkflowsQuery,
        GetSecurityPipelineWorkflowsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSecurityPipelineWorkflowsQuery,
    GetSecurityPipelineWorkflowsQueryVariables
  >(GetSecurityPipelineWorkflowsDocument, options);
}
export type GetSecurityPipelineWorkflowsQueryHookResult = ReturnType<
  typeof useGetSecurityPipelineWorkflowsQuery
>;
export type GetSecurityPipelineWorkflowsLazyQueryHookResult = ReturnType<
  typeof useGetSecurityPipelineWorkflowsLazyQuery
>;
export type GetSecurityPipelineWorkflowsSuspenseQueryHookResult = ReturnType<
  typeof useGetSecurityPipelineWorkflowsSuspenseQuery
>;
export type GetSecurityPipelineWorkflowsQueryResult = Apollo.QueryResult<
  GetSecurityPipelineWorkflowsQuery,
  GetSecurityPipelineWorkflowsQueryVariables
>;
export const CancelSecurityPipelineWorkflowDocument = gql`
  mutation CancelSecurityPipelineWorkflow($mrn: String!) {
    cancelSecurityPipelineWorkflow(mrn: $mrn)
  }
`;
export type CancelSecurityPipelineWorkflowMutationFn = Apollo.MutationFunction<
  CancelSecurityPipelineWorkflowMutation,
  CancelSecurityPipelineWorkflowMutationVariables
>;

/**
 * __useCancelSecurityPipelineWorkflowMutation__
 *
 * To run a mutation, you first call `useCancelSecurityPipelineWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSecurityPipelineWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSecurityPipelineWorkflowMutation, { data, loading, error }] = useCancelSecurityPipelineWorkflowMutation({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useCancelSecurityPipelineWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelSecurityPipelineWorkflowMutation,
    CancelSecurityPipelineWorkflowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelSecurityPipelineWorkflowMutation,
    CancelSecurityPipelineWorkflowMutationVariables
  >(CancelSecurityPipelineWorkflowDocument, options);
}
export type CancelSecurityPipelineWorkflowMutationHookResult = ReturnType<
  typeof useCancelSecurityPipelineWorkflowMutation
>;
export type CancelSecurityPipelineWorkflowMutationResult =
  Apollo.MutationResult<CancelSecurityPipelineWorkflowMutation>;
export type CancelSecurityPipelineWorkflowMutationOptions =
  Apollo.BaseMutationOptions<
    CancelSecurityPipelineWorkflowMutation,
    CancelSecurityPipelineWorkflowMutationVariables
  >;
export const GetWorkflowAssetsDocument = gql`
  query GetWorkflowAssets(
    $workflowMrn: String
    $first: Int
    $after: String
    $scopeMrn: String
    $queryTerms: [String!]
    $rating: [ScoreRating!]
  ) {
    assets(
      workflowMrn: $workflowMrn
      first: $first
      after: $after
      scopeMrn: $scopeMrn
      queryTerms: $queryTerms
      rating: $rating
    ) {
      edges {
        cursor
        node {
          id
          score {
            riskRating
          }
          labels {
            key
            value
          }
          mrn
          name
          riskFactors {
            mrn
            indicator
            isDetected
          }
          updatedAt
          state
          asset_type
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;

/**
 * __useGetWorkflowAssetsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowAssetsQuery({
 *   variables: {
 *      workflowMrn: // value for 'workflowMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      scopeMrn: // value for 'scopeMrn'
 *      queryTerms: // value for 'queryTerms'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useGetWorkflowAssetsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWorkflowAssetsQuery,
    GetWorkflowAssetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkflowAssetsQuery,
    GetWorkflowAssetsQueryVariables
  >(GetWorkflowAssetsDocument, options);
}
export function useGetWorkflowAssetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowAssetsQuery,
    GetWorkflowAssetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkflowAssetsQuery,
    GetWorkflowAssetsQueryVariables
  >(GetWorkflowAssetsDocument, options);
}
// @ts-ignore
export function useGetWorkflowAssetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkflowAssetsQuery,
    GetWorkflowAssetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowAssetsQuery,
  GetWorkflowAssetsQueryVariables
>;
export function useGetWorkflowAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowAssetsQuery,
        GetWorkflowAssetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowAssetsQuery | undefined,
  GetWorkflowAssetsQueryVariables
>;
export function useGetWorkflowAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowAssetsQuery,
        GetWorkflowAssetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkflowAssetsQuery,
    GetWorkflowAssetsQueryVariables
  >(GetWorkflowAssetsDocument, options);
}
export type GetWorkflowAssetsQueryHookResult = ReturnType<
  typeof useGetWorkflowAssetsQuery
>;
export type GetWorkflowAssetsLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowAssetsLazyQuery
>;
export type GetWorkflowAssetsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowAssetsSuspenseQuery
>;
export type GetWorkflowAssetsQueryResult = Apollo.QueryResult<
  GetWorkflowAssetsQuery,
  GetWorkflowAssetsQueryVariables
>;
export const GetWorkflowInitialDocument = gql`
  query GetWorkflowInitial($mrn: String!) {
    securityPipelineWorkflow(mrn: $mrn) {
      ... on SecurityPipelineWorkflow {
        mrn
        ownerMrn
        integrationMrn
        title
        status
        pullRequest {
          title
          url
        }
        createdBy {
          name
          email
          mrn
          type
        }
        createdAt
        updatedAt
        tasks {
          type
          status
          createdAt
          updatedAt
        }
        labels {
          key
          value
        }
        findingGroups {
          findingMrn
          title
          riskScore
          riskValue
          rating
          assetsCount
          method
        }
        scheduledWorkflowMrn
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetWorkflowInitialQuery__
 *
 * To run a query within a React component, call `useGetWorkflowInitialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowInitialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowInitialQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useGetWorkflowInitialQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkflowInitialQuery,
    GetWorkflowInitialQueryVariables
  > &
    (
      | { variables: GetWorkflowInitialQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkflowInitialQuery,
    GetWorkflowInitialQueryVariables
  >(GetWorkflowInitialDocument, options);
}
export function useGetWorkflowInitialLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowInitialQuery,
    GetWorkflowInitialQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkflowInitialQuery,
    GetWorkflowInitialQueryVariables
  >(GetWorkflowInitialDocument, options);
}
// @ts-ignore
export function useGetWorkflowInitialSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkflowInitialQuery,
    GetWorkflowInitialQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowInitialQuery,
  GetWorkflowInitialQueryVariables
>;
export function useGetWorkflowInitialSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowInitialQuery,
        GetWorkflowInitialQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowInitialQuery | undefined,
  GetWorkflowInitialQueryVariables
>;
export function useGetWorkflowInitialSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowInitialQuery,
        GetWorkflowInitialQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkflowInitialQuery,
    GetWorkflowInitialQueryVariables
  >(GetWorkflowInitialDocument, options);
}
export type GetWorkflowInitialQueryHookResult = ReturnType<
  typeof useGetWorkflowInitialQuery
>;
export type GetWorkflowInitialLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowInitialLazyQuery
>;
export type GetWorkflowInitialSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowInitialSuspenseQuery
>;
export type GetWorkflowInitialQueryResult = Apollo.QueryResult<
  GetWorkflowInitialQuery,
  GetWorkflowInitialQueryVariables
>;
export const GetSoftwareDetailsDocument = gql`
  query GetSoftwareDetails(
    $scopeMrn: String!
    $first: Int
    $after: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        totalCount
        edges {
          cursor
          node {
            ... on PackageFinding {
              id
              mrn
              asset {
                id
                mrn
                name
              }
              title
              packageName
              installedVersion
              availableVersion
              iconId
              firstFound
              lastUpdated
              cvss {
                value
                id
                source
                type
                vector
              }
              epss {
                probability
                percentile
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetSoftwareDetailsQuery__
 *
 * To run a query within a React component, call `useGetSoftwareDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSoftwareDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSoftwareDetailsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSoftwareDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSoftwareDetailsQuery,
    GetSoftwareDetailsQueryVariables
  > &
    (
      | { variables: GetSoftwareDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSoftwareDetailsQuery,
    GetSoftwareDetailsQueryVariables
  >(GetSoftwareDetailsDocument, options);
}
export function useGetSoftwareDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSoftwareDetailsQuery,
    GetSoftwareDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSoftwareDetailsQuery,
    GetSoftwareDetailsQueryVariables
  >(GetSoftwareDetailsDocument, options);
}
// @ts-ignore
export function useGetSoftwareDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSoftwareDetailsQuery,
    GetSoftwareDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSoftwareDetailsQuery,
  GetSoftwareDetailsQueryVariables
>;
export function useGetSoftwareDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSoftwareDetailsQuery,
        GetSoftwareDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSoftwareDetailsQuery | undefined,
  GetSoftwareDetailsQueryVariables
>;
export function useGetSoftwareDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSoftwareDetailsQuery,
        GetSoftwareDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSoftwareDetailsQuery,
    GetSoftwareDetailsQueryVariables
  >(GetSoftwareDetailsDocument, options);
}
export type GetSoftwareDetailsQueryHookResult = ReturnType<
  typeof useGetSoftwareDetailsQuery
>;
export type GetSoftwareDetailsLazyQueryHookResult = ReturnType<
  typeof useGetSoftwareDetailsLazyQuery
>;
export type GetSoftwareDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetSoftwareDetailsSuspenseQuery
>;
export type GetSoftwareDetailsQueryResult = Apollo.QueryResult<
  GetSoftwareDetailsQuery,
  GetSoftwareDetailsQueryVariables
>;
export const GetAssetInsightsDocument = gql`
  query GetAssetInsights(
    $findingsScopeMrn: String!
    $cveFindingsFilter: FindingsFilter
    $cveExceptionsFilter: FindingsFilter
    $checkFindingsFilter: FindingsFilter
    $checkExceptionsFilter: FindingsFilter
    $findingsFirst: Int
  ) {
    cveFindings: findings(
      scopeMrn: $findingsScopeMrn
      filter: $cveFindingsFilter
      first: $findingsFirst
    ) {
      ... on FindingsConnection {
        totalCount
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
    cveExceptions: findings(
      scopeMrn: $findingsScopeMrn
      filter: $cveExceptionsFilter
      first: $findingsFirst
    ) {
      ... on FindingsConnection {
        totalCount
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
    checkFindings: findings(
      scopeMrn: $findingsScopeMrn
      filter: $checkFindingsFilter
      first: $findingsFirst
    ) {
      ... on FindingsConnection {
        totalCount
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
    checkExceptions: findings(
      scopeMrn: $findingsScopeMrn
      filter: $checkExceptionsFilter
      first: $findingsFirst
    ) {
      ... on FindingsConnection {
        totalCount
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
`;

/**
 * __useGetAssetInsightsQuery__
 *
 * To run a query within a React component, call `useGetAssetInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetInsightsQuery({
 *   variables: {
 *      findingsScopeMrn: // value for 'findingsScopeMrn'
 *      cveFindingsFilter: // value for 'cveFindingsFilter'
 *      cveExceptionsFilter: // value for 'cveExceptionsFilter'
 *      checkFindingsFilter: // value for 'checkFindingsFilter'
 *      checkExceptionsFilter: // value for 'checkExceptionsFilter'
 *      findingsFirst: // value for 'findingsFirst'
 *   },
 * });
 */
export function useGetAssetInsightsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssetInsightsQuery,
    GetAssetInsightsQueryVariables
  > &
    (
      | { variables: GetAssetInsightsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssetInsightsQuery, GetAssetInsightsQueryVariables>(
    GetAssetInsightsDocument,
    options,
  );
}
export function useGetAssetInsightsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssetInsightsQuery,
    GetAssetInsightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssetInsightsQuery,
    GetAssetInsightsQueryVariables
  >(GetAssetInsightsDocument, options);
}
// @ts-ignore
export function useGetAssetInsightsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssetInsightsQuery,
    GetAssetInsightsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssetInsightsQuery,
  GetAssetInsightsQueryVariables
>;
export function useGetAssetInsightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetInsightsQuery,
        GetAssetInsightsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssetInsightsQuery | undefined,
  GetAssetInsightsQueryVariables
>;
export function useGetAssetInsightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssetInsightsQuery,
        GetAssetInsightsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssetInsightsQuery,
    GetAssetInsightsQueryVariables
  >(GetAssetInsightsDocument, options);
}
export type GetAssetInsightsQueryHookResult = ReturnType<
  typeof useGetAssetInsightsQuery
>;
export type GetAssetInsightsLazyQueryHookResult = ReturnType<
  typeof useGetAssetInsightsLazyQuery
>;
export type GetAssetInsightsSuspenseQueryHookResult = ReturnType<
  typeof useGetAssetInsightsSuspenseQuery
>;
export type GetAssetInsightsQueryResult = Apollo.QueryResult<
  GetAssetInsightsQuery,
  GetAssetInsightsQueryVariables
>;
export const GetPlatformPoliciesDocument = gql`
  query GetPlatformPolicies(
    $input: PolicyAnalyticsInput!
    $first: Int
    $after: String
  ) {
    policyAnalytics(input: $input, first: $first, after: $after) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          mrn
          name
          icon
          action
          score {
            blastRadius {
              assets
            }
            completion
            findingStats {
              pass
              total
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetPlatformPoliciesQuery__
 *
 * To run a query within a React component, call `useGetPlatformPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformPoliciesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPlatformPoliciesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPlatformPoliciesQuery,
    GetPlatformPoliciesQueryVariables
  > &
    (
      | { variables: GetPlatformPoliciesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPlatformPoliciesQuery,
    GetPlatformPoliciesQueryVariables
  >(GetPlatformPoliciesDocument, options);
}
export function useGetPlatformPoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlatformPoliciesQuery,
    GetPlatformPoliciesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPlatformPoliciesQuery,
    GetPlatformPoliciesQueryVariables
  >(GetPlatformPoliciesDocument, options);
}
// @ts-ignore
export function useGetPlatformPoliciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPlatformPoliciesQuery,
    GetPlatformPoliciesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPlatformPoliciesQuery,
  GetPlatformPoliciesQueryVariables
>;
export function useGetPlatformPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPlatformPoliciesQuery,
        GetPlatformPoliciesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPlatformPoliciesQuery | undefined,
  GetPlatformPoliciesQueryVariables
>;
export function useGetPlatformPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPlatformPoliciesQuery,
        GetPlatformPoliciesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPlatformPoliciesQuery,
    GetPlatformPoliciesQueryVariables
  >(GetPlatformPoliciesDocument, options);
}
export type GetPlatformPoliciesQueryHookResult = ReturnType<
  typeof useGetPlatformPoliciesQuery
>;
export type GetPlatformPoliciesLazyQueryHookResult = ReturnType<
  typeof useGetPlatformPoliciesLazyQuery
>;
export type GetPlatformPoliciesSuspenseQueryHookResult = ReturnType<
  typeof useGetPlatformPoliciesSuspenseQuery
>;
export type GetPlatformPoliciesQueryResult = Apollo.QueryResult<
  GetPlatformPoliciesQuery,
  GetPlatformPoliciesQueryVariables
>;
export const GetCheckMqueryDocument = gql`
  query GetCheckMquery($input: MqueryInput!) {
    mquery(input: $input) {
      mql
      docs {
        desc
        references {
          title
          url
        }
        remediations {
          ... on Remediations {
            entries {
              id
              desc
            }
          }
          ... on AuthenticationRequired {
            code
            message
          }
        }
      }
      mrn
      properties {
        uid
        mrn
        title
        mql
        defaultValue
        overrideValue
        setByPolicyMrn
        for {
          mrn
        }
      }
      title
      variants {
        id
        mrn
        title
        icon
      }
    }
  }
`;

/**
 * __useGetCheckMqueryQuery__
 *
 * To run a query within a React component, call `useGetCheckMqueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckMqueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckMqueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCheckMqueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCheckMqueryQuery,
    GetCheckMqueryQueryVariables
  > &
    (
      | { variables: GetCheckMqueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCheckMqueryQuery, GetCheckMqueryQueryVariables>(
    GetCheckMqueryDocument,
    options,
  );
}
export function useGetCheckMqueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCheckMqueryQuery,
    GetCheckMqueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCheckMqueryQuery, GetCheckMqueryQueryVariables>(
    GetCheckMqueryDocument,
    options,
  );
}
// @ts-ignore
export function useGetCheckMquerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCheckMqueryQuery,
    GetCheckMqueryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCheckMqueryQuery,
  GetCheckMqueryQueryVariables
>;
export function useGetCheckMquerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCheckMqueryQuery,
        GetCheckMqueryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCheckMqueryQuery | undefined,
  GetCheckMqueryQueryVariables
>;
export function useGetCheckMquerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCheckMqueryQuery,
        GetCheckMqueryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCheckMqueryQuery,
    GetCheckMqueryQueryVariables
  >(GetCheckMqueryDocument, options);
}
export type GetCheckMqueryQueryHookResult = ReturnType<
  typeof useGetCheckMqueryQuery
>;
export type GetCheckMqueryLazyQueryHookResult = ReturnType<
  typeof useGetCheckMqueryLazyQuery
>;
export type GetCheckMquerySuspenseQueryHookResult = ReturnType<
  typeof useGetCheckMquerySuspenseQuery
>;
export type GetCheckMqueryQueryResult = Apollo.QueryResult<
  GetCheckMqueryQuery,
  GetCheckMqueryQueryVariables
>;
export const GetCheckReportAggregateNodeDataDocument = gql`
  query GetCheckReportAggregateNodeData(
    $entityMrn: String!
    $filter: AggregateScoreFilter
  ) {
    aggregateScores(entityMrn: $entityMrn, filter: $filter) {
      ... on AggregateScoresConnection {
        edges {
          node {
            rating
            riskValue
            cvss {
              id
              value
              type
              vector
              source
              rating
            }
            blastRadius {
              indicator
              assets
              affected
              critical
              high
              medium
              low
              none
              error
              pass
              disabled
              snoozed
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetCheckReportAggregateNodeDataQuery__
 *
 * To run a query within a React component, call `useGetCheckReportAggregateNodeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckReportAggregateNodeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckReportAggregateNodeDataQuery({
 *   variables: {
 *      entityMrn: // value for 'entityMrn'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCheckReportAggregateNodeDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCheckReportAggregateNodeDataQuery,
    GetCheckReportAggregateNodeDataQueryVariables
  > &
    (
      | {
          variables: GetCheckReportAggregateNodeDataQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCheckReportAggregateNodeDataQuery,
    GetCheckReportAggregateNodeDataQueryVariables
  >(GetCheckReportAggregateNodeDataDocument, options);
}
export function useGetCheckReportAggregateNodeDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCheckReportAggregateNodeDataQuery,
    GetCheckReportAggregateNodeDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCheckReportAggregateNodeDataQuery,
    GetCheckReportAggregateNodeDataQueryVariables
  >(GetCheckReportAggregateNodeDataDocument, options);
}
// @ts-ignore
export function useGetCheckReportAggregateNodeDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCheckReportAggregateNodeDataQuery,
    GetCheckReportAggregateNodeDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCheckReportAggregateNodeDataQuery,
  GetCheckReportAggregateNodeDataQueryVariables
>;
export function useGetCheckReportAggregateNodeDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCheckReportAggregateNodeDataQuery,
        GetCheckReportAggregateNodeDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCheckReportAggregateNodeDataQuery | undefined,
  GetCheckReportAggregateNodeDataQueryVariables
>;
export function useGetCheckReportAggregateNodeDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCheckReportAggregateNodeDataQuery,
        GetCheckReportAggregateNodeDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCheckReportAggregateNodeDataQuery,
    GetCheckReportAggregateNodeDataQueryVariables
  >(GetCheckReportAggregateNodeDataDocument, options);
}
export type GetCheckReportAggregateNodeDataQueryHookResult = ReturnType<
  typeof useGetCheckReportAggregateNodeDataQuery
>;
export type GetCheckReportAggregateNodeDataLazyQueryHookResult = ReturnType<
  typeof useGetCheckReportAggregateNodeDataLazyQuery
>;
export type GetCheckReportAggregateNodeDataSuspenseQueryHookResult = ReturnType<
  typeof useGetCheckReportAggregateNodeDataSuspenseQuery
>;
export type GetCheckReportAggregateNodeDataQueryResult = Apollo.QueryResult<
  GetCheckReportAggregateNodeDataQuery,
  GetCheckReportAggregateNodeDataQueryVariables
>;
export const GetSpaceNameDocument = gql`
  query GetSpaceName($mrn: String!) {
    space(mrn: $mrn) {
      id
      name
    }
  }
`;

/**
 * __useGetSpaceNameQuery__
 *
 * To run a query within a React component, call `useGetSpaceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpaceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpaceNameQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useGetSpaceNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSpaceNameQuery,
    GetSpaceNameQueryVariables
  > &
    (
      | { variables: GetSpaceNameQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSpaceNameQuery, GetSpaceNameQueryVariables>(
    GetSpaceNameDocument,
    options,
  );
}
export function useGetSpaceNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSpaceNameQuery,
    GetSpaceNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSpaceNameQuery, GetSpaceNameQueryVariables>(
    GetSpaceNameDocument,
    options,
  );
}
// @ts-ignore
export function useGetSpaceNameSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSpaceNameQuery,
    GetSpaceNameQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetSpaceNameQuery, GetSpaceNameQueryVariables>;
export function useGetSpaceNameSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSpaceNameQuery,
        GetSpaceNameQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSpaceNameQuery | undefined,
  GetSpaceNameQueryVariables
>;
export function useGetSpaceNameSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSpaceNameQuery,
        GetSpaceNameQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSpaceNameQuery, GetSpaceNameQueryVariables>(
    GetSpaceNameDocument,
    options,
  );
}
export type GetSpaceNameQueryHookResult = ReturnType<
  typeof useGetSpaceNameQuery
>;
export type GetSpaceNameLazyQueryHookResult = ReturnType<
  typeof useGetSpaceNameLazyQuery
>;
export type GetSpaceNameSuspenseQueryHookResult = ReturnType<
  typeof useGetSpaceNameSuspenseQuery
>;
export type GetSpaceNameQueryResult = Apollo.QueryResult<
  GetSpaceNameQuery,
  GetSpaceNameQueryVariables
>;
export const CreateWifAuthBindingDocument = gql`
  mutation CreateWIFAuthBinding($input: CreateWIFAuthBindingInput!) {
    createWIFAuthBinding(input: $input) {
      binding {
        mrn
      }
      config {
        universeDomain
        scopes
        type
        audience
        subjectTokenType
        issuerUri
      }
    }
  }
`;
export type CreateWifAuthBindingMutationFn = Apollo.MutationFunction<
  CreateWifAuthBindingMutation,
  CreateWifAuthBindingMutationVariables
>;

/**
 * __useCreateWifAuthBindingMutation__
 *
 * To run a mutation, you first call `useCreateWifAuthBindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWifAuthBindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWifAuthBindingMutation, { data, loading, error }] = useCreateWifAuthBindingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWifAuthBindingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWifAuthBindingMutation,
    CreateWifAuthBindingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWifAuthBindingMutation,
    CreateWifAuthBindingMutationVariables
  >(CreateWifAuthBindingDocument, options);
}
export type CreateWifAuthBindingMutationHookResult = ReturnType<
  typeof useCreateWifAuthBindingMutation
>;
export type CreateWifAuthBindingMutationResult =
  Apollo.MutationResult<CreateWifAuthBindingMutation>;
export type CreateWifAuthBindingMutationOptions = Apollo.BaseMutationOptions<
  CreateWifAuthBindingMutation,
  CreateWifAuthBindingMutationVariables
>;
export const RemoveWifAuthBindingDocument = gql`
  mutation RemoveWIFAuthBinding($mrn: String!) {
    removeWIFAuthBinding(mrn: $mrn) {
      mrn
    }
  }
`;
export type RemoveWifAuthBindingMutationFn = Apollo.MutationFunction<
  RemoveWifAuthBindingMutation,
  RemoveWifAuthBindingMutationVariables
>;

/**
 * __useRemoveWifAuthBindingMutation__
 *
 * To run a mutation, you first call `useRemoveWifAuthBindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWifAuthBindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWifAuthBindingMutation, { data, loading, error }] = useRemoveWifAuthBindingMutation({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useRemoveWifAuthBindingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveWifAuthBindingMutation,
    RemoveWifAuthBindingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveWifAuthBindingMutation,
    RemoveWifAuthBindingMutationVariables
  >(RemoveWifAuthBindingDocument, options);
}
export type RemoveWifAuthBindingMutationHookResult = ReturnType<
  typeof useRemoveWifAuthBindingMutation
>;
export type RemoveWifAuthBindingMutationResult =
  Apollo.MutationResult<RemoveWifAuthBindingMutation>;
export type RemoveWifAuthBindingMutationOptions = Apollo.BaseMutationOptions<
  RemoveWifAuthBindingMutation,
  RemoveWifAuthBindingMutationVariables
>;
export const GetWifAuthBindingConfigDocument = gql`
  query GetWIFAuthBindingConfig($bindingMrn: String!) {
    getWIFAuthBinding(mrn: $bindingMrn) {
      config {
        universeDomain
        scopes
        type
        audience
        subjectTokenType
        issuerUri
      }
    }
  }
`;

/**
 * __useGetWifAuthBindingConfigQuery__
 *
 * To run a query within a React component, call `useGetWifAuthBindingConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWifAuthBindingConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWifAuthBindingConfigQuery({
 *   variables: {
 *      bindingMrn: // value for 'bindingMrn'
 *   },
 * });
 */
export function useGetWifAuthBindingConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWifAuthBindingConfigQuery,
    GetWifAuthBindingConfigQueryVariables
  > &
    (
      | { variables: GetWifAuthBindingConfigQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWifAuthBindingConfigQuery,
    GetWifAuthBindingConfigQueryVariables
  >(GetWifAuthBindingConfigDocument, options);
}
export function useGetWifAuthBindingConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWifAuthBindingConfigQuery,
    GetWifAuthBindingConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWifAuthBindingConfigQuery,
    GetWifAuthBindingConfigQueryVariables
  >(GetWifAuthBindingConfigDocument, options);
}
// @ts-ignore
export function useGetWifAuthBindingConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWifAuthBindingConfigQuery,
    GetWifAuthBindingConfigQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWifAuthBindingConfigQuery,
  GetWifAuthBindingConfigQueryVariables
>;
export function useGetWifAuthBindingConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWifAuthBindingConfigQuery,
        GetWifAuthBindingConfigQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWifAuthBindingConfigQuery | undefined,
  GetWifAuthBindingConfigQueryVariables
>;
export function useGetWifAuthBindingConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWifAuthBindingConfigQuery,
        GetWifAuthBindingConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWifAuthBindingConfigQuery,
    GetWifAuthBindingConfigQueryVariables
  >(GetWifAuthBindingConfigDocument, options);
}
export type GetWifAuthBindingConfigQueryHookResult = ReturnType<
  typeof useGetWifAuthBindingConfigQuery
>;
export type GetWifAuthBindingConfigLazyQueryHookResult = ReturnType<
  typeof useGetWifAuthBindingConfigLazyQuery
>;
export type GetWifAuthBindingConfigSuspenseQueryHookResult = ReturnType<
  typeof useGetWifAuthBindingConfigSuspenseQuery
>;
export type GetWifAuthBindingConfigQueryResult = Apollo.QueryResult<
  GetWifAuthBindingConfigQuery,
  GetWifAuthBindingConfigQueryVariables
>;
export const GetWifAuthBindingsDocument = gql`
  query GetWIFAuthBindings($scopeMrn: String!, $orderBy: WIFAuthBindingOrder) {
    listWIFAuthBindings(scopeMrn: $scopeMrn, orderBy: $orderBy) {
      bindings {
        mrn
        name
        description
        expiration
        issuerUri
        createdAt
        lastUsed
        iconId
      }
    }
  }
`;

/**
 * __useGetWifAuthBindingsQuery__
 *
 * To run a query within a React component, call `useGetWifAuthBindingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWifAuthBindingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWifAuthBindingsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetWifAuthBindingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWifAuthBindingsQuery,
    GetWifAuthBindingsQueryVariables
  > &
    (
      | { variables: GetWifAuthBindingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWifAuthBindingsQuery,
    GetWifAuthBindingsQueryVariables
  >(GetWifAuthBindingsDocument, options);
}
export function useGetWifAuthBindingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWifAuthBindingsQuery,
    GetWifAuthBindingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWifAuthBindingsQuery,
    GetWifAuthBindingsQueryVariables
  >(GetWifAuthBindingsDocument, options);
}
// @ts-ignore
export function useGetWifAuthBindingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWifAuthBindingsQuery,
    GetWifAuthBindingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWifAuthBindingsQuery,
  GetWifAuthBindingsQueryVariables
>;
export function useGetWifAuthBindingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWifAuthBindingsQuery,
        GetWifAuthBindingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWifAuthBindingsQuery | undefined,
  GetWifAuthBindingsQueryVariables
>;
export function useGetWifAuthBindingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWifAuthBindingsQuery,
        GetWifAuthBindingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWifAuthBindingsQuery,
    GetWifAuthBindingsQueryVariables
  >(GetWifAuthBindingsDocument, options);
}
export type GetWifAuthBindingsQueryHookResult = ReturnType<
  typeof useGetWifAuthBindingsQuery
>;
export type GetWifAuthBindingsLazyQueryHookResult = ReturnType<
  typeof useGetWifAuthBindingsLazyQuery
>;
export type GetWifAuthBindingsSuspenseQueryHookResult = ReturnType<
  typeof useGetWifAuthBindingsSuspenseQuery
>;
export type GetWifAuthBindingsQueryResult = Apollo.QueryResult<
  GetWifAuthBindingsQuery,
  GetWifAuthBindingsQueryVariables
>;
export const GetSpaceSoftwareDocument = gql`
  query GetSpaceSoftware(
    $entityMrn: String!
    $filter: AggregateScoreFilter
    $first: Int
    $after: String
    $orderBy: AggregateScoreOrder
  ) {
    aggregateScores(
      entityMrn: $entityMrn
      filter: $filter
      first: $first
      after: $after
      orderBy: $orderBy
    ) {
      ... on AggregateScoresConnection {
        totalCount
        edges {
          cursor
          node {
            id
            iconId
            state
            effort
            enforcementState
            previewUntil
            spaceRiskImprovement
            versionDistribution {
              total
              assets
              installations
              distribution {
                version
                count
                riskScoreRating
                riskValue
              }
            }
            entity {
              ... on EntityInfoAsset {
                id
                mrn
                name
              }
              ... on EntityInfoOrganization {
                id
                mrn
                name
              }
              ... on EntityInfoSpace {
                id
                mrn
                name
              }
              ... on EntityInfoWorkspace {
                id
                mrn
                name
              }
            }
            findingMrn
            rank
            rankScore
            baseScore
            riskValue
            scoreType
            riskValue
            rating
            baseScore
            baseValue
            baseRating
            blastRadius {
              ...BlastRadiusFields
            }
            riskFactors {
              mrn
              indicator
              title
              total
              affected
              isPositive
            }
            detectionSources {
              name
              firstDetectedAt
              lastUpdatedAt
              affectedAssets
              vendor
            }
            tags {
              key
              value
            }
            epss {
              percentile
              probability
            }
            cvss {
              value
              id
              value
              type
              vector
              source
              rating
            }
            title
            description
            lastScannedAt
            firstDetectedAt
            remediatedAt
            spaceId
            slaAtRiskCount
            slaOverdueCount
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
  ${BlastRadiusFieldsFragmentDoc}
`;

/**
 * __useGetSpaceSoftwareQuery__
 *
 * To run a query within a React component, call `useGetSpaceSoftwareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpaceSoftwareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpaceSoftwareQuery({
 *   variables: {
 *      entityMrn: // value for 'entityMrn'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetSpaceSoftwareQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSpaceSoftwareQuery,
    GetSpaceSoftwareQueryVariables
  > &
    (
      | { variables: GetSpaceSoftwareQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSpaceSoftwareQuery, GetSpaceSoftwareQueryVariables>(
    GetSpaceSoftwareDocument,
    options,
  );
}
export function useGetSpaceSoftwareLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSpaceSoftwareQuery,
    GetSpaceSoftwareQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSpaceSoftwareQuery,
    GetSpaceSoftwareQueryVariables
  >(GetSpaceSoftwareDocument, options);
}
// @ts-ignore
export function useGetSpaceSoftwareSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSpaceSoftwareQuery,
    GetSpaceSoftwareQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSpaceSoftwareQuery,
  GetSpaceSoftwareQueryVariables
>;
export function useGetSpaceSoftwareSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSpaceSoftwareQuery,
        GetSpaceSoftwareQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSpaceSoftwareQuery | undefined,
  GetSpaceSoftwareQueryVariables
>;
export function useGetSpaceSoftwareSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSpaceSoftwareQuery,
        GetSpaceSoftwareQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSpaceSoftwareQuery,
    GetSpaceSoftwareQueryVariables
  >(GetSpaceSoftwareDocument, options);
}
export type GetSpaceSoftwareQueryHookResult = ReturnType<
  typeof useGetSpaceSoftwareQuery
>;
export type GetSpaceSoftwareLazyQueryHookResult = ReturnType<
  typeof useGetSpaceSoftwareLazyQuery
>;
export type GetSpaceSoftwareSuspenseQueryHookResult = ReturnType<
  typeof useGetSpaceSoftwareSuspenseQuery
>;
export type GetSpaceSoftwareQueryResult = Apollo.QueryResult<
  GetSpaceSoftwareQuery,
  GetSpaceSoftwareQueryVariables
>;
export const GetAnnotationSuggestionsDocument = gql`
  query GetAnnotationSuggestions(
    $scopeMrn: String!
    $key: String
    $query: String
  ) {
    annotationSuggestions(scopeMrn: $scopeMrn, key: $key, query: $query)
  }
`;

/**
 * __useGetAnnotationSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationSuggestionsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      key: // value for 'key'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAnnotationSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAnnotationSuggestionsQuery,
    GetAnnotationSuggestionsQueryVariables
  > &
    (
      | { variables: GetAnnotationSuggestionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAnnotationSuggestionsQuery,
    GetAnnotationSuggestionsQueryVariables
  >(GetAnnotationSuggestionsDocument, options);
}
export function useGetAnnotationSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnnotationSuggestionsQuery,
    GetAnnotationSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAnnotationSuggestionsQuery,
    GetAnnotationSuggestionsQueryVariables
  >(GetAnnotationSuggestionsDocument, options);
}
// @ts-ignore
export function useGetAnnotationSuggestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAnnotationSuggestionsQuery,
    GetAnnotationSuggestionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAnnotationSuggestionsQuery,
  GetAnnotationSuggestionsQueryVariables
>;
export function useGetAnnotationSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnnotationSuggestionsQuery,
        GetAnnotationSuggestionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAnnotationSuggestionsQuery | undefined,
  GetAnnotationSuggestionsQueryVariables
>;
export function useGetAnnotationSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnnotationSuggestionsQuery,
        GetAnnotationSuggestionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAnnotationSuggestionsQuery,
    GetAnnotationSuggestionsQueryVariables
  >(GetAnnotationSuggestionsDocument, options);
}
export type GetAnnotationSuggestionsQueryHookResult = ReturnType<
  typeof useGetAnnotationSuggestionsQuery
>;
export type GetAnnotationSuggestionsLazyQueryHookResult = ReturnType<
  typeof useGetAnnotationSuggestionsLazyQuery
>;
export type GetAnnotationSuggestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetAnnotationSuggestionsSuspenseQuery
>;
export type GetAnnotationSuggestionsQueryResult = Apollo.QueryResult<
  GetAnnotationSuggestionsQuery,
  GetAnnotationSuggestionsQueryVariables
>;
export const GetLabelSuggestionsDocument = gql`
  query GetLabelSuggestions($scopeMrn: String!, $key: String, $query: String) {
    labelSuggestions(scopeMrn: $scopeMrn, key: $key, query: $query)
  }
`;

/**
 * __useGetLabelSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetLabelSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabelSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabelSuggestionsQuery({
 *   variables: {
 *      scopeMrn: // value for 'scopeMrn'
 *      key: // value for 'key'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetLabelSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLabelSuggestionsQuery,
    GetLabelSuggestionsQueryVariables
  > &
    (
      | { variables: GetLabelSuggestionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLabelSuggestionsQuery,
    GetLabelSuggestionsQueryVariables
  >(GetLabelSuggestionsDocument, options);
}
export function useGetLabelSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLabelSuggestionsQuery,
    GetLabelSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLabelSuggestionsQuery,
    GetLabelSuggestionsQueryVariables
  >(GetLabelSuggestionsDocument, options);
}
// @ts-ignore
export function useGetLabelSuggestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetLabelSuggestionsQuery,
    GetLabelSuggestionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetLabelSuggestionsQuery,
  GetLabelSuggestionsQueryVariables
>;
export function useGetLabelSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLabelSuggestionsQuery,
        GetLabelSuggestionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetLabelSuggestionsQuery | undefined,
  GetLabelSuggestionsQueryVariables
>;
export function useGetLabelSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLabelSuggestionsQuery,
        GetLabelSuggestionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetLabelSuggestionsQuery,
    GetLabelSuggestionsQueryVariables
  >(GetLabelSuggestionsDocument, options);
}
export type GetLabelSuggestionsQueryHookResult = ReturnType<
  typeof useGetLabelSuggestionsQuery
>;
export type GetLabelSuggestionsLazyQueryHookResult = ReturnType<
  typeof useGetLabelSuggestionsLazyQuery
>;
export type GetLabelSuggestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetLabelSuggestionsSuspenseQuery
>;
export type GetLabelSuggestionsQueryResult = Apollo.QueryResult<
  GetLabelSuggestionsQuery,
  GetLabelSuggestionsQueryVariables
>;
export const GetWorkspaceConditionPossibleValuesDocument = gql`
  query GetWorkspaceConditionPossibleValues(
    $input: WorkspaceConditionPossibleValuesInput!
  ) {
    workspaceConditionPossibleValues(input: $input) {
      ... on WorkspaceConditionIntValues {
        suggestions {
          intValue: value
          intDisplayName: displayName
        }
      }
      ... on WorkspaceConditionStringValues {
        suggestions {
          stringValue: value
          stringDisplayName: displayName
        }
      }
      ... on WorkspaceConditionRatingValues {
        suggestions {
          ratingValue: value
          ratingDisplayName: displayName
        }
      }
    }
  }
`;

/**
 * __useGetWorkspaceConditionPossibleValuesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceConditionPossibleValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceConditionPossibleValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceConditionPossibleValuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkspaceConditionPossibleValuesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkspaceConditionPossibleValuesQuery,
    GetWorkspaceConditionPossibleValuesQueryVariables
  > &
    (
      | {
          variables: GetWorkspaceConditionPossibleValuesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkspaceConditionPossibleValuesQuery,
    GetWorkspaceConditionPossibleValuesQueryVariables
  >(GetWorkspaceConditionPossibleValuesDocument, options);
}
export function useGetWorkspaceConditionPossibleValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkspaceConditionPossibleValuesQuery,
    GetWorkspaceConditionPossibleValuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkspaceConditionPossibleValuesQuery,
    GetWorkspaceConditionPossibleValuesQueryVariables
  >(GetWorkspaceConditionPossibleValuesDocument, options);
}
// @ts-ignore
export function useGetWorkspaceConditionPossibleValuesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkspaceConditionPossibleValuesQuery,
    GetWorkspaceConditionPossibleValuesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspaceConditionPossibleValuesQuery,
  GetWorkspaceConditionPossibleValuesQueryVariables
>;
export function useGetWorkspaceConditionPossibleValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspaceConditionPossibleValuesQuery,
        GetWorkspaceConditionPossibleValuesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspaceConditionPossibleValuesQuery | undefined,
  GetWorkspaceConditionPossibleValuesQueryVariables
>;
export function useGetWorkspaceConditionPossibleValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspaceConditionPossibleValuesQuery,
        GetWorkspaceConditionPossibleValuesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkspaceConditionPossibleValuesQuery,
    GetWorkspaceConditionPossibleValuesQueryVariables
  >(GetWorkspaceConditionPossibleValuesDocument, options);
}
export type GetWorkspaceConditionPossibleValuesQueryHookResult = ReturnType<
  typeof useGetWorkspaceConditionPossibleValuesQuery
>;
export type GetWorkspaceConditionPossibleValuesLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceConditionPossibleValuesLazyQuery
>;
export type GetWorkspaceConditionPossibleValuesSuspenseQueryHookResult =
  ReturnType<typeof useGetWorkspaceConditionPossibleValuesSuspenseQuery>;
export type GetWorkspaceConditionPossibleValuesQueryResult = Apollo.QueryResult<
  GetWorkspaceConditionPossibleValuesQuery,
  GetWorkspaceConditionPossibleValuesQueryVariables
>;
export const GetWorkspaceSelectionsDocument = gql`
  query GetWorkspaceSelections($mrn: String!) {
    workspace(mrn: $mrn) {
      ... on Workspace {
        mrn
        selections {
          ...WorkspaceSelection
        }
      }
    }
  }
  ${WorkspaceSelectionFragmentDoc}
`;

/**
 * __useGetWorkspaceSelectionsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSelectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSelectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSelectionsQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useGetWorkspaceSelectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkspaceSelectionsQuery,
    GetWorkspaceSelectionsQueryVariables
  > &
    (
      | { variables: GetWorkspaceSelectionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkspaceSelectionsQuery,
    GetWorkspaceSelectionsQueryVariables
  >(GetWorkspaceSelectionsDocument, options);
}
export function useGetWorkspaceSelectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkspaceSelectionsQuery,
    GetWorkspaceSelectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkspaceSelectionsQuery,
    GetWorkspaceSelectionsQueryVariables
  >(GetWorkspaceSelectionsDocument, options);
}
// @ts-ignore
export function useGetWorkspaceSelectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkspaceSelectionsQuery,
    GetWorkspaceSelectionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspaceSelectionsQuery,
  GetWorkspaceSelectionsQueryVariables
>;
export function useGetWorkspaceSelectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspaceSelectionsQuery,
        GetWorkspaceSelectionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkspaceSelectionsQuery | undefined,
  GetWorkspaceSelectionsQueryVariables
>;
export function useGetWorkspaceSelectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkspaceSelectionsQuery,
        GetWorkspaceSelectionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkspaceSelectionsQuery,
    GetWorkspaceSelectionsQueryVariables
  >(GetWorkspaceSelectionsDocument, options);
}
export type GetWorkspaceSelectionsQueryHookResult = ReturnType<
  typeof useGetWorkspaceSelectionsQuery
>;
export type GetWorkspaceSelectionsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceSelectionsLazyQuery
>;
export type GetWorkspaceSelectionsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspaceSelectionsSuspenseQuery
>;
export type GetWorkspaceSelectionsQueryResult = Apollo.QueryResult<
  GetWorkspaceSelectionsQuery,
  GetWorkspaceSelectionsQueryVariables
>;
